import {
  TAG_PLACEHOLDER,
  TAG_REPLACEMENT,
  component,
  createDocumentationLink,
  createDocumentationMessageGenerator,
  deprecate,
  deserializePayload,
  escapeFacets,
  escapeHits,
  find,
  formatNumber,
  getAppIdAndApiKey,
  getHighlightedParts,
  getPropertyByPath,
  index_default,
  isEqual,
  isIndexWidget,
  isPlainObject,
  mergeSearchParameters,
  noop,
  readDataAttributes,
  require_algoliasearch_helper,
  safelyRunOnBrowser,
  serializePayload,
  unescape,
  uniq
} from "./chunk-RQ4VMJD4.js";
import {
  __commonJS,
  __export,
  __toESM
} from "./chunk-624QZG55.js";

// node_modules/react/cjs/react.production.js
var require_react_production = __commonJS({
  "node_modules/react/cjs/react.production.js"(exports) {
    "use strict";
    var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_CONSUMER_TYPE = Symbol.for("react.consumer");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    function getIteratorFn(maybeIterable) {
      if (null === maybeIterable || "object" !== typeof maybeIterable)
        return null;
      maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
      return "function" === typeof maybeIterable ? maybeIterable : null;
    }
    var ReactNoopUpdateQueue = {
      isMounted: function() {
        return false;
      },
      enqueueForceUpdate: function() {
      },
      enqueueReplaceState: function() {
      },
      enqueueSetState: function() {
      }
    };
    var assign = Object.assign;
    var emptyObject = {};
    function Component(props, context, updater) {
      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;
    }
    Component.prototype.isReactComponent = {};
    Component.prototype.setState = function(partialState, callback) {
      if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState)
        throw Error(
          "takes an object of state variables to update or a function which returns an object of state variables."
        );
      this.updater.enqueueSetState(this, partialState, callback, "setState");
    };
    Component.prototype.forceUpdate = function(callback) {
      this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
    };
    function ComponentDummy() {
    }
    ComponentDummy.prototype = Component.prototype;
    function PureComponent(props, context, updater) {
      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;
    }
    var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
    pureComponentPrototype.constructor = PureComponent;
    assign(pureComponentPrototype, Component.prototype);
    pureComponentPrototype.isPureReactComponent = true;
    var isArrayImpl = Array.isArray;
    function noop3() {
    }
    var ReactSharedInternals = { H: null, A: null, T: null, S: null };
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    function ReactElement(type, key2, props) {
      var refProp = props.ref;
      return {
        $$typeof: REACT_ELEMENT_TYPE,
        type,
        key: key2,
        ref: void 0 !== refProp ? refProp : null,
        props
      };
    }
    function cloneAndReplaceKey(oldElement, newKey) {
      return ReactElement(oldElement.type, newKey, oldElement.props);
    }
    function isValidElement(object3) {
      return "object" === typeof object3 && null !== object3 && object3.$$typeof === REACT_ELEMENT_TYPE;
    }
    function escape(key2) {
      var escaperLookup = { "=": "=0", ":": "=2" };
      return "$" + key2.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
      });
    }
    var userProvidedKeyEscapeRegex = /\/+/g;
    function getElementKey(element, index) {
      return "object" === typeof element && null !== element && null != element.key ? escape("" + element.key) : index.toString(36);
    }
    function resolveThenable(thenable) {
      switch (thenable.status) {
        case "fulfilled":
          return thenable.value;
        case "rejected":
          throw thenable.reason;
        default:
          switch ("string" === typeof thenable.status ? thenable.then(noop3, noop3) : (thenable.status = "pending", thenable.then(
            function(fulfilledValue) {
              "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            },
            function(error40) {
              "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error40);
            }
          )), thenable.status) {
            case "fulfilled":
              return thenable.value;
            case "rejected":
              throw thenable.reason;
          }
      }
      throw thenable;
    }
    function mapIntoArray(children, array2, escapedPrefix, nameSoFar, callback) {
      var type = typeof children;
      if ("undefined" === type || "boolean" === type)
        children = null;
      var invokeCallback = false;
      if (null === children)
        invokeCallback = true;
      else
        switch (type) {
          case "bigint":
          case "string":
          case "number":
            invokeCallback = true;
            break;
          case "object":
            switch (children.$$typeof) {
              case REACT_ELEMENT_TYPE:
              case REACT_PORTAL_TYPE:
                invokeCallback = true;
                break;
              case REACT_LAZY_TYPE:
                return invokeCallback = children._init, mapIntoArray(
                  invokeCallback(children._payload),
                  array2,
                  escapedPrefix,
                  nameSoFar,
                  callback
                );
            }
        }
      if (invokeCallback)
        return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + getElementKey(children, 0) : nameSoFar, isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array2, escapedPrefix, "", function(c4) {
          return c4;
        })) : null != callback && (isValidElement(callback) && (callback = cloneAndReplaceKey(
          callback,
          escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace(
            userProvidedKeyEscapeRegex,
            "$&/"
          ) + "/") + invokeCallback
        )), array2.push(callback)), 1;
      invokeCallback = 0;
      var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
      if (isArrayImpl(children))
        for (var i4 = 0; i4 < children.length; i4++)
          nameSoFar = children[i4], type = nextNamePrefix + getElementKey(nameSoFar, i4), invokeCallback += mapIntoArray(
            nameSoFar,
            array2,
            escapedPrefix,
            type,
            callback
          );
      else if (i4 = getIteratorFn(children), "function" === typeof i4)
        for (children = i4.call(children), i4 = 0; !(nameSoFar = children.next()).done; )
          nameSoFar = nameSoFar.value, type = nextNamePrefix + getElementKey(nameSoFar, i4++), invokeCallback += mapIntoArray(
            nameSoFar,
            array2,
            escapedPrefix,
            type,
            callback
          );
      else if ("object" === type) {
        if ("function" === typeof children.then)
          return mapIntoArray(
            resolveThenable(children),
            array2,
            escapedPrefix,
            nameSoFar,
            callback
          );
        array2 = String(children);
        throw Error(
          "Objects are not valid as a React child (found: " + ("[object Object]" === array2 ? "object with keys {" + Object.keys(children).join(", ") + "}" : array2) + "). If you meant to render a collection of children, use an array instead."
        );
      }
      return invokeCallback;
    }
    function mapChildren(children, func, context) {
      if (null == children)
        return children;
      var result = [], count = 0;
      mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
      });
      return result;
    }
    function lazyInitializer(payload) {
      if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(
          function(moduleObject) {
            if (0 === payload._status || -1 === payload._status)
              payload._status = 1, payload._result = moduleObject;
          },
          function(error40) {
            if (0 === payload._status || -1 === payload._status)
              payload._status = 2, payload._result = error40;
          }
        );
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
      }
      if (1 === payload._status)
        return payload._result.default;
      throw payload._result;
    }
    var reportGlobalError = "function" === typeof reportError ? reportError : function(error40) {
      if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
          bubbles: true,
          cancelable: true,
          message: "object" === typeof error40 && null !== error40 && "string" === typeof error40.message ? String(error40.message) : String(error40),
          error: error40
        });
        if (!window.dispatchEvent(event))
          return;
      } else if ("object" === typeof process && "function" === typeof process.emit) {
        process.emit("uncaughtException", error40);
        return;
      }
      console.error(error40);
    };
    var Children = {
      map: mapChildren,
      forEach: function(children, forEachFunc, forEachContext) {
        mapChildren(
          children,
          function() {
            forEachFunc.apply(this, arguments);
          },
          forEachContext
        );
      },
      count: function(children) {
        var n4 = 0;
        mapChildren(children, function() {
          n4++;
        });
        return n4;
      },
      toArray: function(children) {
        return mapChildren(children, function(child) {
          return child;
        }) || [];
      },
      only: function(children) {
        if (!isValidElement(children))
          throw Error(
            "React.Children.only expected to receive a single React element child."
          );
        return children;
      }
    };
    exports.Activity = REACT_ACTIVITY_TYPE;
    exports.Children = Children;
    exports.Component = Component;
    exports.Fragment = REACT_FRAGMENT_TYPE;
    exports.Profiler = REACT_PROFILER_TYPE;
    exports.PureComponent = PureComponent;
    exports.StrictMode = REACT_STRICT_MODE_TYPE;
    exports.Suspense = REACT_SUSPENSE_TYPE;
    exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
    exports.__COMPILER_RUNTIME = {
      __proto__: null,
      c: function(size) {
        return ReactSharedInternals.H.useMemoCache(size);
      }
    };
    exports.cache = function(fn) {
      return function() {
        return fn.apply(null, arguments);
      };
    };
    exports.cacheSignal = function() {
      return null;
    };
    exports.cloneElement = function(element, config2, children) {
      if (null === element || void 0 === element)
        throw Error(
          "The argument must be a React element, but you passed " + element + "."
        );
      var props = assign({}, element.props), key2 = element.key;
      if (null != config2)
        for (propName in void 0 !== config2.key && (key2 = "" + config2.key), config2)
          !hasOwnProperty.call(config2, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config2.ref || (props[propName] = config2[propName]);
      var propName = arguments.length - 2;
      if (1 === propName)
        props.children = children;
      else if (1 < propName) {
        for (var childArray = Array(propName), i4 = 0; i4 < propName; i4++)
          childArray[i4] = arguments[i4 + 2];
        props.children = childArray;
      }
      return ReactElement(element.type, key2, props);
    };
    exports.createContext = function(defaultValue) {
      defaultValue = {
        $$typeof: REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
      };
      defaultValue.Provider = defaultValue;
      defaultValue.Consumer = {
        $$typeof: REACT_CONSUMER_TYPE,
        _context: defaultValue
      };
      return defaultValue;
    };
    exports.createElement = function(type, config2, children) {
      var propName, props = {}, key2 = null;
      if (null != config2)
        for (propName in void 0 !== config2.key && (key2 = "" + config2.key), config2)
          hasOwnProperty.call(config2, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config2[propName]);
      var childrenLength = arguments.length - 2;
      if (1 === childrenLength)
        props.children = children;
      else if (1 < childrenLength) {
        for (var childArray = Array(childrenLength), i4 = 0; i4 < childrenLength; i4++)
          childArray[i4] = arguments[i4 + 2];
        props.children = childArray;
      }
      if (type && type.defaultProps)
        for (propName in childrenLength = type.defaultProps, childrenLength)
          void 0 === props[propName] && (props[propName] = childrenLength[propName]);
      return ReactElement(type, key2, props);
    };
    exports.createRef = function() {
      return { current: null };
    };
    exports.forwardRef = function(render) {
      return { $$typeof: REACT_FORWARD_REF_TYPE, render };
    };
    exports.isValidElement = isValidElement;
    exports.lazy = function(ctor) {
      return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: { _status: -1, _result: ctor },
        _init: lazyInitializer
      };
    };
    exports.memo = function(type, compare) {
      return {
        $$typeof: REACT_MEMO_TYPE,
        type,
        compare: void 0 === compare ? null : compare
      };
    };
    exports.startTransition = function(scope) {
      var prevTransition = ReactSharedInternals.T, currentTransition = {};
      ReactSharedInternals.T = currentTransition;
      try {
        var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then(noop3, reportGlobalError);
      } catch (error40) {
        reportGlobalError(error40);
      } finally {
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
      }
    };
    exports.unstable_useCacheRefresh = function() {
      return ReactSharedInternals.H.useCacheRefresh();
    };
    exports.use = function(usable) {
      return ReactSharedInternals.H.use(usable);
    };
    exports.useActionState = function(action, initialState, permalink) {
      return ReactSharedInternals.H.useActionState(action, initialState, permalink);
    };
    exports.useCallback = function(callback, deps) {
      return ReactSharedInternals.H.useCallback(callback, deps);
    };
    exports.useContext = function(Context) {
      return ReactSharedInternals.H.useContext(Context);
    };
    exports.useDebugValue = function() {
    };
    exports.useDeferredValue = function(value, initialValue) {
      return ReactSharedInternals.H.useDeferredValue(value, initialValue);
    };
    exports.useEffect = function(create, deps) {
      return ReactSharedInternals.H.useEffect(create, deps);
    };
    exports.useEffectEvent = function(callback) {
      return ReactSharedInternals.H.useEffectEvent(callback);
    };
    exports.useId = function() {
      return ReactSharedInternals.H.useId();
    };
    exports.useImperativeHandle = function(ref, create, deps) {
      return ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
    };
    exports.useInsertionEffect = function(create, deps) {
      return ReactSharedInternals.H.useInsertionEffect(create, deps);
    };
    exports.useLayoutEffect = function(create, deps) {
      return ReactSharedInternals.H.useLayoutEffect(create, deps);
    };
    exports.useMemo = function(create, deps) {
      return ReactSharedInternals.H.useMemo(create, deps);
    };
    exports.useOptimistic = function(passthrough, reducer) {
      return ReactSharedInternals.H.useOptimistic(passthrough, reducer);
    };
    exports.useReducer = function(reducer, initialArg, init) {
      return ReactSharedInternals.H.useReducer(reducer, initialArg, init);
    };
    exports.useRef = function(initialValue) {
      return ReactSharedInternals.H.useRef(initialValue);
    };
    exports.useState = function(initialState) {
      return ReactSharedInternals.H.useState(initialState);
    };
    exports.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
      return ReactSharedInternals.H.useSyncExternalStore(
        subscribe,
        getSnapshot,
        getServerSnapshot
      );
    };
    exports.useTransition = function() {
      return ReactSharedInternals.H.useTransition();
    };
    exports.version = "19.2.0";
  }
});

// node_modules/react/index.js
var require_react = __commonJS({
  "node_modules/react/index.js"(exports, module) {
    "use strict";
    if (true) {
      module.exports = require_react_production();
    } else {
      module.exports = null;
    }
  }
});

// node_modules/hogan.js/lib/compiler.js
var require_compiler = __commonJS({
  "node_modules/hogan.js/lib/compiler.js"(exports) {
    (function(Hogan2) {
      var rIsWhitespace = /\S/, rQuot = /\"/g, rNewline = /\n/g, rCr = /\r/g, rSlash = /\\/g, rLineSep = /\u2028/, rParagraphSep = /\u2029/;
      Hogan2.tags = {
        "#": 1,
        "^": 2,
        "<": 3,
        "$": 4,
        "/": 5,
        "!": 6,
        ">": 7,
        "=": 8,
        "_v": 9,
        "{": 10,
        "&": 11,
        "_t": 12
      };
      Hogan2.scan = function scan(text4, delimiters) {
        var len = text4.length, IN_TEXT = 0, IN_TAG_TYPE = 1, IN_TAG = 2, state = IN_TEXT, tagType = null, tag = null, buf = "", tokens = [], seenTag = false, i4 = 0, lineStart = 0, otag = "{{", ctag = "}}";
        function addBuf() {
          if (buf.length > 0) {
            tokens.push({ tag: "_t", text: new String(buf) });
            buf = "";
          }
        }
        function lineIsWhitespace() {
          var isAllWhitespace = true;
          for (var j4 = lineStart; j4 < tokens.length; j4++) {
            isAllWhitespace = Hogan2.tags[tokens[j4].tag] < Hogan2.tags["_v"] || tokens[j4].tag == "_t" && tokens[j4].text.match(rIsWhitespace) === null;
            if (!isAllWhitespace) {
              return false;
            }
          }
          return isAllWhitespace;
        }
        function filterLine(haveSeenTag, noNewLine) {
          addBuf();
          if (haveSeenTag && lineIsWhitespace()) {
            for (var j4 = lineStart, next2; j4 < tokens.length; j4++) {
              if (tokens[j4].text) {
                if ((next2 = tokens[j4 + 1]) && next2.tag == ">") {
                  next2.indent = tokens[j4].text.toString();
                }
                tokens.splice(j4, 1);
              }
            }
          } else if (!noNewLine) {
            tokens.push({ tag: "\n" });
          }
          seenTag = false;
          lineStart = tokens.length;
        }
        function changeDelimiters(text5, index) {
          var close = "=" + ctag, closeIndex = text5.indexOf(close, index), delimiters2 = trim(
            text5.substring(text5.indexOf("=", index) + 1, closeIndex)
          ).split(" ");
          otag = delimiters2[0];
          ctag = delimiters2[delimiters2.length - 1];
          return closeIndex + close.length - 1;
        }
        if (delimiters) {
          delimiters = delimiters.split(" ");
          otag = delimiters[0];
          ctag = delimiters[1];
        }
        for (i4 = 0; i4 < len; i4++) {
          if (state == IN_TEXT) {
            if (tagChange(otag, text4, i4)) {
              --i4;
              addBuf();
              state = IN_TAG_TYPE;
            } else {
              if (text4.charAt(i4) == "\n") {
                filterLine(seenTag);
              } else {
                buf += text4.charAt(i4);
              }
            }
          } else if (state == IN_TAG_TYPE) {
            i4 += otag.length - 1;
            tag = Hogan2.tags[text4.charAt(i4 + 1)];
            tagType = tag ? text4.charAt(i4 + 1) : "_v";
            if (tagType == "=") {
              i4 = changeDelimiters(text4, i4);
              state = IN_TEXT;
            } else {
              if (tag) {
                i4++;
              }
              state = IN_TAG;
            }
            seenTag = i4;
          } else {
            if (tagChange(ctag, text4, i4)) {
              tokens.push({
                tag: tagType,
                n: trim(buf),
                otag,
                ctag,
                i: tagType == "/" ? seenTag - otag.length : i4 + ctag.length
              });
              buf = "";
              i4 += ctag.length - 1;
              state = IN_TEXT;
              if (tagType == "{") {
                if (ctag == "}}") {
                  i4++;
                } else {
                  cleanTripleStache(tokens[tokens.length - 1]);
                }
              }
            } else {
              buf += text4.charAt(i4);
            }
          }
        }
        filterLine(seenTag, true);
        return tokens;
      };
      function cleanTripleStache(token) {
        if (token.n.substr(token.n.length - 1) === "}") {
          token.n = token.n.substring(0, token.n.length - 1);
        }
      }
      function trim(s4) {
        if (s4.trim) {
          return s4.trim();
        }
        return s4.replace(/^\s*|\s*$/g, "");
      }
      function tagChange(tag, text4, index) {
        if (text4.charAt(index) != tag.charAt(0)) {
          return false;
        }
        for (var i4 = 1, l4 = tag.length; i4 < l4; i4++) {
          if (text4.charAt(index + i4) != tag.charAt(i4)) {
            return false;
          }
        }
        return true;
      }
      var allowedInSuper = { "_t": true, "\n": true, "$": true, "/": true };
      function buildTree(tokens, kind, stack, customTags) {
        var instructions = [], opener = null, tail = null, token = null;
        tail = stack[stack.length - 1];
        while (tokens.length > 0) {
          token = tokens.shift();
          if (tail && tail.tag == "<" && !(token.tag in allowedInSuper)) {
            throw new Error("Illegal content in < super tag.");
          }
          if (Hogan2.tags[token.tag] <= Hogan2.tags["$"] || isOpener(token, customTags)) {
            stack.push(token);
            token.nodes = buildTree(tokens, token.tag, stack, customTags);
          } else if (token.tag == "/") {
            if (stack.length === 0) {
              throw new Error("Closing tag without opener: /" + token.n);
            }
            opener = stack.pop();
            if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) {
              throw new Error("Nesting error: " + opener.n + " vs. " + token.n);
            }
            opener.end = token.i;
            return instructions;
          } else if (token.tag == "\n") {
            token.last = tokens.length == 0 || tokens[0].tag == "\n";
          }
          instructions.push(token);
        }
        if (stack.length > 0) {
          throw new Error("missing closing tag: " + stack.pop().n);
        }
        return instructions;
      }
      function isOpener(token, tags) {
        for (var i4 = 0, l4 = tags.length; i4 < l4; i4++) {
          if (tags[i4].o == token.n) {
            token.tag = "#";
            return true;
          }
        }
      }
      function isCloser(close, open, tags) {
        for (var i4 = 0, l4 = tags.length; i4 < l4; i4++) {
          if (tags[i4].c == close && tags[i4].o == open) {
            return true;
          }
        }
      }
      function stringifySubstitutions(obj) {
        var items = [];
        for (var key2 in obj) {
          items.push('"' + esc2(key2) + '": function(c,p,t,i) {' + obj[key2] + "}");
        }
        return "{ " + items.join(",") + " }";
      }
      function stringifyPartials(codeObj) {
        var partials = [];
        for (var key2 in codeObj.partials) {
          partials.push('"' + esc2(key2) + '":{name:"' + esc2(codeObj.partials[key2].name) + '", ' + stringifyPartials(codeObj.partials[key2]) + "}");
        }
        return "partials: {" + partials.join(",") + "}, subs: " + stringifySubstitutions(codeObj.subs);
      }
      Hogan2.stringify = function(codeObj, text4, options) {
        return "{code: function (c,p,i) { " + Hogan2.wrapMain(codeObj.code) + " }," + stringifyPartials(codeObj) + "}";
      };
      var serialNo = 0;
      Hogan2.generate = function(tree, text4, options) {
        serialNo = 0;
        var context = { code: "", subs: {}, partials: {} };
        Hogan2.walk(tree, context);
        if (options.asString) {
          return this.stringify(context, text4, options);
        }
        return this.makeTemplate(context, text4, options);
      };
      Hogan2.wrapMain = function(code) {
        return 'var t=this;t.b(i=i||"");' + code + "return t.fl();";
      };
      Hogan2.template = Hogan2.Template;
      Hogan2.makeTemplate = function(codeObj, text4, options) {
        var template = this.makePartials(codeObj);
        template.code = new Function("c", "p", "i", this.wrapMain(codeObj.code));
        return new this.template(template, text4, this, options);
      };
      Hogan2.makePartials = function(codeObj) {
        var key2, template = { subs: {}, partials: codeObj.partials, name: codeObj.name };
        for (key2 in template.partials) {
          template.partials[key2] = this.makePartials(template.partials[key2]);
        }
        for (key2 in codeObj.subs) {
          template.subs[key2] = new Function("c", "p", "t", "i", codeObj.subs[key2]);
        }
        return template;
      };
      function esc2(s4) {
        return s4.replace(rSlash, "\\\\").replace(rQuot, '\\"').replace(rNewline, "\\n").replace(rCr, "\\r").replace(rLineSep, "\\u2028").replace(rParagraphSep, "\\u2029");
      }
      function chooseMethod(s4) {
        return ~s4.indexOf(".") ? "d" : "f";
      }
      function createPartial(node, context) {
        var prefix = "<" + (context.prefix || "");
        var sym = prefix + node.n + serialNo++;
        context.partials[sym] = { name: node.n, partials: {} };
        context.code += 't.b(t.rp("' + esc2(sym) + '",c,p,"' + (node.indent || "") + '"));';
        return sym;
      }
      Hogan2.codegen = {
        "#": function(node, context) {
          context.code += "if(t.s(t." + chooseMethod(node.n) + '("' + esc2(node.n) + '",c,p,1),c,p,0,' + node.i + "," + node.end + ',"' + node.otag + " " + node.ctag + '")){t.rs(c,p,function(c,p,t){';
          Hogan2.walk(node.nodes, context);
          context.code += "});c.pop();}";
        },
        "^": function(node, context) {
          context.code += "if(!t.s(t." + chooseMethod(node.n) + '("' + esc2(node.n) + '",c,p,1),c,p,1,0,0,"")){';
          Hogan2.walk(node.nodes, context);
          context.code += "};";
        },
        ">": createPartial,
        "<": function(node, context) {
          var ctx = { partials: {}, code: "", subs: {}, inPartial: true };
          Hogan2.walk(node.nodes, ctx);
          var template = context.partials[createPartial(node, context)];
          template.subs = ctx.subs;
          template.partials = ctx.partials;
        },
        "$": function(node, context) {
          var ctx = { subs: {}, code: "", partials: context.partials, prefix: node.n };
          Hogan2.walk(node.nodes, ctx);
          context.subs[node.n] = ctx.code;
          if (!context.inPartial) {
            context.code += 't.sub("' + esc2(node.n) + '",c,p,i);';
          }
        },
        "\n": function(node, context) {
          context.code += write('"\\n"' + (node.last ? "" : " + i"));
        },
        "_v": function(node, context) {
          context.code += "t.b(t.v(t." + chooseMethod(node.n) + '("' + esc2(node.n) + '",c,p,0)));';
        },
        "_t": function(node, context) {
          context.code += write('"' + esc2(node.text) + '"');
        },
        "{": tripleStache,
        "&": tripleStache
      };
      function tripleStache(node, context) {
        context.code += "t.b(t.t(t." + chooseMethod(node.n) + '("' + esc2(node.n) + '",c,p,0)));';
      }
      function write(s4) {
        return "t.b(" + s4 + ");";
      }
      Hogan2.walk = function(nodelist, context) {
        var func;
        for (var i4 = 0, l4 = nodelist.length; i4 < l4; i4++) {
          func = Hogan2.codegen[nodelist[i4].tag];
          func && func(nodelist[i4], context);
        }
        return context;
      };
      Hogan2.parse = function(tokens, text4, options) {
        options = options || {};
        return buildTree(tokens, "", [], options.sectionTags || []);
      };
      Hogan2.cache = {};
      Hogan2.cacheKey = function(text4, options) {
        return [text4, !!options.asString, !!options.disableLambda, options.delimiters, !!options.modelGet].join("||");
      };
      Hogan2.compile = function(text4, options) {
        options = options || {};
        var key2 = Hogan2.cacheKey(text4, options);
        var template = this.cache[key2];
        if (template) {
          var partials = template.partials;
          for (var name16 in partials) {
            delete partials[name16].instance;
          }
          return template;
        }
        template = this.generate(this.parse(this.scan(text4, options.delimiters), text4, options), text4, options);
        return this.cache[key2] = template;
      };
    })(typeof exports !== "undefined" ? exports : Hogan);
  }
});

// node_modules/hogan.js/lib/template.js
var require_template = __commonJS({
  "node_modules/hogan.js/lib/template.js"(exports) {
    var Hogan2 = {};
    (function(Hogan3) {
      Hogan3.Template = function(codeObj, text4, compiler, options) {
        codeObj = codeObj || {};
        this.r = codeObj.code || this.r;
        this.c = compiler;
        this.options = options || {};
        this.text = text4 || "";
        this.partials = codeObj.partials || {};
        this.subs = codeObj.subs || {};
        this.buf = "";
      };
      Hogan3.Template.prototype = {
        // render: replaced by generated code.
        r: function(context, partials, indent) {
          return "";
        },
        // variable escaping
        v: hoganEscape,
        // triple stache
        t: coerceToString,
        render: function render(context, partials, indent) {
          return this.ri([context], partials || {}, indent);
        },
        // render internal -- a hook for overrides that catches partials too
        ri: function(context, partials, indent) {
          return this.r(context, partials, indent);
        },
        // ensurePartial
        ep: function(symbol18, partials) {
          var partial2 = this.partials[symbol18];
          var template = partials[partial2.name];
          if (partial2.instance && partial2.base == template) {
            return partial2.instance;
          }
          if (typeof template == "string") {
            if (!this.c) {
              throw new Error("No compiler available.");
            }
            template = this.c.compile(template, this.options);
          }
          if (!template) {
            return null;
          }
          this.partials[symbol18].base = template;
          if (partial2.subs) {
            if (!partials.stackText)
              partials.stackText = {};
            for (key in partial2.subs) {
              if (!partials.stackText[key]) {
                partials.stackText[key] = this.activeSub !== void 0 && partials.stackText[this.activeSub] ? partials.stackText[this.activeSub] : this.text;
              }
            }
            template = createSpecializedPartial(
              template,
              partial2.subs,
              partial2.partials,
              this.stackSubs,
              this.stackPartials,
              partials.stackText
            );
          }
          this.partials[symbol18].instance = template;
          return template;
        },
        // tries to find a partial in the current scope and render it
        rp: function(symbol18, context, partials, indent) {
          var partial2 = this.ep(symbol18, partials);
          if (!partial2) {
            return "";
          }
          return partial2.ri(context, partials, indent);
        },
        // render a section
        rs: function(context, partials, section) {
          var tail = context[context.length - 1];
          if (!isArray(tail)) {
            section(context, partials, this);
            return;
          }
          for (var i4 = 0; i4 < tail.length; i4++) {
            context.push(tail[i4]);
            section(context, partials, this);
            context.pop();
          }
        },
        // maybe start a section
        s: function(val, ctx, partials, inverted, start, end, tags) {
          var pass;
          if (isArray(val) && val.length === 0) {
            return false;
          }
          if (typeof val == "function") {
            val = this.ms(val, ctx, partials, inverted, start, end, tags);
          }
          pass = !!val;
          if (!inverted && pass && ctx) {
            ctx.push(typeof val == "object" ? val : ctx[ctx.length - 1]);
          }
          return pass;
        },
        // find values with dotted names
        d: function(key2, ctx, partials, returnFound) {
          var found, names = key2.split("."), val = this.f(names[0], ctx, partials, returnFound), doModelGet = this.options.modelGet, cx2 = null;
          if (key2 === "." && isArray(ctx[ctx.length - 2])) {
            val = ctx[ctx.length - 1];
          } else {
            for (var i4 = 1; i4 < names.length; i4++) {
              found = findInScope(names[i4], val, doModelGet);
              if (found !== void 0) {
                cx2 = val;
                val = found;
              } else {
                val = "";
              }
            }
          }
          if (returnFound && !val) {
            return false;
          }
          if (!returnFound && typeof val == "function") {
            ctx.push(cx2);
            val = this.mv(val, ctx, partials);
            ctx.pop();
          }
          return val;
        },
        // find values with normal names
        f: function(key2, ctx, partials, returnFound) {
          var val = false, v4 = null, found = false, doModelGet = this.options.modelGet;
          for (var i4 = ctx.length - 1; i4 >= 0; i4--) {
            v4 = ctx[i4];
            val = findInScope(key2, v4, doModelGet);
            if (val !== void 0) {
              found = true;
              break;
            }
          }
          if (!found) {
            return returnFound ? false : "";
          }
          if (!returnFound && typeof val == "function") {
            val = this.mv(val, ctx, partials);
          }
          return val;
        },
        // higher order templates
        ls: function(func, cx2, partials, text4, tags) {
          var oldTags = this.options.delimiters;
          this.options.delimiters = tags;
          this.b(this.ct(coerceToString(func.call(cx2, text4)), cx2, partials));
          this.options.delimiters = oldTags;
          return false;
        },
        // compile text
        ct: function(text4, cx2, partials) {
          if (this.options.disableLambda) {
            throw new Error("Lambda features disabled.");
          }
          return this.c.compile(text4, this.options).render(cx2, partials);
        },
        // template result buffering
        b: function(s4) {
          this.buf += s4;
        },
        fl: function() {
          var r3 = this.buf;
          this.buf = "";
          return r3;
        },
        // method replace section
        ms: function(func, ctx, partials, inverted, start, end, tags) {
          var textSource, cx2 = ctx[ctx.length - 1], result = func.call(cx2);
          if (typeof result == "function") {
            if (inverted) {
              return true;
            } else {
              textSource = this.activeSub && this.subsText && this.subsText[this.activeSub] ? this.subsText[this.activeSub] : this.text;
              return this.ls(result, cx2, partials, textSource.substring(start, end), tags);
            }
          }
          return result;
        },
        // method replace variable
        mv: function(func, ctx, partials) {
          var cx2 = ctx[ctx.length - 1];
          var result = func.call(cx2);
          if (typeof result == "function") {
            return this.ct(coerceToString(result.call(cx2)), cx2, partials);
          }
          return result;
        },
        sub: function(name16, context, partials, indent) {
          var f4 = this.subs[name16];
          if (f4) {
            this.activeSub = name16;
            f4(context, partials, this, indent);
            this.activeSub = false;
          }
        }
      };
      function findInScope(key2, scope, doModelGet) {
        var val;
        if (scope && typeof scope == "object") {
          if (scope[key2] !== void 0) {
            val = scope[key2];
          } else if (doModelGet && scope.get && typeof scope.get == "function") {
            val = scope.get(key2);
          }
        }
        return val;
      }
      function createSpecializedPartial(instance, subs, partials, stackSubs, stackPartials, stackText) {
        function PartialTemplate() {
        }
        ;
        PartialTemplate.prototype = instance;
        function Substitutions() {
        }
        ;
        Substitutions.prototype = instance.subs;
        var key2;
        var partial2 = new PartialTemplate();
        partial2.subs = new Substitutions();
        partial2.subsText = {};
        partial2.buf = "";
        stackSubs = stackSubs || {};
        partial2.stackSubs = stackSubs;
        partial2.subsText = stackText;
        for (key2 in subs) {
          if (!stackSubs[key2])
            stackSubs[key2] = subs[key2];
        }
        for (key2 in stackSubs) {
          partial2.subs[key2] = stackSubs[key2];
        }
        stackPartials = stackPartials || {};
        partial2.stackPartials = stackPartials;
        for (key2 in partials) {
          if (!stackPartials[key2])
            stackPartials[key2] = partials[key2];
        }
        for (key2 in stackPartials) {
          partial2.partials[key2] = stackPartials[key2];
        }
        return partial2;
      }
      var rAmp = /&/g, rLt = /</g, rGt = />/g, rApos = /\'/g, rQuot = /\"/g, hChars = /[&<>\"\']/;
      function coerceToString(val) {
        return String(val === null || val === void 0 ? "" : val);
      }
      function hoganEscape(str) {
        str = coerceToString(str);
        return hChars.test(str) ? str.replace(rAmp, "&amp;").replace(rLt, "&lt;").replace(rGt, "&gt;").replace(rApos, "&#39;").replace(rQuot, "&quot;") : str;
      }
      var isArray = Array.isArray || function(a4) {
        return Object.prototype.toString.call(a4) === "[object Array]";
      };
    })(typeof exports !== "undefined" ? exports : Hogan2);
  }
});

// node_modules/hogan.js/lib/hogan.js
var require_hogan = __commonJS({
  "node_modules/hogan.js/lib/hogan.js"(exports, module) {
    var Hogan2 = require_compiler();
    Hogan2.Template = require_template().Template;
    Hogan2.template = Hogan2.Template;
    module.exports = Hogan2;
  }
});

// node_modules/@vercel/oidc/dist/get-context.js
var require_get_context = __commonJS({
  "node_modules/@vercel/oidc/dist/get-context.js"(exports, module) {
    "use strict";
    var __defProp2 = Object.defineProperty;
    var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
    var __getOwnPropNames = Object.getOwnPropertyNames;
    var __hasOwnProp = Object.prototype.hasOwnProperty;
    var __export3 = (target, all) => {
      for (var name16 in all)
        __defProp2(target, name16, { get: all[name16], enumerable: true });
    };
    var __copyProps = (to, from, except, desc) => {
      if (from && typeof from === "object" || typeof from === "function") {
        for (let key2 of __getOwnPropNames(from))
          if (!__hasOwnProp.call(to, key2) && key2 !== except)
            __defProp2(to, key2, { get: () => from[key2], enumerable: !(desc = __getOwnPropDesc(from, key2)) || desc.enumerable });
      }
      return to;
    };
    var __toCommonJS = (mod) => __copyProps(__defProp2({}, "__esModule", { value: true }), mod);
    var get_context_exports = {};
    __export3(get_context_exports, {
      SYMBOL_FOR_REQ_CONTEXT: () => SYMBOL_FOR_REQ_CONTEXT,
      getContext: () => getContext3
    });
    module.exports = __toCommonJS(get_context_exports);
    var SYMBOL_FOR_REQ_CONTEXT = Symbol.for("@vercel/request-context");
    function getContext3() {
      var _a17, _b8, _c;
      const fromSymbol = globalThis;
      return (_c = (_b8 = (_a17 = fromSymbol[SYMBOL_FOR_REQ_CONTEXT]) == null ? void 0 : _a17.get) == null ? void 0 : _b8.call(_a17)) != null ? _c : {};
    }
  }
});

// node_modules/@vercel/oidc/dist/index-browser.js
var require_index_browser = __commonJS({
  "node_modules/@vercel/oidc/dist/index-browser.js"(exports, module) {
    "use strict";
    var __defProp2 = Object.defineProperty;
    var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
    var __getOwnPropNames = Object.getOwnPropertyNames;
    var __hasOwnProp = Object.prototype.hasOwnProperty;
    var __export3 = (target, all) => {
      for (var name16 in all)
        __defProp2(target, name16, { get: all[name16], enumerable: true });
    };
    var __copyProps = (to, from, except, desc) => {
      if (from && typeof from === "object" || typeof from === "function") {
        for (let key2 of __getOwnPropNames(from))
          if (!__hasOwnProp.call(to, key2) && key2 !== except)
            __defProp2(to, key2, { get: () => from[key2], enumerable: !(desc = __getOwnPropDesc(from, key2)) || desc.enumerable });
      }
      return to;
    };
    var __toCommonJS = (mod) => __copyProps(__defProp2({}, "__esModule", { value: true }), mod);
    var index_browser_exports = {};
    __export3(index_browser_exports, {
      getContext: () => import_get_context.getContext,
      getVercelOidcToken: () => getVercelOidcToken2,
      getVercelOidcTokenSync: () => getVercelOidcTokenSync
    });
    module.exports = __toCommonJS(index_browser_exports);
    var import_get_context = require_get_context();
    async function getVercelOidcToken2() {
      return "";
    }
    function getVercelOidcTokenSync() {
      return "";
    }
  }
});

// node_modules/instantsearch.js/es/lib/utils/capitalize.js
function capitalize(text4) {
  return text4.toString().charAt(0).toUpperCase() + text4.toString().slice(1);
}

// node_modules/instantsearch.js/es/lib/utils/getObjectType.js
function getObjectType(object3) {
  return Object.prototype.toString.call(object3).slice(8, -1);
}

// node_modules/instantsearch.js/es/lib/utils/checkRendering.js
function checkRendering(rendering, usage) {
  if (rendering === void 0 || typeof rendering !== "function") {
    throw new Error("The render function is not valid (received type ".concat(getObjectType(rendering), ").\n\n").concat(usage));
  }
}

// node_modules/instantsearch.js/es/lib/utils/clearRefinements.js
function clearRefinements(_ref9) {
  var helper = _ref9.helper, _ref$attributesToClea = _ref9.attributesToClear, attributesToClear = _ref$attributesToClea === void 0 ? [] : _ref$attributesToClea;
  var finalState = helper.state.setPage(0);
  finalState = attributesToClear.reduce(function(state, attribute) {
    if (finalState.isNumericRefined(attribute)) {
      return state.removeNumericRefinement(attribute);
    }
    if (finalState.isHierarchicalFacet(attribute)) {
      return state.removeHierarchicalFacetRefinement(attribute);
    }
    if (finalState.isDisjunctiveFacet(attribute)) {
      return state.removeDisjunctiveFacetRefinement(attribute);
    }
    if (finalState.isConjunctiveFacet(attribute)) {
      return state.removeFacetRefinement(attribute);
    }
    return state;
  }, finalState);
  if (attributesToClear.indexOf("query") !== -1) {
    finalState = finalState.setQuery("");
  }
  return finalState;
}

// node_modules/instantsearch.js/es/lib/utils/createConcurrentSafePromise.js
function createConcurrentSafePromise() {
  var basePromiseId = -1;
  var latestResolvedId = -1;
  var latestResolvedValue = void 0;
  return function runConcurrentSafePromise(promise2) {
    var currentPromiseId = ++basePromiseId;
    return Promise.resolve(promise2).then(function(x4) {
      if (latestResolvedValue && currentPromiseId < latestResolvedId) {
        return latestResolvedValue;
      }
      latestResolvedId = currentPromiseId;
      latestResolvedValue = x4;
      return x4;
    });
  };
}

// node_modules/instantsearch.js/es/lib/utils/isFacetRefined.js
function isFacetRefined(helper, facet, value) {
  if (helper.state.isHierarchicalFacet(facet)) {
    return helper.state.isHierarchicalFacetRefined(facet, value);
  } else if (helper.state.isConjunctiveFacet(facet)) {
    return helper.state.isFacetRefined(facet, value);
  } else {
    return helper.state.isDisjunctiveFacetRefined(facet, value);
  }
}

// node_modules/instantsearch.js/es/lib/utils/createSendEventForFacet.js
function ownKeys(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys(Object(t4), true).forEach(function(r4) {
      _defineProperty(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty(obj, key2, value) {
  key2 = _toPropertyKey(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey(t4) {
  var i4 = _toPrimitive(t4, "string");
  return "symbol" == _typeof(i4) ? i4 : String(i4);
}
function _toPrimitive(t4, r3) {
  if ("object" != _typeof(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _typeof(o4) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof(o4);
}
function _slicedToArray(arr, i4) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i4) || _unsupportedIterableToArray(arr, i4) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray(o4, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
function _iterableToArrayLimit(r3, l4) {
  var t4 = null == r3 ? null : "undefined" != typeof Symbol && r3[Symbol.iterator] || r3["@@iterator"];
  if (null != t4) {
    var e4, n4, i4, u4, a4 = [], f4 = true, o4 = false;
    try {
      if (i4 = (t4 = t4.call(r3)).next, 0 === l4) {
        if (Object(t4) !== t4)
          return;
        f4 = false;
      } else
        for (; !(f4 = (e4 = i4.call(t4)).done) && (a4.push(e4.value), a4.length !== l4); f4 = true)
          ;
    } catch (r4) {
      o4 = true, n4 = r4;
    } finally {
      try {
        if (!f4 && null != t4.return && (u4 = t4.return(), Object(u4) !== u4))
          return;
      } finally {
        if (o4)
          throw n4;
      }
    }
    return a4;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function createSendEventForFacet(_ref9) {
  var instantSearchInstance = _ref9.instantSearchInstance, helper = _ref9.helper, attr = _ref9.attribute, widgetType = _ref9.widgetType;
  var sendEventForFacet = function sendEventForFacet2() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var facetValue = args[1], _args$ = args[2], eventName = _args$ === void 0 ? "Filter Applied" : _args$, _args$2 = args[3], additionalData = _args$2 === void 0 ? {} : _args$2;
    var _args$0$split = args[0].split(":"), _args$0$split2 = _slicedToArray(_args$0$split, 2), eventType = _args$0$split2[0], eventModifier = _args$0$split2[1];
    var attribute = typeof attr === "string" ? attr : attr(facetValue);
    if (args.length === 1 && _typeof(args[0]) === "object") {
      instantSearchInstance.sendEventToInsights(args[0]);
    } else if (eventType === "click" && args.length >= 2 && args.length <= 4) {
      if (!isFacetRefined(helper, attribute, facetValue)) {
        var _helper$lastResults;
        instantSearchInstance.sendEventToInsights({
          insightsMethod: "clickedFilters",
          widgetType,
          eventType,
          eventModifier,
          payload: _objectSpread({
            eventName,
            index: ((_helper$lastResults = helper.lastResults) === null || _helper$lastResults === void 0 ? void 0 : _helper$lastResults.index) || helper.state.index,
            filters: ["".concat(attribute, ":").concat(facetValue)]
          }, additionalData),
          attribute
        });
      }
    } else if (false) {
      throw new Error("You need to pass between two and four arguments like:\n  sendEvent('click', facetValue, eventName?, additionalData?);\n\nIf you want to send a custom payload, you can pass one object: sendEvent(customPayload);\n");
    }
  };
  return sendEventForFacet;
}

// node_modules/instantsearch.js/es/lib/utils/createSendEventForHits.js
function ownKeys2(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread2(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys2(Object(t4), true).forEach(function(r4) {
      _defineProperty2(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys2(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty2(obj, key2, value) {
  key2 = _toPropertyKey2(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey2(t4) {
  var i4 = _toPrimitive2(t4, "string");
  return "symbol" == _typeof2(i4) ? i4 : String(i4);
}
function _toPrimitive2(t4, r3) {
  if ("object" != _typeof2(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof2(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _slicedToArray2(arr, i4) {
  return _arrayWithHoles2(arr) || _iterableToArrayLimit2(arr, i4) || _unsupportedIterableToArray2(arr, i4) || _nonIterableRest2();
}
function _nonIterableRest2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray2(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray2(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray2(o4, minLen);
}
function _arrayLikeToArray2(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
function _iterableToArrayLimit2(r3, l4) {
  var t4 = null == r3 ? null : "undefined" != typeof Symbol && r3[Symbol.iterator] || r3["@@iterator"];
  if (null != t4) {
    var e4, n4, i4, u4, a4 = [], f4 = true, o4 = false;
    try {
      if (i4 = (t4 = t4.call(r3)).next, 0 === l4) {
        if (Object(t4) !== t4)
          return;
        f4 = false;
      } else
        for (; !(f4 = (e4 = i4.call(t4)).done) && (a4.push(e4.value), a4.length !== l4); f4 = true)
          ;
    } catch (r4) {
      o4 = true, n4 = r4;
    } finally {
      try {
        if (!f4 && null != t4.return && (u4 = t4.return(), Object(u4) !== u4))
          return;
      } finally {
        if (o4)
          throw n4;
      }
    }
    return a4;
  }
}
function _arrayWithHoles2(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _typeof2(o4) {
  "@babel/helpers - typeof";
  return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof2(o4);
}
function chunk(arr) {
  var chunkSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 20;
  var chunks = [];
  for (var i4 = 0; i4 < Math.ceil(arr.length / chunkSize); i4++) {
    chunks.push(arr.slice(i4 * chunkSize, (i4 + 1) * chunkSize));
  }
  return chunks;
}
function _buildEventPayloadsForHits(_ref9) {
  var helper = _ref9.helper, widgetType = _ref9.widgetType, methodName = _ref9.methodName, args = _ref9.args, instantSearchInstance = _ref9.instantSearchInstance;
  if (args.length === 1 && _typeof2(args[0]) === "object") {
    return [args[0]];
  }
  var _args$0$split = args[0].split(":"), _args$0$split2 = _slicedToArray2(_args$0$split, 2), eventType = _args$0$split2[0], eventModifier = _args$0$split2[1];
  var hits2 = args[1];
  var eventName = args[2];
  var additionalData = args[3] || {};
  if (!hits2) {
    if (false) {
      throw new Error("You need to pass hit or hits as the second argument like:\n  ".concat(methodName, "(eventType, hit);\n  "));
    } else {
      return [];
    }
  }
  if ((eventType === "click" || eventType === "conversion") && !eventName) {
    if (false) {
      throw new Error("You need to pass eventName as the third argument for 'click' or 'conversion' events like:\n  ".concat(methodName, "('click', hit, 'Product Purchased');\n\n  To learn more about event naming: https://www.algolia.com/doc/guides/getting-insights-and-analytics/search-analytics/click-through-and-conversions/in-depth/clicks-conversions-best-practices/\n  "));
    } else {
      return [];
    }
  }
  var hitsArray = Array.isArray(hits2) ? hits2 : [hits2];
  if (hitsArray.length === 0) {
    return [];
  }
  var queryID = hitsArray[0].__queryID;
  var hitsChunks = chunk(hitsArray);
  var objectIDsByChunk = hitsChunks.map(function(batch) {
    return batch.map(function(hit) {
      return hit.objectID;
    });
  });
  var positionsByChunk = hitsChunks.map(function(batch) {
    return batch.map(function(hit) {
      return hit.__position;
    });
  });
  if (eventType === "view") {
    if (instantSearchInstance.status !== "idle") {
      return [];
    }
    return hitsChunks.map(function(batch, i4) {
      var _helper$lastResults;
      return {
        insightsMethod: "viewedObjectIDs",
        widgetType,
        eventType,
        payload: _objectSpread2({
          eventName: eventName || "Hits Viewed",
          index: ((_helper$lastResults = helper.lastResults) === null || _helper$lastResults === void 0 ? void 0 : _helper$lastResults.index) || helper.state.index,
          objectIDs: objectIDsByChunk[i4]
        }, additionalData),
        hits: batch,
        eventModifier
      };
    });
  } else if (eventType === "click") {
    return hitsChunks.map(function(batch, i4) {
      var _helper$lastResults2;
      return {
        insightsMethod: "clickedObjectIDsAfterSearch",
        widgetType,
        eventType,
        payload: _objectSpread2({
          eventName: eventName || "Hit Clicked",
          index: ((_helper$lastResults2 = helper.lastResults) === null || _helper$lastResults2 === void 0 ? void 0 : _helper$lastResults2.index) || helper.state.index,
          queryID,
          objectIDs: objectIDsByChunk[i4],
          positions: positionsByChunk[i4]
        }, additionalData),
        hits: batch,
        eventModifier
      };
    });
  } else if (eventType === "conversion") {
    return hitsChunks.map(function(batch, i4) {
      var _helper$lastResults3;
      return {
        insightsMethod: "convertedObjectIDsAfterSearch",
        widgetType,
        eventType,
        payload: _objectSpread2({
          eventName: eventName || "Hit Converted",
          index: ((_helper$lastResults3 = helper.lastResults) === null || _helper$lastResults3 === void 0 ? void 0 : _helper$lastResults3.index) || helper.state.index,
          queryID,
          objectIDs: objectIDsByChunk[i4]
        }, additionalData),
        hits: batch,
        eventModifier
      };
    });
  } else if (false) {
    throw new Error('eventType("'.concat(eventType, '") is not supported.\n    If you want to send a custom payload, you can pass one object: ').concat(methodName, "(customPayload);\n    "));
  } else {
    return [];
  }
}
function createSendEventForHits(_ref23) {
  var instantSearchInstance = _ref23.instantSearchInstance, helper = _ref23.helper, widgetType = _ref23.widgetType;
  var sentEvents = {};
  var timer = void 0;
  var sendEventForHits = function sendEventForHits2() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var payloads = _buildEventPayloadsForHits({
      widgetType,
      helper,
      methodName: "sendEvent",
      args,
      instantSearchInstance
    });
    payloads.forEach(function(payload) {
      if (payload.eventType === "click" && payload.eventModifier === "internal" && sentEvents[payload.eventType]) {
        return;
      }
      sentEvents[payload.eventType] = true;
      instantSearchInstance.sendEventToInsights(payload);
    });
    clearTimeout(timer);
    timer = setTimeout(function() {
      sentEvents = {};
    }, 0);
  };
  return sendEventForHits;
}
function createBindEventForHits(_ref33) {
  var helper = _ref33.helper, widgetType = _ref33.widgetType, instantSearchInstance = _ref33.instantSearchInstance;
  var bindEventForHits = function bindEventForHits2() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    var payloads = _buildEventPayloadsForHits({
      widgetType,
      helper,
      methodName: "bindEvent",
      args,
      instantSearchInstance
    });
    return payloads.length ? "data-insights-event=".concat(serializePayload(payloads)) : "";
  };
  return bindEventForHits;
}

// node_modules/instantsearch.js/es/lib/utils/debounce.js
function debounce(func, wait) {
  var lastTimeout = null;
  return function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return new Promise(function(resolve2, reject) {
      if (lastTimeout) {
        clearTimeout(lastTimeout);
      }
      lastTimeout = setTimeout(function() {
        lastTimeout = null;
        Promise.resolve(func.apply(void 0, args)).then(resolve2).catch(reject);
      }, wait);
    });
  };
}

// node_modules/instantsearch.js/es/lib/utils/escapeFacetValue.js
function unescapeFacetValue(value) {
  if (typeof value === "string") {
    return value.replace(/^\\-/, "-");
  }
  return value;
}
function escapeFacetValue(value) {
  if (typeof value === "number" && value < 0 || typeof value === "string") {
    return String(value).replace(/^-/, "\\-");
  }
  return value;
}

// node_modules/instantsearch.js/es/lib/utils/geo-search.js
function _slicedToArray3(arr, i4) {
  return _arrayWithHoles3(arr) || _iterableToArrayLimit3(arr, i4) || _unsupportedIterableToArray3(arr, i4) || _nonIterableRest3();
}
function _nonIterableRest3() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray3(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray3(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray3(o4, minLen);
}
function _arrayLikeToArray3(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
function _iterableToArrayLimit3(r3, l4) {
  var t4 = null == r3 ? null : "undefined" != typeof Symbol && r3[Symbol.iterator] || r3["@@iterator"];
  if (null != t4) {
    var e4, n4, i4, u4, a4 = [], f4 = true, o4 = false;
    try {
      if (i4 = (t4 = t4.call(r3)).next, 0 === l4) {
        if (Object(t4) !== t4)
          return;
        f4 = false;
      } else
        for (; !(f4 = (e4 = i4.call(t4)).done) && (a4.push(e4.value), a4.length !== l4); f4 = true)
          ;
    } catch (r4) {
      o4 = true, n4 = r4;
    } finally {
      try {
        if (!f4 && null != t4.return && (u4 = t4.return(), Object(u4) !== u4))
          return;
      } finally {
        if (o4)
          throw n4;
      }
    }
    return a4;
  }
}
function _arrayWithHoles3(arr) {
  if (Array.isArray(arr))
    return arr;
}
var latLngRegExp = /^(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)$/;
function aroundLatLngToPosition(value) {
  var pattern = value.match(latLngRegExp);
  if (!pattern) {
    throw new Error('Invalid value for "aroundLatLng" parameter: "'.concat(value, '"'));
  }
  return {
    lat: parseFloat(pattern[1]),
    lng: parseFloat(pattern[2])
  };
}
function insideBoundingBoxArrayToBoundingBox(value) {
  var _value = _slicedToArray3(value, 1), _value$ = _value[0], _value$2 = _value$ === void 0 ? [void 0, void 0, void 0, void 0] : _value$, _value$3 = _slicedToArray3(_value$2, 4), neLat = _value$3[0], neLng = _value$3[1], swLat = _value$3[2], swLng = _value$3[3];
  if (!neLat || !neLng || !swLat || !swLng) {
    throw new Error('Invalid value for "insideBoundingBox" parameter: ['.concat(value, "]"));
  }
  return {
    northEast: {
      lat: neLat,
      lng: neLng
    },
    southWest: {
      lat: swLat,
      lng: swLng
    }
  };
}
function insideBoundingBoxStringToBoundingBox(value) {
  var _value$split$map = value.split(",").map(parseFloat), _value$split$map2 = _slicedToArray3(_value$split$map, 4), neLat = _value$split$map2[0], neLng = _value$split$map2[1], swLat = _value$split$map2[2], swLng = _value$split$map2[3];
  if (!neLat || !neLng || !swLat || !swLng) {
    throw new Error('Invalid value for "insideBoundingBox" parameter: "'.concat(value, '"'));
  }
  return {
    northEast: {
      lat: neLat,
      lng: neLng
    },
    southWest: {
      lat: swLat,
      lng: swLng
    }
  };
}
function insideBoundingBoxToBoundingBox(value) {
  if (Array.isArray(value)) {
    return insideBoundingBoxArrayToBoundingBox(value);
  }
  return insideBoundingBoxStringToBoundingBox(value);
}

// node_modules/instantsearch.js/es/lib/utils/isDomElement.js
function isDomElement(object3) {
  return object3 instanceof HTMLElement || Boolean(object3) && object3.nodeType > 0;
}

// node_modules/instantsearch.js/es/lib/utils/getContainerNode.js
function getContainerNode(selectorOrHTMLElement) {
  var isSelectorString = typeof selectorOrHTMLElement === "string";
  var domElement = isSelectorString ? document.querySelector(selectorOrHTMLElement) : selectorOrHTMLElement;
  if (!isDomElement(domElement)) {
    var errorMessage = "Container must be `string` or `HTMLElement`.";
    if (isSelectorString) {
      errorMessage += " Unable to find ".concat(selectorOrHTMLElement);
    }
    throw new Error(errorMessage);
  }
  return domElement;
}

// node_modules/instantsearch.js/es/lib/utils/getRefinements.js
function getRefinement(state, type, attribute, name16) {
  var resultsFacets = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [];
  var res = {
    type,
    attribute,
    name: name16,
    escapedValue: escapeFacetValue(name16)
  };
  var facet = find(resultsFacets, function(resultsFacet) {
    return resultsFacet.name === attribute;
  });
  var count;
  if (type === "hierarchical") {
    var facetDeclaration = state.getHierarchicalFacetByName(attribute);
    var nameParts = name16.split(facetDeclaration.separator);
    var getFacetRefinement = function getFacetRefinement2(facetData) {
      return function(refinementKey) {
        return facetData[refinementKey];
      };
    };
    var _loop = function _loop2(i5) {
      facet = facet && facet.data && find(Object.keys(facet.data).map(getFacetRefinement(facet.data)), function(refinement) {
        return refinement.name === nameParts[i5];
      });
    };
    for (var i4 = 0; facet !== void 0 && i4 < nameParts.length; ++i4) {
      _loop(i4);
    }
    count = facet && facet.count;
  } else {
    count = facet && facet.data && facet.data[res.name];
  }
  if (count !== void 0) {
    res.count = count;
  }
  if (facet && facet.exhaustive !== void 0) {
    res.exhaustive = facet.exhaustive;
  }
  return res;
}
function getRefinements(_results, state) {
  var includesQuery = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  var results = _results || {};
  var refinements = [];
  var _state$facetsRefineme = state.facetsRefinements, facetsRefinements = _state$facetsRefineme === void 0 ? {} : _state$facetsRefineme, _state$facetsExcludes = state.facetsExcludes, facetsExcludes = _state$facetsExcludes === void 0 ? {} : _state$facetsExcludes, _state$disjunctiveFac = state.disjunctiveFacetsRefinements, disjunctiveFacetsRefinements = _state$disjunctiveFac === void 0 ? {} : _state$disjunctiveFac, _state$hierarchicalFa = state.hierarchicalFacetsRefinements, hierarchicalFacetsRefinements = _state$hierarchicalFa === void 0 ? {} : _state$hierarchicalFa, _state$numericRefinem = state.numericRefinements, numericRefinements = _state$numericRefinem === void 0 ? {} : _state$numericRefinem, _state$tagRefinements = state.tagRefinements, tagRefinements = _state$tagRefinements === void 0 ? [] : _state$tagRefinements;
  Object.keys(facetsRefinements).forEach(function(attribute) {
    var refinementNames = facetsRefinements[attribute];
    refinementNames.forEach(function(refinementName) {
      refinements.push(getRefinement(state, "facet", attribute, refinementName, results.facets));
    });
  });
  Object.keys(facetsExcludes).forEach(function(attribute) {
    var refinementNames = facetsExcludes[attribute];
    refinementNames.forEach(function(refinementName) {
      refinements.push({
        type: "exclude",
        attribute,
        name: refinementName,
        exclude: true
      });
    });
  });
  Object.keys(disjunctiveFacetsRefinements).forEach(function(attribute) {
    var refinementNames = disjunctiveFacetsRefinements[attribute];
    refinementNames.forEach(function(refinementName) {
      refinements.push(getRefinement(
        state,
        "disjunctive",
        attribute,
        // We unescape any disjunctive refined values with `unescapeFacetValue` because
        // they can be escaped on negative numeric values with `escapeFacetValue`.
        unescapeFacetValue(refinementName),
        results.disjunctiveFacets
      ));
    });
  });
  Object.keys(hierarchicalFacetsRefinements).forEach(function(attribute) {
    var refinementNames = hierarchicalFacetsRefinements[attribute];
    refinementNames.forEach(function(refinement) {
      refinements.push(getRefinement(state, "hierarchical", attribute, refinement, results.hierarchicalFacets));
    });
  });
  Object.keys(numericRefinements).forEach(function(attribute) {
    var operators = numericRefinements[attribute];
    Object.keys(operators).forEach(function(operatorOriginal) {
      var operator = operatorOriginal;
      var valueOrValues = operators[operator];
      var refinementNames = Array.isArray(valueOrValues) ? valueOrValues : [valueOrValues];
      refinementNames.forEach(function(refinementName) {
        refinements.push({
          type: "numeric",
          attribute,
          name: "".concat(refinementName),
          numericValue: refinementName,
          operator
        });
      });
    });
  });
  tagRefinements.forEach(function(refinementName) {
    refinements.push({
      type: "tag",
      attribute: "_tags",
      name: refinementName
    });
  });
  if (includesQuery && state.query && state.query.trim()) {
    refinements.push({
      attribute: "query",
      type: "query",
      name: state.query,
      query: state.query
    });
  }
  return refinements;
}

// node_modules/instantsearch.js/es/lib/utils/getWidgetAttribute.js
function getWidgetAttribute(widget, initOptions) {
  var _widget$getWidgetRend;
  var renderState = (_widget$getWidgetRend = widget.getWidgetRenderState) === null || _widget$getWidgetRend === void 0 ? void 0 : _widget$getWidgetRend.call(widget, initOptions);
  var attribute = null;
  if (renderState && renderState.widgetParams) {
    var widgetParams = renderState.widgetParams;
    if (widgetParams.attribute) {
      attribute = widgetParams.attribute;
    } else if (Array.isArray(widgetParams.attributes)) {
      attribute = widgetParams.attributes[0];
    }
  }
  if (typeof attribute !== "string") {
    throw new Error("Could not find the attribute of the widget:\n\n".concat(JSON.stringify(widget), "\n\nPlease check whether the widget's getWidgetRenderState returns widgetParams.attribute correctly."));
  }
  return attribute;
}

// node_modules/instantsearch.js/es/lib/utils/hits-absolute-position.js
function _typeof3(o4) {
  "@babel/helpers - typeof";
  return _typeof3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof3(o4);
}
function ownKeys3(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread3(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys3(Object(t4), true).forEach(function(r4) {
      _defineProperty3(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys3(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty3(obj, key2, value) {
  key2 = _toPropertyKey3(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey3(t4) {
  var i4 = _toPrimitive3(t4, "string");
  return "symbol" == _typeof3(i4) ? i4 : String(i4);
}
function _toPrimitive3(t4, r3) {
  if ("object" != _typeof3(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof3(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function addAbsolutePosition(hits2, page2, hitsPerPage3) {
  return hits2.map(function(hit, idx) {
    return _objectSpread3(_objectSpread3({}, hit), {}, {
      __position: hitsPerPage3 * page2 + idx + 1
    });
  });
}

// node_modules/instantsearch.js/es/lib/utils/hits-query-id.js
function _typeof4(o4) {
  "@babel/helpers - typeof";
  return _typeof4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof4(o4);
}
function ownKeys4(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread4(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys4(Object(t4), true).forEach(function(r4) {
      _defineProperty4(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys4(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty4(obj, key2, value) {
  key2 = _toPropertyKey4(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey4(t4) {
  var i4 = _toPrimitive4(t4, "string");
  return "symbol" == _typeof4(i4) ? i4 : String(i4);
}
function _toPrimitive4(t4, r3) {
  if ("object" != _typeof4(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof4(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function addQueryID(hits2, queryID) {
  if (!queryID) {
    return hits2;
  }
  return hits2.map(function(hit) {
    return _objectSpread4(_objectSpread4({}, hit), {}, {
      __queryID: queryID
    });
  });
}

// node_modules/instantsearch.js/es/lib/utils/isFiniteNumber.js
function isFiniteNumber(value) {
  return typeof value === "number" && isFinite(value);
}

// node_modules/instantsearch.js/es/lib/utils/isSpecialClick.js
function isSpecialClick(event) {
  var isMiddleClick = event.button === 1;
  return isMiddleClick || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
}

// node_modules/instantsearch.js/es/lib/utils/walkIndex.js
function walkIndex(indexWidget, callback) {
  callback(indexWidget);
  indexWidget.getWidgets().forEach(function(widget) {
    if (isIndexWidget(widget)) {
      walkIndex(widget, callback);
    }
  });
}

// node_modules/instantsearch.js/es/lib/utils/omit.js
function omit(source, excluded) {
  if (source === null || source === void 0) {
    return source;
  }
  return Object.keys(source).reduce(function(target, key2) {
    if (excluded.indexOf(key2) >= 0) {
      return target;
    }
    var validKey = key2;
    target[validKey] = source[validKey];
    return target;
  }, {});
}

// node_modules/instantsearch.js/es/lib/utils/range.js
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray4(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray4(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray4(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray4(o4, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray4(arr);
}
function _arrayLikeToArray4(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
function range(_ref9) {
  var _ref$start = _ref9.start, start = _ref$start === void 0 ? 0 : _ref$start, end = _ref9.end, _ref$step = _ref9.step, step = _ref$step === void 0 ? 1 : _ref$step;
  var limitStep = step === 0 ? 1 : step;
  var arrayLength = Math.round((end - start) / limitStep);
  return _toConsumableArray(Array(arrayLength)).map(function(_4, current) {
    return start + current * limitStep;
  });
}

// node_modules/instantsearch.js/es/lib/utils/toArray.js
function toArray(value) {
  return Array.isArray(value) ? value : [value];
}

// node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n4) {
    for (var e4 = 1; e4 < arguments.length; e4++) {
      var t4 = arguments[e4];
      for (var r3 in t4)
        ({}).hasOwnProperty.call(t4, r3) && (n4[r3] = t4[r3]);
    }
    return n4;
  }, _extends.apply(null, arguments);
}

// node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(r3, e4) {
  if (null == r3)
    return {};
  var t4 = {};
  for (var n4 in r3)
    if ({}.hasOwnProperty.call(r3, n4)) {
      if (-1 !== e4.indexOf(n4))
        continue;
      t4[n4] = r3[n4];
    }
  return t4;
}

// node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
function _objectWithoutProperties(e4, t4) {
  if (null == e4)
    return {};
  var o4, r3, i4 = _objectWithoutPropertiesLoose(e4, t4);
  if (Object.getOwnPropertySymbols) {
    var n4 = Object.getOwnPropertySymbols(e4);
    for (r3 = 0; r3 < n4.length; r3++)
      o4 = n4[r3], -1 === t4.indexOf(o4) && {}.propertyIsEnumerable.call(e4, o4) && (i4[o4] = e4[o4]);
  }
  return i4;
}

// node_modules/instantsearch-ui-components/dist/es/lib/cx.js
function cx() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }
  return classNames.reduce(function(acc, className) {
    if (Array.isArray(className)) {
      return acc.concat(className);
    }
    return acc.concat([className]);
  }, []).filter(Boolean).join(" ");
}

// node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof5(o4) {
  "@babel/helpers - typeof";
  return _typeof5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof5(o4);
}

// node_modules/@babel/runtime/helpers/esm/toPrimitive.js
function toPrimitive(t4, r3) {
  if ("object" != _typeof5(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof5(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}

// node_modules/@babel/runtime/helpers/esm/toPropertyKey.js
function toPropertyKey(t4) {
  var i4 = toPrimitive(t4, "string");
  return "symbol" == _typeof5(i4) ? i4 : i4 + "";
}

// node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty5(e4, r3, t4) {
  return (r3 = toPropertyKey(r3)) in e4 ? Object.defineProperty(e4, r3, {
    value: t4,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e4[r3] = t4, e4;
}

// node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles4(r3) {
  if (Array.isArray(r3))
    return r3;
}

// node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit4(r3, l4) {
  var t4 = null == r3 ? null : "undefined" != typeof Symbol && r3[Symbol.iterator] || r3["@@iterator"];
  if (null != t4) {
    var e4, n4, i4, u4, a4 = [], f4 = true, o4 = false;
    try {
      if (i4 = (t4 = t4.call(r3)).next, 0 === l4) {
        if (Object(t4) !== t4)
          return;
        f4 = false;
      } else
        for (; !(f4 = (e4 = i4.call(t4)).done) && (a4.push(e4.value), a4.length !== l4); f4 = true)
          ;
    } catch (r4) {
      o4 = true, n4 = r4;
    } finally {
      try {
        if (!f4 && null != t4["return"] && (u4 = t4["return"](), Object(u4) !== u4))
          return;
      } finally {
        if (o4)
          throw n4;
      }
    }
    return a4;
  }
}

// node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray5(r3, a4) {
  (null == a4 || a4 > r3.length) && (a4 = r3.length);
  for (var e4 = 0, n4 = Array(a4); e4 < a4; e4++)
    n4[e4] = r3[e4];
  return n4;
}

// node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
function _unsupportedIterableToArray5(r3, a4) {
  if (r3) {
    if ("string" == typeof r3)
      return _arrayLikeToArray5(r3, a4);
    var t4 = {}.toString.call(r3).slice(8, -1);
    return "Object" === t4 && r3.constructor && (t4 = r3.constructor.name), "Map" === t4 || "Set" === t4 ? Array.from(r3) : "Arguments" === t4 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t4) ? _arrayLikeToArray5(r3, a4) : void 0;
  }
}

// node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest4() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// node_modules/@babel/runtime/helpers/esm/slicedToArray.js
function _slicedToArray4(r3, e4) {
  return _arrayWithHoles4(r3) || _iterableToArrayLimit4(r3, e4) || _unsupportedIterableToArray5(r3, e4) || _nonIterableRest4();
}

// node_modules/instantsearch-ui-components/dist/es/lib/stickToBottom.js
function ownKeys5(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread5(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys5(Object(t4), true).forEach(function(r4) {
      _defineProperty5(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys5(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
var DEFAULT_SPRING_ANIMATION = {
  /**
   * A value from 0 to 1, on how much to damp the animation.
   * 0 means no damping, 1 means full damping.
   *
   * @default 0.7
   */
  damping: 0.7,
  /**
   * The stiffness of how fast/slow the animation gets up to speed.
   *
   * @default 0.05
   */
  stiffness: 0.05,
  /**
   * The inertial mass associated with the animation.
   * Higher numbers make the animation slower.
   *
   * @default 1.25
   */
  mass: 1.25
};
var STICK_TO_BOTTOM_OFFSET_PX = 70;
var SIXTY_FPS_INTERVAL_MS = 1e3 / 60;
var RETAIN_ANIMATION_DURATION_MS = 350;
var mouseDown = false;
if (typeof window !== "undefined") {
  (_window$document = window.document) === null || _window$document === void 0 ? void 0 : _window$document.addEventListener("mousedown", function() {
    mouseDown = true;
  });
  (_window$document2 = window.document) === null || _window$document2 === void 0 ? void 0 : _window$document2.addEventListener("mouseup", function() {
    mouseDown = false;
  });
  (_window$document3 = window.document) === null || _window$document3 === void 0 ? void 0 : _window$document3.addEventListener("click", function() {
    mouseDown = false;
  });
}
var _window$document;
var _window$document2;
var _window$document3;
function createStickToBottom(_ref9) {
  var useCallback = _ref9.useCallback, useEffect = _ref9.useEffect, useMemo = _ref9.useMemo, useRef = _ref9.useRef, useState = _ref9.useState;
  return function useStickToBottom2() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _useState = useState(false), _useState2 = _slicedToArray4(_useState, 2), escapedFromLock = _useState2[0], updateEscapedFromLock = _useState2[1];
    var _useState3 = useState(options.initial !== false), _useState4 = _slicedToArray4(_useState3, 2), isAtBottom = _useState4[0], updateIsAtBottom = _useState4[1];
    var _useState5 = useState(false), _useState6 = _slicedToArray4(_useState5, 2), isNearBottom = _useState6[0], setIsNearBottom = _useState6[1];
    var optionsRef = useRef(null);
    optionsRef.current = options;
    var scrollRef = useRef(null);
    var contentRef = useRef(null);
    var isSelecting = useCallback(function() {
      var _scrollRef$current;
      if (!mouseDown) {
        return false;
      }
      if (typeof window === "undefined") {
        return false;
      }
      var selection = window.getSelection();
      if (!selection || !selection.rangeCount) {
        return false;
      }
      var range2 = selection.getRangeAt(0);
      return range2.commonAncestorContainer.contains(scrollRef.current) || ((_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 ? void 0 : _scrollRef$current.contains(range2.commonAncestorContainer));
    }, []);
    var state = useMemo(function() {
      var lastCalculation;
      return {
        escapedFromLock,
        isAtBottom,
        resizeDifference: 0,
        accumulated: 0,
        velocity: 0,
        get scrollTop() {
          var _scrollRef$current$sc, _scrollRef$current2;
          return (_scrollRef$current$sc = (_scrollRef$current2 = scrollRef.current) === null || _scrollRef$current2 === void 0 ? void 0 : _scrollRef$current2.scrollTop) !== null && _scrollRef$current$sc !== void 0 ? _scrollRef$current$sc : 0;
        },
        set scrollTop(scrollTop) {
          if (scrollRef.current) {
            scrollRef.current.scrollTop = scrollTop;
            state.ignoreScrollToTop = scrollRef.current.scrollTop;
          }
        },
        get targetScrollTop() {
          if (!scrollRef.current || !contentRef.current) {
            return 0;
          }
          return scrollRef.current.scrollHeight - 1 - scrollRef.current.clientHeight;
        },
        get calculatedTargetScrollTop() {
          var _lastCalculation;
          if (!scrollRef.current || !contentRef.current) {
            return 0;
          }
          var targetScrollTop = this.targetScrollTop;
          if (!optionsRef.current.targetScrollTop) {
            return targetScrollTop;
          }
          if (((_lastCalculation = lastCalculation) === null || _lastCalculation === void 0 ? void 0 : _lastCalculation.targetScrollTop) === targetScrollTop) {
            return lastCalculation.calculatedScrollTop;
          }
          var calculatedScrollTop = Math.max(Math.min(optionsRef.current.targetScrollTop(targetScrollTop, {
            scrollElement: scrollRef.current,
            contentElement: contentRef.current
          }), targetScrollTop), 0);
          lastCalculation = {
            targetScrollTop,
            calculatedScrollTop
          };
          requestAnimationFrame(function() {
            lastCalculation = void 0;
          });
          return calculatedScrollTop;
        },
        get scrollDifference() {
          return this.calculatedTargetScrollTop - this.scrollTop;
        },
        get isNearBottom() {
          return this.scrollDifference <= STICK_TO_BOTTOM_OFFSET_PX;
        }
      };
    }, []);
    var setIsAtBottom = useCallback(function(value) {
      state.isAtBottom = value;
      updateIsAtBottom(value);
    }, [state]);
    var setEscapedFromLock = useCallback(function(value) {
      state.escapedFromLock = value;
      updateEscapedFromLock(value);
    }, [state]);
    var scrollToBottom = useCallback(function() {
      var _state$animation2;
      var scrollOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (typeof scrollOptions === "string") {
        scrollOptions = {
          animation: scrollOptions
        };
      }
      if (!scrollOptions.preserveScrollPosition) {
        setIsAtBottom(true);
      }
      var waitElapsed = Date.now() + (Number(scrollOptions.wait) || 0);
      var behavior = mergeAnimations(optionsRef.current, scrollOptions.animation);
      var _scrollOptions = scrollOptions, _scrollOptions$ignore = _scrollOptions.ignoreEscapes, ignoreEscapes = _scrollOptions$ignore === void 0 ? false : _scrollOptions$ignore;
      var durationElapsed;
      var startTarget = state.calculatedTargetScrollTop;
      if (scrollOptions.duration instanceof Promise) {
        scrollOptions.duration.then(function() {
          durationElapsed = Date.now();
        }, function() {
          durationElapsed = Date.now();
        });
      } else {
        var _scrollOptions$durati;
        durationElapsed = waitElapsed + ((_scrollOptions$durati = scrollOptions.duration) !== null && _scrollOptions$durati !== void 0 ? _scrollOptions$durati : 0);
      }
      var next2 = function next3() {
        var promise2 = new Promise(requestAnimationFrame).then(function() {
          var _state$lastTick;
          if (!state.isAtBottom) {
            state.animation = void 0;
            return false;
          }
          var scrollTop = state.scrollTop;
          var tick = performance.now();
          var tickDelta = (tick - ((_state$lastTick = state.lastTick) !== null && _state$lastTick !== void 0 ? _state$lastTick : tick)) / SIXTY_FPS_INTERVAL_MS;
          state.animation || (state.animation = {
            behavior,
            promise: promise2,
            ignoreEscapes
          });
          if (state.animation.behavior === behavior) {
            state.lastTick = tick;
          }
          if (isSelecting()) {
            return next3();
          }
          if (waitElapsed > Date.now()) {
            return next3();
          }
          if (scrollTop < Math.min(startTarget, state.calculatedTargetScrollTop)) {
            var _state$animation;
            if (((_state$animation = state.animation) === null || _state$animation === void 0 ? void 0 : _state$animation.behavior) === behavior) {
              if (behavior === "instant") {
                state.scrollTop = state.calculatedTargetScrollTop;
                return next3();
              }
              state.velocity = (behavior.damping * state.velocity + behavior.stiffness * state.scrollDifference) / behavior.mass;
              state.accumulated += state.velocity * tickDelta;
              state.scrollTop += state.accumulated;
              if (state.scrollTop !== scrollTop) {
                state.accumulated = 0;
              }
            }
            return next3();
          }
          if (durationElapsed > Date.now()) {
            startTarget = state.calculatedTargetScrollTop;
            return next3();
          }
          state.animation = void 0;
          if (state.scrollTop < state.calculatedTargetScrollTop) {
            return scrollToBottom({
              animation: mergeAnimations(optionsRef.current, optionsRef.current.resize),
              ignoreEscapes,
              duration: Math.max(0, durationElapsed - Date.now()) || void 0
            });
          }
          return state.isAtBottom;
        });
        return promise2.then(function(result) {
          requestAnimationFrame(function() {
            if (!state.animation) {
              state.lastTick = void 0;
              state.velocity = 0;
            }
          });
          return result;
        });
      };
      if (scrollOptions.wait !== true) {
        state.animation = void 0;
      }
      if (((_state$animation2 = state.animation) === null || _state$animation2 === void 0 ? void 0 : _state$animation2.behavior) === behavior) {
        return state.animation.promise;
      }
      return next2();
    }, [setIsAtBottom, isSelecting, state]);
    var stopScroll = useCallback(function() {
      setEscapedFromLock(true);
      setIsAtBottom(false);
    }, [setEscapedFromLock, setIsAtBottom]);
    var handleScroll = useCallback(function(_ref23) {
      var target = _ref23.target;
      if (target !== scrollRef.current) {
        return;
      }
      var scrollTop = state.scrollTop, ignoreScrollToTop = state.ignoreScrollToTop;
      var _state$lastScrollTop = state.lastScrollTop, lastScrollTop = _state$lastScrollTop === void 0 ? scrollTop : _state$lastScrollTop;
      state.lastScrollTop = scrollTop;
      state.ignoreScrollToTop = void 0;
      if (ignoreScrollToTop && ignoreScrollToTop > scrollTop) {
        lastScrollTop = ignoreScrollToTop;
      }
      setIsNearBottom(state.isNearBottom);
      setTimeout(function() {
        var _state$animation3;
        if (state.resizeDifference || scrollTop === ignoreScrollToTop) {
          return;
        }
        if (isSelecting()) {
          setEscapedFromLock(true);
          setIsAtBottom(false);
          return;
        }
        var isScrollingDown = scrollTop > lastScrollTop;
        var isScrollingUp = scrollTop < lastScrollTop;
        if ((_state$animation3 = state.animation) !== null && _state$animation3 !== void 0 && _state$animation3.ignoreEscapes) {
          state.scrollTop = lastScrollTop;
          return;
        }
        if (isScrollingUp) {
          setEscapedFromLock(true);
          setIsAtBottom(false);
        }
        if (isScrollingDown) {
          setEscapedFromLock(false);
        }
        if (!state.escapedFromLock && state.isNearBottom) {
          setIsAtBottom(true);
        }
      }, 1);
    }, [setEscapedFromLock, setIsAtBottom, isSelecting, state]);
    var handleWheel = useCallback(function(_ref33) {
      var _state$animation4;
      var target = _ref33.target, deltaY = _ref33.deltaY;
      var element = target;
      while (!["scroll", "auto"].includes(getComputedStyle(element).overflow)) {
        if (!element.parentElement) {
          return;
        }
        element = element.parentElement;
      }
      if (element === scrollRef.current && deltaY < 0 && scrollRef.current.scrollHeight > scrollRef.current.clientHeight && !((_state$animation4 = state.animation) !== null && _state$animation4 !== void 0 && _state$animation4.ignoreEscapes)) {
        setEscapedFromLock(true);
        setIsAtBottom(false);
      }
    }, [setEscapedFromLock, setIsAtBottom, state]);
    useEffect(function() {
      var scroll = scrollRef.current;
      if (!scroll) {
        return void 0;
      }
      scroll.addEventListener("scroll", handleScroll, {
        passive: true
      });
      scroll.addEventListener("wheel", handleWheel, {
        passive: true
      });
      return function() {
        scroll.removeEventListener("scroll", handleScroll);
        scroll.removeEventListener("wheel", handleWheel);
      };
    }, [handleScroll, handleWheel]);
    useEffect(function() {
      var content = contentRef.current;
      if (!content) {
        return void 0;
      }
      var previousHeight;
      var resizeObserver = new ResizeObserver(function(_ref44) {
        var _previousHeight;
        var _ref52 = _slicedToArray4(_ref44, 1), entry = _ref52[0];
        var height = entry.contentRect.height;
        var difference = height - ((_previousHeight = previousHeight) !== null && _previousHeight !== void 0 ? _previousHeight : height);
        state.resizeDifference = difference;
        if (state.scrollTop > state.targetScrollTop) {
          state.scrollTop = state.targetScrollTop;
        }
        setIsNearBottom(state.isNearBottom);
        if (difference >= 0) {
          var animation = mergeAnimations(optionsRef.current, previousHeight ? optionsRef.current.resize : optionsRef.current.initial);
          scrollToBottom({
            animation,
            wait: true,
            preserveScrollPosition: true,
            duration: animation === "instant" ? void 0 : RETAIN_ANIMATION_DURATION_MS
          });
        } else if (state.isNearBottom) {
          setEscapedFromLock(false);
          setIsAtBottom(true);
        }
        previousHeight = height;
        requestAnimationFrame(function() {
          setTimeout(function() {
            if (state.resizeDifference === difference) {
              state.resizeDifference = 0;
            }
          }, 1);
        });
      });
      resizeObserver.observe(content);
      state.resizeObserver = resizeObserver;
      return function() {
        resizeObserver.disconnect();
        state.resizeObserver = void 0;
      };
    }, [state, setIsNearBottom, setEscapedFromLock, setIsAtBottom, scrollToBottom]);
    return {
      contentRef,
      scrollRef,
      scrollToBottom,
      stopScroll,
      isAtBottom: isAtBottom || isNearBottom,
      isNearBottom,
      escapedFromLock,
      state
    };
  };
}
var animationCache = /* @__PURE__ */ new Map();
function mergeAnimations() {
  var result = _objectSpread5({}, DEFAULT_SPRING_ANIMATION);
  var instant = false;
  for (var _len = arguments.length, animations = new Array(_len), _key = 0; _key < _len; _key++) {
    animations[_key] = arguments[_key];
  }
  animations.forEach(function(animation) {
    var _animation$damping, _animation$stiffness, _animation$mass;
    if (animation === "instant") {
      instant = true;
      return;
    }
    if (_typeof5(animation) !== "object") {
      return;
    }
    instant = false;
    result.damping = (_animation$damping = animation.damping) !== null && _animation$damping !== void 0 ? _animation$damping : result.damping;
    result.stiffness = (_animation$stiffness = animation.stiffness) !== null && _animation$stiffness !== void 0 ? _animation$stiffness : result.stiffness;
    result.mass = (_animation$mass = animation.mass) !== null && _animation$mass !== void 0 ? _animation$mass : result.mass;
  });
  var key2 = JSON.stringify(result);
  if (!animationCache.has(key2)) {
    animationCache.set(key2, Object.freeze(result));
  }
  return instant ? "instant" : animationCache.get(key2);
}

// node_modules/instantsearch-ui-components/dist/es/lib/utils/startsWith.js
function startsWith(str, prefix) {
  return str.slice(0, prefix.length) === prefix;
}

// node_modules/instantsearch-ui-components/dist/es/components/Button.js
var _excluded = ["variant", "size", "iconOnly", "className", "children"];
function createButtonComponent(_ref9) {
  var createElement2 = _ref9.createElement;
  return function Button2(userProps) {
    var _userProps$variant = userProps.variant, variant = _userProps$variant === void 0 ? "primary" : _userProps$variant, _userProps$size = userProps.size, size = _userProps$size === void 0 ? "md" : _userProps$size, _userProps$iconOnly = userProps.iconOnly, iconOnly = _userProps$iconOnly === void 0 ? false : _userProps$iconOnly, className = userProps.className, children = userProps.children, props = _objectWithoutProperties(userProps, _excluded);
    return createElement2("button", _extends({
      type: "button",
      className: cx("ais-Button", "ais-Button--".concat(variant), "ais-Button--".concat(size), iconOnly && "ais-Button--icon-only", className)
    }, props), children);
  };
}

// node_modules/instantsearch-ui-components/dist/es/components/recommend-shared/DefaultEmpty.js
function createDefaultEmptyComponent(_ref9) {
  var createElement2 = _ref9.createElement, Fragment = _ref9.Fragment;
  return function DefaultEmpty() {
    return createElement2(Fragment, null, "No results");
  };
}

// node_modules/instantsearch-ui-components/dist/es/components/recommend-shared/DefaultHeader.js
function createDefaultHeaderComponent(_ref9) {
  var createElement2 = _ref9.createElement;
  return function DefaultHeader(userProps) {
    var _userProps$classNames = userProps.classNames, classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames, items = userProps.items, translations = userProps.translations;
    if (!items || items.length < 1) {
      return null;
    }
    if (!translations.title) {
      return null;
    }
    return createElement2("h3", {
      className: classNames.title
    }, translations.title);
  };
}

// node_modules/instantsearch-ui-components/dist/es/components/recommend-shared/DefaultItem.js
function createDefaultItemComponent(_ref9) {
  var createElement2 = _ref9.createElement, Fragment = _ref9.Fragment;
  return function DefaultItem(userProps) {
    return createElement2(Fragment, null, JSON.stringify(userProps.item, null, 2));
  };
}

// node_modules/instantsearch-ui-components/dist/es/components/recommend-shared/List.js
function createListComponent(_ref9) {
  var createElement2 = _ref9.createElement;
  return function List(userProps) {
    var _userProps$classNames = userProps.classNames, classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames, ItemComponent = userProps.itemComponent, items = userProps.items, sendEvent = userProps.sendEvent;
    return createElement2("div", {
      className: classNames.container
    }, createElement2("ol", {
      className: classNames.list
    }, items.map(function(item11) {
      return createElement2("li", {
        key: item11.objectID,
        className: classNames.item,
        onClick: function onClick() {
          sendEvent("click:internal", item11, "Item Clicked");
        },
        onAuxClick: function onAuxClick() {
          sendEvent("click:internal", item11, "Item Clicked");
        }
      }, createElement2(ItemComponent, {
        item: item11,
        sendEvent
      }));
    })));
  };
}

// node_modules/instantsearch-ui-components/dist/es/components/Carousel.js
var _excluded2 = ["listRef", "nextButtonRef", "previousButtonRef", "carouselIdRef", "canScrollLeft", "canScrollRight", "setCanScrollLeft", "setCanScrollRight", "classNames", "itemComponent", "previousIconComponent", "nextIconComponent", "headerComponent", "showNavigation", "items", "translations", "sendEvent"];
function ownKeys6(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread6(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys6(Object(t4), true).forEach(function(r4) {
      _defineProperty5(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys6(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
var lastCarouselId = 0;
function generateCarouselId() {
  return "ais-Carousel-".concat(lastCarouselId++);
}
function PreviousIconDefaultComponent(_ref9) {
  var createElement2 = _ref9.createElement;
  return createElement2("svg", {
    width: "8",
    height: "16",
    viewBox: "0 0 8 16",
    fill: "none"
  }, createElement2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M7.13809 0.744078C7.39844 1.06951 7.39844 1.59715 7.13809 1.92259L2.27616 8L7.13809 14.0774C7.39844 14.4028 7.39844 14.9305 7.13809 15.2559C6.87774 15.5814 6.45563 15.5814 6.19528 15.2559L0.861949 8.58926C0.6016 8.26382 0.6016 7.73618 0.861949 7.41074L6.19528 0.744078C6.45563 0.418641 6.87774 0.418641 7.13809 0.744078Z"
  }));
}
function NextIconDefaultComponent(_ref23) {
  var createElement2 = _ref23.createElement;
  return createElement2("svg", {
    width: "8",
    height: "16",
    viewBox: "0 0 8 16",
    fill: "none"
  }, createElement2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M0.861908 15.2559C0.601559 14.9305 0.601559 14.4028 0.861908 14.0774L5.72384 8L0.861908 1.92259C0.601559 1.59715 0.601559 1.06952 0.861908 0.744079C1.12226 0.418642 1.54437 0.418642 1.80472 0.744079L7.13805 7.41074C7.3984 7.73618 7.3984 8.26382 7.13805 8.58926L1.80472 15.2559C1.54437 15.5814 1.12226 15.5814 0.861908 15.2559Z"
  }));
}
function createCarouselComponent(_ref33) {
  var createElement2 = _ref33.createElement, Fragment = _ref33.Fragment;
  return function Carousel2(userProps) {
    var listRef = userProps.listRef, nextButtonRef = userProps.nextButtonRef, previousButtonRef = userProps.previousButtonRef, carouselIdRef = userProps.carouselIdRef, canScrollLeft = userProps.canScrollLeft, canScrollRight = userProps.canScrollRight, setCanScrollLeft = userProps.setCanScrollLeft, setCanScrollRight = userProps.setCanScrollRight, _userProps$classNames = userProps.classNames, classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames, _userProps$itemCompon = userProps.itemComponent, ItemComponent = _userProps$itemCompon === void 0 ? createDefaultItemComponent({
      createElement: createElement2,
      Fragment
    }) : _userProps$itemCompon, _userProps$previousIc = userProps.previousIconComponent, PreviousIconComponent = _userProps$previousIc === void 0 ? PreviousIconDefaultComponent : _userProps$previousIc, _userProps$nextIconCo = userProps.nextIconComponent, NextIconComponent = _userProps$nextIconCo === void 0 ? NextIconDefaultComponent : _userProps$nextIconCo, HeaderComponent = userProps.headerComponent, _userProps$showNaviga = userProps.showNavigation, showNavigation = _userProps$showNaviga === void 0 ? true : _userProps$showNaviga, items = userProps.items, userTranslations = userProps.translations, sendEvent = userProps.sendEvent, props = _objectWithoutProperties(userProps, _excluded2);
    var translations = _objectSpread6({
      listLabel: "Items",
      nextButtonLabel: "Next",
      nextButtonTitle: "Next",
      previousButtonLabel: "Previous",
      previousButtonTitle: "Previous"
    }, userTranslations);
    var cssClasses = {
      root: cx("ais-Carousel", classNames.root),
      list: cx("ais-Carousel-list", classNames.list),
      item: cx("ais-Carousel-item", classNames.item),
      navigation: cx("ais-Carousel-navigation", classNames.navigation),
      navigationNext: cx("ais-Carousel-navigation--next", classNames.navigationNext),
      navigationPrevious: cx("ais-Carousel-navigation--previous", classNames.navigationPrevious)
    };
    function scrollLeft() {
      if (listRef.current) {
        listRef.current.scrollLeft -= listRef.current.offsetWidth * 0.75;
      }
    }
    function scrollRight() {
      if (listRef.current) {
        listRef.current.scrollLeft += listRef.current.offsetWidth * 0.75;
      }
    }
    function updateNavigationButtonsProps() {
      if (!listRef.current) {
        return;
      }
      var isLeftHidden = listRef.current.scrollLeft <= 0;
      var isRightHidden = listRef.current.scrollLeft + listRef.current.clientWidth >= listRef.current.scrollWidth;
      setCanScrollLeft(!isLeftHidden);
      setCanScrollRight(!isRightHidden);
      if (previousButtonRef.current) {
        previousButtonRef.current.hidden = isLeftHidden;
      }
      if (nextButtonRef.current) {
        nextButtonRef.current.hidden = isRightHidden;
      }
    }
    if (items.length === 0) {
      return null;
    }
    return createElement2("div", _extends({}, props, {
      className: cx(cssClasses.root)
    }), HeaderComponent && createElement2(HeaderComponent, {
      canScrollLeft,
      canScrollRight,
      scrollLeft,
      scrollRight
    }), showNavigation && createElement2("button", {
      ref: previousButtonRef,
      title: translations.previousButtonTitle,
      "aria-label": translations.previousButtonLabel,
      hidden: true,
      "aria-controls": carouselIdRef.current,
      className: cx(cssClasses.navigation, cssClasses.navigationPrevious),
      onClick: function onClick(event) {
        event.preventDefault();
        scrollLeft();
      }
    }, createElement2(PreviousIconComponent, {
      createElement: createElement2
    })), createElement2("ol", {
      className: cx(cssClasses.list),
      ref: listRef,
      tabIndex: 0,
      id: carouselIdRef.current,
      "aria-roledescription": "carousel",
      "aria-label": translations.listLabel,
      "aria-live": "polite",
      onScroll: updateNavigationButtonsProps,
      onKeyDown: function onKeyDown(event) {
        if (event.key === "ArrowLeft") {
          event.preventDefault();
          scrollLeft();
        } else if (event.key === "ArrowRight") {
          event.preventDefault();
          scrollRight();
        }
      }
    }, items.map(function(item11, index) {
      return createElement2("li", {
        key: item11.objectID,
        className: cx(cssClasses.item),
        "aria-roledescription": "slide",
        "aria-label": "".concat(index + 1, " of ").concat(items.length),
        onClick: function onClick() {
          sendEvent("click:internal", item11, "Item Clicked");
        },
        onAuxClick: function onAuxClick() {
          sendEvent("click:internal", item11, "Item Clicked");
        }
      }, createElement2(ItemComponent, {
        item: item11,
        sendEvent
      }));
    })), showNavigation && createElement2("button", {
      ref: nextButtonRef,
      title: translations.nextButtonTitle,
      "aria-label": translations.nextButtonLabel,
      "aria-controls": carouselIdRef.current,
      className: cx(cssClasses.navigation, cssClasses.navigationNext),
      onClick: function onClick(event) {
        event.preventDefault();
        scrollRight();
      }
    }, createElement2(NextIconComponent, {
      createElement: createElement2
    })));
  };
}

// node_modules/instantsearch-ui-components/dist/es/components/chat/icons.js
function SparklesIconComponent(_ref9) {
  var createElement2 = _ref9.createElement, _ref$width = _ref9.width, width = _ref$width === void 0 ? 20 : _ref$width, _ref$height = _ref9.height, height = _ref$height === void 0 ? 20 : _ref$height;
  return createElement2("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    fill: "none",
    viewBox: "0 0 20 20"
  }, createElement2("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 1.875c.27 0 .51.173.594.43l1.593 4.844a1.043 1.043 0 0 0 .664.664l4.844 1.593a.625.625 0 0 1 0 1.188l-4.844 1.593a1.043 1.043 0 0 0-.664.664l-1.593 4.844a.625.625 0 0 1-1.188 0l-1.593-4.844a1.042 1.042 0 0 0-.664-.664l-4.844-1.593a.625.625 0 0 1 0-1.188l4.844-1.593a1.042 1.042 0 0 0 .664-.664l1.593-4.844a.625.625 0 0 1 .594-.43ZM9 7.539A2.292 2.292 0 0 1 7.54 9L4.5 10l3.04 1A2.292 2.292 0 0 1 9 12.46l1 3.04 1-3.04A2.293 2.293 0 0 1 12.46 11l3.04-1-3.04-1A2.292 2.292 0 0 1 11 7.54L10 4.5 9 7.54ZM4.167 1.875c.345 0 .625.28.625.625v3.333a.625.625 0 0 1-1.25 0V2.5c0-.345.28-.625.625-.625ZM15.833 13.542c.345 0 .625.28.625.625V17.5a.625.625 0 1 1-1.25 0v-3.333c0-.345.28-.625.625-.625Z",
    clipRule: "evenodd"
  }), createElement2("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.875 4.167c0-.346.28-.625.625-.625h3.333a.625.625 0 1 1 0 1.25H2.5a.625.625 0 0 1-.625-.625ZM13.542 15.833c0-.345.28-.625.625-.625H17.5a.625.625 0 0 1 0 1.25h-3.333a.625.625 0 0 1-.625-.625Z",
    clipRule: "evenodd"
  }));
}
function ArrowUpIconComponent(_ref23) {
  var createElement2 = _ref23.createElement, _ref2$width = _ref23.width, width = _ref2$width === void 0 ? 16 : _ref2$width, _ref2$height = _ref23.height, height = _ref2$height === void 0 ? 16 : _ref2$height;
  return createElement2("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, createElement2("path", {
    d: "m5 12 7-7 7 7"
  }), createElement2("path", {
    d: "M12 19V5"
  }));
}
function ArrowRightIconComponent(_ref33) {
  var createElement2 = _ref33.createElement, _ref3$width = _ref33.width, width = _ref3$width === void 0 ? 16 : _ref3$width, _ref3$height = _ref33.height, height = _ref3$height === void 0 ? 16 : _ref3$height;
  return createElement2("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, createElement2("path", {
    d: "M5 12h14"
  }), createElement2("path", {
    d: "m12 5 7 7-7 7"
  }));
}
function ChevronUpIconComponent(_ref44) {
  var createElement2 = _ref44.createElement, _ref4$width = _ref44.width, width = _ref4$width === void 0 ? 16 : _ref4$width, _ref4$height = _ref44.height, height = _ref4$height === void 0 ? 16 : _ref4$height;
  return createElement2("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, createElement2("path", {
    d: "m18 15-6-6-6 6"
  }));
}
function ChevronDownIconComponent(_ref52) {
  var createElement2 = _ref52.createElement, _ref5$width = _ref52.width, width = _ref5$width === void 0 ? 16 : _ref5$width, _ref5$height = _ref52.height, height = _ref5$height === void 0 ? 16 : _ref5$height;
  return createElement2("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, createElement2("path", {
    d: "m6 9 6 6 6-6"
  }));
}
function CloseIconComponent(_ref64) {
  var createElement2 = _ref64.createElement, _ref6$width = _ref64.width, width = _ref6$width === void 0 ? 16 : _ref6$width, _ref6$height = _ref64.height, height = _ref6$height === void 0 ? 16 : _ref6$height;
  return createElement2("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, createElement2("path", {
    d: "M18 6 6 18"
  }), createElement2("path", {
    d: "m6 6 12 12"
  }));
}
function MaximizeIconComponent(_ref72) {
  var createElement2 = _ref72.createElement, _ref7$width = _ref72.width, width = _ref7$width === void 0 ? 16 : _ref7$width, _ref7$height = _ref72.height, height = _ref7$height === void 0 ? 16 : _ref7$height;
  return createElement2("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 24 24",
    fill: "none",
    strokeWidth: "2",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, createElement2("path", {
    d: "M15 3h6v6"
  }), createElement2("path", {
    d: "m21 3-7 7"
  }), createElement2("path", {
    d: "m3 21 7-7"
  }), createElement2("path", {
    d: "M9 21H3v-6"
  }));
}
function MinimizeIconComponent(_ref82) {
  var createElement2 = _ref82.createElement, _ref8$width = _ref82.width, width = _ref8$width === void 0 ? 16 : _ref8$width, _ref8$height = _ref82.height, height = _ref8$height === void 0 ? 16 : _ref8$height;
  return createElement2("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 24 24",
    fill: "none",
    strokeWidth: "2",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, createElement2("path", {
    d: "m14 10 7-7"
  }), createElement2("path", {
    d: "M20 10h-6V4"
  }), createElement2("path", {
    d: "m3 21 7-7"
  }), createElement2("path", {
    d: "M4 14h6v6"
  }));
}
function StopIconComponent(_ref9) {
  var createElement2 = _ref9.createElement, _ref9$width = _ref9.width, width = _ref9$width === void 0 ? 16 : _ref9$width, _ref9$height = _ref9.height, height = _ref9$height === void 0 ? 16 : _ref9$height;
  return createElement2("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, createElement2("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), createElement2("rect", {
    x: "9",
    y: "9",
    width: "6",
    height: "6",
    rx: "1"
  }));
}
function ReloadIconComponent(_ref10) {
  var createElement2 = _ref10.createElement, _ref10$width = _ref10.width, width = _ref10$width === void 0 ? 16 : _ref10$width, _ref10$height = _ref10.height, height = _ref10$height === void 0 ? 16 : _ref10$height;
  return createElement2("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, createElement2("path", {
    d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"
  }), createElement2("path", {
    d: "M21 3v5h-5"
  }), createElement2("path", {
    d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"
  }), createElement2("path", {
    d: "M3 21v-5h5"
  }));
}
function CopyIconComponent(_ref11) {
  var createElement2 = _ref11.createElement, _ref11$width = _ref11.width, width = _ref11$width === void 0 ? 16 : _ref11$width, _ref11$height = _ref11.height, height = _ref11$height === void 0 ? 16 : _ref11$height;
  return createElement2("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, createElement2("rect", {
    width: "14",
    height: "14",
    x: "8",
    y: "8",
    rx: "2",
    ry: "2"
  }), createElement2("path", {
    d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
  }));
}
function MenuIconComponent(_ref12) {
  var createElement2 = _ref12.createElement, _ref12$width = _ref12.width, width = _ref12$width === void 0 ? 16 : _ref12$width, _ref12$height = _ref12.height, height = _ref12$height === void 0 ? 16 : _ref12$height;
  return createElement2("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, createElement2("circle", {
    cx: "12",
    cy: "12",
    r: "1"
  }), createElement2("circle", {
    cx: "12",
    cy: "5",
    r: "1"
  }), createElement2("circle", {
    cx: "12",
    cy: "19",
    r: "1"
  }));
}
function LoadingSpinnerIconComponent(_ref13) {
  var createElement2 = _ref13.createElement, _ref13$width = _ref13.width, width = _ref13$width === void 0 ? 24 : _ref13$width, _ref13$height = _ref13.height, height = _ref13$height === void 0 ? 24 : _ref13$height;
  return createElement2("svg", {
    viewBox: "12 12 24 24",
    width,
    height,
    role: "status",
    "aria-busy": "true",
    "aria-live": "polite"
  }, createElement2("title", null, "Loading spinner"), createElement2("circle", {
    cx: "24",
    cy: "24",
    r: "11",
    fill: "none",
    strokeWidth: "2",
    stroke: "currentColor"
  }));
}
function ChevronLeftIconComponent(_ref14) {
  var createElement2 = _ref14.createElement, _ref14$width = _ref14.width, width = _ref14$width === void 0 ? 16 : _ref14$width, _ref14$height = _ref14.height, height = _ref14$height === void 0 ? 16 : _ref14$height;
  return createElement2("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, createElement2("path", {
    d: "m15 18-6-6 6-6"
  }));
}
function ChevronRightIconComponent(_ref15) {
  var createElement2 = _ref15.createElement, _ref15$width = _ref15.width, width = _ref15$width === void 0 ? 16 : _ref15$width, _ref15$height = _ref15.height, height = _ref15$height === void 0 ? 16 : _ref15$height;
  return createElement2("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, createElement2("path", {
    d: "m9 18 6-6-6-6"
  }));
}

// node_modules/instantsearch-ui-components/dist/es/components/chat/ChatHeader.js
var _excluded3 = ["maximized", "onToggleMaximize", "onClose", "onClear", "canClear", "closeIconComponent", "minimizeIconComponent", "maximizeIconComponent", "titleIconComponent", "classNames", "translations"];
function ownKeys7(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread7(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys7(Object(t4), true).forEach(function(r4) {
      _defineProperty5(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys7(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function createChatHeaderComponent(_ref9) {
  var createElement2 = _ref9.createElement;
  var Button2 = createButtonComponent({
    createElement: createElement2
  });
  return function ChatHeader(_ref23) {
    var _ref2$maximized = _ref23.maximized, maximized = _ref2$maximized === void 0 ? false : _ref2$maximized, onToggleMaximize = _ref23.onToggleMaximize, onClose = _ref23.onClose, onClear = _ref23.onClear, _ref2$canClear = _ref23.canClear, canClear = _ref2$canClear === void 0 ? false : _ref2$canClear, CloseIconComponent2 = _ref23.closeIconComponent, MinimizeIconComponent2 = _ref23.minimizeIconComponent, MaximizeIconComponent2 = _ref23.maximizeIconComponent, TitleIconComponent = _ref23.titleIconComponent, _ref2$classNames = _ref23.classNames, classNames = _ref2$classNames === void 0 ? {} : _ref2$classNames, userTranslations = _ref23.translations, props = _objectWithoutProperties(_ref23, _excluded3);
    var translations = _objectSpread7({
      title: "Chat",
      minimizeLabel: "Minimize chat",
      maximizeLabel: "Maximize chat",
      closeLabel: "Close chat",
      clearLabel: "Clear"
    }, userTranslations);
    var defaultMaximizeIcon = maximized ? createElement2(MinimizeIconComponent, {
      createElement: createElement2
    }) : createElement2(MaximizeIconComponent, {
      createElement: createElement2
    });
    return createElement2("div", _extends({
      className: cx("ais-ChatHeader", classNames.root, props.className)
    }, props), createElement2("span", {
      className: cx("ais-ChatHeader-title", classNames.title)
    }, createElement2("span", {
      className: cx("ais-ChatHeader-titleIcon", classNames.titleIcon)
    }, TitleIconComponent ? createElement2(TitleIconComponent, null) : createElement2(SparklesIconComponent, {
      createElement: createElement2,
      width: 20,
      height: 20
    })), translations.title), createElement2("div", {
      className: cx("ais-ChatHeader-actions")
    }, onClear && createElement2(Button2, {
      variant: "ghost",
      size: "sm",
      className: cx("ais-ChatHeader-clear", classNames.clear),
      onClick: onClear,
      disabled: !canClear
    }, translations.clearLabel), createElement2(Button2, {
      variant: "ghost",
      size: "sm",
      iconOnly: true,
      className: cx("ais-ChatHeader-maximize", classNames.maximize),
      onClick: onToggleMaximize,
      "aria-label": maximized ? translations.minimizeLabel : translations.maximizeLabel
    }, MaximizeIconComponent2 ? createElement2(MaximizeIconComponent2, {
      maximized
    }) : defaultMaximizeIcon), createElement2(Button2, {
      variant: "ghost",
      size: "sm",
      iconOnly: true,
      className: cx("ais-ChatHeader-close", classNames.close),
      onClick: onClose,
      "aria-label": translations.closeLabel,
      title: translations.closeLabel
    }, CloseIconComponent2 ? createElement2(CloseIconComponent2, null) : createElement2(CloseIconComponent, {
      createElement: createElement2
    }))));
  };
}

// node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js
function _arrayWithoutHoles2(r3) {
  if (Array.isArray(r3))
    return _arrayLikeToArray5(r3);
}

// node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray2(r3) {
  if ("undefined" != typeof Symbol && null != r3[Symbol.iterator] || null != r3["@@iterator"])
    return Array.from(r3);
}

// node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread2() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// node_modules/@babel/runtime/helpers/esm/toConsumableArray.js
function _toConsumableArray2(r3) {
  return _arrayWithoutHoles2(r3) || _iterableToArray2(r3) || _unsupportedIterableToArray5(r3) || _nonIterableSpread2();
}

// node_modules/markdown-to-jsx/dist/index.modern.js
var e = __toESM(require_react());
function n() {
  return n = Object.assign ? Object.assign.bind() : function(e4) {
    for (var n4 = 1; n4 < arguments.length; n4++) {
      var r3 = arguments[n4];
      for (var t4 in r3)
        Object.prototype.hasOwnProperty.call(r3, t4) && (e4[t4] = r3[t4]);
    }
    return e4;
  }, n.apply(this, arguments);
}
var o = ["allowFullScreen", "allowTransparency", "autoComplete", "autoFocus", "autoPlay", "cellPadding", "cellSpacing", "charSet", "classId", "colSpan", "contentEditable", "contextMenu", "crossOrigin", "encType", "formAction", "formEncType", "formMethod", "formNoValidate", "formTarget", "frameBorder", "hrefLang", "inputMode", "keyParams", "keyType", "marginHeight", "marginWidth", "maxLength", "mediaGroup", "minLength", "noValidate", "radioGroup", "readOnly", "rowSpan", "spellCheck", "srcDoc", "srcLang", "srcSet", "tabIndex", "useMap"].reduce((e4, n4) => (e4[n4.toLowerCase()] = n4, e4), { class: "className", for: "htmlFor" });
var a = { amp: "&", apos: "'", gt: ">", lt: "<", nbsp: " ", quot: "“" };
var c = ["style", "script", "pre"];
var i = ["src", "href", "data", "formAction", "srcDoc", "action"];
var u = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi;
var l = /\n{2,}$/;
var s = /^(\s*>[\s\S]*?)(?=\n\n|$)/;
var f = /^ *> ?/gm;
var _ = /^(?:\[!([^\]]*)\]\n)?([\s\S]*)/;
var d = /^ {2,}\n/;
var p = /^(?:([-*_])( *\1){2,}) *(?:\n *)+\n/;
var y = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/;
var h = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/;
var g = /^(`+)((?:\\`|(?!\1)`|[^`])+)\1/;
var m = /^(?:\n *)*\n/;
var k = /\r\n?/g;
var x = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/;
var q = /^\[\^([^\]]+)]/;
var v = /\f/g;
var b = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/;
var $ = /^\s*?\[(x|\s)\]/;
var S = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/;
var z = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/;
var E = /^([^\n]+)\n *(=|-)\2{2,} *\n/;
var A = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i;
var R = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi;
var B = /^<!--[\s\S]*?(?:-->)/;
var L = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/;
var O = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i;
var j = /^\{.*\}$/;
var C = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/;
var I = /^<([^ >]+[:@\/][^ >]+)>/;
var T = /-([a-z])?/gi;
var M = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/;
var w = /^[^\n]+(?:  \n|\n{2,})/;
var D = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/;
var F = /^!\[([^\]]*)\] ?\[([^\]]*)\]/;
var P = /^\[([^\]]*)\] ?\[([^\]]*)\]/;
var Z = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/;
var N = /\t/g;
var G = /(^ *\||\| *$)/g;
var U = /^ *:-+: *$/;
var V = /^ *:-+ *$/;
var H = /^ *-+: *$/;
var Q = (e4) => "(?=[\\s\\S]+?\\1".concat(e4 ? "\\1" : "", ")");
var W = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|\\\\\\1|[\\s\\S])+?)";
var J = RegExp("^([*_])\\1".concat(Q(1)).concat(W, "\\1\\1(?!\\1)"));
var K = RegExp("^([*_])".concat(Q(0)).concat(W, "\\1(?!\\1)"));
var X = RegExp("^(==)".concat(Q(0)).concat(W, "\\1"));
var Y = RegExp("^(~~)".concat(Q(0)).concat(W, "\\1"));
var ee = /^(:[a-zA-Z0-9-_]+:)/;
var ne = /^\\([^0-9A-Za-z\s])/;
var re = /\\([^0-9A-Za-z\s])/g;
var te = /^[\s\S](?:(?!  \n|[0-9]\.|http)[^=*_~\-\n:<`\\\[!])*/;
var oe = /^\n+/;
var ae = /^([ \t]*)/;
var ce = /(?:^|\n)( *)$/;
var ie = "(?:\\d+\\.)";
var ue = "(?:[*+-])";
function le(e4) {
  return "( *)(" + (1 === e4 ? ie : ue) + ") +";
}
var se = le(1);
var fe = le(2);
function _e(e4) {
  return RegExp("^" + (1 === e4 ? se : fe));
}
var de = _e(1);
var pe = _e(2);
function ye(e4) {
  return RegExp("^" + (1 === e4 ? se : fe) + "[^\\n]*(?:\\n(?!\\1" + (1 === e4 ? ie : ue) + " )[^\\n]*)*(\\n|$)", "gm");
}
var he = ye(1);
var ge = ye(2);
function me(e4) {
  const n4 = 1 === e4 ? ie : ue;
  return RegExp("^( *)(" + n4 + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + n4 + " (?!" + n4 + " ))\\n*|\\s*\\n*$)");
}
var ke = me(1);
var xe = me(2);
function qe(e4, n4) {
  const r3 = 1 === n4, t4 = r3 ? ke : xe, o4 = r3 ? he : ge, a4 = r3 ? de : pe;
  return { t: (e5) => a4.test(e5), o: je(function(e5, n5) {
    const r4 = ce.exec(n5.prevCapture);
    return r4 && (n5.list || !n5.inline && !n5.simple) ? t4.exec(e5 = r4[1] + e5) : null;
  }), i: 1, u(e5, n5, t5) {
    const c4 = r3 ? +e5[2] : void 0, i4 = e5[0].replace(l, "\n").match(o4);
    let u4 = false;
    return { items: i4.map(function(e6, r4) {
      const o5 = a4.exec(e6)[0].length, c5 = RegExp("^ {1," + o5 + "}", "gm"), l4 = e6.replace(c5, "").replace(a4, ""), s4 = r4 === i4.length - 1, f4 = -1 !== l4.indexOf("\n\n") || s4 && u4;
      u4 = f4;
      const _4 = t5.inline, d4 = t5.list;
      let p4;
      t5.list = true, f4 ? (t5.inline = false, p4 = Se(l4) + "\n\n") : (t5.inline = true, p4 = Se(l4));
      const y4 = n5(p4, t5);
      return t5.inline = _4, t5.list = d4, y4;
    }), ordered: r3, start: c4 };
  }, l: (n5, r4, t5) => e4(n5.ordered ? "ol" : "ul", { key: t5.key, start: "20" === n5.type ? n5.start : void 0 }, n5.items.map(function(n6, o5) {
    return e4("li", { key: o5 }, r4(n6, t5));
  })) };
}
var ve = RegExp("^\\[((?:\\[[^\\[\\]]*(?:\\[[^\\[\\]]*\\][^\\[\\]]*)*\\]|[^\\[\\]])*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)");
var be = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/;
function $e(e4) {
  return "string" == typeof e4;
}
function Se(e4) {
  let n4 = e4.length;
  for (; n4 > 0 && e4[n4 - 1] <= " "; )
    n4--;
  return e4.slice(0, n4);
}
function ze(e4, n4) {
  return e4.startsWith(n4);
}
function Ee(e4, n4, r3) {
  if (Array.isArray(r3)) {
    for (let n5 = 0; n5 < r3.length; n5++)
      if (ze(e4, r3[n5]))
        return true;
    return false;
  }
  return r3(e4, n4);
}
function Ae(e4) {
  return e4.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function Re(e4) {
  return H.test(e4) ? "right" : U.test(e4) ? "center" : V.test(e4) ? "left" : null;
}
function Be(e4, n4, r3, t4) {
  const o4 = r3.inTable;
  r3.inTable = true;
  let a4 = [[]], c4 = "";
  function i4() {
    if (!c4)
      return;
    const e5 = a4[a4.length - 1];
    e5.push.apply(e5, n4(c4, r3)), c4 = "";
  }
  return e4.trim().split(/(`[^`]*`|\\\||\|)/).filter(Boolean).forEach((e5, n5, r4) => {
    "|" === e5.trim() && (i4(), t4) ? 0 !== n5 && n5 !== r4.length - 1 && a4.push([]) : c4 += e5;
  }), i4(), r3.inTable = o4, a4;
}
function Le(e4, n4, r3) {
  r3.inline = true;
  const t4 = e4[2] ? e4[2].replace(G, "").split("|").map(Re) : [], o4 = e4[3] ? function(e5, n5, r4) {
    return e5.trim().split("\n").map(function(e6) {
      return Be(e6, n5, r4, true);
    });
  }(e4[3], n4, r3) : [], a4 = Be(e4[1], n4, r3, !!o4.length);
  return r3.inline = false, o4.length ? { align: t4, cells: o4, header: a4, type: "25" } : { children: a4, type: "21" };
}
function Oe(e4, n4) {
  return null == e4.align[n4] ? {} : { textAlign: e4.align[n4] };
}
function je(e4) {
  return e4.inline = 1, e4;
}
function Ce(e4) {
  return je(function(n4, r3) {
    return r3.inline ? e4.exec(n4) : null;
  });
}
function Ie(e4) {
  return je(function(n4, r3) {
    return r3.inline || r3.simple ? e4.exec(n4) : null;
  });
}
function Te(e4) {
  return function(n4, r3) {
    return r3.inline || r3.simple ? null : e4.exec(n4);
  };
}
function Me(e4) {
  return je(function(n4) {
    return e4.exec(n4);
  });
}
var we = /(javascript|vbscript|data(?!:image)):/i;
function De(e4) {
  try {
    const n4 = decodeURIComponent(e4).replace(/[^A-Za-z0-9/:]/g, "");
    if (we.test(n4))
      return null;
  } catch (e5) {
    return null;
  }
  return e4;
}
function Fe(e4) {
  return e4 ? e4.replace(re, "$1") : e4;
}
function Pe(e4, n4, r3) {
  const t4 = r3.inline || false, o4 = r3.simple || false;
  r3.inline = true, r3.simple = true;
  const a4 = e4(n4, r3);
  return r3.inline = t4, r3.simple = o4, a4;
}
function Ze(e4, n4, r3) {
  const t4 = r3.inline || false, o4 = r3.simple || false;
  r3.inline = false, r3.simple = true;
  const a4 = e4(n4, r3);
  return r3.inline = t4, r3.simple = o4, a4;
}
function Ne(e4, n4, r3) {
  const t4 = r3.inline || false;
  r3.inline = false;
  const o4 = e4(n4, r3);
  return r3.inline = t4, o4;
}
var Ge = (e4, n4, r3) => ({ children: Pe(n4, e4[2], r3) });
function Ue() {
  return {};
}
function Ve() {
  return null;
}
function He(...e4) {
  return e4.filter(Boolean).join(" ");
}
function Qe(e4, n4, r3) {
  let t4 = e4;
  const o4 = n4.split(".");
  for (; o4.length && (t4 = t4[o4[0]], void 0 !== t4); )
    o4.shift();
  return t4 || r3;
}
function We(r3 = "", t4 = {}) {
  t4.overrides = t4.overrides || {}, t4.namedCodesToUnicode = t4.namedCodesToUnicode ? n({}, a, t4.namedCodesToUnicode) : a;
  const l4 = t4.slugify || Ae, G2 = t4.sanitizer || De, U2 = t4.createElement || e.createElement, V2 = [s, y, h, t4.enforceAtxHeadings ? z : S, E, M, ke, xe], H3 = [...V2, w, A, B, O];
  function Q2(e4, n4) {
    for (let r4 = 0; r4 < e4.length; r4++)
      if (e4[r4].test(n4))
        return true;
    return false;
  }
  function W2(e4, r4, ...o4) {
    const a4 = Qe(t4.overrides, e4 + ".props", {});
    return U2(function(e5, n4) {
      const r5 = Qe(n4, e5);
      return r5 ? "function" == typeof r5 || "object" == typeof r5 && "render" in r5 ? r5 : Qe(n4, e5 + ".component", e5) : e5;
    }(e4, t4.overrides), n({}, r4, a4, { className: He(null == r4 ? void 0 : r4.className, a4.className) || void 0 }), ...o4);
  }
  function re2(e4) {
    e4 = e4.replace(b, "");
    let n4 = false;
    t4.forceInline ? n4 = true : t4.forceBlock || (n4 = false === Z.test(e4));
    const r4 = fe2(se2(n4 ? e4 : Se(e4).replace(oe, "") + "\n\n", { inline: n4 }));
    for (; $e(r4[r4.length - 1]) && !r4[r4.length - 1].trim(); )
      r4.pop();
    if (null === t4.wrapper)
      return r4;
    const o4 = t4.wrapper || (n4 ? "span" : "div");
    let a4;
    if (r4.length > 1 || t4.forceWrapper)
      a4 = r4;
    else {
      if (1 === r4.length)
        return a4 = r4[0], "string" == typeof a4 ? W2("span", { key: "outer" }, a4) : a4;
      a4 = null;
    }
    return U2(o4, { key: "outer" }, a4);
  }
  function ce2(e4, n4) {
    if (!n4 || !n4.trim())
      return null;
    const r4 = n4.match(u);
    return r4 ? r4.reduce(function(n5, r5) {
      const t5 = r5.indexOf("=");
      if (-1 !== t5) {
        const a4 = function(e5) {
          return -1 !== e5.indexOf("-") && null === e5.match(L) && (e5 = e5.replace(T, function(e6, n6) {
            return n6.toUpperCase();
          })), e5;
        }(r5.slice(0, t5)).trim(), c4 = function(e5) {
          const n6 = e5[0];
          return ('"' === n6 || "'" === n6) && e5.length >= 2 && e5[e5.length - 1] === n6 ? e5.slice(1, -1) : e5;
        }(r5.slice(t5 + 1).trim()), u4 = o[a4] || a4;
        if ("ref" === u4)
          return n5;
        const l5 = n5[u4] = function(e5, n6, r6, t6) {
          return "style" === n6 ? function(e6) {
            const n7 = [];
            let r7 = "", t7 = false, o4 = false, a5 = "";
            if (!e6)
              return n7;
            for (let c6 = 0; c6 < e6.length; c6++) {
              const i4 = e6[c6];
              if ('"' !== i4 && "'" !== i4 || t7 || (o4 ? i4 === a5 && (o4 = false, a5 = "") : (o4 = true, a5 = i4)), "(" === i4 && r7.endsWith("url") ? t7 = true : ")" === i4 && t7 && (t7 = false), ";" !== i4 || o4 || t7)
                r7 += i4;
              else {
                const e7 = r7.trim();
                if (e7) {
                  const r8 = e7.indexOf(":");
                  if (r8 > 0) {
                    const t8 = e7.slice(0, r8).trim(), o5 = e7.slice(r8 + 1).trim();
                    n7.push([t8, o5]);
                  }
                }
                r7 = "";
              }
            }
            const c5 = r7.trim();
            if (c5) {
              const e7 = c5.indexOf(":");
              if (e7 > 0) {
                const r8 = c5.slice(0, e7).trim(), t8 = c5.slice(e7 + 1).trim();
                n7.push([r8, t8]);
              }
            }
            return n7;
          }(r6).reduce(function(n7, [r7, o4]) {
            return n7[r7.replace(/(-[a-z])/g, (e6) => e6[1].toUpperCase())] = t6(o4, e5, r7), n7;
          }, {}) : -1 !== i.indexOf(n6) ? t6(Fe(r6), e5, n6) : (r6.match(j) && (r6 = Fe(r6.slice(1, r6.length - 1))), "true" === r6 || "false" !== r6 && r6);
        }(e4, a4, c4, G2);
        "string" == typeof l5 && (A.test(l5) || O.test(l5)) && (n5[u4] = re2(l5.trim()));
      } else
        "style" !== r5 && (n5[o[r5] || r5] = true);
      return n5;
    }, {}) : null;
  }
  const ie2 = [], ue2 = {}, le2 = { 0: { t: [">"], o: Te(s), i: 1, u(e4, n4, r4) {
    const [, t5, o4] = e4[0].replace(f, "").match(_);
    return { alert: t5, children: n4(o4, r4) };
  }, l(e4, n4, r4) {
    const t5 = { key: r4.key };
    return e4.alert && (t5.className = "markdown-alert-" + l4(e4.alert.toLowerCase(), Ae), e4.children.unshift({ attrs: {}, children: [{ type: "27", text: e4.alert }], noInnerParse: true, type: "11", tag: "header" })), W2("blockquote", t5, n4(e4.children, r4));
  } }, 1: { t: ["  "], o: Me(d), i: 1, u: Ue, l: (e4, n4, r4) => W2("br", { key: r4.key }) }, 2: { t: ["--", "__", "**", "- ", "* ", "_ "], o: Te(p), i: 1, u: Ue, l: (e4, n4, r4) => W2("hr", { key: r4.key }) }, 3: { t: ["    "], o: Te(h), i: 0, u: (e4) => ({ lang: void 0, text: Fe(Se(e4[0].replace(/^ {4}/gm, ""))) }), l: (e4, r4, t5) => W2("pre", { key: t5.key }, W2("code", n({}, e4.attrs, { className: e4.lang ? "lang-" + e4.lang : "" }), e4.text)) }, 4: { t: ["```", "~~~"], o: Te(y), i: 0, u: (e4) => ({ attrs: ce2("code", e4[3] || ""), lang: e4[2] || void 0, text: e4[4], type: "3" }) }, 5: { t: ["`"], o: Ie(g), i: 3, u: (e4) => ({ text: Fe(e4[2]) }), l: (e4, n4, r4) => W2("code", { key: r4.key }, e4.text) }, 6: { t: ["[^"], o: Te(x), i: 0, u: (e4) => (ie2.push({ footnote: e4[2], identifier: e4[1] }), {}), l: Ve }, 7: { t: ["[^"], o: Ce(q), i: 1, u: (e4) => ({ target: "#" + l4(e4[1], Ae), text: e4[1] }), l: (e4, n4, r4) => W2("a", { key: r4.key, href: G2(e4.target, "a", "href") }, W2("sup", { key: r4.key }, e4.text)) }, 8: { t: ["[ ]", "[x]"], o: Ce($), i: 1, u: (e4) => ({ completed: "x" === e4[1].toLowerCase() }), l: (e4, n4, r4) => W2("input", { checked: e4.completed, key: r4.key, readOnly: true, type: "checkbox" }) }, 9: { t: ["#"], o: Te(t4.enforceAtxHeadings ? z : S), i: 1, u: (e4, n4, r4) => ({ children: Pe(n4, e4[2], r4), id: l4(e4[2], Ae), level: e4[1].length }), l: (e4, n4, r4) => W2("h" + e4.level, { id: e4.id, key: r4.key }, n4(e4.children, r4)) }, 10: { t: (e4) => {
    const n4 = e4.indexOf("\n");
    return n4 > 0 && n4 < e4.length - 1 && ("=" === e4[n4 + 1] || "-" === e4[n4 + 1]);
  }, o: Te(E), i: 1, u: (e4, n4, r4) => ({ children: Pe(n4, e4[1], r4), level: "=" === e4[2] ? 1 : 2, type: "9" }) }, 11: { t: ["<"], o: Me(A), i: 1, u(e4, n4, r4) {
    const [, t5] = e4[3].match(ae), o4 = RegExp("^" + t5, "gm"), a4 = e4[3].replace(o4, ""), i4 = Q2(H3, a4) ? Ne : Pe, u4 = e4[1].toLowerCase(), l5 = -1 !== c.indexOf(u4), s4 = (l5 ? u4 : e4[1]).trim(), f4 = { attrs: ce2(s4, e4[2]), noInnerParse: l5, tag: s4 };
    if (r4.inAnchor = r4.inAnchor || "a" === u4, l5)
      f4.text = e4[3];
    else {
      const e5 = r4.inHTML;
      r4.inHTML = true, f4.children = i4(n4, a4, r4), r4.inHTML = e5;
    }
    return r4.inAnchor = false, f4;
  }, l: (e4, r4, t5) => W2(e4.tag, n({ key: t5.key }, e4.attrs), e4.text || (e4.children ? r4(e4.children, t5) : "")) }, 13: { t: ["<"], o: Me(O), i: 1, u(e4) {
    const n4 = e4[1].trim();
    return { attrs: ce2(n4, e4[2] || ""), tag: n4 };
  }, l: (e4, r4, t5) => W2(e4.tag, n({}, e4.attrs, { key: t5.key })) }, 12: { t: ["<!--"], o: Me(B), i: 1, u: () => ({}), l: Ve }, 14: { t: ["!["], o: Ie(be), i: 1, u: (e4) => ({ alt: Fe(e4[1]), target: Fe(e4[2]), title: Fe(e4[3]) }), l: (e4, n4, r4) => W2("img", { key: r4.key, alt: e4.alt || void 0, title: e4.title || void 0, src: G2(e4.target, "img", "src") }) }, 15: { t: ["["], o: Ce(ve), i: 3, u: (e4, n4, r4) => ({ children: Ze(n4, e4[1], r4), target: Fe(e4[2]), title: Fe(e4[3]) }), l: (e4, n4, r4) => W2("a", { key: r4.key, href: G2(e4.target, "a", "href"), title: e4.title }, n4(e4.children, r4)) }, 16: { t: ["<"], o: Ce(I), i: 0, u(e4) {
    let n4 = e4[1], r4 = false;
    return -1 !== n4.indexOf("@") && -1 === n4.indexOf("//") && (r4 = true, n4 = n4.replace("mailto:", "")), { children: [{ text: n4, type: "27" }], target: r4 ? "mailto:" + n4 : n4, type: "15" };
  } }, 17: { t: (e4, n4) => !n4.inAnchor && !t4.disableAutoLink && (ze(e4, "http://") || ze(e4, "https://")), o: Ce(C), i: 0, u: (e4) => ({ children: [{ text: e4[1], type: "27" }], target: e4[1], title: void 0, type: "15" }) }, 20: qe(W2, 1), 33: qe(W2, 2), 19: { t: ["\n"], o: Te(m), i: 3, u: Ue, l: () => "\n" }, 21: { o: je(function(e4, n4) {
    if (n4.inline || n4.simple || n4.inHTML && -1 === e4.indexOf("\n\n") && -1 === n4.prevCapture.indexOf("\n\n"))
      return null;
    let r4 = "", t5 = 0;
    for (; ; ) {
      const n5 = e4.indexOf("\n", t5), o5 = e4.slice(t5, -1 === n5 ? void 0 : n5 + 1);
      if (Q2(V2, o5))
        break;
      if (r4 += o5, -1 === n5 || !o5.trim())
        break;
      t5 = n5 + 1;
    }
    const o4 = Se(r4);
    return "" === o4 ? null : [r4, , o4];
  }), i: 3, u: Ge, l: (e4, n4, r4) => W2("p", { key: r4.key }, n4(e4.children, r4)) }, 22: { t: ["["], o: Ce(D), i: 0, u: (e4) => (ue2[e4[1]] = { target: e4[2], title: e4[4] }, {}), l: Ve }, 23: { t: ["!["], o: Ie(F), i: 0, u: (e4) => ({ alt: e4[1] ? Fe(e4[1]) : void 0, ref: e4[2] }), l: (e4, n4, r4) => ue2[e4.ref] ? W2("img", { key: r4.key, alt: e4.alt, src: G2(ue2[e4.ref].target, "img", "src"), title: ue2[e4.ref].title }) : null }, 24: { t: (e4) => "[" === e4[0] && -1 === e4.indexOf("]("), o: Ce(P), i: 0, u: (e4, n4, r4) => ({ children: n4(e4[1], r4), fallbackChildren: e4[0], ref: e4[2] }), l: (e4, n4, r4) => ue2[e4.ref] ? W2("a", { key: r4.key, href: G2(ue2[e4.ref].target, "a", "href"), title: ue2[e4.ref].title }, n4(e4.children, r4)) : W2("span", { key: r4.key }, e4.fallbackChildren) }, 25: { t: ["|"], o: Te(M), i: 1, u: Le, l(e4, n4, r4) {
    const t5 = e4;
    return W2("table", { key: r4.key }, W2("thead", null, W2("tr", null, t5.header.map(function(e5, o4) {
      return W2("th", { key: o4, style: Oe(t5, o4) }, n4(e5, r4));
    }))), W2("tbody", null, t5.cells.map(function(e5, o4) {
      return W2("tr", { key: o4 }, e5.map(function(e6, o5) {
        return W2("td", { key: o5, style: Oe(t5, o5) }, n4(e6, r4));
      }));
    })));
  } }, 27: { o: je(function(e4, n4) {
    let r4;
    return ze(e4, ":") && (r4 = ee.exec(e4)), r4 || te.exec(e4);
  }), i: 4, u(e4) {
    const n4 = e4[0];
    return { text: -1 === n4.indexOf("&") ? n4 : n4.replace(R, (e5, n5) => t4.namedCodesToUnicode[n5] || e5) };
  }, l: (e4) => e4.text }, 28: { t: ["**", "__"], o: Ie(J), i: 2, u: (e4, n4, r4) => ({ children: n4(e4[2], r4) }), l: (e4, n4, r4) => W2("strong", { key: r4.key }, n4(e4.children, r4)) }, 29: { t: (e4) => {
    const n4 = e4[0];
    return ("*" === n4 || "_" === n4) && e4[1] !== n4;
  }, o: Ie(K), i: 3, u: (e4, n4, r4) => ({ children: n4(e4[2], r4) }), l: (e4, n4, r4) => W2("em", { key: r4.key }, n4(e4.children, r4)) }, 30: { t: ["\\"], o: Ie(ne), i: 1, u: (e4) => ({ text: e4[1], type: "27" }) }, 31: { t: ["=="], o: Ie(X), i: 3, u: Ge, l: (e4, n4, r4) => W2("mark", { key: r4.key }, n4(e4.children, r4)) }, 32: { t: ["~~"], o: Ie(Y), i: 3, u: Ge, l: (e4, n4, r4) => W2("del", { key: r4.key }, n4(e4.children, r4)) } };
  true === t4.disableParsingRawHTML && (delete le2[11], delete le2[13]);
  const se2 = function(e4) {
    var n4 = Object.keys(e4);
    function r4(t5, o4) {
      var a4 = [];
      if (o4.prevCapture = o4.prevCapture || "", t5.trim())
        for (; t5; )
          for (var c4 = 0; c4 < n4.length; ) {
            var i4 = n4[c4], u4 = e4[i4];
            if (!u4.t || Ee(t5, o4, u4.t)) {
              var l5 = u4.o(t5, o4);
              if (l5 && l5[0]) {
                t5 = t5.substring(l5[0].length);
                var s4 = u4.u(l5, r4, o4);
                o4.prevCapture += l5[0], s4.type || (s4.type = i4), a4.push(s4);
                break;
              }
              c4++;
            } else
              c4++;
          }
      return o4.prevCapture = "", a4;
    }
    return n4.sort(function(n5, r5) {
      return e4[n5].i - e4[r5].i || (n5 < r5 ? -1 : 1);
    }), function(e5, n5) {
      return r4(function(e6) {
        return e6.replace(k, "\n").replace(v, "").replace(N, "    ");
      }(e5), n5);
    };
  }(le2), fe2 = /* @__PURE__ */ function(e4, n4) {
    return function r4(t5, o4 = {}) {
      if (Array.isArray(t5)) {
        const e5 = o4.key, n5 = [];
        let a4 = false;
        for (let e6 = 0; e6 < t5.length; e6++) {
          o4.key = e6;
          const c4 = r4(t5[e6], o4), i4 = $e(c4);
          i4 && a4 ? n5[n5.length - 1] += c4 : null !== c4 && n5.push(c4), a4 = i4;
        }
        return o4.key = e5, n5;
      }
      return function(r5, t6, o5) {
        const a4 = e4[r5.type].l;
        return n4 ? n4(() => a4(r5, t6, o5), r5, t6, o5) : a4(r5, t6, o5);
      }(t5, r4, o4);
    };
  }(le2, t4.renderRule), _e2 = re2(r3);
  return ie2.length ? W2("div", null, _e2, W2("footer", { key: "footer" }, ie2.map(function(e4) {
    return W2("div", { id: l4(e4.identifier, Ae), key: e4.identifier }, e4.identifier, fe2(se2(e4.footnote, { inline: true })));
  }))) : _e2;
}

// node_modules/instantsearch-ui-components/dist/es/components/chat/ChatMessage.js
var _excluded4 = ["classNames", "message", "side", "variant", "actions", "autoHideActions", "leadingComponent", "actionsComponent", "footerComponent", "tools", "indexUiState", "setIndexUiState", "onClose", "translations"];
function ownKeys8(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread8(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys8(Object(t4), true).forEach(function(r4) {
      _defineProperty5(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys8(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function createChatMessageComponent(_ref9) {
  var createElement2 = _ref9.createElement;
  var Button2 = createButtonComponent({
    createElement: createElement2
  });
  return function ChatMessage(userProps) {
    var _userProps$classNames = userProps.classNames, classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames, message = userProps.message, _userProps$side = userProps.side, side = _userProps$side === void 0 ? "left" : _userProps$side, _userProps$variant = userProps.variant, variant = _userProps$variant === void 0 ? "subtle" : _userProps$variant, _userProps$actions = userProps.actions, actions = _userProps$actions === void 0 ? [] : _userProps$actions, _userProps$autoHideAc = userProps.autoHideActions, autoHideActions = _userProps$autoHideAc === void 0 ? false : _userProps$autoHideAc, LeadingComponent = userProps.leadingComponent, ActionsComponent = userProps.actionsComponent, FooterComponent = userProps.footerComponent, _userProps$tools = userProps.tools, tools = _userProps$tools === void 0 ? {} : _userProps$tools, indexUiState = userProps.indexUiState, setIndexUiState = userProps.setIndexUiState, onClose = userProps.onClose, userTranslations = userProps.translations, props = _objectWithoutProperties(userProps, _excluded4);
    var translations = _objectSpread8({
      messageLabel: "Message",
      actionsLabel: "Message actions"
    }, userTranslations);
    var hasLeading = Boolean(LeadingComponent);
    var hasActions = Boolean(actions.length > 0 || ActionsComponent);
    var cssClasses = {
      root: cx("ais-ChatMessage", "ais-ChatMessage--".concat(side), "ais-ChatMessage--".concat(variant), autoHideActions && "ais-ChatMessage--auto-hide-actions", classNames.root),
      container: cx("ais-ChatMessage-container", classNames.container),
      leading: cx("ais-ChatMessage-leading", classNames.leading),
      content: cx("ais-ChatMessage-content", classNames.content),
      message: cx("ais-ChatMessage-message", classNames.message),
      actions: cx("ais-ChatMessage-actions", classNames.actions),
      footer: cx("ais-ChatMessage-footer", classNames.footer)
    };
    function renderMessagePart(part, index) {
      if (part.type === "step-start") {
        return null;
      }
      if (part.type === "text") {
        var markdown = We(part.text, {
          createElement: createElement2,
          disableParsingRawHTML: true
        });
        return createElement2("span", {
          key: "".concat(message.id, "-").concat(index)
        }, markdown);
      }
      if (startsWith(part.type, "tool-")) {
        var toolName = part.type.replace("tool-", "");
        var tool2 = tools[toolName];
        if (tool2) {
          var ToolLayoutComponent = tool2.layoutComponent;
          var toolMessage = part;
          var boundAddToolResult = function boundAddToolResult2(params) {
            var _tool$addToolResult;
            return (_tool$addToolResult = tool2.addToolResult) === null || _tool$addToolResult === void 0 ? void 0 : _tool$addToolResult.call(tool2, {
              output: params.output,
              tool: part.type,
              toolCallId: toolMessage.toolCallId
            });
          };
          return createElement2("div", {
            key: "".concat(message.id, "-").concat(index),
            className: "ais-ChatMessage-tool"
          }, createElement2(ToolLayoutComponent, {
            message: toolMessage,
            indexUiState,
            setIndexUiState,
            addToolResult: boundAddToolResult,
            onClose
          }));
        }
      }
      return null;
    }
    return createElement2("article", _extends({}, props, {
      className: cx(cssClasses.root, props.className),
      "aria-label": translations.messageLabel
    }), createElement2("div", {
      className: cx(cssClasses.container)
    }, hasLeading && createElement2("div", {
      className: cx(cssClasses.leading)
    }, LeadingComponent && createElement2(LeadingComponent, null)), createElement2("div", {
      className: cx(cssClasses.content)
    }, createElement2("div", {
      className: cx(cssClasses.message)
    }, message.parts.map(renderMessagePart)), hasActions && createElement2("div", {
      className: cx(cssClasses.actions),
      "aria-label": translations.actionsLabel
    }, ActionsComponent ? createElement2(ActionsComponent, {
      actions,
      message
    }) : actions.map(function(action, index) {
      return createElement2(Button2, {
        key: index,
        variant: "ghost",
        size: "sm",
        iconOnly: true,
        className: "ais-ChatMessage-action",
        disabled: action.disabled,
        "aria-label": action.title,
        onClick: function onClick() {
          var _action$onClick;
          return (_action$onClick = action.onClick) === null || _action$onClick === void 0 ? void 0 : _action$onClick.call(action, message);
        }
      }, action.icon ? createElement2(action.icon, null) : createElement2(MenuIconComponent, {
        createElement: createElement2
      }));
    })), FooterComponent && createElement2("div", {
      className: cx(cssClasses.footer)
    }, createElement2(FooterComponent, null)))));
  };
}

// node_modules/instantsearch-ui-components/dist/es/components/chat/ChatMessageError.js
var _excluded5 = ["onReload", "actions", "translations"];
function ownKeys9(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread9(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys9(Object(t4), true).forEach(function(r4) {
      _defineProperty5(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys9(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function createChatMessageErrorComponent(_ref9) {
  var createElement2 = _ref9.createElement;
  var Button2 = createButtonComponent({
    createElement: createElement2
  });
  return function ChatMessageError(_ref23) {
    var onReload = _ref23.onReload, actions = _ref23.actions, userTranslations = _ref23.translations, props = _objectWithoutProperties(_ref23, _excluded5);
    var translations = _objectSpread9({
      errorMessage: "Sorry, we are not able to generate a response at the moment. Please retry or contact support.",
      retryText: "Retry"
    }, userTranslations);
    return createElement2("article", _extends({
      className: "ais-ChatMessageError ais-ChatMessage ais-ChatMessage--left ais-ChatMessage--subtle"
    }, props), createElement2("div", {
      className: "ais-ChatMessage-container"
    }, createElement2("div", {
      className: "ais-ChatMessage-content"
    }, createElement2("div", {
      className: "ais-ChatMessage-message"
    }, translations.errorMessage), (actions || onReload) && createElement2("div", {
      className: "ais-ChatMessage-actions"
    }, actions ? actions.map(function(action, index) {
      return createElement2(Button2, _extends({
        key: index,
        variant: "ghost",
        className: "ais-ChatMessage-action"
      }, action), action.children);
    }) : createElement2(Button2, {
      variant: "primary",
      size: "md",
      className: "ais-ChatMessage-errorAction",
      onClick: function onClick() {
        return onReload === null || onReload === void 0 ? void 0 : onReload();
      }
    }, createElement2(ReloadIconComponent, {
      createElement: createElement2
    }), translations.retryText)))));
  };
}

// node_modules/instantsearch-ui-components/dist/es/components/chat/ChatMessageLoader.js
var _excluded6 = ["translations"];
function ownKeys10(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread10(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys10(Object(t4), true).forEach(function(r4) {
      _defineProperty5(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys10(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function createChatMessageLoaderComponent(_ref9) {
  var createElement2 = _ref9.createElement;
  return function ChatMessageLoader(_ref23) {
    var userTranslations = _ref23.translations, props = _objectWithoutProperties(_ref23, _excluded6);
    var translations = _objectSpread10({
      loaderText: "Thinking..."
    }, userTranslations);
    return createElement2("article", _extends({
      className: "ais-ChatMessageLoader ais-ChatMessage ais-ChatMessage--left ais-ChatMessage--subtle"
    }, props), createElement2("div", {
      className: "ais-ChatMessage-container"
    }, createElement2("div", {
      className: "ais-ChatMessage-leading"
    }, createElement2("div", {
      className: "ais-ChatMessageLoader-spinner"
    }, createElement2(LoadingSpinnerIconComponent, {
      createElement: createElement2
    }))), createElement2("div", {
      className: "ais-ChatMessage-content"
    }, createElement2("div", {
      className: "ais-ChatMessage-message"
    }, translations.loaderText && createElement2("div", {
      className: "ais-ChatMessageLoader-text"
    }, translations.loaderText), createElement2("div", {
      className: "ais-ChatMessageLoader-skeletonWrapper"
    }, createElement2("div", {
      className: "ais-ChatMessageLoader-skeletonItem"
    }), createElement2("div", {
      className: "ais-ChatMessageLoader-skeletonItem"
    }))))));
  };
}

// node_modules/instantsearch-ui-components/dist/es/components/chat/ChatMessages.js
var _excluded7 = ["classNames", "messages", "messageComponent", "loaderComponent", "errorComponent", "actionsComponent", "tools", "indexUiState", "setIndexUiState", "status", "hideScrollToBottom", "onReload", "onClose", "translations", "userMessageProps", "assistantMessageProps", "isClearing", "onClearTransitionEnd", "isScrollAtBottom", "scrollRef", "contentRef", "onScrollToBottom"];
function ownKeys11(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread11(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys11(Object(t4), true).forEach(function(r4) {
      _defineProperty5(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys11(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
var getTextContent = function getTextContent2(message) {
  return message.parts.map(function(part) {
    return "text" in part ? part.text : "";
  }).join("");
};
var hasTextContent = function hasTextContent2(message) {
  return getTextContent(message).trim() !== "";
};
var copyToClipboard = function copyToClipboard2(message) {
  navigator.clipboard.writeText(getTextContent(message));
};
function createDefaultMessageComponent(_ref9) {
  var createElement2 = _ref9.createElement, Fragment = _ref9.Fragment;
  var ChatMessage = createChatMessageComponent({
    createElement: createElement2,
    Fragment
  });
  return function DefaultMessage(_ref23) {
    var message = _ref23.message, userMessageProps = _ref23.userMessageProps, assistantMessageProps = _ref23.assistantMessageProps, tools = _ref23.tools, indexUiState = _ref23.indexUiState, setIndexUiState = _ref23.setIndexUiState, onReload = _ref23.onReload, onClose = _ref23.onClose, translations = _ref23.translations, actionsComponent = _ref23.actionsComponent;
    var defaultAssistantActions = [].concat(_toConsumableArray2(hasTextContent(message) ? [{
      title: translations.copyToClipboardLabel,
      icon: function icon() {
        return createElement2(CopyIconComponent, {
          createElement: createElement2
        });
      },
      onClick: copyToClipboard
    }] : []), [{
      title: translations.regenerateLabel,
      icon: function icon() {
        return createElement2(ReloadIconComponent, {
          createElement: createElement2
        });
      },
      onClick: function onClick(m5) {
        return onReload(m5.id);
      }
    }]);
    var messageProps = message.role === "user" ? userMessageProps : assistantMessageProps;
    var defaultActions = message.role === "user" ? void 0 : defaultAssistantActions;
    return createElement2(ChatMessage, _extends({
      side: message.role === "user" ? "right" : "left",
      variant: message.role === "user" ? "neutral" : "subtle",
      message,
      tools,
      indexUiState,
      setIndexUiState,
      onClose,
      actions: defaultActions,
      actionsComponent,
      "data-role": message.role
    }, messageProps));
  };
}
function createChatMessagesComponent(_ref33) {
  var createElement2 = _ref33.createElement, Fragment = _ref33.Fragment;
  var Button2 = createButtonComponent({
    createElement: createElement2
  });
  var DefaultMessageComponent = createDefaultMessageComponent({
    createElement: createElement2,
    Fragment
  });
  var DefaultLoaderComponent = createChatMessageLoaderComponent({
    createElement: createElement2
  });
  var DefaultErrorComponent = createChatMessageErrorComponent({
    createElement: createElement2
  });
  return function ChatMessages(userProps) {
    var _userProps$classNames = userProps.classNames, classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames, _userProps$messages = userProps.messages, messages = _userProps$messages === void 0 ? [] : _userProps$messages, MessageComponent = userProps.messageComponent, LoaderComponent = userProps.loaderComponent, ErrorComponent = userProps.errorComponent, ActionsComponent = userProps.actionsComponent, tools = userProps.tools, indexUiState = userProps.indexUiState, setIndexUiState = userProps.setIndexUiState, _userProps$status = userProps.status, status2 = _userProps$status === void 0 ? "ready" : _userProps$status, _userProps$hideScroll = userProps.hideScrollToBottom, hideScrollToBottom = _userProps$hideScroll === void 0 ? false : _userProps$hideScroll, onReload = userProps.onReload, onClose = userProps.onClose, userTranslations = userProps.translations, userMessageProps = userProps.userMessageProps, assistantMessageProps = userProps.assistantMessageProps, _userProps$isClearing = userProps.isClearing, isClearing = _userProps$isClearing === void 0 ? false : _userProps$isClearing, onClearTransitionEnd = userProps.onClearTransitionEnd, isScrollAtBottom = userProps.isScrollAtBottom, scrollRef = userProps.scrollRef, contentRef = userProps.contentRef, onScrollToBottom = userProps.onScrollToBottom, props = _objectWithoutProperties(userProps, _excluded7);
    var translations = _objectSpread11({
      scrollToBottomLabel: "Scroll to bottom",
      copyToClipboardLabel: "Copy to clipboard",
      regenerateLabel: "Regenerate"
    }, userTranslations);
    var cssClasses = {
      root: cx("ais-ChatMessages", classNames.root),
      scroll: cx("ais-ChatMessages-scroll ais-Scrollbar", classNames.scroll),
      content: cx("ais-ChatMessages-content", classNames.content),
      scrollToBottom: cx("ais-ChatMessages-scrollToBottom", classNames.scrollToBottom),
      scrollToBottomHidden: cx("ais-ChatMessages-scrollToBottom--hidden", classNames.scrollToBottomHidden)
    };
    var DefaultMessage = MessageComponent || DefaultMessageComponent;
    var DefaultLoader = LoaderComponent || DefaultLoaderComponent;
    var DefaultError = ErrorComponent || DefaultErrorComponent;
    return createElement2("div", _extends({}, props, {
      className: cx(cssClasses.root, props.className),
      role: "log",
      "aria-live": "polite"
    }), createElement2("div", {
      className: cx(cssClasses.scroll),
      ref: scrollRef
    }, createElement2("div", {
      className: cx(cssClasses.content, isClearing && "ais-ChatMessages-content--clearing"),
      ref: contentRef,
      onTransitionEnd: function onTransitionEnd(e4) {
        if (e4.target === e4.currentTarget && e4.propertyName === "opacity" && isClearing) {
          onClearTransitionEnd === null || onClearTransitionEnd === void 0 ? void 0 : onClearTransitionEnd();
        }
      }
    }, messages.map(function(message) {
      return createElement2(DefaultMessage, {
        key: message.id,
        message,
        userMessageProps,
        assistantMessageProps,
        tools,
        indexUiState,
        setIndexUiState,
        onReload,
        actionsComponent: ActionsComponent,
        onClose,
        translations
      });
    }), status2 === "submitted" && createElement2(DefaultLoader, {
      translations: {
        loaderText: translations.loaderText
      }
    }), status2 === "error" && createElement2(DefaultError, {
      onReload
    }))), createElement2(Button2, {
      variant: "outline",
      size: "sm",
      iconOnly: true,
      className: cx(cssClasses.scrollToBottom, (hideScrollToBottom || isScrollAtBottom) && cssClasses.scrollToBottomHidden),
      onClick: onScrollToBottom,
      "aria-label": translations.scrollToBottomLabel,
      tabIndex: isScrollAtBottom ? -1 : 0
    }, createElement2(ChevronDownIconComponent, {
      createElement: createElement2
    })));
  };
}

// node_modules/instantsearch-ui-components/dist/es/components/chat/ChatPrompt.js
var _excluded8 = ["classNames", "headerComponent", "footerComponent", "value", "placeholder", "status", "disabled", "maxRows", "autoFocus", "translations", "onInput", "onSubmit", "onKeyDown", "onStop", "promptRef"];
function ownKeys12(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread12(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys12(Object(t4), true).forEach(function(r4) {
      _defineProperty5(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys12(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function createChatPromptComponent(_ref9) {
  var createElement2 = _ref9.createElement;
  var Button2 = createButtonComponent({
    createElement: createElement2
  });
  var textAreaElement = null;
  var lineHeight = 0;
  var padding = 0;
  var adjustHeight = function adjustHeight2() {
    if (!textAreaElement)
      return;
    textAreaElement.style.height = "auto";
    var fullHeight = textAreaElement.scrollHeight;
    if (textAreaElement.getAttribute("data-max-rows")) {
      var maxRows = parseInt(textAreaElement.getAttribute("data-max-rows") || "0", 10);
      if (maxRows > 0) {
        var maxHeight = maxRows * lineHeight + padding;
        textAreaElement.style.overflowY = fullHeight > maxHeight ? "auto" : "hidden";
        textAreaElement.style.height = "".concat(Math.min(fullHeight, maxHeight), "px");
        return;
      }
    }
    textAreaElement.style.overflowY = "hidden";
    textAreaElement.style.height = "".concat(fullHeight, "px");
  };
  var setTextAreaRef = function setTextAreaRef2(element, promptRef) {
    textAreaElement = element;
    if (promptRef) {
      promptRef.current = element;
    }
    if (element) {
      var styles = getComputedStyle(element);
      lineHeight = parseFloat(styles.lineHeight);
      var pt = parseFloat(styles.paddingTop);
      var pb = parseFloat(styles.paddingBottom);
      padding = pt + pb;
      adjustHeight();
    }
  };
  return function ChatPrompt(userProps) {
    var _userProps$classNames = userProps.classNames, classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames, HeaderComponent = userProps.headerComponent, FooterComponent = userProps.footerComponent, value = userProps.value, placeholder = userProps.placeholder, _userProps$status = userProps.status, status2 = _userProps$status === void 0 ? "ready" : _userProps$status, _userProps$disabled = userProps.disabled, disabled = _userProps$disabled === void 0 ? false : _userProps$disabled, _userProps$maxRows = userProps.maxRows, maxRows = _userProps$maxRows === void 0 ? 5 : _userProps$maxRows, _userProps$autoFocus = userProps.autoFocus, autoFocus = _userProps$autoFocus === void 0 ? true : _userProps$autoFocus, userTranslations = userProps.translations, _onInput = userProps.onInput, _onSubmit = userProps.onSubmit, _onKeyDown = userProps.onKeyDown, onStop = userProps.onStop, promptRef = userProps.promptRef, props = _objectWithoutProperties(userProps, _excluded8);
    var translations = _objectSpread12({
      textareaLabel: "Type your message...",
      textareaPlaceholder: "Type your message...",
      emptyMessageTooltip: "Message is empty",
      stopResponseTooltip: "Stop response",
      sendMessageTooltip: "Send message",
      disclaimer: "AI can make mistakes. Verify responses."
    }, userTranslations);
    var cssClasses = {
      root: cx("ais-ChatPrompt", classNames.root),
      header: cx("ais-ChatPrompt-header", classNames.header),
      body: cx("ais-ChatPrompt-body", classNames.body),
      textarea: cx("ais-ChatPrompt-textarea ais-Scrollbar", disabled && "ais-ChatPrompt-textarea--disabled", classNames.textarea),
      actions: cx("ais-ChatPrompt-actions", classNames.actions, disabled && "ais-ChatPrompt-actions--disabled"),
      submit: cx("ais-ChatPrompt-submit", classNames.submit),
      footer: cx("ais-ChatPrompt-footer", classNames.footer)
    };
    var hasValue = typeof value === "string" ? value.trim() !== "" : Boolean(value);
    var canStop = status2 === "submitted" || status2 === "streaming";
    var buttonDisabled = !hasValue && !canStop || disabled;
    var submitIcon = canStop ? createElement2(StopIconComponent, {
      createElement: createElement2
    }) : createElement2(ArrowUpIconComponent, {
      createElement: createElement2
    });
    return createElement2("form", {
      className: cx(cssClasses.root, props.className),
      onSubmit: function onSubmit(event) {
        event.preventDefault();
        if (canStop) {
          onStop === null || onStop === void 0 ? void 0 : onStop();
          return;
        }
        if (!hasValue) {
          return;
        }
        _onSubmit === null || _onSubmit === void 0 ? void 0 : _onSubmit(event);
      }
    }, HeaderComponent && createElement2("div", {
      className: cx(cssClasses.header)
    }, createElement2(HeaderComponent, null)), createElement2("div", {
      className: cx(cssClasses.body),
      onClick: function onClick(e4) {
        var _textAreaElement;
        if (e4.target === textAreaElement)
          return;
        (_textAreaElement = textAreaElement) === null || _textAreaElement === void 0 ? void 0 : _textAreaElement.focus();
      }
    }, createElement2("textarea", _extends({}, props, {
      ref: function ref(element) {
        return setTextAreaRef(element, promptRef);
      },
      "data-max-rows": maxRows,
      className: cx(cssClasses.textarea),
      value,
      placeholder: placeholder || translations.textareaPlaceholder,
      "aria-label": translations.textareaLabel,
      disabled,
      autoFocus,
      onInput: function onInput(event) {
        adjustHeight();
        _onInput === null || _onInput === void 0 ? void 0 : _onInput(event);
      },
      onKeyDown: function onKeyDown(event) {
        _onKeyDown === null || _onKeyDown === void 0 ? void 0 : _onKeyDown(event);
        if (event.key === "Enter" && !event.shiftKey) {
          event.preventDefault();
          if (canStop) {
            onStop === null || onStop === void 0 ? void 0 : onStop();
            return;
          }
          if (!hasValue) {
            return;
          }
          _onSubmit === null || _onSubmit === void 0 ? void 0 : _onSubmit(event);
        }
        if (event.key === "Escape") {
          if (event.currentTarget && event.currentTarget.blur) {
            event.currentTarget.blur();
          }
        }
      }
    })), createElement2("div", {
      className: cx(cssClasses.actions)
    }, createElement2(Button2, {
      type: "submit",
      variant: "primary",
      size: "sm",
      iconOnly: true,
      className: cx(cssClasses.submit),
      disabled: buttonDisabled,
      "aria-label": function() {
        if (buttonDisabled)
          return translations.emptyMessageTooltip;
        if (canStop)
          return translations.stopResponseTooltip;
        return translations.sendMessageTooltip;
      }(),
      "data-status": status2
    }, submitIcon))), createElement2("div", {
      className: cx(cssClasses.footer)
    }, FooterComponent ? createElement2(FooterComponent, null) : createElement2("div", {
      className: "ais-ChatPrompt-disclaimer"
    }, translations.disclaimer)));
  };
}

// node_modules/instantsearch-ui-components/dist/es/components/chat/ChatToggleButton.js
var _excluded9 = ["open", "onClick", "toggleIconComponent", "classNames", "className"];
function createChatToggleButtonComponent(_ref9) {
  var createElement2 = _ref9.createElement;
  var Button2 = createButtonComponent({
    createElement: createElement2
  });
  return function ChatToggleButton(_ref23) {
    var open = _ref23.open, onClick = _ref23.onClick, ToggleIconComponent = _ref23.toggleIconComponent, _ref2$classNames = _ref23.classNames, classNames = _ref2$classNames === void 0 ? {} : _ref2$classNames, className = _ref23.className, props = _objectWithoutProperties(_ref23, _excluded9);
    var defaultIcon = open ? createElement2(ChevronUpIconComponent, {
      createElement: createElement2,
      width: 28,
      height: 28
    }) : createElement2(SparklesIconComponent, {
      createElement: createElement2,
      width: 28,
      height: 28
    });
    return createElement2(Button2, _extends({
      variant: "primary",
      size: "md",
      iconOnly: true,
      className: cx("ais-ChatToggleButton", open && "ais-ChatToggleButton--open", classNames.root, className),
      onClick
    }, props), ToggleIconComponent ? createElement2(ToggleIconComponent, {
      isOpen: open
    }) : defaultIcon);
  };
}

// node_modules/instantsearch-ui-components/dist/es/components/chat/Chat.js
var _excluded10 = ["open", "maximized", "headerProps", "toggleButtonProps", "messagesProps", "promptProps", "headerComponent", "promptComponent", "toggleButtonComponent", "classNames", "className"];
function ownKeys13(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread13(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys13(Object(t4), true).forEach(function(r4) {
      _defineProperty5(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys13(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function createChatComponent(_ref9) {
  var createElement2 = _ref9.createElement, Fragment = _ref9.Fragment;
  var ChatToggleButton = createChatToggleButtonComponent({
    createElement: createElement2,
    Fragment
  });
  var ChatHeader = createChatHeaderComponent({
    createElement: createElement2,
    Fragment
  });
  var ChatMessages = createChatMessagesComponent({
    createElement: createElement2,
    Fragment
  });
  var ChatPrompt = createChatPromptComponent({
    createElement: createElement2,
    Fragment
  });
  return function Chat3(_ref23) {
    var open = _ref23.open, _ref2$maximized = _ref23.maximized, maximized = _ref2$maximized === void 0 ? false : _ref2$maximized, headerProps = _ref23.headerProps, toggleButtonProps = _ref23.toggleButtonProps, messagesProps = _ref23.messagesProps, _ref2$promptProps = _ref23.promptProps, promptProps = _ref2$promptProps === void 0 ? {} : _ref2$promptProps, HeaderComponent = _ref23.headerComponent, PromptComponent = _ref23.promptComponent, ToggleButtonComponent = _ref23.toggleButtonComponent, _ref2$classNames = _ref23.classNames, classNames = _ref2$classNames === void 0 ? {} : _ref2$classNames, className = _ref23.className, props = _objectWithoutProperties(_ref23, _excluded10);
    return createElement2("div", _extends({}, props, {
      className: cx("ais-Chat", maximized && "ais-Chat--maximized", classNames.root, className)
    }), createElement2("div", {
      className: cx("ais-Chat-container", open && "ais-Chat-container--open", maximized && "ais-Chat-container--maximized", classNames.container)
    }, createElement2(HeaderComponent || ChatHeader, _objectSpread13(_objectSpread13({}, headerProps), {}, {
      classNames: classNames.header,
      maximized
    })), createElement2(ChatMessages, _extends({}, messagesProps, {
      classNames: classNames.messages
    })), createElement2(PromptComponent || ChatPrompt, _objectSpread13(_objectSpread13({}, promptProps), {}, {
      classNames: classNames.prompt
    }))), createElement2("div", {
      className: "ais-Chat-toggleButtonWrapper"
    }, createElement2(ToggleButtonComponent || ChatToggleButton, _objectSpread13(_objectSpread13({}, toggleButtonProps), {}, {
      classNames: classNames.toggleButton,
      onClick: function onClick() {
        var _toggleButtonProps$on;
        (_toggleButtonProps$on = toggleButtonProps.onClick) === null || _toggleButtonProps$on === void 0 ? void 0 : _toggleButtonProps$on.call(toggleButtonProps);
        if (!open) {
          var _promptProps$promptRe, _promptProps$promptRe2;
          (_promptProps$promptRe = promptProps.promptRef) === null || _promptProps$promptRe === void 0 ? void 0 : (_promptProps$promptRe2 = _promptProps$promptRe.current) === null || _promptProps$promptRe2 === void 0 ? void 0 : _promptProps$promptRe2.focus();
        }
      }
    }))));
  };
}

// node_modules/instantsearch-ui-components/dist/es/components/FrequentlyBoughtTogether.js
var _excluded11 = ["classNames", "emptyComponent", "headerComponent", "itemComponent", "layout", "items", "status", "translations", "sendEvent"];
function ownKeys14(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread14(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys14(Object(t4), true).forEach(function(r4) {
      _defineProperty5(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys14(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function createFrequentlyBoughtTogetherComponent(_ref9) {
  var createElement2 = _ref9.createElement, Fragment = _ref9.Fragment;
  return function FrequentlyBoughtTogether2(userProps) {
    var _userProps$classNames = userProps.classNames, classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames, _userProps$emptyCompo = userProps.emptyComponent, EmptyComponent = _userProps$emptyCompo === void 0 ? createDefaultEmptyComponent({
      createElement: createElement2,
      Fragment
    }) : _userProps$emptyCompo, _userProps$headerComp = userProps.headerComponent, HeaderComponent = _userProps$headerComp === void 0 ? createDefaultHeaderComponent({
      createElement: createElement2,
      Fragment
    }) : _userProps$headerComp, _userProps$itemCompon = userProps.itemComponent, ItemComponent = _userProps$itemCompon === void 0 ? createDefaultItemComponent({
      createElement: createElement2,
      Fragment
    }) : _userProps$itemCompon, _userProps$layout = userProps.layout, Layout = _userProps$layout === void 0 ? createListComponent({
      createElement: createElement2,
      Fragment
    }) : _userProps$layout, items = userProps.items, status2 = userProps.status, userTranslations = userProps.translations, sendEvent = userProps.sendEvent, props = _objectWithoutProperties(userProps, _excluded11);
    var translations = _objectSpread14({
      title: "Frequently bought together",
      sliderLabel: "Frequently bought together products"
    }, userTranslations);
    var cssClasses = {
      root: cx("ais-FrequentlyBoughtTogether", classNames.root),
      emptyRoot: cx("ais-FrequentlyBoughtTogether", classNames.root, "ais-FrequentlyBoughtTogether--empty", classNames.emptyRoot, props.className),
      title: cx("ais-FrequentlyBoughtTogether-title", classNames.title),
      container: cx("ais-FrequentlyBoughtTogether-container", classNames.container),
      list: cx("ais-FrequentlyBoughtTogether-list", classNames.list),
      item: cx("ais-FrequentlyBoughtTogether-item", classNames.item)
    };
    if (items.length === 0 && status2 === "idle") {
      return createElement2("section", _extends({}, props, {
        className: cssClasses.emptyRoot
      }), createElement2(EmptyComponent, null));
    }
    return createElement2("section", _extends({}, props, {
      className: cssClasses.root
    }), createElement2(HeaderComponent, {
      classNames: cssClasses,
      items,
      translations
    }), createElement2(Layout, {
      classNames: cssClasses,
      itemComponent: ItemComponent,
      items,
      sendEvent
    }));
  };
}

// node_modules/instantsearch-ui-components/dist/es/components/Highlight.js
var _excluded12 = ["parts", "highlightedTagName", "nonHighlightedTagName", "separator", "className", "classNames"];
function createHighlightPartComponent(_ref9) {
  var createElement2 = _ref9.createElement;
  return function HighlightPart(_ref23) {
    var classNames = _ref23.classNames, children = _ref23.children, highlightedTagName = _ref23.highlightedTagName, isHighlighted = _ref23.isHighlighted, nonHighlightedTagName = _ref23.nonHighlightedTagName;
    var TagName = isHighlighted ? highlightedTagName : nonHighlightedTagName;
    return createElement2(TagName, {
      className: isHighlighted ? classNames.highlighted : classNames.nonHighlighted
    }, children);
  };
}
function createHighlightComponent(_ref33) {
  var createElement2 = _ref33.createElement, Fragment = _ref33.Fragment;
  var HighlightPart = createHighlightPartComponent({
    createElement: createElement2,
    Fragment
  });
  return function Highlight3(userProps) {
    var parts = userProps.parts, _userProps$highlighte = userProps.highlightedTagName, highlightedTagName = _userProps$highlighte === void 0 ? "mark" : _userProps$highlighte, _userProps$nonHighlig = userProps.nonHighlightedTagName, nonHighlightedTagName = _userProps$nonHighlig === void 0 ? "span" : _userProps$nonHighlig, _userProps$separator = userProps.separator, separator2 = _userProps$separator === void 0 ? ", " : _userProps$separator, className = userProps.className, _userProps$classNames = userProps.classNames, classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames, props = _objectWithoutProperties(userProps, _excluded12);
    return createElement2("span", _extends({}, props, {
      className: cx(classNames.root, className)
    }), parts.map(function(part, partIndex) {
      var isLastPart = partIndex === parts.length - 1;
      return createElement2(Fragment, {
        key: partIndex
      }, part.map(function(subPart, subPartIndex) {
        return createElement2(HighlightPart, {
          key: subPartIndex,
          classNames,
          highlightedTagName,
          nonHighlightedTagName,
          isHighlighted: subPart.isHighlighted
        }, subPart.value);
      }), !isLastPart && createElement2("span", {
        className: classNames.separator
      }, separator2));
    }));
  };
}

// node_modules/instantsearch-ui-components/dist/es/components/Hits.js
var _excluded13 = ["classNames", "hits", "itemComponent", "sendEvent", "emptyComponent", "banner", "bannerComponent"];
function createDefaultBannerComponent(_ref9) {
  var createElement2 = _ref9.createElement;
  return function DefaultBanner3(_ref23) {
    var classNames = _ref23.classNames, banner = _ref23.banner;
    if (!banner.image.urls[0].url) {
      return null;
    }
    return createElement2("aside", {
      className: cx("ais-Hits-banner", classNames.bannerRoot)
    }, banner.link ? createElement2("a", {
      className: cx("ais-Hits-banner-link", classNames.bannerLink),
      href: banner.link.url,
      target: banner.link.target
    }, createElement2("img", {
      className: cx("ais-Hits-banner-image", classNames.bannerImage),
      src: banner.image.urls[0].url,
      alt: banner.image.title
    })) : createElement2("img", {
      className: cx("ais-Hits-banner-image", classNames.bannerImage),
      src: banner.image.urls[0].url,
      alt: banner.image.title
    }));
  };
}
function createHitsComponent(_ref33) {
  var createElement2 = _ref33.createElement, Fragment = _ref33.Fragment;
  var DefaultBannerComponent = createDefaultBannerComponent({
    createElement: createElement2,
    Fragment
  });
  return function Hits2(userProps) {
    var _userProps$classNames = userProps.classNames, classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames, hits2 = userProps.hits, ItemComponent = userProps.itemComponent, sendEvent = userProps.sendEvent, EmptyComponent = userProps.emptyComponent, banner = userProps.banner, BannerComponent = userProps.bannerComponent, props = _objectWithoutProperties(userProps, _excluded13);
    return createElement2("div", _extends({}, props, {
      className: cx("ais-Hits", classNames.root, hits2.length === 0 && cx("ais-Hits--empty", classNames.emptyRoot), props.className)
    }), banner && (BannerComponent ? createElement2(BannerComponent, {
      className: cx("ais-Hits-banner", classNames.bannerRoot),
      banner
    }) : createElement2(DefaultBannerComponent, {
      classNames,
      banner
    })), hits2.length === 0 && EmptyComponent ? createElement2(EmptyComponent, null) : createElement2("ol", {
      className: cx("ais-Hits-list", classNames.list)
    }, hits2.map(function(hit, index) {
      return createElement2(ItemComponent, {
        key: hit.objectID,
        hit,
        index,
        className: cx("ais-Hits-item", classNames.item),
        onClick: function onClick() {
          sendEvent("click:internal", hit, "Hit Clicked");
        },
        onAuxClick: function onAuxClick() {
          sendEvent("click:internal", hit, "Hit Clicked");
        }
      });
    })));
  };
}

// node_modules/instantsearch-ui-components/dist/es/components/LookingSimilar.js
var _excluded14 = ["classNames", "emptyComponent", "headerComponent", "itemComponent", "layout", "items", "status", "translations", "sendEvent"];
function ownKeys15(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread15(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys15(Object(t4), true).forEach(function(r4) {
      _defineProperty5(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys15(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function createLookingSimilarComponent(_ref9) {
  var createElement2 = _ref9.createElement, Fragment = _ref9.Fragment;
  return function LookingSimilar2(userProps) {
    var _userProps$classNames = userProps.classNames, classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames, _userProps$emptyCompo = userProps.emptyComponent, EmptyComponent = _userProps$emptyCompo === void 0 ? createDefaultEmptyComponent({
      createElement: createElement2,
      Fragment
    }) : _userProps$emptyCompo, _userProps$headerComp = userProps.headerComponent, HeaderComponent = _userProps$headerComp === void 0 ? createDefaultHeaderComponent({
      createElement: createElement2,
      Fragment
    }) : _userProps$headerComp, _userProps$itemCompon = userProps.itemComponent, ItemComponent = _userProps$itemCompon === void 0 ? createDefaultItemComponent({
      createElement: createElement2,
      Fragment
    }) : _userProps$itemCompon, _userProps$layout = userProps.layout, Layout = _userProps$layout === void 0 ? createListComponent({
      createElement: createElement2,
      Fragment
    }) : _userProps$layout, items = userProps.items, status2 = userProps.status, userTranslations = userProps.translations, sendEvent = userProps.sendEvent, props = _objectWithoutProperties(userProps, _excluded14);
    var translations = _objectSpread15({
      title: "Looking similar",
      sliderLabel: "Looking similar"
    }, userTranslations);
    var cssClasses = {
      root: cx("ais-LookingSimilar", classNames.root),
      emptyRoot: cx("ais-LookingSimilar", classNames.root, "ais-LookingSimilar--empty", classNames.emptyRoot, props.className),
      title: cx("ais-LookingSimilar-title", classNames.title),
      container: cx("ais-LookingSimilar-container", classNames.container),
      list: cx("ais-LookingSimilar-list", classNames.list),
      item: cx("ais-LookingSimilar-item", classNames.item)
    };
    if (items.length === 0 && status2 === "idle") {
      return createElement2("section", _extends({}, props, {
        className: cssClasses.emptyRoot
      }), createElement2(EmptyComponent, null));
    }
    return createElement2("section", _extends({}, props, {
      className: cssClasses.root
    }), createElement2(HeaderComponent, {
      classNames: cssClasses,
      items,
      translations
    }), createElement2(Layout, {
      classNames: cssClasses,
      itemComponent: ItemComponent,
      items,
      sendEvent
    }));
  };
}

// node_modules/instantsearch-ui-components/dist/es/components/RelatedProducts.js
var _excluded15 = ["classNames", "emptyComponent", "headerComponent", "itemComponent", "layout", "items", "status", "translations", "sendEvent"];
function ownKeys16(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread16(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys16(Object(t4), true).forEach(function(r4) {
      _defineProperty5(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys16(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function createRelatedProductsComponent(_ref9) {
  var createElement2 = _ref9.createElement, Fragment = _ref9.Fragment;
  return function RelatedProducts2(userProps) {
    var _userProps$classNames = userProps.classNames, classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames, _userProps$emptyCompo = userProps.emptyComponent, EmptyComponent = _userProps$emptyCompo === void 0 ? createDefaultEmptyComponent({
      createElement: createElement2,
      Fragment
    }) : _userProps$emptyCompo, _userProps$headerComp = userProps.headerComponent, HeaderComponent = _userProps$headerComp === void 0 ? createDefaultHeaderComponent({
      createElement: createElement2,
      Fragment
    }) : _userProps$headerComp, _userProps$itemCompon = userProps.itemComponent, ItemComponent = _userProps$itemCompon === void 0 ? createDefaultItemComponent({
      createElement: createElement2,
      Fragment
    }) : _userProps$itemCompon, _userProps$layout = userProps.layout, Layout = _userProps$layout === void 0 ? createListComponent({
      createElement: createElement2,
      Fragment
    }) : _userProps$layout, items = userProps.items, status2 = userProps.status, userTranslations = userProps.translations, sendEvent = userProps.sendEvent, props = _objectWithoutProperties(userProps, _excluded15);
    var translations = _objectSpread16({
      title: "Related products",
      sliderLabel: "Related products"
    }, userTranslations);
    var cssClasses = {
      root: cx("ais-RelatedProducts", classNames.root),
      emptyRoot: cx("ais-RelatedProducts", classNames.root, "ais-RelatedProducts--empty", classNames.emptyRoot, props.className),
      title: cx("ais-RelatedProducts-title", classNames.title),
      container: cx("ais-RelatedProducts-container", classNames.container),
      list: cx("ais-RelatedProducts-list", classNames.list),
      item: cx("ais-RelatedProducts-item", classNames.item)
    };
    if (items.length === 0 && status2 === "idle") {
      return createElement2("section", _extends({}, props, {
        className: cssClasses.emptyRoot
      }), createElement2(EmptyComponent, null));
    }
    return createElement2("section", _extends({}, props, {
      className: cssClasses.root
    }), createElement2(HeaderComponent, {
      classNames: cssClasses,
      items,
      translations
    }), createElement2(Layout, {
      classNames: cssClasses,
      itemComponent: ItemComponent,
      items,
      sendEvent
    }));
  };
}

// node_modules/instantsearch-ui-components/dist/es/components/TrendingItems.js
var _excluded16 = ["classNames", "emptyComponent", "headerComponent", "itemComponent", "layout", "items", "status", "translations", "sendEvent"];
function ownKeys17(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread17(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys17(Object(t4), true).forEach(function(r4) {
      _defineProperty5(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys17(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function createTrendingItemsComponent(_ref9) {
  var createElement2 = _ref9.createElement, Fragment = _ref9.Fragment;
  return function TrendingItems2(userProps) {
    var _userProps$classNames = userProps.classNames, classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames, _userProps$emptyCompo = userProps.emptyComponent, EmptyComponent = _userProps$emptyCompo === void 0 ? createDefaultEmptyComponent({
      createElement: createElement2,
      Fragment
    }) : _userProps$emptyCompo, _userProps$headerComp = userProps.headerComponent, HeaderComponent = _userProps$headerComp === void 0 ? createDefaultHeaderComponent({
      createElement: createElement2,
      Fragment
    }) : _userProps$headerComp, _userProps$itemCompon = userProps.itemComponent, ItemComponent = _userProps$itemCompon === void 0 ? createDefaultItemComponent({
      createElement: createElement2,
      Fragment
    }) : _userProps$itemCompon, _userProps$layout = userProps.layout, Layout = _userProps$layout === void 0 ? createListComponent({
      createElement: createElement2,
      Fragment
    }) : _userProps$layout, items = userProps.items, status2 = userProps.status, userTranslations = userProps.translations, sendEvent = userProps.sendEvent, props = _objectWithoutProperties(userProps, _excluded16);
    var translations = _objectSpread17({
      title: "Trending items",
      sliderLabel: "Trending items"
    }, userTranslations);
    var cssClasses = {
      root: cx("ais-TrendingItems", classNames.root),
      emptyRoot: cx("ais-TrendingItems", classNames.root, "ais-TrendingItems--empty", classNames.emptyRoot, props.className),
      title: cx("ais-TrendingItems-title", classNames.title),
      container: cx("ais-TrendingItems-container", classNames.container),
      list: cx("ais-TrendingItems-list", classNames.list),
      item: cx("ais-TrendingItems-item", classNames.item)
    };
    if (items.length === 0 && status2 === "idle") {
      return createElement2("section", _extends({}, props, {
        className: cssClasses.emptyRoot
      }), createElement2(EmptyComponent, null));
    }
    return createElement2("section", _extends({}, props, {
      className: cssClasses.root
    }), createElement2(HeaderComponent, {
      classNames: cssClasses,
      items,
      translations
    }), createElement2(Layout, {
      classNames: cssClasses,
      itemComponent: ItemComponent,
      items,
      sendEvent
    }));
  };
}

// node_modules/preact/dist/preact.module.js
var n2;
var l2;
var u2;
var t;
var i2;
var o2;
var r;
var f2;
var e2;
var c2 = {};
var s2 = [];
var a2 = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
var h2 = Array.isArray;
function v2(n4, l4) {
  for (var u4 in l4)
    n4[u4] = l4[u4];
  return n4;
}
function p2(n4) {
  var l4 = n4.parentNode;
  l4 && l4.removeChild(n4);
}
function y2(l4, u4, t4) {
  var i4, o4, r3, f4 = {};
  for (r3 in u4)
    "key" == r3 ? i4 = u4[r3] : "ref" == r3 ? o4 = u4[r3] : f4[r3] = u4[r3];
  if (arguments.length > 2 && (f4.children = arguments.length > 3 ? n2.call(arguments, 2) : t4), "function" == typeof l4 && null != l4.defaultProps)
    for (r3 in l4.defaultProps)
      void 0 === f4[r3] && (f4[r3] = l4.defaultProps[r3]);
  return d2(l4, f4, i4, o4, null);
}
function d2(n4, t4, i4, o4, r3) {
  var f4 = { type: n4, props: t4, key: i4, ref: o4, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, constructor: void 0, __v: null == r3 ? ++u2 : r3, __i: -1, __u: 0 };
  return null == r3 && null != l2.vnode && l2.vnode(f4), f4;
}
function _2() {
  return { current: null };
}
function g2(n4) {
  return n4.children;
}
function b2(n4, l4) {
  this.props = n4, this.context = l4;
}
function m2(n4, l4) {
  if (null == l4)
    return n4.__ ? m2(n4.__, n4.__i + 1) : null;
  for (var u4; l4 < n4.__k.length; l4++)
    if (null != (u4 = n4.__k[l4]) && null != u4.__e)
      return u4.__e;
  return "function" == typeof n4.type ? m2(n4) : null;
}
function w2(n4) {
  var l4, u4;
  if (null != (n4 = n4.__) && null != n4.__c) {
    for (n4.__e = n4.__c.base = null, l4 = 0; l4 < n4.__k.length; l4++)
      if (null != (u4 = n4.__k[l4]) && null != u4.__e) {
        n4.__e = n4.__c.base = u4.__e;
        break;
      }
    return w2(n4);
  }
}
function k2(n4) {
  (!n4.__d && (n4.__d = true) && i2.push(n4) && !x2.__r++ || o2 !== l2.debounceRendering) && ((o2 = l2.debounceRendering) || r)(x2);
}
function x2() {
  var n4, u4, t4, o4, r3, e4, c4, s4, a4;
  for (i2.sort(f2); n4 = i2.shift(); )
    n4.__d && (u4 = i2.length, o4 = void 0, e4 = (r3 = (t4 = n4).__v).__e, s4 = [], a4 = [], (c4 = t4.__P) && ((o4 = v2({}, r3)).__v = r3.__v + 1, l2.vnode && l2.vnode(o4), F2(c4, o4, r3, t4.__n, void 0 !== c4.ownerSVGElement, 32 & r3.__u ? [e4] : null, s4, null == e4 ? m2(r3) : e4, !!(32 & r3.__u), a4), o4.__v = r3.__v, o4.__.__k[o4.__i] = o4, L2(s4, o4, a4), o4.__e != e4 && w2(o4)), i2.length > u4 && i2.sort(f2));
  x2.__r = 0;
}
function C2(n4, l4, u4, t4, i4, o4, r3, f4, e4, a4, h4) {
  var v4, p4, y4, d4, _4, g3 = t4 && t4.__k || s2, b3 = l4.length;
  for (u4.__d = e4, P2(u4, l4, g3), e4 = u4.__d, v4 = 0; v4 < b3; v4++)
    null != (y4 = u4.__k[v4]) && "boolean" != typeof y4 && "function" != typeof y4 && (p4 = -1 === y4.__i ? c2 : g3[y4.__i] || c2, y4.__i = v4, F2(n4, y4, p4, i4, o4, r3, f4, e4, a4, h4), d4 = y4.__e, y4.ref && p4.ref != y4.ref && (p4.ref && O2(p4.ref, null, y4), h4.push(y4.ref, y4.__c || d4, y4)), null == _4 && null != d4 && (_4 = d4), 65536 & y4.__u || p4.__k === y4.__k ? (d4 || p4.__e != e4 || (e4 = m2(p4)), e4 = S2(y4, e4, n4)) : "function" == typeof y4.type && void 0 !== y4.__d ? e4 = y4.__d : d4 && (e4 = d4.nextSibling), y4.__d = void 0, y4.__u &= -196609);
  u4.__d = e4, u4.__e = _4;
}
function P2(n4, l4, u4) {
  var t4, i4, o4, r3, f4, e4 = l4.length, c4 = u4.length, s4 = c4, a4 = 0;
  for (n4.__k = [], t4 = 0; t4 < e4; t4++)
    r3 = t4 + a4, null != (i4 = n4.__k[t4] = null == (i4 = l4[t4]) || "boolean" == typeof i4 || "function" == typeof i4 ? null : "string" == typeof i4 || "number" == typeof i4 || "bigint" == typeof i4 || i4.constructor == String ? d2(null, i4, null, null, null) : h2(i4) ? d2(g2, { children: i4 }, null, null, null) : void 0 === i4.constructor && i4.__b > 0 ? d2(i4.type, i4.props, i4.key, i4.ref ? i4.ref : null, i4.__v) : i4) ? (i4.__ = n4, i4.__b = n4.__b + 1, f4 = I2(i4, u4, r3, s4), i4.__i = f4, o4 = null, -1 !== f4 && (s4--, (o4 = u4[f4]) && (o4.__u |= 131072)), null == o4 || null === o4.__v ? (-1 == f4 && a4--, "function" != typeof i4.type && (i4.__u |= 65536)) : f4 !== r3 && (f4 === r3 + 1 ? a4++ : f4 > r3 ? s4 > e4 - r3 ? a4 += f4 - r3 : a4-- : f4 < r3 ? f4 == r3 - 1 && (a4 = f4 - r3) : a4 = 0, f4 !== t4 + a4 && (i4.__u |= 65536))) : (o4 = u4[r3]) && null == o4.key && o4.__e && 0 == (131072 & o4.__u) && (o4.__e == n4.__d && (n4.__d = m2(o4)), j2(o4, o4, false), u4[r3] = null, s4--);
  if (s4)
    for (t4 = 0; t4 < c4; t4++)
      null != (o4 = u4[t4]) && 0 == (131072 & o4.__u) && (o4.__e == n4.__d && (n4.__d = m2(o4)), j2(o4, o4));
}
function S2(n4, l4, u4) {
  var t4, i4;
  if ("function" == typeof n4.type) {
    for (t4 = n4.__k, i4 = 0; t4 && i4 < t4.length; i4++)
      t4[i4] && (t4[i4].__ = n4, l4 = S2(t4[i4], l4, u4));
    return l4;
  }
  n4.__e != l4 && (u4.insertBefore(n4.__e, l4 || null), l4 = n4.__e);
  do {
    l4 = l4 && l4.nextSibling;
  } while (null != l4 && 8 === l4.nodeType);
  return l4;
}
function I2(n4, l4, u4, t4) {
  var i4 = n4.key, o4 = n4.type, r3 = u4 - 1, f4 = u4 + 1, e4 = l4[u4];
  if (null === e4 || e4 && i4 == e4.key && o4 === e4.type && 0 == (131072 & e4.__u))
    return u4;
  if (t4 > (null != e4 && 0 == (131072 & e4.__u) ? 1 : 0))
    for (; r3 >= 0 || f4 < l4.length; ) {
      if (r3 >= 0) {
        if ((e4 = l4[r3]) && 0 == (131072 & e4.__u) && i4 == e4.key && o4 === e4.type)
          return r3;
        r3--;
      }
      if (f4 < l4.length) {
        if ((e4 = l4[f4]) && 0 == (131072 & e4.__u) && i4 == e4.key && o4 === e4.type)
          return f4;
        f4++;
      }
    }
  return -1;
}
function H2(n4, l4, u4) {
  "-" === l4[0] ? n4.setProperty(l4, null == u4 ? "" : u4) : n4[l4] = null == u4 ? "" : "number" != typeof u4 || a2.test(l4) ? u4 : u4 + "px";
}
function T2(n4, l4, u4, t4, i4) {
  var o4;
  n:
    if ("style" === l4)
      if ("string" == typeof u4)
        n4.style.cssText = u4;
      else {
        if ("string" == typeof t4 && (n4.style.cssText = t4 = ""), t4)
          for (l4 in t4)
            u4 && l4 in u4 || H2(n4.style, l4, "");
        if (u4)
          for (l4 in u4)
            t4 && u4[l4] === t4[l4] || H2(n4.style, l4, u4[l4]);
      }
    else if ("o" === l4[0] && "n" === l4[1])
      o4 = l4 !== (l4 = l4.replace(/(PointerCapture)$|Capture$/i, "$1")), l4 = l4.toLowerCase() in n4 || "onFocusOut" === l4 || "onFocusIn" === l4 ? l4.toLowerCase().slice(2) : l4.slice(2), n4.l || (n4.l = {}), n4.l[l4 + o4] = u4, u4 ? t4 ? u4.u = t4.u : (u4.u = Date.now(), n4.addEventListener(l4, o4 ? D2 : A2, o4)) : n4.removeEventListener(l4, o4 ? D2 : A2, o4);
    else {
      if (i4)
        l4 = l4.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
      else if ("width" !== l4 && "height" !== l4 && "href" !== l4 && "list" !== l4 && "form" !== l4 && "tabIndex" !== l4 && "download" !== l4 && "rowSpan" !== l4 && "colSpan" !== l4 && "role" !== l4 && l4 in n4)
        try {
          n4[l4] = null == u4 ? "" : u4;
          break n;
        } catch (n5) {
        }
      "function" == typeof u4 || (null == u4 || false === u4 && "-" !== l4[4] ? n4.removeAttribute(l4) : n4.setAttribute(l4, u4));
    }
}
function A2(n4) {
  if (this.l) {
    var u4 = this.l[n4.type + false];
    if (n4.t) {
      if (n4.t <= u4.u)
        return;
    } else
      n4.t = Date.now();
    return u4(l2.event ? l2.event(n4) : n4);
  }
}
function D2(n4) {
  if (this.l)
    return this.l[n4.type + true](l2.event ? l2.event(n4) : n4);
}
function F2(n4, u4, t4, i4, o4, r3, f4, e4, c4, s4) {
  var a4, p4, y4, d4, _4, m5, w4, k4, x4, P3, S3, $2, I3, H3, T3, A3 = u4.type;
  if (void 0 !== u4.constructor)
    return null;
  128 & t4.__u && (c4 = !!(32 & t4.__u), r3 = [e4 = u4.__e = t4.__e]), (a4 = l2.__b) && a4(u4);
  n:
    if ("function" == typeof A3)
      try {
        if (k4 = u4.props, x4 = (a4 = A3.contextType) && i4[a4.__c], P3 = a4 ? x4 ? x4.props.value : a4.__ : i4, t4.__c ? w4 = (p4 = u4.__c = t4.__c).__ = p4.__E : ("prototype" in A3 && A3.prototype.render ? u4.__c = p4 = new A3(k4, P3) : (u4.__c = p4 = new b2(k4, P3), p4.constructor = A3, p4.render = z2), x4 && x4.sub(p4), p4.props = k4, p4.state || (p4.state = {}), p4.context = P3, p4.__n = i4, y4 = p4.__d = true, p4.__h = [], p4._sb = []), null == p4.__s && (p4.__s = p4.state), null != A3.getDerivedStateFromProps && (p4.__s == p4.state && (p4.__s = v2({}, p4.__s)), v2(p4.__s, A3.getDerivedStateFromProps(k4, p4.__s))), d4 = p4.props, _4 = p4.state, p4.__v = u4, y4)
          null == A3.getDerivedStateFromProps && null != p4.componentWillMount && p4.componentWillMount(), null != p4.componentDidMount && p4.__h.push(p4.componentDidMount);
        else {
          if (null == A3.getDerivedStateFromProps && k4 !== d4 && null != p4.componentWillReceiveProps && p4.componentWillReceiveProps(k4, P3), !p4.__e && (null != p4.shouldComponentUpdate && false === p4.shouldComponentUpdate(k4, p4.__s, P3) || u4.__v === t4.__v)) {
            for (u4.__v !== t4.__v && (p4.props = k4, p4.state = p4.__s, p4.__d = false), u4.__e = t4.__e, u4.__k = t4.__k, u4.__k.forEach(function(n5) {
              n5 && (n5.__ = u4);
            }), S3 = 0; S3 < p4._sb.length; S3++)
              p4.__h.push(p4._sb[S3]);
            p4._sb = [], p4.__h.length && f4.push(p4);
            break n;
          }
          null != p4.componentWillUpdate && p4.componentWillUpdate(k4, p4.__s, P3), null != p4.componentDidUpdate && p4.__h.push(function() {
            p4.componentDidUpdate(d4, _4, m5);
          });
        }
        if (p4.context = P3, p4.props = k4, p4.__P = n4, p4.__e = false, $2 = l2.__r, I3 = 0, "prototype" in A3 && A3.prototype.render) {
          for (p4.state = p4.__s, p4.__d = false, $2 && $2(u4), a4 = p4.render(p4.props, p4.state, p4.context), H3 = 0; H3 < p4._sb.length; H3++)
            p4.__h.push(p4._sb[H3]);
          p4._sb = [];
        } else
          do {
            p4.__d = false, $2 && $2(u4), a4 = p4.render(p4.props, p4.state, p4.context), p4.state = p4.__s;
          } while (p4.__d && ++I3 < 25);
        p4.state = p4.__s, null != p4.getChildContext && (i4 = v2(v2({}, i4), p4.getChildContext())), y4 || null == p4.getSnapshotBeforeUpdate || (m5 = p4.getSnapshotBeforeUpdate(d4, _4)), C2(n4, h2(T3 = null != a4 && a4.type === g2 && null == a4.key ? a4.props.children : a4) ? T3 : [T3], u4, t4, i4, o4, r3, f4, e4, c4, s4), p4.base = u4.__e, u4.__u &= -161, p4.__h.length && f4.push(p4), w4 && (p4.__E = p4.__ = null);
      } catch (n5) {
        u4.__v = null, c4 || null != r3 ? (u4.__e = e4, u4.__u |= c4 ? 160 : 32, r3[r3.indexOf(e4)] = null) : (u4.__e = t4.__e, u4.__k = t4.__k), l2.__e(n5, u4, t4);
      }
    else
      null == r3 && u4.__v === t4.__v ? (u4.__k = t4.__k, u4.__e = t4.__e) : u4.__e = M2(t4.__e, u4, t4, i4, o4, r3, f4, c4, s4);
  (a4 = l2.diffed) && a4(u4);
}
function L2(n4, u4, t4) {
  u4.__d = void 0;
  for (var i4 = 0; i4 < t4.length; i4++)
    O2(t4[i4], t4[++i4], t4[++i4]);
  l2.__c && l2.__c(u4, n4), n4.some(function(u5) {
    try {
      n4 = u5.__h, u5.__h = [], n4.some(function(n5) {
        n5.call(u5);
      });
    } catch (n5) {
      l2.__e(n5, u5.__v);
    }
  });
}
function M2(l4, u4, t4, i4, o4, r3, f4, e4, s4) {
  var a4, v4, y4, d4, _4, g3, b3, w4 = t4.props, k4 = u4.props, x4 = u4.type;
  if ("svg" === x4 && (o4 = true), null != r3) {
    for (a4 = 0; a4 < r3.length; a4++)
      if ((_4 = r3[a4]) && "setAttribute" in _4 == !!x4 && (x4 ? _4.localName === x4 : 3 === _4.nodeType)) {
        l4 = _4, r3[a4] = null;
        break;
      }
  }
  if (null == l4) {
    if (null === x4)
      return document.createTextNode(k4);
    l4 = o4 ? document.createElementNS("http://www.w3.org/2000/svg", x4) : document.createElement(x4, k4.is && k4), r3 = null, e4 = false;
  }
  if (null === x4)
    w4 === k4 || e4 && l4.data === k4 || (l4.data = k4);
  else {
    if (r3 = r3 && n2.call(l4.childNodes), w4 = t4.props || c2, !e4 && null != r3)
      for (w4 = {}, a4 = 0; a4 < l4.attributes.length; a4++)
        w4[(_4 = l4.attributes[a4]).name] = _4.value;
    for (a4 in w4)
      _4 = w4[a4], "children" == a4 || ("dangerouslySetInnerHTML" == a4 ? y4 = _4 : "key" === a4 || a4 in k4 || T2(l4, a4, null, _4, o4));
    for (a4 in k4)
      _4 = k4[a4], "children" == a4 ? d4 = _4 : "dangerouslySetInnerHTML" == a4 ? v4 = _4 : "value" == a4 ? g3 = _4 : "checked" == a4 ? b3 = _4 : "key" === a4 || e4 && "function" != typeof _4 || w4[a4] === _4 || T2(l4, a4, _4, w4[a4], o4);
    if (v4)
      e4 || y4 && (v4.__html === y4.__html || v4.__html === l4.innerHTML) || (l4.innerHTML = v4.__html), u4.__k = [];
    else if (y4 && (l4.innerHTML = ""), C2(l4, h2(d4) ? d4 : [d4], u4, t4, i4, o4 && "foreignObject" !== x4, r3, f4, r3 ? r3[0] : t4.__k && m2(t4, 0), e4, s4), null != r3)
      for (a4 = r3.length; a4--; )
        null != r3[a4] && p2(r3[a4]);
    e4 || (a4 = "value", void 0 !== g3 && (g3 !== l4[a4] || "progress" === x4 && !g3 || "option" === x4 && g3 !== w4[a4]) && T2(l4, a4, g3, w4[a4], false), a4 = "checked", void 0 !== b3 && b3 !== l4[a4] && T2(l4, a4, b3, w4[a4], false));
  }
  return l4;
}
function O2(n4, u4, t4) {
  try {
    "function" == typeof n4 ? n4(u4) : n4.current = u4;
  } catch (n5) {
    l2.__e(n5, t4);
  }
}
function j2(n4, u4, t4) {
  var i4, o4;
  if (l2.unmount && l2.unmount(n4), (i4 = n4.ref) && (i4.current && i4.current !== n4.__e || O2(i4, null, u4)), null != (i4 = n4.__c)) {
    if (i4.componentWillUnmount)
      try {
        i4.componentWillUnmount();
      } catch (n5) {
        l2.__e(n5, u4);
      }
    i4.base = i4.__P = null, n4.__c = void 0;
  }
  if (i4 = n4.__k)
    for (o4 = 0; o4 < i4.length; o4++)
      i4[o4] && j2(i4[o4], u4, t4 || "function" != typeof n4.type);
  t4 || null == n4.__e || p2(n4.__e), n4.__ = n4.__e = n4.__d = void 0;
}
function z2(n4, l4, u4) {
  return this.constructor(n4, u4);
}
function N2(u4, t4, i4) {
  var o4, r3, f4, e4;
  l2.__ && l2.__(u4, t4), r3 = (o4 = "function" == typeof i4) ? null : i4 && i4.__k || t4.__k, f4 = [], e4 = [], F2(t4, u4 = (!o4 && i4 || t4).__k = y2(g2, null, [u4]), r3 || c2, c2, void 0 !== t4.ownerSVGElement, !o4 && i4 ? [i4] : r3 ? null : t4.firstChild ? n2.call(t4.childNodes) : null, f4, !o4 && i4 ? i4 : r3 ? r3.__e : t4.firstChild, o4, e4), L2(f4, u4, e4);
}
n2 = s2.slice, l2 = { __e: function(n4, l4, u4, t4) {
  for (var i4, o4, r3; l4 = l4.__; )
    if ((i4 = l4.__c) && !i4.__)
      try {
        if ((o4 = i4.constructor) && null != o4.getDerivedStateFromError && (i4.setState(o4.getDerivedStateFromError(n4)), r3 = i4.__d), null != i4.componentDidCatch && (i4.componentDidCatch(n4, t4 || {}), r3 = i4.__d), r3)
          return i4.__E = i4;
      } catch (l5) {
        n4 = l5;
      }
  throw n4;
} }, u2 = 0, t = function(n4) {
  return null != n4 && null == n4.constructor;
}, b2.prototype.setState = function(n4, l4) {
  var u4;
  u4 = null != this.__s && this.__s !== this.state ? this.__s : this.__s = v2({}, this.state), "function" == typeof n4 && (n4 = n4(v2({}, u4), this.props)), n4 && v2(u4, n4), null != n4 && this.__v && (l4 && this._sb.push(l4), k2(this));
}, b2.prototype.forceUpdate = function(n4) {
  this.__v && (this.__e = true, n4 && this.__h.push(n4), k2(this));
}, b2.prototype.render = g2, i2 = [], r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, f2 = function(n4, l4) {
  return n4.__v.__b - l4.__v.__b;
}, x2.__r = 0, e2 = 0;

// node_modules/instantsearch.js/es/lib/templating/prepareTemplateProps.js
function _typeof6(o4) {
  "@babel/helpers - typeof";
  return _typeof6 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof6(o4);
}
function ownKeys18(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread18(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys18(Object(t4), true).forEach(function(r4) {
      _defineProperty6(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys18(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty6(obj, key2, value) {
  key2 = _toPropertyKey5(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey5(t4) {
  var i4 = _toPrimitive5(t4, "string");
  return "symbol" == _typeof6(i4) ? i4 : String(i4);
}
function _toPrimitive5(t4, r3) {
  if ("object" != _typeof6(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof6(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _toConsumableArray3(arr) {
  return _arrayWithoutHoles3(arr) || _iterableToArray3(arr) || _unsupportedIterableToArray6(arr) || _nonIterableSpread3();
}
function _nonIterableSpread3() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray6(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray6(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray6(o4, minLen);
}
function _iterableToArray3(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles3(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray6(arr);
}
function _arrayLikeToArray6(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
function prepareTemplates(defaultTemplates21) {
  var templates = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var allKeys = uniq([].concat(_toConsumableArray3(Object.keys(defaultTemplates21 || {})), _toConsumableArray3(Object.keys(templates))));
  return allKeys.reduce(function(config2, key2) {
    var defaultTemplate2 = defaultTemplates21 ? defaultTemplates21[key2] : void 0;
    var customTemplate = templates[key2];
    var isCustomTemplate = customTemplate !== void 0 && customTemplate !== defaultTemplate2;
    config2.templates[key2] = isCustomTemplate ? customTemplate : defaultTemplate2;
    config2.useCustomCompileOptions[key2] = isCustomTemplate;
    return config2;
  }, {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    templates: {},
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    useCustomCompileOptions: {}
  });
}
function prepareTemplateProps(_ref9) {
  var defaultTemplates21 = _ref9.defaultTemplates, templates = _ref9.templates, templatesConfig = _ref9.templatesConfig;
  var preparedTemplates = prepareTemplates(defaultTemplates21, templates);
  return _objectSpread18({
    templatesConfig
  }, preparedTemplates);
}

// node_modules/instantsearch.js/es/lib/templating/renderTemplate.js
var import_hogan = __toESM(require_hogan(), 1);

// node_modules/htm/dist/htm.module.js
var n3 = function(t4, s4, r3, e4) {
  var u4;
  s4[0] = 0;
  for (var h4 = 1; h4 < s4.length; h4++) {
    var p4 = s4[h4++], a4 = s4[h4] ? (s4[0] |= p4 ? 1 : 2, r3[s4[h4++]]) : s4[++h4];
    3 === p4 ? e4[0] = a4 : 4 === p4 ? e4[1] = Object.assign(e4[1] || {}, a4) : 5 === p4 ? (e4[1] = e4[1] || {})[s4[++h4]] = a4 : 6 === p4 ? e4[1][s4[++h4]] += a4 + "" : p4 ? (u4 = t4.apply(a4, n3(t4, a4, r3, ["", null])), e4.push(u4), a4[0] ? s4[0] |= 2 : (s4[h4 - 2] = 0, s4[h4] = u4)) : e4.push(a4);
  }
  return e4;
};
var t2 = /* @__PURE__ */ new Map();
function htm_module_default(s4) {
  var r3 = t2.get(this);
  return r3 || (r3 = /* @__PURE__ */ new Map(), t2.set(this, r3)), (r3 = n3(this, r3.get(s4) || (r3.set(s4, r3 = function(n4) {
    for (var t4, s5, r4 = 1, e4 = "", u4 = "", h4 = [0], p4 = function(n5) {
      1 === r4 && (n5 || (e4 = e4.replace(/^\s*\n\s*|\s*\n\s*$/g, ""))) ? h4.push(0, n5, e4) : 3 === r4 && (n5 || e4) ? (h4.push(3, n5, e4), r4 = 2) : 2 === r4 && "..." === e4 && n5 ? h4.push(4, n5, 0) : 2 === r4 && e4 && !n5 ? h4.push(5, 0, true, e4) : r4 >= 5 && ((e4 || !n5 && 5 === r4) && (h4.push(r4, 0, e4, s5), r4 = 6), n5 && (h4.push(r4, n5, 0, s5), r4 = 6)), e4 = "";
    }, a4 = 0; a4 < n4.length; a4++) {
      a4 && (1 === r4 && p4(), p4(a4));
      for (var l4 = 0; l4 < n4[a4].length; l4++)
        t4 = n4[a4][l4], 1 === r4 ? "<" === t4 ? (p4(), h4 = [h4], r4 = 3) : e4 += t4 : 4 === r4 ? "--" === e4 && ">" === t4 ? (r4 = 1, e4 = "") : e4 = t4 + e4[0] : u4 ? t4 === u4 ? u4 = "" : e4 += t4 : '"' === t4 || "'" === t4 ? u4 = t4 : ">" === t4 ? (p4(), r4 = 1) : r4 && ("=" === t4 ? (r4 = 5, s5 = e4, e4 = "") : "/" === t4 && (r4 < 5 || ">" === n4[a4][l4 + 1]) ? (p4(), 3 === r4 && (h4 = h4[0]), r4 = h4, (h4 = h4[0]).push(2, 0, r4), r4 = 0) : " " === t4 || "	" === t4 || "\n" === t4 || "\r" === t4 ? (p4(), r4 = 2) : e4 += t4), 3 === r4 && "!--" === e4 && (r4 = 4, h4 = h4[0]);
    }
    return p4(), h4;
  }(s4)), r3), arguments, [])).length > 1 ? r3 : r3[0];
}

// node_modules/htm/preact/index.module.js
var m3 = htm_module_default.bind(y2);

// node_modules/instantsearch.js/es/components/InternalHighlight/InternalHighlight.js
var InternalHighlight = createHighlightComponent({
  createElement: y2,
  Fragment: g2
});

// node_modules/instantsearch.js/es/components/Highlight/Highlight.js
var _excluded17 = ["classNames"];
function _extends2() {
  _extends2 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends2.apply(this, arguments);
}
function _objectWithoutProperties2(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose2(source, excluded);
  var key2, i4;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i4 = 0; i4 < sourceSymbolKeys.length; i4++) {
      key2 = sourceSymbolKeys[i4];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose2(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i4;
  for (i4 = 0; i4 < sourceKeys.length; i4++) {
    key2 = sourceKeys[i4];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function Highlight(_ref9) {
  var _ref$classNames = _ref9.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = _objectWithoutProperties2(_ref9, _excluded17);
  return y2(InternalHighlight, _extends2({
    classNames: {
      root: cx("ais-Highlight", classNames.root),
      highlighted: cx("ais-Highlight-highlighted", classNames.highlighted),
      nonHighlighted: cx("ais-Highlight-nonHighlighted", classNames.nonHighlighted),
      separator: cx("ais-Highlight-separator", classNames.separator)
    }
  }, props));
}

// node_modules/instantsearch.js/es/helpers/components/Highlight.js
var _excluded18 = ["hit", "attribute", "cssClasses"];
function _extends3() {
  _extends3 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends3.apply(this, arguments);
}
function _objectWithoutProperties3(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose3(source, excluded);
  var key2, i4;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i4 = 0; i4 < sourceSymbolKeys.length; i4++) {
      key2 = sourceSymbolKeys[i4];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose3(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i4;
  for (i4 = 0; i4 < sourceKeys.length; i4++) {
    key2 = sourceKeys[i4];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function Highlight2(_ref9) {
  var hit = _ref9.hit, attribute = _ref9.attribute, cssClasses = _ref9.cssClasses, props = _objectWithoutProperties3(_ref9, _excluded18);
  var property = getPropertyByPath(hit._highlightResult, attribute) || [];
  var properties = toArray(property);
  false ? _warning(Boolean(properties.length), 'Could not enable highlight for "'.concat(attribute.toString(), '", will display an empty string.\nPlease check whether this attribute exists and is either searchable or specified in `attributesToHighlight`.\n\nSee: https://alg.li/highlighting\n')) : void 0;
  var parts = properties.map(function(_ref23) {
    var value = _ref23.value;
    return getHighlightedParts(unescape(value || ""));
  });
  return y2(Highlight, _extends3({}, props, {
    parts,
    classNames: cssClasses
  }));
}

// node_modules/instantsearch.js/es/components/ReverseHighlight/ReverseHighlight.js
var _excluded19 = ["classNames"];
function _extends4() {
  _extends4 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends4.apply(this, arguments);
}
function _objectWithoutProperties4(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose4(source, excluded);
  var key2, i4;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i4 = 0; i4 < sourceSymbolKeys.length; i4++) {
      key2 = sourceSymbolKeys[i4];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose4(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i4;
  for (i4 = 0; i4 < sourceKeys.length; i4++) {
    key2 = sourceKeys[i4];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function ReverseHighlight(_ref9) {
  var _ref$classNames = _ref9.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = _objectWithoutProperties4(_ref9, _excluded19);
  return y2(InternalHighlight, _extends4({
    classNames: {
      root: cx("ais-ReverseHighlight", classNames.root),
      highlighted: cx("ais-ReverseHighlight-highlighted", classNames.highlighted),
      nonHighlighted: cx("ais-ReverseHighlight-nonHighlighted", classNames.nonHighlighted),
      separator: cx("ais-ReverseHighlight-separator", classNames.separator)
    }
  }, props));
}

// node_modules/instantsearch.js/es/helpers/components/ReverseHighlight.js
function _typeof7(o4) {
  "@babel/helpers - typeof";
  return _typeof7 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof7(o4);
}
var _excluded20 = ["hit", "attribute", "cssClasses"];
var _excluded22 = ["isHighlighted"];
function _extends5() {
  _extends5 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends5.apply(this, arguments);
}
function ownKeys19(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread19(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys19(Object(t4), true).forEach(function(r4) {
      _defineProperty7(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys19(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty7(obj, key2, value) {
  key2 = _toPropertyKey6(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey6(t4) {
  var i4 = _toPrimitive6(t4, "string");
  return "symbol" == _typeof7(i4) ? i4 : String(i4);
}
function _toPrimitive6(t4, r3) {
  if ("object" != _typeof7(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof7(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _objectWithoutProperties5(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose5(source, excluded);
  var key2, i4;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i4 = 0; i4 < sourceSymbolKeys.length; i4++) {
      key2 = sourceSymbolKeys[i4];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose5(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i4;
  for (i4 = 0; i4 < sourceKeys.length; i4++) {
    key2 = sourceKeys[i4];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function ReverseHighlight2(_ref9) {
  var hit = _ref9.hit, attribute = _ref9.attribute, cssClasses = _ref9.cssClasses, props = _objectWithoutProperties5(_ref9, _excluded20);
  var property = getPropertyByPath(hit._highlightResult, attribute) || [];
  var properties = toArray(property);
  false ? _warning(Boolean(properties.length), 'Could not enable highlight for "'.concat(attribute.toString(), '", will display an empty string.\nPlease check whether this attribute exists and is either searchable or specified in `attributesToHighlight`.\n\nSee: https://alg.li/highlighting\n')) : void 0;
  var parts = properties.map(function(_ref23) {
    var value = _ref23.value;
    return getHighlightedParts(unescape(value || "")).map(function(_ref33) {
      var isHighlighted = _ref33.isHighlighted, rest = _objectWithoutProperties5(_ref33, _excluded22);
      return _objectSpread19(_objectSpread19({}, rest), {}, {
        isHighlighted: !isHighlighted
      });
    });
  });
  return y2(ReverseHighlight, _extends5({}, props, {
    parts,
    classNames: cssClasses
  }));
}

// node_modules/instantsearch.js/es/components/ReverseSnippet/ReverseSnippet.js
var _excluded21 = ["classNames"];
function _extends6() {
  _extends6 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends6.apply(this, arguments);
}
function _objectWithoutProperties6(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose6(source, excluded);
  var key2, i4;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i4 = 0; i4 < sourceSymbolKeys.length; i4++) {
      key2 = sourceSymbolKeys[i4];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose6(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i4;
  for (i4 = 0; i4 < sourceKeys.length; i4++) {
    key2 = sourceKeys[i4];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function ReverseSnippet(_ref9) {
  var _ref$classNames = _ref9.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = _objectWithoutProperties6(_ref9, _excluded21);
  return y2(InternalHighlight, _extends6({
    classNames: {
      root: cx("ais-ReverseSnippet", classNames.root),
      highlighted: cx("ais-ReverseSnippet-highlighted", classNames.highlighted),
      nonHighlighted: cx("ais-ReverseSnippet-nonHighlighted", classNames.nonHighlighted),
      separator: cx("ais-ReverseSnippet-separator", classNames.separator)
    }
  }, props));
}

// node_modules/instantsearch.js/es/helpers/components/ReverseSnippet.js
function _typeof8(o4) {
  "@babel/helpers - typeof";
  return _typeof8 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof8(o4);
}
var _excluded23 = ["hit", "attribute", "cssClasses"];
var _excluded24 = ["isHighlighted"];
function _extends7() {
  _extends7 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends7.apply(this, arguments);
}
function ownKeys20(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread20(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys20(Object(t4), true).forEach(function(r4) {
      _defineProperty8(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys20(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty8(obj, key2, value) {
  key2 = _toPropertyKey7(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey7(t4) {
  var i4 = _toPrimitive7(t4, "string");
  return "symbol" == _typeof8(i4) ? i4 : String(i4);
}
function _toPrimitive7(t4, r3) {
  if ("object" != _typeof8(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof8(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _objectWithoutProperties7(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose7(source, excluded);
  var key2, i4;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i4 = 0; i4 < sourceSymbolKeys.length; i4++) {
      key2 = sourceSymbolKeys[i4];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose7(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i4;
  for (i4 = 0; i4 < sourceKeys.length; i4++) {
    key2 = sourceKeys[i4];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function ReverseSnippet2(_ref9) {
  var hit = _ref9.hit, attribute = _ref9.attribute, cssClasses = _ref9.cssClasses, props = _objectWithoutProperties7(_ref9, _excluded23);
  var property = getPropertyByPath(hit._snippetResult, attribute) || [];
  var properties = toArray(property);
  false ? _warning(Boolean(properties.length), 'Could not enable snippet for "'.concat(attribute.toString(), '", will display an empty string.\nPlease check whether this attribute exists and is specified in `attributesToSnippet`.\n\nSee: https://alg.li/highlighting\n')) : void 0;
  var parts = properties.map(function(_ref23) {
    var value = _ref23.value;
    return getHighlightedParts(unescape(value || "")).map(function(_ref33) {
      var isHighlighted = _ref33.isHighlighted, rest = _objectWithoutProperties7(_ref33, _excluded24);
      return _objectSpread20(_objectSpread20({}, rest), {}, {
        isHighlighted: !isHighlighted
      });
    });
  });
  return y2(ReverseSnippet, _extends7({}, props, {
    parts,
    classNames: cssClasses
  }));
}

// node_modules/instantsearch.js/es/components/Snippet/Snippet.js
var _excluded25 = ["classNames"];
function _extends8() {
  _extends8 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends8.apply(this, arguments);
}
function _objectWithoutProperties8(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose8(source, excluded);
  var key2, i4;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i4 = 0; i4 < sourceSymbolKeys.length; i4++) {
      key2 = sourceSymbolKeys[i4];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose8(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i4;
  for (i4 = 0; i4 < sourceKeys.length; i4++) {
    key2 = sourceKeys[i4];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function Snippet(_ref9) {
  var _ref$classNames = _ref9.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = _objectWithoutProperties8(_ref9, _excluded25);
  return y2(InternalHighlight, _extends8({
    classNames: {
      root: cx("ais-Snippet", classNames.root),
      highlighted: cx("ais-Snippet-highlighted", classNames.highlighted),
      nonHighlighted: cx("ais-Snippet-nonHighlighted", classNames.nonHighlighted),
      separator: cx("ais-Snippet-separator", classNames.separator)
    }
  }, props));
}

// node_modules/instantsearch.js/es/helpers/components/Snippet.js
var _excluded26 = ["hit", "attribute", "cssClasses"];
function _extends9() {
  _extends9 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends9.apply(this, arguments);
}
function _objectWithoutProperties9(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose9(source, excluded);
  var key2, i4;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i4 = 0; i4 < sourceSymbolKeys.length; i4++) {
      key2 = sourceSymbolKeys[i4];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose9(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i4;
  for (i4 = 0; i4 < sourceKeys.length; i4++) {
    key2 = sourceKeys[i4];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function Snippet2(_ref9) {
  var hit = _ref9.hit, attribute = _ref9.attribute, cssClasses = _ref9.cssClasses, props = _objectWithoutProperties9(_ref9, _excluded26);
  var property = getPropertyByPath(hit._snippetResult, attribute) || [];
  var properties = toArray(property);
  false ? _warning(Boolean(properties.length), 'Could not enable snippet for "'.concat(attribute.toString(), '", will display an empty string.\nPlease check whether this attribute exists and is specified in `attributesToSnippet`.\n\nSee: https://alg.li/highlighting\n')) : void 0;
  var parts = properties.map(function(_ref23) {
    var value = _ref23.value;
    return getHighlightedParts(unescape(value || ""));
  });
  return y2(Snippet, _extends9({}, props, {
    parts,
    classNames: cssClasses
  }));
}

// node_modules/instantsearch.js/es/lib/templating/renderTemplate.js
function _typeof9(o4) {
  "@babel/helpers - typeof";
  return _typeof9 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof9(o4);
}
function ownKeys21(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread21(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys21(Object(t4), true).forEach(function(r4) {
      _defineProperty9(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys21(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty9(obj, key2, value) {
  key2 = _toPropertyKey8(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey8(t4) {
  var i4 = _toPrimitive8(t4, "string");
  return "symbol" == _typeof9(i4) ? i4 : String(i4);
}
function _toPrimitive8(t4, r3) {
  if ("object" != _typeof9(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof9(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function transformHelpersToHogan() {
  var helpers = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var compileOptions = arguments.length > 1 ? arguments[1] : void 0;
  var data = arguments.length > 2 ? arguments[2] : void 0;
  return Object.keys(helpers).reduce(function(acc, helperKey) {
    return _objectSpread21(_objectSpread21({}, acc), {}, _defineProperty9({}, helperKey, function() {
      var _this = this;
      return function(text4) {
        var render = function render2(value) {
          return import_hogan.default.compile(value, compileOptions).render(_this);
        };
        return helpers[helperKey].call(data, text4, render);
      };
    }));
  }, {});
}
function renderTemplate(_ref9) {
  var templates = _ref9.templates, templateKey = _ref9.templateKey, compileOptions = _ref9.compileOptions, helpers = _ref9.helpers, data = _ref9.data, bindEvent = _ref9.bindEvent, sendEvent = _ref9.sendEvent;
  var template = templates[templateKey];
  if (typeof template !== "string" && typeof template !== "function") {
    throw new Error("Template must be 'string' or 'function', was '".concat(_typeof9(template), "' (key: ").concat(templateKey, ")"));
  }
  if (typeof template === "function") {
    var params = bindEvent || {};
    params.html = m3;
    params.sendEvent = sendEvent;
    params.components = {
      Highlight: Highlight2,
      ReverseHighlight: ReverseHighlight2,
      Snippet: Snippet2,
      ReverseSnippet: ReverseSnippet2
    };
    return template(data, params);
  }
  var transformedHelpers = transformHelpersToHogan(helpers, compileOptions, data);
  return import_hogan.default.compile(template, compileOptions).render(_objectSpread21(_objectSpread21({}, data), {}, {
    helpers: transformedHelpers
  })).replace(/[ \n\r\t\f\xA0]+/g, function(spaces) {
    return spaces.replace(/(^|\xA0+)[^\xA0]+/g, "$1 ");
  }).trim();
}

// node_modules/instantsearch.js/es/components/Template/Template.js
function _extends10() {
  _extends10 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends10.apply(this, arguments);
}
function _typeof10(o4) {
  "@babel/helpers - typeof";
  return _typeof10 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof10(o4);
}
function _toConsumableArray4(arr) {
  return _arrayWithoutHoles4(arr) || _iterableToArray4(arr) || _unsupportedIterableToArray7(arr) || _nonIterableSpread4();
}
function _nonIterableSpread4() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray7(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray7(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray7(o4, minLen);
}
function _iterableToArray4(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles4(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray7(arr);
}
function _arrayLikeToArray7(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i4 = 0; i4 < props.length; i4++) {
    var descriptor = props[i4];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey9(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o4, p4) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf9(o5, p5) {
    o5.__proto__ = p5;
    return o5;
  };
  return _setPrototypeOf(o4, p4);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof10(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e4) {
    return false;
  }
}
function _getPrototypeOf(o4) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf9(o5) {
    return o5.__proto__ || Object.getPrototypeOf(o5);
  };
  return _getPrototypeOf(o4);
}
function _defineProperty10(obj, key2, value) {
  key2 = _toPropertyKey9(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey9(t4) {
  var i4 = _toPrimitive9(t4, "string");
  return "symbol" == _typeof10(i4) ? i4 : String(i4);
}
function _toPrimitive9(t4, r3) {
  if ("object" != _typeof10(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof10(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var RawHtml = /* @__PURE__ */ function(_Component) {
  _inherits(RawHtml2, _Component);
  var _super = _createSuper(RawHtml2);
  function RawHtml2() {
    var _this;
    _classCallCheck(this, RawHtml2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty10(_assertThisInitialized(_this), "ref", _2());
    _defineProperty10(_assertThisInitialized(_this), "nodes", []);
    return _this;
  }
  _createClass(RawHtml2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var fragment = new DocumentFragment();
      var root = document.createElement("div");
      root.innerHTML = this.props.content;
      this.nodes = _toConsumableArray4(root.childNodes);
      this.nodes.forEach(function(node) {
        return fragment.appendChild(node);
      });
      this.ref.current.replaceWith(fragment);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.nodes.forEach(function(node) {
        if (node instanceof Element) {
          node.outerHTML = "";
          return;
        }
        node.nodeValue = "";
      });
      if (this.nodes[0] && this.nodes[0].nodeValue) {
        this.nodes[0].nodeValue = "";
      }
    }
  }, {
    key: "render",
    value: function render() {
      return y2("div", {
        ref: this.ref
      });
    }
  }]);
  return RawHtml2;
}(b2);
var defaultProps = {
  data: {},
  rootTagName: "div",
  useCustomCompileOptions: {},
  templates: {},
  templatesConfig: {}
};
var Template = /* @__PURE__ */ function(_Component2) {
  _inherits(Template2, _Component2);
  var _super2 = _createSuper(Template2);
  function Template2() {
    _classCallCheck(this, Template2);
    return _super2.apply(this, arguments);
  }
  _createClass(Template2, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !isEqual(this.props.data, nextProps.data) || this.props.templateKey !== nextProps.templateKey || !isEqual(this.props.rootProps, nextProps.rootProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      if (false) {
        var nonFunctionTemplates = Object.keys(this.props.templates).filter(function(key2) {
          return typeof _this2.props.templates[key2] !== "function";
        });
        false ? _warning(nonFunctionTemplates.length === 0, "Hogan.js and string-based templates are deprecated and will not be supported in InstantSearch.js 5.x.\n\nYou can replace them with function-form templates and use either the provided `html` function or JSX templates.\n\nString-based templates: ".concat(nonFunctionTemplates.join(", "), ".\n\nSee: https://www.algolia.com/doc/guides/building-search-ui/upgrade-guides/js/#upgrade-templates")) : void 0;
      }
      var RootTagName = this.props.rootTagName === "fragment" ? g2 : this.props.rootTagName;
      var useCustomCompileOptions = this.props.useCustomCompileOptions[this.props.templateKey];
      var compileOptions = useCustomCompileOptions ? this.props.templatesConfig.compileOptions : {};
      var content = renderTemplate({
        templates: this.props.templates,
        templateKey: this.props.templateKey,
        compileOptions,
        helpers: this.props.templatesConfig.helpers,
        data: this.props.data,
        bindEvent: this.props.bindEvent,
        sendEvent: this.props.sendEvent
      });
      if (content === null) {
        return null;
      }
      if (_typeof10(content) === "object") {
        return y2(RootTagName, this.props.rootProps, content);
      }
      if (RootTagName === g2) {
        return y2(RawHtml, {
          content,
          key: Math.random()
        });
      }
      return y2(RootTagName, _extends10({}, this.props.rootProps, {
        dangerouslySetInnerHTML: {
          __html: content
        }
      }));
    }
  }]);
  return Template2;
}(b2);
_defineProperty10(Template, "defaultProps", defaultProps);
var Template_default = Template;

// node_modules/instantsearch.js/es/components/Answers/Answers.js
function _typeof11(o4) {
  "@babel/helpers - typeof";
  return _typeof11 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof11(o4);
}
function ownKeys22(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread22(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys22(Object(t4), true).forEach(function(r4) {
      _defineProperty11(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys22(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty11(obj, key2, value) {
  key2 = _toPropertyKey10(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey10(t4) {
  var i4 = _toPrimitive10(t4, "string");
  return "symbol" == _typeof11(i4) ? i4 : String(i4);
}
function _toPrimitive10(t4, r3) {
  if ("object" != _typeof11(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof11(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _extends11() {
  _extends11 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends11.apply(this, arguments);
}
var Answers = function Answers2(_ref9) {
  var hits2 = _ref9.hits, isLoading = _ref9.isLoading, cssClasses = _ref9.cssClasses, templateProps = _ref9.templateProps;
  return y2("div", {
    className: cx(cssClasses.root, hits2.length === 0 && cssClasses.emptyRoot)
  }, y2(Template_default, _extends11({}, templateProps, {
    templateKey: "header",
    rootProps: {
      className: cssClasses.header
    },
    data: {
      hits: hits2,
      isLoading
    }
  })), isLoading ? y2(Template_default, _extends11({}, templateProps, {
    templateKey: "loader",
    rootProps: {
      className: cssClasses.loader
    }
  })) : y2("ul", {
    className: cssClasses.list
  }, hits2.map(function(hit, index) {
    return y2(Template_default, _extends11({}, templateProps, {
      templateKey: "item",
      rootTagName: "li",
      rootProps: {
        className: cssClasses.item
      },
      key: hit.objectID,
      data: _objectSpread22(_objectSpread22({}, hit), {}, {
        get __hitIndex() {
          false ? _warning(false, "The `__hitIndex` property is deprecated. Use the absolute `__position` instead.") : void 0;
          return index;
        }
      })
    }));
  })));
};
var Answers_default = Answers;

// node_modules/instantsearch.js/es/connectors/answers/connectAnswers.js
function _typeof12(o4) {
  "@babel/helpers - typeof";
  return _typeof12 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof12(o4);
}
function ownKeys23(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread23(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys23(Object(t4), true).forEach(function(r4) {
      _defineProperty12(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys23(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty12(obj, key2, value) {
  key2 = _toPropertyKey11(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey11(t4) {
  var i4 = _toPrimitive11(t4, "string");
  return "symbol" == _typeof12(i4) ? i4 : String(i4);
}
function _toPrimitive11(t4, r3) {
  if ("object" != _typeof12(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof12(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function hasFindAnswersMethod(answersIndex) {
  return typeof answersIndex.findAnswers === "function";
}
var withUsage = createDocumentationMessageGenerator({
  name: "answers",
  connector: true
});
var connectAnswers = function connectAnswers2(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage());
  return function(widgetParams) {
    var _ref9 = widgetParams || {}, queryLanguages = _ref9.queryLanguages, attributesForPrediction = _ref9.attributesForPrediction, _ref$nbHits = _ref9.nbHits, nbHits = _ref$nbHits === void 0 ? 1 : _ref$nbHits, _ref$renderDebounceTi = _ref9.renderDebounceTime, renderDebounceTime = _ref$renderDebounceTi === void 0 ? 100 : _ref$renderDebounceTi, _ref$searchDebounceTi = _ref9.searchDebounceTime, searchDebounceTime = _ref$searchDebounceTi === void 0 ? 100 : _ref$searchDebounceTi, _ref$escapeHTML = _ref9.escapeHTML, escapeHTML = _ref$escapeHTML === void 0 ? true : _ref$escapeHTML, _ref$extraParameters = _ref9.extraParameters, extraParameters = _ref$extraParameters === void 0 ? {} : _ref$extraParameters;
    if (!queryLanguages || queryLanguages.length === 0) {
      throw new Error(withUsage("The `queryLanguages` expects an array of strings."));
    }
    var runConcurrentSafePromise = createConcurrentSafePromise();
    var lastHits = [];
    var isLoading = false;
    var debouncedRender = debounce(renderFn, renderDebounceTime);
    var debouncedRefine;
    return {
      $$type: "ais.answers",
      init: function init(initOptions) {
        var state = initOptions.state, instantSearchInstance = initOptions.instantSearchInstance;
        if (typeof instantSearchInstance.client.initIndex !== "function") {
          throw new Error(withUsage("`algoliasearch` <5 required."));
        }
        var answersIndex = instantSearchInstance.client.initIndex(state.index);
        if (!hasFindAnswersMethod(answersIndex)) {
          throw new Error(withUsage("`algoliasearch` >= 4.8.0 required."));
        }
        debouncedRefine = debounce(answersIndex.findAnswers, searchDebounceTime);
        renderFn(_objectSpread23(_objectSpread23({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: initOptions.instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var _this = this;
        var query = renderOptions.state.query;
        if (!query) {
          lastHits = [];
          isLoading = false;
          renderFn(_objectSpread23(_objectSpread23({}, this.getWidgetRenderState(renderOptions)), {}, {
            instantSearchInstance: renderOptions.instantSearchInstance
          }), false);
          return;
        }
        lastHits = [];
        isLoading = true;
        renderFn(_objectSpread23(_objectSpread23({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: renderOptions.instantSearchInstance
        }), false);
        runConcurrentSafePromise(debouncedRefine(query, queryLanguages, _objectSpread23(_objectSpread23({}, extraParameters), {}, {
          nbHits,
          attributesForPrediction
        }))).then(function(result) {
          if (!result) {
            return;
          }
          if (escapeHTML && result.hits.length > 0) {
            result.hits = escapeHits(result.hits);
          }
          var hitsWithAbsolutePosition = addAbsolutePosition(result.hits, 0, nbHits);
          var hitsWithAbsolutePositionAndQueryID = addQueryID(hitsWithAbsolutePosition, result.queryID);
          lastHits = hitsWithAbsolutePositionAndQueryID;
          isLoading = false;
          debouncedRender(_objectSpread23(_objectSpread23({}, _this.getWidgetRenderState(renderOptions)), {}, {
            instantSearchInstance: renderOptions.instantSearchInstance
          }), false);
        });
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return _objectSpread23(_objectSpread23({}, renderState), {}, {
          answers: this.getWidgetRenderState(renderOptions)
        });
      },
      getWidgetRenderState: function getWidgetRenderState() {
        return {
          hits: lastHits,
          isLoading,
          widgetParams
        };
      },
      dispose: function dispose(_ref23) {
        var state = _ref23.state;
        unmountFn();
        return state;
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(state) {
        return state;
      }
    };
  };
};
var connectAnswers_default = connectAnswers;

// node_modules/instantsearch.js/es/widgets/answers/defaultTemplates.js
var defaultTemplates = {
  header: function header() {
    return "";
  },
  loader: function loader() {
    return "";
  },
  item: function item(_item) {
    return JSON.stringify(_item);
  }
};
var defaultTemplates_default = defaultTemplates;

// node_modules/instantsearch.js/es/widgets/answers/answers.js
function _typeof13(o4) {
  "@babel/helpers - typeof";
  return _typeof13 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof13(o4);
}
function ownKeys24(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread24(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys24(Object(t4), true).forEach(function(r4) {
      _defineProperty13(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys24(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty13(obj, key2, value) {
  key2 = _toPropertyKey12(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey12(t4) {
  var i4 = _toPrimitive12(t4, "string");
  return "symbol" == _typeof13(i4) ? i4 : String(i4);
}
function _toPrimitive12(t4, r3) {
  if ("object" != _typeof13(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof13(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage2 = createDocumentationMessageGenerator({
  name: "answers"
});
var suit = component("Answers");
var renderer = function renderer2(_ref9) {
  var containerNode = _ref9.containerNode, cssClasses = _ref9.cssClasses, renderState = _ref9.renderState, templates = _ref9.templates;
  return function(_ref23, isFirstRendering) {
    var hits2 = _ref23.hits, isLoading = _ref23.isLoading, instantSearchInstance = _ref23.instantSearchInstance;
    if (isFirstRendering) {
      renderState.templateProps = prepareTemplateProps({
        defaultTemplates: defaultTemplates_default,
        templatesConfig: instantSearchInstance.templatesConfig,
        templates
      });
      return;
    }
    N2(y2(Answers_default, {
      cssClasses,
      hits: hits2,
      isLoading,
      templateProps: renderState.templateProps
    }), containerNode);
  };
};
var answersWidget = function answersWidget2(widgetParams) {
  var _ref33 = widgetParams || {}, container = _ref33.container, attributesForPrediction = _ref33.attributesForPrediction, queryLanguages = _ref33.queryLanguages, nbHits = _ref33.nbHits, searchDebounceTime = _ref33.searchDebounceTime, renderDebounceTime = _ref33.renderDebounceTime, escapeHTML = _ref33.escapeHTML, extraParameters = _ref33.extraParameters, _ref3$templates = _ref33.templates, templates = _ref3$templates === void 0 ? {} : _ref3$templates, _ref3$cssClasses = _ref33.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses;
  if (!container) {
    throw new Error(withUsage2("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var cssClasses = {
    root: cx(suit(), userCssClasses.root),
    emptyRoot: cx(suit({
      modifierName: "empty"
    }), userCssClasses.emptyRoot),
    header: cx(suit({
      descendantName: "header"
    }), userCssClasses.header),
    loader: cx(suit({
      descendantName: "loader"
    }), userCssClasses.loader),
    list: cx(suit({
      descendantName: "list"
    }), userCssClasses.list),
    item: cx(suit({
      descendantName: "item"
    }), userCssClasses.item)
  };
  var specializedRenderer = renderer({
    containerNode,
    cssClasses,
    templates,
    renderState: {}
  });
  var makeWidget = connectAnswers_default(specializedRenderer, function() {
    return N2(null, containerNode);
  });
  return _objectSpread24(_objectSpread24({}, makeWidget({
    attributesForPrediction,
    queryLanguages,
    nbHits,
    searchDebounceTime,
    renderDebounceTime,
    escapeHTML,
    extraParameters
  })), {}, {
    $$widgetType: "ais.answers"
  });
};
var answers_default = deprecate(answersWidget, "The answers widget is deprecated and will be removed in InstantSearch.js 5.0");

// node_modules/instantsearch.js/es/connectors/configure-related-items/connectConfigureRelatedItems.js
var import_algoliasearch_helper2 = __toESM(require_algoliasearch_helper(), 1);

// node_modules/instantsearch.js/es/connectors/configure/connectConfigure.js
var import_algoliasearch_helper = __toESM(require_algoliasearch_helper(), 1);
function _typeof14(o4) {
  "@babel/helpers - typeof";
  return _typeof14 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof14(o4);
}
function ownKeys25(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread25(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys25(Object(t4), true).forEach(function(r4) {
      _defineProperty14(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys25(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty14(obj, key2, value) {
  key2 = _toPropertyKey13(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey13(t4) {
  var i4 = _toPrimitive13(t4, "string");
  return "symbol" == _typeof14(i4) ? i4 : String(i4);
}
function _toPrimitive13(t4, r3) {
  if ("object" != _typeof14(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof14(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage3 = createDocumentationMessageGenerator({
  name: "configure",
  connector: true
});
function getInitialSearchParameters(state, widgetParams) {
  return state.setQueryParameters(Object.keys(widgetParams.searchParameters).reduce(function(acc, key2) {
    return _objectSpread25(_objectSpread25({}, acc), {}, _defineProperty14({}, key2, void 0));
  }, {}));
}
var connectConfigure = function connectConfigure2() {
  var renderFn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : noop;
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  return function(widgetParams) {
    if (!widgetParams || !isPlainObject(widgetParams.searchParameters)) {
      throw new Error(withUsage3("The `searchParameters` option expects an object."));
    }
    var connectorState = {};
    function refine2(helper) {
      return function(searchParameters) {
        var actualState = getInitialSearchParameters(helper.state, widgetParams);
        var nextSearchParameters = mergeSearchParameters(actualState, new import_algoliasearch_helper.default.SearchParameters(searchParameters));
        widgetParams.searchParameters = searchParameters;
        helper.setState(nextSearchParameters).search();
      };
    }
    return {
      $$type: "ais.configure",
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(_objectSpread25(_objectSpread25({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(_objectSpread25(_objectSpread25({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance
        }), false);
      },
      dispose: function dispose(_ref9) {
        var state = _ref9.state;
        unmountFn();
        return getInitialSearchParameters(state, widgetParams);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        var _renderState$configur;
        var widgetRenderState = this.getWidgetRenderState(renderOptions);
        return _objectSpread25(_objectSpread25({}, renderState), {}, {
          configure: _objectSpread25(_objectSpread25({}, widgetRenderState), {}, {
            widgetParams: _objectSpread25(_objectSpread25({}, widgetRenderState.widgetParams), {}, {
              searchParameters: mergeSearchParameters(new import_algoliasearch_helper.default.SearchParameters((_renderState$configur = renderState.configure) === null || _renderState$configur === void 0 ? void 0 : _renderState$configur.widgetParams.searchParameters), new import_algoliasearch_helper.default.SearchParameters(widgetRenderState.widgetParams.searchParameters)).getQueryParams()
            })
          })
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref23) {
        var helper = _ref23.helper;
        if (!connectorState.refine) {
          connectorState.refine = refine2(helper);
        }
        return {
          refine: connectorState.refine,
          widgetParams
        };
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(state, _ref33) {
        var uiState = _ref33.uiState;
        return mergeSearchParameters(state, new import_algoliasearch_helper.default.SearchParameters(_objectSpread25(_objectSpread25({}, uiState.configure), widgetParams.searchParameters)));
      },
      getWidgetUiState: function getWidgetUiState(uiState) {
        return _objectSpread25(_objectSpread25({}, uiState), {}, {
          configure: _objectSpread25(_objectSpread25({}, uiState.configure), widgetParams.searchParameters)
        });
      }
    };
  };
};
var connectConfigure_default = connectConfigure;

// node_modules/instantsearch.js/es/connectors/configure-related-items/connectConfigureRelatedItems.js
function _typeof15(o4) {
  "@babel/helpers - typeof";
  return _typeof15 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof15(o4);
}
function ownKeys26(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread26(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys26(Object(t4), true).forEach(function(r4) {
      _defineProperty15(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys26(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty15(obj, key2, value) {
  key2 = _toPropertyKey14(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey14(t4) {
  var i4 = _toPrimitive14(t4, "string");
  return "symbol" == _typeof15(i4) ? i4 : String(i4);
}
function _toPrimitive14(t4, r3) {
  if ("object" != _typeof15(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof15(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _toConsumableArray5(arr) {
  return _arrayWithoutHoles5(arr) || _iterableToArray5(arr) || _unsupportedIterableToArray8(arr) || _nonIterableSpread5();
}
function _nonIterableSpread5() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray8(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray8(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray8(o4, minLen);
}
function _iterableToArray5(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles5(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray8(arr);
}
function _arrayLikeToArray8(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
var withUsage4 = createDocumentationMessageGenerator({
  name: "configure-related-items",
  connector: true
});
function createOptionalFilter(_ref9) {
  var attributeName = _ref9.attributeName, attributeValue = _ref9.attributeValue, attributeScore = _ref9.attributeScore;
  return "".concat(attributeName, ":").concat(attributeValue, "<score=").concat(attributeScore || 1, ">");
}
var connectConfigureRelatedItems = function connectConfigureRelatedItems2(renderFn, unmountFn) {
  return function(widgetParams) {
    var _ref23 = widgetParams || {}, hit = _ref23.hit, matchingPatterns = _ref23.matchingPatterns, _ref2$transformSearch = _ref23.transformSearchParameters, transformSearchParameters = _ref2$transformSearch === void 0 ? function(x4) {
      return x4;
    } : _ref2$transformSearch;
    if (!hit) {
      throw new Error(withUsage4("The `hit` option is required."));
    }
    if (!matchingPatterns) {
      throw new Error(withUsage4("The `matchingPatterns` option is required."));
    }
    var optionalFilters = Object.keys(matchingPatterns).reduce(function(acc, attributeName) {
      var attribute = matchingPatterns[attributeName];
      var attributeValue = getPropertyByPath(hit, attributeName);
      var attributeScore = attribute.score;
      if (Array.isArray(attributeValue)) {
        return [].concat(_toConsumableArray5(acc), [attributeValue.map(function(attributeSubValue) {
          return createOptionalFilter({
            attributeName,
            attributeValue: attributeSubValue,
            attributeScore
          });
        })]);
      }
      if (typeof attributeValue === "string") {
        return [].concat(_toConsumableArray5(acc), [createOptionalFilter({
          attributeName,
          attributeValue,
          attributeScore
        })]);
      }
      false ? _warning(false, "\nThe `matchingPatterns` option returned a value of type ".concat(getObjectType(attributeValue), ' for the "').concat(attributeName, '" key. This value was not sent to Algolia because `optionalFilters` only supports strings and array of strings.\n\nYou can remove the "').concat(attributeName, '" key from the `matchingPatterns` option.\n\nSee https://www.algolia.com/doc/api-reference/api-parameters/optionalFilters/\n            ')) : void 0;
      return acc;
    }, []);
    var searchParameters = _objectSpread26({}, transformSearchParameters(new import_algoliasearch_helper2.default.SearchParameters({
      sumOrFiltersScores: true,
      facetFilters: ["objectID:-".concat(hit.objectID)],
      optionalFilters
    })));
    var makeWidget = connectConfigure_default(renderFn, unmountFn);
    return _objectSpread26(_objectSpread26({}, makeWidget({
      searchParameters
    })), {}, {
      $$type: "ais.configureRelatedItems"
    });
  };
};
var connectConfigureRelatedItems_default = connectConfigureRelatedItems;

// node_modules/instantsearch.js/es/widgets/configure-related-items/configure-related-items.js
function _typeof16(o4) {
  "@babel/helpers - typeof";
  return _typeof16 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof16(o4);
}
function ownKeys27(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread27(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys27(Object(t4), true).forEach(function(r4) {
      _defineProperty16(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys27(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty16(obj, key2, value) {
  key2 = _toPropertyKey15(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey15(t4) {
  var i4 = _toPrimitive15(t4, "string");
  return "symbol" == _typeof16(i4) ? i4 : String(i4);
}
function _toPrimitive15(t4, r3) {
  if ("object" != _typeof16(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof16(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var configureRelatedItems = function configureRelatedItems2(widgetParams) {
  var makeWidget = connectConfigureRelatedItems_default(noop);
  return _objectSpread27(_objectSpread27({}, makeWidget(widgetParams)), {}, {
    $$widgetType: "ais.configureRelatedItems"
  });
};
var configure_related_items_default = configureRelatedItems;

// node_modules/instantsearch.js/es/connectors/dynamic-widgets/connectDynamicWidgets.js
function ownKeys28(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread28(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys28(Object(t4), true).forEach(function(r4) {
      _defineProperty17(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys28(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty17(obj, key2, value) {
  key2 = _toPropertyKey16(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey16(t4) {
  var i4 = _toPrimitive16(t4, "string");
  return "symbol" == _typeof17(i4) ? i4 : String(i4);
}
function _toPrimitive16(t4, r3) {
  if ("object" != _typeof17(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof17(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _typeof17(o4) {
  "@babel/helpers - typeof";
  return _typeof17 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof17(o4);
}
var withUsage5 = createDocumentationMessageGenerator({
  name: "dynamic-widgets",
  connector: true
});
var connectDynamicWidgets = function connectDynamicWidgets2(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage5());
  return function(widgetParams) {
    var widgets = widgetParams.widgets, _widgetParams$maxValu = widgetParams.maxValuesPerFacet, maxValuesPerFacet = _widgetParams$maxValu === void 0 ? 20 : _widgetParams$maxValu, _widgetParams$facets = widgetParams.facets, facets = _widgetParams$facets === void 0 ? ["*"] : _widgetParams$facets, _widgetParams$transfo = widgetParams.transformItems, transformItems = _widgetParams$transfo === void 0 ? function(items) {
      return items;
    } : _widgetParams$transfo, fallbackWidget = widgetParams.fallbackWidget;
    if (!(widgets && Array.isArray(widgets) && widgets.every(function(widget) {
      return _typeof17(widget) === "object";
    }))) {
      throw new Error(withUsage5("The `widgets` option expects an array of widgets."));
    }
    if (!Array.isArray(facets)) {
      throw new Error(withUsage5("The `facets` option only accepts an array of facets, you passed ".concat(JSON.stringify(facets))));
    }
    var localWidgets = /* @__PURE__ */ new Map();
    return {
      $$type: "ais.dynamicWidgets",
      init: function init(initOptions) {
        widgets.forEach(function(widget) {
          var attribute = getWidgetAttribute(widget, initOptions);
          localWidgets.set(attribute, {
            widget,
            isMounted: false
          });
        });
        renderFn(_objectSpread28(_objectSpread28({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: initOptions.instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var parent = renderOptions.parent;
        var renderState = this.getWidgetRenderState(renderOptions);
        var widgetsToUnmount = [];
        var widgetsToMount = [];
        if (fallbackWidget) {
          renderState.attributesToRender.forEach(function(attribute) {
            if (!localWidgets.has(attribute)) {
              var widget = fallbackWidget({
                attribute
              });
              localWidgets.set(attribute, {
                widget,
                isMounted: false
              });
            }
          });
        }
        localWidgets.forEach(function(_ref9, attribute) {
          var widget = _ref9.widget, isMounted = _ref9.isMounted;
          var shouldMount = renderState.attributesToRender.indexOf(attribute) > -1;
          if (!isMounted && shouldMount) {
            widgetsToMount.push(widget);
            localWidgets.set(attribute, {
              widget,
              isMounted: true
            });
          } else if (isMounted && !shouldMount) {
            widgetsToUnmount.push(widget);
            localWidgets.set(attribute, {
              widget,
              isMounted: false
            });
          }
        });
        parent.addWidgets(widgetsToMount);
        setTimeout(function() {
          return parent.removeWidgets(widgetsToUnmount);
        }, 0);
        renderFn(_objectSpread28(_objectSpread28({}, renderState), {}, {
          instantSearchInstance: renderOptions.instantSearchInstance
        }), false);
      },
      dispose: function dispose(_ref23) {
        var parent = _ref23.parent;
        var toRemove = [];
        localWidgets.forEach(function(_ref33) {
          var widget = _ref33.widget, isMounted = _ref33.isMounted;
          if (isMounted) {
            toRemove.push(widget);
          }
        });
        parent.removeWidgets(toRemove);
        unmountFn();
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(state) {
        return facets.reduce(function(acc, curr) {
          return acc.addFacet(curr);
        }, state.setQueryParameters({
          maxValuesPerFacet: Math.max(maxValuesPerFacet || 0, state.maxValuesPerFacet || 0)
        }));
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return _objectSpread28(_objectSpread28({}, renderState), {}, {
          dynamicWidgets: this.getWidgetRenderState(renderOptions)
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref44) {
        var _results$renderingCon, _results$renderingCon2, _results$renderingCon3, _results$renderingCon4;
        var results = _ref44.results, state = _ref44.state;
        if (!results) {
          return {
            attributesToRender: [],
            widgetParams
          };
        }
        var attributesToRender = transformItems((_results$renderingCon = (_results$renderingCon2 = results.renderingContent) === null || _results$renderingCon2 === void 0 ? void 0 : (_results$renderingCon3 = _results$renderingCon2.facetOrdering) === null || _results$renderingCon3 === void 0 ? void 0 : (_results$renderingCon4 = _results$renderingCon3.facets) === null || _results$renderingCon4 === void 0 ? void 0 : _results$renderingCon4.order) !== null && _results$renderingCon !== void 0 ? _results$renderingCon : [], {
          results
        });
        if (!Array.isArray(attributesToRender)) {
          throw new Error(withUsage5("The `transformItems` option expects a function that returns an Array."));
        }
        false ? _warning(maxValuesPerFacet >= (state.maxValuesPerFacet || 0), "The maxValuesPerFacet set by dynamic widgets (".concat(maxValuesPerFacet, ") is smaller than one of the limits set by a widget (").concat(state.maxValuesPerFacet, "). This causes a mismatch in query parameters and thus an extra network request when that widget is mounted.")) : void 0;
        false ? _warning(attributesToRender.length <= MAX_WILDCARD_FACETS || widgetParams.facets !== void 0, "More than ".concat(MAX_WILDCARD_FACETS, " facets are requested to be displayed without explicitly setting which facets to retrieve. This could have a performance impact. Set \"facets\" to [] to do two smaller network requests, or explicitly to ['*'] to avoid this warning.")) : void 0;
        return {
          attributesToRender,
          widgetParams
        };
      }
    };
  };
};
var connectDynamicWidgets_default = connectDynamicWidgets;

// node_modules/instantsearch.js/es/widgets/dynamic-widgets/dynamic-widgets.js
function _typeof18(o4) {
  "@babel/helpers - typeof";
  return _typeof18 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof18(o4);
}
var _excluded27 = ["container", "widgets", "fallbackWidget"];
function ownKeys29(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread29(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys29(Object(t4), true).forEach(function(r4) {
      _defineProperty18(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys29(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty18(obj, key2, value) {
  key2 = _toPropertyKey17(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey17(t4) {
  var i4 = _toPrimitive17(t4, "string");
  return "symbol" == _typeof18(i4) ? i4 : String(i4);
}
function _toPrimitive17(t4, r3) {
  if ("object" != _typeof18(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof18(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _objectWithoutProperties10(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose10(source, excluded);
  var key2, i4;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i4 = 0; i4 < sourceSymbolKeys.length; i4++) {
      key2 = sourceSymbolKeys[i4];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose10(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i4;
  for (i4 = 0; i4 < sourceKeys.length; i4++) {
    key2 = sourceKeys[i4];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
var withUsage6 = createDocumentationMessageGenerator({
  name: "dynamic-widgets"
});
var suit2 = component("DynamicWidgets");
function createContainer(rootContainer) {
  var container = document.createElement("div");
  container.className = suit2({
    descendantName: "widget"
  });
  rootContainer.appendChild(container);
  return container;
}
var dynamicWidgets = function dynamicWidgets2(widgetParams) {
  var _ref9 = widgetParams || {}, containerSelector = _ref9.container, widgets = _ref9.widgets, fallbackWidget = _ref9.fallbackWidget, otherWidgetParams = _objectWithoutProperties10(_ref9, _excluded27);
  if (!containerSelector) {
    throw new Error(withUsage6("The `container` option is required."));
  }
  if (!(widgets && Array.isArray(widgets) && widgets.every(function(widget2) {
    return typeof widget2 === "function";
  }))) {
    throw new Error(withUsage6("The `widgets` option expects an array of callbacks."));
  }
  var userContainer = getContainerNode(containerSelector);
  var rootContainer = document.createElement("div");
  rootContainer.className = suit2();
  var containers = /* @__PURE__ */ new Map();
  var connectorWidgets = [];
  var makeWidget = connectDynamicWidgets_default(function(_ref23, isFirstRender) {
    var attributesToRender = _ref23.attributesToRender;
    if (isFirstRender) {
      userContainer.appendChild(rootContainer);
    }
    attributesToRender.forEach(function(attribute) {
      if (!containers.has(attribute)) {
        return;
      }
      var container = containers.get(attribute);
      rootContainer.appendChild(container);
    });
  }, function() {
    userContainer.removeChild(rootContainer);
  });
  var widget = makeWidget(_objectSpread29(_objectSpread29({}, otherWidgetParams), {}, {
    widgets: connectorWidgets,
    fallbackWidget: typeof fallbackWidget === "function" ? function(_ref33) {
      var attribute = _ref33.attribute;
      var container = createContainer(rootContainer);
      containers.set(attribute, container);
      return fallbackWidget({
        attribute,
        container
      });
    } : void 0
  }));
  return _objectSpread29(_objectSpread29({}, widget), {}, {
    init: function init(initOptions) {
      widgets.forEach(function(cb) {
        var container = createContainer(rootContainer);
        var childWidget = cb(container);
        var attribute = getWidgetAttribute(childWidget, initOptions);
        containers.set(attribute, container);
        connectorWidgets.push(childWidget);
      });
      widget.init(initOptions);
    },
    $$widgetType: "ais.dynamicWidgets"
  });
};
var dynamic_widgets_default = dynamicWidgets;

// node_modules/instantsearch.js/es/widgets/analytics/analytics.js
function _typeof19(o4) {
  "@babel/helpers - typeof";
  return _typeof19 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof19(o4);
}
function ownKeys30(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread30(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys30(Object(t4), true).forEach(function(r4) {
      _defineProperty19(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys30(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty19(obj, key2, value) {
  key2 = _toPropertyKey18(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey18(t4) {
  var i4 = _toPrimitive18(t4, "string");
  return "symbol" == _typeof19(i4) ? i4 : String(i4);
}
function _toPrimitive18(t4, r3) {
  if ("object" != _typeof19(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof19(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage7 = createDocumentationMessageGenerator({
  name: "analytics"
});
var analytics = function analytics2(widgetParams) {
  var _ref9 = widgetParams || {}, pushFunction = _ref9.pushFunction, _ref$delay = _ref9.delay, delay2 = _ref$delay === void 0 ? 3e3 : _ref$delay, _ref$triggerOnUIInter = _ref9.triggerOnUIInteraction, triggerOnUIInteraction = _ref$triggerOnUIInter === void 0 ? false : _ref$triggerOnUIInter, _ref$pushInitialSearc = _ref9.pushInitialSearch, pushInitialSearch = _ref$pushInitialSearc === void 0 ? true : _ref$pushInitialSearc, _ref$pushPagination = _ref9.pushPagination, pushPagination = _ref$pushPagination === void 0 ? false : _ref$pushPagination;
  if (!pushFunction) {
    throw new Error(withUsage7("The `pushFunction` option is required."));
  }
  false ? _warning(false, "`analytics` widget has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `insights` middleware.\n\nFor the migration, visit https://www.algolia.com/doc/guides/building-search-ui/upgrade-guides/js/#analytics-widget") : void 0;
  var cachedState = null;
  var serializeRefinements = function serializeRefinements2(parameters) {
    var refinements = [];
    for (var parameter in parameters) {
      if (parameters.hasOwnProperty(parameter)) {
        var values = parameters[parameter].join("+");
        refinements.push("".concat(encodeURIComponent(parameter), "=").concat(encodeURIComponent(parameter), "_").concat(encodeURIComponent(values)));
      }
    }
    return refinements.join("&");
  };
  var serializeNumericRefinements = function serializeNumericRefinements2(numericRefinements) {
    var refinements = [];
    for (var attribute in numericRefinements) {
      if (numericRefinements.hasOwnProperty(attribute)) {
        var filter2 = numericRefinements[attribute];
        if (filter2.hasOwnProperty(">=") && filter2.hasOwnProperty("<=")) {
          if (filter2[">="] && filter2[">="][0] === filter2["<="] && filter2["<="][0]) {
            refinements.push("".concat(attribute, "=").concat(attribute, "_").concat(filter2[">="]));
          } else {
            refinements.push("".concat(attribute, "=").concat(attribute, "_").concat(filter2[">="], "to").concat(filter2["<="]));
          }
        } else if (filter2.hasOwnProperty(">=")) {
          refinements.push("".concat(attribute, "=").concat(attribute, "_from").concat(filter2[">="]));
        } else if (filter2.hasOwnProperty("<=")) {
          refinements.push("".concat(attribute, "=").concat(attribute, "_to").concat(filter2["<="]));
        } else if (filter2.hasOwnProperty("=")) {
          var equals = [];
          for (var equal in filter2["="]) {
            if (filter2["="].hasOwnProperty(equal)) {
              equals.push(filter2["="][equal]);
            }
          }
          refinements.push("".concat(attribute, "=").concat(attribute, "_").concat(equals.join("-")));
        }
      }
    }
    return refinements.join("&");
  };
  var lastSentData = "";
  var sendAnalytics = function sendAnalytics2(analyticsState) {
    if (analyticsState === null) {
      return;
    }
    var serializedParams = [];
    var serializedRefinements = serializeRefinements(_objectSpread30(_objectSpread30(_objectSpread30({}, analyticsState.state.disjunctiveFacetsRefinements), analyticsState.state.facetsRefinements), analyticsState.state.hierarchicalFacetsRefinements));
    var serializedNumericRefinements = serializeNumericRefinements(analyticsState.state.numericRefinements);
    if (serializedRefinements !== "") {
      serializedParams.push(serializedRefinements);
    }
    if (serializedNumericRefinements !== "") {
      serializedParams.push(serializedNumericRefinements);
    }
    var stringifiedParams = serializedParams.join("&");
    var dataToSend = "Query: ".concat(analyticsState.state.query || "", ", ").concat(stringifiedParams);
    if (pushPagination === true) {
      dataToSend += ", Page: ".concat(analyticsState.state.page || 0);
    }
    if (lastSentData !== dataToSend) {
      pushFunction(stringifiedParams, analyticsState.state, analyticsState.results);
      lastSentData = dataToSend;
    }
  };
  var pushTimeout;
  var isInitialSearch = true;
  if (pushInitialSearch === true) {
    isInitialSearch = false;
  }
  var onClick = function onClick2() {
    sendAnalytics(cachedState);
  };
  var onUnload = function onUnload2() {
    sendAnalytics(cachedState);
  };
  return {
    $$type: "ais.analytics",
    $$widgetType: "ais.analytics",
    init: function init() {
      if (triggerOnUIInteraction === true) {
        document.addEventListener("click", onClick);
        window.addEventListener("beforeunload", onUnload);
      }
    },
    render: function render(_ref23) {
      var results = _ref23.results, state = _ref23.state;
      if (!results) {
        return;
      }
      if (isInitialSearch === true) {
        isInitialSearch = false;
        return;
      }
      cachedState = {
        results,
        state
      };
      if (pushTimeout) {
        clearTimeout(pushTimeout);
      }
      pushTimeout = window.setTimeout(function() {
        return sendAnalytics(cachedState);
      }, delay2);
    },
    dispose: function dispose() {
      if (triggerOnUIInteraction === true) {
        document.removeEventListener("click", onClick);
        window.removeEventListener("beforeunload", onUnload);
      }
    },
    getRenderState: function getRenderState(renderState, renderOptions) {
      return _objectSpread30(_objectSpread30({}, renderState), {}, {
        analytics: this.getWidgetRenderState(renderOptions)
      });
    },
    getWidgetRenderState: function getWidgetRenderState() {
      return {
        widgetParams
      };
    }
  };
};
var analytics_default = analytics;

// node_modules/instantsearch.js/es/components/Breadcrumb/Breadcrumb.js
function _extends12() {
  _extends12 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends12.apply(this, arguments);
}
var Breadcrumb = function Breadcrumb2(_ref9) {
  var items = _ref9.items, cssClasses = _ref9.cssClasses, templateProps = _ref9.templateProps, createURL = _ref9.createURL, refine2 = _ref9.refine;
  return y2("div", {
    className: cx(cssClasses.root, items.length === 0 && cssClasses.noRefinementRoot)
  }, y2("ul", {
    className: cssClasses.list
  }, y2("li", {
    className: cx(cssClasses.item, items.length === 0 && cssClasses.selectedItem)
  }, y2(Template_default, _extends12({}, templateProps, {
    templateKey: "home",
    rootTagName: "a",
    rootProps: {
      className: cssClasses.link,
      href: createURL(null),
      onClick: function onClick(event) {
        if (isSpecialClick(event)) {
          return;
        }
        event.preventDefault();
        refine2(null);
      }
    }
  }))), items.map(function(item11, idx) {
    var isLast = idx === items.length - 1;
    return y2("li", {
      key: item11.label + idx,
      className: cx(cssClasses.item, isLast && cssClasses.selectedItem)
    }, y2(Template_default, _extends12({}, templateProps, {
      templateKey: "separator",
      rootTagName: "span",
      rootProps: {
        className: cssClasses.separator,
        "aria-hidden": true
      }
    })), isLast ? item11.label : y2("a", {
      className: cssClasses.link,
      href: createURL(item11.value),
      onClick: function onClick(event) {
        if (isSpecialClick(event)) {
          return;
        }
        event.preventDefault();
        refine2(item11.value);
      }
    }, item11.label));
  })));
};
var Breadcrumb_default = Breadcrumb;

// node_modules/instantsearch.js/es/connectors/breadcrumb/connectBreadcrumb.js
function _typeof20(o4) {
  "@babel/helpers - typeof";
  return _typeof20 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof20(o4);
}
function ownKeys31(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread31(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys31(Object(t4), true).forEach(function(r4) {
      _defineProperty20(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys31(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty20(obj, key2, value) {
  key2 = _toPropertyKey19(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey19(t4) {
  var i4 = _toPrimitive19(t4, "string");
  return "symbol" == _typeof20(i4) ? i4 : String(i4);
}
function _toPrimitive19(t4, r3) {
  if ("object" != _typeof20(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof20(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _slicedToArray5(arr, i4) {
  return _arrayWithHoles5(arr) || _iterableToArrayLimit5(arr, i4) || _unsupportedIterableToArray9(arr, i4) || _nonIterableRest5();
}
function _nonIterableRest5() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray9(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray9(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray9(o4, minLen);
}
function _arrayLikeToArray9(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
function _iterableToArrayLimit5(r3, l4) {
  var t4 = null == r3 ? null : "undefined" != typeof Symbol && r3[Symbol.iterator] || r3["@@iterator"];
  if (null != t4) {
    var e4, n4, i4, u4, a4 = [], f4 = true, o4 = false;
    try {
      if (i4 = (t4 = t4.call(r3)).next, 0 === l4) {
        if (Object(t4) !== t4)
          return;
        f4 = false;
      } else
        for (; !(f4 = (e4 = i4.call(t4)).done) && (a4.push(e4.value), a4.length !== l4); f4 = true)
          ;
    } catch (r4) {
      o4 = true, n4 = r4;
    } finally {
      try {
        if (!f4 && null != t4.return && (u4 = t4.return(), Object(u4) !== u4))
          return;
      } finally {
        if (o4)
          throw n4;
      }
    }
    return a4;
  }
}
function _arrayWithHoles5(arr) {
  if (Array.isArray(arr))
    return arr;
}
var withUsage8 = createDocumentationMessageGenerator({
  name: "breadcrumb",
  connector: true
});
var connectBreadcrumb = function connectBreadcrumb2(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage8());
  var connectorState = {};
  return function(widgetParams) {
    var _ref9 = widgetParams || {}, attributes = _ref9.attributes, _ref$separator = _ref9.separator, separator2 = _ref$separator === void 0 ? " > " : _ref$separator, _ref$rootPath = _ref9.rootPath, rootPath = _ref$rootPath === void 0 ? null : _ref$rootPath, _ref$transformItems = _ref9.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
      return items;
    } : _ref$transformItems;
    if (!attributes || !Array.isArray(attributes) || attributes.length === 0) {
      throw new Error(withUsage8("The `attributes` option expects an array of strings."));
    }
    var _attributes = _slicedToArray5(attributes, 1), hierarchicalFacetName = _attributes[0];
    function getRefinedState2(state, facetValue) {
      if (!facetValue) {
        var breadcrumb3 = state.getHierarchicalFacetBreadcrumb(hierarchicalFacetName);
        if (breadcrumb3.length === 0) {
          return state;
        } else {
          return state.resetPage().toggleFacetRefinement(hierarchicalFacetName, breadcrumb3[0]);
        }
      }
      return state.resetPage().toggleFacetRefinement(hierarchicalFacetName, facetValue);
    }
    return {
      $$type: "ais.breadcrumb",
      init: function init(initOptions) {
        renderFn(_objectSpread31(_objectSpread31({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: initOptions.instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        renderFn(_objectSpread31(_objectSpread31({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: renderOptions.instantSearchInstance
        }), false);
      },
      dispose: function dispose() {
        unmountFn();
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return _objectSpread31(_objectSpread31({}, renderState), {}, {
          breadcrumb: _objectSpread31(_objectSpread31({}, renderState.breadcrumb), {}, _defineProperty20({}, hierarchicalFacetName, this.getWidgetRenderState(renderOptions)))
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref23) {
        var _this = this;
        var helper = _ref23.helper, createURL = _ref23.createURL, results = _ref23.results, state = _ref23.state;
        function getItems() {
          if (!results || state.hierarchicalFacets.length === 0) {
            return [];
          }
          var facetValues = results.getFacetValues(hierarchicalFacetName, {});
          var facetItems = facetValues && !Array.isArray(facetValues) && facetValues.data ? facetValues.data : [];
          var items2 = transformItems(shiftItemsValues(prepareItems(facetItems)), {
            results
          });
          return items2;
        }
        var items = getItems();
        if (!connectorState.createURL) {
          connectorState.createURL = function(facetValue) {
            return createURL(function(uiState) {
              return _this.getWidgetUiState(uiState, {
                searchParameters: getRefinedState2(helper.state, facetValue),
                helper
              });
            });
          };
        }
        if (!connectorState.refine) {
          connectorState.refine = function(facetValue) {
            helper.setState(getRefinedState2(helper.state, facetValue)).search();
          };
        }
        return {
          canRefine: items.length > 0,
          createURL: connectorState.createURL,
          items,
          refine: connectorState.refine,
          widgetParams
        };
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref33) {
        var searchParameters = _ref33.searchParameters;
        var path = searchParameters.getHierarchicalFacetBreadcrumb(hierarchicalFacetName);
        return removeEmptyRefinementsFromUiState(_objectSpread31(_objectSpread31({}, uiState), {}, {
          hierarchicalMenu: _objectSpread31(_objectSpread31({}, uiState.hierarchicalMenu), {}, _defineProperty20({}, hierarchicalFacetName, path))
        }), hierarchicalFacetName);
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref44) {
        var uiState = _ref44.uiState;
        var values = uiState.hierarchicalMenu && uiState.hierarchicalMenu[hierarchicalFacetName];
        if (searchParameters.isConjunctiveFacet(hierarchicalFacetName) || searchParameters.isDisjunctiveFacet(hierarchicalFacetName)) {
          false ? _warning(false, 'HierarchicalMenu: Attribute "'.concat(hierarchicalFacetName, '" is already used by another widget applying conjunctive or disjunctive faceting.\nAs this is not supported, please make sure to remove this other widget or this HierarchicalMenu widget will not work at all.')) : void 0;
          return searchParameters;
        }
        if (searchParameters.isHierarchicalFacet(hierarchicalFacetName)) {
          var facet = searchParameters.getHierarchicalFacetByName(hierarchicalFacetName);
          false ? _warning(isEqual(facet.attributes, attributes) && facet.separator === separator2 && facet.rootPath === rootPath, "Using Breadcrumb and HierarchicalMenu on the same facet with different options overrides the configuration of the HierarchicalMenu.") : void 0;
        }
        var withFacetConfiguration = searchParameters.removeHierarchicalFacet(hierarchicalFacetName).addHierarchicalFacet({
          name: hierarchicalFacetName,
          attributes,
          separator: separator2,
          rootPath
        });
        if (!values) {
          return withFacetConfiguration.setQueryParameters({
            hierarchicalFacetsRefinements: _objectSpread31(_objectSpread31({}, withFacetConfiguration.hierarchicalFacetsRefinements), {}, _defineProperty20({}, hierarchicalFacetName, []))
          });
        }
        return withFacetConfiguration.addHierarchicalFacetRefinement(hierarchicalFacetName, values.join(separator2));
      }
    };
  };
};
function prepareItems(data) {
  return data.reduce(function(result, currentItem) {
    if (currentItem.isRefined) {
      result.push({
        label: currentItem.name,
        value: currentItem.escapedValue
      });
      if (Array.isArray(currentItem.data)) {
        result = result.concat(prepareItems(currentItem.data));
      }
    }
    return result;
  }, []);
}
function shiftItemsValues(array2) {
  return array2.map(function(x4, idx) {
    return {
      label: x4.label,
      value: idx + 1 === array2.length ? null : array2[idx + 1].value
    };
  });
}
function removeEmptyRefinementsFromUiState(indexUiState, attribute) {
  if (!indexUiState.hierarchicalMenu) {
    return indexUiState;
  }
  if (!indexUiState.hierarchicalMenu[attribute] || !indexUiState.hierarchicalMenu[attribute].length) {
    delete indexUiState.hierarchicalMenu[attribute];
  }
  if (Object.keys(indexUiState.hierarchicalMenu).length === 0) {
    delete indexUiState.hierarchicalMenu;
  }
  return indexUiState;
}
var connectBreadcrumb_default = connectBreadcrumb;

// node_modules/instantsearch.js/es/widgets/breadcrumb/defaultTemplates.js
var defaultTemplates2 = {
  home: function home() {
    return "Home";
  },
  separator: function separator() {
    return ">";
  }
};
var defaultTemplates_default2 = defaultTemplates2;

// node_modules/instantsearch.js/es/widgets/breadcrumb/breadcrumb.js
function _typeof21(o4) {
  "@babel/helpers - typeof";
  return _typeof21 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof21(o4);
}
function ownKeys32(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread32(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys32(Object(t4), true).forEach(function(r4) {
      _defineProperty21(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys32(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty21(obj, key2, value) {
  key2 = _toPropertyKey20(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey20(t4) {
  var i4 = _toPrimitive20(t4, "string");
  return "symbol" == _typeof21(i4) ? i4 : String(i4);
}
function _toPrimitive20(t4, r3) {
  if ("object" != _typeof21(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof21(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage9 = createDocumentationMessageGenerator({
  name: "breadcrumb"
});
var suit3 = component("Breadcrumb");
var renderer3 = function renderer4(_ref9) {
  var containerNode = _ref9.containerNode, cssClasses = _ref9.cssClasses, renderState = _ref9.renderState, templates = _ref9.templates;
  return function(_ref23, isFirstRendering) {
    var canRefine = _ref23.canRefine, createURL = _ref23.createURL, instantSearchInstance = _ref23.instantSearchInstance, items = _ref23.items, refine2 = _ref23.refine;
    if (isFirstRendering) {
      renderState.templateProps = prepareTemplateProps({
        defaultTemplates: defaultTemplates_default2,
        templatesConfig: instantSearchInstance.templatesConfig,
        templates
      });
      return;
    }
    N2(y2(Breadcrumb_default, {
      canRefine,
      cssClasses,
      createURL,
      items,
      refine: refine2,
      templateProps: renderState.templateProps
    }), containerNode);
  };
};
var breadcrumb = function breadcrumb2(widgetParams) {
  var _ref33 = widgetParams || {}, container = _ref33.container, attributes = _ref33.attributes, separator2 = _ref33.separator, rootPath = _ref33.rootPath, transformItems = _ref33.transformItems, _ref3$templates = _ref33.templates, templates = _ref3$templates === void 0 ? {} : _ref3$templates, _ref3$cssClasses = _ref33.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses;
  if (!container) {
    throw new Error(withUsage9("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var cssClasses = {
    root: cx(suit3(), userCssClasses.root),
    noRefinementRoot: cx(suit3({
      modifierName: "noRefinement"
    }), userCssClasses.noRefinementRoot),
    list: cx(suit3({
      descendantName: "list"
    }), userCssClasses.list),
    item: cx(suit3({
      descendantName: "item"
    }), userCssClasses.item),
    selectedItem: cx(suit3({
      descendantName: "item",
      modifierName: "selected"
    }), userCssClasses.selectedItem),
    separator: cx(suit3({
      descendantName: "separator"
    }), userCssClasses.separator),
    link: cx(suit3({
      descendantName: "link"
    }), userCssClasses.link)
  };
  var specializedRenderer = renderer3({
    containerNode,
    cssClasses,
    renderState: {},
    templates
  });
  var makeWidget = connectBreadcrumb_default(specializedRenderer, function() {
    return N2(null, containerNode);
  });
  return _objectSpread32(_objectSpread32({}, makeWidget({
    attributes,
    separator: separator2,
    rootPath,
    transformItems
  })), {}, {
    $$widgetType: "ais.breadcrumb"
  });
};
var breadcrumb_default = breadcrumb;

// node_modules/instantsearch.js/es/components/ClearRefinements/ClearRefinements.js
function _extends13() {
  _extends13 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends13.apply(this, arguments);
}
var ClearRefinements = function ClearRefinements2(_ref9) {
  var hasRefinements = _ref9.hasRefinements, refine2 = _ref9.refine, cssClasses = _ref9.cssClasses, templateProps = _ref9.templateProps;
  return y2("div", {
    className: cssClasses.root
  }, y2(Template_default, _extends13({}, templateProps, {
    templateKey: "resetLabel",
    rootTagName: "button",
    rootProps: {
      className: cx(cssClasses.button, !hasRefinements && cssClasses.disabledButton),
      onClick: refine2,
      disabled: !hasRefinements
    },
    data: {
      hasRefinements
    }
  })));
};
var ClearRefinements_default = ClearRefinements;

// node_modules/instantsearch.js/es/connectors/clear-refinements/connectClearRefinements.js
function _typeof22(o4) {
  "@babel/helpers - typeof";
  return _typeof22 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof22(o4);
}
function _toConsumableArray6(arr) {
  return _arrayWithoutHoles6(arr) || _iterableToArray6(arr) || _unsupportedIterableToArray10(arr) || _nonIterableSpread6();
}
function _nonIterableSpread6() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray10(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray10(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray10(o4, minLen);
}
function _iterableToArray6(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles6(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray10(arr);
}
function _arrayLikeToArray10(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
function ownKeys33(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread33(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys33(Object(t4), true).forEach(function(r4) {
      _defineProperty22(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys33(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty22(obj, key2, value) {
  key2 = _toPropertyKey21(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey21(t4) {
  var i4 = _toPrimitive21(t4, "string");
  return "symbol" == _typeof22(i4) ? i4 : String(i4);
}
function _toPrimitive21(t4, r3) {
  if ("object" != _typeof22(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof22(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage10 = createDocumentationMessageGenerator({
  name: "clear-refinements",
  connector: true
});
var connectClearRefinements = function connectClearRefinements2(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage10());
  return function(widgetParams) {
    var _ref9 = widgetParams || {}, _ref$includedAttribut = _ref9.includedAttributes, includedAttributes = _ref$includedAttribut === void 0 ? [] : _ref$includedAttribut, _ref$excludedAttribut = _ref9.excludedAttributes, excludedAttributes = _ref$excludedAttribut === void 0 ? ["query"] : _ref$excludedAttribut, _ref$transformItems = _ref9.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
      return items;
    } : _ref$transformItems;
    if (widgetParams && widgetParams.includedAttributes && widgetParams.excludedAttributes) {
      throw new Error(withUsage10("The options `includedAttributes` and `excludedAttributes` cannot be used together."));
    }
    var connectorState = {
      refine: noop,
      createURL: function createURL() {
        return "";
      },
      attributesToClear: []
    };
    var cachedRefine = function cachedRefine2() {
      return connectorState.refine();
    };
    var cachedCreateURL = function cachedCreateURL2() {
      return connectorState.createURL();
    };
    return {
      $$type: "ais.clearRefinements",
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(_objectSpread33(_objectSpread33({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(_objectSpread33(_objectSpread33({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance
        }), false);
      },
      dispose: function dispose() {
        unmountFn();
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return _objectSpread33(_objectSpread33({}, renderState), {}, {
          clearRefinements: this.getWidgetRenderState(renderOptions)
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref23) {
        var createURL = _ref23.createURL, scopedResults = _ref23.scopedResults, results = _ref23.results;
        connectorState.attributesToClear = scopedResults.reduce(function(attributesToClear, scopedResult) {
          return attributesToClear.concat(getAttributesToClear({
            scopedResult,
            includedAttributes,
            excludedAttributes,
            transformItems,
            results
          }));
        }, []);
        connectorState.refine = function() {
          connectorState.attributesToClear.forEach(function(_ref33) {
            var indexHelper = _ref33.helper, items = _ref33.items;
            indexHelper.setState(clearRefinements({
              helper: indexHelper,
              attributesToClear: items
            })).search();
          });
        };
        connectorState.createURL = function() {
          return createURL(mergeSearchParameters.apply(void 0, _toConsumableArray6(connectorState.attributesToClear.map(function(_ref44) {
            var indexHelper = _ref44.helper, items = _ref44.items;
            return clearRefinements({
              helper: indexHelper,
              attributesToClear: items
            });
          }))));
        };
        var canRefine = connectorState.attributesToClear.some(function(attributeToClear) {
          return attributeToClear.items.length > 0;
        });
        return {
          canRefine,
          hasRefinements: canRefine,
          refine: cachedRefine,
          createURL: cachedCreateURL,
          widgetParams
        };
      }
    };
  };
};
function getAttributesToClear(_ref52) {
  var scopedResult = _ref52.scopedResult, includedAttributes = _ref52.includedAttributes, excludedAttributes = _ref52.excludedAttributes, transformItems = _ref52.transformItems, results = _ref52.results;
  var includesQuery = includedAttributes.indexOf("query") !== -1 || excludedAttributes.indexOf("query") === -1;
  return {
    helper: scopedResult.helper,
    items: transformItems(uniq(getRefinements(scopedResult.results, scopedResult.helper.state, includesQuery).map(function(refinement) {
      return refinement.attribute;
    }).filter(function(attribute) {
      return (
        // If the array is empty (default case), we keep all the attributes
        includedAttributes.length === 0 || // Otherwise, only add the specified attributes
        includedAttributes.indexOf(attribute) !== -1
      );
    }).filter(function(attribute) {
      return (
        // If the query is included, we ignore the default `excludedAttributes = ['query']`
        attribute === "query" && includesQuery || // Otherwise, ignore the excluded attributes
        excludedAttributes.indexOf(attribute) === -1
      );
    })), {
      results
    })
  };
}
var connectClearRefinements_default = connectClearRefinements;

// node_modules/instantsearch.js/es/widgets/clear-refinements/defaultTemplates.js
var defaultTemplates3 = {
  resetLabel: function resetLabel() {
    return "Clear refinements";
  }
};
var defaultTemplates_default3 = defaultTemplates3;

// node_modules/instantsearch.js/es/widgets/clear-refinements/clear-refinements.js
function _typeof23(o4) {
  "@babel/helpers - typeof";
  return _typeof23 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof23(o4);
}
function ownKeys34(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread34(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys34(Object(t4), true).forEach(function(r4) {
      _defineProperty23(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys34(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty23(obj, key2, value) {
  key2 = _toPropertyKey22(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey22(t4) {
  var i4 = _toPrimitive22(t4, "string");
  return "symbol" == _typeof23(i4) ? i4 : String(i4);
}
function _toPrimitive22(t4, r3) {
  if ("object" != _typeof23(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof23(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage11 = createDocumentationMessageGenerator({
  name: "clear-refinements"
});
var suit4 = component("ClearRefinements");
var renderer5 = function renderer6(_ref9) {
  var containerNode = _ref9.containerNode, cssClasses = _ref9.cssClasses, renderState = _ref9.renderState, templates = _ref9.templates;
  return function(_ref23, isFirstRendering) {
    var refine2 = _ref23.refine, canRefine = _ref23.canRefine, instantSearchInstance = _ref23.instantSearchInstance;
    if (isFirstRendering) {
      renderState.templateProps = prepareTemplateProps({
        defaultTemplates: defaultTemplates_default3,
        templatesConfig: instantSearchInstance.templatesConfig,
        templates
      });
      return;
    }
    N2(y2(ClearRefinements_default, {
      refine: refine2,
      cssClasses,
      hasRefinements: canRefine,
      templateProps: renderState.templateProps
    }), containerNode);
  };
};
var clearRefinements2 = function clearRefinements3(widgetParams) {
  var _ref33 = widgetParams || {}, container = _ref33.container, _ref3$templates = _ref33.templates, templates = _ref3$templates === void 0 ? {} : _ref3$templates, includedAttributes = _ref33.includedAttributes, excludedAttributes = _ref33.excludedAttributes, transformItems = _ref33.transformItems, _ref3$cssClasses = _ref33.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses;
  if (!container) {
    throw new Error(withUsage11("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var cssClasses = {
    root: cx(suit4(), userCssClasses.root),
    button: cx(suit4({
      descendantName: "button"
    }), userCssClasses.button),
    disabledButton: cx(suit4({
      descendantName: "button",
      modifierName: "disabled"
    }), userCssClasses.disabledButton)
  };
  var specializedRenderer = renderer5({
    containerNode,
    cssClasses,
    renderState: {},
    templates
  });
  var makeWidget = connectClearRefinements_default(specializedRenderer, function() {
    return N2(null, containerNode);
  });
  return _objectSpread34(_objectSpread34({}, makeWidget({
    includedAttributes,
    excludedAttributes,
    transformItems
  })), {}, {
    $$widgetType: "ais.clearRefinements"
  });
};
var clear_refinements_default = clearRefinements2;

// node_modules/instantsearch.js/es/widgets/configure/configure.js
function _typeof24(o4) {
  "@babel/helpers - typeof";
  return _typeof24 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof24(o4);
}
function ownKeys35(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread35(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys35(Object(t4), true).forEach(function(r4) {
      _defineProperty24(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys35(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty24(obj, key2, value) {
  key2 = _toPropertyKey23(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey23(t4) {
  var i4 = _toPrimitive23(t4, "string");
  return "symbol" == _typeof24(i4) ? i4 : String(i4);
}
function _toPrimitive23(t4, r3) {
  if ("object" != _typeof24(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof24(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var configure = function configure2(widgetParams) {
  var makeWidget = connectConfigure_default(noop);
  return _objectSpread35(_objectSpread35({}, makeWidget({
    searchParameters: widgetParams
  })), {}, {
    $$widgetType: "ais.configure"
  });
};
var configure_default = configure;

// node_modules/instantsearch.js/es/components/CurrentRefinements/CurrentRefinements.js
var createItemKey = function createItemKey2(_ref9) {
  var attribute = _ref9.attribute, value = _ref9.value, type = _ref9.type, operator = _ref9.operator;
  return [attribute, type, value, operator].map(function(key2) {
    return key2;
  }).filter(Boolean).join(":");
};
var handleClick = function handleClick2(callback) {
  return function(event) {
    if (isSpecialClick(event)) {
      return;
    }
    event.preventDefault();
    callback();
  };
};
var CurrentRefinements = function CurrentRefinements2(_ref23) {
  var items = _ref23.items, cssClasses = _ref23.cssClasses, canRefine = _ref23.canRefine;
  return y2("div", {
    className: cx(cssClasses.root, !canRefine && cssClasses.noRefinementRoot)
  }, y2("ul", {
    className: cssClasses.list
  }, items.map(function(item11, index) {
    return y2("li", {
      key: "".concat(item11.indexName, "-").concat(item11.attribute, "-").concat(index),
      className: cssClasses.item
    }, y2("span", {
      className: cssClasses.label
    }, capitalize(item11.label), ": "), item11.refinements.map(function(refinement) {
      return y2("span", {
        key: createItemKey(refinement),
        className: cssClasses.category
      }, y2("span", {
        className: cssClasses.categoryLabel
      }, refinement.attribute === "query" ? y2("q", null, refinement.label) : refinement.label), y2("button", {
        className: cssClasses.delete,
        type: "button",
        onClick: handleClick(item11.refine.bind(null, refinement))
      }, "✕"));
    }));
  })));
};
var CurrentRefinements_default = CurrentRefinements;

// node_modules/instantsearch.js/es/connectors/current-refinements/connectCurrentRefinements.js
function _typeof25(o4) {
  "@babel/helpers - typeof";
  return _typeof25 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof25(o4);
}
function _toConsumableArray7(arr) {
  return _arrayWithoutHoles7(arr) || _iterableToArray7(arr) || _unsupportedIterableToArray11(arr) || _nonIterableSpread7();
}
function _nonIterableSpread7() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray11(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray11(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray11(o4, minLen);
}
function _iterableToArray7(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles7(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray11(arr);
}
function _arrayLikeToArray11(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
function ownKeys36(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread36(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys36(Object(t4), true).forEach(function(r4) {
      _defineProperty25(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys36(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty25(obj, key2, value) {
  key2 = _toPropertyKey24(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey24(t4) {
  var i4 = _toPrimitive24(t4, "string");
  return "symbol" == _typeof25(i4) ? i4 : String(i4);
}
function _toPrimitive24(t4, r3) {
  if ("object" != _typeof25(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof25(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage12 = createDocumentationMessageGenerator({
  name: "current-refinements",
  connector: true
});
var connectCurrentRefinements = function connectCurrentRefinements2(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage12());
  return function(widgetParams) {
    if ((widgetParams || {}).includedAttributes && (widgetParams || {}).excludedAttributes) {
      throw new Error(withUsage12("The options `includedAttributes` and `excludedAttributes` cannot be used together."));
    }
    var _ref9 = widgetParams || {}, includedAttributes = _ref9.includedAttributes, _ref$excludedAttribut = _ref9.excludedAttributes, excludedAttributes = _ref$excludedAttribut === void 0 ? ["query"] : _ref$excludedAttribut, _ref$transformItems = _ref9.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
      return items;
    } : _ref$transformItems;
    return {
      $$type: "ais.currentRefinements",
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(_objectSpread36(_objectSpread36({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(_objectSpread36(_objectSpread36({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance
        }), false);
      },
      dispose: function dispose() {
        unmountFn();
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return _objectSpread36(_objectSpread36({}, renderState), {}, {
          currentRefinements: this.getWidgetRenderState(renderOptions)
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref23) {
        var results = _ref23.results, scopedResults = _ref23.scopedResults, _createURL = _ref23.createURL, helper = _ref23.helper;
        function getItems() {
          if (!results) {
            return transformItems(getRefinementsItems({
              results: null,
              helper,
              indexId: helper.state.index,
              includedAttributes,
              excludedAttributes
            }), {
              results
            });
          }
          return scopedResults.reduce(function(accResults, scopedResult) {
            return accResults.concat(transformItems(getRefinementsItems({
              results: scopedResult.results,
              helper: scopedResult.helper,
              indexId: scopedResult.indexId,
              includedAttributes,
              excludedAttributes
            }), {
              results
            }));
          }, []);
        }
        var items = getItems();
        return {
          items,
          canRefine: items.length > 0,
          refine: function refine2(refinement) {
            return clearRefinement(helper, refinement);
          },
          createURL: function createURL(refinement) {
            return _createURL(clearRefinementFromState(helper.state, refinement));
          },
          widgetParams
        };
      }
    };
  };
};
function getRefinementsItems(_ref33) {
  var results = _ref33.results, helper = _ref33.helper, indexId = _ref33.indexId, includedAttributes = _ref33.includedAttributes, excludedAttributes = _ref33.excludedAttributes;
  var includesQuery = (includedAttributes || []).indexOf("query") !== -1 || (excludedAttributes || []).indexOf("query") === -1;
  var filterFunction = includedAttributes ? function(item11) {
    return includedAttributes.indexOf(item11.attribute) !== -1;
  } : function(item11) {
    return excludedAttributes.indexOf(item11.attribute) === -1;
  };
  var items = getRefinements(results, helper.state, includesQuery).map(normalizeRefinement).filter(filterFunction);
  return items.reduce(function(allItems, currentItem) {
    return [].concat(_toConsumableArray7(allItems.filter(function(item11) {
      return item11.attribute !== currentItem.attribute;
    })), [{
      indexName: helper.state.index,
      indexId,
      attribute: currentItem.attribute,
      label: currentItem.attribute,
      refinements: items.filter(function(result) {
        return result.attribute === currentItem.attribute;
      }).sort(function(a4, b3) {
        return a4.type === "numeric" ? a4.value - b3.value : 0;
      }),
      refine: function refine2(refinement) {
        return clearRefinement(helper, refinement);
      }
    }]);
  }, []);
}
function clearRefinementFromState(state, refinement) {
  state = state.resetPage();
  switch (refinement.type) {
    case "facet":
      return state.removeFacetRefinement(refinement.attribute, String(refinement.value));
    case "disjunctive":
      return state.removeDisjunctiveFacetRefinement(refinement.attribute, String(refinement.value));
    case "hierarchical":
      return state.removeHierarchicalFacetRefinement(refinement.attribute);
    case "exclude":
      return state.removeExcludeRefinement(refinement.attribute, String(refinement.value));
    case "numeric":
      return state.removeNumericRefinement(refinement.attribute, refinement.operator, String(refinement.value));
    case "tag":
      return state.removeTagRefinement(String(refinement.value));
    case "query":
      return state.setQueryParameter("query", "");
    default:
      false ? _warning(false, 'The refinement type "'.concat(refinement.type, '" does not exist and cannot be cleared from the current refinements.')) : void 0;
      return state;
  }
}
function clearRefinement(helper, refinement) {
  helper.setState(clearRefinementFromState(helper.state, refinement)).search();
}
function getOperatorSymbol(operator) {
  switch (operator) {
    case ">=":
      return "≥";
    case "<=":
      return "≤";
    default:
      return operator;
  }
}
function normalizeRefinement(refinement) {
  var value = getValue(refinement);
  var label = refinement.operator ? "".concat(getOperatorSymbol(refinement.operator), " ").concat(refinement.name) : refinement.name;
  var normalizedRefinement = {
    attribute: refinement.attribute,
    type: refinement.type,
    value,
    label
  };
  if (refinement.operator !== void 0) {
    normalizedRefinement.operator = refinement.operator;
  }
  if (refinement.count !== void 0) {
    normalizedRefinement.count = refinement.count;
  }
  if (refinement.exhaustive !== void 0) {
    normalizedRefinement.exhaustive = refinement.exhaustive;
  }
  return normalizedRefinement;
}
function getValue(refinement) {
  if (refinement.type === "numeric") {
    return Number(refinement.name);
  }
  if ("escapedValue" in refinement) {
    return refinement.escapedValue;
  }
  return refinement.name;
}
var connectCurrentRefinements_default = connectCurrentRefinements;

// node_modules/instantsearch.js/es/widgets/current-refinements/current-refinements.js
function _typeof26(o4) {
  "@babel/helpers - typeof";
  return _typeof26 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof26(o4);
}
function ownKeys37(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread37(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys37(Object(t4), true).forEach(function(r4) {
      _defineProperty26(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys37(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty26(obj, key2, value) {
  key2 = _toPropertyKey25(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey25(t4) {
  var i4 = _toPrimitive25(t4, "string");
  return "symbol" == _typeof26(i4) ? i4 : String(i4);
}
function _toPrimitive25(t4, r3) {
  if ("object" != _typeof26(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof26(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage13 = createDocumentationMessageGenerator({
  name: "current-refinements"
});
var suit5 = component("CurrentRefinements");
var renderer7 = function renderer8(_ref9, isFirstRender) {
  var items = _ref9.items, widgetParams = _ref9.widgetParams, canRefine = _ref9.canRefine;
  if (isFirstRender) {
    return;
  }
  var _ref23 = widgetParams, container = _ref23.container, cssClasses = _ref23.cssClasses;
  N2(y2(CurrentRefinements_default, {
    cssClasses,
    items,
    canRefine
  }), container);
};
var currentRefinements = function currentRefinements2(widgetParams) {
  var _ref33 = widgetParams || {}, container = _ref33.container, includedAttributes = _ref33.includedAttributes, excludedAttributes = _ref33.excludedAttributes, _ref3$cssClasses = _ref33.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses, transformItems = _ref33.transformItems;
  if (!container) {
    throw new Error(withUsage13("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var cssClasses = {
    root: cx(suit5(), userCssClasses.root),
    noRefinementRoot: cx(suit5({
      modifierName: "noRefinement"
    }), userCssClasses.noRefinementRoot),
    list: cx(suit5({
      descendantName: "list"
    }), userCssClasses.list),
    item: cx(suit5({
      descendantName: "item"
    }), userCssClasses.item),
    label: cx(suit5({
      descendantName: "label"
    }), userCssClasses.label),
    category: cx(suit5({
      descendantName: "category"
    }), userCssClasses.category),
    categoryLabel: cx(suit5({
      descendantName: "categoryLabel"
    }), userCssClasses.categoryLabel),
    delete: cx(suit5({
      descendantName: "delete"
    }), userCssClasses.delete)
  };
  var makeWidget = connectCurrentRefinements_default(renderer7, function() {
    return N2(null, containerNode);
  });
  return _objectSpread37(_objectSpread37({}, makeWidget({
    container: containerNode,
    cssClasses,
    includedAttributes,
    excludedAttributes,
    transformItems
  })), {}, {
    $$widgetType: "ais.currentRefinements"
  });
};
var current_refinements_default = currentRefinements;

// node_modules/instantsearch.js/es/connectors/geo-search/connectGeoSearch.js
function _typeof27(o4) {
  "@babel/helpers - typeof";
  return _typeof27 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof27(o4);
}
function ownKeys38(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread38(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys38(Object(t4), true).forEach(function(r4) {
      _defineProperty27(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys38(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty27(obj, key2, value) {
  key2 = _toPropertyKey26(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey26(t4) {
  var i4 = _toPrimitive26(t4, "string");
  return "symbol" == _typeof27(i4) ? i4 : String(i4);
}
function _toPrimitive26(t4, r3) {
  if ("object" != _typeof27(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof27(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage14 = createDocumentationMessageGenerator({
  name: "geo-search",
  connector: true
});
function getBoundingBoxAsString(state) {
  return state.insideBoundingBox || "";
}
function setBoundingBoxAsString(state, value) {
  return state.setQueryParameter("insideBoundingBox", value);
}
var $$type = "ais.geoSearch";
var connectGeoSearch_default = function connectGeoSearch(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage14());
  return function(widgetParams) {
    var _ref9 = widgetParams || {}, _ref$enableRefineOnMa = _ref9.enableRefineOnMapMove, enableRefineOnMapMove = _ref$enableRefineOnMa === void 0 ? true : _ref$enableRefineOnMa, _ref$transformItems = _ref9.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
      return items;
    } : _ref$transformItems;
    var widgetState = {
      isRefineOnMapMove: enableRefineOnMapMove,
      // @MAJOR hasMapMoveSinceLastRefine -> hasMapMovedSinceLastRefine
      hasMapMoveSinceLastRefine: false,
      lastRefinePosition: "",
      lastRefineBoundingBox: "",
      internalToggleRefineOnMapMove: noop,
      internalSetMapMoveSinceLastRefine: noop
    };
    var getPositionFromState = function getPositionFromState2(state) {
      return state.aroundLatLng ? aroundLatLngToPosition(state.aroundLatLng) : void 0;
    };
    var getCurrentRefinementFromState = function getCurrentRefinementFromState2(state) {
      return state.insideBoundingBox && insideBoundingBoxToBoundingBox(state.insideBoundingBox);
    };
    var refine2 = function refine3(helper) {
      return function(_ref23) {
        var ne2 = _ref23.northEast, sw = _ref23.southWest;
        var boundingBox = [ne2.lat, ne2.lng, sw.lat, sw.lng].join();
        helper.setState(setBoundingBoxAsString(helper.state, boundingBox).resetPage()).search();
        widgetState.hasMapMoveSinceLastRefine = false;
        widgetState.lastRefineBoundingBox = boundingBox;
      };
    };
    var clearMapRefinement = function clearMapRefinement2(helper) {
      return function() {
        helper.setQueryParameter("insideBoundingBox", void 0).search();
      };
    };
    var isRefinedWithMap = function isRefinedWithMap2(state) {
      return function() {
        return Boolean(state.insideBoundingBox);
      };
    };
    var toggleRefineOnMapMove = function toggleRefineOnMapMove2() {
      return widgetState.internalToggleRefineOnMapMove();
    };
    var createInternalToggleRefinementOnMapMove = function createInternalToggleRefinementOnMapMove2(renderOptions, render) {
      return function() {
        widgetState.isRefineOnMapMove = !widgetState.isRefineOnMapMove;
        render(renderOptions);
      };
    };
    var isRefineOnMapMove = function isRefineOnMapMove2() {
      return widgetState.isRefineOnMapMove;
    };
    var setMapMoveSinceLastRefine = function setMapMoveSinceLastRefine2() {
      return widgetState.internalSetMapMoveSinceLastRefine();
    };
    var createInternalSetMapMoveSinceLastRefine = function createInternalSetMapMoveSinceLastRefine2(renderOptions, render) {
      return function() {
        var shouldTriggerRender = widgetState.hasMapMoveSinceLastRefine !== true;
        widgetState.hasMapMoveSinceLastRefine = true;
        if (shouldTriggerRender) {
          render(renderOptions);
        }
      };
    };
    var hasMapMoveSinceLastRefine = function hasMapMoveSinceLastRefine2() {
      return widgetState.hasMapMoveSinceLastRefine;
    };
    var sendEvent;
    return {
      $$type,
      init: function init(initArgs) {
        var instantSearchInstance = initArgs.instantSearchInstance;
        var isFirstRendering = true;
        widgetState.internalToggleRefineOnMapMove = createInternalToggleRefinementOnMapMove(initArgs, noop);
        widgetState.internalSetMapMoveSinceLastRefine = createInternalSetMapMoveSinceLastRefine(initArgs, noop);
        renderFn(_objectSpread38(_objectSpread38({}, this.getWidgetRenderState(initArgs)), {}, {
          instantSearchInstance
        }), isFirstRendering);
      },
      render: function render(renderArgs) {
        var helper = renderArgs.helper, instantSearchInstance = renderArgs.instantSearchInstance;
        var isFirstRendering = false;
        var state = helper.state;
        var positionChangedSinceLastRefine = Boolean(state.aroundLatLng) && Boolean(widgetState.lastRefinePosition) && state.aroundLatLng !== widgetState.lastRefinePosition;
        var boundingBoxChangedSinceLastRefine = !state.insideBoundingBox && Boolean(widgetState.lastRefineBoundingBox) && state.insideBoundingBox !== widgetState.lastRefineBoundingBox;
        if (positionChangedSinceLastRefine || boundingBoxChangedSinceLastRefine) {
          widgetState.hasMapMoveSinceLastRefine = false;
        }
        widgetState.lastRefinePosition = state.aroundLatLng || "";
        widgetState.lastRefineBoundingBox = getBoundingBoxAsString(state);
        widgetState.internalToggleRefineOnMapMove = createInternalToggleRefinementOnMapMove(renderArgs, this.render.bind(this));
        widgetState.internalSetMapMoveSinceLastRefine = createInternalSetMapMoveSinceLastRefine(renderArgs, this.render.bind(this));
        var widgetRenderState = this.getWidgetRenderState(renderArgs);
        sendEvent("view:internal", widgetRenderState.items);
        renderFn(_objectSpread38(_objectSpread38({}, widgetRenderState), {}, {
          instantSearchInstance
        }), isFirstRendering);
      },
      getWidgetRenderState: function getWidgetRenderState(renderOptions) {
        var helper = renderOptions.helper, results = renderOptions.results, instantSearchInstance = renderOptions.instantSearchInstance;
        var state = helper.state;
        var items = results ? transformItems(results.hits.filter(function(hit) {
          return hit._geoloc;
        }), {
          results
        }) : [];
        if (!sendEvent) {
          sendEvent = createSendEventForHits({
            instantSearchInstance,
            helper,
            widgetType: $$type
          });
        }
        return {
          items,
          position: getPositionFromState(state),
          currentRefinement: getCurrentRefinementFromState(state),
          refine: refine2(helper),
          sendEvent,
          clearMapRefinement: clearMapRefinement(helper),
          isRefinedWithMap: isRefinedWithMap(state),
          toggleRefineOnMapMove,
          isRefineOnMapMove,
          setMapMoveSinceLastRefine,
          hasMapMoveSinceLastRefine,
          widgetParams
        };
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return _objectSpread38(_objectSpread38({}, renderState), {}, {
          geoSearch: this.getWidgetRenderState(renderOptions)
        });
      },
      dispose: function dispose(_ref33) {
        var state = _ref33.state;
        unmountFn();
        return state.setQueryParameter("insideBoundingBox", void 0);
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref44) {
        var searchParameters = _ref44.searchParameters;
        var boundingBox = getBoundingBoxAsString(searchParameters);
        if (!boundingBox || uiState && uiState.geoSearch && uiState.geoSearch.boundingBox === boundingBox) {
          return uiState;
        }
        return _objectSpread38(_objectSpread38({}, uiState), {}, {
          geoSearch: {
            boundingBox
          }
        });
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref52) {
        var uiState = _ref52.uiState;
        if (!uiState || !uiState.geoSearch) {
          return searchParameters.setQueryParameter("insideBoundingBox", void 0);
        }
        return setBoundingBoxAsString(searchParameters, uiState.geoSearch.boundingBox);
      }
    };
  };
};

// node_modules/instantsearch.js/es/widgets/geo-search/createHTMLMarker.js
function _typeof28(o4) {
  "@babel/helpers - typeof";
  return _typeof28 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof28(o4);
}
function _classCallCheck2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties2(target, props) {
  for (var i4 = 0; i4 < props.length; i4++) {
    var descriptor = props[i4];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey27(descriptor.key), descriptor);
  }
}
function _createClass2(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties2(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties2(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _inherits2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf2(subClass, superClass);
}
function _setPrototypeOf2(o4, p4) {
  _setPrototypeOf2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf9(o5, p5) {
    o5.__proto__ = p5;
    return o5;
  };
  return _setPrototypeOf2(o4, p4);
}
function _createSuper2(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct2();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf2(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf2(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn2(this, result);
  };
}
function _possibleConstructorReturn2(self, call) {
  if (call && (_typeof28(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized2(self);
}
function _assertThisInitialized2(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct2() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e4) {
    return false;
  }
}
function _getPrototypeOf2(o4) {
  _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf9(o5) {
    return o5.__proto__ || Object.getPrototypeOf(o5);
  };
  return _getPrototypeOf2(o4);
}
function _defineProperty28(obj, key2, value) {
  key2 = _toPropertyKey27(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey27(t4) {
  var i4 = _toPrimitive27(t4, "string");
  return "symbol" == _typeof28(i4) ? i4 : String(i4);
}
function _toPrimitive27(t4, r3) {
  if ("object" != _typeof28(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof28(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var createHTMLMarker = function createHTMLMarker2(googleReference) {
  var HTMLMarker2 = /* @__PURE__ */ function(_googleReference$maps) {
    _inherits2(HTMLMarker3, _googleReference$maps);
    var _super = _createSuper2(HTMLMarker3);
    function HTMLMarker3(_ref9) {
      var _this;
      var __id = _ref9.__id, position = _ref9.position, map2 = _ref9.map, template = _ref9.template, className = _ref9.className, _ref$anchor = _ref9.anchor, anchor = _ref$anchor === void 0 ? {
        x: 0,
        y: 0
      } : _ref$anchor;
      _classCallCheck2(this, HTMLMarker3);
      _this = _super.call(this);
      _defineProperty28(_assertThisInitialized2(_this), "__id", void 0);
      _defineProperty28(_assertThisInitialized2(_this), "anchor", void 0);
      _defineProperty28(_assertThisInitialized2(_this), "offset", void 0);
      _defineProperty28(_assertThisInitialized2(_this), "listeners", void 0);
      _defineProperty28(_assertThisInitialized2(_this), "latLng", void 0);
      _defineProperty28(_assertThisInitialized2(_this), "element", void 0);
      _this.__id = __id;
      _this.anchor = anchor;
      _this.listeners = {};
      _this.latLng = new googleReference.maps.LatLng(position);
      _this.element = document.createElement("div");
      _this.element.className = className;
      _this.element.style.position = "absolute";
      if (_typeof28(template) === "object") {
        N2(template, _this.element);
      } else {
        _this.element.innerHTML = template;
      }
      _this.setMap(map2);
      return _this;
    }
    _createClass2(HTMLMarker3, [{
      key: "onAdd",
      value: function onAdd() {
        this.getPanes().overlayMouseTarget.appendChild(this.element);
        var bbBox = this.element.getBoundingClientRect();
        this.offset = {
          x: this.anchor.x + bbBox.width / 2,
          y: this.anchor.y + bbBox.height
        };
        this.element.style.width = "".concat(bbBox.width, "px");
      }
    }, {
      key: "draw",
      value: function draw() {
        var position = this.getProjection().fromLatLngToDivPixel(this.latLng);
        this.element.style.left = "".concat(Math.round(position.x - this.offset.x), "px");
        this.element.style.top = "".concat(Math.round(position.y - this.offset.y), "px");
        this.element.style.zIndex = String(parseInt(this.element.style.top, 10));
      }
    }, {
      key: "onRemove",
      value: function onRemove() {
        var _this2 = this;
        if (this.element) {
          this.element.parentNode.removeChild(this.element);
          Object.keys(this.listeners).forEach(function(eventName) {
            _this2.element.removeEventListener(eventName, _this2.listeners[eventName]);
          });
          delete this.element;
          delete this.listeners;
        }
      }
    }, {
      key: "addListener",
      value: function addListener(eventName, listener) {
        this.listeners[eventName] = listener;
        var element = this.element;
        element.addEventListener(eventName, listener);
        return {
          remove: function remove() {
            return element.removeEventListener(eventName, listener);
          }
        };
      }
    }, {
      key: "getPosition",
      value: function getPosition2() {
        return this.latLng;
      }
    }]);
    return HTMLMarker3;
  }(googleReference.maps.OverlayView);
  return HTMLMarker2;
};
var createHTMLMarker_default = createHTMLMarker;

// node_modules/instantsearch.js/es/widgets/geo-search/defaultTemplates.js
var _ref = y2("p", null, "Your custom HTML Marker");
var defaultTemplates4 = {
  HTMLMarker: function HTMLMarker() {
    return _ref;
  },
  reset: function reset() {
    return "Clear the map refinement";
  },
  toggle: function toggle() {
    return "Search as I move the map";
  },
  redo: function redo() {
    return "Redo search here";
  }
};
var defaultTemplates_default4 = defaultTemplates4;

// node_modules/instantsearch.js/es/components/GeoSearchControls/GeoSearchButton.js
var GeoSearchButton = function GeoSearchButton2(_ref9) {
  var className = _ref9.className, _ref$disabled = _ref9.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, onClick = _ref9.onClick, children = _ref9.children;
  return y2("button", {
    className,
    onClick,
    disabled
  }, children);
};
var GeoSearchButton_default = GeoSearchButton;

// node_modules/instantsearch.js/es/components/GeoSearchControls/GeoSearchToggle.js
var GeoSearchToggle = function GeoSearchToggle2(_ref9) {
  var classNameLabel = _ref9.classNameLabel, classNameInput = _ref9.classNameInput, checked = _ref9.checked, onToggle = _ref9.onToggle, children = _ref9.children;
  return y2("label", {
    className: classNameLabel
  }, y2("input", {
    className: classNameInput,
    type: "checkbox",
    checked,
    onChange: onToggle
  }), children);
};
var GeoSearchToggle_default = GeoSearchToggle;

// node_modules/instantsearch.js/es/components/GeoSearchControls/GeoSearchControls.js
function _extends14() {
  _extends14 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends14.apply(this, arguments);
}
var GeoSearchControls = function GeoSearchControls2(_ref9) {
  var cssClasses = _ref9.cssClasses, enableRefine = _ref9.enableRefine, enableRefineControl = _ref9.enableRefineControl, enableClearMapRefinement = _ref9.enableClearMapRefinement, isRefineOnMapMove = _ref9.isRefineOnMapMove, isRefinedWithMap = _ref9.isRefinedWithMap, hasMapMoveSinceLastRefine = _ref9.hasMapMoveSinceLastRefine, onRefineToggle = _ref9.onRefineToggle, onRefineClick = _ref9.onRefineClick, onClearClick = _ref9.onClearClick, templateProps = _ref9.templateProps;
  return y2(g2, null, enableRefine && y2("div", null, enableRefineControl && y2("div", {
    className: cssClasses.control
  }, isRefineOnMapMove || !hasMapMoveSinceLastRefine ? y2(GeoSearchToggle_default, {
    classNameLabel: cx(cssClasses.label, isRefineOnMapMove && cssClasses.selectedLabel),
    classNameInput: cssClasses.input,
    checked: isRefineOnMapMove,
    onToggle: onRefineToggle
  }, y2(Template_default, _extends14({}, templateProps, {
    templateKey: "toggle",
    rootTagName: "span"
  }))) : y2(GeoSearchButton_default, {
    className: cssClasses.redo,
    disabled: !hasMapMoveSinceLastRefine,
    onClick: onRefineClick
  }, y2(Template_default, _extends14({}, templateProps, {
    templateKey: "redo",
    rootTagName: "span"
  })))), !enableRefineControl && !isRefineOnMapMove && y2("div", {
    className: cssClasses.control
  }, y2(GeoSearchButton_default, {
    className: cx(cssClasses.redo, !hasMapMoveSinceLastRefine && cssClasses.disabledRedo),
    disabled: !hasMapMoveSinceLastRefine,
    onClick: onRefineClick
  }, y2(Template_default, _extends14({}, templateProps, {
    templateKey: "redo",
    rootTagName: "span"
  })))), enableClearMapRefinement && isRefinedWithMap && y2(GeoSearchButton_default, {
    className: cssClasses.reset,
    onClick: onClearClick
  }, y2(Template_default, _extends14({}, templateProps, {
    templateKey: "reset",
    rootTagName: "span"
  })))));
};
var GeoSearchControls_default = GeoSearchControls;

// node_modules/instantsearch.js/es/widgets/geo-search/GeoSearchRenderer.js
function _typeof29(o4) {
  "@babel/helpers - typeof";
  return _typeof29 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof29(o4);
}
function ownKeys39(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread39(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys39(Object(t4), true).forEach(function(r4) {
      _defineProperty29(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys39(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty29(obj, key2, value) {
  key2 = _toPropertyKey28(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey28(t4) {
  var i4 = _toPrimitive28(t4, "string");
  return "symbol" == _typeof29(i4) ? i4 : String(i4);
}
function _toPrimitive28(t4, r3) {
  if ("object" != _typeof29(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof29(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _slicedToArray6(arr, i4) {
  return _arrayWithHoles6(arr) || _iterableToArrayLimit6(arr, i4) || _unsupportedIterableToArray12(arr, i4) || _nonIterableRest6();
}
function _nonIterableRest6() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray12(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray12(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray12(o4, minLen);
}
function _arrayLikeToArray12(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
function _iterableToArrayLimit6(r3, l4) {
  var t4 = null == r3 ? null : "undefined" != typeof Symbol && r3[Symbol.iterator] || r3["@@iterator"];
  if (null != t4) {
    var e4, n4, i4, u4, a4 = [], f4 = true, o4 = false;
    try {
      if (i4 = (t4 = t4.call(r3)).next, 0 === l4) {
        if (Object(t4) !== t4)
          return;
        f4 = false;
      } else
        for (; !(f4 = (e4 = i4.call(t4)).done) && (a4.push(e4.value), a4.length !== l4); f4 = true)
          ;
    } catch (r4) {
      o4 = true, n4 = r4;
    } finally {
      try {
        if (!f4 && null != t4.return && (u4 = t4.return(), Object(u4) !== u4))
          return;
      } finally {
        if (o4)
          throw n4;
      }
    }
    return a4;
  }
}
function _arrayWithHoles6(arr) {
  if (Array.isArray(arr))
    return arr;
}
var refineWithMap = function refineWithMap2(_ref9) {
  var refine2 = _ref9.refine, mapInstance = _ref9.mapInstance;
  return refine2({
    northEast: mapInstance.getBounds().getNorthEast().toJSON(),
    southWest: mapInstance.getBounds().getSouthWest().toJSON()
  });
};
var collectMarkersForNextRender = function collectMarkersForNextRender2(markers, nextIds) {
  return markers.reduce(function(_ref23, marker17) {
    var _ref33 = _slicedToArray6(_ref23, 2), update = _ref33[0], exit = _ref33[1];
    var persist = nextIds.includes(marker17.__id);
    return persist ? [update.concat(marker17), exit] : [update, exit.concat(marker17)];
  }, [[], []]);
};
var createBoundingBoxFromMarkers = function createBoundingBoxFromMarkers2(google, markers) {
  var latLngBounds = markers.reduce(function(acc, marker17) {
    return acc.extend(marker17.getPosition());
  }, new google.maps.LatLngBounds());
  return {
    northEast: latLngBounds.getNorthEast().toJSON(),
    southWest: latLngBounds.getSouthWest().toJSON()
  };
};
var lockUserInteraction = function lockUserInteraction2(renderState, functionThatAltersTheMapPosition) {
  renderState.isUserInteraction = false;
  functionThatAltersTheMapPosition();
  renderState.isUserInteraction = true;
};
var renderer9 = function renderer10(_ref44, isFirstRendering) {
  var items = _ref44.items, position = _ref44.position, currentRefinement = _ref44.currentRefinement, refine2 = _ref44.refine, clearMapRefinement = _ref44.clearMapRefinement, toggleRefineOnMapMove = _ref44.toggleRefineOnMapMove, isRefineOnMapMove = _ref44.isRefineOnMapMove, setMapMoveSinceLastRefine = _ref44.setMapMoveSinceLastRefine, hasMapMoveSinceLastRefine = _ref44.hasMapMoveSinceLastRefine, isRefinedWithMap = _ref44.isRefinedWithMap, widgetParams = _ref44.widgetParams, instantSearchInstance = _ref44.instantSearchInstance;
  var container = widgetParams.container, googleReference = widgetParams.googleReference, cssClasses = widgetParams.cssClasses, templates = widgetParams.templates, initialZoom = widgetParams.initialZoom, initialPosition = widgetParams.initialPosition, enableRefine = widgetParams.enableRefine, enableClearMapRefinement = widgetParams.enableClearMapRefinement, enableRefineControl = widgetParams.enableRefineControl, mapOptions = widgetParams.mapOptions, createMarker = widgetParams.createMarker, markerOptions = widgetParams.markerOptions, renderState = widgetParams.renderState;
  if (isFirstRendering) {
    renderState.isUserInteraction = true;
    renderState.isPendingRefine = false;
    renderState.markers = [];
    var rootElement = document.createElement("div");
    rootElement.className = cssClasses.root;
    container.appendChild(rootElement);
    var mapElement = document.createElement("div");
    mapElement.className = cssClasses.map;
    rootElement.appendChild(mapElement);
    var treeElement = document.createElement("div");
    treeElement.className = cssClasses.tree;
    rootElement.appendChild(treeElement);
    renderState.mapInstance = new googleReference.maps.Map(mapElement, _objectSpread39({
      mapTypeControl: false,
      fullscreenControl: false,
      streetViewControl: false,
      clickableIcons: false,
      zoomControlOptions: {
        position: googleReference.maps.ControlPosition.LEFT_TOP
      }
    }, mapOptions));
    var setupListenersWhenMapIsReady = function setupListenersWhenMapIsReady2() {
      var onChange = function onChange2() {
        if (renderState.isUserInteraction && enableRefine) {
          setMapMoveSinceLastRefine();
          if (isRefineOnMapMove()) {
            renderState.isPendingRefine = true;
          }
        }
      };
      renderState.mapInstance.addListener("center_changed", onChange);
      renderState.mapInstance.addListener("zoom_changed", onChange);
      renderState.mapInstance.addListener("dragstart", onChange);
      renderState.mapInstance.addListener("idle", function() {
        if (renderState.isUserInteraction && renderState.isPendingRefine) {
          renderState.isPendingRefine = false;
          refineWithMap({
            mapInstance: renderState.mapInstance,
            refine: refine2
          });
        }
      });
    };
    googleReference.maps.event.addListenerOnce(renderState.mapInstance, "idle", setupListenersWhenMapIsReady);
    renderState.templateProps = prepareTemplateProps({
      templatesConfig: instantSearchInstance.templatesConfig,
      templates
    });
    return;
  }
  var nextItemsIds = items.map(function(_4) {
    return _4.objectID;
  });
  var _collectMarkersForNex = collectMarkersForNextRender(renderState.markers, nextItemsIds), _collectMarkersForNex2 = _slicedToArray6(_collectMarkersForNex, 2), updateMarkers = _collectMarkersForNex2[0], exitMarkers = _collectMarkersForNex2[1];
  var updateMarkerIds = updateMarkers.map(function(_4) {
    return _4.__id;
  });
  var nextPendingItems = items.filter(function(item11) {
    return !updateMarkerIds.includes(item11.objectID);
  });
  exitMarkers.forEach(function(marker17) {
    return marker17.setMap(null);
  });
  renderState.markers = updateMarkers.concat(nextPendingItems.map(function(item11) {
    var marker17 = createMarker({
      map: renderState.mapInstance,
      item: item11
    });
    Object.keys(markerOptions.events).forEach(function(eventName) {
      marker17.addListener(eventName, function(event) {
        markerOptions.events[eventName]({
          map: renderState.mapInstance,
          event,
          item: item11,
          marker: marker17
        });
      });
    });
    return marker17;
  }));
  var shouldUpdate = !hasMapMoveSinceLastRefine();
  var boundingBoxPadding = currentRefinement ? 0 : null;
  var boundingBox = !currentRefinement && Boolean(renderState.markers.length) ? createBoundingBoxFromMarkers(googleReference, renderState.markers) : currentRefinement;
  if (boundingBox && shouldUpdate) {
    lockUserInteraction(renderState, function() {
      renderState.mapInstance.fitBounds(new googleReference.maps.LatLngBounds(boundingBox.southWest, boundingBox.northEast), boundingBoxPadding);
    });
  } else if (shouldUpdate) {
    lockUserInteraction(renderState, function() {
      renderState.mapInstance.setCenter(position || initialPosition);
      renderState.mapInstance.setZoom(initialZoom);
    });
  }
  N2(y2(GeoSearchControls_default, {
    cssClasses,
    enableRefine,
    enableRefineControl,
    enableClearMapRefinement,
    isRefineOnMapMove: isRefineOnMapMove(),
    isRefinedWithMap: isRefinedWithMap(),
    hasMapMoveSinceLastRefine: hasMapMoveSinceLastRefine(),
    onRefineToggle: toggleRefineOnMapMove,
    onRefineClick: function onRefineClick() {
      return refineWithMap({
        mapInstance: renderState.mapInstance,
        refine: refine2
      });
    },
    onClearClick: clearMapRefinement,
    templateProps: renderState.templateProps
  }), container.querySelector(".".concat(cssClasses.tree)));
};
var GeoSearchRenderer_default = renderer9;

// node_modules/instantsearch.js/es/widgets/geo-search/geo-search.js
function _typeof30(o4) {
  "@babel/helpers - typeof";
  return _typeof30 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof30(o4);
}
var _excluded28 = ["initialZoom", "initialPosition", "templates", "cssClasses", "builtInMarker", "customHTMLMarker", "enableRefine", "enableClearMapRefinement", "enableRefineControl", "container", "googleReference"];
var _excluded29 = ["item"];
var _excluded32 = ["item"];
function ownKeys40(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread40(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys40(Object(t4), true).forEach(function(r4) {
      _defineProperty30(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys40(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty30(obj, key2, value) {
  key2 = _toPropertyKey29(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey29(t4) {
  var i4 = _toPrimitive29(t4, "string");
  return "symbol" == _typeof30(i4) ? i4 : String(i4);
}
function _toPrimitive29(t4, r3) {
  if ("object" != _typeof30(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof30(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _objectWithoutProperties11(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose11(source, excluded);
  var key2, i4;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i4 = 0; i4 < sourceSymbolKeys.length; i4++) {
      key2 = sourceSymbolKeys[i4];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose11(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i4;
  for (i4 = 0; i4 < sourceKeys.length; i4++) {
    key2 = sourceKeys[i4];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
var withUsage15 = createDocumentationMessageGenerator({
  name: "geo-search"
});
var suit6 = component("GeoSearch");
var geo_search_default = function geoSearch(widgetParams) {
  var _ref9 = widgetParams || {}, _ref$initialZoom = _ref9.initialZoom, initialZoom = _ref$initialZoom === void 0 ? 1 : _ref$initialZoom, _ref$initialPosition = _ref9.initialPosition, initialPosition = _ref$initialPosition === void 0 ? {
    lat: 0,
    lng: 0
  } : _ref$initialPosition, _ref$templates = _ref9.templates, userTemplates = _ref$templates === void 0 ? {} : _ref$templates, _ref$cssClasses = _ref9.cssClasses, userCssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses, _ref$builtInMarker = _ref9.builtInMarker, userBuiltInMarker = _ref$builtInMarker === void 0 ? {} : _ref$builtInMarker, userCustomHTMLMarker = _ref9.customHTMLMarker, _ref$enableRefine = _ref9.enableRefine, enableRefine = _ref$enableRefine === void 0 ? true : _ref$enableRefine, _ref$enableClearMapRe = _ref9.enableClearMapRefinement, enableClearMapRefinement = _ref$enableClearMapRe === void 0 ? true : _ref$enableClearMapRe, _ref$enableRefineCont = _ref9.enableRefineControl, enableRefineControl = _ref$enableRefineCont === void 0 ? true : _ref$enableRefineCont, container = _ref9.container, googleReference = _ref9.googleReference, otherWidgetParams = _objectWithoutProperties11(_ref9, _excluded28);
  var defaultBuiltInMarker = {
    createOptions: function createOptions() {
      return {};
    },
    events: {}
  };
  var defaultCustomHTMLMarker = {
    createOptions: function createOptions() {
      return {};
    },
    events: {}
  };
  if (!container) {
    throw new Error(withUsage15("The `container` option is required."));
  }
  if (!googleReference) {
    throw new Error(withUsage15("The `googleReference` option is required."));
  }
  var containerNode = getContainerNode(container);
  var cssClasses = {
    root: cx(suit6(), userCssClasses.root),
    // Required only to mount / unmount the Preact tree
    tree: suit6({
      descendantName: "tree"
    }),
    map: cx(suit6({
      descendantName: "map"
    }), userCssClasses.map),
    control: cx(suit6({
      descendantName: "control"
    }), userCssClasses.control),
    label: cx(suit6({
      descendantName: "label"
    }), userCssClasses.label),
    selectedLabel: cx(suit6({
      descendantName: "label",
      modifierName: "selected"
    }), userCssClasses.selectedLabel),
    input: cx(suit6({
      descendantName: "input"
    }), userCssClasses.input),
    redo: cx(suit6({
      descendantName: "redo"
    }), userCssClasses.redo),
    disabledRedo: cx(suit6({
      descendantName: "redo",
      modifierName: "disabled"
    }), userCssClasses.disabledRedo),
    reset: cx(suit6({
      descendantName: "reset"
    }), userCssClasses.reset)
  };
  var templates = _objectSpread40(_objectSpread40({}, defaultTemplates_default4), userTemplates);
  var builtInMarker = _objectSpread40(_objectSpread40({}, defaultBuiltInMarker), userBuiltInMarker);
  var isCustomHTMLMarker = Boolean(userCustomHTMLMarker) || Boolean(userTemplates.HTMLMarker);
  var customHTMLMarker = isCustomHTMLMarker && _objectSpread40(_objectSpread40({}, defaultCustomHTMLMarker), userCustomHTMLMarker);
  var createBuiltInMarker = function createBuiltInMarker2(_ref23) {
    var item11 = _ref23.item, rest = _objectWithoutProperties11(_ref23, _excluded29);
    return new googleReference.maps.Marker(_objectSpread40(_objectSpread40(_objectSpread40({}, builtInMarker.createOptions(item11)), rest), {}, {
      // @ts-expect-error @types/googlemaps doesn't document this
      __id: item11.objectID,
      position: item11._geoloc
    }));
  };
  var HTMLMarker2 = createHTMLMarker_default(googleReference);
  var createCustomHTMLMarker = function createCustomHTMLMarker2(_ref33) {
    var item11 = _ref33.item, rest = _objectWithoutProperties11(_ref33, _excluded32);
    return new HTMLMarker2(_objectSpread40(_objectSpread40(_objectSpread40({}, customHTMLMarker.createOptions(item11)), rest), {}, {
      __id: item11.objectID,
      position: item11._geoloc,
      className: cx(suit6({
        descendantName: "marker"
      })),
      template: renderTemplate({
        templateKey: "HTMLMarker",
        templates,
        data: item11
      })
    }));
  };
  var createMarker = !customHTMLMarker ? createBuiltInMarker : createCustomHTMLMarker;
  var markerOptions = !customHTMLMarker ? builtInMarker : customHTMLMarker;
  var makeWidget = connectGeoSearch_default(GeoSearchRenderer_default, function() {
    return N2(null, containerNode);
  });
  return _objectSpread40(_objectSpread40({}, makeWidget(_objectSpread40(_objectSpread40({}, otherWidgetParams), {}, {
    // @TODO: this type doesn't preserve the generic correctly,
    // (but as they're internal only it's not a big problem)
    templates,
    renderState: {},
    container: containerNode,
    googleReference,
    initialZoom,
    initialPosition,
    cssClasses,
    createMarker,
    markerOptions,
    enableRefine,
    enableClearMapRefinement,
    enableRefineControl
  }))), {}, {
    $$widgetType: "ais.geoSearch"
  });
};

// node_modules/instantsearch.js/es/components/SearchBox/SearchBox.js
function _typeof31(o4) {
  "@babel/helpers - typeof";
  return _typeof31 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof31(o4);
}
function _classCallCheck3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties3(target, props) {
  for (var i4 = 0; i4 < props.length; i4++) {
    var descriptor = props[i4];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey30(descriptor.key), descriptor);
  }
}
function _createClass3(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties3(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties3(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _inherits3(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf3(subClass, superClass);
}
function _setPrototypeOf3(o4, p4) {
  _setPrototypeOf3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf9(o5, p5) {
    o5.__proto__ = p5;
    return o5;
  };
  return _setPrototypeOf3(o4, p4);
}
function _createSuper3(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct3();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf3(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf3(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn3(this, result);
  };
}
function _possibleConstructorReturn3(self, call) {
  if (call && (_typeof31(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized3(self);
}
function _assertThisInitialized3(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct3() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e4) {
    return false;
  }
}
function _getPrototypeOf3(o4) {
  _getPrototypeOf3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf9(o5) {
    return o5.__proto__ || Object.getPrototypeOf(o5);
  };
  return _getPrototypeOf3(o4);
}
function _defineProperty31(obj, key2, value) {
  key2 = _toPropertyKey30(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey30(t4) {
  var i4 = _toPrimitive30(t4, "string");
  return "symbol" == _typeof31(i4) ? i4 : String(i4);
}
function _toPrimitive30(t4, r3) {
  if ("object" != _typeof31(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof31(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var defaultProps2 = {
  query: "",
  showSubmit: true,
  showReset: true,
  showLoadingIndicator: true,
  autofocus: false,
  searchAsYouType: true,
  ignoreCompositionEvents: false,
  isSearchStalled: false,
  disabled: false,
  ariaLabel: "Search",
  onChange: noop,
  onSubmit: noop,
  onReset: noop,
  refine: noop
};
var SearchBox = /* @__PURE__ */ function(_Component) {
  _inherits3(SearchBox2, _Component);
  var _super = _createSuper3(SearchBox2);
  function SearchBox2() {
    var _this;
    _classCallCheck3(this, SearchBox2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty31(_assertThisInitialized3(_this), "state", {
      query: _this.props.query,
      focused: false
    });
    _defineProperty31(_assertThisInitialized3(_this), "input", _2());
    _defineProperty31(_assertThisInitialized3(_this), "onInput", function(event) {
      var _this$props = _this.props, searchAsYouType = _this$props.searchAsYouType, refine2 = _this$props.refine, onChange = _this$props.onChange;
      var query = event.target.value;
      if (!(_this.props.ignoreCompositionEvents && event.isComposing)) {
        if (searchAsYouType) {
          refine2(query);
        }
        _this.setState({
          query
        });
        onChange(event);
      }
    });
    _defineProperty31(_assertThisInitialized3(_this), "onSubmit", function(event) {
      var _this$props2 = _this.props, searchAsYouType = _this$props2.searchAsYouType, refine2 = _this$props2.refine, onSubmit = _this$props2.onSubmit;
      event.preventDefault();
      event.stopPropagation();
      if (_this.input.current) {
        _this.input.current.blur();
      }
      if (!searchAsYouType) {
        refine2(_this.state.query);
      }
      onSubmit(event);
      return false;
    });
    _defineProperty31(_assertThisInitialized3(_this), "onReset", function(event) {
      var _this$props3 = _this.props, refine2 = _this$props3.refine, onReset = _this$props3.onReset;
      var query = "";
      if (_this.input.current) {
        _this.input.current.focus();
      }
      refine2(query);
      _this.setState({
        query
      });
      onReset(event);
    });
    _defineProperty31(_assertThisInitialized3(_this), "onBlur", function() {
      _this.setState({
        focused: false
      });
    });
    _defineProperty31(_assertThisInitialized3(_this), "onFocus", function() {
      _this.setState({
        focused: true
      });
    });
    return _this;
  }
  _createClass3(SearchBox2, [{
    key: "resetInput",
    value: (
      /**
       * This public method is used in the RefinementList SFFV search box
       * to reset the input state when an item is selected.
       *
       * @see RefinementList#componentWillReceiveProps
       * @return {undefined}
       */
      function resetInput() {
        this.setState({
          query: ""
        });
      }
    )
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!this.state.focused && nextProps.query !== this.state.query) {
        this.setState({
          query: nextProps.query
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props, cssClasses = _this$props4.cssClasses, placeholder = _this$props4.placeholder, autofocus = _this$props4.autofocus, showSubmit = _this$props4.showSubmit, showReset = _this$props4.showReset, showLoadingIndicator = _this$props4.showLoadingIndicator, templates = _this$props4.templates, isSearchStalled = _this$props4.isSearchStalled, ariaLabel = _this$props4.ariaLabel;
      return y2("div", {
        className: cssClasses.root
      }, y2("form", {
        action: "",
        role: "search",
        className: cssClasses.form,
        noValidate: true,
        onSubmit: this.onSubmit,
        onReset: this.onReset
      }, y2("input", {
        ref: this.input,
        value: this.state.query,
        disabled: this.props.disabled,
        className: cssClasses.input,
        type: "search",
        placeholder,
        autoFocus: autofocus,
        autoComplete: "off",
        autoCorrect: "off",
        autoCapitalize: "off",
        spellCheck: "false",
        maxLength: 512,
        onInput: this.onInput,
        oncompositionend: this.onInput,
        onBlur: this.onBlur,
        onFocus: this.onFocus,
        "aria-label": ariaLabel
      }), y2(Template_default, {
        templateKey: "submit",
        rootTagName: "button",
        rootProps: {
          className: cssClasses.submit,
          type: "submit",
          title: "Submit the search query",
          hidden: !showSubmit
        },
        templates,
        data: {
          cssClasses
        }
      }), y2(Template_default, {
        templateKey: "reset",
        rootTagName: "button",
        rootProps: {
          className: cssClasses.reset,
          type: "reset",
          title: "Clear the search query",
          hidden: !(showReset && this.state.query.trim() && !isSearchStalled)
        },
        templates,
        data: {
          cssClasses
        }
      }), showLoadingIndicator && y2(Template_default, {
        templateKey: "loadingIndicator",
        rootTagName: "span",
        rootProps: {
          className: cssClasses.loadingIndicator,
          hidden: !isSearchStalled
        },
        templates,
        data: {
          cssClasses
        }
      })));
    }
  }]);
  return SearchBox2;
}(b2);
_defineProperty31(SearchBox, "defaultProps", defaultProps2);
var SearchBox_default = SearchBox;

// node_modules/instantsearch.js/es/components/RefinementList/RefinementListItem.js
function _extends15() {
  _extends15 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends15.apply(this, arguments);
}
function RefinementListItem(_ref9) {
  var className = _ref9.className, handleClick3 = _ref9.handleClick, facetValueToRefine = _ref9.facetValueToRefine, isRefined2 = _ref9.isRefined, templateProps = _ref9.templateProps, templateKey = _ref9.templateKey, templateData = _ref9.templateData, subItems = _ref9.subItems;
  return y2("li", {
    className,
    onClick: function onClick(originalEvent) {
      handleClick3({
        facetValueToRefine,
        isRefined: isRefined2,
        originalEvent
      });
    }
  }, y2(Template_default, _extends15({}, templateProps, {
    templateKey,
    data: templateData
  })), subItems);
}
var RefinementListItem_default = RefinementListItem;

// node_modules/instantsearch.js/es/components/RefinementList/RefinementList.js
var _excluded30 = ["root"];
function _typeof32(o4) {
  "@babel/helpers - typeof";
  return _typeof32 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof32(o4);
}
function ownKeys41(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread41(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys41(Object(t4), true).forEach(function(r4) {
      _defineProperty32(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys41(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _extends16() {
  _extends16 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends16.apply(this, arguments);
}
function _objectWithoutProperties12(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose12(source, excluded);
  var key2, i4;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i4 = 0; i4 < sourceSymbolKeys.length; i4++) {
      key2 = sourceSymbolKeys[i4];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose12(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i4;
  for (i4 = 0; i4 < sourceKeys.length; i4++) {
    key2 = sourceKeys[i4];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function _classCallCheck4(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties4(target, props) {
  for (var i4 = 0; i4 < props.length; i4++) {
    var descriptor = props[i4];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey31(descriptor.key), descriptor);
  }
}
function _createClass4(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties4(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties4(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _inherits4(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf4(subClass, superClass);
}
function _setPrototypeOf4(o4, p4) {
  _setPrototypeOf4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf9(o5, p5) {
    o5.__proto__ = p5;
    return o5;
  };
  return _setPrototypeOf4(o4, p4);
}
function _createSuper4(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct4();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf4(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf4(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn4(this, result);
  };
}
function _possibleConstructorReturn4(self, call) {
  if (call && (_typeof32(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized4(self);
}
function _assertThisInitialized4(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct4() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e4) {
    return false;
  }
}
function _getPrototypeOf4(o4) {
  _getPrototypeOf4 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf9(o5) {
    return o5.__proto__ || Object.getPrototypeOf(o5);
  };
  return _getPrototypeOf4(o4);
}
function _defineProperty32(obj, key2, value) {
  key2 = _toPropertyKey31(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey31(t4) {
  var i4 = _toPrimitive31(t4, "string");
  return "symbol" == _typeof32(i4) ? i4 : String(i4);
}
function _toPrimitive31(t4, r3) {
  if ("object" != _typeof32(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof32(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var defaultProps3 = {
  cssClasses: {},
  depth: 0
};
function isHierarchicalMenuItem(facetValue) {
  return facetValue.data !== void 0;
}
var RefinementList = /* @__PURE__ */ function(_Component) {
  _inherits4(RefinementList2, _Component);
  var _super = _createSuper4(RefinementList2);
  function RefinementList2() {
    var _this;
    _classCallCheck4(this, RefinementList2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty32(_assertThisInitialized4(_this), "listRef", _2());
    _defineProperty32(_assertThisInitialized4(_this), "searchBox", _2());
    _defineProperty32(_assertThisInitialized4(_this), "lastRefinedValue", void 0);
    _defineProperty32(_assertThisInitialized4(_this), "_generateFacetItem", function(facetValue) {
      var subItems;
      if (isHierarchicalMenuItem(facetValue) && Array.isArray(facetValue.data) && facetValue.data.length > 0) {
        var _this$props$cssClasse = _this.props.cssClasses, root = _this$props$cssClasse.root, cssClasses = _objectWithoutProperties12(_this$props$cssClasse, _excluded30);
        subItems = y2(RefinementList2, _extends16({}, _this.props, {
          // We want to keep `root` required for external usage but not for the
          // sub items.
          cssClasses,
          depth: _this.props.depth + 1,
          facetValues: facetValue.data,
          showMore: false,
          className: _this.props.cssClasses.childList
        }));
      }
      var url2 = _this.props.createURL(facetValue.value);
      var templateData = _objectSpread41(_objectSpread41({}, facetValue), {}, {
        url: url2,
        attribute: _this.props.attribute,
        cssClasses: _this.props.cssClasses,
        isFromSearch: _this.props.isFromSearch
      });
      var key2 = facetValue.value;
      if (facetValue.isRefined !== void 0) {
        key2 += "/".concat(facetValue.isRefined);
      }
      if (facetValue.count !== void 0) {
        key2 += "/".concat(facetValue.count);
      }
      var refinementListItemClassName = cx(_this.props.cssClasses.item, facetValue.isRefined && _this.props.cssClasses.selectedItem, !facetValue.count && _this.props.cssClasses.disabledItem, Boolean(isHierarchicalMenuItem(facetValue) && Array.isArray(facetValue.data) && facetValue.data.length > 0) && _this.props.cssClasses.parentItem);
      return y2(RefinementListItem_default, {
        templateKey: "item",
        key: key2,
        facetValueToRefine: facetValue.value,
        handleClick: _this.handleItemClick,
        isRefined: facetValue.isRefined,
        className: refinementListItemClassName,
        subItems,
        templateData,
        templateProps: _this.props.templateProps
      });
    });
    _defineProperty32(_assertThisInitialized4(_this), "handleItemClick", function(_ref9) {
      var facetValueToRefine = _ref9.facetValueToRefine, isRefined2 = _ref9.isRefined, originalEvent = _ref9.originalEvent;
      if (isSpecialClick(originalEvent)) {
        return;
      }
      var parent = originalEvent.target;
      if (parent === null || parent.parentNode === null) {
        return;
      }
      if (isRefined2 && parent.parentNode.querySelector('input[type="radio"]:checked')) {
        return;
      }
      if (parent.tagName === "INPUT") {
        _this.refine(facetValueToRefine);
        return;
      }
      while (parent !== originalEvent.currentTarget) {
        if (parent.tagName === "LABEL" && (parent.querySelector('input[type="checkbox"]') || parent.querySelector('input[type="radio"]'))) {
          return;
        }
        if (parent.tagName === "A" && parent.href) {
          originalEvent.preventDefault();
        }
        parent = parent.parentNode;
      }
      originalEvent.stopPropagation();
      _this.refine(facetValueToRefine);
    });
    return _this;
  }
  _createClass4(RefinementList2, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var areFacetValuesDifferent = !isEqual(this.props.facetValues, nextProps.facetValues);
      return areFacetValuesDifferent;
    }
  }, {
    key: "refine",
    value: function refine2(facetValueToRefine) {
      this.lastRefinedValue = facetValueToRefine;
      this.props.toggleRefinement(facetValueToRefine);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.searchBox.current && !nextProps.isFromSearch) {
        this.searchBox.current.resetInput();
      }
    }
    /**
     * This sets focus on the last refined input element after a render
     * because Preact does not perform it automatically.
     * @see https://github.com/preactjs/preact/issues/3242
     */
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$listRef$current, _this$listRef$current2, _this$lastRefinedValu;
      (_this$listRef$current = this.listRef.current) === null || _this$listRef$current === void 0 ? void 0 : (_this$listRef$current2 = _this$listRef$current.querySelector('input[value="'.concat((_this$lastRefinedValu = this.lastRefinedValue) === null || _this$lastRefinedValu === void 0 ? void 0 : _this$lastRefinedValu.replace('"', '\\"'), '"]'))) === null || _this$listRef$current2 === void 0 ? void 0 : _this$listRef$current2.focus();
      this.lastRefinedValue = void 0;
    }
  }, {
    key: "refineFirstValue",
    value: function refineFirstValue() {
      if (this.props.searchableSelectOnSubmit === false) {
        return;
      }
      var firstValue = this.props.facetValues && this.props.facetValues[0];
      if (firstValue) {
        var actualValue = firstValue.value;
        this.props.toggleRefinement(actualValue);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var showMoreButtonClassName = cx(this.props.cssClasses.showMore, !(this.props.showMore === true && this.props.canToggleShowMore) && this.props.cssClasses.disabledShowMore);
      var showMoreButton = this.props.showMore === true && y2(Template_default, _extends16({}, this.props.templateProps, {
        templateKey: "showMoreText",
        rootTagName: "button",
        rootProps: {
          className: showMoreButtonClassName,
          disabled: !this.props.canToggleShowMore,
          onClick: this.props.toggleShowMore
        },
        data: {
          isShowingMore: this.props.isShowingMore
        }
      }));
      var shouldDisableSearchBox = this.props.searchIsAlwaysActive !== true && !(this.props.isFromSearch || !this.props.hasExhaustiveItems);
      var searchBox3 = this.props.searchFacetValues && y2("div", {
        className: this.props.cssClasses.searchBox
      }, y2(SearchBox_default, {
        ref: this.searchBox,
        placeholder: this.props.searchPlaceholder,
        disabled: shouldDisableSearchBox,
        cssClasses: this.props.cssClasses.searchable,
        templates: this.props.searchBoxTemplateProps.templates,
        onChange: function onChange(event) {
          return _this2.props.searchFacetValues(event.target.value);
        },
        onReset: function onReset() {
          return _this2.props.searchFacetValues("");
        },
        onSubmit: function onSubmit() {
          return _this2.refineFirstValue();
        },
        searchAsYouType: false,
        ariaLabel: "Search for filters"
      }));
      var facetValues = this.props.facetValues && this.props.facetValues.length > 0 && y2("ul", {
        ref: this.listRef,
        className: this.props.cssClasses.list
      }, this.props.facetValues.map(this._generateFacetItem, this));
      var noResults = this.props.searchFacetValues && this.props.isFromSearch && (!this.props.facetValues || this.props.facetValues.length === 0) && y2(Template_default, _extends16({}, this.props.templateProps, {
        templateKey: "searchableNoResults",
        rootProps: {
          className: this.props.cssClasses.noResults
        }
      }));
      var rootClassName = cx(this.props.cssClasses.root, (!this.props.facetValues || this.props.facetValues.length === 0) && this.props.cssClasses.noRefinementRoot, this.props.className);
      return y2("div", {
        className: rootClassName
      }, this.props.children, searchBox3, facetValues, noResults, showMoreButton);
    }
  }]);
  return RefinementList2;
}(b2);
_defineProperty32(RefinementList, "defaultProps", defaultProps3);
var RefinementList_default = RefinementList;

// node_modules/instantsearch.js/es/connectors/hierarchical-menu/connectHierarchicalMenu.js
function _typeof33(o4) {
  "@babel/helpers - typeof";
  return _typeof33 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof33(o4);
}
var _excluded31 = ["name", "escapedValue", "data", "path"];
function ownKeys42(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread42(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys42(Object(t4), true).forEach(function(r4) {
      _defineProperty33(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys42(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty33(obj, key2, value) {
  key2 = _toPropertyKey32(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey32(t4) {
  var i4 = _toPrimitive32(t4, "string");
  return "symbol" == _typeof33(i4) ? i4 : String(i4);
}
function _toPrimitive32(t4, r3) {
  if ("object" != _typeof33(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof33(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _objectWithoutProperties13(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose13(source, excluded);
  var key2, i4;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i4 = 0; i4 < sourceSymbolKeys.length; i4++) {
      key2 = sourceSymbolKeys[i4];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose13(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i4;
  for (i4 = 0; i4 < sourceKeys.length; i4++) {
    key2 = sourceKeys[i4];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function _slicedToArray7(arr, i4) {
  return _arrayWithHoles7(arr) || _iterableToArrayLimit7(arr, i4) || _unsupportedIterableToArray13(arr, i4) || _nonIterableRest7();
}
function _nonIterableRest7() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray13(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray13(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray13(o4, minLen);
}
function _arrayLikeToArray13(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
function _iterableToArrayLimit7(r3, l4) {
  var t4 = null == r3 ? null : "undefined" != typeof Symbol && r3[Symbol.iterator] || r3["@@iterator"];
  if (null != t4) {
    var e4, n4, i4, u4, a4 = [], f4 = true, o4 = false;
    try {
      if (i4 = (t4 = t4.call(r3)).next, 0 === l4) {
        if (Object(t4) !== t4)
          return;
        f4 = false;
      } else
        for (; !(f4 = (e4 = i4.call(t4)).done) && (a4.push(e4.value), a4.length !== l4); f4 = true)
          ;
    } catch (r4) {
      o4 = true, n4 = r4;
    } finally {
      try {
        if (!f4 && null != t4.return && (u4 = t4.return(), Object(u4) !== u4))
          return;
      } finally {
        if (o4)
          throw n4;
      }
    }
    return a4;
  }
}
function _arrayWithHoles7(arr) {
  if (Array.isArray(arr))
    return arr;
}
var withUsage16 = createDocumentationMessageGenerator({
  name: "hierarchical-menu",
  connector: true
});
var DEFAULT_SORT = ["name:asc"];
var connectHierarchicalMenu = function connectHierarchicalMenu2(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage16());
  return function(widgetParams) {
    var _ref9 = widgetParams || {}, attributes = _ref9.attributes, _ref$separator = _ref9.separator, separator2 = _ref$separator === void 0 ? " > " : _ref$separator, _ref$rootPath = _ref9.rootPath, rootPath = _ref$rootPath === void 0 ? null : _ref$rootPath, _ref$showParentLevel = _ref9.showParentLevel, showParentLevel = _ref$showParentLevel === void 0 ? true : _ref$showParentLevel, _ref$limit = _ref9.limit, limit = _ref$limit === void 0 ? 10 : _ref$limit, _ref$showMore = _ref9.showMore, showMore = _ref$showMore === void 0 ? false : _ref$showMore, _ref$showMoreLimit = _ref9.showMoreLimit, showMoreLimit = _ref$showMoreLimit === void 0 ? 20 : _ref$showMoreLimit, _ref$sortBy = _ref9.sortBy, sortBy3 = _ref$sortBy === void 0 ? DEFAULT_SORT : _ref$sortBy, _ref$transformItems = _ref9.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
      return items;
    } : _ref$transformItems;
    if (!attributes || !Array.isArray(attributes) || attributes.length === 0) {
      throw new Error(withUsage16("The `attributes` option expects an array of strings."));
    }
    if (showMore === true && showMoreLimit <= limit) {
      throw new Error(withUsage16("The `showMoreLimit` option must be greater than `limit`."));
    }
    var _attributes = _slicedToArray7(attributes, 1), hierarchicalFacetName = _attributes[0];
    var sendEvent;
    var toggleShowMore = function toggleShowMore2() {
    };
    function cachedToggleShowMore() {
      toggleShowMore();
    }
    var _refine2;
    var isShowingMore = false;
    function createToggleShowMore(renderOptions, widget) {
      return function() {
        isShowingMore = !isShowingMore;
        widget.render(renderOptions);
      };
    }
    function getLimit() {
      return isShowingMore ? showMoreLimit : limit;
    }
    function _prepareFacetValues(facetValues) {
      return facetValues.slice(0, getLimit()).map(function(_ref23) {
        var label = _ref23.name, value = _ref23.escapedValue, data = _ref23.data, path = _ref23.path, subValue = _objectWithoutProperties13(_ref23, _excluded31);
        var item11 = _objectSpread42(_objectSpread42({}, subValue), {}, {
          value,
          label,
          data: null
        });
        if (Array.isArray(data)) {
          item11.data = _prepareFacetValues(data);
        }
        return item11;
      });
    }
    return {
      $$type: "ais.hierarchicalMenu",
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(_objectSpread42(_objectSpread42({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        toggleShowMore = createToggleShowMore(renderOptions, this);
        renderFn(_objectSpread42(_objectSpread42({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance
        }), false);
      },
      dispose: function dispose(_ref33) {
        var state = _ref33.state;
        unmountFn();
        return state.removeHierarchicalFacet(hierarchicalFacetName).setQueryParameter("maxValuesPerFacet", void 0);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return _objectSpread42(_objectSpread42({}, renderState), {}, {
          hierarchicalMenu: _objectSpread42(_objectSpread42({}, renderState.hierarchicalMenu), {}, _defineProperty33({}, hierarchicalFacetName, this.getWidgetRenderState(renderOptions)))
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref44) {
        var _this = this;
        var results = _ref44.results, state = _ref44.state, createURL = _ref44.createURL, instantSearchInstance = _ref44.instantSearchInstance, helper = _ref44.helper;
        var items = [];
        var canToggleShowMore = false;
        var _createURL = function _createURL2(facetValue) {
          return createURL(function(uiState) {
            return _this.getWidgetUiState(uiState, {
              searchParameters: state.resetPage().toggleFacetRefinement(hierarchicalFacetName, facetValue),
              helper
            });
          });
        };
        if (!sendEvent) {
          sendEvent = createSendEventForFacet({
            instantSearchInstance,
            helper,
            attribute: function attribute(facetValue) {
              var index = facetValue.split(separator2).length - 1;
              return attributes[index];
            },
            widgetType: this.$$type
          });
        }
        if (!_refine2) {
          _refine2 = function _refine3(facetValue) {
            sendEvent("click:internal", facetValue);
            helper.toggleFacetRefinement(hierarchicalFacetName, facetValue).search();
          };
        }
        if (results) {
          var facetValues = results.getFacetValues(hierarchicalFacetName, {
            sortBy: sortBy3,
            facetOrdering: sortBy3 === DEFAULT_SORT
          });
          var facetItems = facetValues && !Array.isArray(facetValues) && facetValues.data ? facetValues.data : [];
          var hasExhaustiveItems = (state.maxValuesPerFacet || 0) > getLimit() ? facetItems.length <= getLimit() : facetItems.length < getLimit();
          canToggleShowMore = showMore && (isShowingMore || !hasExhaustiveItems);
          items = transformItems(_prepareFacetValues(facetItems), {
            results
          });
        }
        return {
          items,
          refine: _refine2,
          canRefine: items.length > 0,
          createURL: _createURL,
          sendEvent,
          widgetParams,
          isShowingMore,
          toggleShowMore: cachedToggleShowMore,
          canToggleShowMore
        };
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref52) {
        var searchParameters = _ref52.searchParameters;
        var path = searchParameters.getHierarchicalFacetBreadcrumb(hierarchicalFacetName);
        return removeEmptyRefinementsFromUiState2(_objectSpread42(_objectSpread42({}, uiState), {}, {
          hierarchicalMenu: _objectSpread42(_objectSpread42({}, uiState.hierarchicalMenu), {}, _defineProperty33({}, hierarchicalFacetName, path))
        }), hierarchicalFacetName);
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref64) {
        var uiState = _ref64.uiState;
        var values = uiState.hierarchicalMenu && uiState.hierarchicalMenu[hierarchicalFacetName];
        if (searchParameters.isConjunctiveFacet(hierarchicalFacetName) || searchParameters.isDisjunctiveFacet(hierarchicalFacetName)) {
          false ? _warning(false, 'HierarchicalMenu: Attribute "'.concat(hierarchicalFacetName, '" is already used by another widget applying conjunctive or disjunctive faceting.\nAs this is not supported, please make sure to remove this other widget or this HierarchicalMenu widget will not work at all.')) : void 0;
          return searchParameters;
        }
        if (searchParameters.isHierarchicalFacet(hierarchicalFacetName)) {
          var facet = searchParameters.getHierarchicalFacetByName(hierarchicalFacetName);
          false ? _warning(isEqual(facet.attributes, attributes) && facet.separator === separator2 && facet.rootPath === rootPath, "Using Breadcrumb and HierarchicalMenu on the same facet with different options overrides the configuration of the HierarchicalMenu.") : void 0;
        }
        var withFacetConfiguration = searchParameters.removeHierarchicalFacet(hierarchicalFacetName).addHierarchicalFacet({
          name: hierarchicalFacetName,
          attributes,
          separator: separator2,
          rootPath,
          showParentLevel
        });
        var currentMaxValuesPerFacet = withFacetConfiguration.maxValuesPerFacet || 0;
        var nextMaxValuesPerFacet = Math.max(currentMaxValuesPerFacet, showMore ? showMoreLimit : limit);
        var withMaxValuesPerFacet = withFacetConfiguration.setQueryParameter("maxValuesPerFacet", nextMaxValuesPerFacet);
        if (!values) {
          return withMaxValuesPerFacet.setQueryParameters({
            hierarchicalFacetsRefinements: _objectSpread42(_objectSpread42({}, withMaxValuesPerFacet.hierarchicalFacetsRefinements), {}, _defineProperty33({}, hierarchicalFacetName, []))
          });
        }
        return withMaxValuesPerFacet.addHierarchicalFacetRefinement(hierarchicalFacetName, values.join(separator2));
      }
    };
  };
};
function removeEmptyRefinementsFromUiState2(indexUiState, attribute) {
  if (!indexUiState.hierarchicalMenu) {
    return indexUiState;
  }
  if (!indexUiState.hierarchicalMenu[attribute] || indexUiState.hierarchicalMenu[attribute].length === 0) {
    delete indexUiState.hierarchicalMenu[attribute];
  }
  if (Object.keys(indexUiState.hierarchicalMenu).length === 0) {
    delete indexUiState.hierarchicalMenu;
  }
  return indexUiState;
}
var connectHierarchicalMenu_default = connectHierarchicalMenu;

// node_modules/instantsearch.js/es/widgets/hierarchical-menu/defaultTemplates.js
var defaultTemplates5 = {
  item: function item2(_ref9) {
    var url2 = _ref9.url, label = _ref9.label, count = _ref9.count, cssClasses = _ref9.cssClasses, isRefined2 = _ref9.isRefined;
    return y2("a", {
      className: cx(cx(cssClasses.link), cx(isRefined2 ? cssClasses.selectedItemLink : void 0)),
      href: url2
    }, y2("span", {
      className: cx(cssClasses.label)
    }, label), y2("span", {
      className: cx(cssClasses.count)
    }, formatNumber(count)));
  },
  showMoreText: function showMoreText(_ref23) {
    var isShowingMore = _ref23.isShowingMore;
    return isShowingMore ? "Show less" : "Show more";
  }
};
var defaultTemplates_default5 = defaultTemplates5;

// node_modules/instantsearch.js/es/widgets/hierarchical-menu/hierarchical-menu.js
function _typeof34(o4) {
  "@babel/helpers - typeof";
  return _typeof34 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof34(o4);
}
function ownKeys43(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread43(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys43(Object(t4), true).forEach(function(r4) {
      _defineProperty34(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys43(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty34(obj, key2, value) {
  key2 = _toPropertyKey33(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey33(t4) {
  var i4 = _toPrimitive33(t4, "string");
  return "symbol" == _typeof34(i4) ? i4 : String(i4);
}
function _toPrimitive33(t4, r3) {
  if ("object" != _typeof34(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof34(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage17 = createDocumentationMessageGenerator({
  name: "hierarchical-menu"
});
var suit7 = component("HierarchicalMenu");
var renderer11 = function renderer12(_ref9) {
  var cssClasses = _ref9.cssClasses, containerNode = _ref9.containerNode, showMore = _ref9.showMore, templates = _ref9.templates, renderState = _ref9.renderState;
  return function(_ref23, isFirstRendering) {
    var createURL = _ref23.createURL, items = _ref23.items, refine2 = _ref23.refine, instantSearchInstance = _ref23.instantSearchInstance, isShowingMore = _ref23.isShowingMore, toggleShowMore = _ref23.toggleShowMore, canToggleShowMore = _ref23.canToggleShowMore;
    if (isFirstRendering) {
      renderState.templateProps = prepareTemplateProps({
        defaultTemplates: defaultTemplates_default5,
        templatesConfig: instantSearchInstance.templatesConfig,
        templates
      });
      return;
    }
    N2(y2(RefinementList_default, {
      createURL,
      cssClasses,
      facetValues: items,
      templateProps: renderState.templateProps,
      toggleRefinement: refine2,
      showMore,
      toggleShowMore,
      isShowingMore,
      canToggleShowMore
    }), containerNode);
  };
};
var hierarchicalMenu = function hierarchicalMenu2(widgetParams) {
  var _ref33 = widgetParams || {}, container = _ref33.container, attributes = _ref33.attributes, separator2 = _ref33.separator, rootPath = _ref33.rootPath, showParentLevel = _ref33.showParentLevel, limit = _ref33.limit, _ref3$showMore = _ref33.showMore, showMore = _ref3$showMore === void 0 ? false : _ref3$showMore, showMoreLimit = _ref33.showMoreLimit, sortBy3 = _ref33.sortBy, transformItems = _ref33.transformItems, _ref3$templates = _ref33.templates, templates = _ref3$templates === void 0 ? {} : _ref3$templates, _ref3$cssClasses = _ref33.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses;
  if (!container) {
    throw new Error(withUsage17("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var cssClasses = {
    root: cx(suit7(), userCssClasses.root),
    noRefinementRoot: cx(suit7({
      modifierName: "noRefinement"
    }), userCssClasses.noRefinementRoot),
    list: cx(suit7({
      descendantName: "list"
    }), userCssClasses.list),
    childList: cx(suit7({
      descendantName: "list",
      modifierName: "child"
    }), userCssClasses.childList),
    item: cx(suit7({
      descendantName: "item"
    }), userCssClasses.item),
    selectedItem: cx(suit7({
      descendantName: "item",
      modifierName: "selected"
    }), userCssClasses.selectedItem),
    parentItem: cx(suit7({
      descendantName: "item",
      modifierName: "parent"
    }), userCssClasses.parentItem),
    link: cx(suit7({
      descendantName: "link"
    }), userCssClasses.link),
    selectedItemLink: cx(suit7({
      descendantName: "link",
      modifierName: "selected"
    }), userCssClasses.selectedItemLink),
    label: cx(suit7({
      descendantName: "label"
    }), userCssClasses.label),
    count: cx(suit7({
      descendantName: "count"
    }), userCssClasses.count),
    showMore: cx(suit7({
      descendantName: "showMore"
    }), userCssClasses.showMore),
    disabledShowMore: cx(suit7({
      descendantName: "showMore",
      modifierName: "disabled"
    }), userCssClasses.disabledShowMore)
  };
  var specializedRenderer = renderer11({
    cssClasses,
    containerNode,
    templates,
    showMore,
    renderState: {}
  });
  var makeWidget = connectHierarchicalMenu_default(specializedRenderer, function() {
    return N2(null, containerNode);
  });
  return _objectSpread43(_objectSpread43({}, makeWidget({
    attributes,
    separator: separator2,
    rootPath,
    showParentLevel,
    limit,
    showMore,
    showMoreLimit,
    sortBy: sortBy3,
    transformItems
  })), {}, {
    $$widgetType: "ais.hierarchicalMenu"
  });
};
var hierarchical_menu_default = hierarchicalMenu;

// node_modules/instantsearch.js/es/connectors/hits/connectHits.js
function _typeof35(o4) {
  "@babel/helpers - typeof";
  return _typeof35 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof35(o4);
}
function ownKeys44(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread44(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys44(Object(t4), true).forEach(function(r4) {
      _defineProperty35(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys44(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty35(obj, key2, value) {
  key2 = _toPropertyKey34(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey34(t4) {
  var i4 = _toPrimitive34(t4, "string");
  return "symbol" == _typeof35(i4) ? i4 : String(i4);
}
function _toPrimitive34(t4, r3) {
  if ("object" != _typeof35(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof35(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage18 = createDocumentationMessageGenerator({
  name: "hits",
  connector: true
});
var connectHits_default = function connectHits(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage18());
  return function(widgetParams) {
    var _ref9 = widgetParams || {}, _ref$escapeHTML = _ref9.escapeHTML, escapeHTML = _ref$escapeHTML === void 0 ? true : _ref$escapeHTML, _ref$transformItems = _ref9.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
      return items;
    } : _ref$transformItems;
    var sendEvent;
    var bindEvent;
    return {
      $$type: "ais.hits",
      init: function init(initOptions) {
        renderFn(_objectSpread44(_objectSpread44({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: initOptions.instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var renderState = this.getWidgetRenderState(renderOptions);
        renderFn(_objectSpread44(_objectSpread44({}, renderState), {}, {
          instantSearchInstance: renderOptions.instantSearchInstance
        }), false);
        renderState.sendEvent("view:internal", renderState.items);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return _objectSpread44(_objectSpread44({}, renderState), {}, {
          hits: this.getWidgetRenderState(renderOptions)
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref23) {
        var _results$renderingCon, _results$renderingCon2, _results$renderingCon3;
        var results = _ref23.results, helper = _ref23.helper, instantSearchInstance = _ref23.instantSearchInstance;
        if (!sendEvent) {
          sendEvent = createSendEventForHits({
            instantSearchInstance,
            helper,
            widgetType: this.$$type
          });
        }
        if (!bindEvent) {
          bindEvent = createBindEventForHits({
            helper,
            widgetType: this.$$type,
            instantSearchInstance
          });
        }
        if (!results) {
          return {
            hits: [],
            items: [],
            results: void 0,
            banner: void 0,
            sendEvent,
            bindEvent,
            widgetParams
          };
        }
        if (escapeHTML && results.hits.length > 0) {
          results.hits = escapeHits(results.hits);
        }
        var hitsWithAbsolutePosition = addAbsolutePosition(results.hits, results.page, results.hitsPerPage);
        var hitsWithAbsolutePositionAndQueryID = addQueryID(hitsWithAbsolutePosition, results.queryID);
        var items = transformItems(hitsWithAbsolutePositionAndQueryID, {
          results
        });
        var banner = (_results$renderingCon = results.renderingContent) === null || _results$renderingCon === void 0 ? void 0 : (_results$renderingCon2 = _results$renderingCon.widgets) === null || _results$renderingCon2 === void 0 ? void 0 : (_results$renderingCon3 = _results$renderingCon2.banners) === null || _results$renderingCon3 === void 0 ? void 0 : _results$renderingCon3[0];
        return {
          hits: items,
          items,
          results,
          banner,
          sendEvent,
          bindEvent,
          widgetParams
        };
      },
      dispose: function dispose(_ref33) {
        var state = _ref33.state;
        unmountFn();
        if (!escapeHTML) {
          return state;
        }
        return state.setQueryParameters(Object.keys(TAG_PLACEHOLDER).reduce(function(acc, key2) {
          return _objectSpread44(_objectSpread44({}, acc), {}, _defineProperty35({}, key2, void 0));
        }, {}));
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(state, _uiState) {
        if (!escapeHTML) {
          return state;
        }
        return state.setQueryParameters(TAG_PLACEHOLDER);
      }
    };
  };
};

// node_modules/instantsearch.js/es/lib/insights/client.js
function _typeof36(o4) {
  "@babel/helpers - typeof";
  return _typeof36 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof36(o4);
}
function ownKeys45(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread45(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys45(Object(t4), true).forEach(function(r4) {
      _defineProperty36(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys45(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty36(obj, key2, value) {
  key2 = _toPropertyKey35(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey35(t4) {
  var i4 = _toPrimitive35(t4, "string");
  return "symbol" == _typeof36(i4) ? i4 : String(i4);
}
function _toPrimitive35(t4, r3) {
  if ("object" != _typeof36(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof36(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var getSelectedHits = function getSelectedHits2(hits2, selectedObjectIDs) {
  return selectedObjectIDs.map(function(objectID) {
    var hit = find(hits2, function(h4) {
      return h4.objectID === objectID;
    });
    if (typeof hit === "undefined") {
      throw new Error('Could not find objectID "'.concat(objectID, '" passed to `clickedObjectIDsAfterSearch` in the returned hits. This is necessary to infer the absolute position and the query ID.'));
    }
    return hit;
  });
};
var getQueryID = function getQueryID2(selectedHits) {
  var queryIDs = uniq(selectedHits.map(function(hit) {
    return hit.__queryID;
  }));
  if (queryIDs.length > 1) {
    throw new Error("Insights currently allows a single `queryID`. The `objectIDs` provided map to multiple `queryID`s.");
  }
  var queryID = queryIDs[0];
  if (typeof queryID !== "string") {
    throw new Error("Could not infer `queryID`. Ensure InstantSearch `clickAnalytics: true` was added with the Configure widget.\n\nSee: https://alg.li/lNiZZ7");
  }
  return queryID;
};
var getPositions = function getPositions2(selectedHits) {
  return selectedHits.map(function(hit) {
    return hit.__position;
  });
};
var inferPayload = function inferPayload2(_ref9) {
  var method = _ref9.method, results = _ref9.results, hits2 = _ref9.hits, objectIDs = _ref9.objectIDs;
  var index = results.index;
  var selectedHits = getSelectedHits(hits2, objectIDs);
  var queryID = getQueryID(selectedHits);
  switch (method) {
    case "clickedObjectIDsAfterSearch": {
      var positions = getPositions(selectedHits);
      return {
        index,
        queryID,
        objectIDs,
        positions
      };
    }
    case "convertedObjectIDsAfterSearch":
      return {
        index,
        queryID,
        objectIDs
      };
    default:
      throw new Error('Unsupported method passed to insights: "'.concat(method, '".'));
  }
};
var wrapInsightsClient = function wrapInsightsClient2(aa, results, hits2) {
  return function(method) {
    for (var _len = arguments.length, payloads = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      payloads[_key - 1] = arguments[_key];
    }
    var payload = payloads[0];
    false ? _warning(false, "`insights` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `insights` middleware.\n\nFor more information, visit https://www.algolia.com/doc/guides/getting-insights-and-analytics/search-analytics/click-through-and-conversions/how-to/send-click-and-conversion-events-with-instantsearch/js/") : void 0;
    if (!aa) {
      var withInstantSearchUsage = createDocumentationMessageGenerator({
        name: "instantsearch"
      });
      throw new Error(withInstantSearchUsage("The `insightsClient` option has not been provided to `instantsearch`."));
    }
    if (!Array.isArray(payload.objectIDs)) {
      throw new TypeError("Expected `objectIDs` to be an array.");
    }
    var inferredPayload = inferPayload({
      method,
      results,
      hits: hits2,
      objectIDs: payload.objectIDs
    });
    aa(method, _objectSpread45(_objectSpread45({}, inferredPayload), payload));
  };
};
function withInsights(connector) {
  return function(renderFn, unmountFn) {
    return connector(function(renderOptions, isFirstRender) {
      var results = renderOptions.results, hits2 = renderOptions.hits, instantSearchInstance = renderOptions.instantSearchInstance;
      if (results && hits2 && instantSearchInstance) {
        var insights = wrapInsightsClient(instantSearchInstance.insightsClient, results, hits2);
        return renderFn(_objectSpread45(_objectSpread45({}, renderOptions), {}, {
          insights
        }), isFirstRender);
      }
      return renderFn(renderOptions, isFirstRender);
    }, unmountFn);
  };
}

// node_modules/instantsearch.js/es/lib/insights/listener.js
var createInsightsEventHandler = function createInsightsEventHandler2(_ref9) {
  var insights = _ref9.insights, sendEvent = _ref9.sendEvent;
  return function(event) {
    var insightsThroughSendEvent = findInsightsTarget(event.target, event.currentTarget, function(element) {
      return element.hasAttribute("data-insights-event");
    });
    if (insightsThroughSendEvent) {
      var payload = parseInsightsEvent(insightsThroughSendEvent);
      payload.forEach(function(single) {
        return sendEvent(single);
      });
    }
    var insightsThroughFunction = findInsightsTarget(event.target, event.currentTarget, function(element) {
      return element.hasAttribute("data-insights-method") && element.hasAttribute("data-insights-payload");
    });
    if (insightsThroughFunction) {
      var _readDataAttributes = readDataAttributes(insightsThroughFunction), method = _readDataAttributes.method, _payload = _readDataAttributes.payload;
      insights(method, _payload);
    }
  };
};
function findInsightsTarget(startElement, endElement, validator2) {
  var element = startElement;
  while (element && !validator2(element)) {
    if (element === endElement) {
      return null;
    }
    element = element.parentElement;
  }
  return element;
}
function parseInsightsEvent(element) {
  var serializedPayload = element.getAttribute("data-insights-event");
  if (typeof serializedPayload !== "string") {
    throw new Error("The insights middleware expects `data-insights-event` to be a base64-encoded JSON string.");
  }
  try {
    return deserializePayload(serializedPayload);
  } catch (error40) {
    throw new Error("The insights middleware was unable to parse `data-insights-event`.");
  }
}

// node_modules/instantsearch.js/es/widgets/hits/defaultTemplates.js
var defaultTemplates6 = {
  empty: function empty() {
    return "No results";
  },
  item: function item3(data) {
    return JSON.stringify(omit(data, ["__hitIndex"]), null, 2);
  }
};
var defaultTemplates_default6 = defaultTemplates6;

// node_modules/instantsearch.js/es/widgets/hits/hits.js
function _typeof37(o4) {
  "@babel/helpers - typeof";
  return _typeof37 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof37(o4);
}
var _excluded33 = ["hit", "index"];
function ownKeys46(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread46(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys46(Object(t4), true).forEach(function(r4) {
      _defineProperty37(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys46(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty37(obj, key2, value) {
  key2 = _toPropertyKey36(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey36(t4) {
  var i4 = _toPrimitive36(t4, "string");
  return "symbol" == _typeof37(i4) ? i4 : String(i4);
}
function _toPrimitive36(t4, r3) {
  if ("object" != _typeof37(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof37(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _objectWithoutProperties14(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose14(source, excluded);
  var key2, i4;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i4 = 0; i4 < sourceSymbolKeys.length; i4++) {
      key2 = sourceSymbolKeys[i4];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose14(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i4;
  for (i4 = 0; i4 < sourceKeys.length; i4++) {
    key2 = sourceKeys[i4];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function _objectDestructuringEmpty(obj) {
  if (obj == null)
    throw new TypeError("Cannot destructure " + obj);
}
function _extends17() {
  _extends17 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends17.apply(this, arguments);
}
var withUsage19 = createDocumentationMessageGenerator({
  name: "hits"
});
var Hits = createHitsComponent({
  createElement: y2,
  Fragment: g2
});
var renderer13 = function renderer14(_ref9) {
  var renderState = _ref9.renderState, cssClasses = _ref9.cssClasses, containerNode = _ref9.containerNode, templates = _ref9.templates;
  return function(_ref23, isFirstRendering) {
    var items = _ref23.items, results = _ref23.results, instantSearchInstance = _ref23.instantSearchInstance, insights = _ref23.insights, bindEvent = _ref23.bindEvent, sendEvent = _ref23.sendEvent, banner = _ref23.banner;
    if (isFirstRendering) {
      renderState.templateProps = prepareTemplateProps({
        defaultTemplates: defaultTemplates_default6,
        templatesConfig: instantSearchInstance.templatesConfig,
        templates
      });
      return;
    }
    var handleInsightsClick = createInsightsEventHandler({
      insights,
      sendEvent
    });
    var emptyComponent = function emptyComponent2(_ref33) {
      var rootProps = _extends17({}, (_objectDestructuringEmpty(_ref33), _ref33));
      return y2(Template_default, _extends17({}, renderState.templateProps, {
        rootProps,
        templateKey: "empty",
        data: results,
        rootTagName: "fragment"
      }));
    };
    var itemComponent = function itemComponent2(_ref44) {
      var hit = _ref44.hit, index = _ref44.index, rootProps = _objectWithoutProperties14(_ref44, _excluded33);
      return y2(Template_default, _extends17({}, renderState.templateProps, {
        templateKey: "item",
        rootTagName: "li",
        rootProps: _objectSpread46(_objectSpread46({}, rootProps), {}, {
          onClick: function onClick(event) {
            handleInsightsClick(event);
            rootProps.onClick();
          },
          onAuxClick: function onAuxClick(event) {
            handleInsightsClick(event);
            rootProps.onAuxClick();
          }
        }),
        data: _objectSpread46(_objectSpread46({}, hit), {}, {
          get __hitIndex() {
            false ? _warning(false, "The `__hitIndex` property is deprecated. Use the absolute `__position` instead.") : void 0;
            return index;
          }
        }),
        bindEvent,
        sendEvent
      }));
    };
    var bannerComponent = function bannerComponent2(props) {
      return y2(Template_default, _extends17({}, renderState.templateProps, {
        templateKey: "banner",
        data: props,
        rootTagName: "fragment"
      }));
    };
    N2(y2(Hits, {
      hits: items,
      itemComponent,
      sendEvent,
      classNames: cssClasses,
      emptyComponent,
      banner,
      bannerComponent: templates.banner ? bannerComponent : void 0
    }), containerNode);
  };
};
var hits_default = function hits(widgetParams) {
  var _ref52 = widgetParams || {}, container = _ref52.container, escapeHTML = _ref52.escapeHTML, transformItems = _ref52.transformItems, _ref5$templates = _ref52.templates, templates = _ref5$templates === void 0 ? {} : _ref5$templates, _ref5$cssClasses = _ref52.cssClasses, cssClasses = _ref5$cssClasses === void 0 ? {} : _ref5$cssClasses;
  if (!container) {
    throw new Error(withUsage19("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var specializedRenderer = renderer13({
    containerNode,
    cssClasses,
    renderState: {},
    templates
  });
  var makeWidget = withInsights(connectHits_default)(specializedRenderer, function() {
    return N2(null, containerNode);
  });
  return _objectSpread46(_objectSpread46({}, makeWidget({
    escapeHTML,
    transformItems
  })), {}, {
    $$widgetType: "ais.hits"
  });
};

// node_modules/instantsearch.js/es/components/Selector/Selector.js
function Selector(_ref9) {
  var currentValue = _ref9.currentValue, options = _ref9.options, cssClasses = _ref9.cssClasses, setValue = _ref9.setValue, ariaLabel = _ref9.ariaLabel;
  return y2("select", {
    className: cx(cssClasses.select),
    onChange: function onChange(event) {
      return setValue(event.target.value);
    },
    value: "".concat(currentValue),
    "aria-label": ariaLabel
  }, options.map(function(option) {
    return y2("option", {
      className: cx(cssClasses.option),
      key: option.label + option.value,
      value: "".concat(option.value)
    }, option.label);
  }));
}
var Selector_default = Selector;

// node_modules/instantsearch.js/es/connectors/hits-per-page/connectHitsPerPage.js
function _typeof38(o4) {
  "@babel/helpers - typeof";
  return _typeof38 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof38(o4);
}
function _toConsumableArray8(arr) {
  return _arrayWithoutHoles8(arr) || _iterableToArray8(arr) || _unsupportedIterableToArray14(arr) || _nonIterableSpread8();
}
function _nonIterableSpread8() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray14(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray14(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray14(o4, minLen);
}
function _iterableToArray8(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles8(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray14(arr);
}
function _arrayLikeToArray14(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
function ownKeys47(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread47(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys47(Object(t4), true).forEach(function(r4) {
      _defineProperty38(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys47(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty38(obj, key2, value) {
  key2 = _toPropertyKey37(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey37(t4) {
  var i4 = _toPrimitive37(t4, "string");
  return "symbol" == _typeof38(i4) ? i4 : String(i4);
}
function _toPrimitive37(t4, r3) {
  if ("object" != _typeof38(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof38(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage20 = createDocumentationMessageGenerator({
  name: "hits-per-page",
  connector: true
});
var connectHitsPerPage = function connectHitsPerPage2(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage20());
  return function(widgetParams) {
    var _ref9 = widgetParams || {}, userItems = _ref9.items, _ref$transformItems = _ref9.transformItems, transformItems = _ref$transformItems === void 0 ? function(items2) {
      return items2;
    } : _ref$transformItems;
    if (!Array.isArray(userItems)) {
      throw new Error(withUsage20("The `items` option expects an array of objects."));
    }
    var items = userItems;
    var defaultItems = items.filter(function(item11) {
      return item11.default === true;
    });
    if (defaultItems.length === 0) {
      throw new Error(withUsage20("A default value must be specified in `items`."));
    }
    if (defaultItems.length > 1) {
      throw new Error(withUsage20("More than one default value is specified in `items`."));
    }
    var defaultItem = defaultItems[0];
    var normalizeItems = function normalizeItems2(_ref23) {
      var hitsPerPage3 = _ref23.hitsPerPage;
      return items.map(function(item11) {
        return _objectSpread47(_objectSpread47({}, item11), {}, {
          isRefined: Number(item11.value) === Number(hitsPerPage3)
        });
      });
    };
    var connectorState = {
      getRefine: function getRefine(helper) {
        return function(value) {
          return !value && value !== 0 ? helper.setQueryParameter("hitsPerPage", void 0).search() : helper.setQueryParameter("hitsPerPage", value).search();
        };
      },
      createURLFactory: function createURLFactory(_ref33) {
        var state = _ref33.state, createURL = _ref33.createURL, getWidgetUiState = _ref33.getWidgetUiState, helper = _ref33.helper;
        return function(value) {
          return createURL(function(uiState) {
            return getWidgetUiState(uiState, {
              searchParameters: state.resetPage().setQueryParameter("hitsPerPage", !value && value !== 0 ? void 0 : value),
              helper
            });
          });
        };
      }
    };
    return {
      $$type: "ais.hitsPerPage",
      init: function init(initOptions) {
        var state = initOptions.state, instantSearchInstance = initOptions.instantSearchInstance;
        var isCurrentInOptions = items.some(function(item11) {
          return Number(state.hitsPerPage) === Number(item11.value);
        });
        if (!isCurrentInOptions) {
          false ? _warning(state.hitsPerPage !== void 0, "\n`hitsPerPage` is not defined.\nThe option `hitsPerPage` needs to be set using the `configure` widget.\n\nLearn more: https://www.algolia.com/doc/api-reference/widgets/hits-per-page/js/\n            ") : void 0;
          false ? _warning(false, '\nThe `items` option of `hitsPerPage` does not contain the "hits per page" value coming from the state: '.concat(state.hitsPerPage, ".\n\nYou may want to add another entry to the `items` option with this value.")) : void 0;
          items = [
            // The helper will convert the empty string to `undefined`.
            {
              value: "",
              label: ""
            }
          ].concat(_toConsumableArray8(items));
        }
        renderFn(_objectSpread47(_objectSpread47({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance
        }), true);
      },
      render: function render(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(_objectSpread47(_objectSpread47({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance
        }), false);
      },
      dispose: function dispose(_ref44) {
        var state = _ref44.state;
        unmountFn();
        return state.setQueryParameter("hitsPerPage", void 0);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return _objectSpread47(_objectSpread47({}, renderState), {}, {
          hitsPerPage: this.getWidgetRenderState(renderOptions)
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref52) {
        var state = _ref52.state, results = _ref52.results, createURL = _ref52.createURL, helper = _ref52.helper;
        var canRefine = results ? results.nbHits > 0 : false;
        return {
          items: transformItems(normalizeItems(state), {
            results
          }),
          refine: connectorState.getRefine(helper),
          createURL: connectorState.createURLFactory({
            state,
            createURL,
            getWidgetUiState: this.getWidgetUiState,
            helper
          }),
          hasNoResults: !canRefine,
          canRefine,
          widgetParams
        };
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref64) {
        var searchParameters = _ref64.searchParameters;
        var hitsPerPage3 = searchParameters.hitsPerPage;
        if (hitsPerPage3 === void 0 || hitsPerPage3 === defaultItem.value) {
          return uiState;
        }
        return _objectSpread47(_objectSpread47({}, uiState), {}, {
          hitsPerPage: hitsPerPage3
        });
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref72) {
        var uiState = _ref72.uiState;
        return searchParameters.setQueryParameters({
          hitsPerPage: uiState.hitsPerPage || defaultItem.value
        });
      }
    };
  };
};
var connectHitsPerPage_default = connectHitsPerPage;

// node_modules/instantsearch.js/es/widgets/hits-per-page/hits-per-page.js
function _typeof39(o4) {
  "@babel/helpers - typeof";
  return _typeof39 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof39(o4);
}
function ownKeys48(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread48(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys48(Object(t4), true).forEach(function(r4) {
      _defineProperty39(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys48(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty39(obj, key2, value) {
  key2 = _toPropertyKey38(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey38(t4) {
  var i4 = _toPrimitive38(t4, "string");
  return "symbol" == _typeof39(i4) ? i4 : String(i4);
}
function _toPrimitive38(t4, r3) {
  if ("object" != _typeof39(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof39(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage21 = createDocumentationMessageGenerator({
  name: "hits-per-page"
});
var suit8 = component("HitsPerPage");
var renderer15 = function renderer16(_ref9) {
  var containerNode = _ref9.containerNode, cssClasses = _ref9.cssClasses;
  return function(_ref23, isFirstRendering) {
    var items = _ref23.items, refine2 = _ref23.refine;
    if (isFirstRendering)
      return;
    var _ref33 = find(items, function(_ref44) {
      var isRefined2 = _ref44.isRefined;
      return isRefined2;
    }) || {}, currentValue = _ref33.value;
    N2(y2("div", {
      className: cssClasses.root
    }, y2(Selector_default, {
      cssClasses,
      currentValue,
      options: items,
      setValue: refine2
    })), containerNode);
  };
};
var hitsPerPage = function hitsPerPage2(widgetParams) {
  var _ref52 = widgetParams || {}, container = _ref52.container, items = _ref52.items, _ref5$cssClasses = _ref52.cssClasses, userCssClasses = _ref5$cssClasses === void 0 ? {} : _ref5$cssClasses, transformItems = _ref52.transformItems;
  if (!container) {
    throw new Error(withUsage21("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var cssClasses = {
    root: cx(suit8(), userCssClasses.root),
    select: cx(suit8({
      descendantName: "select"
    }), userCssClasses.select),
    option: cx(suit8({
      descendantName: "option"
    }), userCssClasses.option)
  };
  var specializedRenderer = renderer15({
    containerNode,
    cssClasses
  });
  var makeWidget = connectHitsPerPage_default(specializedRenderer, function() {
    return N2(null, containerNode);
  });
  return _objectSpread48(_objectSpread48({}, makeWidget({
    items,
    transformItems
  })), {}, {
    $$widgetType: "ais.hitsPerPage"
  });
};
var hits_per_page_default = hitsPerPage;

// node_modules/instantsearch.js/es/components/InfiniteHits/InfiniteHits.js
function _typeof40(o4) {
  "@babel/helpers - typeof";
  return _typeof40 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof40(o4);
}
function ownKeys49(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread49(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys49(Object(t4), true).forEach(function(r4) {
      _defineProperty40(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys49(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty40(obj, key2, value) {
  key2 = _toPropertyKey39(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey39(t4) {
  var i4 = _toPrimitive39(t4, "string");
  return "symbol" == _typeof40(i4) ? i4 : String(i4);
}
function _toPrimitive39(t4, r3) {
  if ("object" != _typeof40(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof40(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _extends18() {
  _extends18 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends18.apply(this, arguments);
}
var DefaultBanner = function DefaultBanner2(_ref9) {
  var banner = _ref9.banner, classNames = _ref9.classNames;
  if (!banner.image.urls[0].url) {
    return null;
  }
  return y2("aside", {
    className: cx(classNames.bannerRoot)
  }, banner.link ? y2("a", {
    className: cx(classNames.bannerLink),
    href: banner.link.url,
    target: banner.link.target
  }, y2("img", {
    className: cx(classNames.bannerImage),
    src: banner.image.urls[0].url,
    alt: banner.image.title
  })) : y2("img", {
    className: cx(classNames.bannerImage),
    src: banner.image.urls[0].url,
    alt: banner.image.title
  }));
};
var InfiniteHits = function InfiniteHits2(_ref23) {
  var results = _ref23.results, hits2 = _ref23.hits, insights = _ref23.insights, bindEvent = _ref23.bindEvent, sendEvent = _ref23.sendEvent, hasShowPrevious = _ref23.hasShowPrevious, showPrevious = _ref23.showPrevious, showMore = _ref23.showMore, isFirstPage = _ref23.isFirstPage, isLastPage = _ref23.isLastPage, cssClasses = _ref23.cssClasses, templateProps = _ref23.templateProps, banner = _ref23.banner;
  var handleInsightsClick = createInsightsEventHandler({
    insights,
    sendEvent
  });
  if (results.hits.length === 0) {
    return y2("div", {
      className: cx(cssClasses.root, cssClasses.emptyRoot),
      onClick: handleInsightsClick
    }, banner && (templateProps.templates.banner ? y2(Template_default, _extends18({}, templateProps, {
      templateKey: "banner",
      rootTagName: "fragment",
      data: {
        banner,
        className: cssClasses.bannerRoot
      }
    })) : y2(DefaultBanner, {
      banner,
      classNames: cssClasses
    })), y2(Template_default, _extends18({}, templateProps, {
      templateKey: "empty",
      rootTagName: "fragment",
      data: results
    })));
  }
  return y2("div", {
    className: cssClasses.root
  }, hasShowPrevious && y2(Template_default, _extends18({}, templateProps, {
    templateKey: "showPreviousText",
    rootTagName: "button",
    rootProps: {
      className: cx(cssClasses.loadPrevious, isFirstPage && cssClasses.disabledLoadPrevious),
      disabled: isFirstPage,
      onClick: showPrevious
    }
  })), banner && (templateProps.templates.banner ? y2(Template_default, _extends18({}, templateProps, {
    templateKey: "banner",
    rootTagName: "fragment",
    data: {
      banner,
      className: cssClasses.bannerRoot
    }
  })) : y2(DefaultBanner, {
    banner,
    classNames: cssClasses
  })), y2("ol", {
    className: cssClasses.list
  }, hits2.map(function(hit, index) {
    return y2(Template_default, _extends18({}, templateProps, {
      templateKey: "item",
      rootTagName: "li",
      rootProps: {
        className: cssClasses.item,
        onClick: function onClick(event) {
          handleInsightsClick(event);
          sendEvent("click:internal", hit, "Hit Clicked");
        },
        onAuxClick: function onAuxClick(event) {
          handleInsightsClick(event);
          sendEvent("click:internal", hit, "Hit Clicked");
        }
      },
      key: hit.objectID,
      data: _objectSpread49(_objectSpread49({}, hit), {}, {
        get __hitIndex() {
          false ? _warning(false, "The `__hitIndex` property is deprecated. Use the absolute `__position` instead.") : void 0;
          return index;
        }
      }),
      bindEvent,
      sendEvent
    }));
  })), y2(Template_default, _extends18({}, templateProps, {
    templateKey: "showMoreText",
    rootTagName: "button",
    rootProps: {
      className: cx(cssClasses.loadMore, isLastPage && cssClasses.disabledLoadMore),
      disabled: isLastPage,
      onClick: showMore
    }
  })));
};
var InfiniteHits_default = InfiniteHits;

// node_modules/instantsearch.js/es/connectors/infinite-hits/connectInfiniteHits.js
function _typeof41(o4) {
  "@babel/helpers - typeof";
  return _typeof41 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof41(o4);
}
var _excluded34 = ["page"];
var _excluded210 = ["clickAnalytics", "userToken"];
function ownKeys50(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread50(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys50(Object(t4), true).forEach(function(r4) {
      _defineProperty41(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys50(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty41(obj, key2, value) {
  key2 = _toPropertyKey40(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey40(t4) {
  var i4 = _toPrimitive40(t4, "string");
  return "symbol" == _typeof41(i4) ? i4 : String(i4);
}
function _toPrimitive40(t4, r3) {
  if ("object" != _typeof41(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof41(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _toConsumableArray9(arr) {
  return _arrayWithoutHoles9(arr) || _iterableToArray9(arr) || _unsupportedIterableToArray15(arr) || _nonIterableSpread9();
}
function _nonIterableSpread9() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray15(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray15(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray15(o4, minLen);
}
function _iterableToArray9(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles9(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray15(arr);
}
function _arrayLikeToArray15(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
function _objectWithoutProperties15(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose15(source, excluded);
  var key2, i4;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i4 = 0; i4 < sourceSymbolKeys.length; i4++) {
      key2 = sourceSymbolKeys[i4];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose15(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i4;
  for (i4 = 0; i4 < sourceKeys.length; i4++) {
    key2 = sourceKeys[i4];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
var withUsage22 = createDocumentationMessageGenerator({
  name: "infinite-hits",
  connector: true
});
function getStateWithoutPage(state) {
  var _ref9 = state || {}, page2 = _ref9.page, rest = _objectWithoutProperties15(_ref9, _excluded34);
  return rest;
}
function normalizeState(state) {
  var _ref23 = state || {}, clickAnalytics = _ref23.clickAnalytics, userToken = _ref23.userToken, rest = _objectWithoutProperties15(_ref23, _excluded210);
  return rest;
}
function getInMemoryCache() {
  var cachedHits = null;
  var cachedState = null;
  return {
    read: function read(_ref33) {
      var state = _ref33.state;
      return isEqual(cachedState, getStateWithoutPage(state)) ? cachedHits : null;
    },
    write: function write(_ref44) {
      var state = _ref44.state, hits2 = _ref44.hits;
      cachedState = getStateWithoutPage(state);
      cachedHits = hits2;
    }
  };
}
function extractHitsFromCachedHits(cachedHits) {
  return Object.keys(cachedHits).map(Number).sort(function(a4, b3) {
    return a4 - b3;
  }).reduce(function(acc, page2) {
    return acc.concat(cachedHits[page2]);
  }, []);
}
var connectInfiniteHits_default = function connectInfiniteHits(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage22());
  return function(widgetParams) {
    var _ref52 = widgetParams || {}, _ref5$escapeHTML = _ref52.escapeHTML, escapeHTML = _ref5$escapeHTML === void 0 ? true : _ref5$escapeHTML, _ref5$transformItems = _ref52.transformItems, transformItems = _ref5$transformItems === void 0 ? function(items) {
      return items;
    } : _ref5$transformItems, _ref5$cache = _ref52.cache, cache = _ref5$cache === void 0 ? getInMemoryCache() : _ref5$cache;
    var showPrevious;
    var showMore;
    var sendEvent;
    var bindEvent;
    var getFirstReceivedPage = function getFirstReceivedPage2(state, cachedHits) {
      var _state$page = state.page, page2 = _state$page === void 0 ? 0 : _state$page;
      var pages = Object.keys(cachedHits).map(Number);
      if (pages.length === 0) {
        return page2;
      } else {
        return Math.min.apply(Math, [page2].concat(_toConsumableArray9(pages)));
      }
    };
    var getLastReceivedPage = function getLastReceivedPage2(state, cachedHits) {
      var _state$page2 = state.page, page2 = _state$page2 === void 0 ? 0 : _state$page2;
      var pages = Object.keys(cachedHits).map(Number);
      if (pages.length === 0) {
        return page2;
      } else {
        return Math.max.apply(Math, [page2].concat(_toConsumableArray9(pages)));
      }
    };
    var getShowPrevious = function getShowPrevious2(helper, getCachedHits) {
      return function() {
        var cachedHits = getCachedHits();
        helper.overrideStateWithoutTriggeringChangeEvent(_objectSpread50(_objectSpread50({}, helper.state), {}, {
          page: getFirstReceivedPage(helper.state, cachedHits) - 1
        })).searchWithoutTriggeringOnStateChange();
      };
    };
    var getShowMore = function getShowMore2(helper, getCachedHits) {
      return function() {
        var cachedHits = getCachedHits();
        helper.setPage(getLastReceivedPage(helper.state, cachedHits) + 1).search();
      };
    };
    return {
      $$type: "ais.infiniteHits",
      init: function init(initOptions) {
        renderFn(_objectSpread50(_objectSpread50({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: initOptions.instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        var widgetRenderState = this.getWidgetRenderState(renderOptions);
        renderFn(_objectSpread50(_objectSpread50({}, widgetRenderState), {}, {
          instantSearchInstance
        }), false);
        sendEvent("view:internal", widgetRenderState.currentPageHits);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return _objectSpread50(_objectSpread50({}, renderState), {}, {
          infiniteHits: this.getWidgetRenderState(renderOptions)
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref64) {
        var _results$renderingCon, _results$renderingCon2, _results$renderingCon3;
        var results = _ref64.results, helper = _ref64.helper, parent = _ref64.parent, existingState = _ref64.state, instantSearchInstance = _ref64.instantSearchInstance;
        var getCacheHits = function getCacheHits2() {
          var state2 = parent.getPreviousState() || existingState;
          return cache.read({
            state: normalizeState(state2)
          }) || {};
        };
        var isFirstPage;
        var currentPageHits = [];
        var state = parent.getPreviousState() || existingState;
        var cachedHits = getCacheHits();
        var banner = results === null || results === void 0 ? void 0 : (_results$renderingCon = results.renderingContent) === null || _results$renderingCon === void 0 ? void 0 : (_results$renderingCon2 = _results$renderingCon.widgets) === null || _results$renderingCon2 === void 0 ? void 0 : (_results$renderingCon3 = _results$renderingCon2.banners) === null || _results$renderingCon3 === void 0 ? void 0 : _results$renderingCon3[0];
        if (!showPrevious) {
          showPrevious = function showPrevious2() {
            return getShowPrevious(helper, getCacheHits)();
          };
          showMore = function showMore2() {
            return getShowMore(helper, getCacheHits)();
          };
        }
        if (!sendEvent) {
          sendEvent = createSendEventForHits({
            instantSearchInstance,
            helper,
            widgetType: this.$$type
          });
          bindEvent = createBindEventForHits({
            helper,
            widgetType: this.$$type,
            instantSearchInstance
          });
        }
        if (!results) {
          isFirstPage = state.page === void 0 || getFirstReceivedPage(state, cachedHits) === 0;
        } else {
          var _state$disjunctiveFac, _state$hierarchicalFa;
          var _state$page3 = state.page, _page = _state$page3 === void 0 ? 0 : _state$page3;
          if (escapeHTML && results.hits.length > 0) {
            results.hits = escapeHits(results.hits);
          }
          var hitsWithAbsolutePosition = addAbsolutePosition(results.hits, results.page, results.hitsPerPage);
          var hitsWithAbsolutePositionAndQueryID = addQueryID(hitsWithAbsolutePosition, results.queryID);
          var transformedHits = transformItems(hitsWithAbsolutePositionAndQueryID, {
            results
          });
          var hasDynamicWidgets = false;
          walkIndex(instantSearchInstance.mainIndex, function(indexWidget) {
            if (!hasDynamicWidgets && indexWidget.getWidgets().some(function(_ref72) {
              var $$type6 = _ref72.$$type;
              return $$type6 === "ais.dynamicWidgets";
            })) {
              hasDynamicWidgets = true;
            }
          });
          var hasNoFacets = !((_state$disjunctiveFac = state.disjunctiveFacets) !== null && _state$disjunctiveFac !== void 0 && _state$disjunctiveFac.length) && !(state.facets || []).filter(function(f4) {
            return f4 !== "*";
          }).length && !((_state$hierarchicalFa = state.hierarchicalFacets) !== null && _state$hierarchicalFa !== void 0 && _state$hierarchicalFa.length);
          if (cachedHits[_page] === void 0 && !results.__isArtificial && instantSearchInstance.status === "idle" && !(hasDynamicWidgets && hasNoFacets)) {
            cachedHits[_page] = transformedHits;
            cache.write({
              state: normalizeState(state),
              hits: cachedHits
            });
          }
          currentPageHits = transformedHits;
          isFirstPage = getFirstReceivedPage(state, cachedHits) === 0;
        }
        var items = extractHitsFromCachedHits(cachedHits);
        var isLastPage = results ? results.nbPages <= getLastReceivedPage(state, cachedHits) + 1 : true;
        return {
          hits: items,
          items,
          currentPageHits,
          sendEvent,
          bindEvent,
          banner,
          results: results || void 0,
          showPrevious,
          showMore,
          isFirstPage,
          isLastPage,
          widgetParams
        };
      },
      dispose: function dispose(_ref82) {
        var state = _ref82.state;
        unmountFn();
        var stateWithoutPage = state.setQueryParameter("page", void 0);
        if (!escapeHTML) {
          return stateWithoutPage;
        }
        return stateWithoutPage.setQueryParameters(Object.keys(TAG_PLACEHOLDER).reduce(function(acc, key2) {
          return _objectSpread50(_objectSpread50({}, acc), {}, _defineProperty41({}, key2, void 0));
        }, {}));
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref9) {
        var searchParameters = _ref9.searchParameters;
        var page2 = searchParameters.page || 0;
        if (!page2) {
          return uiState;
        }
        return _objectSpread50(_objectSpread50({}, uiState), {}, {
          // The page in the UI state is incremented by one
          // to expose the user value (not `0`).
          page: page2 + 1
        });
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref10) {
        var uiState = _ref10.uiState;
        var widgetSearchParameters = searchParameters;
        if (escapeHTML) {
          widgetSearchParameters = searchParameters.setQueryParameters(TAG_PLACEHOLDER);
        }
        var page2 = uiState.page ? uiState.page - 1 : 0;
        return widgetSearchParameters.setQueryParameter("page", page2);
      }
    };
  };
};

// node_modules/instantsearch.js/es/widgets/infinite-hits/defaultTemplates.js
var defaultTemplates7 = {
  empty: function empty2() {
    return "No results";
  },
  showPreviousText: function showPreviousText() {
    return "Show previous results";
  },
  showMoreText: function showMoreText2() {
    return "Show more results";
  },
  item: function item4(data) {
    return JSON.stringify(omit(data, ["__hitIndex"]), null, 2);
  }
};
var defaultTemplates_default7 = defaultTemplates7;

// node_modules/instantsearch.js/es/widgets/infinite-hits/infinite-hits.js
function _typeof42(o4) {
  "@babel/helpers - typeof";
  return _typeof42 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof42(o4);
}
function ownKeys51(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread51(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys51(Object(t4), true).forEach(function(r4) {
      _defineProperty42(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys51(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty42(obj, key2, value) {
  key2 = _toPropertyKey41(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey41(t4) {
  var i4 = _toPrimitive41(t4, "string");
  return "symbol" == _typeof42(i4) ? i4 : String(i4);
}
function _toPrimitive41(t4, r3) {
  if ("object" != _typeof42(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof42(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage23 = createDocumentationMessageGenerator({
  name: "infinite-hits"
});
var suit9 = component("InfiniteHits");
var renderer17 = function renderer18(_ref9) {
  var containerNode = _ref9.containerNode, cssClasses = _ref9.cssClasses, renderState = _ref9.renderState, templates = _ref9.templates, hasShowPrevious = _ref9.showPrevious;
  return function(_ref23, isFirstRendering) {
    var items = _ref23.items, results = _ref23.results, showMore = _ref23.showMore, showPrevious = _ref23.showPrevious, isFirstPage = _ref23.isFirstPage, isLastPage = _ref23.isLastPage, instantSearchInstance = _ref23.instantSearchInstance, insights = _ref23.insights, bindEvent = _ref23.bindEvent, sendEvent = _ref23.sendEvent, banner = _ref23.banner;
    if (isFirstRendering) {
      renderState.templateProps = prepareTemplateProps({
        defaultTemplates: defaultTemplates_default7,
        templatesConfig: instantSearchInstance.templatesConfig,
        templates
      });
      return;
    }
    N2(y2(InfiniteHits_default, {
      cssClasses,
      hits: items,
      results,
      hasShowPrevious,
      showPrevious,
      showMore,
      templateProps: renderState.templateProps,
      isFirstPage,
      isLastPage,
      insights,
      sendEvent,
      bindEvent,
      banner
    }), containerNode);
  };
};
var infinite_hits_default = function infiniteHits(widgetParams) {
  var _ref33 = widgetParams || {}, container = _ref33.container, escapeHTML = _ref33.escapeHTML, transformItems = _ref33.transformItems, _ref3$templates = _ref33.templates, templates = _ref3$templates === void 0 ? {} : _ref3$templates, _ref3$cssClasses = _ref33.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses, showPrevious = _ref33.showPrevious, cache = _ref33.cache;
  if (!container) {
    throw new Error(withUsage23("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var cssClasses = {
    root: cx(suit9(), userCssClasses.root),
    emptyRoot: cx(suit9({
      modifierName: "empty"
    }), userCssClasses.emptyRoot),
    item: cx(suit9({
      descendantName: "item"
    }), userCssClasses.item),
    list: cx(suit9({
      descendantName: "list"
    }), userCssClasses.list),
    loadPrevious: cx(suit9({
      descendantName: "loadPrevious"
    }), userCssClasses.loadPrevious),
    disabledLoadPrevious: cx(suit9({
      descendantName: "loadPrevious",
      modifierName: "disabled"
    }), userCssClasses.disabledLoadPrevious),
    loadMore: cx(suit9({
      descendantName: "loadMore"
    }), userCssClasses.loadMore),
    disabledLoadMore: cx(suit9({
      descendantName: "loadMore",
      modifierName: "disabled"
    }), userCssClasses.disabledLoadMore),
    bannerRoot: cx(suit9({
      descendantName: "banner"
    }), userCssClasses.bannerRoot),
    bannerImage: cx(suit9({
      descendantName: "banner-image"
    }), userCssClasses.bannerImage),
    bannerLink: cx(suit9({
      descendantName: "banner-link"
    }), userCssClasses.bannerLink)
  };
  var specializedRenderer = renderer17({
    containerNode,
    cssClasses,
    templates,
    showPrevious,
    renderState: {}
  });
  var makeWidget = withInsights(connectInfiniteHits_default)(specializedRenderer, function() {
    return N2(null, containerNode);
  });
  return _objectSpread51(_objectSpread51({}, makeWidget({
    escapeHTML,
    transformItems,
    showPrevious,
    cache
  })), {}, {
    $$widgetType: "ais.infiniteHits"
  });
};

// node_modules/instantsearch.js/es/connectors/menu/connectMenu.js
var _excluded35 = ["name", "escapedValue", "path"];
function _typeof43(o4) {
  "@babel/helpers - typeof";
  return _typeof43 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof43(o4);
}
function _objectWithoutProperties16(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose16(source, excluded);
  var key2, i4;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i4 = 0; i4 < sourceSymbolKeys.length; i4++) {
      key2 = sourceSymbolKeys[i4];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose16(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i4;
  for (i4 = 0; i4 < sourceKeys.length; i4++) {
    key2 = sourceKeys[i4];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function _slicedToArray8(arr, i4) {
  return _arrayWithHoles8(arr) || _iterableToArrayLimit8(arr, i4) || _unsupportedIterableToArray16(arr, i4) || _nonIterableRest8();
}
function _nonIterableRest8() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray16(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray16(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray16(o4, minLen);
}
function _arrayLikeToArray16(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
function _iterableToArrayLimit8(r3, l4) {
  var t4 = null == r3 ? null : "undefined" != typeof Symbol && r3[Symbol.iterator] || r3["@@iterator"];
  if (null != t4) {
    var e4, n4, i4, u4, a4 = [], f4 = true, o4 = false;
    try {
      if (i4 = (t4 = t4.call(r3)).next, 0 === l4) {
        if (Object(t4) !== t4)
          return;
        f4 = false;
      } else
        for (; !(f4 = (e4 = i4.call(t4)).done) && (a4.push(e4.value), a4.length !== l4); f4 = true)
          ;
    } catch (r4) {
      o4 = true, n4 = r4;
    } finally {
      try {
        if (!f4 && null != t4.return && (u4 = t4.return(), Object(u4) !== u4))
          return;
      } finally {
        if (o4)
          throw n4;
      }
    }
    return a4;
  }
}
function _arrayWithHoles8(arr) {
  if (Array.isArray(arr))
    return arr;
}
function ownKeys52(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread52(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys52(Object(t4), true).forEach(function(r4) {
      _defineProperty43(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys52(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty43(obj, key2, value) {
  key2 = _toPropertyKey42(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey42(t4) {
  var i4 = _toPrimitive42(t4, "string");
  return "symbol" == _typeof43(i4) ? i4 : String(i4);
}
function _toPrimitive42(t4, r3) {
  if ("object" != _typeof43(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof43(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage24 = createDocumentationMessageGenerator({
  name: "menu",
  connector: true
});
var DEFAULT_SORT2 = ["isRefined", "name:asc"];
var connectMenu = function connectMenu2(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage24());
  return function(widgetParams) {
    var _ref9 = widgetParams || {}, attribute = _ref9.attribute, _ref$limit = _ref9.limit, limit = _ref$limit === void 0 ? 10 : _ref$limit, _ref$showMore = _ref9.showMore, showMore = _ref$showMore === void 0 ? false : _ref$showMore, _ref$showMoreLimit = _ref9.showMoreLimit, showMoreLimit = _ref$showMoreLimit === void 0 ? 20 : _ref$showMoreLimit, _ref$sortBy = _ref9.sortBy, sortBy3 = _ref$sortBy === void 0 ? DEFAULT_SORT2 : _ref$sortBy, _ref$transformItems = _ref9.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
      return items;
    } : _ref$transformItems;
    if (!attribute) {
      throw new Error(withUsage24("The `attribute` option is required."));
    }
    if (showMore === true && showMoreLimit <= limit) {
      throw new Error(withUsage24("The `showMoreLimit` option must be greater than `limit`."));
    }
    var sendEvent;
    var _createURL;
    var _refine2;
    var isShowingMore = false;
    var toggleShowMore = function toggleShowMore2() {
    };
    function createToggleShowMore(renderOptions, widget) {
      return function() {
        isShowingMore = !isShowingMore;
        widget.render(renderOptions);
      };
    }
    function cachedToggleShowMore() {
      toggleShowMore();
    }
    function getLimit() {
      return isShowingMore ? showMoreLimit : limit;
    }
    return {
      $$type: "ais.menu",
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(_objectSpread52(_objectSpread52({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(_objectSpread52(_objectSpread52({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance
        }), false);
      },
      dispose: function dispose(_ref23) {
        var state = _ref23.state;
        unmountFn();
        return state.removeHierarchicalFacet(attribute).setQueryParameter("maxValuesPerFacet", void 0);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return _objectSpread52(_objectSpread52({}, renderState), {}, {
          menu: _objectSpread52(_objectSpread52({}, renderState.menu), {}, _defineProperty43({}, attribute, this.getWidgetRenderState(renderOptions)))
        });
      },
      getWidgetRenderState: function getWidgetRenderState(renderOptions) {
        var _this = this;
        var results = renderOptions.results, createURL = renderOptions.createURL, instantSearchInstance = renderOptions.instantSearchInstance, helper = renderOptions.helper;
        var items = [];
        var canToggleShowMore = false;
        if (!sendEvent) {
          sendEvent = createSendEventForFacet({
            instantSearchInstance,
            helper,
            attribute,
            widgetType: this.$$type
          });
        }
        if (!_createURL) {
          _createURL = function _createURL2(facetValue) {
            return createURL(function(uiState) {
              return _this.getWidgetUiState(uiState, {
                searchParameters: helper.state.resetPage().toggleFacetRefinement(attribute, facetValue),
                helper
              });
            });
          };
        }
        if (!_refine2) {
          _refine2 = function _refine3(facetValue) {
            var _helper$getHierarchic = helper.getHierarchicalFacetBreadcrumb(attribute), _helper$getHierarchic2 = _slicedToArray8(_helper$getHierarchic, 1), refinedItem = _helper$getHierarchic2[0];
            sendEvent("click:internal", facetValue ? facetValue : refinedItem);
            helper.toggleFacetRefinement(attribute, facetValue ? facetValue : refinedItem).search();
          };
        }
        if (renderOptions.results) {
          toggleShowMore = createToggleShowMore(renderOptions, this);
        }
        if (results) {
          var facetValues = results.getFacetValues(attribute, {
            sortBy: sortBy3,
            facetOrdering: sortBy3 === DEFAULT_SORT2
          });
          var facetItems = facetValues && !Array.isArray(facetValues) && facetValues.data ? facetValues.data : [];
          canToggleShowMore = showMore && (isShowingMore || facetItems.length > getLimit());
          items = transformItems(facetItems.slice(0, getLimit()).map(function(_ref33) {
            var label = _ref33.name, value = _ref33.escapedValue, path = _ref33.path, item11 = _objectWithoutProperties16(_ref33, _excluded35);
            return _objectSpread52(_objectSpread52({}, item11), {}, {
              label,
              value
            });
          }), {
            results
          });
        }
        return {
          items,
          createURL: _createURL,
          refine: _refine2,
          sendEvent,
          canRefine: items.length > 0,
          widgetParams,
          isShowingMore,
          toggleShowMore: cachedToggleShowMore,
          canToggleShowMore
        };
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref44) {
        var searchParameters = _ref44.searchParameters;
        var _searchParameters$get = searchParameters.getHierarchicalFacetBreadcrumb(attribute), _searchParameters$get2 = _slicedToArray8(_searchParameters$get, 1), value = _searchParameters$get2[0];
        return removeEmptyRefinementsFromUiState3(_objectSpread52(_objectSpread52({}, uiState), {}, {
          menu: _objectSpread52(_objectSpread52({}, uiState.menu), {}, _defineProperty43({}, attribute, value))
        }), attribute);
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref52) {
        var uiState = _ref52.uiState;
        var value = uiState.menu && uiState.menu[attribute];
        if (searchParameters.isConjunctiveFacet(attribute) || searchParameters.isDisjunctiveFacet(attribute)) {
          false ? _warning(false, 'Menu: Attribute "'.concat(attribute, '" is already used by another widget applying conjunctive or disjunctive faceting.\nAs this is not supported, please make sure to remove this other widget or this Menu widget will not work at all.')) : void 0;
          return searchParameters;
        }
        var withFacetConfiguration = searchParameters.removeHierarchicalFacet(attribute).addHierarchicalFacet({
          name: attribute,
          attributes: [attribute]
        });
        var currentMaxValuesPerFacet = withFacetConfiguration.maxValuesPerFacet || 0;
        var nextMaxValuesPerFacet = Math.max(currentMaxValuesPerFacet, showMore ? showMoreLimit : limit);
        var withMaxValuesPerFacet = withFacetConfiguration.setQueryParameter("maxValuesPerFacet", nextMaxValuesPerFacet);
        if (!value) {
          return withMaxValuesPerFacet.setQueryParameters({
            hierarchicalFacetsRefinements: _objectSpread52(_objectSpread52({}, withMaxValuesPerFacet.hierarchicalFacetsRefinements), {}, _defineProperty43({}, attribute, []))
          });
        }
        return withMaxValuesPerFacet.addHierarchicalFacetRefinement(attribute, value);
      }
    };
  };
};
function removeEmptyRefinementsFromUiState3(indexUiState, attribute) {
  if (!indexUiState.menu) {
    return indexUiState;
  }
  if (indexUiState.menu[attribute] === void 0) {
    delete indexUiState.menu[attribute];
  }
  if (Object.keys(indexUiState.menu).length === 0) {
    delete indexUiState.menu;
  }
  return indexUiState;
}
var connectMenu_default = connectMenu;

// node_modules/instantsearch.js/es/widgets/menu/defaultTemplates.js
var defaultTemplates8 = {
  item: function item5(_ref9) {
    var cssClasses = _ref9.cssClasses, url2 = _ref9.url, label = _ref9.label, count = _ref9.count;
    return y2("a", {
      className: cx(cssClasses.link),
      href: url2
    }, y2("span", {
      className: cx(cssClasses.label)
    }, label), y2("span", {
      className: cx(cssClasses.count)
    }, formatNumber(count)));
  },
  showMoreText: function showMoreText3(_ref23) {
    var isShowingMore = _ref23.isShowingMore;
    return isShowingMore ? "Show less" : "Show more";
  }
};
var defaultTemplates_default8 = defaultTemplates8;

// node_modules/instantsearch.js/es/widgets/menu/menu.js
function _typeof44(o4) {
  "@babel/helpers - typeof";
  return _typeof44 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof44(o4);
}
function ownKeys53(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread53(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys53(Object(t4), true).forEach(function(r4) {
      _defineProperty44(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys53(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty44(obj, key2, value) {
  key2 = _toPropertyKey43(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey43(t4) {
  var i4 = _toPrimitive43(t4, "string");
  return "symbol" == _typeof44(i4) ? i4 : String(i4);
}
function _toPrimitive43(t4, r3) {
  if ("object" != _typeof44(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof44(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage25 = createDocumentationMessageGenerator({
  name: "menu"
});
var suit10 = component("Menu");
var renderer19 = function renderer20(_ref9) {
  var containerNode = _ref9.containerNode, cssClasses = _ref9.cssClasses, renderState = _ref9.renderState, templates = _ref9.templates, showMore = _ref9.showMore;
  return function(_ref23, isFirstRendering) {
    var refine2 = _ref23.refine, items = _ref23.items, createURL = _ref23.createURL, instantSearchInstance = _ref23.instantSearchInstance, isShowingMore = _ref23.isShowingMore, toggleShowMore = _ref23.toggleShowMore, canToggleShowMore = _ref23.canToggleShowMore;
    if (isFirstRendering) {
      renderState.templateProps = prepareTemplateProps({
        defaultTemplates: defaultTemplates_default8,
        templatesConfig: instantSearchInstance.templatesConfig,
        templates
      });
      return;
    }
    var facetValues = items.map(function(facetValue) {
      return _objectSpread53(_objectSpread53({}, facetValue), {}, {
        url: createURL(facetValue.value)
      });
    });
    N2(y2(RefinementList_default, {
      createURL,
      cssClasses,
      facetValues,
      showMore,
      templateProps: renderState.templateProps,
      toggleRefinement: refine2,
      toggleShowMore,
      isShowingMore,
      canToggleShowMore
    }), containerNode);
  };
};
var menu = function menu2(widgetParams) {
  var _ref33 = widgetParams || {}, container = _ref33.container, attribute = _ref33.attribute, sortBy3 = _ref33.sortBy, limit = _ref33.limit, showMore = _ref33.showMore, showMoreLimit = _ref33.showMoreLimit, _ref3$cssClasses = _ref33.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses, _ref3$templates = _ref33.templates, templates = _ref3$templates === void 0 ? {} : _ref3$templates, transformItems = _ref33.transformItems;
  if (!container) {
    throw new Error(withUsage25("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var cssClasses = {
    root: cx(suit10(), userCssClasses.root),
    noRefinementRoot: cx(suit10({
      modifierName: "noRefinement"
    }), userCssClasses.noRefinementRoot),
    list: cx(suit10({
      descendantName: "list"
    }), userCssClasses.list),
    item: cx(suit10({
      descendantName: "item"
    }), userCssClasses.item),
    selectedItem: cx(suit10({
      descendantName: "item",
      modifierName: "selected"
    }), userCssClasses.selectedItem),
    link: cx(suit10({
      descendantName: "link"
    }), userCssClasses.link),
    label: cx(suit10({
      descendantName: "label"
    }), userCssClasses.label),
    count: cx(suit10({
      descendantName: "count"
    }), userCssClasses.count),
    showMore: cx(suit10({
      descendantName: "showMore"
    }), userCssClasses.showMore),
    disabledShowMore: cx(suit10({
      descendantName: "showMore",
      modifierName: "disabled"
    }), userCssClasses.disabledShowMore)
  };
  var specializedRenderer = renderer19({
    containerNode,
    cssClasses,
    renderState: {},
    templates,
    showMore
  });
  var makeWidget = connectMenu_default(specializedRenderer, function() {
    return N2(null, containerNode);
  });
  return _objectSpread53(_objectSpread53({}, makeWidget({
    attribute,
    limit,
    showMore,
    showMoreLimit,
    sortBy: sortBy3,
    transformItems
  })), {}, {
    $$widgetType: "ais.menu"
  });
};
var menu_default = menu;

// node_modules/instantsearch.js/es/components/MenuSelect/MenuSelect.js
function _extends19() {
  _extends19 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends19.apply(this, arguments);
}
function MenuSelect(_ref9) {
  var cssClasses = _ref9.cssClasses, templateProps = _ref9.templateProps, items = _ref9.items, refine2 = _ref9.refine;
  var _ref23 = find(items, function(item11) {
    return item11.isRefined;
  }) || {
    value: ""
  }, selectedValue = _ref23.value;
  return y2("div", {
    className: cx(cssClasses.root, items.length === 0 && cssClasses.noRefinementRoot)
  }, y2("select", {
    className: cssClasses.select,
    value: selectedValue,
    onChange: function onChange(event) {
      refine2(event.target.value);
    }
  }, y2(Template_default, _extends19({}, templateProps, {
    templateKey: "defaultOption",
    rootTagName: "option",
    rootProps: {
      value: "",
      className: cssClasses.option
    }
  })), items.map(function(item11) {
    return y2(Template_default, _extends19({}, templateProps, {
      templateKey: "item",
      rootTagName: "option",
      rootProps: {
        value: item11.value,
        className: cssClasses.option
      },
      key: item11.value,
      data: item11
    }));
  })));
}
var MenuSelect_default = MenuSelect;

// node_modules/instantsearch.js/es/widgets/menu-select/defaultTemplates.js
var defaultTemplates9 = {
  item: function item6(_ref9) {
    var label = _ref9.label, count = _ref9.count;
    return "".concat(label, " (").concat(formatNumber(count), ")");
  },
  defaultOption: function defaultOption() {
    return "See all";
  }
};
var defaultTemplates_default9 = defaultTemplates9;

// node_modules/instantsearch.js/es/widgets/menu-select/menu-select.js
function _typeof45(o4) {
  "@babel/helpers - typeof";
  return _typeof45 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof45(o4);
}
function ownKeys54(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread54(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys54(Object(t4), true).forEach(function(r4) {
      _defineProperty45(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys54(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty45(obj, key2, value) {
  key2 = _toPropertyKey44(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey44(t4) {
  var i4 = _toPrimitive44(t4, "string");
  return "symbol" == _typeof45(i4) ? i4 : String(i4);
}
function _toPrimitive44(t4, r3) {
  if ("object" != _typeof45(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof45(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage26 = createDocumentationMessageGenerator({
  name: "menu-select"
});
var suit11 = component("MenuSelect");
var renderer21 = function renderer22(_ref9) {
  var containerNode = _ref9.containerNode, cssClasses = _ref9.cssClasses, renderState = _ref9.renderState, templates = _ref9.templates;
  return function(_ref23, isFirstRendering) {
    var refine2 = _ref23.refine, items = _ref23.items, instantSearchInstance = _ref23.instantSearchInstance;
    if (isFirstRendering) {
      renderState.templateProps = prepareTemplateProps({
        defaultTemplates: defaultTemplates_default9,
        templatesConfig: instantSearchInstance.templatesConfig,
        templates
      });
      return;
    }
    N2(y2(MenuSelect_default, {
      cssClasses,
      items,
      refine: refine2,
      templateProps: renderState.templateProps
    }), containerNode);
  };
};
var menuSelect = function menuSelect2(widgetParams) {
  var _ref33 = widgetParams || {}, container = _ref33.container, attribute = _ref33.attribute, _ref3$sortBy = _ref33.sortBy, sortBy3 = _ref3$sortBy === void 0 ? ["name:asc"] : _ref3$sortBy, _ref3$limit = _ref33.limit, limit = _ref3$limit === void 0 ? 10 : _ref3$limit, _ref3$cssClasses = _ref33.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses, _ref3$templates = _ref33.templates, templates = _ref3$templates === void 0 ? {} : _ref3$templates, transformItems = _ref33.transformItems;
  if (!container) {
    throw new Error(withUsage26("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var cssClasses = {
    root: cx(suit11(), userCssClasses.root),
    noRefinementRoot: cx(suit11({
      modifierName: "noRefinement"
    }), userCssClasses.noRefinementRoot),
    select: cx(suit11({
      descendantName: "select"
    }), userCssClasses.select),
    option: cx(suit11({
      descendantName: "option"
    }), userCssClasses.option)
  };
  var specializedRenderer = renderer21({
    containerNode,
    cssClasses,
    renderState: {},
    templates
  });
  var makeWidget = connectMenu_default(specializedRenderer, function() {
    return N2(null, containerNode);
  });
  return _objectSpread54(_objectSpread54({}, makeWidget({
    attribute,
    limit,
    sortBy: sortBy3,
    transformItems
  })), {}, {
    $$widgetType: "ais.menuSelect"
  });
};
var menu_select_default = menuSelect;

// node_modules/instantsearch.js/es/connectors/numeric-menu/connectNumericMenu.js
function _typeof46(o4) {
  "@babel/helpers - typeof";
  return _typeof46 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof46(o4);
}
function _createForOfIteratorHelper(o4, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o4[Symbol.iterator] || o4["@@iterator"];
  if (!it) {
    if (Array.isArray(o4) || (it = _unsupportedIterableToArray17(o4)) || allowArrayLike && o4 && typeof o4.length === "number") {
      if (it)
        o4 = it;
      var i4 = 0;
      var F4 = function F5() {
      };
      return { s: F4, n: function n4() {
        if (i4 >= o4.length)
          return { done: true };
        return { done: false, value: o4[i4++] };
      }, e: function e4(_e2) {
        throw _e2;
      }, f: F4 };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s4() {
    it = it.call(o4);
  }, n: function n4() {
    var step = it.next();
    normalCompletion = step.done;
    return step;
  }, e: function e4(_e2) {
    didErr = true;
    err = _e2;
  }, f: function f4() {
    try {
      if (!normalCompletion && it.return != null)
        it.return();
    } finally {
      if (didErr)
        throw err;
    }
  } };
}
function _slicedToArray9(arr, i4) {
  return _arrayWithHoles9(arr) || _iterableToArrayLimit9(arr, i4) || _unsupportedIterableToArray17(arr, i4) || _nonIterableRest9();
}
function _nonIterableRest9() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray17(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray17(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray17(o4, minLen);
}
function _arrayLikeToArray17(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
function _iterableToArrayLimit9(r3, l4) {
  var t4 = null == r3 ? null : "undefined" != typeof Symbol && r3[Symbol.iterator] || r3["@@iterator"];
  if (null != t4) {
    var e4, n4, i4, u4, a4 = [], f4 = true, o4 = false;
    try {
      if (i4 = (t4 = t4.call(r3)).next, 0 === l4) {
        if (Object(t4) !== t4)
          return;
        f4 = false;
      } else
        for (; !(f4 = (e4 = i4.call(t4)).done) && (a4.push(e4.value), a4.length !== l4); f4 = true)
          ;
    } catch (r4) {
      o4 = true, n4 = r4;
    } finally {
      try {
        if (!f4 && null != t4.return && (u4 = t4.return(), Object(u4) !== u4))
          return;
      } finally {
        if (o4)
          throw n4;
      }
    }
    return a4;
  }
}
function _arrayWithHoles9(arr) {
  if (Array.isArray(arr))
    return arr;
}
function ownKeys55(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread55(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys55(Object(t4), true).forEach(function(r4) {
      _defineProperty46(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys55(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty46(obj, key2, value) {
  key2 = _toPropertyKey45(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey45(t4) {
  var i4 = _toPrimitive45(t4, "string");
  return "symbol" == _typeof46(i4) ? i4 : String(i4);
}
function _toPrimitive45(t4, r3) {
  if ("object" != _typeof46(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof46(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage27 = createDocumentationMessageGenerator({
  name: "numeric-menu",
  connector: true
});
var $$type2 = "ais.numericMenu";
var createSendEvent = function createSendEvent2(_ref9) {
  var instantSearchInstance = _ref9.instantSearchInstance;
  return function() {
    if (arguments.length === 1) {
      instantSearchInstance.sendEventToInsights(arguments.length <= 0 ? void 0 : arguments[0]);
      return;
    }
  };
};
var connectNumericMenu = function connectNumericMenu2(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage27());
  return function(widgetParams) {
    var _ref23 = widgetParams || {}, _ref2$attribute = _ref23.attribute, attribute = _ref2$attribute === void 0 ? "" : _ref2$attribute, _ref2$items = _ref23.items, items = _ref2$items === void 0 ? [] : _ref2$items, _ref2$transformItems = _ref23.transformItems, transformItems = _ref2$transformItems === void 0 ? function(item11) {
      return item11;
    } : _ref2$transformItems;
    if (attribute === "") {
      throw new Error(withUsage27("The `attribute` option is required."));
    }
    if (!items || items.length === 0) {
      throw new Error(withUsage27("The `items` option expects an array of objects."));
    }
    var prepareItems2 = function prepareItems3(state) {
      return items.map(function(_ref33) {
        var start = _ref33.start, end = _ref33.end, label = _ref33.label;
        return {
          label,
          value: encodeURI(JSON.stringify({
            start,
            end
          })),
          isRefined: isRefined(state, attribute, {
            start,
            end,
            label
          })
        };
      });
    };
    var connectorState = {};
    return {
      $$type: $$type2,
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(_objectSpread55(_objectSpread55({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(_objectSpread55(_objectSpread55({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance
        }), false);
      },
      dispose: function dispose(_ref44) {
        var state = _ref44.state;
        unmountFn();
        return state.removeNumericRefinement(attribute);
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref52) {
        var searchParameters = _ref52.searchParameters;
        var values = searchParameters.getNumericRefinements(attribute);
        var equal = values["="] && values["="][0];
        if (equal || equal === 0) {
          return _objectSpread55(_objectSpread55({}, uiState), {}, {
            numericMenu: _objectSpread55(_objectSpread55({}, uiState.numericMenu), {}, _defineProperty46({}, attribute, "".concat(values["="])))
          });
        }
        var min = values[">="] && values[">="][0] || "";
        var max = values["<="] && values["<="][0] || "";
        return removeEmptyRefinementsFromUiState4(_objectSpread55(_objectSpread55({}, uiState), {}, {
          numericMenu: _objectSpread55(_objectSpread55({}, uiState.numericMenu), {}, _defineProperty46({}, attribute, "".concat(min, ":").concat(max)))
        }), attribute);
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref64) {
        var uiState = _ref64.uiState;
        var value = uiState.numericMenu && uiState.numericMenu[attribute];
        var withoutRefinements = searchParameters.setQueryParameters({
          numericRefinements: _objectSpread55(_objectSpread55({}, searchParameters.numericRefinements), {}, _defineProperty46({}, attribute, {}))
        });
        if (!value) {
          return withoutRefinements;
        }
        var isExact = value.indexOf(":") === -1;
        if (isExact) {
          return withoutRefinements.addNumericRefinement(attribute, "=", Number(value));
        }
        var _value$split$map = value.split(":").map(parseFloat), _value$split$map2 = _slicedToArray9(_value$split$map, 2), min = _value$split$map2[0], max = _value$split$map2[1];
        var withMinRefinement = isFiniteNumber(min) ? withoutRefinements.addNumericRefinement(attribute, ">=", min) : withoutRefinements;
        var withMaxRefinement = isFiniteNumber(max) ? withMinRefinement.addNumericRefinement(attribute, "<=", max) : withMinRefinement;
        return withMaxRefinement;
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return _objectSpread55(_objectSpread55({}, renderState), {}, {
          numericMenu: _objectSpread55(_objectSpread55({}, renderState.numericMenu), {}, _defineProperty46({}, attribute, this.getWidgetRenderState(renderOptions)))
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref72) {
        var _this = this;
        var results = _ref72.results, state = _ref72.state, instantSearchInstance = _ref72.instantSearchInstance, helper = _ref72.helper, createURL = _ref72.createURL;
        if (!connectorState.refine) {
          connectorState.refine = function(facetValue) {
            var refinedState = getRefinedState(helper.state, attribute, facetValue);
            connectorState.sendEvent("click:internal", facetValue);
            helper.setState(refinedState).search();
          };
        }
        if (!connectorState.createURL) {
          connectorState.createURL = function(newState) {
            return function(facetValue) {
              return createURL(function(uiState) {
                return _this.getWidgetUiState(uiState, {
                  searchParameters: getRefinedState(newState, attribute, facetValue),
                  helper
                });
              });
            };
          };
        }
        if (!connectorState.sendEvent) {
          connectorState.sendEvent = createSendEvent({
            instantSearchInstance
          });
        }
        var hasNoResults = results ? results.nbHits === 0 : true;
        var preparedItems = prepareItems2(state);
        var allIsSelected = true;
        var _iterator = _createForOfIteratorHelper(preparedItems), _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done; ) {
            var item11 = _step.value;
            if (item11.isRefined && decodeURI(item11.value) !== "{}") {
              allIsSelected = false;
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return {
          createURL: connectorState.createURL(state),
          items: transformItems(preparedItems, {
            results
          }),
          hasNoResults,
          canRefine: !(hasNoResults && allIsSelected),
          refine: connectorState.refine,
          sendEvent: connectorState.sendEvent,
          widgetParams
        };
      }
    };
  };
};
function isRefined(state, attribute, option) {
  var currentRefinements3 = state.getNumericRefinements(attribute);
  if (option.start !== void 0 && option.end !== void 0) {
    if (option.start === option.end) {
      return hasNumericRefinement(currentRefinements3, "=", option.start);
    } else {
      return hasNumericRefinement(currentRefinements3, ">=", option.start) && hasNumericRefinement(currentRefinements3, "<=", option.end);
    }
  }
  if (option.start !== void 0) {
    return hasNumericRefinement(currentRefinements3, ">=", option.start);
  }
  if (option.end !== void 0) {
    return hasNumericRefinement(currentRefinements3, "<=", option.end);
  }
  if (option.start === void 0 && option.end === void 0) {
    return Object.keys(currentRefinements3).every(function(operator) {
      return (currentRefinements3[operator] || []).length === 0;
    });
  }
  return false;
}
function getRefinedState(state, attribute, facetValue) {
  var resolvedState = state;
  var refinedOption = JSON.parse(decodeURI(facetValue));
  var currentRefinements3 = resolvedState.getNumericRefinements(attribute);
  if (refinedOption.start === void 0 && refinedOption.end === void 0) {
    return resolvedState.removeNumericRefinement(attribute);
  }
  if (!isRefined(resolvedState, attribute, refinedOption)) {
    resolvedState = resolvedState.removeNumericRefinement(attribute);
  }
  if (refinedOption.start !== void 0 && refinedOption.end !== void 0) {
    if (refinedOption.start > refinedOption.end) {
      throw new Error("option.start should be > to option.end");
    }
    if (refinedOption.start === refinedOption.end) {
      if (hasNumericRefinement(currentRefinements3, "=", refinedOption.start)) {
        resolvedState = resolvedState.removeNumericRefinement(attribute, "=", refinedOption.start);
      } else {
        resolvedState = resolvedState.addNumericRefinement(attribute, "=", refinedOption.start);
      }
      return resolvedState;
    }
  }
  if (refinedOption.start !== void 0) {
    if (hasNumericRefinement(currentRefinements3, ">=", refinedOption.start)) {
      resolvedState = resolvedState.removeNumericRefinement(attribute, ">=", refinedOption.start);
    }
    resolvedState = resolvedState.addNumericRefinement(attribute, ">=", refinedOption.start);
  }
  if (refinedOption.end !== void 0) {
    if (hasNumericRefinement(currentRefinements3, "<=", refinedOption.end)) {
      resolvedState = resolvedState.removeNumericRefinement(attribute, "<=", refinedOption.end);
    }
    resolvedState = resolvedState.addNumericRefinement(attribute, "<=", refinedOption.end);
  }
  if (typeof resolvedState.page === "number") {
    resolvedState.page = 0;
  }
  return resolvedState;
}
function hasNumericRefinement(currentRefinements3, operator, value) {
  return currentRefinements3[operator] !== void 0 && currentRefinements3[operator].includes(value);
}
function removeEmptyRefinementsFromUiState4(indexUiState, attribute) {
  if (!indexUiState.numericMenu) {
    return indexUiState;
  }
  if (indexUiState.numericMenu[attribute] === ":") {
    delete indexUiState.numericMenu[attribute];
  }
  if (Object.keys(indexUiState.numericMenu).length === 0) {
    delete indexUiState.numericMenu;
  }
  return indexUiState;
}
var connectNumericMenu_default = connectNumericMenu;

// node_modules/instantsearch.js/es/widgets/numeric-menu/defaultTemplates.js
var defaultTemplates10 = {
  item: function item7(_ref9) {
    var cssClasses = _ref9.cssClasses, attribute = _ref9.attribute, label = _ref9.label, isRefined2 = _ref9.isRefined;
    return y2("label", {
      className: cssClasses.label
    }, y2("input", {
      type: "radio",
      className: cssClasses.radio,
      name: attribute,
      defaultChecked: isRefined2
    }), y2("span", {
      className: cssClasses.labelText
    }, label));
  }
};
var defaultTemplates_default10 = defaultTemplates10;

// node_modules/instantsearch.js/es/widgets/numeric-menu/numeric-menu.js
function _typeof47(o4) {
  "@babel/helpers - typeof";
  return _typeof47 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof47(o4);
}
function ownKeys56(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread56(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys56(Object(t4), true).forEach(function(r4) {
      _defineProperty47(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys56(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty47(obj, key2, value) {
  key2 = _toPropertyKey46(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey46(t4) {
  var i4 = _toPrimitive46(t4, "string");
  return "symbol" == _typeof47(i4) ? i4 : String(i4);
}
function _toPrimitive46(t4, r3) {
  if ("object" != _typeof47(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof47(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage28 = createDocumentationMessageGenerator({
  name: "numeric-menu"
});
var suit12 = component("NumericMenu");
var renderer23 = function renderer24(_ref9) {
  var containerNode = _ref9.containerNode, attribute = _ref9.attribute, cssClasses = _ref9.cssClasses, renderState = _ref9.renderState, templates = _ref9.templates;
  return function(_ref23, isFirstRendering) {
    var createURL = _ref23.createURL, instantSearchInstance = _ref23.instantSearchInstance, refine2 = _ref23.refine, items = _ref23.items;
    if (isFirstRendering) {
      renderState.templateProps = prepareTemplateProps({
        defaultTemplates: defaultTemplates_default10,
        templatesConfig: instantSearchInstance.templatesConfig,
        templates
      });
      return;
    }
    N2(y2(RefinementList_default, {
      createURL,
      cssClasses,
      facetValues: items,
      templateProps: renderState.templateProps,
      toggleRefinement: refine2,
      attribute
    }), containerNode);
  };
};
var numericMenu = function numericMenu2(widgetParams) {
  var _ref33 = widgetParams || {}, container = _ref33.container, attribute = _ref33.attribute, items = _ref33.items, _ref3$cssClasses = _ref33.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses, _ref3$templates = _ref33.templates, templates = _ref3$templates === void 0 ? {} : _ref3$templates, transformItems = _ref33.transformItems;
  if (!container) {
    throw new Error(withUsage28("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var cssClasses = {
    root: cx(suit12(), userCssClasses.root),
    noRefinementRoot: cx(suit12({
      modifierName: "noRefinement"
    }), userCssClasses.noRefinementRoot),
    list: cx(suit12({
      descendantName: "list"
    }), userCssClasses.list),
    item: cx(suit12({
      descendantName: "item"
    }), userCssClasses.item),
    selectedItem: cx(suit12({
      descendantName: "item",
      modifierName: "selected"
    }), userCssClasses.selectedItem),
    label: cx(suit12({
      descendantName: "label"
    }), userCssClasses.label),
    radio: cx(suit12({
      descendantName: "radio"
    }), userCssClasses.radio),
    labelText: cx(suit12({
      descendantName: "labelText"
    }), userCssClasses.labelText)
  };
  var specializedRenderer = renderer23({
    containerNode,
    attribute,
    cssClasses,
    renderState: {},
    templates
  });
  var makeWidget = connectNumericMenu_default(specializedRenderer, function() {
    return N2(null, containerNode);
  });
  return _objectSpread56(_objectSpread56({}, makeWidget({
    attribute,
    items,
    transformItems
  })), {}, {
    $$widgetType: "ais.numericMenu"
  });
};
var numeric_menu_default = numericMenu;

// node_modules/instantsearch.js/es/components/Pagination/Pagination.js
function Pagination(props) {
  function createClickHandler(pageNumber) {
    return function(event) {
      if (isSpecialClick(event)) {
        return;
      }
      event.preventDefault();
      props.setCurrentPage(pageNumber);
    };
  }
  return y2("div", {
    className: cx(props.cssClasses.root, props.nbPages <= 1 && props.cssClasses.noRefinementRoot)
  }, y2("ul", {
    className: props.cssClasses.list
  }, props.showFirst && y2(PaginationLink, {
    ariaLabel: "First Page",
    className: props.cssClasses.firstPageItem,
    isDisabled: props.isFirstPage,
    templates: props.templates,
    templateKey: "first",
    pageNumber: 0,
    createURL: props.createURL,
    cssClasses: props.cssClasses,
    createClickHandler
  }), props.showPrevious && y2(PaginationLink, {
    ariaLabel: "Previous Page",
    className: props.cssClasses.previousPageItem,
    isDisabled: props.isFirstPage,
    templates: props.templates,
    templateKey: "previous",
    pageNumber: props.currentPage - 1,
    createURL: props.createURL,
    cssClasses: props.cssClasses,
    createClickHandler
  }), props.pages.map(function(pageNumber) {
    return y2(PaginationLink, {
      key: pageNumber,
      ariaLabel: "Page ".concat(pageNumber + 1),
      className: props.cssClasses.pageItem,
      isSelected: pageNumber === props.currentPage,
      templates: props.templates,
      templateKey: "page",
      pageNumber,
      createURL: props.createURL,
      cssClasses: props.cssClasses,
      createClickHandler
    });
  }), props.showNext && y2(PaginationLink, {
    ariaLabel: "Next Page",
    className: props.cssClasses.nextPageItem,
    isDisabled: props.isLastPage,
    templates: props.templates,
    templateKey: "next",
    pageNumber: props.currentPage + 1,
    createURL: props.createURL,
    cssClasses: props.cssClasses,
    createClickHandler
  }), props.showLast && y2(PaginationLink, {
    ariaLabel: "Last Page, Page ".concat(props.nbPages),
    className: props.cssClasses.lastPageItem,
    isDisabled: props.isLastPage,
    templates: props.templates,
    templateKey: "last",
    pageNumber: props.nbPages - 1,
    createURL: props.createURL,
    cssClasses: props.cssClasses,
    createClickHandler
  })));
}
function PaginationLink(_ref9) {
  var templates = _ref9.templates, templateKey = _ref9.templateKey, ariaLabel = _ref9.ariaLabel, pageNumber = _ref9.pageNumber, className = _ref9.className, _ref$isDisabled = _ref9.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref9.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, cssClasses = _ref9.cssClasses, createURL = _ref9.createURL, createClickHandler = _ref9.createClickHandler;
  return y2("li", {
    className: cx(cssClasses.item, isDisabled && cssClasses.disabledItem, className, isSelected && cssClasses.selectedItem)
  }, isDisabled ? y2(Template_default, {
    rootTagName: "span",
    rootProps: {
      className: cssClasses.link,
      "aria-label": ariaLabel
    },
    templateKey,
    templates,
    data: {
      page: pageNumber + 1
    }
  }) : y2(Template_default, {
    rootTagName: "a",
    rootProps: {
      className: cssClasses.link,
      "aria-label": ariaLabel,
      href: createURL(pageNumber),
      onClick: createClickHandler(pageNumber)
    },
    templateKey,
    templates,
    data: {
      page: pageNumber + 1
    }
  }));
}
var Pagination_default = Pagination;

// node_modules/instantsearch.js/es/connectors/pagination/Paginator.js
function _typeof48(o4) {
  "@babel/helpers - typeof";
  return _typeof48 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof48(o4);
}
function _classCallCheck5(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties5(target, props) {
  for (var i4 = 0; i4 < props.length; i4++) {
    var descriptor = props[i4];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey47(descriptor.key), descriptor);
  }
}
function _createClass5(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties5(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties5(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _defineProperty48(obj, key2, value) {
  key2 = _toPropertyKey47(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey47(t4) {
  var i4 = _toPrimitive47(t4, "string");
  return "symbol" == _typeof48(i4) ? i4 : String(i4);
}
function _toPrimitive47(t4, r3) {
  if ("object" != _typeof48(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof48(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var Paginator = /* @__PURE__ */ function() {
  function Paginator2(params) {
    _classCallCheck5(this, Paginator2);
    _defineProperty48(this, "currentPage", void 0);
    _defineProperty48(this, "total", void 0);
    _defineProperty48(this, "padding", void 0);
    this.currentPage = params.currentPage;
    this.total = params.total;
    this.padding = params.padding;
  }
  _createClass5(Paginator2, [{
    key: "pages",
    value: function pages() {
      var total = this.total, currentPage = this.currentPage, padding = this.padding;
      if (total === 0)
        return [0];
      var totalDisplayedPages = this.nbPagesDisplayed(padding, total);
      if (totalDisplayedPages === total) {
        return range({
          end: total
        });
      }
      var paddingLeft = this.calculatePaddingLeft(currentPage, padding, total, totalDisplayedPages);
      var paddingRight = totalDisplayedPages - paddingLeft;
      var first2 = currentPage - paddingLeft;
      var last2 = currentPage + paddingRight;
      return range({
        start: first2,
        end: last2
      });
    }
  }, {
    key: "nbPagesDisplayed",
    value: function nbPagesDisplayed(padding, total) {
      return Math.min(2 * padding + 1, total);
    }
  }, {
    key: "calculatePaddingLeft",
    value: function calculatePaddingLeft(current, padding, total, totalDisplayedPages) {
      if (current <= padding) {
        return current;
      }
      if (current >= total - padding) {
        return totalDisplayedPages - (total - current);
      }
      return padding;
    }
  }, {
    key: "isLastPage",
    value: function isLastPage() {
      return this.currentPage >= this.total - 1;
    }
  }, {
    key: "isFirstPage",
    value: function isFirstPage() {
      return this.currentPage <= 0;
    }
  }]);
  return Paginator2;
}();
var Paginator_default = Paginator;

// node_modules/instantsearch.js/es/connectors/pagination/connectPagination.js
function _typeof49(o4) {
  "@babel/helpers - typeof";
  return _typeof49 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof49(o4);
}
function ownKeys57(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread57(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys57(Object(t4), true).forEach(function(r4) {
      _defineProperty49(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys57(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty49(obj, key2, value) {
  key2 = _toPropertyKey48(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey48(t4) {
  var i4 = _toPrimitive48(t4, "string");
  return "symbol" == _typeof49(i4) ? i4 : String(i4);
}
function _toPrimitive48(t4, r3) {
  if ("object" != _typeof49(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof49(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage29 = createDocumentationMessageGenerator({
  name: "pagination",
  connector: true
});
var connectPagination = function connectPagination2(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage29());
  return function(widgetParams) {
    var _ref9 = widgetParams || {}, totalPages = _ref9.totalPages, _ref$padding = _ref9.padding, padding = _ref$padding === void 0 ? 3 : _ref$padding;
    var pager = new Paginator_default({
      currentPage: 0,
      total: 0,
      padding
    });
    var connectorState = {};
    function getMaxPage(_ref23) {
      var nbPages = _ref23.nbPages;
      return totalPages !== void 0 ? Math.min(totalPages, nbPages) : nbPages;
    }
    return {
      $$type: "ais.pagination",
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(_objectSpread57(_objectSpread57({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(_objectSpread57(_objectSpread57({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance
        }), false);
      },
      dispose: function dispose(_ref33) {
        var state = _ref33.state;
        unmountFn();
        return state.setQueryParameter("page", void 0);
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref44) {
        var searchParameters = _ref44.searchParameters;
        var page2 = searchParameters.page || 0;
        if (!page2) {
          return uiState;
        }
        return _objectSpread57(_objectSpread57({}, uiState), {}, {
          page: page2 + 1
        });
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref52) {
        var uiState = _ref52.uiState;
        var page2 = uiState.page ? uiState.page - 1 : 0;
        return searchParameters.setQueryParameter("page", page2);
      },
      getWidgetRenderState: function getWidgetRenderState(_ref64) {
        var results = _ref64.results, helper = _ref64.helper, state = _ref64.state, createURL = _ref64.createURL;
        if (!connectorState.refine) {
          connectorState.refine = function(page3) {
            helper.setPage(page3);
            helper.search();
          };
        }
        if (!connectorState.createURL) {
          connectorState.createURL = function(page3) {
            return createURL(function(uiState) {
              return _objectSpread57(_objectSpread57({}, uiState), {}, {
                page: page3 + 1
              });
            });
          };
        }
        var page2 = state.page || 0;
        var nbPages = getMaxPage(results || {
          nbPages: 0
        });
        pager.currentPage = page2;
        pager.total = nbPages;
        return {
          createURL: connectorState.createURL,
          refine: connectorState.refine,
          canRefine: nbPages > 1,
          currentRefinement: page2,
          nbHits: (results === null || results === void 0 ? void 0 : results.nbHits) || 0,
          nbPages,
          pages: results ? pager.pages() : [],
          isFirstPage: pager.isFirstPage(),
          isLastPage: pager.isLastPage(),
          widgetParams
        };
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return _objectSpread57(_objectSpread57({}, renderState), {}, {
          pagination: this.getWidgetRenderState(renderOptions)
        });
      }
    };
  };
};
var connectPagination_default = connectPagination;

// node_modules/instantsearch.js/es/widgets/pagination/pagination.js
function _typeof50(o4) {
  "@babel/helpers - typeof";
  return _typeof50 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof50(o4);
}
function ownKeys58(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread58(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys58(Object(t4), true).forEach(function(r4) {
      _defineProperty50(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys58(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty50(obj, key2, value) {
  key2 = _toPropertyKey49(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey49(t4) {
  var i4 = _toPrimitive49(t4, "string");
  return "symbol" == _typeof50(i4) ? i4 : String(i4);
}
function _toPrimitive49(t4, r3) {
  if ("object" != _typeof50(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof50(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var suit13 = component("Pagination");
var withUsage30 = createDocumentationMessageGenerator({
  name: "pagination"
});
var defaultTemplates11 = {
  previous: function previous() {
    return "‹";
  },
  next: function next() {
    return "›";
  },
  page: function page(_ref9) {
    var _page = _ref9.page;
    return "".concat(_page);
  },
  first: function first() {
    return "«";
  },
  last: function last() {
    return "»";
  }
};
var renderer25 = function renderer26(_ref23) {
  var containerNode = _ref23.containerNode, cssClasses = _ref23.cssClasses, templates = _ref23.templates, showFirst = _ref23.showFirst, showLast = _ref23.showLast, showPrevious = _ref23.showPrevious, showNext = _ref23.showNext, scrollToNode = _ref23.scrollToNode;
  return function(_ref33, isFirstRendering) {
    var createURL = _ref33.createURL, currentRefinement = _ref33.currentRefinement, nbPages = _ref33.nbPages, pages = _ref33.pages, isFirstPage = _ref33.isFirstPage, isLastPage = _ref33.isLastPage, refine2 = _ref33.refine;
    if (isFirstRendering)
      return;
    var setCurrentPage = function setCurrentPage2(pageNumber) {
      refine2(pageNumber);
      if (scrollToNode !== false) {
        scrollToNode.scrollIntoView();
      }
    };
    N2(y2(Pagination_default, {
      createURL,
      cssClasses,
      currentPage: currentRefinement,
      templates,
      nbPages,
      pages,
      isFirstPage,
      isLastPage,
      setCurrentPage,
      showFirst,
      showLast,
      showPrevious,
      showNext
    }), containerNode);
  };
};
var pagination = function pagination2(widgetParams) {
  var _ref44 = widgetParams || {}, container = _ref44.container, _ref4$templates = _ref44.templates, userTemplates = _ref4$templates === void 0 ? {} : _ref4$templates, _ref4$cssClasses = _ref44.cssClasses, userCssClasses = _ref4$cssClasses === void 0 ? {} : _ref4$cssClasses, totalPages = _ref44.totalPages, padding = _ref44.padding, _ref4$showFirst = _ref44.showFirst, showFirst = _ref4$showFirst === void 0 ? true : _ref4$showFirst, _ref4$showLast = _ref44.showLast, showLast = _ref4$showLast === void 0 ? true : _ref4$showLast, _ref4$showPrevious = _ref44.showPrevious, showPrevious = _ref4$showPrevious === void 0 ? true : _ref4$showPrevious, _ref4$showNext = _ref44.showNext, showNext = _ref4$showNext === void 0 ? true : _ref4$showNext, _ref4$scrollTo = _ref44.scrollTo, userScrollTo = _ref4$scrollTo === void 0 ? "body" : _ref4$scrollTo;
  if (!container) {
    throw new Error(withUsage30("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var scrollTo = userScrollTo === true ? "body" : userScrollTo;
  var scrollToNode = scrollTo !== false ? getContainerNode(scrollTo) : false;
  var cssClasses = {
    root: cx(suit13(), userCssClasses.root),
    noRefinementRoot: cx(suit13({
      modifierName: "noRefinement"
    }), userCssClasses.noRefinementRoot),
    list: cx(suit13({
      descendantName: "list"
    }), userCssClasses.list),
    item: cx(suit13({
      descendantName: "item"
    }), userCssClasses.item),
    firstPageItem: cx(suit13({
      descendantName: "item",
      modifierName: "firstPage"
    }), userCssClasses.firstPageItem),
    lastPageItem: cx(suit13({
      descendantName: "item",
      modifierName: "lastPage"
    }), userCssClasses.lastPageItem),
    previousPageItem: cx(suit13({
      descendantName: "item",
      modifierName: "previousPage"
    }), userCssClasses.previousPageItem),
    nextPageItem: cx(suit13({
      descendantName: "item",
      modifierName: "nextPage"
    }), userCssClasses.nextPageItem),
    pageItem: cx(suit13({
      descendantName: "item",
      modifierName: "page"
    }), userCssClasses.pageItem),
    selectedItem: cx(suit13({
      descendantName: "item",
      modifierName: "selected"
    }), userCssClasses.selectedItem),
    disabledItem: cx(suit13({
      descendantName: "item",
      modifierName: "disabled"
    }), userCssClasses.disabledItem),
    link: cx(suit13({
      descendantName: "link"
    }), userCssClasses.link)
  };
  var templates = _objectSpread58(_objectSpread58({}, defaultTemplates11), userTemplates);
  var specializedRenderer = renderer25({
    containerNode,
    cssClasses,
    templates,
    showFirst,
    showLast,
    showPrevious,
    showNext,
    scrollToNode
  });
  var makeWidget = connectPagination_default(specializedRenderer, function() {
    return N2(null, containerNode);
  });
  return _objectSpread58(_objectSpread58({}, makeWidget({
    totalPages,
    padding
  })), {}, {
    $$widgetType: "ais.pagination"
  });
};
var pagination_default = pagination;

// node_modules/preact/hooks/dist/hooks.module.js
var t3;
var r2;
var u3;
var i3;
var o3 = 0;
var f3 = [];
var c3 = [];
var e3 = l2;
var a3 = e3.__b;
var v3 = e3.__r;
var l3 = e3.diffed;
var m4 = e3.__c;
var s3 = e3.unmount;
var d3 = e3.__;
function h3(n4, t4) {
  e3.__h && e3.__h(r2, n4, o3 || t4), o3 = 0;
  var u4 = r2.__H || (r2.__H = { __: [], __h: [] });
  return n4 >= u4.__.length && u4.__.push({ __V: c3 }), u4.__[n4];
}
function p3(n4) {
  return o3 = 1, y3(D3, n4);
}
function y3(n4, u4, i4) {
  var o4 = h3(t3++, 2);
  if (o4.t = n4, !o4.__c && (o4.__ = [i4 ? i4(u4) : D3(void 0, u4), function(n5) {
    var t4 = o4.__N ? o4.__N[0] : o4.__[0], r3 = o4.t(t4, n5);
    t4 !== r3 && (o4.__N = [r3, o4.__[1]], o4.__c.setState({}));
  }], o4.__c = r2, !r2.u)) {
    var f4 = function(n5, t4, r3) {
      if (!o4.__c.__H)
        return true;
      var u5 = o4.__c.__H.__.filter(function(n6) {
        return !!n6.__c;
      });
      if (u5.every(function(n6) {
        return !n6.__N;
      }))
        return !c4 || c4.call(this, n5, t4, r3);
      var i5 = false;
      return u5.forEach(function(n6) {
        if (n6.__N) {
          var t5 = n6.__[0];
          n6.__ = n6.__N, n6.__N = void 0, t5 !== n6.__[0] && (i5 = true);
        }
      }), !(!i5 && o4.__c.props === n5) && (!c4 || c4.call(this, n5, t4, r3));
    };
    r2.u = true;
    var c4 = r2.shouldComponentUpdate, e4 = r2.componentWillUpdate;
    r2.componentWillUpdate = function(n5, t4, r3) {
      if (this.__e) {
        var u5 = c4;
        c4 = void 0, f4(n5, t4, r3), c4 = u5;
      }
      e4 && e4.call(this, n5, t4, r3);
    }, r2.shouldComponentUpdate = f4;
  }
  return o4.__N || o4.__;
}
function _3(n4, u4) {
  var i4 = h3(t3++, 3);
  !e3.__s && C3(i4.__H, u4) && (i4.__ = n4, i4.i = u4, r2.__H.__h.push(i4));
}
function F3(n4) {
  return o3 = 5, q2(function() {
    return { current: n4 };
  }, []);
}
function q2(n4, r3) {
  var u4 = h3(t3++, 7);
  return C3(u4.__H, r3) ? (u4.__V = n4(), u4.i = r3, u4.__h = n4, u4.__V) : u4.__;
}
function x3(n4, t4) {
  return o3 = 8, q2(function() {
    return n4;
  }, t4);
}
function j3() {
  for (var n4; n4 = f3.shift(); )
    if (n4.__P && n4.__H)
      try {
        n4.__H.__h.forEach(z3), n4.__H.__h.forEach(B2), n4.__H.__h = [];
      } catch (t4) {
        n4.__H.__h = [], e3.__e(t4, n4.__v);
      }
}
e3.__b = function(n4) {
  r2 = null, a3 && a3(n4);
}, e3.__ = function(n4, t4) {
  n4 && t4.__k && t4.__k.__m && (n4.__m = t4.__k.__m), d3 && d3(n4, t4);
}, e3.__r = function(n4) {
  v3 && v3(n4), t3 = 0;
  var i4 = (r2 = n4.__c).__H;
  i4 && (u3 === r2 ? (i4.__h = [], r2.__h = [], i4.__.forEach(function(n5) {
    n5.__N && (n5.__ = n5.__N), n5.__V = c3, n5.__N = n5.i = void 0;
  })) : (i4.__h.forEach(z3), i4.__h.forEach(B2), i4.__h = [], t3 = 0)), u3 = r2;
}, e3.diffed = function(n4) {
  l3 && l3(n4);
  var t4 = n4.__c;
  t4 && t4.__H && (t4.__H.__h.length && (1 !== f3.push(t4) && i3 === e3.requestAnimationFrame || ((i3 = e3.requestAnimationFrame) || w3)(j3)), t4.__H.__.forEach(function(n5) {
    n5.i && (n5.__H = n5.i), n5.__V !== c3 && (n5.__ = n5.__V), n5.i = void 0, n5.__V = c3;
  })), u3 = r2 = null;
}, e3.__c = function(n4, t4) {
  t4.some(function(n5) {
    try {
      n5.__h.forEach(z3), n5.__h = n5.__h.filter(function(n6) {
        return !n6.__ || B2(n6);
      });
    } catch (r3) {
      t4.some(function(n6) {
        n6.__h && (n6.__h = []);
      }), t4 = [], e3.__e(r3, n5.__v);
    }
  }), m4 && m4(n4, t4);
}, e3.unmount = function(n4) {
  s3 && s3(n4);
  var t4, r3 = n4.__c;
  r3 && r3.__H && (r3.__H.__.forEach(function(n5) {
    try {
      z3(n5);
    } catch (n6) {
      t4 = n6;
    }
  }), r3.__H = void 0, t4 && e3.__e(t4, r3.__v));
};
var k3 = "function" == typeof requestAnimationFrame;
function w3(n4) {
  var t4, r3 = function() {
    clearTimeout(u4), k3 && cancelAnimationFrame(t4), setTimeout(n4);
  }, u4 = setTimeout(r3, 100);
  k3 && (t4 = requestAnimationFrame(r3));
}
function z3(n4) {
  var t4 = r2, u4 = n4.__c;
  "function" == typeof u4 && (n4.__c = void 0, u4()), r2 = t4;
}
function B2(n4) {
  var t4 = r2;
  n4.__c = n4.__(), r2 = t4;
}
function C3(n4, t4) {
  return !n4 || n4.length !== t4.length || t4.some(function(t5, r3) {
    return t5 !== n4[r3];
  });
}
function D3(n4, t4) {
  return "function" == typeof t4 ? t4(n4) : t4;
}

// node_modules/instantsearch.js/es/components/Panel/Panel.js
function _slicedToArray10(arr, i4) {
  return _arrayWithHoles10(arr) || _iterableToArrayLimit10(arr, i4) || _unsupportedIterableToArray18(arr, i4) || _nonIterableRest10();
}
function _nonIterableRest10() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray18(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray18(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray18(o4, minLen);
}
function _arrayLikeToArray18(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
function _iterableToArrayLimit10(r3, l4) {
  var t4 = null == r3 ? null : "undefined" != typeof Symbol && r3[Symbol.iterator] || r3["@@iterator"];
  if (null != t4) {
    var e4, n4, i4, u4, a4 = [], f4 = true, o4 = false;
    try {
      if (i4 = (t4 = t4.call(r3)).next, 0 === l4) {
        if (Object(t4) !== t4)
          return;
        f4 = false;
      } else
        for (; !(f4 = (e4 = i4.call(t4)).done) && (a4.push(e4.value), a4.length !== l4); f4 = true)
          ;
    } catch (r4) {
      o4 = true, n4 = r4;
    } finally {
      try {
        if (!f4 && null != t4.return && (u4 = t4.return(), Object(u4) !== u4))
          return;
      } finally {
        if (o4)
          throw n4;
      }
    }
    return a4;
  }
}
function _arrayWithHoles10(arr) {
  if (Array.isArray(arr))
    return arr;
}
function Panel(props) {
  var _useState = p3(props.isCollapsed), _useState2 = _slicedToArray10(_useState, 2), isCollapsed = _useState2[0], setIsCollapsed = _useState2[1];
  var _useState3 = p3(false), _useState4 = _slicedToArray10(_useState3, 2), isControlled = _useState4[0], setIsControlled = _useState4[1];
  var bodyRef = F3(null);
  _3(function() {
    var node = bodyRef.current;
    if (!node) {
      return void 0;
    }
    node.appendChild(props.bodyElement);
    return function() {
      node.removeChild(props.bodyElement);
    };
  }, [bodyRef, props.bodyElement]);
  if (!isControlled && props.isCollapsed !== isCollapsed) {
    setIsCollapsed(props.isCollapsed);
  }
  return y2("div", {
    className: cx(props.cssClasses.root, props.hidden && props.cssClasses.noRefinementRoot, props.collapsible && props.cssClasses.collapsibleRoot, isCollapsed && props.cssClasses.collapsedRoot),
    hidden: props.hidden
  }, props.templates.header && y2("div", {
    className: props.cssClasses.header
  }, y2(Template_default, {
    templates: props.templates,
    templateKey: "header",
    rootTagName: "span",
    data: props.data
  }), props.collapsible && y2("button", {
    className: props.cssClasses.collapseButton,
    "aria-expanded": !isCollapsed,
    onClick: function onClick(event) {
      event.preventDefault();
      setIsControlled(true);
      setIsCollapsed(function(prevIsCollapsed) {
        return !prevIsCollapsed;
      });
    }
  }, y2(Template_default, {
    templates: props.templates,
    templateKey: "collapseButtonText",
    rootTagName: "span",
    data: {
      collapsed: isCollapsed
    }
  }))), y2("div", {
    className: props.cssClasses.body,
    ref: bodyRef
  }), props.templates.footer && y2(Template_default, {
    templates: props.templates,
    templateKey: "footer",
    rootProps: {
      className: props.cssClasses.footer
    },
    data: props.data
  }));
}
var Panel_default = Panel;

// node_modules/instantsearch.js/es/widgets/panel/panel.js
function _typeof51(o4) {
  "@babel/helpers - typeof";
  return _typeof51 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof51(o4);
}
function ownKeys59(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread59(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys59(Object(t4), true).forEach(function(r4) {
      _defineProperty51(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys59(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty51(obj, key2, value) {
  key2 = _toPropertyKey50(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey50(t4) {
  var i4 = _toPrimitive50(t4, "string");
  return "symbol" == _typeof51(i4) ? i4 : String(i4);
}
function _toPrimitive50(t4, r3) {
  if ("object" != _typeof51(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof51(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage31 = createDocumentationMessageGenerator({
  name: "panel"
});
var suit14 = component("Panel");
var renderer27 = function renderer28(_ref9) {
  var containerNode = _ref9.containerNode, bodyContainerNode = _ref9.bodyContainerNode, cssClasses = _ref9.cssClasses, templates = _ref9.templates;
  return function(_ref23) {
    var options = _ref23.options, hidden = _ref23.hidden, collapsible = _ref23.collapsible, collapsed = _ref23.collapsed;
    N2(y2(Panel_default, {
      cssClasses,
      hidden,
      collapsible,
      isCollapsed: collapsed,
      templates,
      data: options,
      bodyElement: bodyContainerNode
    }), containerNode);
  };
};
var panel = function panel2(panelWidgetParams) {
  var _ref33 = panelWidgetParams || {}, _ref3$templates = _ref33.templates, templates = _ref3$templates === void 0 ? {} : _ref3$templates, _ref3$hidden = _ref33.hidden, hidden = _ref3$hidden === void 0 ? function() {
    return false;
  } : _ref3$hidden, collapsed = _ref33.collapsed, _ref3$cssClasses = _ref33.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses;
  false ? _warning(typeof hidden === "function", 'The `hidden` option in the "panel" widget expects a function returning a boolean (received type '.concat(getObjectType(hidden), ").")) : void 0;
  false ? _warning(typeof collapsed === "undefined" || typeof collapsed === "function", 'The `collapsed` option in the "panel" widget expects a function returning a boolean (received type '.concat(getObjectType(collapsed), ").")) : void 0;
  var bodyContainerNode = document.createElement("div");
  var collapsible = Boolean(collapsed);
  var collapsedFn = typeof collapsed === "function" ? collapsed : function() {
    return false;
  };
  var cssClasses = {
    root: cx(suit14(), userCssClasses.root),
    noRefinementRoot: cx(suit14({
      modifierName: "noRefinement"
    }), userCssClasses.noRefinementRoot),
    collapsibleRoot: cx(suit14({
      modifierName: "collapsible"
    }), userCssClasses.collapsibleRoot),
    collapsedRoot: cx(suit14({
      modifierName: "collapsed"
    }), userCssClasses.collapsedRoot),
    collapseButton: cx(suit14({
      descendantName: "collapseButton"
    }), userCssClasses.collapseButton),
    collapseIcon: cx(suit14({
      descendantName: "collapseIcon"
    }), userCssClasses.collapseIcon),
    body: cx(suit14({
      descendantName: "body"
    }), userCssClasses.body),
    header: cx(suit14({
      descendantName: "header"
    }), userCssClasses.header),
    footer: cx(suit14({
      descendantName: "footer"
    }), userCssClasses.footer)
  };
  return function(widgetFactory) {
    return function(widgetParams) {
      if (!(widgetParams && widgetParams.container)) {
        throw new Error(withUsage31("The `container` option is required in the widget within the panel."));
      }
      var containerNode = getContainerNode(widgetParams.container);
      var defaultTemplates21 = {
        collapseButtonText: function collapseButtonText(_ref44) {
          var isCollapsed = _ref44.collapsed;
          return '<svg\n          class="'.concat(cssClasses.collapseIcon, '"\n          style="width: 1em; height: 1em;"\n          viewBox="0 0 500 500"\n        >\n        <path d="').concat(isCollapsed ? "M100 250l300-150v300z" : "M250 400l150-300H100z", '" fill="currentColor" />\n        </svg>');
        }
      };
      var renderPanel = renderer27({
        containerNode,
        bodyContainerNode,
        cssClasses,
        templates: _objectSpread59(_objectSpread59({}, defaultTemplates21), templates)
      });
      var widget = widgetFactory(_objectSpread59(_objectSpread59({}, widgetParams), {}, {
        container: bodyContainerNode
      }));
      return _objectSpread59(_objectSpread59({}, widget), {}, {
        init: function init() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          var renderOptions = args[0];
          var options = _objectSpread59(_objectSpread59({}, widget.getWidgetRenderState ? widget.getWidgetRenderState(renderOptions) : {}), renderOptions);
          renderPanel({
            options,
            hidden: true,
            collapsible,
            collapsed: false
          });
          if (typeof widget.init === "function") {
            var _widget$init;
            (_widget$init = widget.init).call.apply(_widget$init, [this].concat(args));
          }
        },
        render: function render() {
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }
          var renderOptions = args[0];
          var options = _objectSpread59(_objectSpread59({}, widget.getWidgetRenderState ? widget.getWidgetRenderState(renderOptions) : {}), renderOptions);
          renderPanel({
            options,
            hidden: Boolean(hidden(options)),
            collapsible,
            collapsed: Boolean(collapsedFn(options))
          });
          if (typeof widget.render === "function") {
            var _widget$render;
            (_widget$render = widget.render).call.apply(_widget$render, [this].concat(args));
          }
        },
        dispose: function dispose() {
          N2(null, containerNode);
          if (typeof widget.dispose === "function") {
            var _widget$dispose;
            for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
              args[_key3] = arguments[_key3];
            }
            return (_widget$dispose = widget.dispose).call.apply(_widget$dispose, [this].concat(args));
          }
          return void 0;
        }
      });
    };
  };
};
var panel_default = panel;

// node_modules/instantsearch.js/es/widgets/places/places.js
function _typeof52(o4) {
  "@babel/helpers - typeof";
  return _typeof52 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof52(o4);
}
var _excluded36 = ["placesReference", "defaultPosition"];
var _excluded211 = ["places"];
function ownKeys60(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread60(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys60(Object(t4), true).forEach(function(r4) {
      _defineProperty52(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys60(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty52(obj, key2, value) {
  key2 = _toPropertyKey51(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey51(t4) {
  var i4 = _toPrimitive51(t4, "string");
  return "symbol" == _typeof52(i4) ? i4 : String(i4);
}
function _toPrimitive51(t4, r3) {
  if ("object" != _typeof52(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof52(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _objectWithoutProperties17(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose17(source, excluded);
  var key2, i4;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i4 = 0; i4 < sourceSymbolKeys.length; i4++) {
      key2 = sourceSymbolKeys[i4];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose17(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i4;
  for (i4 = 0; i4 < sourceKeys.length; i4++) {
    key2 = sourceKeys[i4];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
var placesWidget = function placesWidget2(widgetParams) {
  var _ref9 = widgetParams || {}, placesReference = _ref9.placesReference, _ref$defaultPosition = _ref9.defaultPosition, defaultPosition = _ref$defaultPosition === void 0 ? [] : _ref$defaultPosition, placesOptions = _objectWithoutProperties17(_ref9, _excluded36);
  if (typeof placesReference !== "function") {
    throw new Error("The `placesReference` option requires a valid Places.js reference.");
  }
  var placesAutocomplete = placesReference(placesOptions);
  var state = {
    query: "",
    initialLatLngViaIP: void 0,
    isInitialLatLngViaIPSet: false
  };
  return {
    $$type: "ais.places",
    $$widgetType: "ais.places",
    init: function init(_ref23) {
      var helper = _ref23.helper;
      placesAutocomplete.on("change", function(eventOptions) {
        var _eventOptions$suggest = eventOptions.suggestion, value = _eventOptions$suggest.value, _eventOptions$suggest2 = _eventOptions$suggest.latlng, lat = _eventOptions$suggest2.lat, lng = _eventOptions$suggest2.lng;
        state.query = value;
        helper.setQueryParameter("insideBoundingBox", void 0).setQueryParameter("aroundLatLngViaIP", false).setQueryParameter("aroundLatLng", "".concat(lat, ",").concat(lng)).search();
      });
      placesAutocomplete.on("clear", function() {
        state.query = "";
        helper.setQueryParameter("insideBoundingBox", void 0);
        if (defaultPosition.length > 1) {
          helper.setQueryParameter("aroundLatLngViaIP", false).setQueryParameter("aroundLatLng", defaultPosition.join(","));
        } else {
          helper.setQueryParameter("aroundLatLngViaIP", state.initialLatLngViaIP).setQueryParameter("aroundLatLng", void 0);
        }
        helper.search();
      });
    },
    getWidgetUiState: function getWidgetUiState(uiState, _ref33) {
      var searchParameters = _ref33.searchParameters;
      var position = searchParameters.aroundLatLng || defaultPosition.join(",");
      var hasPositionSet = position !== defaultPosition.join(",");
      if (!hasPositionSet && !state.query) {
        var places = uiState.places, uiStateWithoutPlaces = _objectWithoutProperties17(uiState, _excluded211);
        return uiStateWithoutPlaces;
      }
      return _objectSpread60(_objectSpread60({}, uiState), {}, {
        places: {
          query: state.query,
          position
        }
      });
    },
    getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref44) {
      var uiState = _ref44.uiState;
      var _ref52 = uiState.places || {}, _ref5$query = _ref52.query, query = _ref5$query === void 0 ? "" : _ref5$query, _ref5$position = _ref52.position, position = _ref5$position === void 0 ? defaultPosition.join(",") : _ref5$position;
      state.query = query;
      if (!state.isInitialLatLngViaIPSet) {
        state.isInitialLatLngViaIPSet = true;
        state.initialLatLngViaIP = searchParameters.aroundLatLngViaIP;
      }
      placesAutocomplete.setVal(query);
      placesAutocomplete.close();
      return searchParameters.setQueryParameter("insideBoundingBox", void 0).setQueryParameter("aroundLatLngViaIP", false).setQueryParameter("aroundLatLng", position || void 0);
    },
    getRenderState: function getRenderState(renderState, renderOptions) {
      return _objectSpread60(_objectSpread60({}, renderState), {}, {
        places: this.getWidgetRenderState(renderOptions)
      });
    },
    getWidgetRenderState: function getWidgetRenderState() {
      return {
        widgetParams
      };
    }
  };
};
var places_default = deprecate(placesWidget, "The places widget is deprecated and will be removed in InstantSearch.js 5.0.");

// node_modules/instantsearch.js/es/components/PoweredBy/PoweredBy.js
var PoweredBy = function PoweredBy2(_ref9) {
  var url2 = _ref9.url, theme = _ref9.theme, cssClasses = _ref9.cssClasses;
  return y2("div", {
    className: cssClasses.root
  }, y2("a", {
    href: url2,
    target: "_blank",
    className: cssClasses.link,
    "aria-label": "Search by Algolia",
    rel: "noopener noreferrer"
  }, y2("svg", {
    height: "1.2em",
    className: cssClasses.logo,
    viewBox: "0 0 572 64",
    style: {
      width: "auto"
    }
  }, y2("path", {
    fill: theme === "dark" ? "#FFF" : "#36395A",
    d: "M16 48.3c-3.4 0-6.3-.6-8.7-1.7A12.4 12.4 0 0 1 1.9 42C.6 40 0 38 0 35.4h6.5a6.7 6.7 0 0 0 3.9 6c1.4.7 3.3 1.1 5.6 1.1 2.2 0 4-.3 5.4-1a7 7 0 0 0 3-2.4 6 6 0 0 0 1-3.4c0-1.5-.6-2.8-1.9-3.7-1.3-1-3.3-1.6-5.9-1.8l-4-.4c-3.7-.3-6.6-1.4-8.8-3.4a10 10 0 0 1-3.3-7.9c0-2.4.6-4.6 1.8-6.4a12 12 0 0 1 5-4.3c2.2-1 4.7-1.6 7.5-1.6s5.5.5 7.6 1.6a12 12 0 0 1 5 4.4c1.2 1.8 1.8 4 1.8 6.7h-6.5a6.4 6.4 0 0 0-3.5-5.9c-1-.6-2.6-1-4.4-1s-3.2.3-4.4 1c-1.1.6-2 1.4-2.6 2.4-.5 1-.8 2-.8 3.1a5 5 0 0 0 1.5 3.6c1 1 2.6 1.7 4.7 1.9l4 .3c2.8.2 5.2.8 7.2 1.8 2.1 1 3.7 2.2 4.9 3.8a9.7 9.7 0 0 1 1.7 5.8c0 2.5-.7 4.7-2 6.6a13 13 0 0 1-5.6 4.4c-2.4 1-5.2 1.6-8.4 1.6Zm35.6 0c-2.6 0-4.8-.4-6.7-1.3a13 13 0 0 1-4.7-3.5 17.1 17.1 0 0 1-3.6-10.4v-1c0-2 .3-3.8 1-5.6a13 13 0 0 1 7.3-8.3 15 15 0 0 1 6.3-1.4A13.2 13.2 0 0 1 64 24.3c1 2.2 1.6 4.6 1.6 7.2V34H39.4v-4.3h21.8l-1.8 2.2c0-2-.3-3.7-.9-5.1a7.3 7.3 0 0 0-2.7-3.4c-1.2-.7-2.7-1.1-4.6-1.1s-3.4.4-4.7 1.3a8 8 0 0 0-2.9 3.6c-.6 1.5-.9 3.3-.9 5.4 0 2 .3 3.7 1 5.3a7.9 7.9 0 0 0 2.8 3.7c1.3.8 3 1.3 5 1.3s3.8-.5 5.1-1.3c1.3-1 2.1-2 2.4-3.2h6a11.8 11.8 0 0 1-7 8.7 16 16 0 0 1-6.4 1.2ZM80 48c-2.2 0-4-.3-5.7-1a8.4 8.4 0 0 1-3.7-3.3 9.7 9.7 0 0 1-1.3-5.2c0-2 .5-3.8 1.5-5.2a9 9 0 0 1 4.3-3.1c1.8-.7 4-1 6.7-1H89v4.1h-7.5c-2 0-3.4.5-4.4 1.4-1 1-1.6 2.1-1.6 3.6s.5 2.7 1.6 3.6c1 1 2.5 1.4 4.4 1.4 1.1 0 2.2-.2 3.2-.7 1-.4 1.9-1 2.6-2 .6-1 1-2.4 1-4.2l1.7 2.1c-.2 2-.7 3.8-1.5 5.2a9 9 0 0 1-3.4 3.3 12 12 0 0 1-5.3 1Zm9.5-.7v-8.8h-1v-10c0-1.8-.5-3.2-1.4-4.1-1-1-2.4-1.4-4.2-1.4a142.9 142.9 0 0 0-10.2.4v-5.6a74.8 74.8 0 0 1 8.6-.4c3 0 5.5.4 7.5 1.2s3.4 2 4.4 3.6c1 1.7 1.4 4 1.4 6.7v18.4h-5Zm12.9 0V17.8h5v12.3h-.2c0-4.2 1-7.4 2.8-9.5a11 11 0 0 1 8.3-3.1h1v5.6h-2a9 9 0 0 0-6.3 2.2c-1.5 1.5-2.2 3.6-2.2 6.4v15.6h-6.4Zm34.4 1a15 15 0 0 1-6.6-1.3c-1.9-.9-3.4-2-4.7-3.5a15.5 15.5 0 0 1-2.7-5c-.6-1.7-1-3.6-1-5.4v-1c0-2 .4-3.8 1-5.6a15 15 0 0 1 2.8-4.9c1.3-1.5 2.8-2.6 4.6-3.5a16.4 16.4 0 0 1 13.3.2c2 1 3.5 2.3 4.8 4a12 12 0 0 1 2 6H144c-.2-1.6-1-3-2.2-4.1a7.5 7.5 0 0 0-5.2-1.7 8 8 0 0 0-4.7 1.3 8 8 0 0 0-2.8 3.6 13.8 13.8 0 0 0 0 10.3c.6 1.5 1.5 2.7 2.8 3.6s2.8 1.3 4.8 1.3c1.5 0 2.7-.2 3.8-.8a7 7 0 0 0 2.6-2c.7-1 1-2 1.2-3.2h6.2a11 11 0 0 1-2 6.2 15.1 15.1 0 0 1-11.8 5.5Zm19.7-1v-40h6.4V31h-1.3c0-3 .4-5.5 1.1-7.6a9.7 9.7 0 0 1 3.5-4.8A9.9 9.9 0 0 1 172 17h.3c3.5 0 6 1.1 7.9 3.5 1.7 2.3 2.6 5.7 2.6 10v16.8h-6.4V29.6c0-2.1-.6-3.8-1.8-5a6.4 6.4 0 0 0-4.8-1.8c-2 0-3.7.7-5 2a7.8 7.8 0 0 0-1.9 5.5v17h-6.4Zm63.8 1a12.2 12.2 0 0 1-10.9-6.2 19 19 0 0 1-1.8-7.3h1.4v12.5h-5.1v-40h6.4v19.8l-2 3.5c.2-3.1.8-5.7 1.9-7.7a11 11 0 0 1 4.4-4.5c1.8-1 3.9-1.5 6.1-1.5a13.4 13.4 0 0 1 12.8 9.1c.7 1.9 1 3.8 1 6v1c0 2.2-.3 4.1-1 6a13.6 13.6 0 0 1-13.2 9.4Zm-1.2-5.5a8.4 8.4 0 0 0 7.9-5c.7-1.5 1.1-3.3 1.1-5.3s-.4-3.8-1.1-5.3a8.7 8.7 0 0 0-3.2-3.6 9.6 9.6 0 0 0-9.2-.2 8.5 8.5 0 0 0-3.3 3.2c-.8 1.4-1.3 3-1.3 5v2.3a9 9 0 0 0 1.3 4.8 9 9 0 0 0 3.4 3c1.4.7 2.8 1 4.4 1Zm27.3 3.9-10-28.9h6.5l9.5 28.9h-6Zm-7.5 12.2v-5.7h4.9c1 0 2-.1 2.9-.4a4 4 0 0 0 2-1.4c.4-.7.9-1.6 1.2-2.7l8.6-30.9h6.2l-9.3 32.4a14 14 0 0 1-2.5 5 8.9 8.9 0 0 1-4 2.8c-1.5.6-3.4.9-5.6.9h-4.4Zm9-12.2v-5.2h6.4v5.2H248Z"
  }), y2("path", {
    fill: theme === "dark" ? "#FFF" : "#003DFF",
    d: "M534.4 9.1H528a.8.8 0 0 1-.7-.7V1.8c0-.4.2-.7.6-.8l6.5-1c.4 0 .8.2.9.6v7.8c0 .4-.4.7-.8.7zM428 35.2V.8c0-.5-.3-.8-.7-.8h-.2l-6.4 1c-.4 0-.7.4-.7.8v35c0 1.6 0 11.8 12.3 12.2.5 0 .8-.4.8-.8V43c0-.4-.3-.7-.6-.8-4.5-.5-4.5-6-4.5-7zm106.5-21.8H528c-.4 0-.7.4-.7.8v34c0 .4.3.8.7.8h6.5c.4 0 .8-.4.8-.8v-34c0-.5-.4-.8-.8-.8zm-17.7 21.8V.8c0-.5-.3-.8-.8-.8l-6.5 1c-.4 0-.7.4-.7.8v35c0 1.6 0 11.8 12.3 12.2.4 0 .8-.4.8-.8V43c0-.4-.3-.7-.7-.8-4.4-.5-4.4-6-4.4-7zm-22.2-20.6a16.5 16.5 0 0 1 8.6 9.3c.8 2.2 1.3 4.8 1.3 7.5a19.4 19.4 0 0 1-4.6 12.6 14.8 14.8 0 0 1-5.2 3.6c-2 .9-5.2 1.4-6.8 1.4a21 21 0 0 1-6.7-1.4 15.4 15.4 0 0 1-8.6-9.3 21.3 21.3 0 0 1 0-14.4 15.2 15.2 0 0 1 8.6-9.3c2-.8 4.3-1.2 6.7-1.2s4.6.4 6.7 1.2zm-6.7 27.6c2.7 0 4.7-1 6.2-3s2.2-4.3 2.2-7.8-.7-6.3-2.2-8.3-3.5-3-6.2-3-4.7 1-6.1 3c-1.5 2-2.2 4.8-2.2 8.3s.7 5.8 2.2 7.8 3.5 3 6.2 3zm-88.8-28.8c-6.2 0-11.7 3.3-14.8 8.2a18.6 18.6 0 0 0 4.8 25.2c1.8 1.2 4 1.8 6.2 1.7s.1 0 .1 0h.9c4.2-.7 8-4 9.1-8.1v7.4c0 .4.3.7.8.7h6.4a.7.7 0 0 0 .7-.7V14.2c0-.5-.3-.8-.7-.8h-13.5zm6.3 26.5a9.8 9.8 0 0 1-5.7 2h-.5a10 10 0 0 1-9.2-14c1.4-3.7 5-6.3 9-6.3h6.4v18.3zm152.3-26.5h13.5c.5 0 .8.3.8.7v33.7c0 .4-.3.7-.8.7h-6.4a.7.7 0 0 1-.8-.7v-7.4c-1.2 4-4.8 7.4-9 8h-.1a4.2 4.2 0 0 1-.5.1h-.9a10.3 10.3 0 0 1-7-2.6c-4-3.3-6.5-8.4-6.5-14.2 0-3.7 1-7.2 3-10 3-5 8.5-8.3 14.7-8.3zm.6 28.4c2.2-.1 4.2-.6 5.7-2V21.7h-6.3a9.8 9.8 0 0 0-9 6.4 10.2 10.2 0 0 0 9.1 13.9h.5zM452.8 13.4c-6.2 0-11.7 3.3-14.8 8.2a18.5 18.5 0 0 0 3.6 24.3 10.4 10.4 0 0 0 13 .6c2.2-1.5 3.8-3.7 4.5-6.1v7.8c0 2.8-.8 5-2.2 6.3-1.5 1.5-4 2.2-7.5 2.2l-6-.3c-.3 0-.7.2-.8.5l-1.6 5.5c-.1.4.1.8.5 1h.1c2.8.4 5.5.6 7 .6 6.3 0 11-1.4 14-4.1 2.7-2.5 4.2-6.3 4.5-11.4V14.2c0-.5-.4-.8-.8-.8h-13.5zm6.3 8.2v18.3a9.6 9.6 0 0 1-5.6 2h-1a10.3 10.3 0 0 1-8.8-14c1.4-3.7 5-6.3 9-6.3h6.4zM291 31.5A32 32 0 0 1 322.8 0h30.8c.6 0 1.2.5 1.2 1.2v61.5c0 1.1-1.3 1.7-2.2 1l-19.2-17a18 18 0 0 1-11 3.4 18.1 18.1 0 1 1 18.2-14.8c-.1.4-.5.7-.9.6-.1 0-.3 0-.4-.2l-3.8-3.4c-.4-.3-.6-.8-.7-1.4a12 12 0 1 0-2.4 8.3c.4-.4 1-.5 1.6-.2l14.7 13.1v-46H323a26 26 0 1 0 10 49.7c.8-.4 1.6-.2 2.3.3l3 2.7c.3.2.3.7 0 1l-.2.2a32 32 0 0 1-47.2-28.6z"
  }))));
};
var PoweredBy_default = PoweredBy;

// node_modules/instantsearch.js/es/connectors/powered-by/connectPoweredBy.js
function _typeof53(o4) {
  "@babel/helpers - typeof";
  return _typeof53 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof53(o4);
}
function ownKeys61(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread61(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys61(Object(t4), true).forEach(function(r4) {
      _defineProperty53(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys61(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty53(obj, key2, value) {
  key2 = _toPropertyKey52(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey52(t4) {
  var i4 = _toPrimitive52(t4, "string");
  return "symbol" == _typeof53(i4) ? i4 : String(i4);
}
function _toPrimitive52(t4, r3) {
  if ("object" != _typeof53(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof53(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage32 = createDocumentationMessageGenerator({
  name: "powered-by",
  connector: true
});
var connectPoweredBy = function connectPoweredBy2(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage32());
  var defaultUrl = "https://www.algolia.com/?utm_source=instantsearch.js&utm_medium=website&" + "utm_content=".concat(safelyRunOnBrowser(function(_ref9) {
    var _window$location;
    var window2 = _ref9.window;
    return ((_window$location = window2.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname) || "";
  }, {
    fallback: function fallback() {
      return "";
    }
  }), "&") + "utm_campaign=poweredby";
  return function(widgetParams) {
    var _ref23 = widgetParams || {}, _ref2$url = _ref23.url, url2 = _ref2$url === void 0 ? defaultUrl : _ref2$url;
    return {
      $$type: "ais.poweredBy",
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(_objectSpread61(_objectSpread61({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(_objectSpread61(_objectSpread61({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance
        }), false);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return _objectSpread61(_objectSpread61({}, renderState), {}, {
          poweredBy: this.getWidgetRenderState(renderOptions)
        });
      },
      getWidgetRenderState: function getWidgetRenderState() {
        return {
          url: url2,
          widgetParams
        };
      },
      dispose: function dispose() {
        unmountFn();
      }
    };
  };
};
var connectPoweredBy_default = connectPoweredBy;

// node_modules/instantsearch.js/es/widgets/powered-by/powered-by.js
function _typeof54(o4) {
  "@babel/helpers - typeof";
  return _typeof54 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof54(o4);
}
function ownKeys62(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread62(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys62(Object(t4), true).forEach(function(r4) {
      _defineProperty54(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys62(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty54(obj, key2, value) {
  key2 = _toPropertyKey53(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey53(t4) {
  var i4 = _toPrimitive53(t4, "string");
  return "symbol" == _typeof54(i4) ? i4 : String(i4);
}
function _toPrimitive53(t4, r3) {
  if ("object" != _typeof54(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof54(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var suit15 = component("PoweredBy");
var withUsage33 = createDocumentationMessageGenerator({
  name: "powered-by"
});
var renderer29 = function renderer30(_ref9) {
  var containerNode = _ref9.containerNode, cssClasses = _ref9.cssClasses;
  return function(_ref23, isFirstRendering) {
    var url2 = _ref23.url, widgetParams = _ref23.widgetParams;
    if (isFirstRendering) {
      var _widgetParams$theme = widgetParams.theme, theme = _widgetParams$theme === void 0 ? "light" : _widgetParams$theme;
      N2(y2(PoweredBy_default, {
        cssClasses,
        url: url2,
        theme
      }), containerNode);
      return;
    }
  };
};
var poweredBy = function poweredBy2(widgetParams) {
  var _ref33 = widgetParams || {}, container = _ref33.container, _ref3$cssClasses = _ref33.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses, _ref3$theme = _ref33.theme, theme = _ref3$theme === void 0 ? "light" : _ref3$theme;
  if (!container) {
    throw new Error(withUsage33("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var cssClasses = {
    root: cx(suit15(), suit15({
      modifierName: theme === "dark" ? "dark" : "light"
    }), userCssClasses.root),
    link: cx(suit15({
      descendantName: "link"
    }), userCssClasses.link),
    logo: cx(suit15({
      descendantName: "logo"
    }), userCssClasses.logo)
  };
  var specializedRenderer = renderer29({
    containerNode,
    cssClasses
  });
  var makeWidget = connectPoweredBy_default(specializedRenderer, function() {
    return N2(null, containerNode);
  });
  return _objectSpread62(_objectSpread62({}, makeWidget({
    theme
  })), {}, {
    $$widgetType: "ais.poweredBy"
  });
};
var powered_by_default = poweredBy;

// node_modules/instantsearch.js/es/connectors/query-rules/connectQueryRules.js
function _typeof55(o4) {
  "@babel/helpers - typeof";
  return _typeof55 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof55(o4);
}
function ownKeys63(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread63(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys63(Object(t4), true).forEach(function(r4) {
      _defineProperty55(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys63(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty55(obj, key2, value) {
  key2 = _toPropertyKey54(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey54(t4) {
  var i4 = _toPrimitive54(t4, "string");
  return "symbol" == _typeof55(i4) ? i4 : String(i4);
}
function _toPrimitive54(t4, r3) {
  if ("object" != _typeof55(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof55(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _toConsumableArray10(arr) {
  return _arrayWithoutHoles10(arr) || _iterableToArray10(arr) || _unsupportedIterableToArray19(arr) || _nonIterableSpread10();
}
function _nonIterableSpread10() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray19(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray19(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray19(o4, minLen);
}
function _iterableToArray10(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles10(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray19(arr);
}
function _arrayLikeToArray19(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
var withUsage34 = createDocumentationMessageGenerator({
  name: "query-rules",
  connector: true
});
function hasStateRefinements(state) {
  return [state.disjunctiveFacetsRefinements, state.facetsRefinements, state.hierarchicalFacetsRefinements, state.numericRefinements].some(function(refinement) {
    return Boolean(refinement && Object.keys(refinement).length > 0);
  });
}
function escapeRuleContext(ruleName) {
  return ruleName.replace(/[^a-z0-9-_]+/gi, "_");
}
function getRuleContextsFromTrackedFilters(_ref9) {
  var helper = _ref9.helper, sharedHelperState = _ref9.sharedHelperState, trackedFilters = _ref9.trackedFilters;
  var ruleContexts = Object.keys(trackedFilters).reduce(function(facets, facetName) {
    var facetRefinements = getRefinements(helper.lastResults || {}, sharedHelperState, true).filter(function(refinement) {
      return refinement.attribute === facetName;
    }).map(function(refinement) {
      return refinement.numericValue || refinement.name;
    });
    var getTrackedFacetValues = trackedFilters[facetName];
    var trackedFacetValues = getTrackedFacetValues(facetRefinements);
    return [].concat(_toConsumableArray10(facets), _toConsumableArray10(facetRefinements.filter(function(facetRefinement) {
      return trackedFacetValues.includes(facetRefinement);
    }).map(function(facetValue) {
      return escapeRuleContext("ais-".concat(facetName, "-").concat(facetValue));
    })));
  }, []);
  return ruleContexts;
}
function applyRuleContexts(event) {
  var helper = this.helper, initialRuleContexts = this.initialRuleContexts, trackedFilters = this.trackedFilters, transformRuleContexts = this.transformRuleContexts;
  var sharedHelperState = event.state;
  var previousRuleContexts = sharedHelperState.ruleContexts || [];
  var newRuleContexts = getRuleContextsFromTrackedFilters({
    helper,
    sharedHelperState,
    trackedFilters
  });
  var nextRuleContexts = [].concat(_toConsumableArray10(initialRuleContexts), _toConsumableArray10(newRuleContexts));
  false ? _warning(nextRuleContexts.length <= 10, "\nThe maximum number of `ruleContexts` is 10. They have been sliced to that limit.\nConsider using `transformRuleContexts` to minimize the number of rules sent to Algolia.\n") : void 0;
  var ruleContexts = transformRuleContexts(nextRuleContexts).slice(0, 10);
  if (!isEqual(previousRuleContexts, ruleContexts)) {
    helper.overrideStateWithoutTriggeringChangeEvent(_objectSpread63(_objectSpread63({}, sharedHelperState), {}, {
      ruleContexts
    }));
  }
}
var connectQueryRules = function connectQueryRules2(_render) {
  var unmount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(_render, withUsage34());
  return function(widgetParams) {
    var _ref23 = widgetParams || {}, _ref2$trackedFilters = _ref23.trackedFilters, trackedFilters = _ref2$trackedFilters === void 0 ? {} : _ref2$trackedFilters, _ref2$transformRuleCo = _ref23.transformRuleContexts, transformRuleContexts = _ref2$transformRuleCo === void 0 ? function(rules) {
      return rules;
    } : _ref2$transformRuleCo, _ref2$transformItems = _ref23.transformItems, transformItems = _ref2$transformItems === void 0 ? function(items) {
      return items;
    } : _ref2$transformItems;
    Object.keys(trackedFilters).forEach(function(facetName) {
      if (typeof trackedFilters[facetName] !== "function") {
        throw new Error(withUsage34("'The \"".concat(facetName, '" filter value in the `trackedFilters` option expects a function.')));
      }
    });
    var hasTrackedFilters = Object.keys(trackedFilters).length > 0;
    var initialRuleContexts = [];
    var onHelperChange;
    return {
      $$type: "ais.queryRules",
      init: function init(initOptions) {
        var helper = initOptions.helper, state = initOptions.state, instantSearchInstance = initOptions.instantSearchInstance;
        initialRuleContexts = state.ruleContexts || [];
        onHelperChange = applyRuleContexts.bind({
          helper,
          initialRuleContexts,
          trackedFilters,
          transformRuleContexts
        });
        if (hasTrackedFilters) {
          if (hasStateRefinements(state) || Boolean(widgetParams.transformRuleContexts)) {
            onHelperChange({
              state
            });
          }
          helper.on("change", onHelperChange);
        }
        _render(_objectSpread63(_objectSpread63({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        _render(_objectSpread63(_objectSpread63({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance
        }), false);
      },
      getWidgetRenderState: function getWidgetRenderState(_ref33) {
        var results = _ref33.results;
        var _ref44 = results || {}, _ref4$userData = _ref44.userData, userData = _ref4$userData === void 0 ? [] : _ref4$userData;
        var items = transformItems(userData, {
          results
        });
        return {
          items,
          widgetParams
        };
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return _objectSpread63(_objectSpread63({}, renderState), {}, {
          queryRules: this.getWidgetRenderState(renderOptions)
        });
      },
      dispose: function dispose(_ref52) {
        var helper = _ref52.helper, state = _ref52.state;
        unmount();
        if (hasTrackedFilters) {
          helper.removeListener("change", onHelperChange);
          return state.setQueryParameter("ruleContexts", initialRuleContexts);
        }
        return state;
      }
    };
  };
};
var connectQueryRules_default = connectQueryRules;

// node_modules/instantsearch.js/es/widgets/query-rule-context/query-rule-context.js
function _typeof56(o4) {
  "@babel/helpers - typeof";
  return _typeof56 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof56(o4);
}
function ownKeys64(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread64(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys64(Object(t4), true).forEach(function(r4) {
      _defineProperty56(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys64(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty56(obj, key2, value) {
  key2 = _toPropertyKey55(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey55(t4) {
  var i4 = _toPrimitive55(t4, "string");
  return "symbol" == _typeof56(i4) ? i4 : String(i4);
}
function _toPrimitive55(t4, r3) {
  if ("object" != _typeof56(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof56(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage35 = createDocumentationMessageGenerator({
  name: "query-rule-context"
});
var queryRuleContext = function queryRuleContext2() {
  var widgetParams = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  if (!widgetParams.trackedFilters) {
    throw new Error(withUsage35("The `trackedFilters` option is required."));
  }
  return _objectSpread64(_objectSpread64({}, connectQueryRules_default(noop)(widgetParams)), {}, {
    $$widgetType: "ais.queryRuleContext"
  });
};
var query_rule_context_default = queryRuleContext;

// node_modules/instantsearch.js/es/components/QueryRuleCustomData/QueryRuleCustomData.js
var QueryRuleCustomData = function QueryRuleCustomData2(_ref9) {
  var cssClasses = _ref9.cssClasses, templates = _ref9.templates, items = _ref9.items;
  return y2(Template_default, {
    templateKey: "default",
    templates,
    rootProps: {
      className: cssClasses.root
    },
    data: {
      items
    }
  });
};
var QueryRuleCustomData_default = QueryRuleCustomData;

// node_modules/instantsearch.js/es/widgets/query-rule-custom-data/query-rule-custom-data.js
function _typeof57(o4) {
  "@babel/helpers - typeof";
  return _typeof57 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof57(o4);
}
function ownKeys65(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread65(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys65(Object(t4), true).forEach(function(r4) {
      _defineProperty57(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys65(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty57(obj, key2, value) {
  key2 = _toPropertyKey56(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey56(t4) {
  var i4 = _toPrimitive56(t4, "string");
  return "symbol" == _typeof57(i4) ? i4 : String(i4);
}
function _toPrimitive56(t4, r3) {
  if ("object" != _typeof57(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof57(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var defaultTemplates12 = {
  default: function _default(_ref9) {
    var items = _ref9.items;
    return JSON.stringify(items, null, 2);
  }
};
var withUsage36 = createDocumentationMessageGenerator({
  name: "query-rule-custom-data"
});
var suit16 = component("QueryRuleCustomData");
var renderer31 = function renderer32(_ref23) {
  var containerNode = _ref23.containerNode, cssClasses = _ref23.cssClasses, templates = _ref23.templates;
  return function(_ref33) {
    var items = _ref33.items;
    N2(y2(QueryRuleCustomData_default, {
      cssClasses,
      templates,
      items
    }), containerNode);
  };
};
var queryRuleCustomData = function queryRuleCustomData2(widgetParams) {
  var _ref44 = widgetParams || {}, container = _ref44.container, _ref4$cssClasses = _ref44.cssClasses, userCssClasses = _ref4$cssClasses === void 0 ? {} : _ref4$cssClasses, _ref4$templates = _ref44.templates, userTemplates = _ref4$templates === void 0 ? {} : _ref4$templates, _ref4$transformItems = _ref44.transformItems, transformItems = _ref4$transformItems === void 0 ? function(items) {
    return items;
  } : _ref4$transformItems;
  if (!container) {
    throw new Error(withUsage36("The `container` option is required."));
  }
  var cssClasses = {
    root: cx(suit16(), userCssClasses.root)
  };
  var containerNode = getContainerNode(container);
  var templates = _objectSpread65(_objectSpread65({}, defaultTemplates12), userTemplates);
  var specializedRenderer = renderer31({
    containerNode,
    cssClasses,
    renderState: {},
    templates
  });
  var makeWidget = connectQueryRules_default(specializedRenderer, function() {
    N2(null, containerNode);
  });
  return _objectSpread65(_objectSpread65({}, makeWidget({
    transformItems
  })), {}, {
    $$widgetType: "ais.queryRuleCustomData"
  });
};
var query_rule_custom_data_default = queryRuleCustomData;

// node_modules/instantsearch.js/es/connectors/related-products/connectRelatedProducts.js
function _typeof58(o4) {
  "@babel/helpers - typeof";
  return _typeof58 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof58(o4);
}
function ownKeys66(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread66(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys66(Object(t4), true).forEach(function(r4) {
      _defineProperty58(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys66(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty58(obj, key2, value) {
  key2 = _toPropertyKey57(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey57(t4) {
  var i4 = _toPrimitive57(t4, "string");
  return "symbol" == _typeof58(i4) ? i4 : String(i4);
}
function _toPrimitive57(t4, r3) {
  if ("object" != _typeof58(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof58(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage37 = createDocumentationMessageGenerator({
  name: "related-products",
  connector: true
});
var connectRelatedProducts_default = function connectRelatedProducts(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage37());
  return function(widgetParams) {
    var _ref9 = widgetParams || {}, _ref$escapeHTML = _ref9.escapeHTML, escapeHTML = _ref$escapeHTML === void 0 ? true : _ref$escapeHTML, objectIDs = _ref9.objectIDs, limit = _ref9.limit, threshold = _ref9.threshold, fallbackParameters = _ref9.fallbackParameters, queryParameters = _ref9.queryParameters, _ref$transformItems = _ref9.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
      return items;
    } : _ref$transformItems;
    if (!objectIDs || objectIDs.length === 0) {
      throw new Error(withUsage37("The `objectIDs` option is required."));
    }
    var sendEvent;
    return {
      dependsOn: "recommend",
      $$type: "ais.relatedProducts",
      init: function init(initOptions) {
        renderFn(_objectSpread66(_objectSpread66({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: initOptions.instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var renderState = this.getWidgetRenderState(renderOptions);
        renderFn(_objectSpread66(_objectSpread66({}, renderState), {}, {
          instantSearchInstance: renderOptions.instantSearchInstance
        }), false);
      },
      getRenderState: function getRenderState(renderState) {
        return renderState;
      },
      getWidgetRenderState: function getWidgetRenderState(_ref23) {
        var results = _ref23.results, helper = _ref23.helper, instantSearchInstance = _ref23.instantSearchInstance;
        if (!sendEvent) {
          sendEvent = createSendEventForHits({
            instantSearchInstance,
            helper,
            widgetType: this.$$type
          });
        }
        if (results === null || results === void 0) {
          return {
            items: [],
            widgetParams,
            sendEvent
          };
        }
        if (escapeHTML && results.hits.length > 0) {
          results.hits = escapeHits(results.hits);
        }
        var itemsWithAbsolutePosition = addAbsolutePosition(results.hits, 0, 1);
        var itemsWithAbsolutePositionAndQueryID = addQueryID(itemsWithAbsolutePosition, results.queryID);
        var transformedItems = transformItems(itemsWithAbsolutePositionAndQueryID, {
          results
        });
        return {
          items: transformedItems,
          widgetParams,
          sendEvent
        };
      },
      dispose: function dispose(_ref33) {
        var recommendState = _ref33.recommendState;
        unmountFn();
        return recommendState.removeParams(this.$$id);
      },
      getWidgetParameters: function getWidgetParameters(state) {
        var _this = this;
        return objectIDs.reduce(function(acc, objectID) {
          return acc.addRelatedProducts({
            objectID,
            maxRecommendations: limit,
            threshold,
            fallbackParameters: _objectSpread66(_objectSpread66({}, fallbackParameters), escapeHTML ? TAG_PLACEHOLDER : {}),
            queryParameters: _objectSpread66(_objectSpread66({}, queryParameters), escapeHTML ? TAG_PLACEHOLDER : {}),
            $$id: _this.$$id
          });
        }, state.removeParams(this.$$id));
      }
    };
  };
};

// node_modules/instantsearch.js/es/widgets/related-products/related-products.js
function _typeof59(o4) {
  "@babel/helpers - typeof";
  return _typeof59 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof59(o4);
}
var _excluded37 = ["item", "sendEvent"];
function ownKeys67(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread67(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys67(Object(t4), true).forEach(function(r4) {
      _defineProperty59(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys67(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty59(obj, key2, value) {
  key2 = _toPropertyKey58(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey58(t4) {
  var i4 = _toPrimitive58(t4, "string");
  return "symbol" == _typeof59(i4) ? i4 : String(i4);
}
function _toPrimitive58(t4, r3) {
  if ("object" != _typeof59(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof59(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _objectWithoutProperties18(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose18(source, excluded);
  var key2, i4;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i4 = 0; i4 < sourceSymbolKeys.length; i4++) {
      key2 = sourceSymbolKeys[i4];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose18(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i4;
  for (i4 = 0; i4 < sourceKeys.length; i4++) {
    key2 = sourceKeys[i4];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function _extends20() {
  _extends20 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends20.apply(this, arguments);
}
var withUsage38 = createDocumentationMessageGenerator({
  name: "related-products"
});
var RelatedProducts = createRelatedProductsComponent({
  createElement: y2,
  Fragment: g2
});
function createRenderer(_ref9) {
  var renderState = _ref9.renderState, cssClasses = _ref9.cssClasses, containerNode = _ref9.containerNode, templates = _ref9.templates;
  return function renderer55(_ref23, isFirstRendering) {
    var items = _ref23.items, results = _ref23.results, instantSearchInstance = _ref23.instantSearchInstance, sendEvent = _ref23.sendEvent;
    if (isFirstRendering) {
      renderState.templateProps = prepareTemplateProps({
        defaultTemplates: {},
        templatesConfig: instantSearchInstance.templatesConfig,
        templates
      });
      return;
    }
    var headerComponent = templates.header ? function(data) {
      return y2(Template_default, _extends20({}, renderState.templateProps, {
        templateKey: "header",
        rootTagName: "fragment",
        data: {
          cssClasses: data.classNames,
          items: data.items
        }
      }));
    } : void 0;
    var itemComponent = templates.item ? function(_ref33) {
      var item11 = _ref33.item, _sendEvent = _ref33.sendEvent, rootProps = _objectWithoutProperties18(_ref33, _excluded37);
      return y2(Template_default, _extends20({}, renderState.templateProps, {
        templateKey: "item",
        rootTagName: "fragment",
        data: item11,
        sendEvent: _sendEvent,
        rootProps: _objectSpread67({}, rootProps)
      }));
    } : void 0;
    var emptyComponent = templates.empty ? function() {
      return y2(Template_default, _extends20({}, renderState.templateProps, {
        templateKey: "empty",
        rootTagName: "fragment",
        data: results
      }));
    } : void 0;
    var layoutComponent = templates.layout ? function(data) {
      return y2(Template_default, _extends20({}, renderState.templateProps, {
        templateKey: "layout",
        rootTagName: "fragment",
        data: {
          sendEvent,
          items: data.items,
          templates: {
            item: templates.item ? function(_ref44) {
              var item11 = _ref44.item;
              return y2(Template_default, _extends20({}, renderState.templateProps, {
                templateKey: "item",
                rootTagName: "fragment",
                data: item11,
                sendEvent
              }));
            } : void 0
          },
          cssClasses: {
            list: data.classNames.list,
            item: data.classNames.item
          }
        },
        sendEvent
      }));
    } : void 0;
    N2(y2(RelatedProducts, {
      items,
      sendEvent,
      classNames: cssClasses,
      headerComponent,
      itemComponent,
      emptyComponent,
      layout: layoutComponent,
      status: instantSearchInstance.status
    }), containerNode);
  };
}
var related_products_default = function relatedProducts(widgetParams) {
  var _ref52 = widgetParams || {}, container = _ref52.container, objectIDs = _ref52.objectIDs, limit = _ref52.limit, queryParameters = _ref52.queryParameters, fallbackParameters = _ref52.fallbackParameters, threshold = _ref52.threshold, escapeHTML = _ref52.escapeHTML, transformItems = _ref52.transformItems, _ref5$templates = _ref52.templates, templates = _ref5$templates === void 0 ? {} : _ref5$templates, _ref5$cssClasses = _ref52.cssClasses, cssClasses = _ref5$cssClasses === void 0 ? {} : _ref5$cssClasses;
  if (!container) {
    throw new Error(withUsage38("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var specializedRenderer = createRenderer({
    containerNode,
    cssClasses,
    renderState: {},
    templates
  });
  var makeWidget = connectRelatedProducts_default(specializedRenderer, function() {
    return N2(null, containerNode);
  });
  return _objectSpread67(_objectSpread67({}, makeWidget({
    objectIDs,
    limit,
    queryParameters,
    fallbackParameters,
    threshold,
    escapeHTML,
    transformItems
  })), {}, {
    $$widgetType: "ais.relatedProducts"
  });
};

// node_modules/instantsearch.js/es/components/RangeInput/RangeInput.js
function _typeof60(o4) {
  "@babel/helpers - typeof";
  return _typeof60 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof60(o4);
}
function _extends21() {
  _extends21 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends21.apply(this, arguments);
}
function _classCallCheck6(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties6(target, props) {
  for (var i4 = 0; i4 < props.length; i4++) {
    var descriptor = props[i4];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey59(descriptor.key), descriptor);
  }
}
function _createClass6(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties6(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties6(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _inherits5(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf5(subClass, superClass);
}
function _setPrototypeOf5(o4, p4) {
  _setPrototypeOf5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf9(o5, p5) {
    o5.__proto__ = p5;
    return o5;
  };
  return _setPrototypeOf5(o4, p4);
}
function _createSuper5(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct5();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf5(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf5(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn5(this, result);
  };
}
function _possibleConstructorReturn5(self, call) {
  if (call && (_typeof60(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized5(self);
}
function _assertThisInitialized5(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct5() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e4) {
    return false;
  }
}
function _getPrototypeOf5(o4) {
  _getPrototypeOf5 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf9(o5) {
    return o5.__proto__ || Object.getPrototypeOf(o5);
  };
  return _getPrototypeOf5(o4);
}
function _defineProperty60(obj, key2, value) {
  key2 = _toPropertyKey59(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey59(t4) {
  var i4 = _toPrimitive59(t4, "string");
  return "symbol" == _typeof60(i4) ? i4 : String(i4);
}
function _toPrimitive59(t4, r3) {
  if ("object" != _typeof60(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof60(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function stripLeadingZeroFromInput(value) {
  return value.replace(/^(0+)\d/, function(part) {
    return Number(part).toString();
  });
}
var RangeInput = /* @__PURE__ */ function(_Component) {
  _inherits5(RangeInput2, _Component);
  var _super = _createSuper5(RangeInput2);
  function RangeInput2() {
    var _this$props$values$mi, _this$props$values$ma;
    var _this;
    _classCallCheck6(this, RangeInput2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty60(_assertThisInitialized5(_this), "state", {
      min: (_this$props$values$mi = _this.props.values.min) === null || _this$props$values$mi === void 0 ? void 0 : _this$props$values$mi.toString(),
      max: (_this$props$values$ma = _this.props.values.max) === null || _this$props$values$ma === void 0 ? void 0 : _this$props$values$ma.toString()
    });
    _defineProperty60(_assertThisInitialized5(_this), "onInput", function(key2) {
      return function(event) {
        var _ref9 = event.currentTarget, value = _ref9.value;
        _this.setState(_defineProperty60({}, key2, value));
      };
    });
    _defineProperty60(_assertThisInitialized5(_this), "onSubmit", function(event) {
      event.preventDefault();
      var _this$state = _this.state, min = _this$state.min, max = _this$state.max;
      _this.props.refine([min ? Number(min) : void 0, max ? Number(max) : void 0]);
    });
    return _this;
  }
  _createClass6(RangeInput2, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _nextProps$values$min, _nextProps$values$max;
      this.setState({
        min: (_nextProps$values$min = nextProps.values.min) === null || _nextProps$values$min === void 0 ? void 0 : _nextProps$values$min.toString(),
        max: (_nextProps$values$max = nextProps.values.max) === null || _nextProps$values$max === void 0 ? void 0 : _nextProps$values$max.toString()
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state, minValue = _this$state2.min, maxValue = _this$state2.max;
      var _this$props = this.props, min = _this$props.min, max = _this$props.max, step = _this$props.step, cssClasses = _this$props.cssClasses, templateProps = _this$props.templateProps;
      var isDisabled = min && max ? min >= max : false;
      var hasRefinements = Boolean(minValue || maxValue);
      var rootClassNames = cx(cssClasses.root, !hasRefinements && cssClasses.noRefinement);
      return y2("div", {
        className: rootClassNames
      }, y2("form", {
        className: cssClasses.form,
        onSubmit: this.onSubmit
      }, y2("label", {
        className: cssClasses.label
      }, y2("input", {
        className: cx(cssClasses.input, cssClasses.inputMin),
        type: "number",
        min,
        max,
        step,
        value: stripLeadingZeroFromInput(minValue !== null && minValue !== void 0 ? minValue : ""),
        onInput: this.onInput("min"),
        placeholder: min === null || min === void 0 ? void 0 : min.toString(),
        disabled: isDisabled
      })), y2(Template_default, _extends21({}, templateProps, {
        templateKey: "separatorText",
        rootTagName: "span",
        rootProps: {
          className: cssClasses.separator
        }
      })), y2("label", {
        className: cssClasses.label
      }, y2("input", {
        className: cx(cssClasses.input, cssClasses.inputMax),
        type: "number",
        min,
        max,
        step,
        value: stripLeadingZeroFromInput(maxValue !== null && maxValue !== void 0 ? maxValue : ""),
        onInput: this.onInput("max"),
        placeholder: max === null || max === void 0 ? void 0 : max.toString(),
        disabled: isDisabled
      })), y2(Template_default, _extends21({}, templateProps, {
        templateKey: "submitText",
        rootTagName: "button",
        rootProps: {
          type: "submit",
          className: cssClasses.submit,
          disabled: isDisabled
        }
      }))));
    }
  }]);
  return RangeInput2;
}(b2);
var RangeInput_default = RangeInput;

// node_modules/instantsearch.js/es/connectors/range/connectRange.js
function _typeof61(o4) {
  "@babel/helpers - typeof";
  return _typeof61 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof61(o4);
}
function ownKeys68(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread68(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys68(Object(t4), true).forEach(function(r4) {
      _defineProperty61(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys68(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty61(obj, key2, value) {
  key2 = _toPropertyKey60(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey60(t4) {
  var i4 = _toPrimitive60(t4, "string");
  return "symbol" == _typeof61(i4) ? i4 : String(i4);
}
function _toPrimitive60(t4, r3) {
  if ("object" != _typeof61(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof61(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _slicedToArray11(arr, i4) {
  return _arrayWithHoles11(arr) || _iterableToArrayLimit11(arr, i4) || _unsupportedIterableToArray20(arr, i4) || _nonIterableRest11();
}
function _nonIterableRest11() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray20(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray20(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray20(o4, minLen);
}
function _arrayLikeToArray20(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
function _iterableToArrayLimit11(r3, l4) {
  var t4 = null == r3 ? null : "undefined" != typeof Symbol && r3[Symbol.iterator] || r3["@@iterator"];
  if (null != t4) {
    var e4, n4, i4, u4, a4 = [], f4 = true, o4 = false;
    try {
      if (i4 = (t4 = t4.call(r3)).next, 0 === l4) {
        if (Object(t4) !== t4)
          return;
        f4 = false;
      } else
        for (; !(f4 = (e4 = i4.call(t4)).done) && (a4.push(e4.value), a4.length !== l4); f4 = true)
          ;
    } catch (r4) {
      o4 = true, n4 = r4;
    } finally {
      try {
        if (!f4 && null != t4.return && (u4 = t4.return(), Object(u4) !== u4))
          return;
      } finally {
        if (o4)
          throw n4;
      }
    }
    return a4;
  }
}
function _arrayWithHoles11(arr) {
  if (Array.isArray(arr))
    return arr;
}
var withUsage39 = createDocumentationMessageGenerator({
  name: "range-input",
  connector: true
}, {
  name: "range-slider",
  connector: true
});
var $$type3 = "ais.range";
function toPrecision(_ref9) {
  var min = _ref9.min, max = _ref9.max, precision = _ref9.precision;
  var pow = Math.pow(10, precision);
  return {
    min: min ? Math.floor(min * pow) / pow : min,
    max: max ? Math.ceil(max * pow) / pow : max
  };
}
var connectRange = function connectRange2(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage39());
  return function(widgetParams) {
    var _ref23 = widgetParams || {}, _ref2$attribute = _ref23.attribute, attribute = _ref2$attribute === void 0 ? "" : _ref2$attribute, minBound = _ref23.min, maxBound = _ref23.max, _ref2$precision = _ref23.precision, precision = _ref2$precision === void 0 ? 0 : _ref2$precision;
    if (!attribute) {
      throw new Error(withUsage39("The `attribute` option is required."));
    }
    if (isFiniteNumber(minBound) && isFiniteNumber(maxBound) && minBound > maxBound) {
      throw new Error(withUsage39("The `max` option can't be lower than `min`."));
    }
    var formatToNumber = function formatToNumber2(v4) {
      return Number(Number(v4).toFixed(precision));
    };
    var rangeFormatter = {
      from: function from(v4) {
        return v4.toLocaleString();
      },
      to: function to(v4) {
        return formatToNumber(v4).toLocaleString();
      }
    };
    var getRefinedState2 = function getRefinedState3(helper, currentRange, nextMin, nextMax) {
      var resolvedState = helper.state;
      var currentRangeMin = currentRange.min, currentRangeMax = currentRange.max;
      var _ref33 = resolvedState.getNumericRefinement(attribute, ">=") || [], _ref44 = _slicedToArray11(_ref33, 1), min = _ref44[0];
      var _ref52 = resolvedState.getNumericRefinement(attribute, "<=") || [], _ref64 = _slicedToArray11(_ref52, 1), max = _ref64[0];
      var isResetMin = nextMin === void 0 || nextMin === "";
      var isResetMax = nextMax === void 0 || nextMax === "";
      var _toPrecision = toPrecision({
        min: !isResetMin ? parseFloat(nextMin) : void 0,
        max: !isResetMax ? parseFloat(nextMax) : void 0,
        precision
      }), nextMinAsNumber = _toPrecision.min, nextMaxAsNumber = _toPrecision.max;
      var newNextMin;
      if (!isFiniteNumber(minBound) && currentRangeMin === nextMinAsNumber) {
        newNextMin = void 0;
      } else if (isFiniteNumber(minBound) && isResetMin) {
        newNextMin = minBound;
      } else {
        newNextMin = nextMinAsNumber;
      }
      var newNextMax;
      if (!isFiniteNumber(maxBound) && currentRangeMax === nextMaxAsNumber) {
        newNextMax = void 0;
      } else if (isFiniteNumber(maxBound) && isResetMax) {
        newNextMax = maxBound;
      } else {
        newNextMax = nextMaxAsNumber;
      }
      var isResetNewNextMin = newNextMin === void 0;
      var isGreaterThanCurrentRange = isFiniteNumber(currentRangeMin) && currentRangeMin <= newNextMin;
      var isMinValid = isResetNewNextMin || isFiniteNumber(newNextMin) && (!isFiniteNumber(currentRangeMin) || isGreaterThanCurrentRange);
      var isResetNewNextMax = newNextMax === void 0;
      var isLowerThanRange = isFiniteNumber(newNextMax) && currentRangeMax >= newNextMax;
      var isMaxValid = isResetNewNextMax || isFiniteNumber(newNextMax) && (!isFiniteNumber(currentRangeMax) || isLowerThanRange);
      var hasMinChange = min !== newNextMin;
      var hasMaxChange = max !== newNextMax;
      if ((hasMinChange || hasMaxChange) && isMinValid && isMaxValid) {
        resolvedState = resolvedState.removeNumericRefinement(attribute);
        if (isFiniteNumber(newNextMin)) {
          resolvedState = resolvedState.addNumericRefinement(attribute, ">=", newNextMin);
        }
        if (isFiniteNumber(newNextMax)) {
          resolvedState = resolvedState.addNumericRefinement(attribute, "<=", newNextMax);
        }
        return resolvedState.resetPage();
      }
      return null;
    };
    var createSendEvent7 = function createSendEvent8(instantSearchInstance) {
      return function() {
        if (arguments.length === 1) {
          instantSearchInstance.sendEventToInsights(arguments.length <= 0 ? void 0 : arguments[0]);
          return;
        }
      };
    };
    function _getCurrentRange(stats3) {
      var min;
      if (isFiniteNumber(minBound)) {
        min = minBound;
      } else if (isFiniteNumber(stats3.min)) {
        min = stats3.min;
      } else {
        min = 0;
      }
      var max;
      if (isFiniteNumber(maxBound)) {
        max = maxBound;
      } else if (isFiniteNumber(stats3.max)) {
        max = stats3.max;
      } else {
        max = 0;
      }
      return toPrecision({
        min,
        max,
        precision
      });
    }
    function _getCurrentRefinement(helper) {
      var _ref72 = helper.getNumericRefinement(attribute, ">=") || [], _ref82 = _slicedToArray11(_ref72, 1), minValue = _ref82[0];
      var _ref9 = helper.getNumericRefinement(attribute, "<=") || [], _ref10 = _slicedToArray11(_ref9, 1), maxValue = _ref10[0];
      var min = isFiniteNumber(minValue) ? minValue : -Infinity;
      var max = isFiniteNumber(maxValue) ? maxValue : Infinity;
      return [min, max];
    }
    function _refine2(helper, currentRange) {
      return function() {
        var _ref11 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [void 0, void 0], _ref12 = _slicedToArray11(_ref11, 2), nextMin = _ref12[0], nextMax = _ref12[1];
        var refinedState = getRefinedState2(helper, currentRange, nextMin, nextMax);
        if (refinedState) {
          helper.setState(refinedState).search();
        }
      };
    }
    return {
      $$type: $$type3,
      init: function init(initOptions) {
        renderFn(_objectSpread68(_objectSpread68({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: initOptions.instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        renderFn(_objectSpread68(_objectSpread68({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: renderOptions.instantSearchInstance
        }), false);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return _objectSpread68(_objectSpread68({}, renderState), {}, {
          range: _objectSpread68(_objectSpread68({}, renderState.range), {}, _defineProperty61({}, attribute, this.getWidgetRenderState(renderOptions)))
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref13) {
        var results = _ref13.results, helper = _ref13.helper, instantSearchInstance = _ref13.instantSearchInstance;
        var facetsFromResults = results && results.disjunctiveFacets || [];
        var facet = find(facetsFromResults, function(facetResult) {
          return facetResult.name === attribute;
        });
        var stats3 = facet && facet.stats || {
          min: void 0,
          max: void 0
        };
        var currentRange = _getCurrentRange(stats3);
        var start = _getCurrentRefinement(helper);
        var refine2;
        if (!results) {
          refine2 = _refine2(helper, {
            min: void 0,
            max: void 0
          });
        } else {
          refine2 = _refine2(helper, currentRange);
        }
        return {
          refine: refine2,
          canRefine: currentRange.min !== currentRange.max,
          format: rangeFormatter,
          range: currentRange,
          sendEvent: createSendEvent7(instantSearchInstance),
          widgetParams: _objectSpread68(_objectSpread68({}, widgetParams), {}, {
            precision
          }),
          start
        };
      },
      dispose: function dispose(_ref14) {
        var state = _ref14.state;
        unmountFn();
        return state.removeDisjunctiveFacet(attribute).removeNumericRefinement(attribute);
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref15) {
        var searchParameters = _ref15.searchParameters;
        var _searchParameters$get = searchParameters.getNumericRefinements(attribute), _searchParameters$get2 = _searchParameters$get[">="], min = _searchParameters$get2 === void 0 ? [] : _searchParameters$get2, _searchParameters$get3 = _searchParameters$get["<="], max = _searchParameters$get3 === void 0 ? [] : _searchParameters$get3;
        if (min.length === 0 && max.length === 0) {
          return uiState;
        }
        return _objectSpread68(_objectSpread68({}, uiState), {}, {
          range: _objectSpread68(_objectSpread68({}, uiState.range), {}, _defineProperty61({}, attribute, "".concat(min, ":").concat(max)))
        });
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref16) {
        var uiState = _ref16.uiState;
        var widgetSearchParameters = searchParameters.addDisjunctiveFacet(attribute).setQueryParameters({
          numericRefinements: _objectSpread68(_objectSpread68({}, searchParameters.numericRefinements), {}, _defineProperty61({}, attribute, {}))
        });
        if (isFiniteNumber(minBound)) {
          widgetSearchParameters = widgetSearchParameters.addNumericRefinement(attribute, ">=", minBound);
        }
        if (isFiniteNumber(maxBound)) {
          widgetSearchParameters = widgetSearchParameters.addNumericRefinement(attribute, "<=", maxBound);
        }
        var value = uiState.range && uiState.range[attribute];
        if (!value || value.indexOf(":") === -1) {
          return widgetSearchParameters;
        }
        var _value$split$map = value.split(":").map(parseFloat), _value$split$map2 = _slicedToArray11(_value$split$map, 2), lowerBound = _value$split$map2[0], upperBound = _value$split$map2[1];
        if (isFiniteNumber(lowerBound) && (!isFiniteNumber(minBound) || minBound < lowerBound)) {
          widgetSearchParameters = widgetSearchParameters.removeNumericRefinement(attribute, ">=");
          widgetSearchParameters = widgetSearchParameters.addNumericRefinement(attribute, ">=", lowerBound);
        }
        if (isFiniteNumber(upperBound) && (!isFiniteNumber(maxBound) || upperBound < maxBound)) {
          widgetSearchParameters = widgetSearchParameters.removeNumericRefinement(attribute, "<=");
          widgetSearchParameters = widgetSearchParameters.addNumericRefinement(attribute, "<=", upperBound);
        }
        return widgetSearchParameters;
      }
    };
  };
};
var connectRange_default = connectRange;

// node_modules/instantsearch.js/es/widgets/range-input/range-input.js
function _typeof62(o4) {
  "@babel/helpers - typeof";
  return _typeof62 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof62(o4);
}
function ownKeys69(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread69(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys69(Object(t4), true).forEach(function(r4) {
      _defineProperty62(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys69(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty62(obj, key2, value) {
  key2 = _toPropertyKey61(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey61(t4) {
  var i4 = _toPrimitive61(t4, "string");
  return "symbol" == _typeof62(i4) ? i4 : String(i4);
}
function _toPrimitive61(t4, r3) {
  if ("object" != _typeof62(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof62(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _slicedToArray12(arr, i4) {
  return _arrayWithHoles12(arr) || _iterableToArrayLimit12(arr, i4) || _unsupportedIterableToArray21(arr, i4) || _nonIterableRest12();
}
function _nonIterableRest12() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray21(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray21(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray21(o4, minLen);
}
function _arrayLikeToArray21(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
function _iterableToArrayLimit12(r3, l4) {
  var t4 = null == r3 ? null : "undefined" != typeof Symbol && r3[Symbol.iterator] || r3["@@iterator"];
  if (null != t4) {
    var e4, n4, i4, u4, a4 = [], f4 = true, o4 = false;
    try {
      if (i4 = (t4 = t4.call(r3)).next, 0 === l4) {
        if (Object(t4) !== t4)
          return;
        f4 = false;
      } else
        for (; !(f4 = (e4 = i4.call(t4)).done) && (a4.push(e4.value), a4.length !== l4); f4 = true)
          ;
    } catch (r4) {
      o4 = true, n4 = r4;
    } finally {
      try {
        if (!f4 && null != t4.return && (u4 = t4.return(), Object(u4) !== u4))
          return;
      } finally {
        if (o4)
          throw n4;
      }
    }
    return a4;
  }
}
function _arrayWithHoles12(arr) {
  if (Array.isArray(arr))
    return arr;
}
var withUsage40 = createDocumentationMessageGenerator({
  name: "range-input"
});
var suit17 = component("RangeInput");
var defaultTemplates13 = {
  separatorText: function separatorText() {
    return "to";
  },
  submitText: function submitText() {
    return "Go";
  }
};
var renderer33 = function renderer34(_ref9) {
  var containerNode = _ref9.containerNode, cssClasses = _ref9.cssClasses, renderState = _ref9.renderState, templates = _ref9.templates;
  return function(_ref23, isFirstRendering) {
    var refine2 = _ref23.refine, range2 = _ref23.range, start = _ref23.start, widgetParams = _ref23.widgetParams, instantSearchInstance = _ref23.instantSearchInstance;
    if (isFirstRendering) {
      renderState.templateProps = prepareTemplateProps({
        defaultTemplates: defaultTemplates13,
        templatesConfig: instantSearchInstance.templatesConfig,
        templates
      });
      return;
    }
    var rangeMin = range2.min, rangeMax = range2.max;
    var _start = _slicedToArray12(start, 2), minValue = _start[0], maxValue = _start[1];
    var step = 1 / Math.pow(10, widgetParams.precision || 0);
    var values = {
      min: minValue !== -Infinity && minValue !== rangeMin ? minValue : void 0,
      max: maxValue !== Infinity && maxValue !== rangeMax ? maxValue : void 0
    };
    N2(y2(RangeInput_default, {
      min: rangeMin,
      max: rangeMax,
      step,
      values,
      cssClasses,
      refine: refine2,
      templateProps: renderState.templateProps
    }), containerNode);
  };
};
var rangeInput = function rangeInput2(widgetParams) {
  var _ref33 = widgetParams || {}, container = _ref33.container, attribute = _ref33.attribute, min = _ref33.min, max = _ref33.max, _ref3$precision = _ref33.precision, precision = _ref3$precision === void 0 ? 0 : _ref3$precision, _ref3$cssClasses = _ref33.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses, _ref3$templates = _ref33.templates, templates = _ref3$templates === void 0 ? {} : _ref3$templates;
  if (!container) {
    throw new Error(withUsage40("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var cssClasses = {
    root: cx(suit17(), userCssClasses.root),
    noRefinement: cx(suit17({
      modifierName: "noRefinement"
    })),
    form: cx(suit17({
      descendantName: "form"
    }), userCssClasses.form),
    label: cx(suit17({
      descendantName: "label"
    }), userCssClasses.label),
    input: cx(suit17({
      descendantName: "input"
    }), userCssClasses.input),
    inputMin: cx(suit17({
      descendantName: "input",
      modifierName: "min"
    }), userCssClasses.inputMin),
    inputMax: cx(suit17({
      descendantName: "input",
      modifierName: "max"
    }), userCssClasses.inputMax),
    separator: cx(suit17({
      descendantName: "separator"
    }), userCssClasses.separator),
    submit: cx(suit17({
      descendantName: "submit"
    }), userCssClasses.submit)
  };
  var specializedRenderer = renderer33({
    containerNode,
    cssClasses,
    templates,
    renderState: {}
  });
  var makeWidget = connectRange_default(specializedRenderer, function() {
    return N2(null, containerNode);
  });
  return _objectSpread69(_objectSpread69({}, makeWidget({
    attribute,
    min,
    max,
    precision
  })), {}, {
    $$type: "ais.rangeInput",
    $$widgetType: "ais.rangeInput"
  });
};
var range_input_default = rangeInput;

// node_modules/instantsearch.js/es/components/Slider/Pit.js
function _typeof63(o4) {
  "@babel/helpers - typeof";
  return _typeof63 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof63(o4);
}
function ownKeys70(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread70(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys70(Object(t4), true).forEach(function(r4) {
      _defineProperty63(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys70(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty63(obj, key2, value) {
  key2 = _toPropertyKey62(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey62(t4) {
  var i4 = _toPrimitive62(t4, "string");
  return "symbol" == _typeof63(i4) ? i4 : String(i4);
}
function _toPrimitive62(t4, r3) {
  if ("object" != _typeof63(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof63(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var Pit = function Pit2(_ref9) {
  var style = _ref9.style, children = _ref9.children;
  var positionValue = Math.round(parseFloat(style.left));
  var shouldDisplayValue = [0, 50, 100].includes(positionValue);
  var value = children;
  var pitValue = Math.round(parseInt(value, 10) * 100) / 100;
  return y2("div", {
    style: _objectSpread70(_objectSpread70({}, style), {}, {
      marginLeft: positionValue === 100 ? "-2px" : 0
    }),
    className: cx("rheostat-marker", "rheostat-marker-horizontal", shouldDisplayValue && "rheostat-marker-large")
  }, shouldDisplayValue && y2("div", {
    className: "rheostat-value"
  }, pitValue));
};
var Pit_default = Pit;

// node_modules/instantsearch.js/es/components/Slider/Rheostat.js
function _typeof64(o4) {
  "@babel/helpers - typeof";
  return _typeof64 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof64(o4);
}
function _defineProperties7(target, props) {
  for (var i4 = 0; i4 < props.length; i4++) {
    var descriptor = props[i4];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey63(descriptor.key), descriptor);
  }
}
function _createClass7(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties7(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties7(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _classCallCheck7(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _inherits6(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf6(subClass, superClass);
}
function _setPrototypeOf6(o4, p4) {
  _setPrototypeOf6 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf9(o5, p5) {
    o5.__proto__ = p5;
    return o5;
  };
  return _setPrototypeOf6(o4, p4);
}
function _createSuper6(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct6();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf6(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf6(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn6(this, result);
  };
}
function _possibleConstructorReturn6(self, call) {
  if (call && (_typeof64(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized6(self);
}
function _assertThisInitialized6(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct6() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e4) {
    return false;
  }
}
function _getPrototypeOf6(o4) {
  _getPrototypeOf6 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf9(o5) {
    return o5.__proto__ || Object.getPrototypeOf(o5);
  };
  return _getPrototypeOf6(o4);
}
function _defineProperty64(obj, key2, value) {
  key2 = _toPropertyKey63(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey63(t4) {
  var i4 = _toPrimitive63(t4, "string");
  return "symbol" == _typeof64(i4) ? i4 : String(i4);
}
function _toPrimitive63(t4, r3) {
  if ("object" != _typeof64(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof64(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _extends22() {
  _extends22 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends22.apply(this, arguments);
}
var KEYS = {
  DOWN: 40,
  END: 35,
  ESC: 27,
  HOME: 36,
  LEFT: 37,
  PAGE_DOWN: 34,
  PAGE_UP: 33,
  RIGHT: 39,
  UP: 38
};
var PERCENT_EMPTY = 0;
var PERCENT_FULL = 100;
function getPosition(value, min, max) {
  return (value - min) / (max - min) * 100;
}
function getValue2(pos, min, max) {
  var decimal = pos / 100;
  if (pos === 0) {
    return min;
  } else if (pos === 100) {
    return max;
  }
  return Math.round((max - min) * decimal + min);
}
function getClassName(props) {
  var orientation = props.orientation === "vertical" ? "rheostat-vertical" : "rheostat-horizontal";
  return ["rheostat", orientation].concat(props.className.split(" ")).join(" ");
}
function getHandleFor(ev) {
  return Number(ev.currentTarget.getAttribute("data-handle-key"));
}
function killEvent(ev) {
  ev.stopPropagation();
  ev.preventDefault();
}
function Button(props) {
  return y2("button", _extends22({}, props, {
    type: "button"
  }));
}
var _ref6 = y2("div", {
  className: "rheostat-background"
});
var Rheostat = /* @__PURE__ */ function(_Component) {
  _inherits6(Rheostat2, _Component);
  var _super = _createSuper6(Rheostat2);
  function Rheostat2() {
    var _this;
    _classCallCheck7(this, Rheostat2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty64(_assertThisInitialized6(_this), "x", [0, 0].map(function(y4) {
      return y4;
    }));
    _defineProperty64(_assertThisInitialized6(_this), "state", {
      className: getClassName(_this.props),
      // non-null thanks to defaultProps
      handlePos: _this.props.values.map(function(value) {
        return getPosition(value, _this.props.min, _this.props.max);
      }),
      handleDimensions: 0,
      mousePos: null,
      sliderBox: {},
      slidingIndex: null,
      // non-null thanks to defaultProps
      values: _this.props.values
    });
    _defineProperty64(_assertThisInitialized6(_this), "rheostat", _2());
    _defineProperty64(_assertThisInitialized6(_this), "componentWillReceiveProps", function(nextProps) {
      var _this$props = _this.props, className = _this$props.className, disabled = _this$props.disabled, min = _this$props.min, max = _this$props.max, orientation = _this$props.orientation;
      var _this$state = _this.state, values = _this$state.values, slidingIndex = _this$state.slidingIndex;
      var minMaxChanged = nextProps.min !== min || nextProps.max !== max;
      var valuesChanged = values.length !== nextProps.values.length || values.some(function(value, idx) {
        return nextProps.values[idx] !== value;
      });
      var orientationChanged = nextProps.className !== className || nextProps.orientation !== orientation;
      var willBeDisabled = nextProps.disabled && !disabled;
      if (orientationChanged) {
        _this.setState({
          className: getClassName(nextProps)
        });
      }
      if (minMaxChanged || valuesChanged)
        _this.updateNewValues(nextProps);
      if (willBeDisabled && slidingIndex !== null) {
        _this.endSlide();
      }
    });
    _defineProperty64(_assertThisInitialized6(_this), "getPublicState", function() {
      var _this$props2 = _this.props, min = _this$props2.min, max = _this$props2.max;
      var values = _this.state.values;
      return {
        max,
        min,
        values
      };
    });
    _defineProperty64(_assertThisInitialized6(_this), "getSliderBoundingBox", function() {
      var node = _this.rheostat.current;
      var rect = node.getBoundingClientRect();
      return {
        height: rect.height || node.clientHeight,
        left: rect.left,
        top: rect.top,
        width: rect.width || node.clientWidth
      };
    });
    _defineProperty64(_assertThisInitialized6(_this), "getProgressStyle", function(idx) {
      var handlePos = _this.state.handlePos;
      var value = handlePos[idx];
      if (idx === 0) {
        return _this.props.orientation === "vertical" ? {
          height: "".concat(value, "%"),
          top: 0
        } : {
          left: 0,
          width: "".concat(value, "%")
        };
      }
      var prevValue = handlePos[idx - 1];
      var diffValue = value - prevValue;
      return _this.props.orientation === "vertical" ? {
        height: "".concat(diffValue, "%"),
        top: "".concat(prevValue, "%")
      } : {
        left: "".concat(prevValue, "%"),
        width: "".concat(diffValue, "%")
      };
    });
    _defineProperty64(_assertThisInitialized6(_this), "getMinValue", function(idx) {
      return _this.state.values[idx - 1] ? Math.max(_this.props.min, _this.state.values[idx - 1]) : _this.props.min;
    });
    _defineProperty64(_assertThisInitialized6(_this), "getMaxValue", function(idx) {
      return _this.state.values[idx + 1] ? Math.min(_this.props.max, _this.state.values[idx + 1]) : _this.props.max;
    });
    _defineProperty64(_assertThisInitialized6(_this), "getHandleDimensions", function(ev, sliderBox) {
      var handleNode = ev.currentTarget || null;
      if (!handleNode)
        return 0;
      return _this.props.orientation === "vertical" ? handleNode.clientHeight / sliderBox.height * PERCENT_FULL / 2 : handleNode.clientWidth / sliderBox.width * PERCENT_FULL / 2;
    });
    _defineProperty64(_assertThisInitialized6(_this), "getClosestSnapPoint", function(value) {
      if (!_this.props.snapPoints.length)
        return value;
      return _this.props.snapPoints.reduce(function(snapTo, snap) {
        return Math.abs(snapTo - value) < Math.abs(snap - value) ? snapTo : snap;
      });
    });
    _defineProperty64(_assertThisInitialized6(_this), "getSnapPosition", function(positionPercent) {
      if (!_this.props.snap)
        return positionPercent;
      var _ref9 = _this.props, max = _ref9.max, min = _ref9.min;
      var value = getValue2(positionPercent, min, max);
      var snapValue = _this.getClosestSnapPoint(value);
      return getPosition(snapValue, min, max);
    });
    _defineProperty64(_assertThisInitialized6(_this), "getNextPositionForKey", function(idx, keyCode) {
      var _stepMultiplier;
      var _this$state2 = _this.state, handlePos = _this$state2.handlePos, values = _this$state2.values;
      var _ref23 = _this.props, max = _ref23.max, min = _ref23.min, snapPoints = _ref23.snapPoints;
      var shouldSnap = _this.props.snap;
      var proposedValue = values[idx];
      var proposedPercentage = handlePos[idx];
      var originalPercentage = proposedPercentage;
      var stepValue = 1;
      if (max >= 100) {
        proposedPercentage = Math.round(proposedPercentage);
      } else {
        stepValue = 100 / (max - min);
      }
      var currentIndex = null;
      if (shouldSnap) {
        currentIndex = snapPoints.indexOf(_this.getClosestSnapPoint(values[idx]));
      }
      var stepMultiplier = (_stepMultiplier = {}, _defineProperty64(_stepMultiplier, KEYS.LEFT, function(v4) {
        return v4 * -1;
      }), _defineProperty64(_stepMultiplier, KEYS.RIGHT, function(v4) {
        return v4;
      }), _defineProperty64(_stepMultiplier, KEYS.UP, function(v4) {
        return v4;
      }), _defineProperty64(_stepMultiplier, KEYS.DOWN, function(v4) {
        return v4 * -1;
      }), _defineProperty64(_stepMultiplier, KEYS.PAGE_DOWN, function(v4) {
        return v4 > 1 ? -v4 : v4 * -10;
      }), _defineProperty64(_stepMultiplier, KEYS.PAGE_UP, function(v4) {
        return v4 > 1 ? v4 : v4 * 10;
      }), _stepMultiplier);
      if (Object.prototype.hasOwnProperty.call(stepMultiplier, keyCode)) {
        proposedPercentage += stepMultiplier[keyCode](stepValue);
        if (shouldSnap) {
          if (!currentIndex) {
          } else if (proposedPercentage > originalPercentage) {
            if (currentIndex < snapPoints.length - 1) {
              proposedValue = snapPoints[currentIndex + 1];
            }
          } else if (currentIndex > 0) {
            proposedValue = snapPoints[currentIndex - 1];
          }
        }
      } else if (keyCode === KEYS.HOME) {
        proposedPercentage = PERCENT_EMPTY;
        if (shouldSnap) {
          proposedValue = snapPoints[0];
        }
      } else if (keyCode === KEYS.END) {
        proposedPercentage = PERCENT_FULL;
        if (shouldSnap) {
          proposedValue = snapPoints[snapPoints.length - 1];
        }
      } else {
        return null;
      }
      return shouldSnap ? getPosition(proposedValue, min, max) : proposedPercentage;
    });
    _defineProperty64(_assertThisInitialized6(_this), "getNextState", function(idx, proposedPosition) {
      var handlePos = _this.state.handlePos;
      var _ref33 = _this.props, max = _ref33.max, min = _ref33.min;
      var actualPosition = _this.validatePosition(idx, proposedPosition);
      var nextHandlePos = handlePos.map(function(pos, index) {
        return index === idx ? actualPosition : pos;
      });
      return {
        handlePos: nextHandlePos,
        values: nextHandlePos.map(function(pos) {
          return getValue2(pos, min, max);
        })
      };
    });
    _defineProperty64(_assertThisInitialized6(_this), "getClosestHandle", function(positionPercent) {
      var handlePos = _this.state.handlePos;
      return handlePos.reduce(function(closestIdx, _node, idx) {
        var challenger = Math.abs(handlePos[idx] - positionPercent);
        var current = Math.abs(handlePos[closestIdx] - positionPercent);
        return challenger < current ? idx : closestIdx;
      }, 0);
    });
    _defineProperty64(_assertThisInitialized6(_this), "setStartSlide", function(ev, x4, y4) {
      var sliderBox = _this.getSliderBoundingBox();
      _this.setState({
        handleDimensions: _this.getHandleDimensions(ev, sliderBox),
        mousePos: {
          x: x4,
          y: y4
        },
        sliderBox,
        slidingIndex: getHandleFor(ev)
      });
    });
    _defineProperty64(_assertThisInitialized6(_this), "startMouseSlide", function(ev) {
      _this.setStartSlide(ev, ev.clientX, ev.clientY);
      document.addEventListener("mousemove", _this.handleMouseSlide, false);
      document.addEventListener("mouseup", _this.endSlide, false);
      killEvent(ev);
    });
    _defineProperty64(_assertThisInitialized6(_this), "startTouchSlide", function(ev) {
      if (ev.changedTouches.length > 1)
        return;
      var touch = ev.changedTouches[0];
      _this.setStartSlide(ev, touch.clientX, touch.clientY);
      document.addEventListener("touchmove", _this.handleTouchSlide, false);
      document.addEventListener("touchend", _this.endSlide, false);
      if (_this.props.onSliderDragStart)
        _this.props.onSliderDragStart();
      killEvent(ev);
    });
    _defineProperty64(_assertThisInitialized6(_this), "handleMouseSlide", function(ev) {
      if (_this.state.slidingIndex === null)
        return;
      _this.handleSlide(ev.clientX, ev.clientY);
      killEvent(ev);
    });
    _defineProperty64(_assertThisInitialized6(_this), "handleTouchSlide", function(ev) {
      if (_this.state.slidingIndex === null)
        return;
      if (ev.changedTouches.length > 1) {
        _this.endSlide();
        return;
      }
      var touch = ev.changedTouches[0];
      _this.handleSlide(touch.clientX, touch.clientY);
      killEvent(ev);
    });
    _defineProperty64(_assertThisInitialized6(_this), "handleSlide", function(x4, y4) {
      var _this$state3 = _this.state, idx = _this$state3.slidingIndex, sliderBox = _this$state3.sliderBox;
      var positionPercent = _this.props.orientation === "vertical" ? (y4 - sliderBox.top) / sliderBox.height * PERCENT_FULL : (x4 - sliderBox.left) / sliderBox.width * PERCENT_FULL;
      _this.slideTo(idx, positionPercent);
      if (_this.canMove(idx, positionPercent)) {
        _this.setState({
          mousePos: {
            x: x4,
            y: y4
          }
        });
        if (_this.props.onSliderDragMove)
          _this.props.onSliderDragMove();
      }
    });
    _defineProperty64(_assertThisInitialized6(_this), "endSlide", function() {
      var idx = _this.state.slidingIndex;
      _this.setState({
        slidingIndex: null
      });
      document.removeEventListener("mouseup", _this.endSlide, false);
      document.removeEventListener("touchend", _this.endSlide, false);
      document.removeEventListener("touchmove", _this.handleTouchSlide, false);
      document.removeEventListener("mousemove", _this.handleMouseSlide, false);
      if (_this.props.onSliderDragEnd)
        _this.props.onSliderDragEnd();
      if (_this.props.snap) {
        var positionPercent = _this.getSnapPosition(_this.state.handlePos[idx]);
        _this.slideTo(idx, positionPercent, function() {
          return _this.fireChangeEvent();
        });
      } else {
        _this.fireChangeEvent();
      }
    });
    _defineProperty64(_assertThisInitialized6(_this), "handleClick", function(ev) {
      if (ev.target.getAttribute("data-handle-key")) {
        return;
      }
      var sliderBox = _this.getSliderBoundingBox();
      var positionDecimal = _this.props.orientation === "vertical" ? (ev.clientY - sliderBox.top) / sliderBox.height : (ev.clientX - sliderBox.left) / sliderBox.width;
      var positionPercent = positionDecimal * PERCENT_FULL;
      var handleId = _this.getClosestHandle(positionPercent);
      var validPositionPercent = _this.getSnapPosition(positionPercent);
      _this.slideTo(handleId, validPositionPercent, function() {
        return _this.fireChangeEvent();
      });
      if (_this.props.onClick)
        _this.props.onClick();
    });
    _defineProperty64(_assertThisInitialized6(_this), "handleKeydown", function(ev) {
      var idx = getHandleFor(ev);
      if (ev.keyCode === KEYS.ESC) {
        ev.currentTarget.blur();
        return;
      }
      var proposedPercentage = _this.getNextPositionForKey(idx, ev.keyCode);
      if (proposedPercentage === null)
        return;
      if (_this.canMove(idx, proposedPercentage)) {
        _this.slideTo(idx, proposedPercentage, function() {
          return _this.fireChangeEvent();
        });
        if (_this.props.onKeyPress)
          _this.props.onKeyPress();
      }
      killEvent(ev);
    });
    _defineProperty64(_assertThisInitialized6(_this), "validatePosition", function(idx, proposedPosition) {
      var _this$state4 = _this.state, handlePos = _this$state4.handlePos, handleDimensions = _this$state4.handleDimensions;
      return Math.max(
        Math.min(
          proposedPosition,
          handlePos[idx + 1] !== void 0 ? handlePos[idx + 1] - handleDimensions : PERCENT_FULL
          // 100% is the highest value
        ),
        handlePos[idx - 1] !== void 0 ? handlePos[idx - 1] + handleDimensions : PERCENT_EMPTY
        // 0% is the lowest value
      );
    });
    _defineProperty64(_assertThisInitialized6(_this), "validateValues", function(proposedValues, props) {
      var _ref44 = props || _this.props, max = _ref44.max, min = _ref44.min;
      return proposedValues.map(function(value, idx, values) {
        var realValue = Math.max(Math.min(value, max), min);
        if (values.length && realValue < values[idx - 1]) {
          return values[idx - 1];
        }
        return realValue;
      });
    });
    _defineProperty64(_assertThisInitialized6(_this), "canMove", function(idx, proposedPosition) {
      var _this$state5 = _this.state, handlePos = _this$state5.handlePos, handleDimensions = _this$state5.handleDimensions;
      if (proposedPosition < PERCENT_EMPTY)
        return false;
      if (proposedPosition > PERCENT_FULL)
        return false;
      var nextHandlePosition = handlePos[idx + 1] !== void 0 ? handlePos[idx + 1] - handleDimensions : Infinity;
      if (proposedPosition > nextHandlePosition)
        return false;
      var prevHandlePosition = handlePos[idx - 1] !== void 0 ? handlePos[idx - 1] + handleDimensions : -Infinity;
      if (proposedPosition < prevHandlePosition)
        return false;
      return true;
    });
    _defineProperty64(_assertThisInitialized6(_this), "fireChangeEvent", function() {
      var onChange = _this.props.onChange;
      if (onChange)
        onChange(_this.getPublicState());
    });
    _defineProperty64(_assertThisInitialized6(_this), "slideTo", function(idx, proposedPosition, onAfterSet) {
      var nextState = _this.getNextState(idx, proposedPosition);
      _this.setState(nextState, function() {
        var onValuesUpdated = _this.props.onValuesUpdated;
        if (onValuesUpdated)
          onValuesUpdated(_this.getPublicState());
        if (onAfterSet)
          onAfterSet();
      });
    });
    _defineProperty64(_assertThisInitialized6(_this), "updateNewValues", function(nextProps) {
      var slidingIndex = _this.state.slidingIndex;
      if (slidingIndex !== null) {
        return;
      }
      var max = nextProps.max, min = nextProps.min, values = nextProps.values;
      var nextValues = _this.validateValues(values, nextProps);
      _this.setState({
        handlePos: nextValues.map(function(value) {
          return getPosition(value, min, max);
        }),
        values: nextValues
      }, function() {
        return _this.fireChangeEvent();
      });
    });
    _defineProperty64(_assertThisInitialized6(_this), "render", function() {
      var _ref52 = _this.props, children = _ref52.children, disabled = _ref52.disabled, Handle = _ref52.handle, max = _ref52.max, min = _ref52.min, orientation = _ref52.orientation, PitComponent = _ref52.pitComponent, pitPoints = _ref52.pitPoints, ProgressBar = _ref52.progressBar;
      var _this$state6 = _this.state, className = _this$state6.className, handlePos = _this$state6.handlePos, values = _this$state6.values;
      return y2("div", {
        className,
        ref: _this.rheostat,
        onClick: disabled ? void 0 : _this.handleClick,
        style: {
          position: "relative"
        }
      }, _ref6, handlePos.map(function(pos, idx) {
        var handleStyle = orientation === "vertical" ? {
          top: "".concat(pos, "%"),
          position: "absolute"
        } : {
          left: "".concat(pos, "%"),
          position: "absolute"
        };
        return y2(Handle, {
          "aria-valuemax": _this.getMaxValue(idx),
          "aria-valuemin": _this.getMinValue(idx),
          "aria-valuenow": values[idx],
          "aria-disabled": disabled,
          "data-handle-key": idx,
          className: "rheostat-handle",
          key: "handle-".concat(idx),
          onClick: killEvent,
          onKeyDown: disabled ? void 0 : _this.handleKeydown,
          onMouseDown: disabled ? void 0 : _this.startMouseSlide,
          onTouchStart: disabled ? void 0 : _this.startTouchSlide,
          role: "slider",
          style: handleStyle,
          tabIndex: 0
        });
      }), handlePos.map(function(_node, idx, arr) {
        if (idx === 0 && arr.length > 1) {
          return null;
        }
        return y2(ProgressBar, {
          className: "rheostat-progress",
          key: "progress-bar-".concat(idx),
          style: _this.getProgressStyle(idx)
        });
      }), PitComponent && pitPoints.map(function(n4) {
        var pos = getPosition(n4, min, max);
        var pitStyle = orientation === "vertical" ? {
          top: "".concat(pos, "%"),
          position: "absolute"
        } : {
          left: "".concat(pos, "%"),
          position: "absolute"
        };
        return y2(PitComponent, {
          key: "pit-".concat(n4),
          style: pitStyle
        }, n4);
      }), children);
    });
    return _this;
  }
  return _createClass7(Rheostat2);
}(b2);
_defineProperty64(Rheostat, "defaultProps", {
  className: "",
  children: null,
  disabled: false,
  handle: Button,
  max: PERCENT_FULL,
  min: PERCENT_EMPTY,
  onClick: null,
  onChange: null,
  onKeyPress: null,
  onSliderDragEnd: null,
  onSliderDragMove: null,
  onSliderDragStart: null,
  onValuesUpdated: null,
  orientation: "horizontal",
  pitComponent: null,
  pitPoints: [],
  progressBar: "div",
  snap: false,
  snapPoints: [],
  values: [PERCENT_EMPTY]
});
var Rheostat_default = Rheostat;

// node_modules/instantsearch.js/es/components/Slider/Slider.js
function _toConsumableArray11(arr) {
  return _arrayWithoutHoles11(arr) || _iterableToArray11(arr) || _unsupportedIterableToArray22(arr) || _nonIterableSpread11();
}
function _nonIterableSpread11() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray22(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray22(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray22(o4, minLen);
}
function _iterableToArray11(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles11(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray22(arr);
}
function _arrayLikeToArray22(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
function _extends23() {
  _extends23 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends23.apply(this, arguments);
}
function _typeof65(o4) {
  "@babel/helpers - typeof";
  return _typeof65 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof65(o4);
}
function _classCallCheck8(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties8(target, props) {
  for (var i4 = 0; i4 < props.length; i4++) {
    var descriptor = props[i4];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey64(descriptor.key), descriptor);
  }
}
function _createClass8(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties8(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties8(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _inherits7(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf7(subClass, superClass);
}
function _setPrototypeOf7(o4, p4) {
  _setPrototypeOf7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf9(o5, p5) {
    o5.__proto__ = p5;
    return o5;
  };
  return _setPrototypeOf7(o4, p4);
}
function _createSuper7(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct7();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf7(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf7(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn7(this, result);
  };
}
function _possibleConstructorReturn7(self, call) {
  if (call && (_typeof65(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized7(self);
}
function _assertThisInitialized7(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct7() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e4) {
    return false;
  }
}
function _getPrototypeOf7(o4) {
  _getPrototypeOf7 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf9(o5) {
    return o5.__proto__ || Object.getPrototypeOf(o5);
  };
  return _getPrototypeOf7(o4);
}
function _defineProperty65(obj, key2, value) {
  key2 = _toPropertyKey64(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey64(t4) {
  var i4 = _toPrimitive64(t4, "string");
  return "symbol" == _typeof65(i4) ? i4 : String(i4);
}
function _toPrimitive64(t4, r3) {
  if ("object" != _typeof65(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof65(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var Slider = /* @__PURE__ */ function(_Component) {
  _inherits7(Slider2, _Component);
  var _super = _createSuper7(Slider2);
  function Slider2() {
    var _this;
    _classCallCheck8(this, Slider2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty65(_assertThisInitialized7(_this), "handleChange", function(_ref9) {
      var values = _ref9.values;
      if (!_this.isDisabled) {
        _this.props.refine(values);
      }
    });
    _defineProperty65(_assertThisInitialized7(_this), "createHandleComponent", function(tooltips) {
      return function(props) {
        var roundedValue = Math.round(
          // have to cast as a string, as the value given to the prop is a number, but becomes a string when read
          parseFloat(props["aria-valuenow"]) * 100
        ) / 100;
        var value = _typeof65(tooltips) === "object" && tooltips.format ? tooltips.format(roundedValue) : roundedValue;
        var className = cx(props.className, props["data-handle-key"] === 0 && "rheostat-handle-lower", props["data-handle-key"] === 1 && "rheostat-handle-upper");
        var ariaLabel = props["data-handle-key"] === 0 ? "Minimum Filter Handle" : "Maximum Filter Handle";
        return y2("div", _extends23({}, props, {
          className,
          "aria-label": ariaLabel
        }), tooltips && y2("div", {
          className: "rheostat-tooltip"
        }, value));
      };
    });
    return _this;
  }
  _createClass8(Slider2, [{
    key: "isDisabled",
    get: function get() {
      return this.props.min >= this.props.max;
    }
  }, {
    key: "computeDefaultPitPoints",
    value: (
      // creates an array number where to display a pit point on the slider
      function computeDefaultPitPoints(_ref23) {
        var min = _ref23.min, max = _ref23.max;
        var totalLength = max - min;
        var steps = 34;
        var stepsLength = totalLength / steps;
        var pitPoints = [min].concat(_toConsumableArray11(range({
          end: steps - 1
        }).map(function(step) {
          return min + stepsLength * (step + 1);
        })), [max]);
        return pitPoints;
      }
    )
    // creates an array of values where the slider should snap to
  }, {
    key: "computeSnapPoints",
    value: function computeSnapPoints(_ref33) {
      var min = _ref33.min, max = _ref33.max, step = _ref33.step;
      if (!step)
        return void 0;
      return [].concat(_toConsumableArray11(range({
        start: min,
        end: max,
        step
      })), [max]);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props, tooltips = _this$props.tooltips, step = _this$props.step, pips = _this$props.pips, values = _this$props.values, cssClasses = _this$props.cssClasses;
      var _ref44 = this.isDisabled ? {
        min: this.props.min,
        max: this.props.max + 1e-3
      } : this.props, min = _ref44.min, max = _ref44.max;
      var snapPoints = this.computeSnapPoints({
        min,
        max,
        step
      });
      var pitPoints = pips === false ? [] : this.computeDefaultPitPoints({
        min,
        max
      });
      return y2("div", {
        className: cx(cssClasses.root, this.isDisabled && cssClasses.disabledRoot)
      }, y2(Rheostat_default, {
        handle: this.createHandleComponent(tooltips),
        onChange: this.handleChange,
        min,
        max,
        pitComponent: Pit_default,
        pitPoints,
        snap: true,
        snapPoints,
        values: this.isDisabled ? [min, max] : values,
        disabled: this.isDisabled
      }));
    }
  }]);
  return Slider2;
}(b2);
var Slider_default = Slider;

// node_modules/instantsearch.js/es/widgets/range-slider/range-slider.js
function _typeof66(o4) {
  "@babel/helpers - typeof";
  return _typeof66 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof66(o4);
}
function ownKeys71(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread71(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys71(Object(t4), true).forEach(function(r4) {
      _defineProperty66(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys71(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty66(obj, key2, value) {
  key2 = _toPropertyKey65(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey65(t4) {
  var i4 = _toPrimitive65(t4, "string");
  return "symbol" == _typeof66(i4) ? i4 : String(i4);
}
function _toPrimitive65(t4, r3) {
  if ("object" != _typeof66(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof66(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _slicedToArray13(arr, i4) {
  return _arrayWithHoles13(arr) || _iterableToArrayLimit13(arr, i4) || _unsupportedIterableToArray23(arr, i4) || _nonIterableRest13();
}
function _nonIterableRest13() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray23(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray23(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray23(o4, minLen);
}
function _arrayLikeToArray23(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
function _iterableToArrayLimit13(r3, l4) {
  var t4 = null == r3 ? null : "undefined" != typeof Symbol && r3[Symbol.iterator] || r3["@@iterator"];
  if (null != t4) {
    var e4, n4, i4, u4, a4 = [], f4 = true, o4 = false;
    try {
      if (i4 = (t4 = t4.call(r3)).next, 0 === l4) {
        if (Object(t4) !== t4)
          return;
        f4 = false;
      } else
        for (; !(f4 = (e4 = i4.call(t4)).done) && (a4.push(e4.value), a4.length !== l4); f4 = true)
          ;
    } catch (r4) {
      o4 = true, n4 = r4;
    } finally {
      try {
        if (!f4 && null != t4.return && (u4 = t4.return(), Object(u4) !== u4))
          return;
      } finally {
        if (o4)
          throw n4;
      }
    }
    return a4;
  }
}
function _arrayWithHoles13(arr) {
  if (Array.isArray(arr))
    return arr;
}
var withUsage41 = createDocumentationMessageGenerator({
  name: "range-slider"
});
var suit18 = component("RangeSlider");
var renderer35 = function renderer36(_ref9) {
  var containerNode = _ref9.containerNode, cssClasses = _ref9.cssClasses, pips = _ref9.pips, step = _ref9.step, tooltips = _ref9.tooltips;
  return function(_ref23, isFirstRendering) {
    var refine2 = _ref23.refine, range2 = _ref23.range, start = _ref23.start;
    if (isFirstRendering) {
      return;
    }
    var minRange = range2.min, maxRange = range2.max;
    var _start = _slicedToArray13(start, 2), minStart = _start[0], maxStart = _start[1];
    var minFinite = minStart === -Infinity ? minRange : minStart;
    var maxFinite = maxStart === Infinity ? maxRange : maxStart;
    var values = [minFinite > maxRange ? maxRange : minFinite, maxFinite < minRange ? minRange : maxFinite];
    N2(y2(Slider_default, {
      cssClasses,
      refine: refine2,
      min: minRange,
      max: maxRange,
      values,
      tooltips,
      step,
      pips
    }), containerNode);
  };
};
var rangeSlider = function rangeSlider2(widgetParams) {
  var _ref33 = widgetParams || {}, container = _ref33.container, attribute = _ref33.attribute, min = _ref33.min, max = _ref33.max, _ref3$cssClasses = _ref33.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses, step = _ref33.step, _ref3$pips = _ref33.pips, pips = _ref3$pips === void 0 ? true : _ref3$pips, _ref3$precision = _ref33.precision, precision = _ref3$precision === void 0 ? 0 : _ref3$precision, _ref3$tooltips = _ref33.tooltips, tooltips = _ref3$tooltips === void 0 ? true : _ref3$tooltips;
  if (!container) {
    throw new Error(withUsage41("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var cssClasses = {
    root: cx(suit18(), userCssClasses.root),
    disabledRoot: cx(suit18({
      modifierName: "disabled"
    }), userCssClasses.disabledRoot)
  };
  var specializedRenderer = renderer35({
    containerNode,
    step,
    pips,
    tooltips,
    cssClasses
  });
  var makeWidget = connectRange_default(specializedRenderer, function() {
    return N2(null, containerNode);
  });
  return _objectSpread71(_objectSpread71({}, makeWidget({
    attribute,
    min,
    max,
    precision
  })), {}, {
    $$type: "ais.rangeSlider",
    $$widgetType: "ais.rangeSlider"
  });
};
var range_slider_default = rangeSlider;

// node_modules/instantsearch.js/es/connectors/rating-menu/connectRatingMenu.js
function _typeof67(o4) {
  "@babel/helpers - typeof";
  return _typeof67 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof67(o4);
}
function _toConsumableArray12(arr) {
  return _arrayWithoutHoles12(arr) || _iterableToArray12(arr) || _unsupportedIterableToArray24(arr) || _nonIterableSpread12();
}
function _nonIterableSpread12() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray12(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles12(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray24(arr);
}
function ownKeys72(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread72(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys72(Object(t4), true).forEach(function(r4) {
      _defineProperty67(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys72(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty67(obj, key2, value) {
  key2 = _toPropertyKey66(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey66(t4) {
  var i4 = _toPrimitive66(t4, "string");
  return "symbol" == _typeof67(i4) ? i4 : String(i4);
}
function _toPrimitive66(t4, r3) {
  if ("object" != _typeof67(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof67(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _slicedToArray14(arr, i4) {
  return _arrayWithHoles14(arr) || _iterableToArrayLimit14(arr, i4) || _unsupportedIterableToArray24(arr, i4) || _nonIterableRest14();
}
function _nonIterableRest14() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray24(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray24(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray24(o4, minLen);
}
function _arrayLikeToArray24(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
function _iterableToArrayLimit14(r3, l4) {
  var t4 = null == r3 ? null : "undefined" != typeof Symbol && r3[Symbol.iterator] || r3["@@iterator"];
  if (null != t4) {
    var e4, n4, i4, u4, a4 = [], f4 = true, o4 = false;
    try {
      if (i4 = (t4 = t4.call(r3)).next, 0 === l4) {
        if (Object(t4) !== t4)
          return;
        f4 = false;
      } else
        for (; !(f4 = (e4 = i4.call(t4)).done) && (a4.push(e4.value), a4.length !== l4); f4 = true)
          ;
    } catch (r4) {
      o4 = true, n4 = r4;
    } finally {
      try {
        if (!f4 && null != t4.return && (u4 = t4.return(), Object(u4) !== u4))
          return;
      } finally {
        if (o4)
          throw n4;
      }
    }
    return a4;
  }
}
function _arrayWithHoles14(arr) {
  if (Array.isArray(arr))
    return arr;
}
var withUsage42 = createDocumentationMessageGenerator({
  name: "rating-menu",
  connector: true
});
var $$type4 = "ais.ratingMenu";
var MAX_VALUES_PER_FACET_API_LIMIT = 1e3;
var STEP = 1;
var createSendEvent3 = function createSendEvent4(_ref9) {
  var instantSearchInstance = _ref9.instantSearchInstance, helper = _ref9.helper, getRefinedStar = _ref9.getRefinedStar, attribute = _ref9.attribute;
  return function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (args.length === 1) {
      instantSearchInstance.sendEventToInsights(args[0]);
      return;
    }
    var facetValue = args[1], _args$ = args[2], eventName = _args$ === void 0 ? "Filter Applied" : _args$;
    var _args$0$split = args[0].split(":"), _args$0$split2 = _slicedToArray14(_args$0$split, 2), eventType = _args$0$split2[0], eventModifier = _args$0$split2[1];
    if (eventType !== "click") {
      return;
    }
    var isRefined2 = getRefinedStar() === Number(facetValue);
    if (!isRefined2) {
      var _helper$lastResults;
      instantSearchInstance.sendEventToInsights({
        insightsMethod: "clickedFilters",
        widgetType: $$type4,
        eventType,
        eventModifier,
        payload: {
          eventName,
          index: ((_helper$lastResults = helper.lastResults) === null || _helper$lastResults === void 0 ? void 0 : _helper$lastResults.index) || helper.state.index,
          filters: ["".concat(attribute, ">=").concat(facetValue)]
        },
        attribute
      });
    }
  };
};
var connectRatingMenu = function connectRatingMenu2(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage42());
  return function(widgetParams) {
    var _ref23 = widgetParams || {}, attribute = _ref23.attribute, _ref2$max = _ref23.max, max = _ref2$max === void 0 ? 5 : _ref2$max;
    var sendEvent;
    if (!attribute) {
      throw new Error(withUsage42("The `attribute` option is required."));
    }
    var _getRefinedStar = function getRefinedStar(state) {
      var _values$;
      var values = state.getNumericRefinements(attribute);
      if (!((_values$ = values[">="]) !== null && _values$ !== void 0 && _values$.length)) {
        return void 0;
      }
      return values[">="][0];
    };
    var getFacetsMaxDecimalPlaces = function getFacetsMaxDecimalPlaces2(facetResults) {
      var maxDecimalPlaces = 0;
      facetResults.forEach(function(facetResult) {
        var _facetResult$name$spl = facetResult.name.split("."), _facetResult$name$spl2 = _slicedToArray14(_facetResult$name$spl, 2), _facetResult$name$spl3 = _facetResult$name$spl2[1], decimal = _facetResult$name$spl3 === void 0 ? "" : _facetResult$name$spl3;
        maxDecimalPlaces = Math.max(maxDecimalPlaces, decimal.length);
      });
      return maxDecimalPlaces;
    };
    var getFacetValuesWarningMessage = function getFacetValuesWarningMessage2(_ref33) {
      var maxDecimalPlaces = _ref33.maxDecimalPlaces, maxFacets = _ref33.maxFacets, maxValuesPerFacet = _ref33.maxValuesPerFacet;
      var maxDecimalPlacesInRange = Math.max(0, Math.floor(Math.log10(MAX_VALUES_PER_FACET_API_LIMIT / max)));
      var maxFacetsInRange = Math.min(MAX_VALUES_PER_FACET_API_LIMIT, Math.pow(10, maxDecimalPlacesInRange) * max);
      var solutions = [];
      if (maxFacets > MAX_VALUES_PER_FACET_API_LIMIT) {
        solutions.push('- Update your records to lower the precision of the values in the "'.concat(attribute, '" attribute (for example: ').concat(5.123456789.toPrecision(maxDecimalPlaces + 1), " to ").concat(5.123456789.toPrecision(maxDecimalPlacesInRange + 1), ")"));
      }
      if (maxValuesPerFacet < maxFacetsInRange) {
        solutions.push("- Increase the maximum number of facet values to ".concat(maxFacetsInRange, ' using the "configure" widget ').concat(createDocumentationLink({
          name: "configure"
        }), ' and the "maxValuesPerFacet" parameter https://www.algolia.com/doc/api-reference/api-parameters/maxValuesPerFacet/'));
      }
      return "The ".concat(attribute, " attribute can have ").concat(maxFacets, " different values (0 to ").concat(max, " with a maximum of ").concat(maxDecimalPlaces, " decimals = ").concat(maxFacets, ") but you retrieved only ").concat(maxValuesPerFacet, " facet values. Therefore the number of results that match the refinements can be incorrect.\n    ").concat(solutions.length ? "To resolve this problem you can:\n".concat(solutions.join("\n")) : "");
    };
    function getRefinedState2(state, facetValue) {
      var isRefined2 = _getRefinedStar(state) === Number(facetValue);
      var emptyState = state.resetPage().removeNumericRefinement(attribute);
      if (!isRefined2) {
        return emptyState.addNumericRefinement(attribute, "<=", max).addNumericRefinement(attribute, ">=", Number(facetValue));
      }
      return emptyState;
    }
    var toggleRefinement3 = function toggleRefinement4(helper, facetValue) {
      sendEvent("click:internal", facetValue);
      helper.setState(getRefinedState2(helper.state, facetValue)).search();
    };
    var connectorState = {
      toggleRefinementFactory: function toggleRefinementFactory(helper) {
        return toggleRefinement3.bind(null, helper);
      },
      createURLFactory: function createURLFactory(_ref44) {
        var state = _ref44.state, createURL = _ref44.createURL, getWidgetUiState = _ref44.getWidgetUiState, helper = _ref44.helper;
        return function(value) {
          return createURL(function(uiState) {
            return getWidgetUiState(uiState, {
              searchParameters: getRefinedState2(state, value),
              helper
            });
          });
        };
      }
    };
    return {
      $$type: $$type4,
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(_objectSpread72(_objectSpread72({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(_objectSpread72(_objectSpread72({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance
        }), false);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return _objectSpread72(_objectSpread72({}, renderState), {}, {
          ratingMenu: _objectSpread72(_objectSpread72({}, renderState.ratingMenu), {}, _defineProperty67({}, attribute, this.getWidgetRenderState(renderOptions)))
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref52) {
        var helper = _ref52.helper, results = _ref52.results, state = _ref52.state, instantSearchInstance = _ref52.instantSearchInstance, createURL = _ref52.createURL;
        var facetValues = [];
        if (!sendEvent) {
          sendEvent = createSendEvent3({
            instantSearchInstance,
            helper,
            getRefinedStar: function getRefinedStar() {
              return _getRefinedStar(helper.state);
            },
            attribute
          });
        }
        var refinementIsApplied = false;
        var totalCount = 0;
        var facetResults = results === null || results === void 0 ? void 0 : results.getFacetValues(attribute, {});
        if (results && facetResults) {
          var maxValuesPerFacet = facetResults.length;
          var maxDecimalPlaces = getFacetsMaxDecimalPlaces(facetResults);
          var maxFacets = Math.pow(10, maxDecimalPlaces) * max;
          false ? _warning(maxFacets <= maxValuesPerFacet || Boolean(results.__isArtificial), getFacetValuesWarningMessage({
            maxDecimalPlaces,
            maxFacets,
            maxValuesPerFacet
          })) : void 0;
          var refinedStar = _getRefinedStar(state);
          var _loop = function _loop2(star2) {
            var isRefined2 = refinedStar === star2;
            refinementIsApplied = refinementIsApplied || isRefined2;
            var count = facetResults.filter(function(f4) {
              return Number(f4.name) >= star2 && Number(f4.name) <= max;
            }).map(function(f4) {
              return f4.count;
            }).reduce(function(sum, current) {
              return sum + current;
            }, 0);
            totalCount += count;
            if (refinedStar && !isRefined2 && count === 0) {
              return "continue";
            }
            var stars = _toConsumableArray12(new Array(Math.floor(max / STEP))).map(function(_v, i4) {
              return i4 * STEP < star2;
            });
            facetValues.push({
              stars,
              name: String(star2),
              label: String(star2),
              value: String(star2),
              count,
              isRefined: isRefined2
            });
          };
          for (var star = STEP; star < max; star += STEP) {
            var _ret = _loop(star);
            if (_ret === "continue")
              continue;
          }
        }
        facetValues = facetValues.reverse();
        var hasNoResults = results ? results.nbHits === 0 : true;
        return {
          items: facetValues,
          hasNoResults,
          canRefine: (!hasNoResults || refinementIsApplied) && totalCount > 0,
          refine: connectorState.toggleRefinementFactory(helper),
          sendEvent,
          createURL: connectorState.createURLFactory({
            state,
            createURL,
            helper,
            getWidgetUiState: this.getWidgetUiState
          }),
          widgetParams
        };
      },
      dispose: function dispose(_ref64) {
        var state = _ref64.state;
        unmountFn();
        return state.removeNumericRefinement(attribute);
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref72) {
        var searchParameters = _ref72.searchParameters;
        var value = _getRefinedStar(searchParameters);
        return removeEmptyRefinementsFromUiState5(_objectSpread72(_objectSpread72({}, uiState), {}, {
          ratingMenu: _objectSpread72(_objectSpread72({}, uiState.ratingMenu), {}, _defineProperty67({}, attribute, typeof value === "number" ? value : void 0))
        }), attribute);
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref82) {
        var uiState = _ref82.uiState;
        var value = uiState.ratingMenu && uiState.ratingMenu[attribute];
        var withDisjunctiveFacet = searchParameters.addDisjunctiveFacet(attribute).removeNumericRefinement(attribute).removeDisjunctiveFacetRefinement(attribute);
        if (!value) {
          return withDisjunctiveFacet.setQueryParameters({
            numericRefinements: _objectSpread72(_objectSpread72({}, withDisjunctiveFacet.numericRefinements), {}, _defineProperty67({}, attribute, {}))
          });
        }
        return withDisjunctiveFacet.addNumericRefinement(attribute, "<=", max).addNumericRefinement(attribute, ">=", value);
      }
    };
  };
};
function removeEmptyRefinementsFromUiState5(indexUiState, attribute) {
  if (!indexUiState.ratingMenu) {
    return indexUiState;
  }
  if (typeof indexUiState.ratingMenu[attribute] !== "number") {
    delete indexUiState.ratingMenu[attribute];
  }
  if (Object.keys(indexUiState.ratingMenu).length === 0) {
    delete indexUiState.ratingMenu;
  }
  return indexUiState;
}
var connectRatingMenu_default = connectRatingMenu;

// node_modules/instantsearch.js/es/widgets/rating-menu/defaultTemplates.js
function ItemWrapper(_ref9) {
  var children = _ref9.children, count = _ref9.count, value = _ref9.value, url2 = _ref9.url, cssClasses = _ref9.cssClasses;
  if (count) {
    return y2("a", {
      className: cx(cssClasses.link),
      "aria-label": "".concat(value, " & up"),
      href: url2
    }, children);
  }
  return y2("div", {
    className: cx(cssClasses.link),
    "aria-label": "".concat(value, " & up"),
    disabled: true
  }, children);
}
var defaultTemplates14 = {
  item: function item8(_ref23) {
    var count = _ref23.count, value = _ref23.value, url2 = _ref23.url, stars = _ref23.stars, cssClasses = _ref23.cssClasses;
    return y2(ItemWrapper, {
      count,
      value,
      url: url2,
      cssClasses
    }, stars.map(function(isFull, index) {
      return y2("svg", {
        key: index,
        className: cx(cssClasses.starIcon, isFull ? cssClasses.fullStarIcon : cssClasses.emptyStarIcon),
        "aria-hidden": "true",
        width: "24",
        height: "24"
      }, y2("use", {
        xlinkHref: isFull ? "#ais-RatingMenu-starSymbol" : "#ais-RatingMenu-starEmptySymbol"
      }));
    }), y2("span", {
      "aria-hidden": "true",
      className: cx(cssClasses.label)
    }, "& Up"), count && y2("span", {
      className: cx(cssClasses.count)
    }, formatNumber(count)));
  }
};
var defaultTemplates_default11 = defaultTemplates14;

// node_modules/instantsearch.js/es/widgets/rating-menu/rating-menu.js
function _typeof68(o4) {
  "@babel/helpers - typeof";
  return _typeof68 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof68(o4);
}
function ownKeys73(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread73(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys73(Object(t4), true).forEach(function(r4) {
      _defineProperty68(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys73(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty68(obj, key2, value) {
  key2 = _toPropertyKey67(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey67(t4) {
  var i4 = _toPrimitive67(t4, "string");
  return "symbol" == _typeof68(i4) ? i4 : String(i4);
}
function _toPrimitive67(t4, r3) {
  if ("object" != _typeof68(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof68(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage43 = createDocumentationMessageGenerator({
  name: "rating-menu"
});
var suit19 = component("RatingMenu");
var _ref3 = y2("path", {
  d: "M12 .288l2.833 8.718h9.167l-7.417 5.389 2.833 8.718-7.416-5.388-7.417 5.388 2.833-8.718-7.416-5.389h9.167z"
});
var _ref4 = y2("path", {
  d: "M12 6.76l1.379 4.246h4.465l-3.612 2.625 1.379 4.246-3.611-2.625-3.612 2.625 1.379-4.246-3.612-2.625h4.465l1.38-4.246zm0-6.472l-2.833 8.718h-9.167l7.416 5.389-2.833 8.718 7.417-5.388 7.416 5.388-2.833-8.718 7.417-5.389h-9.167l-2.833-8.718z"
});
var renderer37 = function renderer38(_ref9) {
  var containerNode = _ref9.containerNode, cssClasses = _ref9.cssClasses, templates = _ref9.templates, renderState = _ref9.renderState;
  return function(_ref23, isFirstRendering) {
    var refine2 = _ref23.refine, items = _ref23.items, createURL = _ref23.createURL, instantSearchInstance = _ref23.instantSearchInstance;
    if (isFirstRendering) {
      renderState.templateProps = prepareTemplateProps({
        defaultTemplates: defaultTemplates_default11,
        templatesConfig: instantSearchInstance.templatesConfig,
        templates
      });
      return;
    }
    N2(y2(RefinementList_default, {
      createURL,
      cssClasses,
      facetValues: items,
      templateProps: renderState.templateProps,
      toggleRefinement: refine2
    }, y2("svg", {
      style: "display:none;"
    }, y2("symbol", {
      id: suit19({
        descendantName: "starSymbol"
      }),
      viewBox: "0 0 24 24"
    }, _ref3), y2("symbol", {
      id: suit19({
        descendantName: "starEmptySymbol"
      }),
      viewBox: "0 0 24 24"
    }, _ref4))), containerNode);
  };
};
var ratingMenu = function ratingMenu2(widgetParams) {
  var _ref52 = widgetParams || {}, container = _ref52.container, attribute = _ref52.attribute, _ref5$max = _ref52.max, max = _ref5$max === void 0 ? 5 : _ref5$max, _ref5$cssClasses = _ref52.cssClasses, userCssClasses = _ref5$cssClasses === void 0 ? {} : _ref5$cssClasses, _ref5$templates = _ref52.templates, templates = _ref5$templates === void 0 ? {} : _ref5$templates;
  if (!container) {
    throw new Error(withUsage43("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var cssClasses = {
    root: cx(suit19(), userCssClasses.root),
    noRefinementRoot: cx(suit19({
      modifierName: "noRefinement"
    }), userCssClasses.noRefinementRoot),
    list: cx(suit19({
      descendantName: "list"
    }), userCssClasses.list),
    item: cx(suit19({
      descendantName: "item"
    }), userCssClasses.item),
    selectedItem: cx(suit19({
      descendantName: "item",
      modifierName: "selected"
    }), userCssClasses.selectedItem),
    disabledItem: cx(suit19({
      descendantName: "item",
      modifierName: "disabled"
    }), userCssClasses.disabledItem),
    link: cx(suit19({
      descendantName: "link"
    }), userCssClasses.link),
    starIcon: cx(suit19({
      descendantName: "starIcon"
    }), userCssClasses.starIcon),
    fullStarIcon: cx(suit19({
      descendantName: "starIcon",
      modifierName: "full"
    }), userCssClasses.fullStarIcon),
    emptyStarIcon: cx(suit19({
      descendantName: "starIcon",
      modifierName: "empty"
    }), userCssClasses.emptyStarIcon),
    label: cx(suit19({
      descendantName: "label"
    }), userCssClasses.label),
    count: cx(suit19({
      descendantName: "count"
    }), userCssClasses.count)
  };
  var specializedRenderer = renderer37({
    containerNode,
    cssClasses,
    renderState: {},
    templates
  });
  var makeWidget = connectRatingMenu_default(specializedRenderer, function() {
    return N2(null, containerNode);
  });
  return _objectSpread73(_objectSpread73({}, makeWidget({
    attribute,
    max
  })), {}, {
    $$widgetType: "ais.ratingMenu"
  });
};
var rating_menu_default = ratingMenu;

// node_modules/instantsearch.js/es/connectors/refinement-list/connectRefinementList.js
function _typeof69(o4) {
  "@babel/helpers - typeof";
  return _typeof69 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof69(o4);
}
var _excluded38 = ["name", "escapedValue"];
var _excluded212 = ["escapedValue", "value"];
function ownKeys74(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread74(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys74(Object(t4), true).forEach(function(r4) {
      _defineProperty69(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys74(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty69(obj, key2, value) {
  key2 = _toPropertyKey68(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey68(t4) {
  var i4 = _toPrimitive68(t4, "string");
  return "symbol" == _typeof69(i4) ? i4 : String(i4);
}
function _toPrimitive68(t4, r3) {
  if ("object" != _typeof69(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof69(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _objectWithoutProperties19(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose19(source, excluded);
  var key2, i4;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i4 = 0; i4 < sourceSymbolKeys.length; i4++) {
      key2 = sourceSymbolKeys[i4];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose19(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i4;
  for (i4 = 0; i4 < sourceKeys.length; i4++) {
    key2 = sourceKeys[i4];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
var withUsage44 = createDocumentationMessageGenerator({
  name: "refinement-list",
  connector: true
});
var DEFAULT_SORT3 = ["isRefined", "count:desc", "name:asc"];
var connectRefinementList = function connectRefinementList2(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage44());
  return function(widgetParams) {
    var _ref9 = widgetParams || {}, attribute = _ref9.attribute, _ref$operator = _ref9.operator, operator = _ref$operator === void 0 ? "or" : _ref$operator, _ref$limit = _ref9.limit, limit = _ref$limit === void 0 ? 10 : _ref$limit, _ref$showMore = _ref9.showMore, showMore = _ref$showMore === void 0 ? false : _ref$showMore, _ref$showMoreLimit = _ref9.showMoreLimit, showMoreLimit = _ref$showMoreLimit === void 0 ? 20 : _ref$showMoreLimit, _ref$sortBy = _ref9.sortBy, sortBy3 = _ref$sortBy === void 0 ? DEFAULT_SORT3 : _ref$sortBy, _ref$escapeFacetValue = _ref9.escapeFacetValues, escapeFacetValues = _ref$escapeFacetValue === void 0 ? true : _ref$escapeFacetValue, _ref$transformItems = _ref9.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
      return items;
    } : _ref$transformItems;
    if (!attribute) {
      throw new Error(withUsage44("The `attribute` option is required."));
    }
    if (!/^(and|or)$/.test(operator)) {
      throw new Error(withUsage44('The `operator` must one of: `"and"`, `"or"` (got "'.concat(operator, '").')));
    }
    if (showMore === true && showMoreLimit <= limit) {
      throw new Error(withUsage44("`showMoreLimit` should be greater than `limit`."));
    }
    var formatItems = function formatItems2(_ref23) {
      var label = _ref23.name, value = _ref23.escapedValue, item11 = _objectWithoutProperties19(_ref23, _excluded38);
      return _objectSpread74(_objectSpread74({}, item11), {}, {
        value,
        label,
        highlighted: label
      });
    };
    var lastResultsFromMainSearch;
    var lastItemsFromMainSearch = [];
    var hasExhaustiveItems = true;
    var triggerRefine;
    var sendEvent;
    var isShowingMore = false;
    var toggleShowMore = function toggleShowMore2() {
    };
    function cachedToggleShowMore() {
      toggleShowMore();
    }
    function createToggleShowMore(renderOptions, widget) {
      return function() {
        isShowingMore = !isShowingMore;
        widget.render(renderOptions);
      };
    }
    function getLimit() {
      return isShowingMore ? showMoreLimit : limit;
    }
    var searchForFacetValues = function searchForFacetValues2() {
      return function() {
      };
    };
    var createSearchForFacetValues = function createSearchForFacetValues2(helper, widget) {
      return function(renderOptions) {
        return function(query) {
          var instantSearchInstance = renderOptions.instantSearchInstance, searchResults = renderOptions.results;
          if (query === "" && lastItemsFromMainSearch) {
            renderFn(_objectSpread74(_objectSpread74({}, widget.getWidgetRenderState(_objectSpread74(_objectSpread74({}, renderOptions), {}, {
              results: lastResultsFromMainSearch
            }))), {}, {
              instantSearchInstance
            }), false);
          } else {
            var tags = {
              highlightPreTag: escapeFacetValues ? TAG_PLACEHOLDER.highlightPreTag : TAG_REPLACEMENT.highlightPreTag,
              highlightPostTag: escapeFacetValues ? TAG_PLACEHOLDER.highlightPostTag : TAG_REPLACEMENT.highlightPostTag
            };
            helper.searchForFacetValues(
              attribute,
              query,
              // We cap the `maxFacetHits` value to 100 because the Algolia API
              // doesn't support a greater number.
              // See https://www.algolia.com/doc/api-reference/api-parameters/maxFacetHits/
              Math.min(getLimit(), 100),
              tags
            ).then(function(results) {
              var facetValues = escapeFacetValues ? escapeFacets(results.facetHits) : results.facetHits;
              var normalizedFacetValues = transformItems(facetValues.map(function(_ref33) {
                var escapedValue = _ref33.escapedValue, value = _ref33.value, item11 = _objectWithoutProperties19(_ref33, _excluded212);
                return _objectSpread74(_objectSpread74({}, item11), {}, {
                  value: escapedValue,
                  label: value
                });
              }), {
                results: searchResults
              });
              renderFn(_objectSpread74(_objectSpread74({}, widget.getWidgetRenderState(_objectSpread74(_objectSpread74({}, renderOptions), {}, {
                results: lastResultsFromMainSearch
              }))), {}, {
                items: normalizedFacetValues,
                canToggleShowMore: false,
                canRefine: true,
                isFromSearch: true,
                instantSearchInstance
              }), false);
            });
          }
        };
      };
    };
    return {
      $$type: "ais.refinementList",
      init: function init(initOptions) {
        renderFn(_objectSpread74(_objectSpread74({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: initOptions.instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        renderFn(_objectSpread74(_objectSpread74({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: renderOptions.instantSearchInstance
        }), false);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return _objectSpread74(_objectSpread74({}, renderState), {}, {
          refinementList: _objectSpread74(_objectSpread74({}, renderState.refinementList), {}, _defineProperty69({}, attribute, this.getWidgetRenderState(renderOptions)))
        });
      },
      getWidgetRenderState: function getWidgetRenderState(renderOptions) {
        var _this = this;
        var results = renderOptions.results, state = renderOptions.state, _createURL = renderOptions.createURL, instantSearchInstance = renderOptions.instantSearchInstance, helper = renderOptions.helper;
        var items = [];
        var facetValues = [];
        if (!sendEvent || !triggerRefine || !searchForFacetValues) {
          sendEvent = createSendEventForFacet({
            instantSearchInstance,
            helper,
            attribute,
            widgetType: this.$$type
          });
          triggerRefine = function triggerRefine2(facetValue) {
            sendEvent("click:internal", facetValue);
            helper.toggleFacetRefinement(attribute, facetValue).search();
          };
          searchForFacetValues = createSearchForFacetValues(helper, this);
        }
        if (results) {
          var values = results.getFacetValues(attribute, {
            sortBy: sortBy3,
            facetOrdering: sortBy3 === DEFAULT_SORT3
          });
          facetValues = values && Array.isArray(values) ? values : [];
          items = transformItems(facetValues.slice(0, getLimit()).map(formatItems), {
            results
          });
          var maxValuesPerFacetConfig = state.maxValuesPerFacet;
          var currentLimit = getLimit();
          hasExhaustiveItems = maxValuesPerFacetConfig > currentLimit ? facetValues.length <= currentLimit : facetValues.length < currentLimit;
          lastResultsFromMainSearch = results;
          lastItemsFromMainSearch = items;
          if (renderOptions.results) {
            toggleShowMore = createToggleShowMore(renderOptions, this);
          }
        }
        var searchFacetValues = searchForFacetValues && searchForFacetValues(renderOptions);
        var canShowLess = isShowingMore && lastItemsFromMainSearch.length > limit;
        var canShowMore = showMore && !hasExhaustiveItems;
        var canToggleShowMore = canShowLess || canShowMore;
        return {
          createURL: function createURL(facetValue) {
            return _createURL(function(uiState) {
              return _this.getWidgetUiState(uiState, {
                searchParameters: state.resetPage().toggleFacetRefinement(attribute, facetValue),
                helper
              });
            });
          },
          items,
          refine: triggerRefine,
          searchForItems: searchFacetValues,
          isFromSearch: false,
          canRefine: items.length > 0,
          widgetParams,
          isShowingMore,
          canToggleShowMore,
          toggleShowMore: cachedToggleShowMore,
          sendEvent,
          hasExhaustiveItems
        };
      },
      dispose: function dispose(_ref44) {
        var state = _ref44.state;
        unmountFn();
        var withoutMaxValuesPerFacet = state.setQueryParameter("maxValuesPerFacet", void 0);
        if (operator === "and") {
          return withoutMaxValuesPerFacet.removeFacet(attribute);
        }
        return withoutMaxValuesPerFacet.removeDisjunctiveFacet(attribute);
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref52) {
        var searchParameters = _ref52.searchParameters;
        var values = operator === "or" ? searchParameters.getDisjunctiveRefinements(attribute) : searchParameters.getConjunctiveRefinements(attribute);
        return removeEmptyRefinementsFromUiState6(_objectSpread74(_objectSpread74({}, uiState), {}, {
          refinementList: _objectSpread74(_objectSpread74({}, uiState.refinementList), {}, _defineProperty69({}, attribute, values))
        }), attribute);
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref64) {
        var uiState = _ref64.uiState;
        var isDisjunctive = operator === "or";
        if (searchParameters.isHierarchicalFacet(attribute)) {
          false ? _warning(false, 'RefinementList: Attribute "'.concat(attribute, '" is already used by another widget applying hierarchical faceting.\nAs this is not supported, please make sure to remove this other widget or this RefinementList widget will not work at all.')) : void 0;
          return searchParameters;
        }
        if (isDisjunctive && searchParameters.isConjunctiveFacet(attribute) || !isDisjunctive && searchParameters.isDisjunctiveFacet(attribute)) {
          false ? _warning(false, 'RefinementList: Attribute "'.concat(attribute, '" is used by another refinement list with a different operator.\nAs this is not supported, please make sure to only use this attribute with one of the two operators.')) : void 0;
          return searchParameters;
        }
        var values = uiState.refinementList && uiState.refinementList[attribute];
        var withFacetConfiguration = isDisjunctive ? searchParameters.addDisjunctiveFacet(attribute).removeDisjunctiveFacetRefinement(attribute) : searchParameters.addFacet(attribute).removeFacetRefinement(attribute);
        var currentMaxValuesPerFacet = withFacetConfiguration.maxValuesPerFacet || 0;
        var nextMaxValuesPerFacet = Math.max(currentMaxValuesPerFacet, showMore ? showMoreLimit : limit);
        var withMaxValuesPerFacet = withFacetConfiguration.setQueryParameter("maxValuesPerFacet", nextMaxValuesPerFacet);
        if (!values) {
          var key2 = isDisjunctive ? "disjunctiveFacetsRefinements" : "facetsRefinements";
          return withMaxValuesPerFacet.setQueryParameters(_defineProperty69({}, key2, _objectSpread74(_objectSpread74({}, withMaxValuesPerFacet[key2]), {}, _defineProperty69({}, attribute, []))));
        }
        return values.reduce(function(parameters, value) {
          return isDisjunctive ? parameters.addDisjunctiveFacetRefinement(attribute, value) : parameters.addFacetRefinement(attribute, value);
        }, withMaxValuesPerFacet);
      }
    };
  };
};
function removeEmptyRefinementsFromUiState6(indexUiState, attribute) {
  if (!indexUiState.refinementList) {
    return indexUiState;
  }
  if (!indexUiState.refinementList[attribute] || indexUiState.refinementList[attribute].length === 0) {
    delete indexUiState.refinementList[attribute];
  }
  if (Object.keys(indexUiState.refinementList).length === 0) {
    delete indexUiState.refinementList;
  }
  return indexUiState;
}
var connectRefinementList_default = connectRefinementList;

// node_modules/instantsearch.js/es/widgets/search-box/defaultTemplates.js
var _ref2 = y2("path", {
  d: "M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"
});
var _ref42 = y2("path", {
  d: "M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z"
});
var _ref62 = y2("g", {
  fill: "none",
  "fill-rule": "evenodd"
}, y2("g", {
  transform: "translate(1 1)",
  "stroke-width": "2"
}, y2("circle", {
  "stroke-opacity": ".5",
  cx: "18",
  cy: "18",
  r: "18"
}), y2("path", {
  d: "M36 18c0-9.94-8.06-18-18-18"
}, y2("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  from: "0 18 18",
  to: "360 18 18",
  dur: "1s",
  repeatCount: "indefinite"
}))));
var defaultTemplate = {
  reset: function reset2(_ref9) {
    var cssClasses = _ref9.cssClasses;
    return y2("svg", {
      className: cssClasses.resetIcon,
      viewBox: "0 0 20 20",
      width: "10",
      height: "10",
      "aria-hidden": "true"
    }, _ref2);
  },
  submit: function submit(_ref33) {
    var cssClasses = _ref33.cssClasses;
    return y2("svg", {
      className: cssClasses.submitIcon,
      width: "10",
      height: "10",
      viewBox: "0 0 40 40",
      "aria-hidden": "true"
    }, _ref42);
  },
  loadingIndicator: function loadingIndicator(_ref52) {
    var cssClasses = _ref52.cssClasses;
    return y2("svg", {
      "aria-label": "Results are loading",
      className: cssClasses.loadingIcon,
      width: "16",
      height: "16",
      viewBox: "0 0 38 38",
      stroke: "#444",
      "aria-hidden": "true"
    }, _ref62);
  }
};
var defaultTemplates_default12 = defaultTemplate;

// node_modules/instantsearch.js/es/widgets/refinement-list/defaultTemplates.js
var defaultTemplates15 = {
  item: function item9(_ref9) {
    var cssClasses = _ref9.cssClasses, count = _ref9.count, value = _ref9.value, highlighted = _ref9.highlighted, isRefined2 = _ref9.isRefined, isFromSearch = _ref9.isFromSearch;
    return y2("label", {
      className: cx(cssClasses.label)
    }, y2("input", {
      type: "checkbox",
      className: cx(cssClasses.checkbox),
      value,
      defaultChecked: isRefined2
    }), y2("span", {
      className: cx(cssClasses.labelText),
      dangerouslySetInnerHTML: isFromSearch ? {
        __html: highlighted
      } : void 0
    }, !isFromSearch && highlighted), y2("span", {
      className: cx(cssClasses.count)
    }, formatNumber(count)));
  },
  showMoreText: function showMoreText4(_ref23) {
    var isShowingMore = _ref23.isShowingMore;
    return isShowingMore ? "Show less" : "Show more";
  },
  searchableNoResults: function searchableNoResults() {
    return "No results";
  }
};
var defaultTemplates_default13 = defaultTemplates15;

// node_modules/instantsearch.js/es/widgets/refinement-list/refinement-list.js
function _typeof70(o4) {
  "@babel/helpers - typeof";
  return _typeof70 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof70(o4);
}
function ownKeys75(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread75(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys75(Object(t4), true).forEach(function(r4) {
      _defineProperty70(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys75(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty70(obj, key2, value) {
  key2 = _toPropertyKey69(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey69(t4) {
  var i4 = _toPrimitive69(t4, "string");
  return "symbol" == _typeof70(i4) ? i4 : String(i4);
}
function _toPrimitive69(t4, r3) {
  if ("object" != _typeof70(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof70(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage45 = createDocumentationMessageGenerator({
  name: "refinement-list"
});
var suit20 = component("RefinementList");
var searchBoxSuit = component("SearchBox");
var renderer39 = function renderer40(_ref9) {
  var containerNode = _ref9.containerNode, cssClasses = _ref9.cssClasses, templates = _ref9.templates, searchBoxTemplates = _ref9.searchBoxTemplates, renderState = _ref9.renderState, showMore = _ref9.showMore, searchable = _ref9.searchable, searchablePlaceholder = _ref9.searchablePlaceholder, searchableIsAlwaysActive = _ref9.searchableIsAlwaysActive, searchableSelectOnSubmit = _ref9.searchableSelectOnSubmit;
  return function(_ref23, isFirstRendering) {
    var refine2 = _ref23.refine, items = _ref23.items, createURL = _ref23.createURL, searchForItems = _ref23.searchForItems, isFromSearch = _ref23.isFromSearch, instantSearchInstance = _ref23.instantSearchInstance, toggleShowMore = _ref23.toggleShowMore, isShowingMore = _ref23.isShowingMore, hasExhaustiveItems = _ref23.hasExhaustiveItems, canToggleShowMore = _ref23.canToggleShowMore;
    if (isFirstRendering) {
      renderState.templateProps = prepareTemplateProps({
        defaultTemplates: defaultTemplates_default13,
        templatesConfig: instantSearchInstance.templatesConfig,
        templates
      });
      renderState.searchBoxTemplateProps = prepareTemplateProps({
        defaultTemplates: defaultTemplates_default12,
        templatesConfig: instantSearchInstance.templatesConfig,
        templates: searchBoxTemplates
      });
      return;
    }
    N2(y2(RefinementList_default, {
      createURL,
      cssClasses,
      facetValues: items,
      templateProps: renderState.templateProps,
      searchBoxTemplateProps: renderState.searchBoxTemplateProps,
      toggleRefinement: refine2,
      searchFacetValues: searchable ? searchForItems : void 0,
      searchPlaceholder: searchablePlaceholder,
      searchIsAlwaysActive: searchableIsAlwaysActive,
      isFromSearch,
      showMore: showMore && !isFromSearch && items.length > 0,
      toggleShowMore,
      isShowingMore,
      hasExhaustiveItems,
      canToggleShowMore,
      searchableSelectOnSubmit
    }), containerNode);
  };
};
var refinementList = function refinementList2(widgetParams) {
  var _ref33 = widgetParams || {}, container = _ref33.container, attribute = _ref33.attribute, operator = _ref33.operator, sortBy3 = _ref33.sortBy, limit = _ref33.limit, showMore = _ref33.showMore, showMoreLimit = _ref33.showMoreLimit, _ref3$searchable = _ref33.searchable, searchable = _ref3$searchable === void 0 ? false : _ref3$searchable, _ref3$searchablePlace = _ref33.searchablePlaceholder, searchablePlaceholder = _ref3$searchablePlace === void 0 ? "Search..." : _ref3$searchablePlace, _ref3$searchableEscap = _ref33.searchableEscapeFacetValues, searchableEscapeFacetValues = _ref3$searchableEscap === void 0 ? true : _ref3$searchableEscap, _ref3$searchableIsAlw = _ref33.searchableIsAlwaysActive, searchableIsAlwaysActive = _ref3$searchableIsAlw === void 0 ? true : _ref3$searchableIsAlw, _ref3$searchableSelec = _ref33.searchableSelectOnSubmit, searchableSelectOnSubmit = _ref3$searchableSelec === void 0 ? true : _ref3$searchableSelec, _ref3$cssClasses = _ref33.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses, _ref3$templates = _ref33.templates, templates = _ref3$templates === void 0 ? {} : _ref3$templates, transformItems = _ref33.transformItems;
  if (!container) {
    throw new Error(withUsage45("The `container` option is required."));
  }
  var escapeFacetValues = searchable ? Boolean(searchableEscapeFacetValues) : false;
  var containerNode = getContainerNode(container);
  var cssClasses = {
    root: cx(suit20(), userCssClasses.root),
    noRefinementRoot: cx(suit20({
      modifierName: "noRefinement"
    }), userCssClasses.noRefinementRoot),
    list: cx(suit20({
      descendantName: "list"
    }), userCssClasses.list),
    item: cx(suit20({
      descendantName: "item"
    }), userCssClasses.item),
    selectedItem: cx(suit20({
      descendantName: "item",
      modifierName: "selected"
    }), userCssClasses.selectedItem),
    searchBox: cx(suit20({
      descendantName: "searchBox"
    }), userCssClasses.searchBox),
    label: cx(suit20({
      descendantName: "label"
    }), userCssClasses.label),
    checkbox: cx(suit20({
      descendantName: "checkbox"
    }), userCssClasses.checkbox),
    labelText: cx(suit20({
      descendantName: "labelText"
    }), userCssClasses.labelText),
    count: cx(suit20({
      descendantName: "count"
    }), userCssClasses.count),
    noResults: cx(suit20({
      descendantName: "noResults"
    }), userCssClasses.noResults),
    showMore: cx(suit20({
      descendantName: "showMore"
    }), userCssClasses.showMore),
    disabledShowMore: cx(suit20({
      descendantName: "showMore",
      modifierName: "disabled"
    }), userCssClasses.disabledShowMore),
    searchable: {
      root: cx(searchBoxSuit(), userCssClasses.searchableRoot),
      form: cx(searchBoxSuit({
        descendantName: "form"
      }), userCssClasses.searchableForm),
      input: cx(searchBoxSuit({
        descendantName: "input"
      }), userCssClasses.searchableInput),
      submit: cx(searchBoxSuit({
        descendantName: "submit"
      }), userCssClasses.searchableSubmit),
      submitIcon: cx(searchBoxSuit({
        descendantName: "submitIcon"
      }), userCssClasses.searchableSubmitIcon),
      reset: cx(searchBoxSuit({
        descendantName: "reset"
      }), userCssClasses.searchableReset),
      resetIcon: cx(searchBoxSuit({
        descendantName: "resetIcon"
      }), userCssClasses.searchableResetIcon),
      loadingIndicator: cx(searchBoxSuit({
        descendantName: "loadingIndicator"
      }), userCssClasses.searchableLoadingIndicator),
      loadingIcon: cx(searchBoxSuit({
        descendantName: "loadingIcon"
      }), userCssClasses.searchableLoadingIcon)
    }
  };
  var specializedRenderer = renderer39({
    containerNode,
    cssClasses,
    templates,
    searchBoxTemplates: {
      submit: templates.searchableSubmit,
      reset: templates.searchableReset,
      loadingIndicator: templates.searchableLoadingIndicator
    },
    renderState: {},
    searchable,
    searchablePlaceholder,
    searchableIsAlwaysActive,
    searchableSelectOnSubmit,
    showMore
  });
  var makeWidget = connectRefinementList_default(specializedRenderer, function() {
    return N2(null, containerNode);
  });
  return _objectSpread75(_objectSpread75({}, makeWidget({
    attribute,
    operator,
    limit,
    showMore,
    showMoreLimit,
    sortBy: sortBy3,
    escapeFacetValues,
    transformItems
  })), {}, {
    $$widgetType: "ais.refinementList"
  });
};
var refinement_list_default = refinementList;

// node_modules/instantsearch.js/es/components/RelevantSort/RelevantSort.js
var RelevantSort = function RelevantSort2(_ref9) {
  var cssClasses = _ref9.cssClasses, templates = _ref9.templates, isRelevantSorted = _ref9.isRelevantSorted, isVirtualReplica = _ref9.isVirtualReplica, refine2 = _ref9.refine;
  return isVirtualReplica ? y2("div", {
    className: cssClasses.root
  }, y2(Template_default, {
    templateKey: "text",
    templates,
    rootProps: {
      className: cssClasses.text
    },
    data: {
      isRelevantSorted
    }
  }), y2("button", {
    type: "button",
    className: cssClasses.button,
    onClick: function onClick() {
      if (isRelevantSorted) {
        refine2(0);
      } else {
        refine2(void 0);
      }
    }
  }, y2(Template_default, {
    rootTagName: "span",
    templateKey: "button",
    templates,
    data: {
      isRelevantSorted
    }
  }))) : null;
};
var RelevantSort_default = RelevantSort;

// node_modules/instantsearch.js/es/connectors/relevant-sort/connectRelevantSort.js
function _typeof71(o4) {
  "@babel/helpers - typeof";
  return _typeof71 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof71(o4);
}
function ownKeys76(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread76(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys76(Object(t4), true).forEach(function(r4) {
      _defineProperty71(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys76(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty71(obj, key2, value) {
  key2 = _toPropertyKey70(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey70(t4) {
  var i4 = _toPrimitive70(t4, "string");
  return "symbol" == _typeof71(i4) ? i4 : String(i4);
}
function _toPrimitive70(t4, r3) {
  if ("object" != _typeof71(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof71(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var connectRelevantSort = function connectRelevantSort2() {
  var renderFn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : noop;
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  return function(widgetParams) {
    var connectorState = {};
    return {
      $$type: "ais.relevantSort",
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(_objectSpread76(_objectSpread76({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(_objectSpread76(_objectSpread76({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance
        }), false);
      },
      dispose: function dispose(_ref9) {
        var state = _ref9.state;
        unmountFn();
        return state.setQueryParameter("relevancyStrictness", void 0);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return _objectSpread76(_objectSpread76({}, renderState), {}, {
          relevantSort: this.getWidgetRenderState(renderOptions)
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref23) {
        var results = _ref23.results, helper = _ref23.helper;
        if (!connectorState.refine) {
          connectorState.refine = function(relevancyStrictness) {
            helper.setQueryParameter("relevancyStrictness", relevancyStrictness).search();
          };
        }
        var _ref33 = results || {}, appliedRelevancyStrictness = _ref33.appliedRelevancyStrictness;
        var isVirtualReplica = appliedRelevancyStrictness !== void 0;
        return {
          isRelevantSorted: typeof appliedRelevancyStrictness !== "undefined" && appliedRelevancyStrictness > 0,
          isVirtualReplica,
          canRefine: isVirtualReplica,
          refine: connectorState.refine,
          widgetParams
        };
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(state, _ref44) {
        var _uiState$relevantSort;
        var uiState = _ref44.uiState;
        return state.setQueryParameter("relevancyStrictness", (_uiState$relevantSort = uiState.relevantSort) !== null && _uiState$relevantSort !== void 0 ? _uiState$relevantSort : state.relevancyStrictness);
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref52) {
        var searchParameters = _ref52.searchParameters;
        return _objectSpread76(_objectSpread76({}, uiState), {}, {
          relevantSort: searchParameters.relevancyStrictness || uiState.relevantSort
        });
      }
    };
  };
};
var connectRelevantSort_default = connectRelevantSort;

// node_modules/instantsearch.js/es/widgets/relevant-sort/defaultTemplates.js
var defaultTemplates16 = {
  text: function text() {
    return "";
  },
  button: function button(_ref9) {
    var isRelevantSorted = _ref9.isRelevantSorted;
    return isRelevantSorted ? "See all results" : "See relevant results";
  }
};
var defaultTemplates_default14 = defaultTemplates16;

// node_modules/instantsearch.js/es/widgets/relevant-sort/relevant-sort.js
function _typeof72(o4) {
  "@babel/helpers - typeof";
  return _typeof72 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof72(o4);
}
function ownKeys77(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread77(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys77(Object(t4), true).forEach(function(r4) {
      _defineProperty72(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys77(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty72(obj, key2, value) {
  key2 = _toPropertyKey71(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey71(t4) {
  var i4 = _toPrimitive71(t4, "string");
  return "symbol" == _typeof72(i4) ? i4 : String(i4);
}
function _toPrimitive71(t4, r3) {
  if ("object" != _typeof72(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof72(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage46 = createDocumentationMessageGenerator({
  name: "relevant-sort"
});
var suit21 = component("RelevantSort");
var renderer41 = function renderer42(_ref9) {
  var containerNode = _ref9.containerNode, cssClasses = _ref9.cssClasses, templates = _ref9.templates;
  return function(_ref23) {
    var isRelevantSorted = _ref23.isRelevantSorted, isVirtualReplica = _ref23.isVirtualReplica, refine2 = _ref23.refine;
    N2(y2(RelevantSort_default, {
      cssClasses,
      templates,
      isRelevantSorted,
      isVirtualReplica,
      refine: refine2
    }), containerNode);
  };
};
var relevantSort = function relevantSort2(widgetParams) {
  var container = widgetParams.container, _widgetParams$templat = widgetParams.templates, userTemplates = _widgetParams$templat === void 0 ? {} : _widgetParams$templat, _widgetParams$cssClas = widgetParams.cssClasses, userCssClasses = _widgetParams$cssClas === void 0 ? {} : _widgetParams$cssClas;
  if (!container) {
    throw new Error(withUsage46("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var cssClasses = {
    root: cx(suit21(), userCssClasses.root),
    text: cx(suit21({
      descendantName: "text"
    }), userCssClasses.text),
    button: cx(suit21({
      descendantName: "button"
    }), userCssClasses.button)
  };
  var templates = _objectSpread77(_objectSpread77({}, defaultTemplates_default14), userTemplates);
  var specializedRenderer = renderer41({
    containerNode,
    cssClasses,
    renderState: {},
    templates
  });
  var makeWidget = connectRelevantSort_default(specializedRenderer, function() {
    N2(null, containerNode);
  });
  return _objectSpread77(_objectSpread77({}, makeWidget({})), {}, {
    $$widgetType: "ais.relevantSort"
  });
};
var relevant_sort_default = relevantSort;

// node_modules/instantsearch.js/es/connectors/search-box/connectSearchBox.js
function _typeof73(o4) {
  "@babel/helpers - typeof";
  return _typeof73 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof73(o4);
}
function ownKeys78(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread78(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys78(Object(t4), true).forEach(function(r4) {
      _defineProperty73(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys78(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty73(obj, key2, value) {
  key2 = _toPropertyKey72(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey72(t4) {
  var i4 = _toPrimitive72(t4, "string");
  return "symbol" == _typeof73(i4) ? i4 : String(i4);
}
function _toPrimitive72(t4, r3) {
  if ("object" != _typeof73(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof73(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage47 = createDocumentationMessageGenerator({
  name: "search-box",
  connector: true
});
var defaultQueryHook = function defaultQueryHook2(query, hook) {
  return hook(query);
};
var connectSearchBox = function connectSearchBox2(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage47());
  return function(widgetParams) {
    var _ref9 = widgetParams || {}, _ref$queryHook = _ref9.queryHook, queryHook = _ref$queryHook === void 0 ? defaultQueryHook : _ref$queryHook;
    var _refine2;
    var _clear;
    return {
      $$type: "ais.searchBox",
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(_objectSpread78(_objectSpread78({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(_objectSpread78(_objectSpread78({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance
        }), false);
      },
      dispose: function dispose(_ref23) {
        var state = _ref23.state;
        unmountFn();
        return state.setQueryParameter("query", void 0);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return _objectSpread78(_objectSpread78({}, renderState), {}, {
          searchBox: this.getWidgetRenderState(renderOptions)
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref33) {
        var helper = _ref33.helper, instantSearchInstance = _ref33.instantSearchInstance, state = _ref33.state;
        if (!_refine2) {
          _refine2 = function _refine3(query) {
            queryHook(query, function(q3) {
              return helper.setQuery(q3).search();
            });
          };
          _clear = function _clear2() {
            helper.setQuery("").search();
          };
        }
        return {
          query: state.query || "",
          refine: _refine2,
          clear: _clear,
          widgetParams,
          isSearchStalled: instantSearchInstance.status === "stalled"
        };
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref44) {
        var searchParameters = _ref44.searchParameters;
        var query = searchParameters.query || "";
        if (query === "" || uiState && uiState.query === query) {
          return uiState;
        }
        return _objectSpread78(_objectSpread78({}, uiState), {}, {
          query
        });
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref52) {
        var uiState = _ref52.uiState;
        return searchParameters.setQueryParameter("query", uiState.query || "");
      }
    };
  };
};
var connectSearchBox_default = connectSearchBox;

// node_modules/instantsearch.js/es/widgets/search-box/search-box.js
function _typeof74(o4) {
  "@babel/helpers - typeof";
  return _typeof74 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof74(o4);
}
function ownKeys79(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread79(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys79(Object(t4), true).forEach(function(r4) {
      _defineProperty74(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys79(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty74(obj, key2, value) {
  key2 = _toPropertyKey73(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey73(t4) {
  var i4 = _toPrimitive73(t4, "string");
  return "symbol" == _typeof74(i4) ? i4 : String(i4);
}
function _toPrimitive73(t4, r3) {
  if ("object" != _typeof74(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof74(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage48 = createDocumentationMessageGenerator({
  name: "search-box"
});
var suit22 = component("SearchBox");
var renderer43 = function renderer44(_ref9) {
  var containerNode = _ref9.containerNode, cssClasses = _ref9.cssClasses, placeholder = _ref9.placeholder, templates = _ref9.templates, autofocus = _ref9.autofocus, searchAsYouType = _ref9.searchAsYouType, ignoreCompositionEvents = _ref9.ignoreCompositionEvents, showReset = _ref9.showReset, showSubmit = _ref9.showSubmit, showLoadingIndicator = _ref9.showLoadingIndicator;
  return function(_ref23) {
    var refine2 = _ref23.refine, query = _ref23.query, isSearchStalled = _ref23.isSearchStalled;
    N2(y2(SearchBox_default, {
      query,
      placeholder,
      autofocus,
      refine: refine2,
      searchAsYouType,
      ignoreCompositionEvents,
      templates,
      showSubmit,
      showReset,
      showLoadingIndicator,
      isSearchStalled,
      cssClasses
    }), containerNode);
  };
};
var searchBox = function searchBox2(widgetParams) {
  var _ref33 = widgetParams || {}, container = _ref33.container, _ref3$placeholder = _ref33.placeholder, placeholder = _ref3$placeholder === void 0 ? "" : _ref3$placeholder, _ref3$cssClasses = _ref33.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses, _ref3$autofocus = _ref33.autofocus, autofocus = _ref3$autofocus === void 0 ? false : _ref3$autofocus, _ref3$searchAsYouType = _ref33.searchAsYouType, searchAsYouType = _ref3$searchAsYouType === void 0 ? true : _ref3$searchAsYouType, _ref3$ignoreCompositi = _ref33.ignoreCompositionEvents, ignoreCompositionEvents = _ref3$ignoreCompositi === void 0 ? false : _ref3$ignoreCompositi, _ref3$showReset = _ref33.showReset, showReset = _ref3$showReset === void 0 ? true : _ref3$showReset, _ref3$showSubmit = _ref33.showSubmit, showSubmit = _ref3$showSubmit === void 0 ? true : _ref3$showSubmit, _ref3$showLoadingIndi = _ref33.showLoadingIndicator, showLoadingIndicator = _ref3$showLoadingIndi === void 0 ? true : _ref3$showLoadingIndi, queryHook = _ref33.queryHook, _ref3$templates = _ref33.templates, userTemplates = _ref3$templates === void 0 ? {} : _ref3$templates;
  if (!container) {
    throw new Error(withUsage48("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var cssClasses = {
    root: cx(suit22(), userCssClasses.root),
    form: cx(suit22({
      descendantName: "form"
    }), userCssClasses.form),
    input: cx(suit22({
      descendantName: "input"
    }), userCssClasses.input),
    submit: cx(suit22({
      descendantName: "submit"
    }), userCssClasses.submit),
    submitIcon: cx(suit22({
      descendantName: "submitIcon"
    }), userCssClasses.submitIcon),
    reset: cx(suit22({
      descendantName: "reset"
    }), userCssClasses.reset),
    resetIcon: cx(suit22({
      descendantName: "resetIcon"
    }), userCssClasses.resetIcon),
    loadingIndicator: cx(suit22({
      descendantName: "loadingIndicator"
    }), userCssClasses.loadingIndicator),
    loadingIcon: cx(suit22({
      descendantName: "loadingIcon"
    }), userCssClasses.loadingIcon)
  };
  var templates = _objectSpread79(_objectSpread79({}, defaultTemplates_default12), userTemplates);
  var specializedRenderer = renderer43({
    containerNode,
    cssClasses,
    placeholder,
    templates,
    autofocus,
    searchAsYouType,
    ignoreCompositionEvents,
    showReset,
    showSubmit,
    showLoadingIndicator
  });
  var makeWidget = connectSearchBox_default(specializedRenderer, function() {
    return N2(null, containerNode);
  });
  return _objectSpread79(_objectSpread79({}, makeWidget({
    queryHook
  })), {}, {
    $$widgetType: "ais.searchBox"
  });
};
var search_box_default = searchBox;

// node_modules/instantsearch.js/es/connectors/sort-by/connectSortBy.js
function _typeof75(o4) {
  "@babel/helpers - typeof";
  return _typeof75 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof75(o4);
}
function ownKeys80(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread80(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys80(Object(t4), true).forEach(function(r4) {
      _defineProperty75(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys80(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty75(obj, key2, value) {
  key2 = _toPropertyKey74(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey74(t4) {
  var i4 = _toPrimitive74(t4, "string");
  return "symbol" == _typeof75(i4) ? i4 : String(i4);
}
function _toPrimitive74(t4, r3) {
  if ("object" != _typeof75(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof75(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage49 = createDocumentationMessageGenerator({
  name: "sort-by",
  connector: true
});
var connectSortBy = function connectSortBy2(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage49());
  var connectorState = {};
  return function(widgetParams) {
    var _ref9 = widgetParams || {}, items = _ref9.items, _ref$transformItems = _ref9.transformItems, transformItems = _ref$transformItems === void 0 ? function(x4) {
      return x4;
    } : _ref$transformItems;
    if (!Array.isArray(items)) {
      throw new Error(withUsage49("The `items` option expects an array of objects."));
    }
    return {
      $$type: "ais.sortBy",
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        var widgetRenderState = this.getWidgetRenderState(initOptions);
        var currentIndex = widgetRenderState.currentRefinement;
        var isCurrentIndexInItems = find(items, function(item11) {
          return item11.value === currentIndex;
        });
        false ? _warning(isCurrentIndexInItems !== void 0, 'The index named "'.concat(currentIndex, '" is not listed in the `items` of `sortBy`.')) : void 0;
        renderFn(_objectSpread80(_objectSpread80({}, widgetRenderState), {}, {
          instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(_objectSpread80(_objectSpread80({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance
        }), false);
      },
      dispose: function dispose(_ref23) {
        var state = _ref23.state;
        unmountFn();
        return connectorState.initialIndex ? state.setIndex(connectorState.initialIndex) : state;
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return _objectSpread80(_objectSpread80({}, renderState), {}, {
          sortBy: this.getWidgetRenderState(renderOptions)
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref33) {
        var results = _ref33.results, helper = _ref33.helper, state = _ref33.state, parent = _ref33.parent;
        if (!connectorState.initialIndex && parent) {
          connectorState.initialIndex = parent.getIndexName();
        }
        if (!connectorState.setIndex) {
          connectorState.setIndex = function(indexName) {
            helper.setIndex(indexName).search();
          };
        }
        var hasNoResults = results ? results.nbHits === 0 : true;
        return {
          currentRefinement: state.index,
          options: transformItems(items, {
            results
          }),
          refine: connectorState.setIndex,
          hasNoResults,
          canRefine: !hasNoResults && items.length > 0,
          widgetParams
        };
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref44) {
        var searchParameters = _ref44.searchParameters;
        var currentIndex = searchParameters.index;
        return _objectSpread80(_objectSpread80({}, uiState), {}, {
          sortBy: currentIndex !== connectorState.initialIndex ? currentIndex : void 0
        });
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref52) {
        var uiState = _ref52.uiState;
        return searchParameters.setQueryParameter("index", uiState.sortBy || connectorState.initialIndex || searchParameters.index);
      }
    };
  };
};
var connectSortBy_default = connectSortBy;

// node_modules/instantsearch.js/es/widgets/sort-by/sort-by.js
function _typeof76(o4) {
  "@babel/helpers - typeof";
  return _typeof76 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof76(o4);
}
function ownKeys81(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread81(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys81(Object(t4), true).forEach(function(r4) {
      _defineProperty76(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys81(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty76(obj, key2, value) {
  key2 = _toPropertyKey75(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey75(t4) {
  var i4 = _toPrimitive75(t4, "string");
  return "symbol" == _typeof76(i4) ? i4 : String(i4);
}
function _toPrimitive75(t4, r3) {
  if ("object" != _typeof76(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof76(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage50 = createDocumentationMessageGenerator({
  name: "sort-by"
});
var suit23 = component("SortBy");
var renderer45 = function renderer46(_ref9) {
  var containerNode = _ref9.containerNode, cssClasses = _ref9.cssClasses;
  return function(_ref23, isFirstRendering) {
    var currentRefinement = _ref23.currentRefinement, options = _ref23.options, refine2 = _ref23.refine;
    if (isFirstRendering) {
      return;
    }
    N2(y2("div", {
      className: cssClasses.root
    }, y2(Selector_default, {
      cssClasses,
      currentValue: currentRefinement,
      options,
      setValue: refine2,
      ariaLabel: "Sort results by"
    })), containerNode);
  };
};
var sortBy = function sortBy2(widgetParams) {
  var _ref33 = widgetParams || {}, container = _ref33.container, items = _ref33.items, _ref3$cssClasses = _ref33.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses, transformItems = _ref33.transformItems;
  if (!container) {
    throw new Error(withUsage50("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var cssClasses = {
    root: cx(suit23(), userCssClasses.root),
    select: cx(suit23({
      descendantName: "select"
    }), userCssClasses.select),
    option: cx(suit23({
      descendantName: "option"
    }), userCssClasses.option)
  };
  var specializedRenderer = renderer45({
    containerNode,
    cssClasses
  });
  var makeWidget = connectSortBy_default(specializedRenderer, function() {
    return N2(null, containerNode);
  });
  return _objectSpread81(_objectSpread81({}, makeWidget({
    container: containerNode,
    items,
    transformItems
  })), {}, {
    $$widgetType: "ais.sortBy"
  });
};
var sort_by_default = sortBy;

// node_modules/instantsearch.js/es/components/Stats/Stats.js
function _typeof77(o4) {
  "@babel/helpers - typeof";
  return _typeof77 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof77(o4);
}
var _excluded39 = ["nbHits", "nbSortedHits", "cssClasses", "templateProps"];
function _extends24() {
  _extends24 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends24.apply(this, arguments);
}
function ownKeys82(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread82(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys82(Object(t4), true).forEach(function(r4) {
      _defineProperty77(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys82(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty77(obj, key2, value) {
  key2 = _toPropertyKey76(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey76(t4) {
  var i4 = _toPrimitive76(t4, "string");
  return "symbol" == _typeof77(i4) ? i4 : String(i4);
}
function _toPrimitive76(t4, r3) {
  if ("object" != _typeof77(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof77(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _objectWithoutProperties20(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose20(source, excluded);
  var key2, i4;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i4 = 0; i4 < sourceSymbolKeys.length; i4++) {
      key2 = sourceSymbolKeys[i4];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose20(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i4;
  for (i4 = 0; i4 < sourceKeys.length; i4++) {
    key2 = sourceKeys[i4];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
var Stats = function Stats2(_ref9) {
  var nbHits = _ref9.nbHits, nbSortedHits = _ref9.nbSortedHits, cssClasses = _ref9.cssClasses, templateProps = _ref9.templateProps, rest = _objectWithoutProperties20(_ref9, _excluded39);
  return y2("div", {
    className: cx(cssClasses.root)
  }, y2(Template_default, _extends24({}, templateProps, {
    templateKey: "text",
    rootTagName: "span",
    rootProps: {
      className: cssClasses.text
    },
    data: _objectSpread82({
      hasManySortedResults: nbSortedHits && nbSortedHits > 1,
      hasNoSortedResults: nbSortedHits === 0,
      hasOneSortedResults: nbSortedHits === 1,
      hasManyResults: nbHits > 1,
      hasNoResults: nbHits === 0,
      hasOneResult: nbHits === 1,
      nbHits,
      nbSortedHits,
      cssClasses
    }, rest)
  })));
};
var Stats_default = Stats;

// node_modules/instantsearch.js/es/connectors/stats/connectStats.js
function _typeof78(o4) {
  "@babel/helpers - typeof";
  return _typeof78 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof78(o4);
}
function ownKeys83(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread83(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys83(Object(t4), true).forEach(function(r4) {
      _defineProperty78(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys83(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty78(obj, key2, value) {
  key2 = _toPropertyKey77(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey77(t4) {
  var i4 = _toPrimitive77(t4, "string");
  return "symbol" == _typeof78(i4) ? i4 : String(i4);
}
function _toPrimitive77(t4, r3) {
  if ("object" != _typeof78(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof78(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage51 = createDocumentationMessageGenerator({
  name: "stats",
  connector: true
});
var connectStats = function connectStats2(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage51());
  return function(widgetParams) {
    return {
      $$type: "ais.stats",
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(_objectSpread83(_objectSpread83({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(_objectSpread83(_objectSpread83({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance
        }), false);
      },
      dispose: function dispose() {
        unmountFn();
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return _objectSpread83(_objectSpread83({}, renderState), {}, {
          stats: this.getWidgetRenderState(renderOptions)
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref9) {
        var results = _ref9.results, state = _ref9.state;
        if (!results) {
          return {
            hitsPerPage: state.hitsPerPage,
            nbHits: 0,
            nbSortedHits: void 0,
            areHitsSorted: false,
            nbPages: 0,
            page: state.page || 0,
            processingTimeMS: -1,
            query: state.query || "",
            widgetParams
          };
        }
        return {
          hitsPerPage: results.hitsPerPage,
          nbHits: results.nbHits,
          nbSortedHits: results.nbSortedHits,
          areHitsSorted: typeof results.appliedRelevancyStrictness !== "undefined" && results.appliedRelevancyStrictness > 0 && results.nbSortedHits !== results.nbHits,
          nbPages: results.nbPages,
          page: results.page,
          processingTimeMS: results.processingTimeMS,
          query: results.query,
          widgetParams
        };
      }
    };
  };
};
var connectStats_default = connectStats;

// node_modules/instantsearch.js/es/widgets/stats/stats.js
function _typeof79(o4) {
  "@babel/helpers - typeof";
  return _typeof79 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof79(o4);
}
function ownKeys84(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread84(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys84(Object(t4), true).forEach(function(r4) {
      _defineProperty79(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys84(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty79(obj, key2, value) {
  key2 = _toPropertyKey78(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey78(t4) {
  var i4 = _toPrimitive78(t4, "string");
  return "symbol" == _typeof79(i4) ? i4 : String(i4);
}
function _toPrimitive78(t4, r3) {
  if ("object" != _typeof79(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof79(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage52 = createDocumentationMessageGenerator({
  name: "stats"
});
var suit24 = component("Stats");
var defaultTemplates17 = {
  text: function text2(props) {
    return "".concat(props.areHitsSorted ? getSortedResultsSentence(props) : getResultsSentence(props), " found in ").concat(props.processingTimeMS, "ms");
  }
};
function getSortedResultsSentence(_ref9) {
  var nbHits = _ref9.nbHits, hasNoSortedResults = _ref9.hasNoSortedResults, hasOneSortedResults = _ref9.hasOneSortedResults, hasManySortedResults = _ref9.hasManySortedResults, nbSortedHits = _ref9.nbSortedHits;
  var suffix = "sorted out of ".concat(formatNumber(nbHits));
  if (hasNoSortedResults) {
    return "No relevant results ".concat(suffix);
  }
  if (hasOneSortedResults) {
    return "1 relevant result ".concat(suffix);
  }
  if (hasManySortedResults) {
    return "".concat(formatNumber(nbSortedHits || 0), " relevant results ").concat(suffix);
  }
  return "";
}
function getResultsSentence(_ref23) {
  var nbHits = _ref23.nbHits, hasNoResults = _ref23.hasNoResults, hasOneResult = _ref23.hasOneResult, hasManyResults = _ref23.hasManyResults;
  if (hasNoResults) {
    return "No results";
  }
  if (hasOneResult) {
    return "1 result";
  }
  if (hasManyResults) {
    return "".concat(formatNumber(nbHits), " results");
  }
  return "";
}
var renderer47 = function renderer48(_ref33) {
  var renderState = _ref33.renderState, cssClasses = _ref33.cssClasses, containerNode = _ref33.containerNode, templates = _ref33.templates;
  return function(_ref44, isFirstRendering) {
    var hitsPerPage3 = _ref44.hitsPerPage, nbHits = _ref44.nbHits, nbSortedHits = _ref44.nbSortedHits, areHitsSorted = _ref44.areHitsSorted, nbPages = _ref44.nbPages, page2 = _ref44.page, processingTimeMS = _ref44.processingTimeMS, query = _ref44.query, instantSearchInstance = _ref44.instantSearchInstance;
    if (isFirstRendering) {
      renderState.templateProps = prepareTemplateProps({
        defaultTemplates: defaultTemplates17,
        templatesConfig: instantSearchInstance.templatesConfig,
        templates
      });
      return;
    }
    N2(y2(Stats_default, {
      cssClasses,
      hitsPerPage: hitsPerPage3,
      nbHits,
      nbSortedHits,
      areHitsSorted,
      nbPages,
      page: page2,
      processingTimeMS,
      query,
      templateProps: renderState.templateProps
    }), containerNode);
  };
};
var stats = function stats2(widgetParams) {
  var _ref52 = widgetParams || {}, container = _ref52.container, _ref5$cssClasses = _ref52.cssClasses, userCssClasses = _ref5$cssClasses === void 0 ? {} : _ref5$cssClasses, _ref5$templates = _ref52.templates, templates = _ref5$templates === void 0 ? {} : _ref5$templates;
  if (!container) {
    throw new Error(withUsage52("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var cssClasses = {
    root: cx(suit24(), userCssClasses.root),
    text: cx(suit24({
      descendantName: "text"
    }), userCssClasses.text)
  };
  var specializedRenderer = renderer47({
    containerNode,
    cssClasses,
    templates,
    renderState: {}
  });
  var makeWidget = connectStats_default(specializedRenderer, function() {
    return N2(null, containerNode);
  });
  return _objectSpread84(_objectSpread84({}, makeWidget({})), {}, {
    $$widgetType: "ais.stats"
  });
};
var stats_default = stats;

// node_modules/instantsearch.js/es/components/ToggleRefinement/ToggleRefinement.js
function _extends25() {
  _extends25 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends25.apply(this, arguments);
}
var ToggleRefinement = function ToggleRefinement2(_ref9) {
  var currentRefinement = _ref9.currentRefinement, refine2 = _ref9.refine, cssClasses = _ref9.cssClasses, templateProps = _ref9.templateProps;
  return y2("div", {
    className: cssClasses.root
  }, y2("label", {
    className: cssClasses.label
  }, y2("input", {
    className: cssClasses.checkbox,
    type: "checkbox",
    checked: currentRefinement.isRefined,
    onChange: function onChange(event) {
      return refine2({
        isRefined: !event.target.checked
      });
    }
  }), y2(Template_default, _extends25({}, templateProps, {
    rootTagName: "span",
    rootProps: {
      className: cssClasses.labelText
    },
    templateKey: "labelText",
    data: currentRefinement
  }))));
};
var ToggleRefinement_default = ToggleRefinement;

// node_modules/instantsearch.js/es/connectors/toggle-refinement/connectToggleRefinement.js
function _typeof80(o4) {
  "@babel/helpers - typeof";
  return _typeof80 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof80(o4);
}
function ownKeys85(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread85(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys85(Object(t4), true).forEach(function(r4) {
      _defineProperty80(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys85(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty80(obj, key2, value) {
  key2 = _toPropertyKey79(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey79(t4) {
  var i4 = _toPrimitive79(t4, "string");
  return "symbol" == _typeof80(i4) ? i4 : String(i4);
}
function _toPrimitive79(t4, r3) {
  if ("object" != _typeof80(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof80(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _slicedToArray15(arr, i4) {
  return _arrayWithHoles15(arr) || _iterableToArrayLimit15(arr, i4) || _unsupportedIterableToArray25(arr, i4) || _nonIterableRest15();
}
function _nonIterableRest15() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray25(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray25(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray25(o4, minLen);
}
function _arrayLikeToArray25(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
function _iterableToArrayLimit15(r3, l4) {
  var t4 = null == r3 ? null : "undefined" != typeof Symbol && r3[Symbol.iterator] || r3["@@iterator"];
  if (null != t4) {
    var e4, n4, i4, u4, a4 = [], f4 = true, o4 = false;
    try {
      if (i4 = (t4 = t4.call(r3)).next, 0 === l4) {
        if (Object(t4) !== t4)
          return;
        f4 = false;
      } else
        for (; !(f4 = (e4 = i4.call(t4)).done) && (a4.push(e4.value), a4.length !== l4); f4 = true)
          ;
    } catch (r4) {
      o4 = true, n4 = r4;
    } finally {
      try {
        if (!f4 && null != t4.return && (u4 = t4.return(), Object(u4) !== u4))
          return;
      } finally {
        if (o4)
          throw n4;
      }
    }
    return a4;
  }
}
function _arrayWithHoles15(arr) {
  if (Array.isArray(arr))
    return arr;
}
var withUsage53 = createDocumentationMessageGenerator({
  name: "toggle-refinement",
  connector: true
});
var $$type5 = "ais.toggleRefinement";
var createSendEvent5 = function createSendEvent6(_ref9) {
  var instantSearchInstance = _ref9.instantSearchInstance, helper = _ref9.helper, attribute = _ref9.attribute, on = _ref9.on;
  var sendEventForToggle = function sendEventForToggle2() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (args.length === 1) {
      instantSearchInstance.sendEventToInsights(args[0]);
      return;
    }
    var isRefined2 = args[1], _args$ = args[2], eventName = _args$ === void 0 ? "Filter Applied" : _args$;
    var _args$0$split = args[0].split(":"), _args$0$split2 = _slicedToArray15(_args$0$split, 2), eventType = _args$0$split2[0], eventModifier = _args$0$split2[1];
    if (eventType !== "click" || on === void 0) {
      return;
    }
    if (!isRefined2) {
      var _helper$lastResults;
      instantSearchInstance.sendEventToInsights({
        insightsMethod: "clickedFilters",
        widgetType: $$type5,
        eventType,
        eventModifier,
        payload: {
          eventName,
          index: ((_helper$lastResults = helper.lastResults) === null || _helper$lastResults === void 0 ? void 0 : _helper$lastResults.index) || helper.state.index,
          filters: on.map(function(value) {
            return "".concat(attribute, ":").concat(value);
          })
        },
        attribute
      });
    }
  };
  return sendEventForToggle;
};
var connectToggleRefinement = function connectToggleRefinement2(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage53());
  return function(widgetParams) {
    var _ref23 = widgetParams || {}, attribute = _ref23.attribute, _ref2$on = _ref23.on, userOn = _ref2$on === void 0 ? true : _ref2$on, userOff = _ref23.off;
    if (!attribute) {
      throw new Error(withUsage53("The `attribute` option is required."));
    }
    var hasAnOffValue = userOff !== void 0;
    var on = toArray(userOn).map(escapeFacetValue);
    var off = hasAnOffValue ? toArray(userOff).map(escapeFacetValue) : void 0;
    var sendEvent;
    var toggleRefinementFactory = function toggleRefinementFactory2(helper) {
      return function() {
        var _ref33 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
          isRefined: false
        }, isRefined2 = _ref33.isRefined;
        if (!isRefined2) {
          sendEvent("click:internal", isRefined2);
          if (hasAnOffValue) {
            off.forEach(function(v4) {
              return helper.removeDisjunctiveFacetRefinement(attribute, v4);
            });
          }
          on.forEach(function(v4) {
            return helper.addDisjunctiveFacetRefinement(attribute, v4);
          });
        } else {
          on.forEach(function(v4) {
            return helper.removeDisjunctiveFacetRefinement(attribute, v4);
          });
          if (hasAnOffValue) {
            off.forEach(function(v4) {
              return helper.addDisjunctiveFacetRefinement(attribute, v4);
            });
          }
        }
        helper.search();
      };
    };
    var connectorState = {
      createURLFactory: function createURLFactory(isRefined2, _ref44) {
        var state = _ref44.state, createURL = _ref44.createURL, getWidgetUiState = _ref44.getWidgetUiState, helper = _ref44.helper;
        return function() {
          state = state.resetPage();
          var valuesToRemove = isRefined2 ? on : off;
          if (valuesToRemove) {
            valuesToRemove.forEach(function(v4) {
              state = state.removeDisjunctiveFacetRefinement(attribute, v4);
            });
          }
          var valuesToAdd = isRefined2 ? off : on;
          if (valuesToAdd) {
            valuesToAdd.forEach(function(v4) {
              state = state.addDisjunctiveFacetRefinement(attribute, v4);
            });
          }
          return createURL(function(uiState) {
            return getWidgetUiState(uiState, {
              searchParameters: state,
              helper
            });
          });
        };
      }
    };
    return {
      $$type: $$type5,
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(_objectSpread85(_objectSpread85({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(_objectSpread85(_objectSpread85({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance
        }), false);
      },
      dispose: function dispose(_ref52) {
        var state = _ref52.state;
        unmountFn();
        return state.removeDisjunctiveFacet(attribute);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return _objectSpread85(_objectSpread85({}, renderState), {}, {
          toggleRefinement: _objectSpread85(_objectSpread85({}, renderState.toggleRefinement), {}, _defineProperty80({}, attribute, this.getWidgetRenderState(renderOptions)))
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref64) {
        var state = _ref64.state, helper = _ref64.helper, results = _ref64.results, createURL = _ref64.createURL, instantSearchInstance = _ref64.instantSearchInstance;
        var isRefined2 = results ? on.every(function(v4) {
          return state.isDisjunctiveFacetRefined(attribute, v4);
        }) : on.every(function(v4) {
          return state.isDisjunctiveFacetRefined(attribute, v4);
        });
        var onFacetValue = {
          isRefined: isRefined2,
          count: 0
        };
        var offFacetValue = {
          isRefined: hasAnOffValue && !isRefined2,
          count: 0
        };
        if (results) {
          var offValue = toArray(off || false);
          var allFacetValues = results.getFacetValues(attribute, {}) || [];
          var onData = on.map(function(v4) {
            return find(allFacetValues, function(_ref72) {
              var escapedValue = _ref72.escapedValue;
              return escapedValue === escapeFacetValue(String(v4));
            });
          }).filter(function(v4) {
            return v4 !== void 0;
          });
          var offData = hasAnOffValue ? offValue.map(function(v4) {
            return find(allFacetValues, function(_ref82) {
              var escapedValue = _ref82.escapedValue;
              return escapedValue === escapeFacetValue(String(v4));
            });
          }).filter(function(v4) {
            return v4 !== void 0;
          }) : [];
          onFacetValue = {
            isRefined: onData.length ? onData.every(function(v4) {
              return v4.isRefined;
            }) : false,
            count: onData.reduce(function(acc, v4) {
              return acc + v4.count;
            }, 0) || null
          };
          offFacetValue = {
            isRefined: offData.length ? offData.every(function(v4) {
              return v4.isRefined;
            }) : false,
            count: offData.reduce(function(acc, v4) {
              return acc + v4.count;
            }, 0) || allFacetValues.reduce(function(total, _ref9) {
              var count = _ref9.count;
              return total + count;
            }, 0)
          };
        }
        if (!sendEvent) {
          sendEvent = createSendEvent5({
            instantSearchInstance,
            attribute,
            on,
            helper
          });
        }
        var nextRefinement = isRefined2 ? offFacetValue : onFacetValue;
        return {
          value: {
            name: attribute,
            isRefined: isRefined2,
            count: results ? nextRefinement.count : null,
            onFacetValue,
            offFacetValue
          },
          createURL: connectorState.createURLFactory(isRefined2, {
            state,
            createURL,
            helper,
            getWidgetUiState: this.getWidgetUiState
          }),
          sendEvent,
          canRefine: Boolean(results ? nextRefinement.count : null),
          refine: toggleRefinementFactory(helper),
          widgetParams
        };
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref10) {
        var searchParameters = _ref10.searchParameters;
        var isRefined2 = on && on.every(function(v4) {
          return searchParameters.isDisjunctiveFacetRefined(attribute, v4);
        });
        if (!isRefined2) {
          var _uiState$toggle;
          (_uiState$toggle = uiState.toggle) === null || _uiState$toggle === void 0 ? true : delete _uiState$toggle[attribute];
          return uiState;
        }
        return _objectSpread85(_objectSpread85({}, uiState), {}, {
          toggle: _objectSpread85(_objectSpread85({}, uiState.toggle), {}, _defineProperty80({}, attribute, isRefined2))
        });
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref11) {
        var uiState = _ref11.uiState;
        if (searchParameters.isHierarchicalFacet(attribute) || searchParameters.isConjunctiveFacet(attribute)) {
          false ? _warning(false, 'ToggleRefinement: Attribute "'.concat(attribute, '" is already used by another widget of a different type.\nAs this is not supported, please make sure to remove this other widget or this ToggleRefinement widget will not work at all.')) : void 0;
          return searchParameters;
        }
        var withFacetConfiguration = searchParameters.addDisjunctiveFacet(attribute).removeDisjunctiveFacetRefinement(attribute);
        var isRefined2 = Boolean(uiState.toggle && uiState.toggle[attribute]);
        if (isRefined2) {
          if (on) {
            on.forEach(function(v4) {
              withFacetConfiguration = withFacetConfiguration.addDisjunctiveFacetRefinement(attribute, v4);
            });
          }
          return withFacetConfiguration;
        }
        if (hasAnOffValue) {
          if (off) {
            off.forEach(function(v4) {
              withFacetConfiguration = withFacetConfiguration.addDisjunctiveFacetRefinement(attribute, v4);
            });
          }
          return withFacetConfiguration;
        }
        return withFacetConfiguration.setQueryParameters({
          disjunctiveFacetsRefinements: _objectSpread85(_objectSpread85({}, searchParameters.disjunctiveFacetsRefinements), {}, _defineProperty80({}, attribute, []))
        });
      }
    };
  };
};
var connectToggleRefinement_default = connectToggleRefinement;

// node_modules/instantsearch.js/es/widgets/toggle-refinement/defaultTemplates.js
var defaultTemplates18 = {
  labelText: function labelText(_ref9) {
    var name16 = _ref9.name;
    return name16;
  }
};
var defaultTemplates_default15 = defaultTemplates18;

// node_modules/instantsearch.js/es/widgets/toggle-refinement/toggle-refinement.js
function _typeof81(o4) {
  "@babel/helpers - typeof";
  return _typeof81 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof81(o4);
}
function ownKeys86(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread86(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys86(Object(t4), true).forEach(function(r4) {
      _defineProperty81(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys86(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty81(obj, key2, value) {
  key2 = _toPropertyKey80(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey80(t4) {
  var i4 = _toPrimitive80(t4, "string");
  return "symbol" == _typeof81(i4) ? i4 : String(i4);
}
function _toPrimitive80(t4, r3) {
  if ("object" != _typeof81(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof81(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage54 = createDocumentationMessageGenerator({
  name: "toggle-refinement"
});
var suit25 = component("ToggleRefinement");
var renderer49 = function renderer50(_ref9) {
  var containerNode = _ref9.containerNode, cssClasses = _ref9.cssClasses, renderState = _ref9.renderState, templates = _ref9.templates;
  return function(_ref23, isFirstRendering) {
    var value = _ref23.value, refine2 = _ref23.refine, instantSearchInstance = _ref23.instantSearchInstance;
    if (isFirstRendering) {
      renderState.templateProps = prepareTemplateProps({
        defaultTemplates: defaultTemplates_default15,
        templatesConfig: instantSearchInstance.templatesConfig,
        templates
      });
      return;
    }
    N2(y2(ToggleRefinement_default, {
      cssClasses,
      currentRefinement: value,
      templateProps: renderState.templateProps,
      refine: refine2
    }), containerNode);
  };
};
var toggleRefinement = function toggleRefinement2(widgetParams) {
  var _ref33 = widgetParams || {}, container = _ref33.container, attribute = _ref33.attribute, _ref3$cssClasses = _ref33.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses, _ref3$templates = _ref33.templates, templates = _ref3$templates === void 0 ? {} : _ref3$templates, _ref3$on = _ref33.on, on = _ref3$on === void 0 ? true : _ref3$on, off = _ref33.off;
  if (!container) {
    throw new Error(withUsage54("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var cssClasses = {
    root: cx(suit25(), userCssClasses.root),
    label: cx(suit25({
      descendantName: "label"
    }), userCssClasses.label),
    checkbox: cx(suit25({
      descendantName: "checkbox"
    }), userCssClasses.checkbox),
    labelText: cx(suit25({
      descendantName: "labelText"
    }), userCssClasses.labelText)
  };
  var specializedRenderer = renderer49({
    containerNode,
    cssClasses,
    renderState: {},
    templates
  });
  var makeWidget = connectToggleRefinement_default(specializedRenderer, function() {
    return N2(null, containerNode);
  });
  return _objectSpread86(_objectSpread86({}, makeWidget({
    attribute,
    on,
    off
  })), {}, {
    $$widgetType: "ais.toggleRefinement"
  });
};
var toggle_refinement_default = toggleRefinement;

// node_modules/instantsearch.js/es/connectors/trending-items/connectTrendingItems.js
function _typeof82(o4) {
  "@babel/helpers - typeof";
  return _typeof82 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof82(o4);
}
function ownKeys87(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread87(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys87(Object(t4), true).forEach(function(r4) {
      _defineProperty82(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys87(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty82(obj, key2, value) {
  key2 = _toPropertyKey81(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey81(t4) {
  var i4 = _toPrimitive81(t4, "string");
  return "symbol" == _typeof82(i4) ? i4 : String(i4);
}
function _toPrimitive81(t4, r3) {
  if ("object" != _typeof82(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof82(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage55 = createDocumentationMessageGenerator({
  name: "trending-items",
  connector: true
});
var connectTrendingItems_default = function connectTrendingItems(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage55());
  return function(widgetParams) {
    var _ref9 = widgetParams || {}, facetName = _ref9.facetName, facetValue = _ref9.facetValue, limit = _ref9.limit, threshold = _ref9.threshold, fallbackParameters = _ref9.fallbackParameters, queryParameters = _ref9.queryParameters, _ref$escapeHTML = _ref9.escapeHTML, escapeHTML = _ref$escapeHTML === void 0 ? true : _ref$escapeHTML, _ref$transformItems = _ref9.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
      return items;
    } : _ref$transformItems;
    if (facetName && !facetValue || !facetName && facetValue) {
      throw new Error(withUsage55("When you provide facetName (received type ".concat(getObjectType(facetName), "), you must also provide facetValue (received type ").concat(getObjectType(facetValue), ").")));
    }
    var sendEvent;
    return {
      dependsOn: "recommend",
      $$type: "ais.trendingItems",
      init: function init(initOptions) {
        renderFn(_objectSpread87(_objectSpread87({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: initOptions.instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var renderState = this.getWidgetRenderState(renderOptions);
        renderFn(_objectSpread87(_objectSpread87({}, renderState), {}, {
          instantSearchInstance: renderOptions.instantSearchInstance
        }), false);
      },
      getRenderState: function getRenderState(renderState) {
        return renderState;
      },
      getWidgetRenderState: function getWidgetRenderState(_ref23) {
        var results = _ref23.results, helper = _ref23.helper, instantSearchInstance = _ref23.instantSearchInstance;
        if (!sendEvent) {
          sendEvent = createSendEventForHits({
            instantSearchInstance,
            helper,
            widgetType: this.$$type
          });
        }
        if (results === null || results === void 0) {
          return {
            items: [],
            widgetParams,
            sendEvent
          };
        }
        if (escapeHTML && results.hits.length > 0) {
          results.hits = escapeHits(results.hits);
        }
        var itemsWithAbsolutePosition = addAbsolutePosition(results.hits, 0, 1);
        var itemsWithAbsolutePositionAndQueryID = addQueryID(itemsWithAbsolutePosition, results.queryID);
        var transformedItems = transformItems(itemsWithAbsolutePositionAndQueryID, {
          results
        });
        return {
          items: transformedItems,
          widgetParams,
          sendEvent
        };
      },
      dispose: function dispose(_ref33) {
        var recommendState = _ref33.recommendState;
        unmountFn();
        return recommendState.removeParams(this.$$id);
      },
      getWidgetParameters: function getWidgetParameters(state) {
        return state.removeParams(this.$$id).addTrendingItems({
          facetName,
          facetValue,
          maxRecommendations: limit,
          threshold,
          fallbackParameters: _objectSpread87(_objectSpread87({}, fallbackParameters), escapeHTML ? TAG_PLACEHOLDER : {}),
          queryParameters: _objectSpread87(_objectSpread87({}, queryParameters), escapeHTML ? TAG_PLACEHOLDER : {}),
          $$id: this.$$id
        });
      }
    };
  };
};

// node_modules/instantsearch.js/es/widgets/trending-items/trending-items.js
function _typeof83(o4) {
  "@babel/helpers - typeof";
  return _typeof83 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof83(o4);
}
var _excluded40 = ["item", "sendEvent"];
function ownKeys88(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread88(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys88(Object(t4), true).forEach(function(r4) {
      _defineProperty83(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys88(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty83(obj, key2, value) {
  key2 = _toPropertyKey82(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey82(t4) {
  var i4 = _toPrimitive82(t4, "string");
  return "symbol" == _typeof83(i4) ? i4 : String(i4);
}
function _toPrimitive82(t4, r3) {
  if ("object" != _typeof83(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof83(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _objectWithoutProperties21(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose21(source, excluded);
  var key2, i4;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i4 = 0; i4 < sourceSymbolKeys.length; i4++) {
      key2 = sourceSymbolKeys[i4];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose21(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i4;
  for (i4 = 0; i4 < sourceKeys.length; i4++) {
    key2 = sourceKeys[i4];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function _extends26() {
  _extends26 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends26.apply(this, arguments);
}
var withUsage56 = createDocumentationMessageGenerator({
  name: "trending-items"
});
var TrendingItems = createTrendingItemsComponent({
  createElement: y2,
  Fragment: g2
});
function createRenderer2(_ref9) {
  var renderState = _ref9.renderState, cssClasses = _ref9.cssClasses, containerNode = _ref9.containerNode, templates = _ref9.templates;
  return function renderer55(_ref23, isFirstRendering) {
    var items = _ref23.items, results = _ref23.results, instantSearchInstance = _ref23.instantSearchInstance, sendEvent = _ref23.sendEvent;
    if (isFirstRendering) {
      renderState.templateProps = prepareTemplateProps({
        defaultTemplates: {},
        templatesConfig: instantSearchInstance.templatesConfig,
        templates
      });
      return;
    }
    var headerComponent = templates.header ? function(data) {
      return y2(Template_default, _extends26({}, renderState.templateProps, {
        templateKey: "header",
        rootTagName: "fragment",
        data: {
          cssClasses: data.classNames,
          items: data.items
        }
      }));
    } : void 0;
    var itemComponent = templates.item ? function(_ref33) {
      var item11 = _ref33.item, _sendEvent = _ref33.sendEvent, rootProps = _objectWithoutProperties21(_ref33, _excluded40);
      return y2(Template_default, _extends26({}, renderState.templateProps, {
        templateKey: "item",
        rootTagName: "fragment",
        data: item11,
        sendEvent: _sendEvent,
        rootProps: _objectSpread88({}, rootProps)
      }));
    } : void 0;
    var emptyComponent = templates.empty ? function() {
      return y2(Template_default, _extends26({}, renderState.templateProps, {
        templateKey: "empty",
        rootTagName: "fragment",
        data: results
      }));
    } : void 0;
    var layoutComponent = templates.layout ? function(data) {
      return y2(Template_default, _extends26({}, renderState.templateProps, {
        templateKey: "layout",
        rootTagName: "fragment",
        data: {
          sendEvent,
          items: data.items,
          templates: {
            item: templates.item ? function(_ref44) {
              var item11 = _ref44.item;
              return y2(Template_default, _extends26({}, renderState.templateProps, {
                templateKey: "item",
                rootTagName: "fragment",
                data: item11,
                sendEvent
              }));
            } : void 0
          },
          cssClasses: {
            list: data.classNames.list,
            item: data.classNames.item
          }
        },
        sendEvent
      }));
    } : void 0;
    N2(y2(TrendingItems, {
      items,
      sendEvent,
      classNames: cssClasses,
      headerComponent,
      itemComponent,
      emptyComponent,
      layout: layoutComponent,
      status: instantSearchInstance.status
    }), containerNode);
  };
}
var trending_items_default = function trendingItems(widgetParams) {
  var _ref52 = widgetParams || {}, container = _ref52.container, facetName = _ref52.facetName, facetValue = _ref52.facetValue, limit = _ref52.limit, queryParameters = _ref52.queryParameters, fallbackParameters = _ref52.fallbackParameters, threshold = _ref52.threshold, escapeHTML = _ref52.escapeHTML, transformItems = _ref52.transformItems, _ref5$templates = _ref52.templates, templates = _ref5$templates === void 0 ? {} : _ref5$templates, _ref5$cssClasses = _ref52.cssClasses, cssClasses = _ref5$cssClasses === void 0 ? {} : _ref5$cssClasses;
  if (!container) {
    throw new Error(withUsage56("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var specializedRenderer = createRenderer2({
    containerNode,
    cssClasses,
    renderState: {},
    templates
  });
  var makeWidget = connectTrendingItems_default(specializedRenderer, function() {
    return N2(null, containerNode);
  });
  var facetParameters = facetName && facetValue ? {
    facetName,
    facetValue
  } : {};
  return _objectSpread88(_objectSpread88({}, makeWidget(_objectSpread88(_objectSpread88({}, facetParameters), {}, {
    limit,
    queryParameters,
    fallbackParameters,
    threshold,
    escapeHTML,
    transformItems
  }))), {}, {
    $$widgetType: "ais.trendingItems"
  });
};

// node_modules/instantsearch.js/es/components/VoiceSearch/VoiceSearch.js
var VoiceSearch = function VoiceSearch2(_ref9) {
  var cssClasses = _ref9.cssClasses, isBrowserSupported = _ref9.isBrowserSupported, isListening = _ref9.isListening, toggleListening = _ref9.toggleListening, voiceListeningState = _ref9.voiceListeningState, templates = _ref9.templates;
  var handleClick3 = function handleClick4(event) {
    if (event.currentTarget instanceof HTMLElement) {
      event.currentTarget.blur();
    }
    toggleListening();
  };
  var status2 = voiceListeningState.status, transcript = voiceListeningState.transcript, isSpeechFinal = voiceListeningState.isSpeechFinal, errorCode = voiceListeningState.errorCode;
  return y2("div", {
    className: cssClasses.root
  }, y2(Template_default, {
    templateKey: "buttonText",
    rootTagName: "button",
    rootProps: {
      className: cssClasses.button,
      type: "button",
      title: "Search by voice".concat(isBrowserSupported ? "" : " (not supported on this browser)"),
      onClick: handleClick3,
      disabled: !isBrowserSupported
    },
    data: {
      status: status2,
      errorCode,
      isListening,
      transcript,
      isSpeechFinal,
      isBrowserSupported
    },
    templates
  }), y2(Template_default, {
    templateKey: "status",
    rootProps: {
      className: cssClasses.status
    },
    data: {
      status: status2,
      errorCode,
      isListening,
      transcript,
      isSpeechFinal,
      isBrowserSupported
    },
    templates
  }));
};
var VoiceSearch_default = VoiceSearch;

// node_modules/instantsearch.js/es/lib/voiceSearchHelper/index.js
function _typeof84(o4) {
  "@babel/helpers - typeof";
  return _typeof84 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof84(o4);
}
function ownKeys89(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread89(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys89(Object(t4), true).forEach(function(r4) {
      _defineProperty84(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys89(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty84(obj, key2, value) {
  key2 = _toPropertyKey83(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey83(t4) {
  var i4 = _toPrimitive83(t4, "string");
  return "symbol" == _typeof84(i4) ? i4 : String(i4);
}
function _toPrimitive83(t4, r3) {
  if ("object" != _typeof84(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof84(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var createVoiceSearchHelper = function createVoiceSearchHelper2(_ref9) {
  var searchAsYouSpeak = _ref9.searchAsYouSpeak, language = _ref9.language, onQueryChange = _ref9.onQueryChange, onStateChange = _ref9.onStateChange;
  var SpeechRecognitionAPI = window.webkitSpeechRecognition || window.SpeechRecognition;
  var getDefaultState = function getDefaultState2(status2) {
    return {
      status: status2,
      transcript: "",
      isSpeechFinal: false,
      errorCode: void 0
    };
  };
  var state = getDefaultState("initial");
  var recognition;
  var isBrowserSupported = function isBrowserSupported2() {
    return Boolean(SpeechRecognitionAPI);
  };
  var isListening = function isListening2() {
    return state.status === "askingPermission" || state.status === "waiting" || state.status === "recognizing";
  };
  var setState = function setState2() {
    var newState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    state = _objectSpread89(_objectSpread89({}, state), newState);
    onStateChange();
  };
  var getState = function getState2() {
    return state;
  };
  var resetState = function resetState2() {
    var status2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "initial";
    setState(getDefaultState(status2));
  };
  var onStart = function onStart2() {
    setState({
      status: "waiting"
    });
  };
  var onError = function onError2(event) {
    setState({
      status: "error",
      errorCode: event.error
    });
  };
  var onResult = function onResult2(event) {
    setState({
      status: "recognizing",
      transcript: event.results[0] && event.results[0][0] && event.results[0][0].transcript || "",
      isSpeechFinal: event.results[0] && event.results[0].isFinal
    });
    if (searchAsYouSpeak && state.transcript) {
      onQueryChange(state.transcript);
    }
  };
  var onEnd = function onEnd2() {
    if (!state.errorCode && state.transcript && !searchAsYouSpeak) {
      onQueryChange(state.transcript);
    }
    if (state.status !== "error") {
      setState({
        status: "finished"
      });
    }
  };
  var startListening = function startListening2() {
    recognition = new SpeechRecognitionAPI();
    if (!recognition) {
      return;
    }
    resetState("askingPermission");
    recognition.interimResults = true;
    if (language) {
      recognition.lang = language;
    }
    recognition.addEventListener("start", onStart);
    recognition.addEventListener("error", onError);
    recognition.addEventListener("result", onResult);
    recognition.addEventListener("end", onEnd);
    recognition.start();
  };
  var dispose = function dispose2() {
    if (!recognition) {
      return;
    }
    recognition.stop();
    recognition.removeEventListener("start", onStart);
    recognition.removeEventListener("error", onError);
    recognition.removeEventListener("result", onResult);
    recognition.removeEventListener("end", onEnd);
    recognition = void 0;
  };
  var stopListening = function stopListening2() {
    dispose();
    resetState("finished");
  };
  return {
    getState,
    isBrowserSupported,
    isListening,
    startListening,
    stopListening,
    dispose
  };
};
var voiceSearchHelper_default = createVoiceSearchHelper;

// node_modules/instantsearch.js/es/connectors/voice-search/connectVoiceSearch.js
function _typeof85(o4) {
  "@babel/helpers - typeof";
  return _typeof85 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof85(o4);
}
function ownKeys90(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread90(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys90(Object(t4), true).forEach(function(r4) {
      _defineProperty85(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys90(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty85(obj, key2, value) {
  key2 = _toPropertyKey84(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey84(t4) {
  var i4 = _toPrimitive84(t4, "string");
  return "symbol" == _typeof85(i4) ? i4 : String(i4);
}
function _toPrimitive84(t4, r3) {
  if ("object" != _typeof85(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof85(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage57 = createDocumentationMessageGenerator({
  name: "voice-search",
  connector: true
});
var connectVoiceSearch = function connectVoiceSearch2(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage57());
  return function(widgetParams) {
    var _widgetParams$searchA = widgetParams.searchAsYouSpeak, searchAsYouSpeak = _widgetParams$searchA === void 0 ? false : _widgetParams$searchA, language = widgetParams.language, additionalQueryParameters = widgetParams.additionalQueryParameters, _widgetParams$createV = widgetParams.createVoiceSearchHelper, createVoiceSearchHelper3 = _widgetParams$createV === void 0 ? voiceSearchHelper_default : _widgetParams$createV;
    return {
      $$type: "ais.voiceSearch",
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(_objectSpread90(_objectSpread90({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(_objectSpread90(_objectSpread90({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance
        }), false);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return _objectSpread90(_objectSpread90({}, renderState), {}, {
          voiceSearch: this.getWidgetRenderState(renderOptions)
        });
      },
      getWidgetRenderState: function getWidgetRenderState(renderOptions) {
        var _this = this;
        var helper = renderOptions.helper, instantSearchInstance = renderOptions.instantSearchInstance;
        if (!this._refine) {
          this._refine = function(query) {
            if (query !== helper.state.query) {
              var queryLanguages = language ? [language.split("-")[0]] : void 0;
              helper.setQueryParameter("queryLanguages", queryLanguages);
              if (typeof additionalQueryParameters === "function") {
                helper.setState(helper.state.setQueryParameters(_objectSpread90({
                  ignorePlurals: true,
                  removeStopWords: true,
                  // @ts-ignore optionalWords is allowed to be a string too
                  optionalWords: query
                }, additionalQueryParameters({
                  query
                }))));
              }
              helper.setQuery(query).search();
            }
          };
        }
        if (!this._voiceSearchHelper) {
          this._voiceSearchHelper = createVoiceSearchHelper3({
            searchAsYouSpeak,
            language,
            onQueryChange: function onQueryChange(query) {
              return _this._refine(query);
            },
            onStateChange: function onStateChange() {
              renderFn(_objectSpread90(_objectSpread90({}, _this.getWidgetRenderState(renderOptions)), {}, {
                instantSearchInstance
              }), false);
            }
          });
        }
        var _voiceSearchHelper = this._voiceSearchHelper, isBrowserSupported = _voiceSearchHelper.isBrowserSupported, isListening = _voiceSearchHelper.isListening, startListening = _voiceSearchHelper.startListening, stopListening = _voiceSearchHelper.stopListening, getState = _voiceSearchHelper.getState;
        return {
          isBrowserSupported: isBrowserSupported(),
          isListening: isListening(),
          toggleListening: function toggleListening() {
            if (!isBrowserSupported()) {
              return;
            }
            if (isListening()) {
              stopListening();
            } else {
              startListening();
            }
          },
          voiceListeningState: getState(),
          widgetParams
        };
      },
      dispose: function dispose(_ref9) {
        var state = _ref9.state;
        this._voiceSearchHelper.dispose();
        unmountFn();
        var newState = state;
        if (typeof additionalQueryParameters === "function") {
          var additional = additionalQueryParameters({
            query: ""
          });
          var toReset = additional ? Object.keys(additional).reduce(function(acc, current) {
            acc[current] = void 0;
            return acc;
          }, {}) : {};
          newState = state.setQueryParameters(_objectSpread90({
            // @ts-ignore (queryLanguages is not added to algoliasearch v3)
            queryLanguages: void 0,
            ignorePlurals: void 0,
            removeStopWords: void 0,
            optionalWords: void 0
          }, toReset));
        }
        return newState.setQueryParameter("query", void 0);
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref23) {
        var searchParameters = _ref23.searchParameters;
        var query = searchParameters.query || "";
        if (!query) {
          return uiState;
        }
        return _objectSpread90(_objectSpread90({}, uiState), {}, {
          query
        });
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref33) {
        var uiState = _ref33.uiState;
        return searchParameters.setQueryParameter("query", uiState.query || "");
      }
    };
  };
};
var connectVoiceSearch_default = connectVoiceSearch;

// node_modules/instantsearch.js/es/widgets/voice-search/defaultTemplates.js
var _ref22 = y2(g2, null, y2("line", {
  x1: "1",
  y1: "1",
  x2: "23",
  y2: "23"
}), y2("path", {
  d: "M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"
}), y2("path", {
  d: "M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"
}), y2("line", {
  x1: "12",
  y1: "19",
  x2: "12",
  y2: "23"
}), y2("line", {
  x1: "8",
  y1: "23",
  x2: "16",
  y2: "23"
}));
var _ref32 = y2("path", {
  d: "M19 10v2a7 7 0 0 1-14 0v-2"
});
var _ref43 = y2("line", {
  x1: "12",
  y1: "19",
  x2: "12",
  y2: "23"
});
var _ref5 = y2("line", {
  x1: "8",
  y1: "23",
  x2: "16",
  y2: "23"
});
var ButtonInnerElement = function ButtonInnerElement2(_ref9) {
  var status2 = _ref9.status, errorCode = _ref9.errorCode, isListening = _ref9.isListening;
  if (status2 === "error" && errorCode === "not-allowed") {
    return _ref22;
  }
  return y2(g2, null, y2("path", {
    d: "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z",
    fill: isListening ? "currentColor" : "none"
  }), _ref32, _ref43, _ref5);
};
var defaultTemplates19 = {
  buttonText: function buttonText(_ref64) {
    var status2 = _ref64.status, errorCode = _ref64.errorCode, isListening = _ref64.isListening;
    return y2("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
      /* eslint-enable react/no-unknown-property */
    }, y2(ButtonInnerElement, {
      status: status2,
      errorCode,
      isListening
    }));
  },
  status: function status(_ref72) {
    var transcript = _ref72.transcript;
    return y2("p", null, transcript);
  }
};
var defaultTemplates_default16 = defaultTemplates19;

// node_modules/instantsearch.js/es/widgets/voice-search/voice-search.js
function _typeof86(o4) {
  "@babel/helpers - typeof";
  return _typeof86 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof86(o4);
}
function ownKeys91(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread91(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys91(Object(t4), true).forEach(function(r4) {
      _defineProperty86(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys91(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty86(obj, key2, value) {
  key2 = _toPropertyKey85(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey85(t4) {
  var i4 = _toPrimitive85(t4, "string");
  return "symbol" == _typeof86(i4) ? i4 : String(i4);
}
function _toPrimitive85(t4, r3) {
  if ("object" != _typeof86(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof86(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage58 = createDocumentationMessageGenerator({
  name: "voice-search"
});
var suit26 = component("VoiceSearch");
var renderer51 = function renderer52(_ref9) {
  var containerNode = _ref9.containerNode, cssClasses = _ref9.cssClasses, templates = _ref9.templates;
  return function(_ref23) {
    var isBrowserSupported = _ref23.isBrowserSupported, isListening = _ref23.isListening, toggleListening = _ref23.toggleListening, voiceListeningState = _ref23.voiceListeningState;
    N2(y2(VoiceSearch_default, {
      cssClasses,
      templates,
      isBrowserSupported,
      isListening,
      toggleListening,
      voiceListeningState
    }), containerNode);
  };
};
var voiceSearch = function voiceSearch2(widgetParams) {
  var _ref33 = widgetParams || {}, container = _ref33.container, _ref3$cssClasses = _ref33.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses, _ref3$templates = _ref33.templates, userTemplates = _ref3$templates === void 0 ? {} : _ref3$templates, _ref3$searchAsYouSpea = _ref33.searchAsYouSpeak, searchAsYouSpeak = _ref3$searchAsYouSpea === void 0 ? false : _ref3$searchAsYouSpea, language = _ref33.language, additionalQueryParameters = _ref33.additionalQueryParameters, createVoiceSearchHelper3 = _ref33.createVoiceSearchHelper;
  if (!container) {
    throw new Error(withUsage58("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var cssClasses = {
    root: cx(suit26(), userCssClasses.root),
    button: cx(suit26({
      descendantName: "button"
    }), userCssClasses.button),
    status: cx(suit26({
      descendantName: "status"
    }), userCssClasses.status)
  };
  var templates = _objectSpread91(_objectSpread91({}, defaultTemplates_default16), userTemplates);
  var specializedRenderer = renderer51({
    containerNode,
    cssClasses,
    templates
  });
  var makeWidget = connectVoiceSearch_default(specializedRenderer, function() {
    return N2(null, containerNode);
  });
  return _objectSpread91(_objectSpread91({}, makeWidget({
    container: containerNode,
    cssClasses,
    templates,
    searchAsYouSpeak,
    language,
    additionalQueryParameters,
    createVoiceSearchHelper: createVoiceSearchHelper3
  })), {}, {
    $$widgetType: "ais.voiceSearch"
  });
};
var voice_search_default = voiceSearch;

// node_modules/instantsearch.js/es/connectors/frequently-bought-together/connectFrequentlyBoughtTogether.js
function _typeof87(o4) {
  "@babel/helpers - typeof";
  return _typeof87 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof87(o4);
}
function ownKeys92(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread92(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys92(Object(t4), true).forEach(function(r4) {
      _defineProperty87(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys92(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty87(obj, key2, value) {
  key2 = _toPropertyKey86(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey86(t4) {
  var i4 = _toPrimitive86(t4, "string");
  return "symbol" == _typeof87(i4) ? i4 : String(i4);
}
function _toPrimitive86(t4, r3) {
  if ("object" != _typeof87(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof87(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage59 = createDocumentationMessageGenerator({
  name: "frequently-bought-together",
  connector: true
});
var connectFrequentlyBoughtTogether_default = function connectFrequentlyBoughtTogether(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage59());
  return function(widgetParams) {
    var _ref9 = widgetParams || {}, _ref$escapeHTML = _ref9.escapeHTML, escapeHTML = _ref$escapeHTML === void 0 ? true : _ref$escapeHTML, _ref$transformItems = _ref9.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
      return items;
    } : _ref$transformItems, objectIDs = _ref9.objectIDs, limit = _ref9.limit, threshold = _ref9.threshold, queryParameters = _ref9.queryParameters;
    if (!objectIDs || objectIDs.length === 0) {
      throw new Error(withUsage59("The `objectIDs` option is required."));
    }
    var sendEvent;
    return {
      dependsOn: "recommend",
      $$type: "ais.frequentlyBoughtTogether",
      init: function init(initOptions) {
        renderFn(_objectSpread92(_objectSpread92({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: initOptions.instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var renderState = this.getWidgetRenderState(renderOptions);
        renderFn(_objectSpread92(_objectSpread92({}, renderState), {}, {
          instantSearchInstance: renderOptions.instantSearchInstance
        }), false);
      },
      getRenderState: function getRenderState(renderState) {
        return renderState;
      },
      getWidgetRenderState: function getWidgetRenderState(_ref23) {
        var results = _ref23.results, helper = _ref23.helper, instantSearchInstance = _ref23.instantSearchInstance;
        if (!sendEvent) {
          sendEvent = createSendEventForHits({
            instantSearchInstance,
            helper,
            widgetType: this.$$type
          });
        }
        if (results === null || results === void 0) {
          return {
            items: [],
            widgetParams,
            sendEvent
          };
        }
        if (escapeHTML && results.hits.length > 0) {
          results.hits = escapeHits(results.hits);
        }
        var itemsWithAbsolutePosition = addAbsolutePosition(results.hits, 0, 1);
        var itemsWithAbsolutePositionAndQueryID = addQueryID(itemsWithAbsolutePosition, results.queryID);
        var transformedItems = transformItems(itemsWithAbsolutePositionAndQueryID, {
          results
        });
        return {
          items: transformedItems,
          widgetParams,
          sendEvent
        };
      },
      dispose: function dispose(_ref33) {
        var recommendState = _ref33.recommendState;
        unmountFn();
        return recommendState.removeParams(this.$$id);
      },
      getWidgetParameters: function getWidgetParameters(state) {
        var _this = this;
        return objectIDs.reduce(function(acc, objectID) {
          return acc.addFrequentlyBoughtTogether({
            objectID,
            threshold,
            maxRecommendations: limit,
            queryParameters: _objectSpread92(_objectSpread92({}, queryParameters), escapeHTML ? TAG_PLACEHOLDER : {}),
            $$id: _this.$$id
          });
        }, state.removeParams(this.$$id));
      }
    };
  };
};

// node_modules/instantsearch.js/es/widgets/frequently-bought-together/frequently-bought-together.js
function _typeof88(o4) {
  "@babel/helpers - typeof";
  return _typeof88 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof88(o4);
}
var _excluded41 = ["item", "sendEvent"];
function ownKeys93(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread93(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys93(Object(t4), true).forEach(function(r4) {
      _defineProperty88(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys93(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty88(obj, key2, value) {
  key2 = _toPropertyKey87(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey87(t4) {
  var i4 = _toPrimitive87(t4, "string");
  return "symbol" == _typeof88(i4) ? i4 : String(i4);
}
function _toPrimitive87(t4, r3) {
  if ("object" != _typeof88(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof88(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _objectWithoutProperties22(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose22(source, excluded);
  var key2, i4;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i4 = 0; i4 < sourceSymbolKeys.length; i4++) {
      key2 = sourceSymbolKeys[i4];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose22(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i4;
  for (i4 = 0; i4 < sourceKeys.length; i4++) {
    key2 = sourceKeys[i4];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function _extends27() {
  _extends27 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends27.apply(this, arguments);
}
var withUsage60 = createDocumentationMessageGenerator({
  name: "frequently-bought-together"
});
var FrequentlyBoughtTogether = createFrequentlyBoughtTogetherComponent({
  createElement: y2,
  Fragment: g2
});
var renderer53 = function renderer54(_ref9) {
  var renderState = _ref9.renderState, cssClasses = _ref9.cssClasses, containerNode = _ref9.containerNode, templates = _ref9.templates;
  return function(_ref23, isFirstRendering) {
    var items = _ref23.items, results = _ref23.results, instantSearchInstance = _ref23.instantSearchInstance, sendEvent = _ref23.sendEvent;
    if (isFirstRendering) {
      renderState.templateProps = prepareTemplateProps({
        defaultTemplates: {},
        templatesConfig: instantSearchInstance.templatesConfig,
        templates
      });
      return;
    }
    var headerComponent = templates.header ? function(data) {
      return y2(Template_default, _extends27({}, renderState.templateProps, {
        templateKey: "header",
        rootTagName: "fragment",
        data: {
          cssClasses: data.classNames,
          items: data.items
        }
      }));
    } : void 0;
    var itemComponent = templates.item ? function(_ref33) {
      var item11 = _ref33.item, _sendEvent = _ref33.sendEvent, rootProps = _objectWithoutProperties22(_ref33, _excluded41);
      return y2(Template_default, _extends27({}, renderState.templateProps, {
        templateKey: "item",
        rootTagName: "fragment",
        data: item11,
        sendEvent: _sendEvent,
        rootProps: _objectSpread93({}, rootProps)
      }));
    } : void 0;
    var emptyComponent = templates.empty ? function() {
      return y2(Template_default, _extends27({}, renderState.templateProps, {
        templateKey: "empty",
        rootTagName: "fragment",
        data: results
      }));
    } : void 0;
    var layoutComponent = templates.layout ? function(data) {
      return y2(Template_default, _extends27({}, renderState.templateProps, {
        templateKey: "layout",
        rootTagName: "fragment",
        data: {
          sendEvent,
          items: data.items,
          templates: {
            item: templates.item ? function(_ref44) {
              var item11 = _ref44.item;
              return y2(Template_default, _extends27({}, renderState.templateProps, {
                templateKey: "item",
                rootTagName: "fragment",
                data: item11,
                sendEvent
              }));
            } : void 0
          },
          cssClasses: {
            list: data.classNames.list,
            item: data.classNames.item
          }
        },
        sendEvent
      }));
    } : void 0;
    N2(y2(FrequentlyBoughtTogether, {
      items,
      headerComponent,
      itemComponent,
      sendEvent,
      classNames: cssClasses,
      emptyComponent,
      layout: layoutComponent,
      status: instantSearchInstance.status
    }), containerNode);
  };
};
var frequently_bought_together_default = function frequentlyBoughtTogether(widgetParams) {
  var _ref52 = widgetParams || {}, container = _ref52.container, objectIDs = _ref52.objectIDs, limit = _ref52.limit, queryParameters = _ref52.queryParameters, threshold = _ref52.threshold, escapeHTML = _ref52.escapeHTML, transformItems = _ref52.transformItems, _ref5$templates = _ref52.templates, templates = _ref5$templates === void 0 ? {} : _ref5$templates, _ref5$cssClasses = _ref52.cssClasses, cssClasses = _ref5$cssClasses === void 0 ? {} : _ref5$cssClasses;
  if (!container) {
    throw new Error(withUsage60("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var specializedRenderer = renderer53({
    containerNode,
    cssClasses,
    renderState: {},
    templates
  });
  var makeWidget = connectFrequentlyBoughtTogether_default(specializedRenderer, function() {
    return N2(null, containerNode);
  });
  return _objectSpread93(_objectSpread93({}, makeWidget({
    objectIDs,
    limit,
    queryParameters,
    threshold,
    escapeHTML,
    transformItems
  })), {}, {
    $$widgetType: "ais.frequentlyBoughtTogether"
  });
};

// node_modules/instantsearch.js/es/connectors/looking-similar/connectLookingSimilar.js
function _typeof89(o4) {
  "@babel/helpers - typeof";
  return _typeof89 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof89(o4);
}
function ownKeys94(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread94(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys94(Object(t4), true).forEach(function(r4) {
      _defineProperty89(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys94(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty89(obj, key2, value) {
  key2 = _toPropertyKey88(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey88(t4) {
  var i4 = _toPrimitive88(t4, "string");
  return "symbol" == _typeof89(i4) ? i4 : String(i4);
}
function _toPrimitive88(t4, r3) {
  if ("object" != _typeof89(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof89(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var withUsage61 = createDocumentationMessageGenerator({
  name: "looking-similar",
  connector: true
});
var connectLookingSimilar_default = function connectLookingSimilar(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage61());
  return function(widgetParams) {
    var _ref9 = widgetParams || {}, _ref$escapeHTML = _ref9.escapeHTML, escapeHTML = _ref$escapeHTML === void 0 ? true : _ref$escapeHTML, objectIDs = _ref9.objectIDs, limit = _ref9.limit, threshold = _ref9.threshold, fallbackParameters = _ref9.fallbackParameters, queryParameters = _ref9.queryParameters, _ref$transformItems = _ref9.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
      return items;
    } : _ref$transformItems;
    if (!objectIDs || objectIDs.length === 0) {
      throw new Error(withUsage61("The `objectIDs` option is required."));
    }
    var sendEvent;
    return {
      dependsOn: "recommend",
      $$type: "ais.lookingSimilar",
      init: function init(initOptions) {
        renderFn(_objectSpread94(_objectSpread94({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: initOptions.instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var renderState = this.getWidgetRenderState(renderOptions);
        renderFn(_objectSpread94(_objectSpread94({}, renderState), {}, {
          instantSearchInstance: renderOptions.instantSearchInstance
        }), false);
      },
      getRenderState: function getRenderState(renderState) {
        return renderState;
      },
      getWidgetRenderState: function getWidgetRenderState(_ref23) {
        var results = _ref23.results, helper = _ref23.helper, instantSearchInstance = _ref23.instantSearchInstance;
        if (!sendEvent) {
          sendEvent = createSendEventForHits({
            instantSearchInstance,
            helper,
            widgetType: this.$$type
          });
        }
        if (results === null || results === void 0) {
          return {
            items: [],
            widgetParams,
            sendEvent
          };
        }
        if (escapeHTML && results.hits.length > 0) {
          results.hits = escapeHits(results.hits);
        }
        var itemsWithAbsolutePosition = addAbsolutePosition(results.hits, 0, 1);
        var itemsWithAbsolutePositionAndQueryID = addQueryID(itemsWithAbsolutePosition, results.queryID);
        var transformedItems = transformItems(itemsWithAbsolutePositionAndQueryID, {
          results
        });
        return {
          items: transformedItems,
          widgetParams,
          sendEvent
        };
      },
      dispose: function dispose(_ref33) {
        var recommendState = _ref33.recommendState;
        unmountFn();
        return recommendState.removeParams(this.$$id);
      },
      getWidgetParameters: function getWidgetParameters(state) {
        var _this = this;
        return objectIDs.reduce(function(acc, objectID) {
          return acc.addLookingSimilar({
            objectID,
            maxRecommendations: limit,
            threshold,
            fallbackParameters: _objectSpread94(_objectSpread94({}, fallbackParameters), escapeHTML ? TAG_PLACEHOLDER : {}),
            queryParameters: _objectSpread94(_objectSpread94({}, queryParameters), escapeHTML ? TAG_PLACEHOLDER : {}),
            $$id: _this.$$id
          });
        }, state.removeParams(this.$$id));
      }
    };
  };
};

// node_modules/instantsearch.js/es/widgets/looking-similar/looking-similar.js
function _typeof90(o4) {
  "@babel/helpers - typeof";
  return _typeof90 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof90(o4);
}
var _excluded42 = ["item", "sendEvent"];
function ownKeys95(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread95(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys95(Object(t4), true).forEach(function(r4) {
      _defineProperty90(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys95(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty90(obj, key2, value) {
  key2 = _toPropertyKey89(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey89(t4) {
  var i4 = _toPrimitive89(t4, "string");
  return "symbol" == _typeof90(i4) ? i4 : String(i4);
}
function _toPrimitive89(t4, r3) {
  if ("object" != _typeof90(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof90(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _objectWithoutProperties23(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose23(source, excluded);
  var key2, i4;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i4 = 0; i4 < sourceSymbolKeys.length; i4++) {
      key2 = sourceSymbolKeys[i4];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose23(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i4;
  for (i4 = 0; i4 < sourceKeys.length; i4++) {
    key2 = sourceKeys[i4];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function _extends28() {
  _extends28 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends28.apply(this, arguments);
}
var withUsage62 = createDocumentationMessageGenerator({
  name: "looking-similar"
});
var LookingSimilar = createLookingSimilarComponent({
  createElement: y2,
  Fragment: g2
});
function createRenderer3(_ref9) {
  var renderState = _ref9.renderState, cssClasses = _ref9.cssClasses, containerNode = _ref9.containerNode, templates = _ref9.templates;
  return function(_ref23, isFirstRendering) {
    var items = _ref23.items, results = _ref23.results, instantSearchInstance = _ref23.instantSearchInstance, sendEvent = _ref23.sendEvent;
    if (isFirstRendering) {
      renderState.templateProps = prepareTemplateProps({
        defaultTemplates: {},
        templatesConfig: instantSearchInstance.templatesConfig,
        templates
      });
      return;
    }
    var headerComponent = templates.header ? function(data) {
      return y2(Template_default, _extends28({}, renderState.templateProps, {
        templateKey: "header",
        rootTagName: "fragment",
        data: {
          cssClasses: data.classNames,
          items: data.items
        }
      }));
    } : void 0;
    var itemComponent = templates.item ? function(_ref33) {
      var item11 = _ref33.item, _sendEvent = _ref33.sendEvent, rootProps = _objectWithoutProperties23(_ref33, _excluded42);
      return y2(Template_default, _extends28({}, renderState.templateProps, {
        templateKey: "item",
        rootTagName: "fragment",
        data: item11,
        sendEvent: _sendEvent,
        rootProps: _objectSpread95({}, rootProps)
      }));
    } : void 0;
    var emptyComponent = templates.empty ? function() {
      return y2(Template_default, _extends28({}, renderState.templateProps, {
        templateKey: "empty",
        rootTagName: "fragment",
        data: results
      }));
    } : void 0;
    var layoutComponent = templates.layout ? function(data) {
      return y2(Template_default, _extends28({}, renderState.templateProps, {
        templateKey: "layout",
        rootTagName: "fragment",
        data: {
          sendEvent,
          items: data.items,
          templates: {
            item: templates.item ? function(_ref44) {
              var item11 = _ref44.item;
              return y2(Template_default, _extends28({}, renderState.templateProps, {
                templateKey: "item",
                rootTagName: "fragment",
                data: item11,
                sendEvent
              }));
            } : void 0
          },
          cssClasses: {
            list: data.classNames.list,
            item: data.classNames.item
          }
        },
        sendEvent
      }));
    } : void 0;
    N2(y2(LookingSimilar, {
      items,
      headerComponent,
      itemComponent,
      sendEvent: function sendEvent2() {
      },
      classNames: cssClasses,
      emptyComponent,
      layout: layoutComponent,
      status: instantSearchInstance.status
    }), containerNode);
  };
}
var looking_similar_default = function lookingSimilar(widgetParams) {
  var _ref52 = widgetParams || {}, container = _ref52.container, objectIDs = _ref52.objectIDs, limit = _ref52.limit, queryParameters = _ref52.queryParameters, fallbackParameters = _ref52.fallbackParameters, threshold = _ref52.threshold, escapeHTML = _ref52.escapeHTML, transformItems = _ref52.transformItems, _ref5$templates = _ref52.templates, templates = _ref5$templates === void 0 ? {} : _ref5$templates, _ref5$cssClasses = _ref52.cssClasses, cssClasses = _ref5$cssClasses === void 0 ? {} : _ref5$cssClasses;
  if (!container) {
    throw new Error(withUsage62("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var specializedRenderer = createRenderer3({
    containerNode,
    cssClasses,
    renderState: {},
    templates
  });
  var makeWidget = connectLookingSimilar_default(specializedRenderer, function() {
    return N2(null, containerNode);
  });
  return _objectSpread95(_objectSpread95({}, makeWidget({
    objectIDs,
    limit,
    queryParameters,
    fallbackParameters,
    threshold,
    escapeHTML,
    transformItems
  })), {}, {
    $$widgetType: "ais.lookingSimilar"
  });
};

// node_modules/@ai-sdk/provider/dist/index.mjs
var marker = "vercel.ai.error";
var symbol = Symbol.for(marker);
var _a;
var _AISDKError = class _AISDKError2 extends Error {
  /**
   * Creates an AI SDK Error.
   *
   * @param {Object} params - The parameters for creating the error.
   * @param {string} params.name - The name of the error.
   * @param {string} params.message - The error message.
   * @param {unknown} [params.cause] - The underlying cause of the error.
   */
  constructor({
    name: name143,
    message,
    cause
  }) {
    super(message);
    this[_a] = true;
    this.name = name143;
    this.cause = cause;
  }
  /**
   * Checks if the given error is an AI SDK Error.
   * @param {unknown} error - The error to check.
   * @returns {boolean} True if the error is an AI SDK Error, false otherwise.
   */
  static isInstance(error40) {
    return _AISDKError2.hasMarker(error40, marker);
  }
  static hasMarker(error40, marker153) {
    const markerSymbol = Symbol.for(marker153);
    return error40 != null && typeof error40 === "object" && markerSymbol in error40 && typeof error40[markerSymbol] === "boolean" && error40[markerSymbol] === true;
  }
};
_a = symbol;
var AISDKError = _AISDKError;
var name = "AI_APICallError";
var marker2 = "vercel.ai.error.".concat(name);
var symbol2 = Symbol.for(marker2);
var _a2;
var APICallError = class extends AISDKError {
  constructor({
    message,
    url: url2,
    requestBodyValues,
    statusCode,
    responseHeaders,
    responseBody,
    cause,
    isRetryable = statusCode != null && (statusCode === 408 || // request timeout
    statusCode === 409 || // conflict
    statusCode === 429 || // too many requests
    statusCode >= 500),
    // server error
    data
  }) {
    super({ name, message, cause });
    this[_a2] = true;
    this.url = url2;
    this.requestBodyValues = requestBodyValues;
    this.statusCode = statusCode;
    this.responseHeaders = responseHeaders;
    this.responseBody = responseBody;
    this.isRetryable = isRetryable;
    this.data = data;
  }
  static isInstance(error40) {
    return AISDKError.hasMarker(error40, marker2);
  }
};
_a2 = symbol2;
var name2 = "AI_EmptyResponseBodyError";
var marker3 = "vercel.ai.error.".concat(name2);
var symbol3 = Symbol.for(marker3);
var _a3;
var EmptyResponseBodyError = class extends AISDKError {
  // used in isInstance
  constructor({ message = "Empty response body" } = {}) {
    super({ name: name2, message });
    this[_a3] = true;
  }
  static isInstance(error40) {
    return AISDKError.hasMarker(error40, marker3);
  }
};
_a3 = symbol3;
function getErrorMessage(error40) {
  if (error40 == null) {
    return "unknown error";
  }
  if (typeof error40 === "string") {
    return error40;
  }
  if (error40 instanceof Error) {
    return error40.message;
  }
  return JSON.stringify(error40);
}
var name3 = "AI_InvalidArgumentError";
var marker4 = "vercel.ai.error.".concat(name3);
var symbol4 = Symbol.for(marker4);
var _a4;
var InvalidArgumentError = class extends AISDKError {
  constructor({
    message,
    cause,
    argument
  }) {
    super({ name: name3, message, cause });
    this[_a4] = true;
    this.argument = argument;
  }
  static isInstance(error40) {
    return AISDKError.hasMarker(error40, marker4);
  }
};
_a4 = symbol4;
var name4 = "AI_InvalidPromptError";
var marker5 = "vercel.ai.error.".concat(name4);
var symbol5 = Symbol.for(marker5);
var _a5;
_a5 = symbol5;
var name5 = "AI_InvalidResponseDataError";
var marker6 = "vercel.ai.error.".concat(name5);
var symbol6 = Symbol.for(marker6);
var _a6;
_a6 = symbol6;
var name6 = "AI_JSONParseError";
var marker7 = "vercel.ai.error.".concat(name6);
var symbol7 = Symbol.for(marker7);
var _a7;
var JSONParseError = class extends AISDKError {
  constructor({ text: text4, cause }) {
    super({
      name: name6,
      message: "JSON parsing failed: Text: ".concat(text4, ".\nError message: ").concat(getErrorMessage(cause)),
      cause
    });
    this[_a7] = true;
    this.text = text4;
  }
  static isInstance(error40) {
    return AISDKError.hasMarker(error40, marker7);
  }
};
_a7 = symbol7;
var name7 = "AI_LoadAPIKeyError";
var marker8 = "vercel.ai.error.".concat(name7);
var symbol8 = Symbol.for(marker8);
var _a8;
_a8 = symbol8;
var name8 = "AI_LoadSettingError";
var marker9 = "vercel.ai.error.".concat(name8);
var symbol9 = Symbol.for(marker9);
var _a9;
_a9 = symbol9;
var name9 = "AI_NoContentGeneratedError";
var marker10 = "vercel.ai.error.".concat(name9);
var symbol10 = Symbol.for(marker10);
var _a10;
_a10 = symbol10;
var name10 = "AI_NoSuchModelError";
var marker11 = "vercel.ai.error.".concat(name10);
var symbol11 = Symbol.for(marker11);
var _a11;
var NoSuchModelError = class extends AISDKError {
  constructor({
    errorName = name10,
    modelId,
    modelType,
    message = "No such ".concat(modelType, ": ").concat(modelId)
  }) {
    super({ name: errorName, message });
    this[_a11] = true;
    this.modelId = modelId;
    this.modelType = modelType;
  }
  static isInstance(error40) {
    return AISDKError.hasMarker(error40, marker11);
  }
};
_a11 = symbol11;
var name11 = "AI_TooManyEmbeddingValuesForCallError";
var marker12 = "vercel.ai.error.".concat(name11);
var symbol12 = Symbol.for(marker12);
var _a12;
_a12 = symbol12;
var name12 = "AI_TypeValidationError";
var marker13 = "vercel.ai.error.".concat(name12);
var symbol13 = Symbol.for(marker13);
var _a13;
var _TypeValidationError = class _TypeValidationError2 extends AISDKError {
  constructor({ value, cause }) {
    super({
      name: name12,
      message: "Type validation failed: Value: ".concat(JSON.stringify(value), ".\nError message: ").concat(getErrorMessage(cause)),
      cause
    });
    this[_a13] = true;
    this.value = value;
  }
  static isInstance(error40) {
    return AISDKError.hasMarker(error40, marker13);
  }
  /**
   * Wraps an error into a TypeValidationError.
   * If the cause is already a TypeValidationError with the same value, it returns the cause.
   * Otherwise, it creates a new TypeValidationError.
   *
   * @param {Object} params - The parameters for wrapping the error.
   * @param {unknown} params.value - The value that failed validation.
   * @param {unknown} params.cause - The original error or cause of the validation failure.
   * @returns {TypeValidationError} A TypeValidationError instance.
   */
  static wrap({
    value,
    cause
  }) {
    return _TypeValidationError2.isInstance(cause) && cause.value === value ? cause : new _TypeValidationError2({ value, cause });
  }
};
_a13 = symbol13;
var TypeValidationError = _TypeValidationError;
var name13 = "AI_UnsupportedFunctionalityError";
var marker14 = "vercel.ai.error.".concat(name13);
var symbol14 = Symbol.for(marker14);
var _a14;
_a14 = symbol14;

// node_modules/eventsource-parser/dist/index.js
var ParseError = class extends Error {
  constructor(message, options) {
    super(message), this.name = "ParseError", this.type = options.type, this.field = options.field, this.value = options.value, this.line = options.line;
  }
};
function noop2(_arg) {
}
function createParser(callbacks) {
  if (typeof callbacks == "function")
    throw new TypeError(
      "`callbacks` must be an object, got a function instead. Did you mean `{onEvent: fn}`?"
    );
  const { onEvent = noop2, onError = noop2, onRetry = noop2, onComment } = callbacks;
  let incompleteLine = "", isFirstChunk = true, id, data = "", eventType = "";
  function feed(newChunk) {
    const chunk2 = isFirstChunk ? newChunk.replace(/^\xEF\xBB\xBF/, "") : newChunk, [complete, incomplete] = splitLines("".concat(incompleteLine).concat(chunk2));
    for (const line of complete)
      parseLine(line);
    incompleteLine = incomplete, isFirstChunk = false;
  }
  function parseLine(line) {
    if (line === "") {
      dispatchEvent();
      return;
    }
    if (line.startsWith(":")) {
      onComment && onComment(line.slice(line.startsWith(": ") ? 2 : 1));
      return;
    }
    const fieldSeparatorIndex = line.indexOf(":");
    if (fieldSeparatorIndex !== -1) {
      const field = line.slice(0, fieldSeparatorIndex), offset = line[fieldSeparatorIndex + 1] === " " ? 2 : 1, value = line.slice(fieldSeparatorIndex + offset);
      processField(field, value, line);
      return;
    }
    processField(line, "", line);
  }
  function processField(field, value, line) {
    switch (field) {
      case "event":
        eventType = value;
        break;
      case "data":
        data = "".concat(data).concat(value, "\n");
        break;
      case "id":
        id = value.includes("\0") ? void 0 : value;
        break;
      case "retry":
        /^\d+$/.test(value) ? onRetry(parseInt(value, 10)) : onError(
          new ParseError('Invalid `retry` value: "'.concat(value, '"'), {
            type: "invalid-retry",
            value,
            line
          })
        );
        break;
      default:
        onError(
          new ParseError(
            'Unknown field "'.concat(field.length > 20 ? "".concat(field.slice(0, 20), "…") : field, '"'),
            { type: "unknown-field", field, value, line }
          )
        );
        break;
    }
  }
  function dispatchEvent() {
    data.length > 0 && onEvent({
      id,
      event: eventType || void 0,
      // If the data buffer's last character is a U+000A LINE FEED (LF) character,
      // then remove the last character from the data buffer.
      data: data.endsWith("\n") ? data.slice(0, -1) : data
    }), id = void 0, data = "", eventType = "";
  }
  function reset3(options = {}) {
    incompleteLine && options.consume && parseLine(incompleteLine), isFirstChunk = true, id = void 0, data = "", eventType = "", incompleteLine = "";
  }
  return { feed, reset: reset3 };
}
function splitLines(chunk2) {
  const lines = [];
  let incompleteLine = "", searchIndex = 0;
  for (; searchIndex < chunk2.length; ) {
    const crIndex = chunk2.indexOf("\r", searchIndex), lfIndex = chunk2.indexOf("\n", searchIndex);
    let lineEnd = -1;
    if (crIndex !== -1 && lfIndex !== -1 ? lineEnd = Math.min(crIndex, lfIndex) : crIndex !== -1 ? crIndex === chunk2.length - 1 ? lineEnd = -1 : lineEnd = crIndex : lfIndex !== -1 && (lineEnd = lfIndex), lineEnd === -1) {
      incompleteLine = chunk2.slice(searchIndex);
      break;
    } else {
      const line = chunk2.slice(searchIndex, lineEnd);
      lines.push(line), searchIndex = lineEnd + 1, chunk2[searchIndex - 1] === "\r" && chunk2[searchIndex] === "\n" && searchIndex++;
    }
  }
  return [lines, incompleteLine];
}

// node_modules/eventsource-parser/dist/stream.js
var EventSourceParserStream = class extends TransformStream {
  constructor({ onError, onRetry, onComment } = {}) {
    let parser;
    super({
      start(controller) {
        parser = createParser({
          onEvent: (event) => {
            controller.enqueue(event);
          },
          onError(error40) {
            onError === "terminate" ? controller.error(error40) : typeof onError == "function" && onError(error40);
          },
          onRetry,
          onComment
        });
      },
      transform(chunk2) {
        parser.feed(chunk2);
      }
    });
  }
};

// node_modules/zod/v4/classic/external.js
var external_exports = {};
__export(external_exports, {
  $brand: () => $brand,
  $input: () => $input,
  $output: () => $output,
  NEVER: () => NEVER,
  TimePrecision: () => TimePrecision,
  ZodAny: () => ZodAny,
  ZodArray: () => ZodArray,
  ZodBase64: () => ZodBase64,
  ZodBase64URL: () => ZodBase64URL,
  ZodBigInt: () => ZodBigInt,
  ZodBigIntFormat: () => ZodBigIntFormat,
  ZodBoolean: () => ZodBoolean,
  ZodCIDRv4: () => ZodCIDRv4,
  ZodCIDRv6: () => ZodCIDRv6,
  ZodCUID: () => ZodCUID,
  ZodCUID2: () => ZodCUID2,
  ZodCatch: () => ZodCatch,
  ZodCustom: () => ZodCustom,
  ZodCustomStringFormat: () => ZodCustomStringFormat,
  ZodDate: () => ZodDate,
  ZodDefault: () => ZodDefault,
  ZodDiscriminatedUnion: () => ZodDiscriminatedUnion,
  ZodE164: () => ZodE164,
  ZodEmail: () => ZodEmail,
  ZodEmoji: () => ZodEmoji,
  ZodEnum: () => ZodEnum,
  ZodError: () => ZodError,
  ZodFile: () => ZodFile,
  ZodGUID: () => ZodGUID,
  ZodIPv4: () => ZodIPv4,
  ZodIPv6: () => ZodIPv6,
  ZodISODate: () => ZodISODate,
  ZodISODateTime: () => ZodISODateTime,
  ZodISODuration: () => ZodISODuration,
  ZodISOTime: () => ZodISOTime,
  ZodIntersection: () => ZodIntersection,
  ZodIssueCode: () => ZodIssueCode,
  ZodJWT: () => ZodJWT,
  ZodKSUID: () => ZodKSUID,
  ZodLazy: () => ZodLazy,
  ZodLiteral: () => ZodLiteral,
  ZodMap: () => ZodMap,
  ZodNaN: () => ZodNaN,
  ZodNanoID: () => ZodNanoID,
  ZodNever: () => ZodNever,
  ZodNonOptional: () => ZodNonOptional,
  ZodNull: () => ZodNull,
  ZodNullable: () => ZodNullable,
  ZodNumber: () => ZodNumber,
  ZodNumberFormat: () => ZodNumberFormat,
  ZodObject: () => ZodObject,
  ZodOptional: () => ZodOptional,
  ZodPipe: () => ZodPipe,
  ZodPrefault: () => ZodPrefault,
  ZodPromise: () => ZodPromise,
  ZodReadonly: () => ZodReadonly,
  ZodRealError: () => ZodRealError,
  ZodRecord: () => ZodRecord,
  ZodSet: () => ZodSet,
  ZodString: () => ZodString,
  ZodStringFormat: () => ZodStringFormat,
  ZodSuccess: () => ZodSuccess,
  ZodSymbol: () => ZodSymbol,
  ZodTemplateLiteral: () => ZodTemplateLiteral,
  ZodTransform: () => ZodTransform,
  ZodTuple: () => ZodTuple,
  ZodType: () => ZodType,
  ZodULID: () => ZodULID,
  ZodURL: () => ZodURL,
  ZodUUID: () => ZodUUID,
  ZodUndefined: () => ZodUndefined,
  ZodUnion: () => ZodUnion,
  ZodUnknown: () => ZodUnknown,
  ZodVoid: () => ZodVoid,
  ZodXID: () => ZodXID,
  _ZodString: () => _ZodString,
  _default: () => _default3,
  any: () => any,
  array: () => array,
  base64: () => base642,
  base64url: () => base64url2,
  bigint: () => bigint2,
  boolean: () => boolean2,
  catch: () => _catch2,
  check: () => check,
  cidrv4: () => cidrv42,
  cidrv6: () => cidrv62,
  clone: () => clone,
  coerce: () => coerce_exports,
  config: () => config,
  core: () => core_exports2,
  cuid: () => cuid3,
  cuid2: () => cuid22,
  custom: () => custom,
  date: () => date3,
  discriminatedUnion: () => discriminatedUnion,
  e164: () => e1642,
  email: () => email2,
  emoji: () => emoji2,
  endsWith: () => _endsWith,
  enum: () => _enum2,
  file: () => file,
  flattenError: () => flattenError,
  float32: () => float32,
  float64: () => float64,
  formatError: () => formatError,
  function: () => _function,
  getErrorMap: () => getErrorMap,
  globalRegistry: () => globalRegistry,
  gt: () => _gt,
  gte: () => _gte,
  guid: () => guid2,
  includes: () => _includes,
  instanceof: () => _instanceof,
  int: () => int,
  int32: () => int32,
  int64: () => int64,
  intersection: () => intersection,
  ipv4: () => ipv42,
  ipv6: () => ipv62,
  iso: () => iso_exports,
  json: () => json,
  jwt: () => jwt,
  keyof: () => keyof,
  ksuid: () => ksuid2,
  lazy: () => lazy,
  length: () => _length,
  literal: () => literal,
  locales: () => locales_exports,
  looseObject: () => looseObject,
  lowercase: () => _lowercase,
  lt: () => _lt,
  lte: () => _lte,
  map: () => map,
  maxLength: () => _maxLength,
  maxSize: () => _maxSize,
  mime: () => _mime,
  minLength: () => _minLength,
  minSize: () => _minSize,
  multipleOf: () => _multipleOf,
  nan: () => nan,
  nanoid: () => nanoid2,
  nativeEnum: () => nativeEnum,
  negative: () => _negative,
  never: () => never,
  nonnegative: () => _nonnegative,
  nonoptional: () => nonoptional,
  nonpositive: () => _nonpositive,
  normalize: () => _normalize,
  null: () => _null3,
  nullable: () => nullable,
  nullish: () => nullish2,
  number: () => number2,
  object: () => object,
  optional: () => optional,
  overwrite: () => _overwrite,
  parse: () => parse2,
  parseAsync: () => parseAsync2,
  partialRecord: () => partialRecord,
  pipe: () => pipe,
  positive: () => _positive,
  prefault: () => prefault,
  preprocess: () => preprocess,
  prettifyError: () => prettifyError,
  promise: () => promise,
  property: () => _property,
  readonly: () => readonly,
  record: () => record,
  refine: () => refine,
  regex: () => _regex,
  regexes: () => regexes_exports,
  registry: () => registry,
  safeParse: () => safeParse2,
  safeParseAsync: () => safeParseAsync2,
  set: () => set,
  setErrorMap: () => setErrorMap,
  size: () => _size,
  startsWith: () => _startsWith,
  strictObject: () => strictObject,
  string: () => string2,
  stringFormat: () => stringFormat,
  stringbool: () => stringbool,
  success: () => success,
  superRefine: () => superRefine,
  symbol: () => symbol15,
  templateLiteral: () => templateLiteral,
  toJSONSchema: () => toJSONSchema,
  toLowerCase: () => _toLowerCase,
  toUpperCase: () => _toUpperCase,
  transform: () => transform,
  treeifyError: () => treeifyError,
  trim: () => _trim,
  tuple: () => tuple,
  uint32: () => uint32,
  uint64: () => uint64,
  ulid: () => ulid2,
  undefined: () => _undefined3,
  union: () => union,
  unknown: () => unknown,
  uppercase: () => _uppercase,
  url: () => url,
  uuid: () => uuid2,
  uuidv4: () => uuidv4,
  uuidv6: () => uuidv6,
  uuidv7: () => uuidv7,
  void: () => _void2,
  xid: () => xid2
});

// node_modules/zod/v4/core/index.js
var core_exports2 = {};
__export(core_exports2, {
  $ZodAny: () => $ZodAny,
  $ZodArray: () => $ZodArray,
  $ZodAsyncError: () => $ZodAsyncError,
  $ZodBase64: () => $ZodBase64,
  $ZodBase64URL: () => $ZodBase64URL,
  $ZodBigInt: () => $ZodBigInt,
  $ZodBigIntFormat: () => $ZodBigIntFormat,
  $ZodBoolean: () => $ZodBoolean,
  $ZodCIDRv4: () => $ZodCIDRv4,
  $ZodCIDRv6: () => $ZodCIDRv6,
  $ZodCUID: () => $ZodCUID,
  $ZodCUID2: () => $ZodCUID2,
  $ZodCatch: () => $ZodCatch,
  $ZodCheck: () => $ZodCheck,
  $ZodCheckBigIntFormat: () => $ZodCheckBigIntFormat,
  $ZodCheckEndsWith: () => $ZodCheckEndsWith,
  $ZodCheckGreaterThan: () => $ZodCheckGreaterThan,
  $ZodCheckIncludes: () => $ZodCheckIncludes,
  $ZodCheckLengthEquals: () => $ZodCheckLengthEquals,
  $ZodCheckLessThan: () => $ZodCheckLessThan,
  $ZodCheckLowerCase: () => $ZodCheckLowerCase,
  $ZodCheckMaxLength: () => $ZodCheckMaxLength,
  $ZodCheckMaxSize: () => $ZodCheckMaxSize,
  $ZodCheckMimeType: () => $ZodCheckMimeType,
  $ZodCheckMinLength: () => $ZodCheckMinLength,
  $ZodCheckMinSize: () => $ZodCheckMinSize,
  $ZodCheckMultipleOf: () => $ZodCheckMultipleOf,
  $ZodCheckNumberFormat: () => $ZodCheckNumberFormat,
  $ZodCheckOverwrite: () => $ZodCheckOverwrite,
  $ZodCheckProperty: () => $ZodCheckProperty,
  $ZodCheckRegex: () => $ZodCheckRegex,
  $ZodCheckSizeEquals: () => $ZodCheckSizeEquals,
  $ZodCheckStartsWith: () => $ZodCheckStartsWith,
  $ZodCheckStringFormat: () => $ZodCheckStringFormat,
  $ZodCheckUpperCase: () => $ZodCheckUpperCase,
  $ZodCustom: () => $ZodCustom,
  $ZodCustomStringFormat: () => $ZodCustomStringFormat,
  $ZodDate: () => $ZodDate,
  $ZodDefault: () => $ZodDefault,
  $ZodDiscriminatedUnion: () => $ZodDiscriminatedUnion,
  $ZodE164: () => $ZodE164,
  $ZodEmail: () => $ZodEmail,
  $ZodEmoji: () => $ZodEmoji,
  $ZodEnum: () => $ZodEnum,
  $ZodError: () => $ZodError,
  $ZodFile: () => $ZodFile,
  $ZodFunction: () => $ZodFunction,
  $ZodGUID: () => $ZodGUID,
  $ZodIPv4: () => $ZodIPv4,
  $ZodIPv6: () => $ZodIPv6,
  $ZodISODate: () => $ZodISODate,
  $ZodISODateTime: () => $ZodISODateTime,
  $ZodISODuration: () => $ZodISODuration,
  $ZodISOTime: () => $ZodISOTime,
  $ZodIntersection: () => $ZodIntersection,
  $ZodJWT: () => $ZodJWT,
  $ZodKSUID: () => $ZodKSUID,
  $ZodLazy: () => $ZodLazy,
  $ZodLiteral: () => $ZodLiteral,
  $ZodMap: () => $ZodMap,
  $ZodNaN: () => $ZodNaN,
  $ZodNanoID: () => $ZodNanoID,
  $ZodNever: () => $ZodNever,
  $ZodNonOptional: () => $ZodNonOptional,
  $ZodNull: () => $ZodNull,
  $ZodNullable: () => $ZodNullable,
  $ZodNumber: () => $ZodNumber,
  $ZodNumberFormat: () => $ZodNumberFormat,
  $ZodObject: () => $ZodObject,
  $ZodOptional: () => $ZodOptional,
  $ZodPipe: () => $ZodPipe,
  $ZodPrefault: () => $ZodPrefault,
  $ZodPromise: () => $ZodPromise,
  $ZodReadonly: () => $ZodReadonly,
  $ZodRealError: () => $ZodRealError,
  $ZodRecord: () => $ZodRecord,
  $ZodRegistry: () => $ZodRegistry,
  $ZodSet: () => $ZodSet,
  $ZodString: () => $ZodString,
  $ZodStringFormat: () => $ZodStringFormat,
  $ZodSuccess: () => $ZodSuccess,
  $ZodSymbol: () => $ZodSymbol,
  $ZodTemplateLiteral: () => $ZodTemplateLiteral,
  $ZodTransform: () => $ZodTransform,
  $ZodTuple: () => $ZodTuple,
  $ZodType: () => $ZodType,
  $ZodULID: () => $ZodULID,
  $ZodURL: () => $ZodURL,
  $ZodUUID: () => $ZodUUID,
  $ZodUndefined: () => $ZodUndefined,
  $ZodUnion: () => $ZodUnion,
  $ZodUnknown: () => $ZodUnknown,
  $ZodVoid: () => $ZodVoid,
  $ZodXID: () => $ZodXID,
  $brand: () => $brand,
  $constructor: () => $constructor,
  $input: () => $input,
  $output: () => $output,
  Doc: () => Doc,
  JSONSchema: () => json_schema_exports,
  JSONSchemaGenerator: () => JSONSchemaGenerator,
  NEVER: () => NEVER,
  TimePrecision: () => TimePrecision,
  _any: () => _any,
  _array: () => _array,
  _base64: () => _base64,
  _base64url: () => _base64url,
  _bigint: () => _bigint,
  _boolean: () => _boolean,
  _catch: () => _catch,
  _cidrv4: () => _cidrv4,
  _cidrv6: () => _cidrv6,
  _coercedBigint: () => _coercedBigint,
  _coercedBoolean: () => _coercedBoolean,
  _coercedDate: () => _coercedDate,
  _coercedNumber: () => _coercedNumber,
  _coercedString: () => _coercedString,
  _cuid: () => _cuid,
  _cuid2: () => _cuid2,
  _custom: () => _custom,
  _date: () => _date,
  _default: () => _default2,
  _discriminatedUnion: () => _discriminatedUnion,
  _e164: () => _e164,
  _email: () => _email,
  _emoji: () => _emoji2,
  _endsWith: () => _endsWith,
  _enum: () => _enum,
  _file: () => _file,
  _float32: () => _float32,
  _float64: () => _float64,
  _gt: () => _gt,
  _gte: () => _gte,
  _guid: () => _guid,
  _includes: () => _includes,
  _int: () => _int,
  _int32: () => _int32,
  _int64: () => _int64,
  _intersection: () => _intersection,
  _ipv4: () => _ipv4,
  _ipv6: () => _ipv6,
  _isoDate: () => _isoDate,
  _isoDateTime: () => _isoDateTime,
  _isoDuration: () => _isoDuration,
  _isoTime: () => _isoTime,
  _jwt: () => _jwt,
  _ksuid: () => _ksuid,
  _lazy: () => _lazy,
  _length: () => _length,
  _literal: () => _literal,
  _lowercase: () => _lowercase,
  _lt: () => _lt,
  _lte: () => _lte,
  _map: () => _map,
  _max: () => _lte,
  _maxLength: () => _maxLength,
  _maxSize: () => _maxSize,
  _mime: () => _mime,
  _min: () => _gte,
  _minLength: () => _minLength,
  _minSize: () => _minSize,
  _multipleOf: () => _multipleOf,
  _nan: () => _nan,
  _nanoid: () => _nanoid,
  _nativeEnum: () => _nativeEnum,
  _negative: () => _negative,
  _never: () => _never,
  _nonnegative: () => _nonnegative,
  _nonoptional: () => _nonoptional,
  _nonpositive: () => _nonpositive,
  _normalize: () => _normalize,
  _null: () => _null2,
  _nullable: () => _nullable,
  _number: () => _number,
  _optional: () => _optional,
  _overwrite: () => _overwrite,
  _parse: () => _parse,
  _parseAsync: () => _parseAsync,
  _pipe: () => _pipe,
  _positive: () => _positive,
  _promise: () => _promise,
  _property: () => _property,
  _readonly: () => _readonly,
  _record: () => _record,
  _refine: () => _refine,
  _regex: () => _regex,
  _safeParse: () => _safeParse,
  _safeParseAsync: () => _safeParseAsync,
  _set: () => _set,
  _size: () => _size,
  _startsWith: () => _startsWith,
  _string: () => _string,
  _stringFormat: () => _stringFormat,
  _stringbool: () => _stringbool,
  _success: () => _success,
  _symbol: () => _symbol,
  _templateLiteral: () => _templateLiteral,
  _toLowerCase: () => _toLowerCase,
  _toUpperCase: () => _toUpperCase,
  _transform: () => _transform,
  _trim: () => _trim,
  _tuple: () => _tuple,
  _uint32: () => _uint32,
  _uint64: () => _uint64,
  _ulid: () => _ulid,
  _undefined: () => _undefined2,
  _union: () => _union,
  _unknown: () => _unknown,
  _uppercase: () => _uppercase,
  _url: () => _url,
  _uuid: () => _uuid,
  _uuidv4: () => _uuidv4,
  _uuidv6: () => _uuidv6,
  _uuidv7: () => _uuidv7,
  _void: () => _void,
  _xid: () => _xid,
  clone: () => clone,
  config: () => config,
  flattenError: () => flattenError,
  formatError: () => formatError,
  function: () => _function,
  globalConfig: () => globalConfig,
  globalRegistry: () => globalRegistry,
  isValidBase64: () => isValidBase64,
  isValidBase64URL: () => isValidBase64URL,
  isValidJWT: () => isValidJWT,
  locales: () => locales_exports,
  parse: () => parse,
  parseAsync: () => parseAsync,
  prettifyError: () => prettifyError,
  regexes: () => regexes_exports,
  registry: () => registry,
  safeParse: () => safeParse,
  safeParseAsync: () => safeParseAsync,
  toDotPath: () => toDotPath,
  toJSONSchema: () => toJSONSchema,
  treeifyError: () => treeifyError,
  util: () => util_exports,
  version: () => version
});

// node_modules/zod/v4/core/core.js
var NEVER = Object.freeze({
  status: "aborted"
});
// @__NO_SIDE_EFFECTS__
function $constructor(name16, initializer3, params) {
  var _a17;
  function init(inst, def) {
    var _a19, _b8;
    var _a18;
    Object.defineProperty(inst, "_zod", {
      value: (_a19 = inst._zod) != null ? _a19 : {},
      enumerable: false
    });
    (_b8 = (_a18 = inst._zod).traits) != null ? _b8 : _a18.traits = /* @__PURE__ */ new Set();
    inst._zod.traits.add(name16);
    initializer3(inst, def);
    for (const k4 in _4.prototype) {
      if (!(k4 in inst))
        Object.defineProperty(inst, k4, { value: _4.prototype[k4].bind(inst) });
    }
    inst._zod.constr = _4;
    inst._zod.def = def;
  }
  const Parent = (_a17 = params == null ? void 0 : params.Parent) != null ? _a17 : Object;
  class Definition extends Parent {
  }
  Object.defineProperty(Definition, "name", { value: name16 });
  function _4(def) {
    var _a19;
    var _a18;
    const inst = (params == null ? void 0 : params.Parent) ? new Definition() : this;
    init(inst, def);
    (_a19 = (_a18 = inst._zod).deferred) != null ? _a19 : _a18.deferred = [];
    for (const fn of inst._zod.deferred) {
      fn();
    }
    return inst;
  }
  Object.defineProperty(_4, "init", { value: init });
  Object.defineProperty(_4, Symbol.hasInstance, {
    value: (inst) => {
      var _a18, _b8;
      if ((params == null ? void 0 : params.Parent) && inst instanceof params.Parent)
        return true;
      return (_b8 = (_a18 = inst == null ? void 0 : inst._zod) == null ? void 0 : _a18.traits) == null ? void 0 : _b8.has(name16);
    }
  });
  Object.defineProperty(_4, "name", { value: name16 });
  return _4;
}
var $brand = Symbol("zod_brand");
var $ZodAsyncError = class extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
};
var globalConfig = {};
function config(newConfig) {
  if (newConfig)
    Object.assign(globalConfig, newConfig);
  return globalConfig;
}

// node_modules/zod/v4/core/util.js
var util_exports = {};
__export(util_exports, {
  BIGINT_FORMAT_RANGES: () => BIGINT_FORMAT_RANGES,
  Class: () => Class,
  NUMBER_FORMAT_RANGES: () => NUMBER_FORMAT_RANGES,
  aborted: () => aborted,
  allowsEval: () => allowsEval,
  assert: () => assert,
  assertEqual: () => assertEqual,
  assertIs: () => assertIs,
  assertNever: () => assertNever,
  assertNotEqual: () => assertNotEqual,
  assignProp: () => assignProp,
  cached: () => cached,
  captureStackTrace: () => captureStackTrace,
  cleanEnum: () => cleanEnum,
  cleanRegex: () => cleanRegex,
  clone: () => clone,
  createTransparentProxy: () => createTransparentProxy,
  defineLazy: () => defineLazy,
  esc: () => esc,
  escapeRegex: () => escapeRegex,
  extend: () => extend,
  finalizeIssue: () => finalizeIssue,
  floatSafeRemainder: () => floatSafeRemainder,
  getElementAtPath: () => getElementAtPath,
  getEnumValues: () => getEnumValues,
  getLengthableOrigin: () => getLengthableOrigin,
  getParsedType: () => getParsedType,
  getSizableOrigin: () => getSizableOrigin,
  isObject: () => isObject,
  isPlainObject: () => isPlainObject2,
  issue: () => issue,
  joinValues: () => joinValues,
  jsonStringifyReplacer: () => jsonStringifyReplacer,
  merge: () => merge,
  normalizeParams: () => normalizeParams,
  nullish: () => nullish,
  numKeys: () => numKeys,
  omit: () => omit2,
  optionalKeys: () => optionalKeys,
  partial: () => partial,
  pick: () => pick,
  prefixIssues: () => prefixIssues,
  primitiveTypes: () => primitiveTypes,
  promiseAllObject: () => promiseAllObject,
  propertyKeyTypes: () => propertyKeyTypes,
  randomString: () => randomString,
  required: () => required,
  stringifyPrimitive: () => stringifyPrimitive,
  unwrapMessage: () => unwrapMessage
});
function assertEqual(val) {
  return val;
}
function assertNotEqual(val) {
  return val;
}
function assertIs(_arg) {
}
function assertNever(_x) {
  throw new Error();
}
function assert(_4) {
}
function getEnumValues(entries) {
  const numericValues = Object.values(entries).filter((v4) => typeof v4 === "number");
  const values = Object.entries(entries).filter(([k4, _4]) => numericValues.indexOf(+k4) === -1).map(([_4, v4]) => v4);
  return values;
}
function joinValues(array2, separator2 = "|") {
  return array2.map((val) => stringifyPrimitive(val)).join(separator2);
}
function jsonStringifyReplacer(_4, value) {
  if (typeof value === "bigint")
    return value.toString();
  return value;
}
function cached(getter) {
  const set2 = false;
  return {
    get value() {
      if (!set2) {
        const value = getter();
        Object.defineProperty(this, "value", { value });
        return value;
      }
      throw new Error("cached value already set");
    }
  };
}
function nullish(input) {
  return input === null || input === void 0;
}
function cleanRegex(source) {
  const start = source.startsWith("^") ? 1 : 0;
  const end = source.endsWith("$") ? source.length - 1 : source.length;
  return source.slice(start, end);
}
function floatSafeRemainder(val, step) {
  const valDecCount = (val.toString().split(".")[1] || "").length;
  const stepDecCount = (step.toString().split(".")[1] || "").length;
  const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
  const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
  const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
  return valInt % stepInt / 10 ** decCount;
}
function defineLazy(object3, key2, getter) {
  const set2 = false;
  Object.defineProperty(object3, key2, {
    get() {
      if (!set2) {
        const value = getter();
        object3[key2] = value;
        return value;
      }
      throw new Error("cached value already set");
    },
    set(v4) {
      Object.defineProperty(object3, key2, {
        value: v4
        // configurable: true,
      });
    },
    configurable: true
  });
}
function assignProp(target, prop, value) {
  Object.defineProperty(target, prop, {
    value,
    writable: true,
    enumerable: true,
    configurable: true
  });
}
function getElementAtPath(obj, path) {
  if (!path)
    return obj;
  return path.reduce((acc, key2) => acc == null ? void 0 : acc[key2], obj);
}
function promiseAllObject(promisesObj) {
  const keys = Object.keys(promisesObj);
  const promises = keys.map((key2) => promisesObj[key2]);
  return Promise.all(promises).then((results) => {
    const resolvedObj = {};
    for (let i4 = 0; i4 < keys.length; i4++) {
      resolvedObj[keys[i4]] = results[i4];
    }
    return resolvedObj;
  });
}
function randomString(length = 10) {
  const chars = "abcdefghijklmnopqrstuvwxyz";
  let str = "";
  for (let i4 = 0; i4 < length; i4++) {
    str += chars[Math.floor(Math.random() * chars.length)];
  }
  return str;
}
function esc(str) {
  return JSON.stringify(str);
}
var captureStackTrace = Error.captureStackTrace ? Error.captureStackTrace : (..._args) => {
};
function isObject(data) {
  return typeof data === "object" && data !== null && !Array.isArray(data);
}
var allowsEval = cached(() => {
  var _a17;
  if (typeof navigator !== "undefined" && ((_a17 = navigator == null ? void 0 : navigator.userAgent) == null ? void 0 : _a17.includes("Cloudflare"))) {
    return false;
  }
  try {
    const F4 = Function;
    new F4("");
    return true;
  } catch (_4) {
    return false;
  }
});
function isPlainObject2(o4) {
  if (isObject(o4) === false)
    return false;
  const ctor = o4.constructor;
  if (ctor === void 0)
    return true;
  const prot = ctor.prototype;
  if (isObject(prot) === false)
    return false;
  if (Object.prototype.hasOwnProperty.call(prot, "isPrototypeOf") === false) {
    return false;
  }
  return true;
}
function numKeys(data) {
  let keyCount = 0;
  for (const key2 in data) {
    if (Object.prototype.hasOwnProperty.call(data, key2)) {
      keyCount++;
    }
  }
  return keyCount;
}
var getParsedType = (data) => {
  const t4 = typeof data;
  switch (t4) {
    case "undefined":
      return "undefined";
    case "string":
      return "string";
    case "number":
      return Number.isNaN(data) ? "nan" : "number";
    case "boolean":
      return "boolean";
    case "function":
      return "function";
    case "bigint":
      return "bigint";
    case "symbol":
      return "symbol";
    case "object":
      if (Array.isArray(data)) {
        return "array";
      }
      if (data === null) {
        return "null";
      }
      if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") {
        return "promise";
      }
      if (typeof Map !== "undefined" && data instanceof Map) {
        return "map";
      }
      if (typeof Set !== "undefined" && data instanceof Set) {
        return "set";
      }
      if (typeof Date !== "undefined" && data instanceof Date) {
        return "date";
      }
      if (typeof File !== "undefined" && data instanceof File) {
        return "file";
      }
      return "object";
    default:
      throw new Error("Unknown data type: ".concat(t4));
  }
};
var propertyKeyTypes = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
var primitiveTypes = /* @__PURE__ */ new Set(["string", "number", "bigint", "boolean", "symbol", "undefined"]);
function escapeRegex(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function clone(inst, def, params) {
  const cl = new inst._zod.constr(def != null ? def : inst._zod.def);
  if (!def || (params == null ? void 0 : params.parent))
    cl._zod.parent = inst;
  return cl;
}
function normalizeParams(_params) {
  const params = _params;
  if (!params)
    return {};
  if (typeof params === "string")
    return { error: () => params };
  if ((params == null ? void 0 : params.message) !== void 0) {
    if ((params == null ? void 0 : params.error) !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    params.error = params.message;
  }
  delete params.message;
  if (typeof params.error === "string")
    return { ...params, error: () => params.error };
  return params;
}
function createTransparentProxy(getter) {
  let target;
  return new Proxy({}, {
    get(_4, prop, receiver) {
      target != null ? target : target = getter();
      return Reflect.get(target, prop, receiver);
    },
    set(_4, prop, value, receiver) {
      target != null ? target : target = getter();
      return Reflect.set(target, prop, value, receiver);
    },
    has(_4, prop) {
      target != null ? target : target = getter();
      return Reflect.has(target, prop);
    },
    deleteProperty(_4, prop) {
      target != null ? target : target = getter();
      return Reflect.deleteProperty(target, prop);
    },
    ownKeys(_4) {
      target != null ? target : target = getter();
      return Reflect.ownKeys(target);
    },
    getOwnPropertyDescriptor(_4, prop) {
      target != null ? target : target = getter();
      return Reflect.getOwnPropertyDescriptor(target, prop);
    },
    defineProperty(_4, prop, descriptor) {
      target != null ? target : target = getter();
      return Reflect.defineProperty(target, prop, descriptor);
    }
  });
}
function stringifyPrimitive(value) {
  if (typeof value === "bigint")
    return value.toString() + "n";
  if (typeof value === "string")
    return '"'.concat(value, '"');
  return "".concat(value);
}
function optionalKeys(shape) {
  return Object.keys(shape).filter((k4) => {
    return shape[k4]._zod.optin === "optional" && shape[k4]._zod.optout === "optional";
  });
}
var NUMBER_FORMAT_RANGES = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
var BIGINT_FORMAT_RANGES = {
  int64: [/* @__PURE__ */ BigInt("-9223372036854775808"), /* @__PURE__ */ BigInt("9223372036854775807")],
  uint64: [/* @__PURE__ */ BigInt(0), /* @__PURE__ */ BigInt("18446744073709551615")]
};
function pick(schema, mask) {
  const newShape = {};
  const currDef = schema._zod.def;
  for (const key2 in mask) {
    if (!(key2 in currDef.shape)) {
      throw new Error('Unrecognized key: "'.concat(key2, '"'));
    }
    if (!mask[key2])
      continue;
    newShape[key2] = currDef.shape[key2];
  }
  return clone(schema, {
    ...schema._zod.def,
    shape: newShape,
    checks: []
  });
}
function omit2(schema, mask) {
  const newShape = { ...schema._zod.def.shape };
  const currDef = schema._zod.def;
  for (const key2 in mask) {
    if (!(key2 in currDef.shape)) {
      throw new Error('Unrecognized key: "'.concat(key2, '"'));
    }
    if (!mask[key2])
      continue;
    delete newShape[key2];
  }
  return clone(schema, {
    ...schema._zod.def,
    shape: newShape,
    checks: []
  });
}
function extend(schema, shape) {
  if (!isPlainObject2(shape)) {
    throw new Error("Invalid input to extend: expected a plain object");
  }
  const def = {
    ...schema._zod.def,
    get shape() {
      const _shape = { ...schema._zod.def.shape, ...shape };
      assignProp(this, "shape", _shape);
      return _shape;
    },
    checks: []
    // delete existing checks
  };
  return clone(schema, def);
}
function merge(a4, b3) {
  return clone(a4, {
    ...a4._zod.def,
    get shape() {
      const _shape = { ...a4._zod.def.shape, ...b3._zod.def.shape };
      assignProp(this, "shape", _shape);
      return _shape;
    },
    catchall: b3._zod.def.catchall,
    checks: []
    // delete existing checks
  });
}
function partial(Class2, schema, mask) {
  const oldShape = schema._zod.def.shape;
  const shape = { ...oldShape };
  if (mask) {
    for (const key2 in mask) {
      if (!(key2 in oldShape)) {
        throw new Error('Unrecognized key: "'.concat(key2, '"'));
      }
      if (!mask[key2])
        continue;
      shape[key2] = Class2 ? new Class2({
        type: "optional",
        innerType: oldShape[key2]
      }) : oldShape[key2];
    }
  } else {
    for (const key2 in oldShape) {
      shape[key2] = Class2 ? new Class2({
        type: "optional",
        innerType: oldShape[key2]
      }) : oldShape[key2];
    }
  }
  return clone(schema, {
    ...schema._zod.def,
    shape,
    checks: []
  });
}
function required(Class2, schema, mask) {
  const oldShape = schema._zod.def.shape;
  const shape = { ...oldShape };
  if (mask) {
    for (const key2 in mask) {
      if (!(key2 in shape)) {
        throw new Error('Unrecognized key: "'.concat(key2, '"'));
      }
      if (!mask[key2])
        continue;
      shape[key2] = new Class2({
        type: "nonoptional",
        innerType: oldShape[key2]
      });
    }
  } else {
    for (const key2 in oldShape) {
      shape[key2] = new Class2({
        type: "nonoptional",
        innerType: oldShape[key2]
      });
    }
  }
  return clone(schema, {
    ...schema._zod.def,
    shape,
    // optional: [],
    checks: []
  });
}
function aborted(x4, startIndex = 0) {
  var _a17;
  for (let i4 = startIndex; i4 < x4.issues.length; i4++) {
    if (((_a17 = x4.issues[i4]) == null ? void 0 : _a17.continue) !== true)
      return true;
  }
  return false;
}
function prefixIssues(path, issues) {
  return issues.map((iss) => {
    var _a18;
    var _a17;
    (_a18 = (_a17 = iss).path) != null ? _a18 : _a17.path = [];
    iss.path.unshift(path);
    return iss;
  });
}
function unwrapMessage(message) {
  return typeof message === "string" ? message : message == null ? void 0 : message.message;
}
function finalizeIssue(iss, ctx, config2) {
  var _a17, _b8, _c, _d, _e2, _f, _g, _h, _i, _j, _k;
  const full = { ...iss, path: (_a17 = iss.path) != null ? _a17 : [] };
  if (!iss.message) {
    const message = (_k = (_j = (_h = (_f = unwrapMessage((_d = (_c = (_b8 = iss.inst) == null ? void 0 : _b8._zod.def) == null ? void 0 : _c.error) == null ? void 0 : _d.call(_c, iss))) != null ? _f : unwrapMessage((_e2 = ctx == null ? void 0 : ctx.error) == null ? void 0 : _e2.call(ctx, iss))) != null ? _h : unwrapMessage((_g = config2.customError) == null ? void 0 : _g.call(config2, iss))) != null ? _j : unwrapMessage((_i = config2.localeError) == null ? void 0 : _i.call(config2, iss))) != null ? _k : "Invalid input";
    full.message = message;
  }
  delete full.inst;
  delete full.continue;
  if (!(ctx == null ? void 0 : ctx.reportInput)) {
    delete full.input;
  }
  return full;
}
function getSizableOrigin(input) {
  if (input instanceof Set)
    return "set";
  if (input instanceof Map)
    return "map";
  if (input instanceof File)
    return "file";
  return "unknown";
}
function getLengthableOrigin(input) {
  if (Array.isArray(input))
    return "array";
  if (typeof input === "string")
    return "string";
  return "unknown";
}
function issue(...args) {
  const [iss, input, inst] = args;
  if (typeof iss === "string") {
    return {
      message: iss,
      code: "custom",
      input,
      inst
    };
  }
  return { ...iss };
}
function cleanEnum(obj) {
  return Object.entries(obj).filter(([k4, _4]) => {
    return Number.isNaN(Number.parseInt(k4, 10));
  }).map((el) => el[1]);
}
var Class = class {
  constructor(..._args) {
  }
};

// node_modules/zod/v4/core/errors.js
var initializer = (inst, def) => {
  inst.name = "$ZodError";
  Object.defineProperty(inst, "_zod", {
    value: inst._zod,
    enumerable: false
  });
  Object.defineProperty(inst, "issues", {
    value: def,
    enumerable: false
  });
  Object.defineProperty(inst, "message", {
    get() {
      return JSON.stringify(def, jsonStringifyReplacer, 2);
    },
    enumerable: true
    // configurable: false,
  });
  Object.defineProperty(inst, "toString", {
    value: () => inst.message,
    enumerable: false
  });
};
var $ZodError = $constructor("$ZodError", initializer);
var $ZodRealError = $constructor("$ZodError", initializer, { Parent: Error });
function flattenError(error40, mapper = (issue2) => issue2.message) {
  const fieldErrors = {};
  const formErrors = [];
  for (const sub of error40.issues) {
    if (sub.path.length > 0) {
      fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
      fieldErrors[sub.path[0]].push(mapper(sub));
    } else {
      formErrors.push(mapper(sub));
    }
  }
  return { formErrors, fieldErrors };
}
function formatError(error40, _mapper) {
  const mapper = _mapper || function(issue2) {
    return issue2.message;
  };
  const fieldErrors = { _errors: [] };
  const processError = (error41) => {
    for (const issue2 of error41.issues) {
      if (issue2.code === "invalid_union" && issue2.errors.length) {
        issue2.errors.map((issues) => processError({ issues }));
      } else if (issue2.code === "invalid_key") {
        processError({ issues: issue2.issues });
      } else if (issue2.code === "invalid_element") {
        processError({ issues: issue2.issues });
      } else if (issue2.path.length === 0) {
        fieldErrors._errors.push(mapper(issue2));
      } else {
        let curr = fieldErrors;
        let i4 = 0;
        while (i4 < issue2.path.length) {
          const el = issue2.path[i4];
          const terminal = i4 === issue2.path.length - 1;
          if (!terminal) {
            curr[el] = curr[el] || { _errors: [] };
          } else {
            curr[el] = curr[el] || { _errors: [] };
            curr[el]._errors.push(mapper(issue2));
          }
          curr = curr[el];
          i4++;
        }
      }
    }
  };
  processError(error40);
  return fieldErrors;
}
function treeifyError(error40, _mapper) {
  const mapper = _mapper || function(issue2) {
    return issue2.message;
  };
  const result = { errors: [] };
  const processError = (error41, path = []) => {
    var _a18, _b9, _c, _d;
    var _a17, _b8;
    for (const issue2 of error41.issues) {
      if (issue2.code === "invalid_union" && issue2.errors.length) {
        issue2.errors.map((issues) => processError({ issues }, issue2.path));
      } else if (issue2.code === "invalid_key") {
        processError({ issues: issue2.issues }, issue2.path);
      } else if (issue2.code === "invalid_element") {
        processError({ issues: issue2.issues }, issue2.path);
      } else {
        const fullpath = [...path, ...issue2.path];
        if (fullpath.length === 0) {
          result.errors.push(mapper(issue2));
          continue;
        }
        let curr = result;
        let i4 = 0;
        while (i4 < fullpath.length) {
          const el = fullpath[i4];
          const terminal = i4 === fullpath.length - 1;
          if (typeof el === "string") {
            (_a18 = curr.properties) != null ? _a18 : curr.properties = {};
            (_b9 = (_a17 = curr.properties)[el]) != null ? _b9 : _a17[el] = { errors: [] };
            curr = curr.properties[el];
          } else {
            (_c = curr.items) != null ? _c : curr.items = [];
            (_d = (_b8 = curr.items)[el]) != null ? _d : _b8[el] = { errors: [] };
            curr = curr.items[el];
          }
          if (terminal) {
            curr.errors.push(mapper(issue2));
          }
          i4++;
        }
      }
    }
  };
  processError(error40);
  return result;
}
function toDotPath(path) {
  const segs = [];
  for (const seg of path) {
    if (typeof seg === "number")
      segs.push("[".concat(seg, "]"));
    else if (typeof seg === "symbol")
      segs.push("[".concat(JSON.stringify(String(seg)), "]"));
    else if (/[^\w$]/.test(seg))
      segs.push("[".concat(JSON.stringify(seg), "]"));
    else {
      if (segs.length)
        segs.push(".");
      segs.push(seg);
    }
  }
  return segs.join("");
}
function prettifyError(error40) {
  var _a17;
  const lines = [];
  const issues = [...error40.issues].sort((a4, b3) => a4.path.length - b3.path.length);
  for (const issue2 of issues) {
    lines.push("✖ ".concat(issue2.message));
    if ((_a17 = issue2.path) == null ? void 0 : _a17.length)
      lines.push("  → at ".concat(toDotPath(issue2.path)));
  }
  return lines.join("\n");
}

// node_modules/zod/v4/core/parse.js
var _parse = (_Err) => (schema, value, _ctx, _params) => {
  var _a17;
  const ctx = _ctx ? Object.assign(_ctx, { async: false }) : { async: false };
  const result = schema._zod.run({ value, issues: [] }, ctx);
  if (result instanceof Promise) {
    throw new $ZodAsyncError();
  }
  if (result.issues.length) {
    const e4 = new ((_a17 = _params == null ? void 0 : _params.Err) != null ? _a17 : _Err)(result.issues.map((iss) => finalizeIssue(iss, ctx, config())));
    captureStackTrace(e4, _params == null ? void 0 : _params.callee);
    throw e4;
  }
  return result.value;
};
var parse = /* @__PURE__ */ _parse($ZodRealError);
var _parseAsync = (_Err) => async (schema, value, _ctx, params) => {
  var _a17;
  const ctx = _ctx ? Object.assign(_ctx, { async: true }) : { async: true };
  let result = schema._zod.run({ value, issues: [] }, ctx);
  if (result instanceof Promise)
    result = await result;
  if (result.issues.length) {
    const e4 = new ((_a17 = params == null ? void 0 : params.Err) != null ? _a17 : _Err)(result.issues.map((iss) => finalizeIssue(iss, ctx, config())));
    captureStackTrace(e4, params == null ? void 0 : params.callee);
    throw e4;
  }
  return result.value;
};
var parseAsync = /* @__PURE__ */ _parseAsync($ZodRealError);
var _safeParse = (_Err) => (schema, value, _ctx) => {
  const ctx = _ctx ? { ..._ctx, async: false } : { async: false };
  const result = schema._zod.run({ value, issues: [] }, ctx);
  if (result instanceof Promise) {
    throw new $ZodAsyncError();
  }
  return result.issues.length ? {
    success: false,
    error: new (_Err != null ? _Err : $ZodError)(result.issues.map((iss) => finalizeIssue(iss, ctx, config())))
  } : { success: true, data: result.value };
};
var safeParse = /* @__PURE__ */ _safeParse($ZodRealError);
var _safeParseAsync = (_Err) => async (schema, value, _ctx) => {
  const ctx = _ctx ? Object.assign(_ctx, { async: true }) : { async: true };
  let result = schema._zod.run({ value, issues: [] }, ctx);
  if (result instanceof Promise)
    result = await result;
  return result.issues.length ? {
    success: false,
    error: new _Err(result.issues.map((iss) => finalizeIssue(iss, ctx, config())))
  } : { success: true, data: result.value };
};
var safeParseAsync = /* @__PURE__ */ _safeParseAsync($ZodRealError);

// node_modules/zod/v4/core/regexes.js
var regexes_exports = {};
__export(regexes_exports, {
  _emoji: () => _emoji,
  base64: () => base64,
  base64url: () => base64url,
  bigint: () => bigint,
  boolean: () => boolean,
  browserEmail: () => browserEmail,
  cidrv4: () => cidrv4,
  cidrv6: () => cidrv6,
  cuid: () => cuid,
  cuid2: () => cuid2,
  date: () => date,
  datetime: () => datetime,
  domain: () => domain,
  duration: () => duration,
  e164: () => e164,
  email: () => email,
  emoji: () => emoji,
  extendedDuration: () => extendedDuration,
  guid: () => guid,
  hostname: () => hostname,
  html5Email: () => html5Email,
  integer: () => integer,
  ipv4: () => ipv4,
  ipv6: () => ipv6,
  ksuid: () => ksuid,
  lowercase: () => lowercase,
  nanoid: () => nanoid,
  null: () => _null,
  number: () => number,
  rfc5322Email: () => rfc5322Email,
  string: () => string,
  time: () => time,
  ulid: () => ulid,
  undefined: () => _undefined,
  unicodeEmail: () => unicodeEmail,
  uppercase: () => uppercase,
  uuid: () => uuid,
  uuid4: () => uuid4,
  uuid6: () => uuid6,
  uuid7: () => uuid7,
  xid: () => xid
});
var cuid = /^[cC][^\s-]{8,}$/;
var cuid2 = /^[0-9a-z]+$/;
var ulid = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/;
var xid = /^[0-9a-vA-V]{20}$/;
var ksuid = /^[A-Za-z0-9]{27}$/;
var nanoid = /^[a-zA-Z0-9_-]{21}$/;
var duration = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/;
var extendedDuration = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
var guid = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/;
var uuid = (version2) => {
  if (!version2)
    return /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000)$/;
  return new RegExp("^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-".concat(version2, "[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$"));
};
var uuid4 = /* @__PURE__ */ uuid(4);
var uuid6 = /* @__PURE__ */ uuid(6);
var uuid7 = /* @__PURE__ */ uuid(7);
var email = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/;
var html5Email = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
var rfc5322Email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var unicodeEmail = /^[^\s@"]{1,64}@[^\s@]{1,255}$/u;
var browserEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
var _emoji = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function emoji() {
  return new RegExp(_emoji, "u");
}
var ipv4 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
var ipv6 = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})$/;
var cidrv4 = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/;
var cidrv6 = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
var base64 = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/;
var base64url = /^[A-Za-z0-9_-]*$/;
var hostname = /^([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+$/;
var domain = /^([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
var e164 = /^\+(?:[0-9]){6,14}[0-9]$/;
var dateSource = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))";
var date = /* @__PURE__ */ new RegExp("^".concat(dateSource, "$"));
function timeSource(args) {
  const hhmm = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  const regex = typeof args.precision === "number" ? args.precision === -1 ? "".concat(hhmm) : args.precision === 0 ? "".concat(hhmm, ":[0-5]\\d") : "".concat(hhmm, ":[0-5]\\d\\.\\d{").concat(args.precision, "}") : "".concat(hhmm, "(?::[0-5]\\d(?:\\.\\d+)?)?");
  return regex;
}
function time(args) {
  return new RegExp("^".concat(timeSource(args), "$"));
}
function datetime(args) {
  const time3 = timeSource({ precision: args.precision });
  const opts = ["Z"];
  if (args.local)
    opts.push("");
  if (args.offset)
    opts.push("([+-]\\d{2}:\\d{2})");
  const timeRegex2 = "".concat(time3, "(?:").concat(opts.join("|"), ")");
  return new RegExp("^".concat(dateSource, "T(?:").concat(timeRegex2, ")$"));
}
var string = (params) => {
  var _a17, _b8;
  const regex = params ? "[\\s\\S]{".concat((_a17 = params == null ? void 0 : params.minimum) != null ? _a17 : 0, ",").concat((_b8 = params == null ? void 0 : params.maximum) != null ? _b8 : "", "}") : "[\\s\\S]*";
  return new RegExp("^".concat(regex, "$"));
};
var bigint = /^\d+n?$/;
var integer = /^\d+$/;
var number = /^-?\d+(?:\.\d+)?/i;
var boolean = /true|false/i;
var _null = /null/i;
var _undefined = /undefined/i;
var lowercase = /^[^A-Z]*$/;
var uppercase = /^[^a-z]*$/;

// node_modules/zod/v4/core/checks.js
var $ZodCheck = /* @__PURE__ */ $constructor("$ZodCheck", (inst, def) => {
  var _a18, _b8;
  var _a17;
  (_a18 = inst._zod) != null ? _a18 : inst._zod = {};
  inst._zod.def = def;
  (_b8 = (_a17 = inst._zod).onattach) != null ? _b8 : _a17.onattach = [];
});
var numericOriginMap = {
  number: "number",
  bigint: "bigint",
  object: "date"
};
var $ZodCheckLessThan = /* @__PURE__ */ $constructor("$ZodCheckLessThan", (inst, def) => {
  $ZodCheck.init(inst, def);
  const origin = numericOriginMap[typeof def.value];
  inst._zod.onattach.push((inst2) => {
    var _a17;
    const bag = inst2._zod.bag;
    const curr = (_a17 = def.inclusive ? bag.maximum : bag.exclusiveMaximum) != null ? _a17 : Number.POSITIVE_INFINITY;
    if (def.value < curr) {
      if (def.inclusive)
        bag.maximum = def.value;
      else
        bag.exclusiveMaximum = def.value;
    }
  });
  inst._zod.check = (payload) => {
    if (def.inclusive ? payload.value <= def.value : payload.value < def.value) {
      return;
    }
    payload.issues.push({
      origin,
      code: "too_big",
      maximum: def.value,
      input: payload.value,
      inclusive: def.inclusive,
      inst,
      continue: !def.abort
    });
  };
});
var $ZodCheckGreaterThan = /* @__PURE__ */ $constructor("$ZodCheckGreaterThan", (inst, def) => {
  $ZodCheck.init(inst, def);
  const origin = numericOriginMap[typeof def.value];
  inst._zod.onattach.push((inst2) => {
    var _a17;
    const bag = inst2._zod.bag;
    const curr = (_a17 = def.inclusive ? bag.minimum : bag.exclusiveMinimum) != null ? _a17 : Number.NEGATIVE_INFINITY;
    if (def.value > curr) {
      if (def.inclusive)
        bag.minimum = def.value;
      else
        bag.exclusiveMinimum = def.value;
    }
  });
  inst._zod.check = (payload) => {
    if (def.inclusive ? payload.value >= def.value : payload.value > def.value) {
      return;
    }
    payload.issues.push({
      origin,
      code: "too_small",
      minimum: def.value,
      input: payload.value,
      inclusive: def.inclusive,
      inst,
      continue: !def.abort
    });
  };
});
var $ZodCheckMultipleOf = /* @__PURE__ */ $constructor("$ZodCheckMultipleOf", (inst, def) => {
  $ZodCheck.init(inst, def);
  inst._zod.onattach.push((inst2) => {
    var _a18;
    var _a17;
    (_a18 = (_a17 = inst2._zod.bag).multipleOf) != null ? _a18 : _a17.multipleOf = def.value;
  });
  inst._zod.check = (payload) => {
    if (typeof payload.value !== typeof def.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    const isMultiple = typeof payload.value === "bigint" ? payload.value % def.value === BigInt(0) : floatSafeRemainder(payload.value, def.value) === 0;
    if (isMultiple)
      return;
    payload.issues.push({
      origin: typeof payload.value,
      code: "not_multiple_of",
      divisor: def.value,
      input: payload.value,
      inst,
      continue: !def.abort
    });
  };
});
var $ZodCheckNumberFormat = /* @__PURE__ */ $constructor("$ZodCheckNumberFormat", (inst, def) => {
  var _a17;
  $ZodCheck.init(inst, def);
  def.format = def.format || "float64";
  const isInt = (_a17 = def.format) == null ? void 0 : _a17.includes("int");
  const origin = isInt ? "int" : "number";
  const [minimum, maximum] = NUMBER_FORMAT_RANGES[def.format];
  inst._zod.onattach.push((inst2) => {
    const bag = inst2._zod.bag;
    bag.format = def.format;
    bag.minimum = minimum;
    bag.maximum = maximum;
    if (isInt)
      bag.pattern = integer;
  });
  inst._zod.check = (payload) => {
    const input = payload.value;
    if (isInt) {
      if (!Number.isInteger(input)) {
        payload.issues.push({
          expected: origin,
          format: def.format,
          code: "invalid_type",
          input,
          inst
        });
        return;
      }
      if (!Number.isSafeInteger(input)) {
        if (input > 0) {
          payload.issues.push({
            input,
            code: "too_big",
            maximum: Number.MAX_SAFE_INTEGER,
            note: "Integers must be within the safe integer range.",
            inst,
            origin,
            continue: !def.abort
          });
        } else {
          payload.issues.push({
            input,
            code: "too_small",
            minimum: Number.MIN_SAFE_INTEGER,
            note: "Integers must be within the safe integer range.",
            inst,
            origin,
            continue: !def.abort
          });
        }
        return;
      }
    }
    if (input < minimum) {
      payload.issues.push({
        origin: "number",
        input,
        code: "too_small",
        minimum,
        inclusive: true,
        inst,
        continue: !def.abort
      });
    }
    if (input > maximum) {
      payload.issues.push({
        origin: "number",
        input,
        code: "too_big",
        maximum,
        inst
      });
    }
  };
});
var $ZodCheckBigIntFormat = /* @__PURE__ */ $constructor("$ZodCheckBigIntFormat", (inst, def) => {
  $ZodCheck.init(inst, def);
  const [minimum, maximum] = BIGINT_FORMAT_RANGES[def.format];
  inst._zod.onattach.push((inst2) => {
    const bag = inst2._zod.bag;
    bag.format = def.format;
    bag.minimum = minimum;
    bag.maximum = maximum;
  });
  inst._zod.check = (payload) => {
    const input = payload.value;
    if (input < minimum) {
      payload.issues.push({
        origin: "bigint",
        input,
        code: "too_small",
        minimum,
        inclusive: true,
        inst,
        continue: !def.abort
      });
    }
    if (input > maximum) {
      payload.issues.push({
        origin: "bigint",
        input,
        code: "too_big",
        maximum,
        inst
      });
    }
  };
});
var $ZodCheckMaxSize = /* @__PURE__ */ $constructor("$ZodCheckMaxSize", (inst, def) => {
  var _a18;
  var _a17;
  $ZodCheck.init(inst, def);
  (_a18 = (_a17 = inst._zod.def).when) != null ? _a18 : _a17.when = (payload) => {
    const val = payload.value;
    return !nullish(val) && val.size !== void 0;
  };
  inst._zod.onattach.push((inst2) => {
    var _a19;
    const curr = (_a19 = inst2._zod.bag.maximum) != null ? _a19 : Number.POSITIVE_INFINITY;
    if (def.maximum < curr)
      inst2._zod.bag.maximum = def.maximum;
  });
  inst._zod.check = (payload) => {
    const input = payload.value;
    const size = input.size;
    if (size <= def.maximum)
      return;
    payload.issues.push({
      origin: getSizableOrigin(input),
      code: "too_big",
      maximum: def.maximum,
      input,
      inst,
      continue: !def.abort
    });
  };
});
var $ZodCheckMinSize = /* @__PURE__ */ $constructor("$ZodCheckMinSize", (inst, def) => {
  var _a18;
  var _a17;
  $ZodCheck.init(inst, def);
  (_a18 = (_a17 = inst._zod.def).when) != null ? _a18 : _a17.when = (payload) => {
    const val = payload.value;
    return !nullish(val) && val.size !== void 0;
  };
  inst._zod.onattach.push((inst2) => {
    var _a19;
    const curr = (_a19 = inst2._zod.bag.minimum) != null ? _a19 : Number.NEGATIVE_INFINITY;
    if (def.minimum > curr)
      inst2._zod.bag.minimum = def.minimum;
  });
  inst._zod.check = (payload) => {
    const input = payload.value;
    const size = input.size;
    if (size >= def.minimum)
      return;
    payload.issues.push({
      origin: getSizableOrigin(input),
      code: "too_small",
      minimum: def.minimum,
      input,
      inst,
      continue: !def.abort
    });
  };
});
var $ZodCheckSizeEquals = /* @__PURE__ */ $constructor("$ZodCheckSizeEquals", (inst, def) => {
  var _a18;
  var _a17;
  $ZodCheck.init(inst, def);
  (_a18 = (_a17 = inst._zod.def).when) != null ? _a18 : _a17.when = (payload) => {
    const val = payload.value;
    return !nullish(val) && val.size !== void 0;
  };
  inst._zod.onattach.push((inst2) => {
    const bag = inst2._zod.bag;
    bag.minimum = def.size;
    bag.maximum = def.size;
    bag.size = def.size;
  });
  inst._zod.check = (payload) => {
    const input = payload.value;
    const size = input.size;
    if (size === def.size)
      return;
    const tooBig = size > def.size;
    payload.issues.push({
      origin: getSizableOrigin(input),
      ...tooBig ? { code: "too_big", maximum: def.size } : { code: "too_small", minimum: def.size },
      inclusive: true,
      exact: true,
      input: payload.value,
      inst,
      continue: !def.abort
    });
  };
});
var $ZodCheckMaxLength = /* @__PURE__ */ $constructor("$ZodCheckMaxLength", (inst, def) => {
  var _a18;
  var _a17;
  $ZodCheck.init(inst, def);
  (_a18 = (_a17 = inst._zod.def).when) != null ? _a18 : _a17.when = (payload) => {
    const val = payload.value;
    return !nullish(val) && val.length !== void 0;
  };
  inst._zod.onattach.push((inst2) => {
    var _a19;
    const curr = (_a19 = inst2._zod.bag.maximum) != null ? _a19 : Number.POSITIVE_INFINITY;
    if (def.maximum < curr)
      inst2._zod.bag.maximum = def.maximum;
  });
  inst._zod.check = (payload) => {
    const input = payload.value;
    const length = input.length;
    if (length <= def.maximum)
      return;
    const origin = getLengthableOrigin(input);
    payload.issues.push({
      origin,
      code: "too_big",
      maximum: def.maximum,
      inclusive: true,
      input,
      inst,
      continue: !def.abort
    });
  };
});
var $ZodCheckMinLength = /* @__PURE__ */ $constructor("$ZodCheckMinLength", (inst, def) => {
  var _a18;
  var _a17;
  $ZodCheck.init(inst, def);
  (_a18 = (_a17 = inst._zod.def).when) != null ? _a18 : _a17.when = (payload) => {
    const val = payload.value;
    return !nullish(val) && val.length !== void 0;
  };
  inst._zod.onattach.push((inst2) => {
    var _a19;
    const curr = (_a19 = inst2._zod.bag.minimum) != null ? _a19 : Number.NEGATIVE_INFINITY;
    if (def.minimum > curr)
      inst2._zod.bag.minimum = def.minimum;
  });
  inst._zod.check = (payload) => {
    const input = payload.value;
    const length = input.length;
    if (length >= def.minimum)
      return;
    const origin = getLengthableOrigin(input);
    payload.issues.push({
      origin,
      code: "too_small",
      minimum: def.minimum,
      inclusive: true,
      input,
      inst,
      continue: !def.abort
    });
  };
});
var $ZodCheckLengthEquals = /* @__PURE__ */ $constructor("$ZodCheckLengthEquals", (inst, def) => {
  var _a18;
  var _a17;
  $ZodCheck.init(inst, def);
  (_a18 = (_a17 = inst._zod.def).when) != null ? _a18 : _a17.when = (payload) => {
    const val = payload.value;
    return !nullish(val) && val.length !== void 0;
  };
  inst._zod.onattach.push((inst2) => {
    const bag = inst2._zod.bag;
    bag.minimum = def.length;
    bag.maximum = def.length;
    bag.length = def.length;
  });
  inst._zod.check = (payload) => {
    const input = payload.value;
    const length = input.length;
    if (length === def.length)
      return;
    const origin = getLengthableOrigin(input);
    const tooBig = length > def.length;
    payload.issues.push({
      origin,
      ...tooBig ? { code: "too_big", maximum: def.length } : { code: "too_small", minimum: def.length },
      inclusive: true,
      exact: true,
      input: payload.value,
      inst,
      continue: !def.abort
    });
  };
});
var $ZodCheckStringFormat = /* @__PURE__ */ $constructor("$ZodCheckStringFormat", (inst, def) => {
  var _a18, _b9;
  var _a17, _b8;
  $ZodCheck.init(inst, def);
  inst._zod.onattach.push((inst2) => {
    var _a19;
    const bag = inst2._zod.bag;
    bag.format = def.format;
    if (def.pattern) {
      (_a19 = bag.patterns) != null ? _a19 : bag.patterns = /* @__PURE__ */ new Set();
      bag.patterns.add(def.pattern);
    }
  });
  if (def.pattern)
    (_a18 = (_a17 = inst._zod).check) != null ? _a18 : _a17.check = (payload) => {
      def.pattern.lastIndex = 0;
      if (def.pattern.test(payload.value))
        return;
      payload.issues.push({
        origin: "string",
        code: "invalid_format",
        format: def.format,
        input: payload.value,
        ...def.pattern ? { pattern: def.pattern.toString() } : {},
        inst,
        continue: !def.abort
      });
    };
  else
    (_b9 = (_b8 = inst._zod).check) != null ? _b9 : _b8.check = () => {
    };
});
var $ZodCheckRegex = /* @__PURE__ */ $constructor("$ZodCheckRegex", (inst, def) => {
  $ZodCheckStringFormat.init(inst, def);
  inst._zod.check = (payload) => {
    def.pattern.lastIndex = 0;
    if (def.pattern.test(payload.value))
      return;
    payload.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: payload.value,
      pattern: def.pattern.toString(),
      inst,
      continue: !def.abort
    });
  };
});
var $ZodCheckLowerCase = /* @__PURE__ */ $constructor("$ZodCheckLowerCase", (inst, def) => {
  var _a17;
  (_a17 = def.pattern) != null ? _a17 : def.pattern = lowercase;
  $ZodCheckStringFormat.init(inst, def);
});
var $ZodCheckUpperCase = /* @__PURE__ */ $constructor("$ZodCheckUpperCase", (inst, def) => {
  var _a17;
  (_a17 = def.pattern) != null ? _a17 : def.pattern = uppercase;
  $ZodCheckStringFormat.init(inst, def);
});
var $ZodCheckIncludes = /* @__PURE__ */ $constructor("$ZodCheckIncludes", (inst, def) => {
  $ZodCheck.init(inst, def);
  const escapedRegex = escapeRegex(def.includes);
  const pattern = new RegExp(typeof def.position === "number" ? "^.{".concat(def.position, "}").concat(escapedRegex) : escapedRegex);
  def.pattern = pattern;
  inst._zod.onattach.push((inst2) => {
    var _a17;
    const bag = inst2._zod.bag;
    (_a17 = bag.patterns) != null ? _a17 : bag.patterns = /* @__PURE__ */ new Set();
    bag.patterns.add(pattern);
  });
  inst._zod.check = (payload) => {
    if (payload.value.includes(def.includes, def.position))
      return;
    payload.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: def.includes,
      input: payload.value,
      inst,
      continue: !def.abort
    });
  };
});
var $ZodCheckStartsWith = /* @__PURE__ */ $constructor("$ZodCheckStartsWith", (inst, def) => {
  var _a17;
  $ZodCheck.init(inst, def);
  const pattern = new RegExp("^".concat(escapeRegex(def.prefix), ".*"));
  (_a17 = def.pattern) != null ? _a17 : def.pattern = pattern;
  inst._zod.onattach.push((inst2) => {
    var _a18;
    const bag = inst2._zod.bag;
    (_a18 = bag.patterns) != null ? _a18 : bag.patterns = /* @__PURE__ */ new Set();
    bag.patterns.add(pattern);
  });
  inst._zod.check = (payload) => {
    if (payload.value.startsWith(def.prefix))
      return;
    payload.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: def.prefix,
      input: payload.value,
      inst,
      continue: !def.abort
    });
  };
});
var $ZodCheckEndsWith = /* @__PURE__ */ $constructor("$ZodCheckEndsWith", (inst, def) => {
  var _a17;
  $ZodCheck.init(inst, def);
  const pattern = new RegExp(".*".concat(escapeRegex(def.suffix), "$"));
  (_a17 = def.pattern) != null ? _a17 : def.pattern = pattern;
  inst._zod.onattach.push((inst2) => {
    var _a18;
    const bag = inst2._zod.bag;
    (_a18 = bag.patterns) != null ? _a18 : bag.patterns = /* @__PURE__ */ new Set();
    bag.patterns.add(pattern);
  });
  inst._zod.check = (payload) => {
    if (payload.value.endsWith(def.suffix))
      return;
    payload.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: def.suffix,
      input: payload.value,
      inst,
      continue: !def.abort
    });
  };
});
function handleCheckPropertyResult(result, payload, property) {
  if (result.issues.length) {
    payload.issues.push(...prefixIssues(property, result.issues));
  }
}
var $ZodCheckProperty = /* @__PURE__ */ $constructor("$ZodCheckProperty", (inst, def) => {
  $ZodCheck.init(inst, def);
  inst._zod.check = (payload) => {
    const result = def.schema._zod.run({
      value: payload.value[def.property],
      issues: []
    }, {});
    if (result instanceof Promise) {
      return result.then((result2) => handleCheckPropertyResult(result2, payload, def.property));
    }
    handleCheckPropertyResult(result, payload, def.property);
    return;
  };
});
var $ZodCheckMimeType = /* @__PURE__ */ $constructor("$ZodCheckMimeType", (inst, def) => {
  $ZodCheck.init(inst, def);
  const mimeSet = new Set(def.mime);
  inst._zod.onattach.push((inst2) => {
    inst2._zod.bag.mime = def.mime;
  });
  inst._zod.check = (payload) => {
    if (mimeSet.has(payload.value.type))
      return;
    payload.issues.push({
      code: "invalid_value",
      values: def.mime,
      input: payload.value.type,
      inst
    });
  };
});
var $ZodCheckOverwrite = /* @__PURE__ */ $constructor("$ZodCheckOverwrite", (inst, def) => {
  $ZodCheck.init(inst, def);
  inst._zod.check = (payload) => {
    payload.value = def.tx(payload.value);
  };
});

// node_modules/zod/v4/core/doc.js
var Doc = class {
  constructor(args = []) {
    this.content = [];
    this.indent = 0;
    if (this)
      this.args = args;
  }
  indented(fn) {
    this.indent += 1;
    fn(this);
    this.indent -= 1;
  }
  write(arg) {
    if (typeof arg === "function") {
      arg(this, { execution: "sync" });
      arg(this, { execution: "async" });
      return;
    }
    const content = arg;
    const lines = content.split("\n").filter((x4) => x4);
    const minIndent = Math.min(...lines.map((x4) => x4.length - x4.trimStart().length));
    const dedented = lines.map((x4) => x4.slice(minIndent)).map((x4) => " ".repeat(this.indent * 2) + x4);
    for (const line of dedented) {
      this.content.push(line);
    }
  }
  compile() {
    var _a17;
    const F4 = Function;
    const args = this == null ? void 0 : this.args;
    const content = (_a17 = this == null ? void 0 : this.content) != null ? _a17 : [""];
    const lines = [...content.map((x4) => "  ".concat(x4))];
    return new F4(...args, lines.join("\n"));
  }
};

// node_modules/zod/v4/core/versions.js
var version = {
  major: 4,
  minor: 0,
  patch: 0
};

// node_modules/zod/v4/core/schemas.js
var $ZodType = /* @__PURE__ */ $constructor("$ZodType", (inst, def) => {
  var _a18, _b8, _c;
  var _a17;
  inst != null ? inst : inst = {};
  inst._zod.def = def;
  inst._zod.bag = inst._zod.bag || {};
  inst._zod.version = version;
  const checks = [...(_a18 = inst._zod.def.checks) != null ? _a18 : []];
  if (inst._zod.traits.has("$ZodCheck")) {
    checks.unshift(inst);
  }
  for (const ch of checks) {
    for (const fn of ch._zod.onattach) {
      fn(inst);
    }
  }
  if (checks.length === 0) {
    (_b8 = (_a17 = inst._zod).deferred) != null ? _b8 : _a17.deferred = [];
    (_c = inst._zod.deferred) == null ? void 0 : _c.push(() => {
      inst._zod.run = inst._zod.parse;
    });
  } else {
    const runChecks = (payload, checks2, ctx) => {
      let isAborted2 = aborted(payload);
      let asyncResult;
      for (const ch of checks2) {
        if (ch._zod.def.when) {
          const shouldRun = ch._zod.def.when(payload);
          if (!shouldRun)
            continue;
        } else if (isAborted2) {
          continue;
        }
        const currLen = payload.issues.length;
        const _4 = ch._zod.check(payload);
        if (_4 instanceof Promise && (ctx == null ? void 0 : ctx.async) === false) {
          throw new $ZodAsyncError();
        }
        if (asyncResult || _4 instanceof Promise) {
          asyncResult = (asyncResult != null ? asyncResult : Promise.resolve()).then(async () => {
            await _4;
            const nextLen = payload.issues.length;
            if (nextLen === currLen)
              return;
            if (!isAborted2)
              isAborted2 = aborted(payload, currLen);
          });
        } else {
          const nextLen = payload.issues.length;
          if (nextLen === currLen)
            continue;
          if (!isAborted2)
            isAborted2 = aborted(payload, currLen);
        }
      }
      if (asyncResult) {
        return asyncResult.then(() => {
          return payload;
        });
      }
      return payload;
    };
    inst._zod.run = (payload, ctx) => {
      const result = inst._zod.parse(payload, ctx);
      if (result instanceof Promise) {
        if (ctx.async === false)
          throw new $ZodAsyncError();
        return result.then((result2) => runChecks(result2, checks, ctx));
      }
      return runChecks(result, checks, ctx);
    };
  }
  inst["~standard"] = {
    validate: (value) => {
      var _a19;
      try {
        const r3 = safeParse(inst, value);
        return r3.success ? { value: r3.data } : { issues: (_a19 = r3.error) == null ? void 0 : _a19.issues };
      } catch (_4) {
        return safeParseAsync(inst, value).then((r3) => {
          var _a20;
          return r3.success ? { value: r3.data } : { issues: (_a20 = r3.error) == null ? void 0 : _a20.issues };
        });
      }
    },
    vendor: "zod",
    version: 1
  };
});
var $ZodString = /* @__PURE__ */ $constructor("$ZodString", (inst, def) => {
  var _a17, _b8, _c;
  $ZodType.init(inst, def);
  inst._zod.pattern = (_c = [...(_b8 = (_a17 = inst == null ? void 0 : inst._zod.bag) == null ? void 0 : _a17.patterns) != null ? _b8 : []].pop()) != null ? _c : string(inst._zod.bag);
  inst._zod.parse = (payload, _4) => {
    if (def.coerce)
      try {
        payload.value = String(payload.value);
      } catch (_5) {
      }
    if (typeof payload.value === "string")
      return payload;
    payload.issues.push({
      expected: "string",
      code: "invalid_type",
      input: payload.value,
      inst
    });
    return payload;
  };
});
var $ZodStringFormat = /* @__PURE__ */ $constructor("$ZodStringFormat", (inst, def) => {
  $ZodCheckStringFormat.init(inst, def);
  $ZodString.init(inst, def);
});
var $ZodGUID = /* @__PURE__ */ $constructor("$ZodGUID", (inst, def) => {
  var _a17;
  (_a17 = def.pattern) != null ? _a17 : def.pattern = guid;
  $ZodStringFormat.init(inst, def);
});
var $ZodUUID = /* @__PURE__ */ $constructor("$ZodUUID", (inst, def) => {
  var _a17, _b8;
  if (def.version) {
    const versionMap = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    };
    const v4 = versionMap[def.version];
    if (v4 === void 0)
      throw new Error('Invalid UUID version: "'.concat(def.version, '"'));
    (_a17 = def.pattern) != null ? _a17 : def.pattern = uuid(v4);
  } else
    (_b8 = def.pattern) != null ? _b8 : def.pattern = uuid();
  $ZodStringFormat.init(inst, def);
});
var $ZodEmail = /* @__PURE__ */ $constructor("$ZodEmail", (inst, def) => {
  var _a17;
  (_a17 = def.pattern) != null ? _a17 : def.pattern = email;
  $ZodStringFormat.init(inst, def);
});
var $ZodURL = /* @__PURE__ */ $constructor("$ZodURL", (inst, def) => {
  $ZodStringFormat.init(inst, def);
  inst._zod.check = (payload) => {
    try {
      const orig = payload.value;
      const url2 = new URL(orig);
      const href = url2.href;
      if (def.hostname) {
        def.hostname.lastIndex = 0;
        if (!def.hostname.test(url2.hostname)) {
          payload.issues.push({
            code: "invalid_format",
            format: "url",
            note: "Invalid hostname",
            pattern: hostname.source,
            input: payload.value,
            inst,
            continue: !def.abort
          });
        }
      }
      if (def.protocol) {
        def.protocol.lastIndex = 0;
        if (!def.protocol.test(url2.protocol.endsWith(":") ? url2.protocol.slice(0, -1) : url2.protocol)) {
          payload.issues.push({
            code: "invalid_format",
            format: "url",
            note: "Invalid protocol",
            pattern: def.protocol.source,
            input: payload.value,
            inst,
            continue: !def.abort
          });
        }
      }
      if (!orig.endsWith("/") && href.endsWith("/")) {
        payload.value = href.slice(0, -1);
      } else {
        payload.value = href;
      }
      return;
    } catch (_4) {
      payload.issues.push({
        code: "invalid_format",
        format: "url",
        input: payload.value,
        inst,
        continue: !def.abort
      });
    }
  };
});
var $ZodEmoji = /* @__PURE__ */ $constructor("$ZodEmoji", (inst, def) => {
  var _a17;
  (_a17 = def.pattern) != null ? _a17 : def.pattern = emoji();
  $ZodStringFormat.init(inst, def);
});
var $ZodNanoID = /* @__PURE__ */ $constructor("$ZodNanoID", (inst, def) => {
  var _a17;
  (_a17 = def.pattern) != null ? _a17 : def.pattern = nanoid;
  $ZodStringFormat.init(inst, def);
});
var $ZodCUID = /* @__PURE__ */ $constructor("$ZodCUID", (inst, def) => {
  var _a17;
  (_a17 = def.pattern) != null ? _a17 : def.pattern = cuid;
  $ZodStringFormat.init(inst, def);
});
var $ZodCUID2 = /* @__PURE__ */ $constructor("$ZodCUID2", (inst, def) => {
  var _a17;
  (_a17 = def.pattern) != null ? _a17 : def.pattern = cuid2;
  $ZodStringFormat.init(inst, def);
});
var $ZodULID = /* @__PURE__ */ $constructor("$ZodULID", (inst, def) => {
  var _a17;
  (_a17 = def.pattern) != null ? _a17 : def.pattern = ulid;
  $ZodStringFormat.init(inst, def);
});
var $ZodXID = /* @__PURE__ */ $constructor("$ZodXID", (inst, def) => {
  var _a17;
  (_a17 = def.pattern) != null ? _a17 : def.pattern = xid;
  $ZodStringFormat.init(inst, def);
});
var $ZodKSUID = /* @__PURE__ */ $constructor("$ZodKSUID", (inst, def) => {
  var _a17;
  (_a17 = def.pattern) != null ? _a17 : def.pattern = ksuid;
  $ZodStringFormat.init(inst, def);
});
var $ZodISODateTime = /* @__PURE__ */ $constructor("$ZodISODateTime", (inst, def) => {
  var _a17;
  (_a17 = def.pattern) != null ? _a17 : def.pattern = datetime(def);
  $ZodStringFormat.init(inst, def);
});
var $ZodISODate = /* @__PURE__ */ $constructor("$ZodISODate", (inst, def) => {
  var _a17;
  (_a17 = def.pattern) != null ? _a17 : def.pattern = date;
  $ZodStringFormat.init(inst, def);
});
var $ZodISOTime = /* @__PURE__ */ $constructor("$ZodISOTime", (inst, def) => {
  var _a17;
  (_a17 = def.pattern) != null ? _a17 : def.pattern = time(def);
  $ZodStringFormat.init(inst, def);
});
var $ZodISODuration = /* @__PURE__ */ $constructor("$ZodISODuration", (inst, def) => {
  var _a17;
  (_a17 = def.pattern) != null ? _a17 : def.pattern = duration;
  $ZodStringFormat.init(inst, def);
});
var $ZodIPv4 = /* @__PURE__ */ $constructor("$ZodIPv4", (inst, def) => {
  var _a17;
  (_a17 = def.pattern) != null ? _a17 : def.pattern = ipv4;
  $ZodStringFormat.init(inst, def);
  inst._zod.onattach.push((inst2) => {
    const bag = inst2._zod.bag;
    bag.format = "ipv4";
  });
});
var $ZodIPv6 = /* @__PURE__ */ $constructor("$ZodIPv6", (inst, def) => {
  var _a17;
  (_a17 = def.pattern) != null ? _a17 : def.pattern = ipv6;
  $ZodStringFormat.init(inst, def);
  inst._zod.onattach.push((inst2) => {
    const bag = inst2._zod.bag;
    bag.format = "ipv6";
  });
  inst._zod.check = (payload) => {
    try {
      new URL("http://[".concat(payload.value, "]"));
    } catch (e4) {
      payload.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: payload.value,
        inst,
        continue: !def.abort
      });
    }
  };
});
var $ZodCIDRv4 = /* @__PURE__ */ $constructor("$ZodCIDRv4", (inst, def) => {
  var _a17;
  (_a17 = def.pattern) != null ? _a17 : def.pattern = cidrv4;
  $ZodStringFormat.init(inst, def);
});
var $ZodCIDRv6 = /* @__PURE__ */ $constructor("$ZodCIDRv6", (inst, def) => {
  var _a17;
  (_a17 = def.pattern) != null ? _a17 : def.pattern = cidrv6;
  $ZodStringFormat.init(inst, def);
  inst._zod.check = (payload) => {
    const [address, prefix] = payload.value.split("/");
    try {
      if (!prefix)
        throw new Error();
      const prefixNum = Number(prefix);
      if ("".concat(prefixNum) !== prefix)
        throw new Error();
      if (prefixNum < 0 || prefixNum > 128)
        throw new Error();
      new URL("http://[".concat(address, "]"));
    } catch (e4) {
      payload.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: payload.value,
        inst,
        continue: !def.abort
      });
    }
  };
});
function isValidBase64(data) {
  if (data === "")
    return true;
  if (data.length % 4 !== 0)
    return false;
  try {
    atob(data);
    return true;
  } catch (e4) {
    return false;
  }
}
var $ZodBase64 = /* @__PURE__ */ $constructor("$ZodBase64", (inst, def) => {
  var _a17;
  (_a17 = def.pattern) != null ? _a17 : def.pattern = base64;
  $ZodStringFormat.init(inst, def);
  inst._zod.onattach.push((inst2) => {
    inst2._zod.bag.contentEncoding = "base64";
  });
  inst._zod.check = (payload) => {
    if (isValidBase64(payload.value))
      return;
    payload.issues.push({
      code: "invalid_format",
      format: "base64",
      input: payload.value,
      inst,
      continue: !def.abort
    });
  };
});
function isValidBase64URL(data) {
  if (!base64url.test(data))
    return false;
  const base643 = data.replace(/[-_]/g, (c4) => c4 === "-" ? "+" : "/");
  const padded = base643.padEnd(Math.ceil(base643.length / 4) * 4, "=");
  return isValidBase64(padded);
}
var $ZodBase64URL = /* @__PURE__ */ $constructor("$ZodBase64URL", (inst, def) => {
  var _a17;
  (_a17 = def.pattern) != null ? _a17 : def.pattern = base64url;
  $ZodStringFormat.init(inst, def);
  inst._zod.onattach.push((inst2) => {
    inst2._zod.bag.contentEncoding = "base64url";
  });
  inst._zod.check = (payload) => {
    if (isValidBase64URL(payload.value))
      return;
    payload.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: payload.value,
      inst,
      continue: !def.abort
    });
  };
});
var $ZodE164 = /* @__PURE__ */ $constructor("$ZodE164", (inst, def) => {
  var _a17;
  (_a17 = def.pattern) != null ? _a17 : def.pattern = e164;
  $ZodStringFormat.init(inst, def);
});
function isValidJWT(token, algorithm = null) {
  try {
    const tokensParts = token.split(".");
    if (tokensParts.length !== 3)
      return false;
    const [header2] = tokensParts;
    if (!header2)
      return false;
    const parsedHeader = JSON.parse(atob(header2));
    if ("typ" in parsedHeader && (parsedHeader == null ? void 0 : parsedHeader.typ) !== "JWT")
      return false;
    if (!parsedHeader.alg)
      return false;
    if (algorithm && (!("alg" in parsedHeader) || parsedHeader.alg !== algorithm))
      return false;
    return true;
  } catch (e4) {
    return false;
  }
}
var $ZodJWT = /* @__PURE__ */ $constructor("$ZodJWT", (inst, def) => {
  $ZodStringFormat.init(inst, def);
  inst._zod.check = (payload) => {
    if (isValidJWT(payload.value, def.alg))
      return;
    payload.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: payload.value,
      inst,
      continue: !def.abort
    });
  };
});
var $ZodCustomStringFormat = /* @__PURE__ */ $constructor("$ZodCustomStringFormat", (inst, def) => {
  $ZodStringFormat.init(inst, def);
  inst._zod.check = (payload) => {
    if (def.fn(payload.value))
      return;
    payload.issues.push({
      code: "invalid_format",
      format: def.format,
      input: payload.value,
      inst,
      continue: !def.abort
    });
  };
});
var $ZodNumber = /* @__PURE__ */ $constructor("$ZodNumber", (inst, def) => {
  var _a17;
  $ZodType.init(inst, def);
  inst._zod.pattern = (_a17 = inst._zod.bag.pattern) != null ? _a17 : number;
  inst._zod.parse = (payload, _ctx) => {
    if (def.coerce)
      try {
        payload.value = Number(payload.value);
      } catch (_4) {
      }
    const input = payload.value;
    if (typeof input === "number" && !Number.isNaN(input) && Number.isFinite(input)) {
      return payload;
    }
    const received = typeof input === "number" ? Number.isNaN(input) ? "NaN" : !Number.isFinite(input) ? "Infinity" : void 0 : void 0;
    payload.issues.push({
      expected: "number",
      code: "invalid_type",
      input,
      inst,
      ...received ? { received } : {}
    });
    return payload;
  };
});
var $ZodNumberFormat = /* @__PURE__ */ $constructor("$ZodNumber", (inst, def) => {
  $ZodCheckNumberFormat.init(inst, def);
  $ZodNumber.init(inst, def);
});
var $ZodBoolean = /* @__PURE__ */ $constructor("$ZodBoolean", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.pattern = boolean;
  inst._zod.parse = (payload, _ctx) => {
    if (def.coerce)
      try {
        payload.value = Boolean(payload.value);
      } catch (_4) {
      }
    const input = payload.value;
    if (typeof input === "boolean")
      return payload;
    payload.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input,
      inst
    });
    return payload;
  };
});
var $ZodBigInt = /* @__PURE__ */ $constructor("$ZodBigInt", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.pattern = bigint;
  inst._zod.parse = (payload, _ctx) => {
    if (def.coerce)
      try {
        payload.value = BigInt(payload.value);
      } catch (_4) {
      }
    if (typeof payload.value === "bigint")
      return payload;
    payload.issues.push({
      expected: "bigint",
      code: "invalid_type",
      input: payload.value,
      inst
    });
    return payload;
  };
});
var $ZodBigIntFormat = /* @__PURE__ */ $constructor("$ZodBigInt", (inst, def) => {
  $ZodCheckBigIntFormat.init(inst, def);
  $ZodBigInt.init(inst, def);
});
var $ZodSymbol = /* @__PURE__ */ $constructor("$ZodSymbol", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, _ctx) => {
    const input = payload.value;
    if (typeof input === "symbol")
      return payload;
    payload.issues.push({
      expected: "symbol",
      code: "invalid_type",
      input,
      inst
    });
    return payload;
  };
});
var $ZodUndefined = /* @__PURE__ */ $constructor("$ZodUndefined", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.pattern = _undefined;
  inst._zod.values = /* @__PURE__ */ new Set([void 0]);
  inst._zod.optin = "optional";
  inst._zod.optout = "optional";
  inst._zod.parse = (payload, _ctx) => {
    const input = payload.value;
    if (typeof input === "undefined")
      return payload;
    payload.issues.push({
      expected: "undefined",
      code: "invalid_type",
      input,
      inst
    });
    return payload;
  };
});
var $ZodNull = /* @__PURE__ */ $constructor("$ZodNull", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.pattern = _null;
  inst._zod.values = /* @__PURE__ */ new Set([null]);
  inst._zod.parse = (payload, _ctx) => {
    const input = payload.value;
    if (input === null)
      return payload;
    payload.issues.push({
      expected: "null",
      code: "invalid_type",
      input,
      inst
    });
    return payload;
  };
});
var $ZodAny = /* @__PURE__ */ $constructor("$ZodAny", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload) => payload;
});
var $ZodUnknown = /* @__PURE__ */ $constructor("$ZodUnknown", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload) => payload;
});
var $ZodNever = /* @__PURE__ */ $constructor("$ZodNever", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, _ctx) => {
    payload.issues.push({
      expected: "never",
      code: "invalid_type",
      input: payload.value,
      inst
    });
    return payload;
  };
});
var $ZodVoid = /* @__PURE__ */ $constructor("$ZodVoid", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, _ctx) => {
    const input = payload.value;
    if (typeof input === "undefined")
      return payload;
    payload.issues.push({
      expected: "void",
      code: "invalid_type",
      input,
      inst
    });
    return payload;
  };
});
var $ZodDate = /* @__PURE__ */ $constructor("$ZodDate", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, _ctx) => {
    if (def.coerce) {
      try {
        payload.value = new Date(payload.value);
      } catch (_err) {
      }
    }
    const input = payload.value;
    const isDate = input instanceof Date;
    const isValidDate = isDate && !Number.isNaN(input.getTime());
    if (isValidDate)
      return payload;
    payload.issues.push({
      expected: "date",
      code: "invalid_type",
      input,
      ...isDate ? { received: "Invalid Date" } : {},
      inst
    });
    return payload;
  };
});
function handleArrayResult(result, final, index) {
  if (result.issues.length) {
    final.issues.push(...prefixIssues(index, result.issues));
  }
  final.value[index] = result.value;
}
var $ZodArray = /* @__PURE__ */ $constructor("$ZodArray", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, ctx) => {
    const input = payload.value;
    if (!Array.isArray(input)) {
      payload.issues.push({
        expected: "array",
        code: "invalid_type",
        input,
        inst
      });
      return payload;
    }
    payload.value = Array(input.length);
    const proms = [];
    for (let i4 = 0; i4 < input.length; i4++) {
      const item11 = input[i4];
      const result = def.element._zod.run({
        value: item11,
        issues: []
      }, ctx);
      if (result instanceof Promise) {
        proms.push(result.then((result2) => handleArrayResult(result2, payload, i4)));
      } else {
        handleArrayResult(result, payload, i4);
      }
    }
    if (proms.length) {
      return Promise.all(proms).then(() => payload);
    }
    return payload;
  };
});
function handleObjectResult(result, final, key2) {
  if (result.issues.length) {
    final.issues.push(...prefixIssues(key2, result.issues));
  }
  final.value[key2] = result.value;
}
function handleOptionalObjectResult(result, final, key2, input) {
  if (result.issues.length) {
    if (input[key2] === void 0) {
      if (key2 in input) {
        final.value[key2] = void 0;
      } else {
        final.value[key2] = result.value;
      }
    } else {
      final.issues.push(...prefixIssues(key2, result.issues));
    }
  } else if (result.value === void 0) {
    if (key2 in input)
      final.value[key2] = void 0;
  } else {
    final.value[key2] = result.value;
  }
}
var $ZodObject = /* @__PURE__ */ $constructor("$ZodObject", (inst, def) => {
  $ZodType.init(inst, def);
  const _normalized = cached(() => {
    const keys = Object.keys(def.shape);
    for (const k4 of keys) {
      if (!(def.shape[k4] instanceof $ZodType)) {
        throw new Error('Invalid element at key "'.concat(k4, '": expected a Zod schema'));
      }
    }
    const okeys = optionalKeys(def.shape);
    return {
      shape: def.shape,
      keys,
      keySet: new Set(keys),
      numKeys: keys.length,
      optionalKeys: new Set(okeys)
    };
  });
  defineLazy(inst._zod, "propValues", () => {
    var _a17;
    const shape = def.shape;
    const propValues = {};
    for (const key2 in shape) {
      const field = shape[key2]._zod;
      if (field.values) {
        (_a17 = propValues[key2]) != null ? _a17 : propValues[key2] = /* @__PURE__ */ new Set();
        for (const v4 of field.values)
          propValues[key2].add(v4);
      }
    }
    return propValues;
  });
  const generateFastpass = (shape) => {
    const doc = new Doc(["shape", "payload", "ctx"]);
    const normalized = _normalized.value;
    const parseStr = (key2) => {
      const k4 = esc(key2);
      return "shape[".concat(k4, "]._zod.run({ value: input[").concat(k4, "], issues: [] }, ctx)");
    };
    doc.write("const input = payload.value;");
    const ids = /* @__PURE__ */ Object.create(null);
    let counter = 0;
    for (const key2 of normalized.keys) {
      ids[key2] = "key_".concat(counter++);
    }
    doc.write("const newResult = {}");
    for (const key2 of normalized.keys) {
      if (normalized.optionalKeys.has(key2)) {
        const id = ids[key2];
        doc.write("const ".concat(id, " = ").concat(parseStr(key2), ";"));
        const k4 = esc(key2);
        doc.write("\n        if (".concat(id, ".issues.length) {\n          if (input[").concat(k4, "] === undefined) {\n            if (").concat(k4, " in input) {\n              newResult[").concat(k4, "] = undefined;\n            }\n          } else {\n            payload.issues = payload.issues.concat(\n              ").concat(id, ".issues.map((iss) => ({\n                ...iss,\n                path: iss.path ? [").concat(k4, ", ...iss.path] : [").concat(k4, "],\n              }))\n            );\n          }\n        } else if (").concat(id, ".value === undefined) {\n          if (").concat(k4, " in input) newResult[").concat(k4, "] = undefined;\n        } else {\n          newResult[").concat(k4, "] = ").concat(id, ".value;\n        }\n        "));
      } else {
        const id = ids[key2];
        doc.write("const ".concat(id, " = ").concat(parseStr(key2), ";"));
        doc.write("\n          if (".concat(id, ".issues.length) payload.issues = payload.issues.concat(").concat(id, ".issues.map(iss => ({\n            ...iss,\n            path: iss.path ? [").concat(esc(key2), ", ...iss.path] : [").concat(esc(key2), "]\n          })));"));
        doc.write("newResult[".concat(esc(key2), "] = ").concat(id, ".value"));
      }
    }
    doc.write("payload.value = newResult;");
    doc.write("return payload;");
    const fn = doc.compile();
    return (payload, ctx) => fn(shape, payload, ctx);
  };
  let fastpass;
  const isObject2 = isObject;
  const jit = !globalConfig.jitless;
  const allowsEval2 = allowsEval;
  const fastEnabled = jit && allowsEval2.value;
  const catchall = def.catchall;
  let value;
  inst._zod.parse = (payload, ctx) => {
    value != null ? value : value = _normalized.value;
    const input = payload.value;
    if (!isObject2(input)) {
      payload.issues.push({
        expected: "object",
        code: "invalid_type",
        input,
        inst
      });
      return payload;
    }
    const proms = [];
    if (jit && fastEnabled && (ctx == null ? void 0 : ctx.async) === false && ctx.jitless !== true) {
      if (!fastpass)
        fastpass = generateFastpass(def.shape);
      payload = fastpass(payload, ctx);
    } else {
      payload.value = {};
      const shape = value.shape;
      for (const key2 of value.keys) {
        const el = shape[key2];
        const r3 = el._zod.run({ value: input[key2], issues: [] }, ctx);
        const isOptional = el._zod.optin === "optional" && el._zod.optout === "optional";
        if (r3 instanceof Promise) {
          proms.push(r3.then((r4) => isOptional ? handleOptionalObjectResult(r4, payload, key2, input) : handleObjectResult(r4, payload, key2)));
        } else if (isOptional) {
          handleOptionalObjectResult(r3, payload, key2, input);
        } else {
          handleObjectResult(r3, payload, key2);
        }
      }
    }
    if (!catchall) {
      return proms.length ? Promise.all(proms).then(() => payload) : payload;
    }
    const unrecognized = [];
    const keySet = value.keySet;
    const _catchall = catchall._zod;
    const t4 = _catchall.def.type;
    for (const key2 of Object.keys(input)) {
      if (keySet.has(key2))
        continue;
      if (t4 === "never") {
        unrecognized.push(key2);
        continue;
      }
      const r3 = _catchall.run({ value: input[key2], issues: [] }, ctx);
      if (r3 instanceof Promise) {
        proms.push(r3.then((r4) => handleObjectResult(r4, payload, key2)));
      } else {
        handleObjectResult(r3, payload, key2);
      }
    }
    if (unrecognized.length) {
      payload.issues.push({
        code: "unrecognized_keys",
        keys: unrecognized,
        input,
        inst
      });
    }
    if (!proms.length)
      return payload;
    return Promise.all(proms).then(() => {
      return payload;
    });
  };
});
function handleUnionResults(results, final, inst, ctx) {
  for (const result of results) {
    if (result.issues.length === 0) {
      final.value = result.value;
      return final;
    }
  }
  final.issues.push({
    code: "invalid_union",
    input: final.value,
    inst,
    errors: results.map((result) => result.issues.map((iss) => finalizeIssue(iss, ctx, config())))
  });
  return final;
}
var $ZodUnion = /* @__PURE__ */ $constructor("$ZodUnion", (inst, def) => {
  $ZodType.init(inst, def);
  defineLazy(inst._zod, "optin", () => def.options.some((o4) => o4._zod.optin === "optional") ? "optional" : void 0);
  defineLazy(inst._zod, "optout", () => def.options.some((o4) => o4._zod.optout === "optional") ? "optional" : void 0);
  defineLazy(inst._zod, "values", () => {
    if (def.options.every((o4) => o4._zod.values)) {
      return new Set(def.options.flatMap((option) => Array.from(option._zod.values)));
    }
    return void 0;
  });
  defineLazy(inst._zod, "pattern", () => {
    if (def.options.every((o4) => o4._zod.pattern)) {
      const patterns = def.options.map((o4) => o4._zod.pattern);
      return new RegExp("^(".concat(patterns.map((p4) => cleanRegex(p4.source)).join("|"), ")$"));
    }
    return void 0;
  });
  inst._zod.parse = (payload, ctx) => {
    let async = false;
    const results = [];
    for (const option of def.options) {
      const result = option._zod.run({
        value: payload.value,
        issues: []
      }, ctx);
      if (result instanceof Promise) {
        results.push(result);
        async = true;
      } else {
        if (result.issues.length === 0)
          return result;
        results.push(result);
      }
    }
    if (!async)
      return handleUnionResults(results, payload, inst, ctx);
    return Promise.all(results).then((results2) => {
      return handleUnionResults(results2, payload, inst, ctx);
    });
  };
});
var $ZodDiscriminatedUnion = /* @__PURE__ */ $constructor("$ZodDiscriminatedUnion", (inst, def) => {
  $ZodUnion.init(inst, def);
  const _super = inst._zod.parse;
  defineLazy(inst._zod, "propValues", () => {
    const propValues = {};
    for (const option of def.options) {
      const pv = option._zod.propValues;
      if (!pv || Object.keys(pv).length === 0)
        throw new Error('Invalid discriminated union option at index "'.concat(def.options.indexOf(option), '"'));
      for (const [k4, v4] of Object.entries(pv)) {
        if (!propValues[k4])
          propValues[k4] = /* @__PURE__ */ new Set();
        for (const val of v4) {
          propValues[k4].add(val);
        }
      }
    }
    return propValues;
  });
  const disc = cached(() => {
    const opts = def.options;
    const map2 = /* @__PURE__ */ new Map();
    for (const o4 of opts) {
      const values = o4._zod.propValues[def.discriminator];
      if (!values || values.size === 0)
        throw new Error('Invalid discriminated union option at index "'.concat(def.options.indexOf(o4), '"'));
      for (const v4 of values) {
        if (map2.has(v4)) {
          throw new Error('Duplicate discriminator value "'.concat(String(v4), '"'));
        }
        map2.set(v4, o4);
      }
    }
    return map2;
  });
  inst._zod.parse = (payload, ctx) => {
    const input = payload.value;
    if (!isObject(input)) {
      payload.issues.push({
        code: "invalid_type",
        expected: "object",
        input,
        inst
      });
      return payload;
    }
    const opt = disc.value.get(input == null ? void 0 : input[def.discriminator]);
    if (opt) {
      return opt._zod.run(payload, ctx);
    }
    if (def.unionFallback) {
      return _super(payload, ctx);
    }
    payload.issues.push({
      code: "invalid_union",
      errors: [],
      note: "No matching discriminator",
      input,
      path: [def.discriminator],
      inst
    });
    return payload;
  };
});
var $ZodIntersection = /* @__PURE__ */ $constructor("$ZodIntersection", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, ctx) => {
    const input = payload.value;
    const left = def.left._zod.run({ value: input, issues: [] }, ctx);
    const right = def.right._zod.run({ value: input, issues: [] }, ctx);
    const async = left instanceof Promise || right instanceof Promise;
    if (async) {
      return Promise.all([left, right]).then(([left2, right2]) => {
        return handleIntersectionResults(payload, left2, right2);
      });
    }
    return handleIntersectionResults(payload, left, right);
  };
});
function mergeValues(a4, b3) {
  if (a4 === b3) {
    return { valid: true, data: a4 };
  }
  if (a4 instanceof Date && b3 instanceof Date && +a4 === +b3) {
    return { valid: true, data: a4 };
  }
  if (isPlainObject2(a4) && isPlainObject2(b3)) {
    const bKeys = Object.keys(b3);
    const sharedKeys = Object.keys(a4).filter((key2) => bKeys.indexOf(key2) !== -1);
    const newObj = { ...a4, ...b3 };
    for (const key2 of sharedKeys) {
      const sharedValue = mergeValues(a4[key2], b3[key2]);
      if (!sharedValue.valid) {
        return {
          valid: false,
          mergeErrorPath: [key2, ...sharedValue.mergeErrorPath]
        };
      }
      newObj[key2] = sharedValue.data;
    }
    return { valid: true, data: newObj };
  }
  if (Array.isArray(a4) && Array.isArray(b3)) {
    if (a4.length !== b3.length) {
      return { valid: false, mergeErrorPath: [] };
    }
    const newArray = [];
    for (let index = 0; index < a4.length; index++) {
      const itemA = a4[index];
      const itemB = b3[index];
      const sharedValue = mergeValues(itemA, itemB);
      if (!sharedValue.valid) {
        return {
          valid: false,
          mergeErrorPath: [index, ...sharedValue.mergeErrorPath]
        };
      }
      newArray.push(sharedValue.data);
    }
    return { valid: true, data: newArray };
  }
  return { valid: false, mergeErrorPath: [] };
}
function handleIntersectionResults(result, left, right) {
  if (left.issues.length) {
    result.issues.push(...left.issues);
  }
  if (right.issues.length) {
    result.issues.push(...right.issues);
  }
  if (aborted(result))
    return result;
  const merged = mergeValues(left.value, right.value);
  if (!merged.valid) {
    throw new Error("Unmergable intersection. Error path: " + "".concat(JSON.stringify(merged.mergeErrorPath)));
  }
  result.value = merged.data;
  return result;
}
var $ZodTuple = /* @__PURE__ */ $constructor("$ZodTuple", (inst, def) => {
  $ZodType.init(inst, def);
  const items = def.items;
  const optStart = items.length - [...items].reverse().findIndex((item11) => item11._zod.optin !== "optional");
  inst._zod.parse = (payload, ctx) => {
    const input = payload.value;
    if (!Array.isArray(input)) {
      payload.issues.push({
        input,
        inst,
        expected: "tuple",
        code: "invalid_type"
      });
      return payload;
    }
    payload.value = [];
    const proms = [];
    if (!def.rest) {
      const tooBig = input.length > items.length;
      const tooSmall = input.length < optStart - 1;
      if (tooBig || tooSmall) {
        payload.issues.push({
          input,
          inst,
          origin: "array",
          ...tooBig ? { code: "too_big", maximum: items.length } : { code: "too_small", minimum: items.length }
        });
        return payload;
      }
    }
    let i4 = -1;
    for (const item11 of items) {
      i4++;
      if (i4 >= input.length) {
        if (i4 >= optStart)
          continue;
      }
      const result = item11._zod.run({
        value: input[i4],
        issues: []
      }, ctx);
      if (result instanceof Promise) {
        proms.push(result.then((result2) => handleTupleResult(result2, payload, i4)));
      } else {
        handleTupleResult(result, payload, i4);
      }
    }
    if (def.rest) {
      const rest = input.slice(items.length);
      for (const el of rest) {
        i4++;
        const result = def.rest._zod.run({
          value: el,
          issues: []
        }, ctx);
        if (result instanceof Promise) {
          proms.push(result.then((result2) => handleTupleResult(result2, payload, i4)));
        } else {
          handleTupleResult(result, payload, i4);
        }
      }
    }
    if (proms.length)
      return Promise.all(proms).then(() => payload);
    return payload;
  };
});
function handleTupleResult(result, final, index) {
  if (result.issues.length) {
    final.issues.push(...prefixIssues(index, result.issues));
  }
  final.value[index] = result.value;
}
var $ZodRecord = /* @__PURE__ */ $constructor("$ZodRecord", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, ctx) => {
    const input = payload.value;
    if (!isPlainObject2(input)) {
      payload.issues.push({
        expected: "record",
        code: "invalid_type",
        input,
        inst
      });
      return payload;
    }
    const proms = [];
    if (def.keyType._zod.values) {
      const values = def.keyType._zod.values;
      payload.value = {};
      for (const key2 of values) {
        if (typeof key2 === "string" || typeof key2 === "number" || typeof key2 === "symbol") {
          const result = def.valueType._zod.run({ value: input[key2], issues: [] }, ctx);
          if (result instanceof Promise) {
            proms.push(result.then((result2) => {
              if (result2.issues.length) {
                payload.issues.push(...prefixIssues(key2, result2.issues));
              }
              payload.value[key2] = result2.value;
            }));
          } else {
            if (result.issues.length) {
              payload.issues.push(...prefixIssues(key2, result.issues));
            }
            payload.value[key2] = result.value;
          }
        }
      }
      let unrecognized;
      for (const key2 in input) {
        if (!values.has(key2)) {
          unrecognized = unrecognized != null ? unrecognized : [];
          unrecognized.push(key2);
        }
      }
      if (unrecognized && unrecognized.length > 0) {
        payload.issues.push({
          code: "unrecognized_keys",
          input,
          inst,
          keys: unrecognized
        });
      }
    } else {
      payload.value = {};
      for (const key2 of Reflect.ownKeys(input)) {
        if (key2 === "__proto__")
          continue;
        const keyResult = def.keyType._zod.run({ value: key2, issues: [] }, ctx);
        if (keyResult instanceof Promise) {
          throw new Error("Async schemas not supported in object keys currently");
        }
        if (keyResult.issues.length) {
          payload.issues.push({
            origin: "record",
            code: "invalid_key",
            issues: keyResult.issues.map((iss) => finalizeIssue(iss, ctx, config())),
            input: key2,
            path: [key2],
            inst
          });
          payload.value[keyResult.value] = keyResult.value;
          continue;
        }
        const result = def.valueType._zod.run({ value: input[key2], issues: [] }, ctx);
        if (result instanceof Promise) {
          proms.push(result.then((result2) => {
            if (result2.issues.length) {
              payload.issues.push(...prefixIssues(key2, result2.issues));
            }
            payload.value[keyResult.value] = result2.value;
          }));
        } else {
          if (result.issues.length) {
            payload.issues.push(...prefixIssues(key2, result.issues));
          }
          payload.value[keyResult.value] = result.value;
        }
      }
    }
    if (proms.length) {
      return Promise.all(proms).then(() => payload);
    }
    return payload;
  };
});
var $ZodMap = /* @__PURE__ */ $constructor("$ZodMap", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, ctx) => {
    const input = payload.value;
    if (!(input instanceof Map)) {
      payload.issues.push({
        expected: "map",
        code: "invalid_type",
        input,
        inst
      });
      return payload;
    }
    const proms = [];
    payload.value = /* @__PURE__ */ new Map();
    for (const [key2, value] of input) {
      const keyResult = def.keyType._zod.run({ value: key2, issues: [] }, ctx);
      const valueResult = def.valueType._zod.run({ value, issues: [] }, ctx);
      if (keyResult instanceof Promise || valueResult instanceof Promise) {
        proms.push(Promise.all([keyResult, valueResult]).then(([keyResult2, valueResult2]) => {
          handleMapResult(keyResult2, valueResult2, payload, key2, input, inst, ctx);
        }));
      } else {
        handleMapResult(keyResult, valueResult, payload, key2, input, inst, ctx);
      }
    }
    if (proms.length)
      return Promise.all(proms).then(() => payload);
    return payload;
  };
});
function handleMapResult(keyResult, valueResult, final, key2, input, inst, ctx) {
  if (keyResult.issues.length) {
    if (propertyKeyTypes.has(typeof key2)) {
      final.issues.push(...prefixIssues(key2, keyResult.issues));
    } else {
      final.issues.push({
        origin: "map",
        code: "invalid_key",
        input,
        inst,
        issues: keyResult.issues.map((iss) => finalizeIssue(iss, ctx, config()))
      });
    }
  }
  if (valueResult.issues.length) {
    if (propertyKeyTypes.has(typeof key2)) {
      final.issues.push(...prefixIssues(key2, valueResult.issues));
    } else {
      final.issues.push({
        origin: "map",
        code: "invalid_element",
        input,
        inst,
        key: key2,
        issues: valueResult.issues.map((iss) => finalizeIssue(iss, ctx, config()))
      });
    }
  }
  final.value.set(keyResult.value, valueResult.value);
}
var $ZodSet = /* @__PURE__ */ $constructor("$ZodSet", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, ctx) => {
    const input = payload.value;
    if (!(input instanceof Set)) {
      payload.issues.push({
        input,
        inst,
        expected: "set",
        code: "invalid_type"
      });
      return payload;
    }
    const proms = [];
    payload.value = /* @__PURE__ */ new Set();
    for (const item11 of input) {
      const result = def.valueType._zod.run({ value: item11, issues: [] }, ctx);
      if (result instanceof Promise) {
        proms.push(result.then((result2) => handleSetResult(result2, payload)));
      } else
        handleSetResult(result, payload);
    }
    if (proms.length)
      return Promise.all(proms).then(() => payload);
    return payload;
  };
});
function handleSetResult(result, final) {
  if (result.issues.length) {
    final.issues.push(...result.issues);
  }
  final.value.add(result.value);
}
var $ZodEnum = /* @__PURE__ */ $constructor("$ZodEnum", (inst, def) => {
  $ZodType.init(inst, def);
  const values = getEnumValues(def.entries);
  inst._zod.values = new Set(values);
  inst._zod.pattern = new RegExp("^(".concat(values.filter((k4) => propertyKeyTypes.has(typeof k4)).map((o4) => typeof o4 === "string" ? escapeRegex(o4) : o4.toString()).join("|"), ")$"));
  inst._zod.parse = (payload, _ctx) => {
    const input = payload.value;
    if (inst._zod.values.has(input)) {
      return payload;
    }
    payload.issues.push({
      code: "invalid_value",
      values,
      input,
      inst
    });
    return payload;
  };
});
var $ZodLiteral = /* @__PURE__ */ $constructor("$ZodLiteral", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.values = new Set(def.values);
  inst._zod.pattern = new RegExp("^(".concat(def.values.map((o4) => typeof o4 === "string" ? escapeRegex(o4) : o4 ? o4.toString() : String(o4)).join("|"), ")$"));
  inst._zod.parse = (payload, _ctx) => {
    const input = payload.value;
    if (inst._zod.values.has(input)) {
      return payload;
    }
    payload.issues.push({
      code: "invalid_value",
      values: def.values,
      input,
      inst
    });
    return payload;
  };
});
var $ZodFile = /* @__PURE__ */ $constructor("$ZodFile", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, _ctx) => {
    const input = payload.value;
    if (input instanceof File)
      return payload;
    payload.issues.push({
      expected: "file",
      code: "invalid_type",
      input,
      inst
    });
    return payload;
  };
});
var $ZodTransform = /* @__PURE__ */ $constructor("$ZodTransform", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, _ctx) => {
    const _out = def.transform(payload.value, payload);
    if (_ctx.async) {
      const output = _out instanceof Promise ? _out : Promise.resolve(_out);
      return output.then((output2) => {
        payload.value = output2;
        return payload;
      });
    }
    if (_out instanceof Promise) {
      throw new $ZodAsyncError();
    }
    payload.value = _out;
    return payload;
  };
});
var $ZodOptional = /* @__PURE__ */ $constructor("$ZodOptional", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.optin = "optional";
  inst._zod.optout = "optional";
  defineLazy(inst._zod, "values", () => {
    return def.innerType._zod.values ? /* @__PURE__ */ new Set([...def.innerType._zod.values, void 0]) : void 0;
  });
  defineLazy(inst._zod, "pattern", () => {
    const pattern = def.innerType._zod.pattern;
    return pattern ? new RegExp("^(".concat(cleanRegex(pattern.source), ")?$")) : void 0;
  });
  inst._zod.parse = (payload, ctx) => {
    if (def.innerType._zod.optin === "optional") {
      return def.innerType._zod.run(payload, ctx);
    }
    if (payload.value === void 0) {
      return payload;
    }
    return def.innerType._zod.run(payload, ctx);
  };
});
var $ZodNullable = /* @__PURE__ */ $constructor("$ZodNullable", (inst, def) => {
  $ZodType.init(inst, def);
  defineLazy(inst._zod, "optin", () => def.innerType._zod.optin);
  defineLazy(inst._zod, "optout", () => def.innerType._zod.optout);
  defineLazy(inst._zod, "pattern", () => {
    const pattern = def.innerType._zod.pattern;
    return pattern ? new RegExp("^(".concat(cleanRegex(pattern.source), "|null)$")) : void 0;
  });
  defineLazy(inst._zod, "values", () => {
    return def.innerType._zod.values ? /* @__PURE__ */ new Set([...def.innerType._zod.values, null]) : void 0;
  });
  inst._zod.parse = (payload, ctx) => {
    if (payload.value === null)
      return payload;
    return def.innerType._zod.run(payload, ctx);
  };
});
var $ZodDefault = /* @__PURE__ */ $constructor("$ZodDefault", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.optin = "optional";
  defineLazy(inst._zod, "values", () => def.innerType._zod.values);
  inst._zod.parse = (payload, ctx) => {
    if (payload.value === void 0) {
      payload.value = def.defaultValue;
      return payload;
    }
    const result = def.innerType._zod.run(payload, ctx);
    if (result instanceof Promise) {
      return result.then((result2) => handleDefaultResult(result2, def));
    }
    return handleDefaultResult(result, def);
  };
});
function handleDefaultResult(payload, def) {
  if (payload.value === void 0) {
    payload.value = def.defaultValue;
  }
  return payload;
}
var $ZodPrefault = /* @__PURE__ */ $constructor("$ZodPrefault", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.optin = "optional";
  defineLazy(inst._zod, "values", () => def.innerType._zod.values);
  inst._zod.parse = (payload, ctx) => {
    if (payload.value === void 0) {
      payload.value = def.defaultValue;
    }
    return def.innerType._zod.run(payload, ctx);
  };
});
var $ZodNonOptional = /* @__PURE__ */ $constructor("$ZodNonOptional", (inst, def) => {
  $ZodType.init(inst, def);
  defineLazy(inst._zod, "values", () => {
    const v4 = def.innerType._zod.values;
    return v4 ? new Set([...v4].filter((x4) => x4 !== void 0)) : void 0;
  });
  inst._zod.parse = (payload, ctx) => {
    const result = def.innerType._zod.run(payload, ctx);
    if (result instanceof Promise) {
      return result.then((result2) => handleNonOptionalResult(result2, inst));
    }
    return handleNonOptionalResult(result, inst);
  };
});
function handleNonOptionalResult(payload, inst) {
  if (!payload.issues.length && payload.value === void 0) {
    payload.issues.push({
      code: "invalid_type",
      expected: "nonoptional",
      input: payload.value,
      inst
    });
  }
  return payload;
}
var $ZodSuccess = /* @__PURE__ */ $constructor("$ZodSuccess", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, ctx) => {
    const result = def.innerType._zod.run(payload, ctx);
    if (result instanceof Promise) {
      return result.then((result2) => {
        payload.value = result2.issues.length === 0;
        return payload;
      });
    }
    payload.value = result.issues.length === 0;
    return payload;
  };
});
var $ZodCatch = /* @__PURE__ */ $constructor("$ZodCatch", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.optin = "optional";
  defineLazy(inst._zod, "optout", () => def.innerType._zod.optout);
  defineLazy(inst._zod, "values", () => def.innerType._zod.values);
  inst._zod.parse = (payload, ctx) => {
    const result = def.innerType._zod.run(payload, ctx);
    if (result instanceof Promise) {
      return result.then((result2) => {
        payload.value = result2.value;
        if (result2.issues.length) {
          payload.value = def.catchValue({
            ...payload,
            error: {
              issues: result2.issues.map((iss) => finalizeIssue(iss, ctx, config()))
            },
            input: payload.value
          });
          payload.issues = [];
        }
        return payload;
      });
    }
    payload.value = result.value;
    if (result.issues.length) {
      payload.value = def.catchValue({
        ...payload,
        error: {
          issues: result.issues.map((iss) => finalizeIssue(iss, ctx, config()))
        },
        input: payload.value
      });
      payload.issues = [];
    }
    return payload;
  };
});
var $ZodNaN = /* @__PURE__ */ $constructor("$ZodNaN", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, _ctx) => {
    if (typeof payload.value !== "number" || !Number.isNaN(payload.value)) {
      payload.issues.push({
        input: payload.value,
        inst,
        expected: "nan",
        code: "invalid_type"
      });
      return payload;
    }
    return payload;
  };
});
var $ZodPipe = /* @__PURE__ */ $constructor("$ZodPipe", (inst, def) => {
  $ZodType.init(inst, def);
  defineLazy(inst._zod, "values", () => def.in._zod.values);
  defineLazy(inst._zod, "optin", () => def.in._zod.optin);
  defineLazy(inst._zod, "optout", () => def.out._zod.optout);
  inst._zod.parse = (payload, ctx) => {
    const left = def.in._zod.run(payload, ctx);
    if (left instanceof Promise) {
      return left.then((left2) => handlePipeResult(left2, def, ctx));
    }
    return handlePipeResult(left, def, ctx);
  };
});
function handlePipeResult(left, def, ctx) {
  if (aborted(left)) {
    return left;
  }
  return def.out._zod.run({ value: left.value, issues: left.issues }, ctx);
}
var $ZodReadonly = /* @__PURE__ */ $constructor("$ZodReadonly", (inst, def) => {
  $ZodType.init(inst, def);
  defineLazy(inst._zod, "propValues", () => def.innerType._zod.propValues);
  defineLazy(inst._zod, "values", () => def.innerType._zod.values);
  defineLazy(inst._zod, "optin", () => def.innerType._zod.optin);
  defineLazy(inst._zod, "optout", () => def.innerType._zod.optout);
  inst._zod.parse = (payload, ctx) => {
    const result = def.innerType._zod.run(payload, ctx);
    if (result instanceof Promise) {
      return result.then(handleReadonlyResult);
    }
    return handleReadonlyResult(result);
  };
});
function handleReadonlyResult(payload) {
  payload.value = Object.freeze(payload.value);
  return payload;
}
var $ZodTemplateLiteral = /* @__PURE__ */ $constructor("$ZodTemplateLiteral", (inst, def) => {
  $ZodType.init(inst, def);
  const regexParts = [];
  for (const part of def.parts) {
    if (part instanceof $ZodType) {
      if (!part._zod.pattern) {
        throw new Error("Invalid template literal part, no pattern found: ".concat([...part._zod.traits].shift()));
      }
      const source = part._zod.pattern instanceof RegExp ? part._zod.pattern.source : part._zod.pattern;
      if (!source)
        throw new Error("Invalid template literal part: ".concat(part._zod.traits));
      const start = source.startsWith("^") ? 1 : 0;
      const end = source.endsWith("$") ? source.length - 1 : source.length;
      regexParts.push(source.slice(start, end));
    } else if (part === null || primitiveTypes.has(typeof part)) {
      regexParts.push(escapeRegex("".concat(part)));
    } else {
      throw new Error("Invalid template literal part: ".concat(part));
    }
  }
  inst._zod.pattern = new RegExp("^".concat(regexParts.join(""), "$"));
  inst._zod.parse = (payload, _ctx) => {
    if (typeof payload.value !== "string") {
      payload.issues.push({
        input: payload.value,
        inst,
        expected: "template_literal",
        code: "invalid_type"
      });
      return payload;
    }
    inst._zod.pattern.lastIndex = 0;
    if (!inst._zod.pattern.test(payload.value)) {
      payload.issues.push({
        input: payload.value,
        inst,
        code: "invalid_format",
        format: "template_literal",
        pattern: inst._zod.pattern.source
      });
      return payload;
    }
    return payload;
  };
});
var $ZodPromise = /* @__PURE__ */ $constructor("$ZodPromise", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, ctx) => {
    return Promise.resolve(payload.value).then((inner) => def.innerType._zod.run({ value: inner, issues: [] }, ctx));
  };
});
var $ZodLazy = /* @__PURE__ */ $constructor("$ZodLazy", (inst, def) => {
  $ZodType.init(inst, def);
  defineLazy(inst._zod, "innerType", () => def.getter());
  defineLazy(inst._zod, "pattern", () => inst._zod.innerType._zod.pattern);
  defineLazy(inst._zod, "propValues", () => inst._zod.innerType._zod.propValues);
  defineLazy(inst._zod, "optin", () => inst._zod.innerType._zod.optin);
  defineLazy(inst._zod, "optout", () => inst._zod.innerType._zod.optout);
  inst._zod.parse = (payload, ctx) => {
    const inner = inst._zod.innerType;
    return inner._zod.run(payload, ctx);
  };
});
var $ZodCustom = /* @__PURE__ */ $constructor("$ZodCustom", (inst, def) => {
  $ZodCheck.init(inst, def);
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, _4) => {
    return payload;
  };
  inst._zod.check = (payload) => {
    const input = payload.value;
    const r3 = def.fn(input);
    if (r3 instanceof Promise) {
      return r3.then((r4) => handleRefineResult(r4, payload, input, inst));
    }
    handleRefineResult(r3, payload, input, inst);
    return;
  };
});
function handleRefineResult(result, payload, input, inst) {
  var _a17;
  if (!result) {
    const _iss = {
      code: "custom",
      input,
      inst,
      // incorporates params.error into issue reporting
      path: [...(_a17 = inst._zod.def.path) != null ? _a17 : []],
      // incorporates params.error into issue reporting
      continue: !inst._zod.def.abort
      // params: inst._zod.def.params,
    };
    if (inst._zod.def.params)
      _iss.params = inst._zod.def.params;
    payload.issues.push(issue(_iss));
  }
}

// node_modules/zod/v4/locales/index.js
var locales_exports = {};
__export(locales_exports, {
  ar: () => ar_default,
  az: () => az_default,
  be: () => be_default,
  ca: () => ca_default,
  cs: () => cs_default,
  de: () => de_default,
  en: () => en_default,
  eo: () => eo_default,
  es: () => es_default,
  fa: () => fa_default,
  fi: () => fi_default,
  fr: () => fr_default,
  frCA: () => fr_CA_default,
  he: () => he_default,
  hu: () => hu_default,
  id: () => id_default,
  it: () => it_default,
  ja: () => ja_default,
  kh: () => kh_default,
  ko: () => ko_default,
  mk: () => mk_default,
  ms: () => ms_default,
  nl: () => nl_default,
  no: () => no_default,
  ota: () => ota_default,
  pl: () => pl_default,
  ps: () => ps_default,
  pt: () => pt_default,
  ru: () => ru_default,
  sl: () => sl_default,
  sv: () => sv_default,
  ta: () => ta_default,
  th: () => th_default,
  tr: () => tr_default,
  ua: () => ua_default,
  ur: () => ur_default,
  vi: () => vi_default,
  zhCN: () => zh_CN_default,
  zhTW: () => zh_TW_default
});

// node_modules/zod/v4/locales/ar.js
var error = () => {
  const Sizable = {
    string: { unit: "حرف", verb: "أن يحوي" },
    file: { unit: "بايت", verb: "أن يحوي" },
    array: { unit: "عنصر", verb: "أن يحوي" },
    set: { unit: "عنصر", verb: "أن يحوي" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "number";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "array";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "مدخل",
    email: "بريد إلكتروني",
    url: "رابط",
    emoji: "إيموجي",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "تاريخ ووقت بمعيار ISO",
    date: "تاريخ بمعيار ISO",
    time: "وقت بمعيار ISO",
    duration: "مدة بمعيار ISO",
    ipv4: "عنوان IPv4",
    ipv6: "عنوان IPv6",
    cidrv4: "مدى عناوين بصيغة IPv4",
    cidrv6: "مدى عناوين بصيغة IPv6",
    base64: "نَص بترميز base64-encoded",
    base64url: "نَص بترميز base64url-encoded",
    json_string: "نَص على هيئة JSON",
    e164: "رقم هاتف بمعيار E.164",
    jwt: "JWT",
    template_literal: "مدخل"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "مدخلات غير مقبولة: يفترض إدخال ".concat(issue2.expected, "، ولكن تم إدخال ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "مدخلات غير مقبولة: يفترض إدخال ".concat(stringifyPrimitive(issue2.values[0]));
        return "اختيار غير مقبول: يتوقع انتقاء أحد هذه الخيارات: ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return " أكبر من اللازم: يفترض أن تكون ".concat((_a17 = issue2.origin) != null ? _a17 : "القيمة", " ").concat(adj, " ").concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "عنصر");
        return "أكبر من اللازم: يفترض أن تكون ".concat((_c = issue2.origin) != null ? _c : "القيمة", " ").concat(adj, " ").concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "أصغر من اللازم: يفترض لـ ".concat(issue2.origin, " أن يكون ").concat(adj, " ").concat(issue2.minimum.toString(), " ").concat(sizing.unit);
        }
        return "أصغر من اللازم: يفترض لـ ".concat(issue2.origin, " أن يكون ").concat(adj, " ").concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with")
          return 'نَص غير مقبول: يجب أن يبدأ بـ "'.concat(issue2.prefix, '"');
        if (_issue.format === "ends_with")
          return 'نَص غير مقبول: يجب أن ينتهي بـ "'.concat(_issue.suffix, '"');
        if (_issue.format === "includes")
          return 'نَص غير مقبول: يجب أن يتضمَّن "'.concat(_issue.includes, '"');
        if (_issue.format === "regex")
          return "نَص غير مقبول: يجب أن يطابق النمط ".concat(_issue.pattern);
        return "".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format, " غير مقبول");
      }
      case "not_multiple_of":
        return "رقم غير مقبول: يجب أن يكون من مضاعفات ".concat(issue2.divisor);
      case "unrecognized_keys":
        return "معرف".concat(issue2.keys.length > 1 ? "ات" : "", " غريب").concat(issue2.keys.length > 1 ? "ة" : "", ": ").concat(joinValues(issue2.keys, "، "));
      case "invalid_key":
        return "معرف غير مقبول في ".concat(issue2.origin);
      case "invalid_union":
        return "مدخل غير مقبول";
      case "invalid_element":
        return "مدخل غير مقبول في ".concat(issue2.origin);
      default:
        return "مدخل غير مقبول";
    }
  };
};
function ar_default() {
  return {
    localeError: error()
  };
}

// node_modules/zod/v4/locales/az.js
var error2 = () => {
  const Sizable = {
    string: { unit: "simvol", verb: "olmalıdır" },
    file: { unit: "bayt", verb: "olmalıdır" },
    array: { unit: "element", verb: "olmalıdır" },
    set: { unit: "element", verb: "olmalıdır" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "number";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "array";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "input",
    email: "email address",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO datetime",
    date: "ISO date",
    time: "ISO time",
    duration: "ISO duration",
    ipv4: "IPv4 address",
    ipv6: "IPv6 address",
    cidrv4: "IPv4 range",
    cidrv6: "IPv6 range",
    base64: "base64-encoded string",
    base64url: "base64url-encoded string",
    json_string: "JSON string",
    e164: "E.164 number",
    jwt: "JWT",
    template_literal: "input"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "Yanlış dəyər: gözlənilən ".concat(issue2.expected, ", daxil olan ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Yanlış dəyər: gözlənilən ".concat(stringifyPrimitive(issue2.values[0]));
        return "Yanlış seçim: aşağıdakılardan biri olmalıdır: ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "Çox böyük: gözlənilən ".concat((_a17 = issue2.origin) != null ? _a17 : "dəyər", " ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "element");
        return "Çox böyük: gözlənilən ".concat((_c = issue2.origin) != null ? _c : "dəyər", " ").concat(adj).concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "Çox kiçik: gözlənilən ".concat(issue2.origin, " ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit);
        return "Çox kiçik: gözlənilən ".concat(issue2.origin, " ").concat(adj).concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with")
          return 'Yanlış mətn: "'.concat(_issue.prefix, '" ilə başlamalıdır');
        if (_issue.format === "ends_with")
          return 'Yanlış mətn: "'.concat(_issue.suffix, '" ilə bitməlidir');
        if (_issue.format === "includes")
          return 'Yanlış mətn: "'.concat(_issue.includes, '" daxil olmalıdır');
        if (_issue.format === "regex")
          return "Yanlış mətn: ".concat(_issue.pattern, " şablonuna uyğun olmalıdır");
        return "Yanlış ".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format);
      }
      case "not_multiple_of":
        return "Yanlış ədəd: ".concat(issue2.divisor, " ilə bölünə bilən olmalıdır");
      case "unrecognized_keys":
        return "Tanınmayan açar".concat(issue2.keys.length > 1 ? "lar" : "", ": ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "".concat(issue2.origin, " daxilində yanlış açar");
      case "invalid_union":
        return "Yanlış dəyər";
      case "invalid_element":
        return "".concat(issue2.origin, " daxilində yanlış dəyər");
      default:
        return "Yanlış dəyər";
    }
  };
};
function az_default() {
  return {
    localeError: error2()
  };
}

// node_modules/zod/v4/locales/be.js
function getBelarusianPlural(count, one, few, many) {
  const absCount = Math.abs(count);
  const lastDigit = absCount % 10;
  const lastTwoDigits = absCount % 100;
  if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
    return many;
  }
  if (lastDigit === 1) {
    return one;
  }
  if (lastDigit >= 2 && lastDigit <= 4) {
    return few;
  }
  return many;
}
var error3 = () => {
  const Sizable = {
    string: {
      unit: {
        one: "сімвал",
        few: "сімвалы",
        many: "сімвалаў"
      },
      verb: "мець"
    },
    array: {
      unit: {
        one: "элемент",
        few: "элементы",
        many: "элементаў"
      },
      verb: "мець"
    },
    set: {
      unit: {
        one: "элемент",
        few: "элементы",
        many: "элементаў"
      },
      verb: "мець"
    },
    file: {
      unit: {
        one: "байт",
        few: "байты",
        many: "байтаў"
      },
      verb: "мець"
    }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "лік";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "масіў";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "увод",
    email: "email адрас",
    url: "URL",
    emoji: "эмодзі",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO дата і час",
    date: "ISO дата",
    time: "ISO час",
    duration: "ISO працягласць",
    ipv4: "IPv4 адрас",
    ipv6: "IPv6 адрас",
    cidrv4: "IPv4 дыяпазон",
    cidrv6: "IPv6 дыяпазон",
    base64: "радок у фармаце base64",
    base64url: "радок у фармаце base64url",
    json_string: "JSON радок",
    e164: "нумар E.164",
    jwt: "JWT",
    template_literal: "увод"
  };
  return (issue2) => {
    var _a17, _b8, _c;
    switch (issue2.code) {
      case "invalid_type":
        return "Няправільны ўвод: чакаўся ".concat(issue2.expected, ", атрымана ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Няправільны ўвод: чакалася ".concat(stringifyPrimitive(issue2.values[0]));
        return "Няправільны варыянт: чакаўся адзін з ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          const maxValue = Number(issue2.maximum);
          const unit = getBelarusianPlural(maxValue, sizing.unit.one, sizing.unit.few, sizing.unit.many);
          return "Занадта вялікі: чакалася, што ".concat((_a17 = issue2.origin) != null ? _a17 : "значэнне", " павінна ").concat(sizing.verb, " ").concat(adj).concat(issue2.maximum.toString(), " ").concat(unit);
        }
        return "Занадта вялікі: чакалася, што ".concat((_b8 = issue2.origin) != null ? _b8 : "значэнне", " павінна быць ").concat(adj).concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          const minValue = Number(issue2.minimum);
          const unit = getBelarusianPlural(minValue, sizing.unit.one, sizing.unit.few, sizing.unit.many);
          return "Занадта малы: чакалася, што ".concat(issue2.origin, " павінна ").concat(sizing.verb, " ").concat(adj).concat(issue2.minimum.toString(), " ").concat(unit);
        }
        return "Занадта малы: чакалася, што ".concat(issue2.origin, " павінна быць ").concat(adj).concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with")
          return 'Няправільны радок: павінен пачынацца з "'.concat(_issue.prefix, '"');
        if (_issue.format === "ends_with")
          return 'Няправільны радок: павінен заканчвацца на "'.concat(_issue.suffix, '"');
        if (_issue.format === "includes")
          return 'Няправільны радок: павінен змяшчаць "'.concat(_issue.includes, '"');
        if (_issue.format === "regex")
          return "Няправільны радок: павінен адпавядаць шаблону ".concat(_issue.pattern);
        return "Няправільны ".concat((_c = Nouns[_issue.format]) != null ? _c : issue2.format);
      }
      case "not_multiple_of":
        return "Няправільны лік: павінен быць кратным ".concat(issue2.divisor);
      case "unrecognized_keys":
        return "Нераспазнаны ".concat(issue2.keys.length > 1 ? "ключы" : "ключ", ": ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "Няправільны ключ у ".concat(issue2.origin);
      case "invalid_union":
        return "Няправільны ўвод";
      case "invalid_element":
        return "Няправільнае значэнне ў ".concat(issue2.origin);
      default:
        return "Няправільны ўвод";
    }
  };
};
function be_default() {
  return {
    localeError: error3()
  };
}

// node_modules/zod/v4/locales/ca.js
var error4 = () => {
  const Sizable = {
    string: { unit: "caràcters", verb: "contenir" },
    file: { unit: "bytes", verb: "contenir" },
    array: { unit: "elements", verb: "contenir" },
    set: { unit: "elements", verb: "contenir" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "number";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "array";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "entrada",
    email: "adreça electrònica",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "data i hora ISO",
    date: "data ISO",
    time: "hora ISO",
    duration: "durada ISO",
    ipv4: "adreça IPv4",
    ipv6: "adreça IPv6",
    cidrv4: "rang IPv4",
    cidrv6: "rang IPv6",
    base64: "cadena codificada en base64",
    base64url: "cadena codificada en base64url",
    json_string: "cadena JSON",
    e164: "número E.164",
    jwt: "JWT",
    template_literal: "entrada"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "Tipus invàlid: s'esperava ".concat(issue2.expected, ", s'ha rebut ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Valor invàlid: s'esperava ".concat(stringifyPrimitive(issue2.values[0]));
        return "Opció invàlida: s'esperava una de ".concat(joinValues(issue2.values, " o "));
      case "too_big": {
        const adj = issue2.inclusive ? "com a màxim" : "menys de";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "Massa gran: s'esperava que ".concat((_a17 = issue2.origin) != null ? _a17 : "el valor", " contingués ").concat(adj, " ").concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "elements");
        return "Massa gran: s'esperava que ".concat((_c = issue2.origin) != null ? _c : "el valor", " fos ").concat(adj, " ").concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? "com a mínim" : "més de";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "Massa petit: s'esperava que ".concat(issue2.origin, " contingués ").concat(adj, " ").concat(issue2.minimum.toString(), " ").concat(sizing.unit);
        }
        return "Massa petit: s'esperava que ".concat(issue2.origin, " fos ").concat(adj, " ").concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with") {
          return 'Format invàlid: ha de començar amb "'.concat(_issue.prefix, '"');
        }
        if (_issue.format === "ends_with")
          return "Format invàlid: ha d'acabar amb \"".concat(_issue.suffix, '"');
        if (_issue.format === "includes")
          return "Format invàlid: ha d'incloure \"".concat(_issue.includes, '"');
        if (_issue.format === "regex")
          return "Format invàlid: ha de coincidir amb el patró ".concat(_issue.pattern);
        return "Format invàlid per a ".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format);
      }
      case "not_multiple_of":
        return "Número invàlid: ha de ser múltiple de ".concat(issue2.divisor);
      case "unrecognized_keys":
        return "Clau".concat(issue2.keys.length > 1 ? "s" : "", " no reconeguda").concat(issue2.keys.length > 1 ? "s" : "", ": ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "Clau invàlida a ".concat(issue2.origin);
      case "invalid_union":
        return "Entrada invàlida";
      case "invalid_element":
        return "Element invàlid a ".concat(issue2.origin);
      default:
        return "Entrada invàlida";
    }
  };
};
function ca_default() {
  return {
    localeError: error4()
  };
}

// node_modules/zod/v4/locales/cs.js
var error5 = () => {
  const Sizable = {
    string: { unit: "znaků", verb: "mít" },
    file: { unit: "bajtů", verb: "mít" },
    array: { unit: "prvků", verb: "mít" },
    set: { unit: "prvků", verb: "mít" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "číslo";
      }
      case "string": {
        return "řetězec";
      }
      case "boolean": {
        return "boolean";
      }
      case "bigint": {
        return "bigint";
      }
      case "function": {
        return "funkce";
      }
      case "symbol": {
        return "symbol";
      }
      case "undefined": {
        return "undefined";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "pole";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "regulární výraz",
    email: "e-mailová adresa",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "datum a čas ve formátu ISO",
    date: "datum ve formátu ISO",
    time: "čas ve formátu ISO",
    duration: "doba trvání ISO",
    ipv4: "IPv4 adresa",
    ipv6: "IPv6 adresa",
    cidrv4: "rozsah IPv4",
    cidrv6: "rozsah IPv6",
    base64: "řetězec zakódovaný ve formátu base64",
    base64url: "řetězec zakódovaný ve formátu base64url",
    json_string: "řetězec ve formátu JSON",
    e164: "číslo E.164",
    jwt: "JWT",
    template_literal: "vstup"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d, _e2, _f, _g;
    switch (issue2.code) {
      case "invalid_type":
        return "Neplatný vstup: očekáváno ".concat(issue2.expected, ", obdrženo ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Neplatný vstup: očekáváno ".concat(stringifyPrimitive(issue2.values[0]));
        return "Neplatná možnost: očekávána jedna z hodnot ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "Hodnota je příliš velká: ".concat((_a17 = issue2.origin) != null ? _a17 : "hodnota", " musí mít ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "prvků");
        }
        return "Hodnota je příliš velká: ".concat((_c = issue2.origin) != null ? _c : "hodnota", " musí být ").concat(adj).concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "Hodnota je příliš malá: ".concat((_d = issue2.origin) != null ? _d : "hodnota", " musí mít ").concat(adj).concat(issue2.minimum.toString(), " ").concat((_e2 = sizing.unit) != null ? _e2 : "prvků");
        }
        return "Hodnota je příliš malá: ".concat((_f = issue2.origin) != null ? _f : "hodnota", " musí být ").concat(adj).concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with")
          return 'Neplatný řetězec: musí začínat na "'.concat(_issue.prefix, '"');
        if (_issue.format === "ends_with")
          return 'Neplatný řetězec: musí končit na "'.concat(_issue.suffix, '"');
        if (_issue.format === "includes")
          return 'Neplatný řetězec: musí obsahovat "'.concat(_issue.includes, '"');
        if (_issue.format === "regex")
          return "Neplatný řetězec: musí odpovídat vzoru ".concat(_issue.pattern);
        return "Neplatný formát ".concat((_g = Nouns[_issue.format]) != null ? _g : issue2.format);
      }
      case "not_multiple_of":
        return "Neplatné číslo: musí být násobkem ".concat(issue2.divisor);
      case "unrecognized_keys":
        return "Neznámé klíče: ".concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "Neplatný klíč v ".concat(issue2.origin);
      case "invalid_union":
        return "Neplatný vstup";
      case "invalid_element":
        return "Neplatná hodnota v ".concat(issue2.origin);
      default:
        return "Neplatný vstup";
    }
  };
};
function cs_default() {
  return {
    localeError: error5()
  };
}

// node_modules/zod/v4/locales/de.js
var error6 = () => {
  const Sizable = {
    string: { unit: "Zeichen", verb: "zu haben" },
    file: { unit: "Bytes", verb: "zu haben" },
    array: { unit: "Elemente", verb: "zu haben" },
    set: { unit: "Elemente", verb: "zu haben" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "Zahl";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "Array";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "Eingabe",
    email: "E-Mail-Adresse",
    url: "URL",
    emoji: "Emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO-Datum und -Uhrzeit",
    date: "ISO-Datum",
    time: "ISO-Uhrzeit",
    duration: "ISO-Dauer",
    ipv4: "IPv4-Adresse",
    ipv6: "IPv6-Adresse",
    cidrv4: "IPv4-Bereich",
    cidrv6: "IPv6-Bereich",
    base64: "Base64-codierter String",
    base64url: "Base64-URL-codierter String",
    json_string: "JSON-String",
    e164: "E.164-Nummer",
    jwt: "JWT",
    template_literal: "Eingabe"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "Ungültige Eingabe: erwartet ".concat(issue2.expected, ", erhalten ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Ungültige Eingabe: erwartet ".concat(stringifyPrimitive(issue2.values[0]));
        return "Ungültige Option: erwartet eine von ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "Zu groß: erwartet, dass ".concat((_a17 = issue2.origin) != null ? _a17 : "Wert", " ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "Elemente", " hat");
        return "Zu groß: erwartet, dass ".concat((_c = issue2.origin) != null ? _c : "Wert", " ").concat(adj).concat(issue2.maximum.toString(), " ist");
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "Zu klein: erwartet, dass ".concat(issue2.origin, " ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit, " hat");
        }
        return "Zu klein: erwartet, dass ".concat(issue2.origin, " ").concat(adj).concat(issue2.minimum.toString(), " ist");
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with")
          return 'Ungültiger String: muss mit "'.concat(_issue.prefix, '" beginnen');
        if (_issue.format === "ends_with")
          return 'Ungültiger String: muss mit "'.concat(_issue.suffix, '" enden');
        if (_issue.format === "includes")
          return 'Ungültiger String: muss "'.concat(_issue.includes, '" enthalten');
        if (_issue.format === "regex")
          return "Ungültiger String: muss dem Muster ".concat(_issue.pattern, " entsprechen");
        return "Ungültig: ".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format);
      }
      case "not_multiple_of":
        return "Ungültige Zahl: muss ein Vielfaches von ".concat(issue2.divisor, " sein");
      case "unrecognized_keys":
        return "".concat(issue2.keys.length > 1 ? "Unbekannte Schlüssel" : "Unbekannter Schlüssel", ": ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "Ungültiger Schlüssel in ".concat(issue2.origin);
      case "invalid_union":
        return "Ungültige Eingabe";
      case "invalid_element":
        return "Ungültiger Wert in ".concat(issue2.origin);
      default:
        return "Ungültige Eingabe";
    }
  };
};
function de_default() {
  return {
    localeError: error6()
  };
}

// node_modules/zod/v4/locales/en.js
var parsedType = (data) => {
  const t4 = typeof data;
  switch (t4) {
    case "number": {
      return Number.isNaN(data) ? "NaN" : "number";
    }
    case "object": {
      if (Array.isArray(data)) {
        return "array";
      }
      if (data === null) {
        return "null";
      }
      if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
        return data.constructor.name;
      }
    }
  }
  return t4;
};
var error7 = () => {
  const Sizable = {
    string: { unit: "characters", verb: "to have" },
    file: { unit: "bytes", verb: "to have" },
    array: { unit: "items", verb: "to have" },
    set: { unit: "items", verb: "to have" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const Nouns = {
    regex: "input",
    email: "email address",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO datetime",
    date: "ISO date",
    time: "ISO time",
    duration: "ISO duration",
    ipv4: "IPv4 address",
    ipv6: "IPv6 address",
    cidrv4: "IPv4 range",
    cidrv6: "IPv6 range",
    base64: "base64-encoded string",
    base64url: "base64url-encoded string",
    json_string: "JSON string",
    e164: "E.164 number",
    jwt: "JWT",
    template_literal: "input"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "Invalid input: expected ".concat(issue2.expected, ", received ").concat(parsedType(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Invalid input: expected ".concat(stringifyPrimitive(issue2.values[0]));
        return "Invalid option: expected one of ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "Too big: expected ".concat((_a17 = issue2.origin) != null ? _a17 : "value", " to have ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "elements");
        return "Too big: expected ".concat((_c = issue2.origin) != null ? _c : "value", " to be ").concat(adj).concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "Too small: expected ".concat(issue2.origin, " to have ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit);
        }
        return "Too small: expected ".concat(issue2.origin, " to be ").concat(adj).concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with") {
          return 'Invalid string: must start with "'.concat(_issue.prefix, '"');
        }
        if (_issue.format === "ends_with")
          return 'Invalid string: must end with "'.concat(_issue.suffix, '"');
        if (_issue.format === "includes")
          return 'Invalid string: must include "'.concat(_issue.includes, '"');
        if (_issue.format === "regex")
          return "Invalid string: must match pattern ".concat(_issue.pattern);
        return "Invalid ".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format);
      }
      case "not_multiple_of":
        return "Invalid number: must be a multiple of ".concat(issue2.divisor);
      case "unrecognized_keys":
        return "Unrecognized key".concat(issue2.keys.length > 1 ? "s" : "", ": ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "Invalid key in ".concat(issue2.origin);
      case "invalid_union":
        return "Invalid input";
      case "invalid_element":
        return "Invalid value in ".concat(issue2.origin);
      default:
        return "Invalid input";
    }
  };
};
function en_default() {
  return {
    localeError: error7()
  };
}

// node_modules/zod/v4/locales/eo.js
var parsedType2 = (data) => {
  const t4 = typeof data;
  switch (t4) {
    case "number": {
      return Number.isNaN(data) ? "NaN" : "nombro";
    }
    case "object": {
      if (Array.isArray(data)) {
        return "tabelo";
      }
      if (data === null) {
        return "senvalora";
      }
      if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
        return data.constructor.name;
      }
    }
  }
  return t4;
};
var error8 = () => {
  const Sizable = {
    string: { unit: "karaktrojn", verb: "havi" },
    file: { unit: "bajtojn", verb: "havi" },
    array: { unit: "elementojn", verb: "havi" },
    set: { unit: "elementojn", verb: "havi" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const Nouns = {
    regex: "enigo",
    email: "retadreso",
    url: "URL",
    emoji: "emoĝio",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO-datotempo",
    date: "ISO-dato",
    time: "ISO-tempo",
    duration: "ISO-daŭro",
    ipv4: "IPv4-adreso",
    ipv6: "IPv6-adreso",
    cidrv4: "IPv4-rango",
    cidrv6: "IPv6-rango",
    base64: "64-ume kodita karaktraro",
    base64url: "URL-64-ume kodita karaktraro",
    json_string: "JSON-karaktraro",
    e164: "E.164-nombro",
    jwt: "JWT",
    template_literal: "enigo"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "Nevalida enigo: atendiĝis ".concat(issue2.expected, ", riceviĝis ").concat(parsedType2(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Nevalida enigo: atendiĝis ".concat(stringifyPrimitive(issue2.values[0]));
        return "Nevalida opcio: atendiĝis unu el ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "Tro granda: atendiĝis ke ".concat((_a17 = issue2.origin) != null ? _a17 : "valoro", " havu ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "elementojn");
        return "Tro granda: atendiĝis ke ".concat((_c = issue2.origin) != null ? _c : "valoro", " havu ").concat(adj).concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "Tro malgranda: atendiĝis ke ".concat(issue2.origin, " havu ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit);
        }
        return "Tro malgranda: atendiĝis ke ".concat(issue2.origin, " estu ").concat(adj).concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with")
          return 'Nevalida karaktraro: devas komenciĝi per "'.concat(_issue.prefix, '"');
        if (_issue.format === "ends_with")
          return 'Nevalida karaktraro: devas finiĝi per "'.concat(_issue.suffix, '"');
        if (_issue.format === "includes")
          return 'Nevalida karaktraro: devas inkluzivi "'.concat(_issue.includes, '"');
        if (_issue.format === "regex")
          return "Nevalida karaktraro: devas kongrui kun la modelo ".concat(_issue.pattern);
        return "Nevalida ".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format);
      }
      case "not_multiple_of":
        return "Nevalida nombro: devas esti oblo de ".concat(issue2.divisor);
      case "unrecognized_keys":
        return "Nekonata".concat(issue2.keys.length > 1 ? "j" : "", " ŝlosilo").concat(issue2.keys.length > 1 ? "j" : "", ": ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "Nevalida ŝlosilo en ".concat(issue2.origin);
      case "invalid_union":
        return "Nevalida enigo";
      case "invalid_element":
        return "Nevalida valoro en ".concat(issue2.origin);
      default:
        return "Nevalida enigo";
    }
  };
};
function eo_default() {
  return {
    localeError: error8()
  };
}

// node_modules/zod/v4/locales/es.js
var error9 = () => {
  const Sizable = {
    string: { unit: "caracteres", verb: "tener" },
    file: { unit: "bytes", verb: "tener" },
    array: { unit: "elementos", verb: "tener" },
    set: { unit: "elementos", verb: "tener" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "número";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "arreglo";
        }
        if (data === null) {
          return "nulo";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "entrada",
    email: "dirección de correo electrónico",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "fecha y hora ISO",
    date: "fecha ISO",
    time: "hora ISO",
    duration: "duración ISO",
    ipv4: "dirección IPv4",
    ipv6: "dirección IPv6",
    cidrv4: "rango IPv4",
    cidrv6: "rango IPv6",
    base64: "cadena codificada en base64",
    base64url: "URL codificada en base64",
    json_string: "cadena JSON",
    e164: "número E.164",
    jwt: "JWT",
    template_literal: "entrada"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "Entrada inválida: se esperaba ".concat(issue2.expected, ", recibido ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Entrada inválida: se esperaba ".concat(stringifyPrimitive(issue2.values[0]));
        return "Opción inválida: se esperaba una de ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "Demasiado grande: se esperaba que ".concat((_a17 = issue2.origin) != null ? _a17 : "valor", " tuviera ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "elementos");
        return "Demasiado grande: se esperaba que ".concat((_c = issue2.origin) != null ? _c : "valor", " fuera ").concat(adj).concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "Demasiado pequeño: se esperaba que ".concat(issue2.origin, " tuviera ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit);
        }
        return "Demasiado pequeño: se esperaba que ".concat(issue2.origin, " fuera ").concat(adj).concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with")
          return 'Cadena inválida: debe comenzar con "'.concat(_issue.prefix, '"');
        if (_issue.format === "ends_with")
          return 'Cadena inválida: debe terminar en "'.concat(_issue.suffix, '"');
        if (_issue.format === "includes")
          return 'Cadena inválida: debe incluir "'.concat(_issue.includes, '"');
        if (_issue.format === "regex")
          return "Cadena inválida: debe coincidir con el patrón ".concat(_issue.pattern);
        return "Inválido ".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format);
      }
      case "not_multiple_of":
        return "Número inválido: debe ser múltiplo de ".concat(issue2.divisor);
      case "unrecognized_keys":
        return "Llave".concat(issue2.keys.length > 1 ? "s" : "", " desconocida").concat(issue2.keys.length > 1 ? "s" : "", ": ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "Llave inválida en ".concat(issue2.origin);
      case "invalid_union":
        return "Entrada inválida";
      case "invalid_element":
        return "Valor inválido en ".concat(issue2.origin);
      default:
        return "Entrada inválida";
    }
  };
};
function es_default() {
  return {
    localeError: error9()
  };
}

// node_modules/zod/v4/locales/fa.js
var error10 = () => {
  const Sizable = {
    string: { unit: "کاراکتر", verb: "داشته باشد" },
    file: { unit: "بایت", verb: "داشته باشد" },
    array: { unit: "آیتم", verb: "داشته باشد" },
    set: { unit: "آیتم", verb: "داشته باشد" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "عدد";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "آرایه";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "ورودی",
    email: "آدرس ایمیل",
    url: "URL",
    emoji: "ایموجی",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "تاریخ و زمان ایزو",
    date: "تاریخ ایزو",
    time: "زمان ایزو",
    duration: "مدت زمان ایزو",
    ipv4: "IPv4 آدرس",
    ipv6: "IPv6 آدرس",
    cidrv4: "IPv4 دامنه",
    cidrv6: "IPv6 دامنه",
    base64: "base64-encoded رشته",
    base64url: "base64url-encoded رشته",
    json_string: "JSON رشته",
    e164: "E.164 عدد",
    jwt: "JWT",
    template_literal: "ورودی"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "ورودی نامعتبر: می‌بایست ".concat(issue2.expected, " می‌بود، ").concat(parsedType4(issue2.input), " دریافت شد");
      case "invalid_value":
        if (issue2.values.length === 1) {
          return "ورودی نامعتبر: می‌بایست ".concat(stringifyPrimitive(issue2.values[0]), " می‌بود");
        }
        return "گزینه نامعتبر: می‌بایست یکی از ".concat(joinValues(issue2.values, "|"), " می‌بود");
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "خیلی بزرگ: ".concat((_a17 = issue2.origin) != null ? _a17 : "مقدار", " باید ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "عنصر", " باشد");
        }
        return "خیلی بزرگ: ".concat((_c = issue2.origin) != null ? _c : "مقدار", " باید ").concat(adj).concat(issue2.maximum.toString(), " باشد");
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "خیلی کوچک: ".concat(issue2.origin, " باید ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit, " باشد");
        }
        return "خیلی کوچک: ".concat(issue2.origin, " باید ").concat(adj).concat(issue2.minimum.toString(), " باشد");
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with") {
          return 'رشته نامعتبر: باید با "'.concat(_issue.prefix, '" شروع شود');
        }
        if (_issue.format === "ends_with") {
          return 'رشته نامعتبر: باید با "'.concat(_issue.suffix, '" تمام شود');
        }
        if (_issue.format === "includes") {
          return 'رشته نامعتبر: باید شامل "'.concat(_issue.includes, '" باشد');
        }
        if (_issue.format === "regex") {
          return "رشته نامعتبر: باید با الگوی ".concat(_issue.pattern, " مطابقت داشته باشد");
        }
        return "".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format, " نامعتبر");
      }
      case "not_multiple_of":
        return "عدد نامعتبر: باید مضرب ".concat(issue2.divisor, " باشد");
      case "unrecognized_keys":
        return "کلید".concat(issue2.keys.length > 1 ? "های" : "", " ناشناس: ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "کلید ناشناس در ".concat(issue2.origin);
      case "invalid_union":
        return "ورودی نامعتبر";
      case "invalid_element":
        return "مقدار نامعتبر در ".concat(issue2.origin);
      default:
        return "ورودی نامعتبر";
    }
  };
};
function fa_default() {
  return {
    localeError: error10()
  };
}

// node_modules/zod/v4/locales/fi.js
var error11 = () => {
  const Sizable = {
    string: { unit: "merkkiä", subject: "merkkijonon" },
    file: { unit: "tavua", subject: "tiedoston" },
    array: { unit: "alkiota", subject: "listan" },
    set: { unit: "alkiota", subject: "joukon" },
    number: { unit: "", subject: "luvun" },
    bigint: { unit: "", subject: "suuren kokonaisluvun" },
    int: { unit: "", subject: "kokonaisluvun" },
    date: { unit: "", subject: "päivämäärän" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "number";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "array";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "säännöllinen lauseke",
    email: "sähköpostiosoite",
    url: "URL-osoite",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO-aikaleima",
    date: "ISO-päivämäärä",
    time: "ISO-aika",
    duration: "ISO-kesto",
    ipv4: "IPv4-osoite",
    ipv6: "IPv6-osoite",
    cidrv4: "IPv4-alue",
    cidrv6: "IPv6-alue",
    base64: "base64-koodattu merkkijono",
    base64url: "base64url-koodattu merkkijono",
    json_string: "JSON-merkkijono",
    e164: "E.164-luku",
    jwt: "JWT",
    template_literal: "templaattimerkkijono"
  };
  return (issue2) => {
    var _a17;
    switch (issue2.code) {
      case "invalid_type":
        return "Virheellinen tyyppi: odotettiin ".concat(issue2.expected, ", oli ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Virheellinen syöte: täytyy olla ".concat(stringifyPrimitive(issue2.values[0]));
        return "Virheellinen valinta: täytyy olla yksi seuraavista: ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "Liian suuri: ".concat(sizing.subject, " täytyy olla ").concat(adj).concat(issue2.maximum.toString(), " ").concat(sizing.unit).trim();
        }
        return "Liian suuri: arvon täytyy olla ".concat(adj).concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "Liian pieni: ".concat(sizing.subject, " täytyy olla ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit).trim();
        }
        return "Liian pieni: arvon täytyy olla ".concat(adj).concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with")
          return 'Virheellinen syöte: täytyy alkaa "'.concat(_issue.prefix, '"');
        if (_issue.format === "ends_with")
          return 'Virheellinen syöte: täytyy loppua "'.concat(_issue.suffix, '"');
        if (_issue.format === "includes")
          return 'Virheellinen syöte: täytyy sisältää "'.concat(_issue.includes, '"');
        if (_issue.format === "regex") {
          return "Virheellinen syöte: täytyy vastata säännöllistä lauseketta ".concat(_issue.pattern);
        }
        return "Virheellinen ".concat((_a17 = Nouns[_issue.format]) != null ? _a17 : issue2.format);
      }
      case "not_multiple_of":
        return "Virheellinen luku: täytyy olla luvun ".concat(issue2.divisor, " monikerta");
      case "unrecognized_keys":
        return "".concat(issue2.keys.length > 1 ? "Tuntemattomat avaimet" : "Tuntematon avain", ": ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "Virheellinen avain tietueessa";
      case "invalid_union":
        return "Virheellinen unioni";
      case "invalid_element":
        return "Virheellinen arvo joukossa";
      default:
        return "Virheellinen syöte";
    }
  };
};
function fi_default() {
  return {
    localeError: error11()
  };
}

// node_modules/zod/v4/locales/fr.js
var error12 = () => {
  const Sizable = {
    string: { unit: "caractères", verb: "avoir" },
    file: { unit: "octets", verb: "avoir" },
    array: { unit: "éléments", verb: "avoir" },
    set: { unit: "éléments", verb: "avoir" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "nombre";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "tableau";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "entrée",
    email: "adresse e-mail",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "date et heure ISO",
    date: "date ISO",
    time: "heure ISO",
    duration: "durée ISO",
    ipv4: "adresse IPv4",
    ipv6: "adresse IPv6",
    cidrv4: "plage IPv4",
    cidrv6: "plage IPv6",
    base64: "chaîne encodée en base64",
    base64url: "chaîne encodée en base64url",
    json_string: "chaîne JSON",
    e164: "numéro E.164",
    jwt: "JWT",
    template_literal: "entrée"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "Entrée invalide : ".concat(issue2.expected, " attendu, ").concat(parsedType4(issue2.input), " reçu");
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Entrée invalide : ".concat(stringifyPrimitive(issue2.values[0]), " attendu");
        return "Option invalide : une valeur parmi ".concat(joinValues(issue2.values, "|"), " attendue");
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "Trop grand : ".concat((_a17 = issue2.origin) != null ? _a17 : "valeur", " doit ").concat(sizing.verb, " ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "élément(s)");
        return "Trop grand : ".concat((_c = issue2.origin) != null ? _c : "valeur", " doit être ").concat(adj).concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "Trop petit : ".concat(issue2.origin, " doit ").concat(sizing.verb, " ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit);
        }
        return "Trop petit : ".concat(issue2.origin, " doit être ").concat(adj).concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with")
          return 'Chaîne invalide : doit commencer par "'.concat(_issue.prefix, '"');
        if (_issue.format === "ends_with")
          return 'Chaîne invalide : doit se terminer par "'.concat(_issue.suffix, '"');
        if (_issue.format === "includes")
          return 'Chaîne invalide : doit inclure "'.concat(_issue.includes, '"');
        if (_issue.format === "regex")
          return "Chaîne invalide : doit correspondre au modèle ".concat(_issue.pattern);
        return "".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format, " invalide");
      }
      case "not_multiple_of":
        return "Nombre invalide : doit être un multiple de ".concat(issue2.divisor);
      case "unrecognized_keys":
        return "Clé".concat(issue2.keys.length > 1 ? "s" : "", " non reconnue").concat(issue2.keys.length > 1 ? "s" : "", " : ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "Clé invalide dans ".concat(issue2.origin);
      case "invalid_union":
        return "Entrée invalide";
      case "invalid_element":
        return "Valeur invalide dans ".concat(issue2.origin);
      default:
        return "Entrée invalide";
    }
  };
};
function fr_default() {
  return {
    localeError: error12()
  };
}

// node_modules/zod/v4/locales/fr-CA.js
var error13 = () => {
  const Sizable = {
    string: { unit: "caractères", verb: "avoir" },
    file: { unit: "octets", verb: "avoir" },
    array: { unit: "éléments", verb: "avoir" },
    set: { unit: "éléments", verb: "avoir" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "number";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "array";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "entrée",
    email: "adresse courriel",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "date-heure ISO",
    date: "date ISO",
    time: "heure ISO",
    duration: "durée ISO",
    ipv4: "adresse IPv4",
    ipv6: "adresse IPv6",
    cidrv4: "plage IPv4",
    cidrv6: "plage IPv6",
    base64: "chaîne encodée en base64",
    base64url: "chaîne encodée en base64url",
    json_string: "chaîne JSON",
    e164: "numéro E.164",
    jwt: "JWT",
    template_literal: "entrée"
  };
  return (issue2) => {
    var _a17, _b8, _c;
    switch (issue2.code) {
      case "invalid_type":
        return "Entrée invalide : attendu ".concat(issue2.expected, ", reçu ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Entrée invalide : attendu ".concat(stringifyPrimitive(issue2.values[0]));
        return "Option invalide : attendu l'une des valeurs suivantes ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "≤" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "Trop grand : attendu que ".concat((_a17 = issue2.origin) != null ? _a17 : "la valeur", " ait ").concat(adj).concat(issue2.maximum.toString(), " ").concat(sizing.unit);
        return "Trop grand : attendu que ".concat((_b8 = issue2.origin) != null ? _b8 : "la valeur", " soit ").concat(adj).concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? "≥" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "Trop petit : attendu que ".concat(issue2.origin, " ait ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit);
        }
        return "Trop petit : attendu que ".concat(issue2.origin, " soit ").concat(adj).concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with") {
          return 'Chaîne invalide : doit commencer par "'.concat(_issue.prefix, '"');
        }
        if (_issue.format === "ends_with")
          return 'Chaîne invalide : doit se terminer par "'.concat(_issue.suffix, '"');
        if (_issue.format === "includes")
          return 'Chaîne invalide : doit inclure "'.concat(_issue.includes, '"');
        if (_issue.format === "regex")
          return "Chaîne invalide : doit correspondre au motif ".concat(_issue.pattern);
        return "".concat((_c = Nouns[_issue.format]) != null ? _c : issue2.format, " invalide");
      }
      case "not_multiple_of":
        return "Nombre invalide : doit être un multiple de ".concat(issue2.divisor);
      case "unrecognized_keys":
        return "Clé".concat(issue2.keys.length > 1 ? "s" : "", " non reconnue").concat(issue2.keys.length > 1 ? "s" : "", " : ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "Clé invalide dans ".concat(issue2.origin);
      case "invalid_union":
        return "Entrée invalide";
      case "invalid_element":
        return "Valeur invalide dans ".concat(issue2.origin);
      default:
        return "Entrée invalide";
    }
  };
};
function fr_CA_default() {
  return {
    localeError: error13()
  };
}

// node_modules/zod/v4/locales/he.js
var error14 = () => {
  const Sizable = {
    string: { unit: "אותיות", verb: "לכלול" },
    file: { unit: "בייטים", verb: "לכלול" },
    array: { unit: "פריטים", verb: "לכלול" },
    set: { unit: "פריטים", verb: "לכלול" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "number";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "array";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "קלט",
    email: "כתובת אימייל",
    url: "כתובת רשת",
    emoji: "אימוג'י",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "תאריך וזמן ISO",
    date: "תאריך ISO",
    time: "זמן ISO",
    duration: "משך זמן ISO",
    ipv4: "כתובת IPv4",
    ipv6: "כתובת IPv6",
    cidrv4: "טווח IPv4",
    cidrv6: "טווח IPv6",
    base64: "מחרוזת בבסיס 64",
    base64url: "מחרוזת בבסיס 64 לכתובות רשת",
    json_string: "מחרוזת JSON",
    e164: "מספר E.164",
    jwt: "JWT",
    template_literal: "קלט"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "קלט לא תקין: צריך ".concat(issue2.expected, ", התקבל ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "קלט לא תקין: צריך ".concat(stringifyPrimitive(issue2.values[0]));
        return "קלט לא תקין: צריך אחת מהאפשרויות  ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "גדול מדי: ".concat((_a17 = issue2.origin) != null ? _a17 : "value", " צריך להיות ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "elements");
        return "גדול מדי: ".concat((_c = issue2.origin) != null ? _c : "value", " צריך להיות ").concat(adj).concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "קטן מדי: ".concat(issue2.origin, " צריך להיות ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit);
        }
        return "קטן מדי: ".concat(issue2.origin, " צריך להיות ").concat(adj).concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with")
          return 'מחרוזת לא תקינה: חייבת להתחיל ב"'.concat(_issue.prefix, '"');
        if (_issue.format === "ends_with")
          return 'מחרוזת לא תקינה: חייבת להסתיים ב "'.concat(_issue.suffix, '"');
        if (_issue.format === "includes")
          return 'מחרוזת לא תקינה: חייבת לכלול "'.concat(_issue.includes, '"');
        if (_issue.format === "regex")
          return "מחרוזת לא תקינה: חייבת להתאים לתבנית ".concat(_issue.pattern);
        return "".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format, " לא תקין");
      }
      case "not_multiple_of":
        return "מספר לא תקין: חייב להיות מכפלה של ".concat(issue2.divisor);
      case "unrecognized_keys":
        return "מפתח".concat(issue2.keys.length > 1 ? "ות" : "", " לא מזוה").concat(issue2.keys.length > 1 ? "ים" : "ה", ": ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "מפתח לא תקין ב".concat(issue2.origin);
      case "invalid_union":
        return "קלט לא תקין";
      case "invalid_element":
        return "ערך לא תקין ב".concat(issue2.origin);
      default:
        return "קלט לא תקין";
    }
  };
};
function he_default() {
  return {
    localeError: error14()
  };
}

// node_modules/zod/v4/locales/hu.js
var error15 = () => {
  const Sizable = {
    string: { unit: "karakter", verb: "legyen" },
    file: { unit: "byte", verb: "legyen" },
    array: { unit: "elem", verb: "legyen" },
    set: { unit: "elem", verb: "legyen" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "szám";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "tömb";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "bemenet",
    email: "email cím",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO időbélyeg",
    date: "ISO dátum",
    time: "ISO idő",
    duration: "ISO időintervallum",
    ipv4: "IPv4 cím",
    ipv6: "IPv6 cím",
    cidrv4: "IPv4 tartomány",
    cidrv6: "IPv6 tartomány",
    base64: "base64-kódolt string",
    base64url: "base64url-kódolt string",
    json_string: "JSON string",
    e164: "E.164 szám",
    jwt: "JWT",
    template_literal: "bemenet"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "Érvénytelen bemenet: a várt érték ".concat(issue2.expected, ", a kapott érték ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Érvénytelen bemenet: a várt érték ".concat(stringifyPrimitive(issue2.values[0]));
        return "Érvénytelen opció: valamelyik érték várt ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "Túl nagy: ".concat((_a17 = issue2.origin) != null ? _a17 : "érték", " mérete túl nagy ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "elem");
        return "Túl nagy: a bemeneti érték ".concat((_c = issue2.origin) != null ? _c : "érték", " túl nagy: ").concat(adj).concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "Túl kicsi: a bemeneti érték ".concat(issue2.origin, " mérete túl kicsi ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit);
        }
        return "Túl kicsi: a bemeneti érték ".concat(issue2.origin, " túl kicsi ").concat(adj).concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with")
          return 'Érvénytelen string: "'.concat(_issue.prefix, '" értékkel kell kezdődnie');
        if (_issue.format === "ends_with")
          return 'Érvénytelen string: "'.concat(_issue.suffix, '" értékkel kell végződnie');
        if (_issue.format === "includes")
          return 'Érvénytelen string: "'.concat(_issue.includes, '" értéket kell tartalmaznia');
        if (_issue.format === "regex")
          return "Érvénytelen string: ".concat(_issue.pattern, " mintának kell megfelelnie");
        return "Érvénytelen ".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format);
      }
      case "not_multiple_of":
        return "Érvénytelen szám: ".concat(issue2.divisor, " többszörösének kell lennie");
      case "unrecognized_keys":
        return "Ismeretlen kulcs".concat(issue2.keys.length > 1 ? "s" : "", ": ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "Érvénytelen kulcs ".concat(issue2.origin);
      case "invalid_union":
        return "Érvénytelen bemenet";
      case "invalid_element":
        return "Érvénytelen érték: ".concat(issue2.origin);
      default:
        return "Érvénytelen bemenet";
    }
  };
};
function hu_default() {
  return {
    localeError: error15()
  };
}

// node_modules/zod/v4/locales/id.js
var error16 = () => {
  const Sizable = {
    string: { unit: "karakter", verb: "memiliki" },
    file: { unit: "byte", verb: "memiliki" },
    array: { unit: "item", verb: "memiliki" },
    set: { unit: "item", verb: "memiliki" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "number";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "array";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "input",
    email: "alamat email",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "tanggal dan waktu format ISO",
    date: "tanggal format ISO",
    time: "jam format ISO",
    duration: "durasi format ISO",
    ipv4: "alamat IPv4",
    ipv6: "alamat IPv6",
    cidrv4: "rentang alamat IPv4",
    cidrv6: "rentang alamat IPv6",
    base64: "string dengan enkode base64",
    base64url: "string dengan enkode base64url",
    json_string: "string JSON",
    e164: "angka E.164",
    jwt: "JWT",
    template_literal: "input"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "Input tidak valid: diharapkan ".concat(issue2.expected, ", diterima ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Input tidak valid: diharapkan ".concat(stringifyPrimitive(issue2.values[0]));
        return "Pilihan tidak valid: diharapkan salah satu dari ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "Terlalu besar: diharapkan ".concat((_a17 = issue2.origin) != null ? _a17 : "value", " memiliki ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "elemen");
        return "Terlalu besar: diharapkan ".concat((_c = issue2.origin) != null ? _c : "value", " menjadi ").concat(adj).concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "Terlalu kecil: diharapkan ".concat(issue2.origin, " memiliki ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit);
        }
        return "Terlalu kecil: diharapkan ".concat(issue2.origin, " menjadi ").concat(adj).concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with")
          return 'String tidak valid: harus dimulai dengan "'.concat(_issue.prefix, '"');
        if (_issue.format === "ends_with")
          return 'String tidak valid: harus berakhir dengan "'.concat(_issue.suffix, '"');
        if (_issue.format === "includes")
          return 'String tidak valid: harus menyertakan "'.concat(_issue.includes, '"');
        if (_issue.format === "regex")
          return "String tidak valid: harus sesuai pola ".concat(_issue.pattern);
        return "".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format, " tidak valid");
      }
      case "not_multiple_of":
        return "Angka tidak valid: harus kelipatan dari ".concat(issue2.divisor);
      case "unrecognized_keys":
        return "Kunci tidak dikenali ".concat(issue2.keys.length > 1 ? "s" : "", ": ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "Kunci tidak valid di ".concat(issue2.origin);
      case "invalid_union":
        return "Input tidak valid";
      case "invalid_element":
        return "Nilai tidak valid di ".concat(issue2.origin);
      default:
        return "Input tidak valid";
    }
  };
};
function id_default() {
  return {
    localeError: error16()
  };
}

// node_modules/zod/v4/locales/it.js
var error17 = () => {
  const Sizable = {
    string: { unit: "caratteri", verb: "avere" },
    file: { unit: "byte", verb: "avere" },
    array: { unit: "elementi", verb: "avere" },
    set: { unit: "elementi", verb: "avere" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "numero";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "vettore";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "input",
    email: "indirizzo email",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "data e ora ISO",
    date: "data ISO",
    time: "ora ISO",
    duration: "durata ISO",
    ipv4: "indirizzo IPv4",
    ipv6: "indirizzo IPv6",
    cidrv4: "intervallo IPv4",
    cidrv6: "intervallo IPv6",
    base64: "stringa codificata in base64",
    base64url: "URL codificata in base64",
    json_string: "stringa JSON",
    e164: "numero E.164",
    jwt: "JWT",
    template_literal: "input"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "Input non valido: atteso ".concat(issue2.expected, ", ricevuto ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Input non valido: atteso ".concat(stringifyPrimitive(issue2.values[0]));
        return "Opzione non valida: atteso uno tra ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "Troppo grande: ".concat((_a17 = issue2.origin) != null ? _a17 : "valore", " deve avere ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "elementi");
        return "Troppo grande: ".concat((_c = issue2.origin) != null ? _c : "valore", " deve essere ").concat(adj).concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "Troppo piccolo: ".concat(issue2.origin, " deve avere ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit);
        }
        return "Troppo piccolo: ".concat(issue2.origin, " deve essere ").concat(adj).concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with")
          return 'Stringa non valida: deve iniziare con "'.concat(_issue.prefix, '"');
        if (_issue.format === "ends_with")
          return 'Stringa non valida: deve terminare con "'.concat(_issue.suffix, '"');
        if (_issue.format === "includes")
          return 'Stringa non valida: deve includere "'.concat(_issue.includes, '"');
        if (_issue.format === "regex")
          return "Stringa non valida: deve corrispondere al pattern ".concat(_issue.pattern);
        return "Invalid ".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format);
      }
      case "not_multiple_of":
        return "Numero non valido: deve essere un multiplo di ".concat(issue2.divisor);
      case "unrecognized_keys":
        return "Chiav".concat(issue2.keys.length > 1 ? "i" : "e", " non riconosciut").concat(issue2.keys.length > 1 ? "e" : "a", ": ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "Chiave non valida in ".concat(issue2.origin);
      case "invalid_union":
        return "Input non valido";
      case "invalid_element":
        return "Valore non valido in ".concat(issue2.origin);
      default:
        return "Input non valido";
    }
  };
};
function it_default() {
  return {
    localeError: error17()
  };
}

// node_modules/zod/v4/locales/ja.js
var error18 = () => {
  const Sizable = {
    string: { unit: "文字", verb: "である" },
    file: { unit: "バイト", verb: "である" },
    array: { unit: "要素", verb: "である" },
    set: { unit: "要素", verb: "である" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "数値";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "配列";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "入力値",
    email: "メールアドレス",
    url: "URL",
    emoji: "絵文字",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO日時",
    date: "ISO日付",
    time: "ISO時刻",
    duration: "ISO期間",
    ipv4: "IPv4アドレス",
    ipv6: "IPv6アドレス",
    cidrv4: "IPv4範囲",
    cidrv6: "IPv6範囲",
    base64: "base64エンコード文字列",
    base64url: "base64urlエンコード文字列",
    json_string: "JSON文字列",
    e164: "E.164番号",
    jwt: "JWT",
    template_literal: "入力値"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "無効な入力: ".concat(issue2.expected, "が期待されましたが、").concat(parsedType4(issue2.input), "が入力されました");
      case "invalid_value":
        if (issue2.values.length === 1)
          return "無効な入力: ".concat(stringifyPrimitive(issue2.values[0]), "が期待されました");
        return "無効な選択: ".concat(joinValues(issue2.values, "、"), "のいずれかである必要があります");
      case "too_big": {
        const adj = issue2.inclusive ? "以下である" : "より小さい";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "大きすぎる値: ".concat((_a17 = issue2.origin) != null ? _a17 : "値", "は").concat(issue2.maximum.toString()).concat((_b8 = sizing.unit) != null ? _b8 : "要素").concat(adj, "必要があります");
        return "大きすぎる値: ".concat((_c = issue2.origin) != null ? _c : "値", "は").concat(issue2.maximum.toString()).concat(adj, "必要があります");
      }
      case "too_small": {
        const adj = issue2.inclusive ? "以上である" : "より大きい";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "小さすぎる値: ".concat(issue2.origin, "は").concat(issue2.minimum.toString()).concat(sizing.unit).concat(adj, "必要があります");
        return "小さすぎる値: ".concat(issue2.origin, "は").concat(issue2.minimum.toString()).concat(adj, "必要があります");
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with")
          return '無効な文字列: "'.concat(_issue.prefix, '"で始まる必要があります');
        if (_issue.format === "ends_with")
          return '無効な文字列: "'.concat(_issue.suffix, '"で終わる必要があります');
        if (_issue.format === "includes")
          return '無効な文字列: "'.concat(_issue.includes, '"を含む必要があります');
        if (_issue.format === "regex")
          return "無効な文字列: パターン".concat(_issue.pattern, "に一致する必要があります");
        return "無効な".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format);
      }
      case "not_multiple_of":
        return "無効な数値: ".concat(issue2.divisor, "の倍数である必要があります");
      case "unrecognized_keys":
        return "認識されていないキー".concat(issue2.keys.length > 1 ? "群" : "", ": ").concat(joinValues(issue2.keys, "、"));
      case "invalid_key":
        return "".concat(issue2.origin, "内の無効なキー");
      case "invalid_union":
        return "無効な入力";
      case "invalid_element":
        return "".concat(issue2.origin, "内の無効な値");
      default:
        return "無効な入力";
    }
  };
};
function ja_default() {
  return {
    localeError: error18()
  };
}

// node_modules/zod/v4/locales/kh.js
var error19 = () => {
  const Sizable = {
    string: { unit: "តួអក្សរ", verb: "គួរមាន" },
    file: { unit: "បៃ", verb: "គួរមាន" },
    array: { unit: "ធាតុ", verb: "គួរមាន" },
    set: { unit: "ធាតុ", verb: "គួរមាន" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "មិនមែនជាលេខ (NaN)" : "លេខ";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "អារេ (Array)";
        }
        if (data === null) {
          return "គ្មានតម្លៃ (null)";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "ទិន្នន័យបញ្ចូល",
    email: "អាសយដ្ឋានអ៊ីមែល",
    url: "URL",
    emoji: "សញ្ញាអារម្មណ៍",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "កាលបរិច្ឆេទ និងម៉ោង ISO",
    date: "កាលបរិច្ឆេទ ISO",
    time: "ម៉ោង ISO",
    duration: "រយៈពេល ISO",
    ipv4: "អាសយដ្ឋាន IPv4",
    ipv6: "អាសយដ្ឋាន IPv6",
    cidrv4: "ដែនអាសយដ្ឋាន IPv4",
    cidrv6: "ដែនអាសយដ្ឋាន IPv6",
    base64: "ខ្សែអក្សរអ៊ិកូដ base64",
    base64url: "ខ្សែអក្សរអ៊ិកូដ base64url",
    json_string: "ខ្សែអក្សរ JSON",
    e164: "លេខ E.164",
    jwt: "JWT",
    template_literal: "ទិន្នន័យបញ្ចូល"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "ទិន្នន័យបញ្ចូលមិនត្រឹមត្រូវ៖ ត្រូវការ ".concat(issue2.expected, " ប៉ុន្តែទទួលបាន ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "ទិន្នន័យបញ្ចូលមិនត្រឹមត្រូវ៖ ត្រូវការ ".concat(stringifyPrimitive(issue2.values[0]));
        return "ជម្រើសមិនត្រឹមត្រូវ៖ ត្រូវជាមួយក្នុងចំណោម ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "ធំពេក៖ ត្រូវការ ".concat((_a17 = issue2.origin) != null ? _a17 : "តម្លៃ", " ").concat(adj, " ").concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "ធាតុ");
        return "ធំពេក៖ ត្រូវការ ".concat((_c = issue2.origin) != null ? _c : "តម្លៃ", " ").concat(adj, " ").concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "តូចពេក៖ ត្រូវការ ".concat(issue2.origin, " ").concat(adj, " ").concat(issue2.minimum.toString(), " ").concat(sizing.unit);
        }
        return "តូចពេក៖ ត្រូវការ ".concat(issue2.origin, " ").concat(adj, " ").concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with") {
          return 'ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវចាប់ផ្តើមដោយ "'.concat(_issue.prefix, '"');
        }
        if (_issue.format === "ends_with")
          return 'ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវបញ្ចប់ដោយ "'.concat(_issue.suffix, '"');
        if (_issue.format === "includes")
          return 'ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវមាន "'.concat(_issue.includes, '"');
        if (_issue.format === "regex")
          return "ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវតែផ្គូផ្គងនឹងទម្រង់ដែលបានកំណត់ ".concat(_issue.pattern);
        return "មិនត្រឹមត្រូវ៖ ".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format);
      }
      case "not_multiple_of":
        return "លេខមិនត្រឹមត្រូវ៖ ត្រូវតែជាពហុគុណនៃ ".concat(issue2.divisor);
      case "unrecognized_keys":
        return "រកឃើញសោមិនស្គាល់៖ ".concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "សោមិនត្រឹមត្រូវនៅក្នុង ".concat(issue2.origin);
      case "invalid_union":
        return "ទិន្នន័យមិនត្រឹមត្រូវ";
      case "invalid_element":
        return "ទិន្នន័យមិនត្រឹមត្រូវនៅក្នុង ".concat(issue2.origin);
      default:
        return "ទិន្នន័យមិនត្រឹមត្រូវ";
    }
  };
};
function kh_default() {
  return {
    localeError: error19()
  };
}

// node_modules/zod/v4/locales/ko.js
var error20 = () => {
  const Sizable = {
    string: { unit: "문자", verb: "to have" },
    file: { unit: "바이트", verb: "to have" },
    array: { unit: "개", verb: "to have" },
    set: { unit: "개", verb: "to have" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "number";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "array";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "입력",
    email: "이메일 주소",
    url: "URL",
    emoji: "이모지",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO 날짜시간",
    date: "ISO 날짜",
    time: "ISO 시간",
    duration: "ISO 기간",
    ipv4: "IPv4 주소",
    ipv6: "IPv6 주소",
    cidrv4: "IPv4 범위",
    cidrv6: "IPv6 범위",
    base64: "base64 인코딩 문자열",
    base64url: "base64url 인코딩 문자열",
    json_string: "JSON 문자열",
    e164: "E.164 번호",
    jwt: "JWT",
    template_literal: "입력"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d, _e2, _f, _g;
    switch (issue2.code) {
      case "invalid_type":
        return "잘못된 입력: 예상 타입은 ".concat(issue2.expected, ", 받은 타입은 ").concat(parsedType4(issue2.input), "입니다");
      case "invalid_value":
        if (issue2.values.length === 1)
          return "잘못된 입력: 값은 ".concat(stringifyPrimitive(issue2.values[0]), " 이어야 합니다");
        return "잘못된 옵션: ".concat(joinValues(issue2.values, "또는 "), " 중 하나여야 합니다");
      case "too_big": {
        const adj = issue2.inclusive ? "이하" : "미만";
        const suffix = adj === "미만" ? "이어야 합니다" : "여야 합니다";
        const sizing = getSizing(issue2.origin);
        const unit = (_a17 = sizing == null ? void 0 : sizing.unit) != null ? _a17 : "요소";
        if (sizing)
          return "".concat((_b8 = issue2.origin) != null ? _b8 : "값", "이 너무 큽니다: ").concat(issue2.maximum.toString()).concat(unit, " ").concat(adj).concat(suffix);
        return "".concat((_c = issue2.origin) != null ? _c : "값", "이 너무 큽니다: ").concat(issue2.maximum.toString(), " ").concat(adj).concat(suffix);
      }
      case "too_small": {
        const adj = issue2.inclusive ? "이상" : "초과";
        const suffix = adj === "이상" ? "이어야 합니다" : "여야 합니다";
        const sizing = getSizing(issue2.origin);
        const unit = (_d = sizing == null ? void 0 : sizing.unit) != null ? _d : "요소";
        if (sizing) {
          return "".concat((_e2 = issue2.origin) != null ? _e2 : "값", "이 너무 작습니다: ").concat(issue2.minimum.toString()).concat(unit, " ").concat(adj).concat(suffix);
        }
        return "".concat((_f = issue2.origin) != null ? _f : "값", "이 너무 작습니다: ").concat(issue2.minimum.toString(), " ").concat(adj).concat(suffix);
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with") {
          return '잘못된 문자열: "'.concat(_issue.prefix, '"(으)로 시작해야 합니다');
        }
        if (_issue.format === "ends_with")
          return '잘못된 문자열: "'.concat(_issue.suffix, '"(으)로 끝나야 합니다');
        if (_issue.format === "includes")
          return '잘못된 문자열: "'.concat(_issue.includes, '"을(를) 포함해야 합니다');
        if (_issue.format === "regex")
          return "잘못된 문자열: 정규식 ".concat(_issue.pattern, " 패턴과 일치해야 합니다");
        return "잘못된 ".concat((_g = Nouns[_issue.format]) != null ? _g : issue2.format);
      }
      case "not_multiple_of":
        return "잘못된 숫자: ".concat(issue2.divisor, "의 배수여야 합니다");
      case "unrecognized_keys":
        return "인식할 수 없는 키: ".concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "잘못된 키: ".concat(issue2.origin);
      case "invalid_union":
        return "잘못된 입력";
      case "invalid_element":
        return "잘못된 값: ".concat(issue2.origin);
      default:
        return "잘못된 입력";
    }
  };
};
function ko_default() {
  return {
    localeError: error20()
  };
}

// node_modules/zod/v4/locales/mk.js
var error21 = () => {
  const Sizable = {
    string: { unit: "знаци", verb: "да имаат" },
    file: { unit: "бајти", verb: "да имаат" },
    array: { unit: "ставки", verb: "да имаат" },
    set: { unit: "ставки", verb: "да имаат" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "број";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "низа";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "внес",
    email: "адреса на е-пошта",
    url: "URL",
    emoji: "емоџи",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO датум и време",
    date: "ISO датум",
    time: "ISO време",
    duration: "ISO времетраење",
    ipv4: "IPv4 адреса",
    ipv6: "IPv6 адреса",
    cidrv4: "IPv4 опсег",
    cidrv6: "IPv6 опсег",
    base64: "base64-енкодирана низа",
    base64url: "base64url-енкодирана низа",
    json_string: "JSON низа",
    e164: "E.164 број",
    jwt: "JWT",
    template_literal: "внес"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "Грешен внес: се очекува ".concat(issue2.expected, ", примено ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Invalid input: expected ".concat(stringifyPrimitive(issue2.values[0]));
        return "Грешана опција: се очекува една ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "Премногу голем: се очекува ".concat((_a17 = issue2.origin) != null ? _a17 : "вредноста", " да има ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "елементи");
        return "Премногу голем: се очекува ".concat((_c = issue2.origin) != null ? _c : "вредноста", " да биде ").concat(adj).concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "Премногу мал: се очекува ".concat(issue2.origin, " да има ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit);
        }
        return "Премногу мал: се очекува ".concat(issue2.origin, " да биде ").concat(adj).concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with") {
          return 'Неважечка низа: мора да започнува со "'.concat(_issue.prefix, '"');
        }
        if (_issue.format === "ends_with")
          return 'Неважечка низа: мора да завршува со "'.concat(_issue.suffix, '"');
        if (_issue.format === "includes")
          return 'Неважечка низа: мора да вклучува "'.concat(_issue.includes, '"');
        if (_issue.format === "regex")
          return "Неважечка низа: мора да одгоара на патернот ".concat(_issue.pattern);
        return "Invalid ".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format);
      }
      case "not_multiple_of":
        return "Грешен број: мора да биде делив со ".concat(issue2.divisor);
      case "unrecognized_keys":
        return "".concat(issue2.keys.length > 1 ? "Непрепознаени клучеви" : "Непрепознаен клуч", ": ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "Грешен клуч во ".concat(issue2.origin);
      case "invalid_union":
        return "Грешен внес";
      case "invalid_element":
        return "Грешна вредност во ".concat(issue2.origin);
      default:
        return "Грешен внес";
    }
  };
};
function mk_default() {
  return {
    localeError: error21()
  };
}

// node_modules/zod/v4/locales/ms.js
var error22 = () => {
  const Sizable = {
    string: { unit: "aksara", verb: "mempunyai" },
    file: { unit: "bait", verb: "mempunyai" },
    array: { unit: "elemen", verb: "mempunyai" },
    set: { unit: "elemen", verb: "mempunyai" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "nombor";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "array";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "input",
    email: "alamat e-mel",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "tarikh masa ISO",
    date: "tarikh ISO",
    time: "masa ISO",
    duration: "tempoh ISO",
    ipv4: "alamat IPv4",
    ipv6: "alamat IPv6",
    cidrv4: "julat IPv4",
    cidrv6: "julat IPv6",
    base64: "string dikodkan base64",
    base64url: "string dikodkan base64url",
    json_string: "string JSON",
    e164: "nombor E.164",
    jwt: "JWT",
    template_literal: "input"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "Input tidak sah: dijangka ".concat(issue2.expected, ", diterima ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Input tidak sah: dijangka ".concat(stringifyPrimitive(issue2.values[0]));
        return "Pilihan tidak sah: dijangka salah satu daripada ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "Terlalu besar: dijangka ".concat((_a17 = issue2.origin) != null ? _a17 : "nilai", " ").concat(sizing.verb, " ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "elemen");
        return "Terlalu besar: dijangka ".concat((_c = issue2.origin) != null ? _c : "nilai", " adalah ").concat(adj).concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "Terlalu kecil: dijangka ".concat(issue2.origin, " ").concat(sizing.verb, " ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit);
        }
        return "Terlalu kecil: dijangka ".concat(issue2.origin, " adalah ").concat(adj).concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with")
          return 'String tidak sah: mesti bermula dengan "'.concat(_issue.prefix, '"');
        if (_issue.format === "ends_with")
          return 'String tidak sah: mesti berakhir dengan "'.concat(_issue.suffix, '"');
        if (_issue.format === "includes")
          return 'String tidak sah: mesti mengandungi "'.concat(_issue.includes, '"');
        if (_issue.format === "regex")
          return "String tidak sah: mesti sepadan dengan corak ".concat(_issue.pattern);
        return "".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format, " tidak sah");
      }
      case "not_multiple_of":
        return "Nombor tidak sah: perlu gandaan ".concat(issue2.divisor);
      case "unrecognized_keys":
        return "Kunci tidak dikenali: ".concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "Kunci tidak sah dalam ".concat(issue2.origin);
      case "invalid_union":
        return "Input tidak sah";
      case "invalid_element":
        return "Nilai tidak sah dalam ".concat(issue2.origin);
      default:
        return "Input tidak sah";
    }
  };
};
function ms_default() {
  return {
    localeError: error22()
  };
}

// node_modules/zod/v4/locales/nl.js
var error23 = () => {
  const Sizable = {
    string: { unit: "tekens" },
    file: { unit: "bytes" },
    array: { unit: "elementen" },
    set: { unit: "elementen" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "getal";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "array";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "invoer",
    email: "emailadres",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO datum en tijd",
    date: "ISO datum",
    time: "ISO tijd",
    duration: "ISO duur",
    ipv4: "IPv4-adres",
    ipv6: "IPv6-adres",
    cidrv4: "IPv4-bereik",
    cidrv6: "IPv6-bereik",
    base64: "base64-gecodeerde tekst",
    base64url: "base64 URL-gecodeerde tekst",
    json_string: "JSON string",
    e164: "E.164-nummer",
    jwt: "JWT",
    template_literal: "invoer"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "Ongeldige invoer: verwacht ".concat(issue2.expected, ", ontving ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Ongeldige invoer: verwacht ".concat(stringifyPrimitive(issue2.values[0]));
        return "Ongeldige optie: verwacht één van ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "Te lang: verwacht dat ".concat((_a17 = issue2.origin) != null ? _a17 : "waarde", " ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "elementen", " bevat");
        return "Te lang: verwacht dat ".concat((_c = issue2.origin) != null ? _c : "waarde", " ").concat(adj).concat(issue2.maximum.toString(), " is");
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "Te kort: verwacht dat ".concat(issue2.origin, " ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit, " bevat");
        }
        return "Te kort: verwacht dat ".concat(issue2.origin, " ").concat(adj).concat(issue2.minimum.toString(), " is");
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with") {
          return 'Ongeldige tekst: moet met "'.concat(_issue.prefix, '" beginnen');
        }
        if (_issue.format === "ends_with")
          return 'Ongeldige tekst: moet op "'.concat(_issue.suffix, '" eindigen');
        if (_issue.format === "includes")
          return 'Ongeldige tekst: moet "'.concat(_issue.includes, '" bevatten');
        if (_issue.format === "regex")
          return "Ongeldige tekst: moet overeenkomen met patroon ".concat(_issue.pattern);
        return "Ongeldig: ".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format);
      }
      case "not_multiple_of":
        return "Ongeldig getal: moet een veelvoud van ".concat(issue2.divisor, " zijn");
      case "unrecognized_keys":
        return "Onbekende key".concat(issue2.keys.length > 1 ? "s" : "", ": ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "Ongeldige key in ".concat(issue2.origin);
      case "invalid_union":
        return "Ongeldige invoer";
      case "invalid_element":
        return "Ongeldige waarde in ".concat(issue2.origin);
      default:
        return "Ongeldige invoer";
    }
  };
};
function nl_default() {
  return {
    localeError: error23()
  };
}

// node_modules/zod/v4/locales/no.js
var error24 = () => {
  const Sizable = {
    string: { unit: "tegn", verb: "å ha" },
    file: { unit: "bytes", verb: "å ha" },
    array: { unit: "elementer", verb: "å inneholde" },
    set: { unit: "elementer", verb: "å inneholde" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "tall";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "liste";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "input",
    email: "e-postadresse",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO dato- og klokkeslett",
    date: "ISO-dato",
    time: "ISO-klokkeslett",
    duration: "ISO-varighet",
    ipv4: "IPv4-område",
    ipv6: "IPv6-område",
    cidrv4: "IPv4-spekter",
    cidrv6: "IPv6-spekter",
    base64: "base64-enkodet streng",
    base64url: "base64url-enkodet streng",
    json_string: "JSON-streng",
    e164: "E.164-nummer",
    jwt: "JWT",
    template_literal: "input"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "Ugyldig input: forventet ".concat(issue2.expected, ", fikk ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Ugyldig verdi: forventet ".concat(stringifyPrimitive(issue2.values[0]));
        return "Ugyldig valg: forventet en av ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "For stor(t): forventet ".concat((_a17 = issue2.origin) != null ? _a17 : "value", " til å ha ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "elementer");
        return "For stor(t): forventet ".concat((_c = issue2.origin) != null ? _c : "value", " til å ha ").concat(adj).concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "For lite(n): forventet ".concat(issue2.origin, " til å ha ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit);
        }
        return "For lite(n): forventet ".concat(issue2.origin, " til å ha ").concat(adj).concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with")
          return 'Ugyldig streng: må starte med "'.concat(_issue.prefix, '"');
        if (_issue.format === "ends_with")
          return 'Ugyldig streng: må ende med "'.concat(_issue.suffix, '"');
        if (_issue.format === "includes")
          return 'Ugyldig streng: må inneholde "'.concat(_issue.includes, '"');
        if (_issue.format === "regex")
          return "Ugyldig streng: må matche mønsteret ".concat(_issue.pattern);
        return "Ugyldig ".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format);
      }
      case "not_multiple_of":
        return "Ugyldig tall: må være et multiplum av ".concat(issue2.divisor);
      case "unrecognized_keys":
        return "".concat(issue2.keys.length > 1 ? "Ukjente nøkler" : "Ukjent nøkkel", ": ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "Ugyldig nøkkel i ".concat(issue2.origin);
      case "invalid_union":
        return "Ugyldig input";
      case "invalid_element":
        return "Ugyldig verdi i ".concat(issue2.origin);
      default:
        return "Ugyldig input";
    }
  };
};
function no_default() {
  return {
    localeError: error24()
  };
}

// node_modules/zod/v4/locales/ota.js
var error25 = () => {
  const Sizable = {
    string: { unit: "harf", verb: "olmalıdır" },
    file: { unit: "bayt", verb: "olmalıdır" },
    array: { unit: "unsur", verb: "olmalıdır" },
    set: { unit: "unsur", verb: "olmalıdır" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "numara";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "saf";
        }
        if (data === null) {
          return "gayb";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "giren",
    email: "epostagâh",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO hengâmı",
    date: "ISO tarihi",
    time: "ISO zamanı",
    duration: "ISO müddeti",
    ipv4: "IPv4 nişânı",
    ipv6: "IPv6 nişânı",
    cidrv4: "IPv4 menzili",
    cidrv6: "IPv6 menzili",
    base64: "base64-şifreli metin",
    base64url: "base64url-şifreli metin",
    json_string: "JSON metin",
    e164: "E.164 sayısı",
    jwt: "JWT",
    template_literal: "giren"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "Fâsit giren: umulan ".concat(issue2.expected, ", alınan ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Fâsit giren: umulan ".concat(stringifyPrimitive(issue2.values[0]));
        return "Fâsit tercih: mûteberler ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "Fazla büyük: ".concat((_a17 = issue2.origin) != null ? _a17 : "value", ", ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "elements", " sahip olmalıydı.");
        return "Fazla büyük: ".concat((_c = issue2.origin) != null ? _c : "value", ", ").concat(adj).concat(issue2.maximum.toString(), " olmalıydı.");
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "Fazla küçük: ".concat(issue2.origin, ", ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit, " sahip olmalıydı.");
        }
        return "Fazla küçük: ".concat(issue2.origin, ", ").concat(adj).concat(issue2.minimum.toString(), " olmalıydı.");
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with")
          return 'Fâsit metin: "'.concat(_issue.prefix, '" ile başlamalı.');
        if (_issue.format === "ends_with")
          return 'Fâsit metin: "'.concat(_issue.suffix, '" ile bitmeli.');
        if (_issue.format === "includes")
          return 'Fâsit metin: "'.concat(_issue.includes, '" ihtivâ etmeli.');
        if (_issue.format === "regex")
          return "Fâsit metin: ".concat(_issue.pattern, " nakşına uymalı.");
        return "Fâsit ".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format);
      }
      case "not_multiple_of":
        return "Fâsit sayı: ".concat(issue2.divisor, " katı olmalıydı.");
      case "unrecognized_keys":
        return "Tanınmayan anahtar ".concat(issue2.keys.length > 1 ? "s" : "", ": ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "".concat(issue2.origin, " için tanınmayan anahtar var.");
      case "invalid_union":
        return "Giren tanınamadı.";
      case "invalid_element":
        return "".concat(issue2.origin, " için tanınmayan kıymet var.");
      default:
        return "Kıymet tanınamadı.";
    }
  };
};
function ota_default() {
  return {
    localeError: error25()
  };
}

// node_modules/zod/v4/locales/ps.js
var error26 = () => {
  const Sizable = {
    string: { unit: "توکي", verb: "ولري" },
    file: { unit: "بایټس", verb: "ولري" },
    array: { unit: "توکي", verb: "ولري" },
    set: { unit: "توکي", verb: "ولري" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "عدد";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "ارې";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "ورودي",
    email: "بریښنالیک",
    url: "یو آر ال",
    emoji: "ایموجي",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "نیټه او وخت",
    date: "نېټه",
    time: "وخت",
    duration: "موده",
    ipv4: "د IPv4 پته",
    ipv6: "د IPv6 پته",
    cidrv4: "د IPv4 ساحه",
    cidrv6: "د IPv6 ساحه",
    base64: "base64-encoded متن",
    base64url: "base64url-encoded متن",
    json_string: "JSON متن",
    e164: "د E.164 شمېره",
    jwt: "JWT",
    template_literal: "ورودي"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "ناسم ورودي: باید ".concat(issue2.expected, " وای, مګر ").concat(parsedType4(issue2.input), " ترلاسه شو");
      case "invalid_value":
        if (issue2.values.length === 1) {
          return "ناسم ورودي: باید ".concat(stringifyPrimitive(issue2.values[0]), " وای");
        }
        return "ناسم انتخاب: باید یو له ".concat(joinValues(issue2.values, "|"), " څخه وای");
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "ډیر لوی: ".concat((_a17 = issue2.origin) != null ? _a17 : "ارزښت", " باید ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "عنصرونه", " ولري");
        }
        return "ډیر لوی: ".concat((_c = issue2.origin) != null ? _c : "ارزښت", " باید ").concat(adj).concat(issue2.maximum.toString(), " وي");
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "ډیر کوچنی: ".concat(issue2.origin, " باید ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit, " ولري");
        }
        return "ډیر کوچنی: ".concat(issue2.origin, " باید ").concat(adj).concat(issue2.minimum.toString(), " وي");
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with") {
          return 'ناسم متن: باید د "'.concat(_issue.prefix, '" سره پیل شي');
        }
        if (_issue.format === "ends_with") {
          return 'ناسم متن: باید د "'.concat(_issue.suffix, '" سره پای ته ورسيږي');
        }
        if (_issue.format === "includes") {
          return 'ناسم متن: باید "'.concat(_issue.includes, '" ولري');
        }
        if (_issue.format === "regex") {
          return "ناسم متن: باید د ".concat(_issue.pattern, " سره مطابقت ولري");
        }
        return "".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format, " ناسم دی");
      }
      case "not_multiple_of":
        return "ناسم عدد: باید د ".concat(issue2.divisor, " مضرب وي");
      case "unrecognized_keys":
        return "ناسم ".concat(issue2.keys.length > 1 ? "کلیډونه" : "کلیډ", ": ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "ناسم کلیډ په ".concat(issue2.origin, " کې");
      case "invalid_union":
        return "ناسمه ورودي";
      case "invalid_element":
        return "ناسم عنصر په ".concat(issue2.origin, " کې");
      default:
        return "ناسمه ورودي";
    }
  };
};
function ps_default() {
  return {
    localeError: error26()
  };
}

// node_modules/zod/v4/locales/pl.js
var error27 = () => {
  const Sizable = {
    string: { unit: "znaków", verb: "mieć" },
    file: { unit: "bajtów", verb: "mieć" },
    array: { unit: "elementów", verb: "mieć" },
    set: { unit: "elementów", verb: "mieć" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "liczba";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "tablica";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "wyrażenie",
    email: "adres email",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "data i godzina w formacie ISO",
    date: "data w formacie ISO",
    time: "godzina w formacie ISO",
    duration: "czas trwania ISO",
    ipv4: "adres IPv4",
    ipv6: "adres IPv6",
    cidrv4: "zakres IPv4",
    cidrv6: "zakres IPv6",
    base64: "ciąg znaków zakodowany w formacie base64",
    base64url: "ciąg znaków zakodowany w formacie base64url",
    json_string: "ciąg znaków w formacie JSON",
    e164: "liczba E.164",
    jwt: "JWT",
    template_literal: "wejście"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d, _e2, _f, _g;
    switch (issue2.code) {
      case "invalid_type":
        return "Nieprawidłowe dane wejściowe: oczekiwano ".concat(issue2.expected, ", otrzymano ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Nieprawidłowe dane wejściowe: oczekiwano ".concat(stringifyPrimitive(issue2.values[0]));
        return "Nieprawidłowa opcja: oczekiwano jednej z wartości ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "Za duża wartość: oczekiwano, że ".concat((_a17 = issue2.origin) != null ? _a17 : "wartość", " będzie mieć ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "elementów");
        }
        return "Zbyt duż(y/a/e): oczekiwano, że ".concat((_c = issue2.origin) != null ? _c : "wartość", " będzie wynosić ").concat(adj).concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "Za mała wartość: oczekiwano, że ".concat((_d = issue2.origin) != null ? _d : "wartość", " będzie mieć ").concat(adj).concat(issue2.minimum.toString(), " ").concat((_e2 = sizing.unit) != null ? _e2 : "elementów");
        }
        return "Zbyt mał(y/a/e): oczekiwano, że ".concat((_f = issue2.origin) != null ? _f : "wartość", " będzie wynosić ").concat(adj).concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with")
          return 'Nieprawidłowy ciąg znaków: musi zaczynać się od "'.concat(_issue.prefix, '"');
        if (_issue.format === "ends_with")
          return 'Nieprawidłowy ciąg znaków: musi kończyć się na "'.concat(_issue.suffix, '"');
        if (_issue.format === "includes")
          return 'Nieprawidłowy ciąg znaków: musi zawierać "'.concat(_issue.includes, '"');
        if (_issue.format === "regex")
          return "Nieprawidłowy ciąg znaków: musi odpowiadać wzorcowi ".concat(_issue.pattern);
        return "Nieprawidłow(y/a/e) ".concat((_g = Nouns[_issue.format]) != null ? _g : issue2.format);
      }
      case "not_multiple_of":
        return "Nieprawidłowa liczba: musi być wielokrotnością ".concat(issue2.divisor);
      case "unrecognized_keys":
        return "Nierozpoznane klucze".concat(issue2.keys.length > 1 ? "s" : "", ": ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "Nieprawidłowy klucz w ".concat(issue2.origin);
      case "invalid_union":
        return "Nieprawidłowe dane wejściowe";
      case "invalid_element":
        return "Nieprawidłowa wartość w ".concat(issue2.origin);
      default:
        return "Nieprawidłowe dane wejściowe";
    }
  };
};
function pl_default() {
  return {
    localeError: error27()
  };
}

// node_modules/zod/v4/locales/pt.js
var error28 = () => {
  const Sizable = {
    string: { unit: "caracteres", verb: "ter" },
    file: { unit: "bytes", verb: "ter" },
    array: { unit: "itens", verb: "ter" },
    set: { unit: "itens", verb: "ter" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "número";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "array";
        }
        if (data === null) {
          return "nulo";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "padrão",
    email: "endereço de e-mail",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "data e hora ISO",
    date: "data ISO",
    time: "hora ISO",
    duration: "duração ISO",
    ipv4: "endereço IPv4",
    ipv6: "endereço IPv6",
    cidrv4: "faixa de IPv4",
    cidrv6: "faixa de IPv6",
    base64: "texto codificado em base64",
    base64url: "URL codificada em base64",
    json_string: "texto JSON",
    e164: "número E.164",
    jwt: "JWT",
    template_literal: "entrada"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "Tipo inválido: esperado ".concat(issue2.expected, ", recebido ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Entrada inválida: esperado ".concat(stringifyPrimitive(issue2.values[0]));
        return "Opção inválida: esperada uma das ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "Muito grande: esperado que ".concat((_a17 = issue2.origin) != null ? _a17 : "valor", " tivesse ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "elementos");
        return "Muito grande: esperado que ".concat((_c = issue2.origin) != null ? _c : "valor", " fosse ").concat(adj).concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "Muito pequeno: esperado que ".concat(issue2.origin, " tivesse ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit);
        }
        return "Muito pequeno: esperado que ".concat(issue2.origin, " fosse ").concat(adj).concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with")
          return 'Texto inválido: deve começar com "'.concat(_issue.prefix, '"');
        if (_issue.format === "ends_with")
          return 'Texto inválido: deve terminar com "'.concat(_issue.suffix, '"');
        if (_issue.format === "includes")
          return 'Texto inválido: deve incluir "'.concat(_issue.includes, '"');
        if (_issue.format === "regex")
          return "Texto inválido: deve corresponder ao padrão ".concat(_issue.pattern);
        return "".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format, " inválido");
      }
      case "not_multiple_of":
        return "Número inválido: deve ser múltiplo de ".concat(issue2.divisor);
      case "unrecognized_keys":
        return "Chave".concat(issue2.keys.length > 1 ? "s" : "", " desconhecida").concat(issue2.keys.length > 1 ? "s" : "", ": ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "Chave inválida em ".concat(issue2.origin);
      case "invalid_union":
        return "Entrada inválida";
      case "invalid_element":
        return "Valor inválido em ".concat(issue2.origin);
      default:
        return "Campo inválido";
    }
  };
};
function pt_default() {
  return {
    localeError: error28()
  };
}

// node_modules/zod/v4/locales/ru.js
function getRussianPlural(count, one, few, many) {
  const absCount = Math.abs(count);
  const lastDigit = absCount % 10;
  const lastTwoDigits = absCount % 100;
  if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
    return many;
  }
  if (lastDigit === 1) {
    return one;
  }
  if (lastDigit >= 2 && lastDigit <= 4) {
    return few;
  }
  return many;
}
var error29 = () => {
  const Sizable = {
    string: {
      unit: {
        one: "символ",
        few: "символа",
        many: "символов"
      },
      verb: "иметь"
    },
    file: {
      unit: {
        one: "байт",
        few: "байта",
        many: "байт"
      },
      verb: "иметь"
    },
    array: {
      unit: {
        one: "элемент",
        few: "элемента",
        many: "элементов"
      },
      verb: "иметь"
    },
    set: {
      unit: {
        one: "элемент",
        few: "элемента",
        many: "элементов"
      },
      verb: "иметь"
    }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "число";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "массив";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "ввод",
    email: "email адрес",
    url: "URL",
    emoji: "эмодзи",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO дата и время",
    date: "ISO дата",
    time: "ISO время",
    duration: "ISO длительность",
    ipv4: "IPv4 адрес",
    ipv6: "IPv6 адрес",
    cidrv4: "IPv4 диапазон",
    cidrv6: "IPv6 диапазон",
    base64: "строка в формате base64",
    base64url: "строка в формате base64url",
    json_string: "JSON строка",
    e164: "номер E.164",
    jwt: "JWT",
    template_literal: "ввод"
  };
  return (issue2) => {
    var _a17, _b8, _c;
    switch (issue2.code) {
      case "invalid_type":
        return "Неверный ввод: ожидалось ".concat(issue2.expected, ", получено ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Неверный ввод: ожидалось ".concat(stringifyPrimitive(issue2.values[0]));
        return "Неверный вариант: ожидалось одно из ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          const maxValue = Number(issue2.maximum);
          const unit = getRussianPlural(maxValue, sizing.unit.one, sizing.unit.few, sizing.unit.many);
          return "Слишком большое значение: ожидалось, что ".concat((_a17 = issue2.origin) != null ? _a17 : "значение", " будет иметь ").concat(adj).concat(issue2.maximum.toString(), " ").concat(unit);
        }
        return "Слишком большое значение: ожидалось, что ".concat((_b8 = issue2.origin) != null ? _b8 : "значение", " будет ").concat(adj).concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          const minValue = Number(issue2.minimum);
          const unit = getRussianPlural(minValue, sizing.unit.one, sizing.unit.few, sizing.unit.many);
          return "Слишком маленькое значение: ожидалось, что ".concat(issue2.origin, " будет иметь ").concat(adj).concat(issue2.minimum.toString(), " ").concat(unit);
        }
        return "Слишком маленькое значение: ожидалось, что ".concat(issue2.origin, " будет ").concat(adj).concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with")
          return 'Неверная строка: должна начинаться с "'.concat(_issue.prefix, '"');
        if (_issue.format === "ends_with")
          return 'Неверная строка: должна заканчиваться на "'.concat(_issue.suffix, '"');
        if (_issue.format === "includes")
          return 'Неверная строка: должна содержать "'.concat(_issue.includes, '"');
        if (_issue.format === "regex")
          return "Неверная строка: должна соответствовать шаблону ".concat(_issue.pattern);
        return "Неверный ".concat((_c = Nouns[_issue.format]) != null ? _c : issue2.format);
      }
      case "not_multiple_of":
        return "Неверное число: должно быть кратным ".concat(issue2.divisor);
      case "unrecognized_keys":
        return "Нераспознанн".concat(issue2.keys.length > 1 ? "ые" : "ый", " ключ").concat(issue2.keys.length > 1 ? "и" : "", ": ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "Неверный ключ в ".concat(issue2.origin);
      case "invalid_union":
        return "Неверные входные данные";
      case "invalid_element":
        return "Неверное значение в ".concat(issue2.origin);
      default:
        return "Неверные входные данные";
    }
  };
};
function ru_default() {
  return {
    localeError: error29()
  };
}

// node_modules/zod/v4/locales/sl.js
var error30 = () => {
  const Sizable = {
    string: { unit: "znakov", verb: "imeti" },
    file: { unit: "bajtov", verb: "imeti" },
    array: { unit: "elementov", verb: "imeti" },
    set: { unit: "elementov", verb: "imeti" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "število";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "tabela";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "vnos",
    email: "e-poštni naslov",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO datum in čas",
    date: "ISO datum",
    time: "ISO čas",
    duration: "ISO trajanje",
    ipv4: "IPv4 naslov",
    ipv6: "IPv6 naslov",
    cidrv4: "obseg IPv4",
    cidrv6: "obseg IPv6",
    base64: "base64 kodiran niz",
    base64url: "base64url kodiran niz",
    json_string: "JSON niz",
    e164: "E.164 številka",
    jwt: "JWT",
    template_literal: "vnos"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "Neveljaven vnos: pričakovano ".concat(issue2.expected, ", prejeto ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Neveljaven vnos: pričakovano ".concat(stringifyPrimitive(issue2.values[0]));
        return "Neveljavna možnost: pričakovano eno izmed ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "Preveliko: pričakovano, da bo ".concat((_a17 = issue2.origin) != null ? _a17 : "vrednost", " imelo ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "elementov");
        return "Preveliko: pričakovano, da bo ".concat((_c = issue2.origin) != null ? _c : "vrednost", " ").concat(adj).concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "Premajhno: pričakovano, da bo ".concat(issue2.origin, " imelo ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit);
        }
        return "Premajhno: pričakovano, da bo ".concat(issue2.origin, " ").concat(adj).concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with") {
          return 'Neveljaven niz: mora se začeti z "'.concat(_issue.prefix, '"');
        }
        if (_issue.format === "ends_with")
          return 'Neveljaven niz: mora se končati z "'.concat(_issue.suffix, '"');
        if (_issue.format === "includes")
          return 'Neveljaven niz: mora vsebovati "'.concat(_issue.includes, '"');
        if (_issue.format === "regex")
          return "Neveljaven niz: mora ustrezati vzorcu ".concat(_issue.pattern);
        return "Neveljaven ".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format);
      }
      case "not_multiple_of":
        return "Neveljavno število: mora biti večkratnik ".concat(issue2.divisor);
      case "unrecognized_keys":
        return "Neprepoznan".concat(issue2.keys.length > 1 ? "i ključi" : " ključ", ": ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "Neveljaven ključ v ".concat(issue2.origin);
      case "invalid_union":
        return "Neveljaven vnos";
      case "invalid_element":
        return "Neveljavna vrednost v ".concat(issue2.origin);
      default:
        return "Neveljaven vnos";
    }
  };
};
function sl_default() {
  return {
    localeError: error30()
  };
}

// node_modules/zod/v4/locales/sv.js
var error31 = () => {
  const Sizable = {
    string: { unit: "tecken", verb: "att ha" },
    file: { unit: "bytes", verb: "att ha" },
    array: { unit: "objekt", verb: "att innehålla" },
    set: { unit: "objekt", verb: "att innehålla" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "antal";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "lista";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "reguljärt uttryck",
    email: "e-postadress",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO-datum och tid",
    date: "ISO-datum",
    time: "ISO-tid",
    duration: "ISO-varaktighet",
    ipv4: "IPv4-intervall",
    ipv6: "IPv6-intervall",
    cidrv4: "IPv4-spektrum",
    cidrv6: "IPv6-spektrum",
    base64: "base64-kodad sträng",
    base64url: "base64url-kodad sträng",
    json_string: "JSON-sträng",
    e164: "E.164-nummer",
    jwt: "JWT",
    template_literal: "mall-literal"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d, _e2, _f, _g, _h;
    switch (issue2.code) {
      case "invalid_type":
        return "Ogiltig inmatning: förväntat ".concat(issue2.expected, ", fick ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Ogiltig inmatning: förväntat ".concat(stringifyPrimitive(issue2.values[0]));
        return "Ogiltigt val: förväntade en av ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "För stor(t): förväntade ".concat((_a17 = issue2.origin) != null ? _a17 : "värdet", " att ha ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "element");
        }
        return "För stor(t): förväntat ".concat((_c = issue2.origin) != null ? _c : "värdet", " att ha ").concat(adj).concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "För lite(t): förväntade ".concat((_d = issue2.origin) != null ? _d : "värdet", " att ha ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit);
        }
        return "För lite(t): förväntade ".concat((_e2 = issue2.origin) != null ? _e2 : "värdet", " att ha ").concat(adj).concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with") {
          return 'Ogiltig sträng: måste börja med "'.concat(_issue.prefix, '"');
        }
        if (_issue.format === "ends_with")
          return 'Ogiltig sträng: måste sluta med "'.concat(_issue.suffix, '"');
        if (_issue.format === "includes")
          return 'Ogiltig sträng: måste innehålla "'.concat(_issue.includes, '"');
        if (_issue.format === "regex")
          return 'Ogiltig sträng: måste matcha mönstret "'.concat(_issue.pattern, '"');
        return "Ogiltig(t) ".concat((_f = Nouns[_issue.format]) != null ? _f : issue2.format);
      }
      case "not_multiple_of":
        return "Ogiltigt tal: måste vara en multipel av ".concat(issue2.divisor);
      case "unrecognized_keys":
        return "".concat(issue2.keys.length > 1 ? "Okända nycklar" : "Okänd nyckel", ": ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "Ogiltig nyckel i ".concat((_g = issue2.origin) != null ? _g : "värdet");
      case "invalid_union":
        return "Ogiltig input";
      case "invalid_element":
        return "Ogiltigt värde i ".concat((_h = issue2.origin) != null ? _h : "värdet");
      default:
        return "Ogiltig input";
    }
  };
};
function sv_default() {
  return {
    localeError: error31()
  };
}

// node_modules/zod/v4/locales/ta.js
var error32 = () => {
  const Sizable = {
    string: { unit: "எழுத்துக்கள்", verb: "கொண்டிருக்க வேண்டும்" },
    file: { unit: "பைட்டுகள்", verb: "கொண்டிருக்க வேண்டும்" },
    array: { unit: "உறுப்புகள்", verb: "கொண்டிருக்க வேண்டும்" },
    set: { unit: "உறுப்புகள்", verb: "கொண்டிருக்க வேண்டும்" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "எண் அல்லாதது" : "எண்";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "அணி";
        }
        if (data === null) {
          return "வெறுமை";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "உள்ளீடு",
    email: "மின்னஞ்சல் முகவரி",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO தேதி நேரம்",
    date: "ISO தேதி",
    time: "ISO நேரம்",
    duration: "ISO கால அளவு",
    ipv4: "IPv4 முகவரி",
    ipv6: "IPv6 முகவரி",
    cidrv4: "IPv4 வரம்பு",
    cidrv6: "IPv6 வரம்பு",
    base64: "base64-encoded சரம்",
    base64url: "base64url-encoded சரம்",
    json_string: "JSON சரம்",
    e164: "E.164 எண்",
    jwt: "JWT",
    template_literal: "input"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "தவறான உள்ளீடு: எதிர்பார்க்கப்பட்டது ".concat(issue2.expected, ", பெறப்பட்டது ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "தவறான உள்ளீடு: எதிர்பார்க்கப்பட்டது ".concat(stringifyPrimitive(issue2.values[0]));
        return "தவறான விருப்பம்: எதிர்பார்க்கப்பட்டது ".concat(joinValues(issue2.values, "|"), " இல் ஒன்று");
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "மிக பெரியது: எதிர்பார்க்கப்பட்டது ".concat((_a17 = issue2.origin) != null ? _a17 : "மதிப்பு", " ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "உறுப்புகள்", " ஆக இருக்க வேண்டும்");
        }
        return "மிக பெரியது: எதிர்பார்க்கப்பட்டது ".concat((_c = issue2.origin) != null ? _c : "மதிப்பு", " ").concat(adj).concat(issue2.maximum.toString(), " ஆக இருக்க வேண்டும்");
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "மிகச் சிறியது: எதிர்பார்க்கப்பட்டது ".concat(issue2.origin, " ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit, " ஆக இருக்க வேண்டும்");
        }
        return "மிகச் சிறியது: எதிர்பார்க்கப்பட்டது ".concat(issue2.origin, " ").concat(adj).concat(issue2.minimum.toString(), " ஆக இருக்க வேண்டும்");
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with")
          return 'தவறான சரம்: "'.concat(_issue.prefix, '" இல் தொடங்க வேண்டும்');
        if (_issue.format === "ends_with")
          return 'தவறான சரம்: "'.concat(_issue.suffix, '" இல் முடிவடைய வேண்டும்');
        if (_issue.format === "includes")
          return 'தவறான சரம்: "'.concat(_issue.includes, '" ஐ உள்ளடக்க வேண்டும்');
        if (_issue.format === "regex")
          return "தவறான சரம்: ".concat(_issue.pattern, " முறைபாட்டுடன் பொருந்த வேண்டும்");
        return "தவறான ".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format);
      }
      case "not_multiple_of":
        return "தவறான எண்: ".concat(issue2.divisor, " இன் பலமாக இருக்க வேண்டும்");
      case "unrecognized_keys":
        return "அடையாளம் தெரியாத விசை".concat(issue2.keys.length > 1 ? "கள்" : "", ": ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "".concat(issue2.origin, " இல் தவறான விசை");
      case "invalid_union":
        return "தவறான உள்ளீடு";
      case "invalid_element":
        return "".concat(issue2.origin, " இல் தவறான மதிப்பு");
      default:
        return "தவறான உள்ளீடு";
    }
  };
};
function ta_default() {
  return {
    localeError: error32()
  };
}

// node_modules/zod/v4/locales/th.js
var error33 = () => {
  const Sizable = {
    string: { unit: "ตัวอักษร", verb: "ควรมี" },
    file: { unit: "ไบต์", verb: "ควรมี" },
    array: { unit: "รายการ", verb: "ควรมี" },
    set: { unit: "รายการ", verb: "ควรมี" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "ไม่ใช่ตัวเลข (NaN)" : "ตัวเลข";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "อาร์เรย์ (Array)";
        }
        if (data === null) {
          return "ไม่มีค่า (null)";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "ข้อมูลที่ป้อน",
    email: "ที่อยู่อีเมล",
    url: "URL",
    emoji: "อิโมจิ",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "วันที่เวลาแบบ ISO",
    date: "วันที่แบบ ISO",
    time: "เวลาแบบ ISO",
    duration: "ช่วงเวลาแบบ ISO",
    ipv4: "ที่อยู่ IPv4",
    ipv6: "ที่อยู่ IPv6",
    cidrv4: "ช่วง IP แบบ IPv4",
    cidrv6: "ช่วง IP แบบ IPv6",
    base64: "ข้อความแบบ Base64",
    base64url: "ข้อความแบบ Base64 สำหรับ URL",
    json_string: "ข้อความแบบ JSON",
    e164: "เบอร์โทรศัพท์ระหว่างประเทศ (E.164)",
    jwt: "โทเคน JWT",
    template_literal: "ข้อมูลที่ป้อน"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "ประเภทข้อมูลไม่ถูกต้อง: ควรเป็น ".concat(issue2.expected, " แต่ได้รับ ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "ค่าไม่ถูกต้อง: ควรเป็น ".concat(stringifyPrimitive(issue2.values[0]));
        return "ตัวเลือกไม่ถูกต้อง: ควรเป็นหนึ่งใน ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "ไม่เกิน" : "น้อยกว่า";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "เกินกำหนด: ".concat((_a17 = issue2.origin) != null ? _a17 : "ค่า", " ควรมี").concat(adj, " ").concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "รายการ");
        return "เกินกำหนด: ".concat((_c = issue2.origin) != null ? _c : "ค่า", " ควรมี").concat(adj, " ").concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? "อย่างน้อย" : "มากกว่า";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "น้อยกว่ากำหนด: ".concat(issue2.origin, " ควรมี").concat(adj, " ").concat(issue2.minimum.toString(), " ").concat(sizing.unit);
        }
        return "น้อยกว่ากำหนด: ".concat(issue2.origin, " ควรมี").concat(adj, " ").concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with") {
          return 'รูปแบบไม่ถูกต้อง: ข้อความต้องขึ้นต้นด้วย "'.concat(_issue.prefix, '"');
        }
        if (_issue.format === "ends_with")
          return 'รูปแบบไม่ถูกต้อง: ข้อความต้องลงท้ายด้วย "'.concat(_issue.suffix, '"');
        if (_issue.format === "includes")
          return 'รูปแบบไม่ถูกต้อง: ข้อความต้องมี "'.concat(_issue.includes, '" อยู่ในข้อความ');
        if (_issue.format === "regex")
          return "รูปแบบไม่ถูกต้อง: ต้องตรงกับรูปแบบที่กำหนด ".concat(_issue.pattern);
        return "รูปแบบไม่ถูกต้อง: ".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format);
      }
      case "not_multiple_of":
        return "ตัวเลขไม่ถูกต้อง: ต้องเป็นจำนวนที่หารด้วย ".concat(issue2.divisor, " ได้ลงตัว");
      case "unrecognized_keys":
        return "พบคีย์ที่ไม่รู้จัก: ".concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "คีย์ไม่ถูกต้องใน ".concat(issue2.origin);
      case "invalid_union":
        return "ข้อมูลไม่ถูกต้อง: ไม่ตรงกับรูปแบบยูเนียนที่กำหนดไว้";
      case "invalid_element":
        return "ข้อมูลไม่ถูกต้องใน ".concat(issue2.origin);
      default:
        return "ข้อมูลไม่ถูกต้อง";
    }
  };
};
function th_default() {
  return {
    localeError: error33()
  };
}

// node_modules/zod/v4/locales/tr.js
var parsedType3 = (data) => {
  const t4 = typeof data;
  switch (t4) {
    case "number": {
      return Number.isNaN(data) ? "NaN" : "number";
    }
    case "object": {
      if (Array.isArray(data)) {
        return "array";
      }
      if (data === null) {
        return "null";
      }
      if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
        return data.constructor.name;
      }
    }
  }
  return t4;
};
var error34 = () => {
  const Sizable = {
    string: { unit: "karakter", verb: "olmalı" },
    file: { unit: "bayt", verb: "olmalı" },
    array: { unit: "öğe", verb: "olmalı" },
    set: { unit: "öğe", verb: "olmalı" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const Nouns = {
    regex: "girdi",
    email: "e-posta adresi",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO tarih ve saat",
    date: "ISO tarih",
    time: "ISO saat",
    duration: "ISO süre",
    ipv4: "IPv4 adresi",
    ipv6: "IPv6 adresi",
    cidrv4: "IPv4 aralığı",
    cidrv6: "IPv6 aralığı",
    base64: "base64 ile şifrelenmiş metin",
    base64url: "base64url ile şifrelenmiş metin",
    json_string: "JSON dizesi",
    e164: "E.164 sayısı",
    jwt: "JWT",
    template_literal: "Şablon dizesi"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "Geçersiz değer: beklenen ".concat(issue2.expected, ", alınan ").concat(parsedType3(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Geçersiz değer: beklenen ".concat(stringifyPrimitive(issue2.values[0]));
        return "Geçersiz seçenek: aşağıdakilerden biri olmalı: ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "Çok büyük: beklenen ".concat((_a17 = issue2.origin) != null ? _a17 : "değer", " ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "öğe");
        return "Çok büyük: beklenen ".concat((_c = issue2.origin) != null ? _c : "değer", " ").concat(adj).concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "Çok küçük: beklenen ".concat(issue2.origin, " ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit);
        return "Çok küçük: beklenen ".concat(issue2.origin, " ").concat(adj).concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with")
          return 'Geçersiz metin: "'.concat(_issue.prefix, '" ile başlamalı');
        if (_issue.format === "ends_with")
          return 'Geçersiz metin: "'.concat(_issue.suffix, '" ile bitmeli');
        if (_issue.format === "includes")
          return 'Geçersiz metin: "'.concat(_issue.includes, '" içermeli');
        if (_issue.format === "regex")
          return "Geçersiz metin: ".concat(_issue.pattern, " desenine uymalı");
        return "Geçersiz ".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format);
      }
      case "not_multiple_of":
        return "Geçersiz sayı: ".concat(issue2.divisor, " ile tam bölünebilmeli");
      case "unrecognized_keys":
        return "Tanınmayan anahtar".concat(issue2.keys.length > 1 ? "lar" : "", ": ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "".concat(issue2.origin, " içinde geçersiz anahtar");
      case "invalid_union":
        return "Geçersiz değer";
      case "invalid_element":
        return "".concat(issue2.origin, " içinde geçersiz değer");
      default:
        return "Geçersiz değer";
    }
  };
};
function tr_default() {
  return {
    localeError: error34()
  };
}

// node_modules/zod/v4/locales/ua.js
var error35 = () => {
  const Sizable = {
    string: { unit: "символів", verb: "матиме" },
    file: { unit: "байтів", verb: "матиме" },
    array: { unit: "елементів", verb: "матиме" },
    set: { unit: "елементів", verb: "матиме" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "число";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "масив";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "вхідні дані",
    email: "адреса електронної пошти",
    url: "URL",
    emoji: "емодзі",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "дата та час ISO",
    date: "дата ISO",
    time: "час ISO",
    duration: "тривалість ISO",
    ipv4: "адреса IPv4",
    ipv6: "адреса IPv6",
    cidrv4: "діапазон IPv4",
    cidrv6: "діапазон IPv6",
    base64: "рядок у кодуванні base64",
    base64url: "рядок у кодуванні base64url",
    json_string: "рядок JSON",
    e164: "номер E.164",
    jwt: "JWT",
    template_literal: "вхідні дані"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "Неправильні вхідні дані: очікується ".concat(issue2.expected, ", отримано ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Неправильні вхідні дані: очікується ".concat(stringifyPrimitive(issue2.values[0]));
        return "Неправильна опція: очікується одне з ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "Занадто велике: очікується, що ".concat((_a17 = issue2.origin) != null ? _a17 : "значення", " ").concat(sizing.verb, " ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "елементів");
        return "Занадто велике: очікується, що ".concat((_c = issue2.origin) != null ? _c : "значення", " буде ").concat(adj).concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "Занадто мале: очікується, що ".concat(issue2.origin, " ").concat(sizing.verb, " ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit);
        }
        return "Занадто мале: очікується, що ".concat(issue2.origin, " буде ").concat(adj).concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with")
          return 'Неправильний рядок: повинен починатися з "'.concat(_issue.prefix, '"');
        if (_issue.format === "ends_with")
          return 'Неправильний рядок: повинен закінчуватися на "'.concat(_issue.suffix, '"');
        if (_issue.format === "includes")
          return 'Неправильний рядок: повинен містити "'.concat(_issue.includes, '"');
        if (_issue.format === "regex")
          return "Неправильний рядок: повинен відповідати шаблону ".concat(_issue.pattern);
        return "Неправильний ".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format);
      }
      case "not_multiple_of":
        return "Неправильне число: повинно бути кратним ".concat(issue2.divisor);
      case "unrecognized_keys":
        return "Нерозпізнаний ключ".concat(issue2.keys.length > 1 ? "і" : "", ": ").concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "Неправильний ключ у ".concat(issue2.origin);
      case "invalid_union":
        return "Неправильні вхідні дані";
      case "invalid_element":
        return "Неправильне значення у ".concat(issue2.origin);
      default:
        return "Неправильні вхідні дані";
    }
  };
};
function ua_default() {
  return {
    localeError: error35()
  };
}

// node_modules/zod/v4/locales/ur.js
var error36 = () => {
  const Sizable = {
    string: { unit: "حروف", verb: "ہونا" },
    file: { unit: "بائٹس", verb: "ہونا" },
    array: { unit: "آئٹمز", verb: "ہونا" },
    set: { unit: "آئٹمز", verb: "ہونا" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "نمبر";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "آرے";
        }
        if (data === null) {
          return "نل";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "ان پٹ",
    email: "ای میل ایڈریس",
    url: "یو آر ایل",
    emoji: "ایموجی",
    uuid: "یو یو آئی ڈی",
    uuidv4: "یو یو آئی ڈی وی 4",
    uuidv6: "یو یو آئی ڈی وی 6",
    nanoid: "نینو آئی ڈی",
    guid: "جی یو آئی ڈی",
    cuid: "سی یو آئی ڈی",
    cuid2: "سی یو آئی ڈی 2",
    ulid: "یو ایل آئی ڈی",
    xid: "ایکس آئی ڈی",
    ksuid: "کے ایس یو آئی ڈی",
    datetime: "آئی ایس او ڈیٹ ٹائم",
    date: "آئی ایس او تاریخ",
    time: "آئی ایس او وقت",
    duration: "آئی ایس او مدت",
    ipv4: "آئی پی وی 4 ایڈریس",
    ipv6: "آئی پی وی 6 ایڈریس",
    cidrv4: "آئی پی وی 4 رینج",
    cidrv6: "آئی پی وی 6 رینج",
    base64: "بیس 64 ان کوڈڈ سٹرنگ",
    base64url: "بیس 64 یو آر ایل ان کوڈڈ سٹرنگ",
    json_string: "جے ایس او این سٹرنگ",
    e164: "ای 164 نمبر",
    jwt: "جے ڈبلیو ٹی",
    template_literal: "ان پٹ"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "غلط ان پٹ: ".concat(issue2.expected, " متوقع تھا، ").concat(parsedType4(issue2.input), " موصول ہوا");
      case "invalid_value":
        if (issue2.values.length === 1)
          return "غلط ان پٹ: ".concat(stringifyPrimitive(issue2.values[0]), " متوقع تھا");
        return "غلط آپشن: ".concat(joinValues(issue2.values, "|"), " میں سے ایک متوقع تھا");
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "بہت بڑا: ".concat((_a17 = issue2.origin) != null ? _a17 : "ویلیو", " کے ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "عناصر", " ہونے متوقع تھے");
        return "بہت بڑا: ".concat((_c = issue2.origin) != null ? _c : "ویلیو", " کا ").concat(adj).concat(issue2.maximum.toString(), " ہونا متوقع تھا");
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "بہت چھوٹا: ".concat(issue2.origin, " کے ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit, " ہونے متوقع تھے");
        }
        return "بہت چھوٹا: ".concat(issue2.origin, " کا ").concat(adj).concat(issue2.minimum.toString(), " ہونا متوقع تھا");
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with") {
          return 'غلط سٹرنگ: "'.concat(_issue.prefix, '" سے شروع ہونا چاہیے');
        }
        if (_issue.format === "ends_with")
          return 'غلط سٹرنگ: "'.concat(_issue.suffix, '" پر ختم ہونا چاہیے');
        if (_issue.format === "includes")
          return 'غلط سٹرنگ: "'.concat(_issue.includes, '" شامل ہونا چاہیے');
        if (_issue.format === "regex")
          return "غلط سٹرنگ: پیٹرن ".concat(_issue.pattern, " سے میچ ہونا چاہیے");
        return "غلط ".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format);
      }
      case "not_multiple_of":
        return "غلط نمبر: ".concat(issue2.divisor, " کا مضاعف ہونا چاہیے");
      case "unrecognized_keys":
        return "غیر تسلیم شدہ کی".concat(issue2.keys.length > 1 ? "ز" : "", ": ").concat(joinValues(issue2.keys, "، "));
      case "invalid_key":
        return "".concat(issue2.origin, " میں غلط کی");
      case "invalid_union":
        return "غلط ان پٹ";
      case "invalid_element":
        return "".concat(issue2.origin, " میں غلط ویلیو");
      default:
        return "غلط ان پٹ";
    }
  };
};
function ur_default() {
  return {
    localeError: error36()
  };
}

// node_modules/zod/v4/locales/vi.js
var error37 = () => {
  const Sizable = {
    string: { unit: "ký tự", verb: "có" },
    file: { unit: "byte", verb: "có" },
    array: { unit: "phần tử", verb: "có" },
    set: { unit: "phần tử", verb: "có" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "số";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "mảng";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "đầu vào",
    email: "địa chỉ email",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ngày giờ ISO",
    date: "ngày ISO",
    time: "giờ ISO",
    duration: "khoảng thời gian ISO",
    ipv4: "địa chỉ IPv4",
    ipv6: "địa chỉ IPv6",
    cidrv4: "dải IPv4",
    cidrv6: "dải IPv6",
    base64: "chuỗi mã hóa base64",
    base64url: "chuỗi mã hóa base64url",
    json_string: "chuỗi JSON",
    e164: "số E.164",
    jwt: "JWT",
    template_literal: "đầu vào"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "Đầu vào không hợp lệ: mong đợi ".concat(issue2.expected, ", nhận được ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "Đầu vào không hợp lệ: mong đợi ".concat(stringifyPrimitive(issue2.values[0]));
        return "Tùy chọn không hợp lệ: mong đợi một trong các giá trị ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "Quá lớn: mong đợi ".concat((_a17 = issue2.origin) != null ? _a17 : "giá trị", " ").concat(sizing.verb, " ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "phần tử");
        return "Quá lớn: mong đợi ".concat((_c = issue2.origin) != null ? _c : "giá trị", " ").concat(adj).concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "Quá nhỏ: mong đợi ".concat(issue2.origin, " ").concat(sizing.verb, " ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit);
        }
        return "Quá nhỏ: mong đợi ".concat(issue2.origin, " ").concat(adj).concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with")
          return 'Chuỗi không hợp lệ: phải bắt đầu bằng "'.concat(_issue.prefix, '"');
        if (_issue.format === "ends_with")
          return 'Chuỗi không hợp lệ: phải kết thúc bằng "'.concat(_issue.suffix, '"');
        if (_issue.format === "includes")
          return 'Chuỗi không hợp lệ: phải bao gồm "'.concat(_issue.includes, '"');
        if (_issue.format === "regex")
          return "Chuỗi không hợp lệ: phải khớp với mẫu ".concat(_issue.pattern);
        return "".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format, " không hợp lệ");
      }
      case "not_multiple_of":
        return "Số không hợp lệ: phải là bội số của ".concat(issue2.divisor);
      case "unrecognized_keys":
        return "Khóa không được nhận dạng: ".concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "Khóa không hợp lệ trong ".concat(issue2.origin);
      case "invalid_union":
        return "Đầu vào không hợp lệ";
      case "invalid_element":
        return "Giá trị không hợp lệ trong ".concat(issue2.origin);
      default:
        return "Đầu vào không hợp lệ";
    }
  };
};
function vi_default() {
  return {
    localeError: error37()
  };
}

// node_modules/zod/v4/locales/zh-CN.js
var error38 = () => {
  const Sizable = {
    string: { unit: "字符", verb: "包含" },
    file: { unit: "字节", verb: "包含" },
    array: { unit: "项", verb: "包含" },
    set: { unit: "项", verb: "包含" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "非数字(NaN)" : "数字";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "数组";
        }
        if (data === null) {
          return "空值(null)";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "输入",
    email: "电子邮件",
    url: "URL",
    emoji: "表情符号",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO日期时间",
    date: "ISO日期",
    time: "ISO时间",
    duration: "ISO时长",
    ipv4: "IPv4地址",
    ipv6: "IPv6地址",
    cidrv4: "IPv4网段",
    cidrv6: "IPv6网段",
    base64: "base64编码字符串",
    base64url: "base64url编码字符串",
    json_string: "JSON字符串",
    e164: "E.164号码",
    jwt: "JWT",
    template_literal: "输入"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "无效输入：期望 ".concat(issue2.expected, "，实际接收 ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "无效输入：期望 ".concat(stringifyPrimitive(issue2.values[0]));
        return "无效选项：期望以下之一 ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "数值过大：期望 ".concat((_a17 = issue2.origin) != null ? _a17 : "值", " ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "个元素");
        return "数值过大：期望 ".concat((_c = issue2.origin) != null ? _c : "值", " ").concat(adj).concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "数值过小：期望 ".concat(issue2.origin, " ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit);
        }
        return "数值过小：期望 ".concat(issue2.origin, " ").concat(adj).concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with")
          return '无效字符串：必须以 "'.concat(_issue.prefix, '" 开头');
        if (_issue.format === "ends_with")
          return '无效字符串：必须以 "'.concat(_issue.suffix, '" 结尾');
        if (_issue.format === "includes")
          return '无效字符串：必须包含 "'.concat(_issue.includes, '"');
        if (_issue.format === "regex")
          return "无效字符串：必须满足正则表达式 ".concat(_issue.pattern);
        return "无效".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format);
      }
      case "not_multiple_of":
        return "无效数字：必须是 ".concat(issue2.divisor, " 的倍数");
      case "unrecognized_keys":
        return "出现未知的键(key): ".concat(joinValues(issue2.keys, ", "));
      case "invalid_key":
        return "".concat(issue2.origin, " 中的键(key)无效");
      case "invalid_union":
        return "无效输入";
      case "invalid_element":
        return "".concat(issue2.origin, " 中包含无效值(value)");
      default:
        return "无效输入";
    }
  };
};
function zh_CN_default() {
  return {
    localeError: error38()
  };
}

// node_modules/zod/v4/locales/zh-TW.js
var error39 = () => {
  const Sizable = {
    string: { unit: "字元", verb: "擁有" },
    file: { unit: "位元組", verb: "擁有" },
    array: { unit: "項目", verb: "擁有" },
    set: { unit: "項目", verb: "擁有" }
  };
  function getSizing(origin) {
    var _a17;
    return (_a17 = Sizable[origin]) != null ? _a17 : null;
  }
  const parsedType4 = (data) => {
    const t4 = typeof data;
    switch (t4) {
      case "number": {
        return Number.isNaN(data) ? "NaN" : "number";
      }
      case "object": {
        if (Array.isArray(data)) {
          return "array";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
    }
    return t4;
  };
  const Nouns = {
    regex: "輸入",
    email: "郵件地址",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO 日期時間",
    date: "ISO 日期",
    time: "ISO 時間",
    duration: "ISO 期間",
    ipv4: "IPv4 位址",
    ipv6: "IPv6 位址",
    cidrv4: "IPv4 範圍",
    cidrv6: "IPv6 範圍",
    base64: "base64 編碼字串",
    base64url: "base64url 編碼字串",
    json_string: "JSON 字串",
    e164: "E.164 數值",
    jwt: "JWT",
    template_literal: "輸入"
  };
  return (issue2) => {
    var _a17, _b8, _c, _d;
    switch (issue2.code) {
      case "invalid_type":
        return "無效的輸入值：預期為 ".concat(issue2.expected, "，但收到 ").concat(parsedType4(issue2.input));
      case "invalid_value":
        if (issue2.values.length === 1)
          return "無效的輸入值：預期為 ".concat(stringifyPrimitive(issue2.values[0]));
        return "無效的選項：預期為以下其中之一 ".concat(joinValues(issue2.values, "|"));
      case "too_big": {
        const adj = issue2.inclusive ? "<=" : "<";
        const sizing = getSizing(issue2.origin);
        if (sizing)
          return "數值過大：預期 ".concat((_a17 = issue2.origin) != null ? _a17 : "值", " 應為 ").concat(adj).concat(issue2.maximum.toString(), " ").concat((_b8 = sizing.unit) != null ? _b8 : "個元素");
        return "數值過大：預期 ".concat((_c = issue2.origin) != null ? _c : "值", " 應為 ").concat(adj).concat(issue2.maximum.toString());
      }
      case "too_small": {
        const adj = issue2.inclusive ? ">=" : ">";
        const sizing = getSizing(issue2.origin);
        if (sizing) {
          return "數值過小：預期 ".concat(issue2.origin, " 應為 ").concat(adj).concat(issue2.minimum.toString(), " ").concat(sizing.unit);
        }
        return "數值過小：預期 ".concat(issue2.origin, " 應為 ").concat(adj).concat(issue2.minimum.toString());
      }
      case "invalid_format": {
        const _issue = issue2;
        if (_issue.format === "starts_with") {
          return '無效的字串：必須以 "'.concat(_issue.prefix, '" 開頭');
        }
        if (_issue.format === "ends_with")
          return '無效的字串：必須以 "'.concat(_issue.suffix, '" 結尾');
        if (_issue.format === "includes")
          return '無效的字串：必須包含 "'.concat(_issue.includes, '"');
        if (_issue.format === "regex")
          return "無效的字串：必須符合格式 ".concat(_issue.pattern);
        return "無效的 ".concat((_d = Nouns[_issue.format]) != null ? _d : issue2.format);
      }
      case "not_multiple_of":
        return "無效的數字：必須為 ".concat(issue2.divisor, " 的倍數");
      case "unrecognized_keys":
        return "無法識別的鍵值".concat(issue2.keys.length > 1 ? "們" : "", "：").concat(joinValues(issue2.keys, "、"));
      case "invalid_key":
        return "".concat(issue2.origin, " 中有無效的鍵值");
      case "invalid_union":
        return "無效的輸入值";
      case "invalid_element":
        return "".concat(issue2.origin, " 中有無效的值");
      default:
        return "無效的輸入值";
    }
  };
};
function zh_TW_default() {
  return {
    localeError: error39()
  };
}

// node_modules/zod/v4/core/registries.js
var $output = Symbol("ZodOutput");
var $input = Symbol("ZodInput");
var $ZodRegistry = class {
  constructor() {
    this._map = /* @__PURE__ */ new Map();
    this._idmap = /* @__PURE__ */ new Map();
  }
  add(schema, ..._meta) {
    const meta = _meta[0];
    this._map.set(schema, meta);
    if (meta && typeof meta === "object" && "id" in meta) {
      if (this._idmap.has(meta.id)) {
        throw new Error("ID ".concat(meta.id, " already exists in the registry"));
      }
      this._idmap.set(meta.id, schema);
    }
    return this;
  }
  clear() {
    this._map = /* @__PURE__ */ new Map();
    this._idmap = /* @__PURE__ */ new Map();
    return this;
  }
  remove(schema) {
    const meta = this._map.get(schema);
    if (meta && typeof meta === "object" && "id" in meta) {
      this._idmap.delete(meta.id);
    }
    this._map.delete(schema);
    return this;
  }
  get(schema) {
    var _a17;
    const p4 = schema._zod.parent;
    if (p4) {
      const pm = { ...(_a17 = this.get(p4)) != null ? _a17 : {} };
      delete pm.id;
      return { ...pm, ...this._map.get(schema) };
    }
    return this._map.get(schema);
  }
  has(schema) {
    return this._map.has(schema);
  }
};
function registry() {
  return new $ZodRegistry();
}
var globalRegistry = /* @__PURE__ */ registry();

// node_modules/zod/v4/core/api.js
function _string(Class2, params) {
  return new Class2({
    type: "string",
    ...normalizeParams(params)
  });
}
function _coercedString(Class2, params) {
  return new Class2({
    type: "string",
    coerce: true,
    ...normalizeParams(params)
  });
}
function _email(Class2, params) {
  return new Class2({
    type: "string",
    format: "email",
    check: "string_format",
    abort: false,
    ...normalizeParams(params)
  });
}
function _guid(Class2, params) {
  return new Class2({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: false,
    ...normalizeParams(params)
  });
}
function _uuid(Class2, params) {
  return new Class2({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: false,
    ...normalizeParams(params)
  });
}
function _uuidv4(Class2, params) {
  return new Class2({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: false,
    version: "v4",
    ...normalizeParams(params)
  });
}
function _uuidv6(Class2, params) {
  return new Class2({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: false,
    version: "v6",
    ...normalizeParams(params)
  });
}
function _uuidv7(Class2, params) {
  return new Class2({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: false,
    version: "v7",
    ...normalizeParams(params)
  });
}
function _url(Class2, params) {
  return new Class2({
    type: "string",
    format: "url",
    check: "string_format",
    abort: false,
    ...normalizeParams(params)
  });
}
function _emoji2(Class2, params) {
  return new Class2({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: false,
    ...normalizeParams(params)
  });
}
function _nanoid(Class2, params) {
  return new Class2({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: false,
    ...normalizeParams(params)
  });
}
function _cuid(Class2, params) {
  return new Class2({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: false,
    ...normalizeParams(params)
  });
}
function _cuid2(Class2, params) {
  return new Class2({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: false,
    ...normalizeParams(params)
  });
}
function _ulid(Class2, params) {
  return new Class2({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: false,
    ...normalizeParams(params)
  });
}
function _xid(Class2, params) {
  return new Class2({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: false,
    ...normalizeParams(params)
  });
}
function _ksuid(Class2, params) {
  return new Class2({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: false,
    ...normalizeParams(params)
  });
}
function _ipv4(Class2, params) {
  return new Class2({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: false,
    ...normalizeParams(params)
  });
}
function _ipv6(Class2, params) {
  return new Class2({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: false,
    ...normalizeParams(params)
  });
}
function _cidrv4(Class2, params) {
  return new Class2({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: false,
    ...normalizeParams(params)
  });
}
function _cidrv6(Class2, params) {
  return new Class2({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: false,
    ...normalizeParams(params)
  });
}
function _base64(Class2, params) {
  return new Class2({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: false,
    ...normalizeParams(params)
  });
}
function _base64url(Class2, params) {
  return new Class2({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: false,
    ...normalizeParams(params)
  });
}
function _e164(Class2, params) {
  return new Class2({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: false,
    ...normalizeParams(params)
  });
}
function _jwt(Class2, params) {
  return new Class2({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: false,
    ...normalizeParams(params)
  });
}
var TimePrecision = {
  Any: null,
  Minute: -1,
  Second: 0,
  Millisecond: 3,
  Microsecond: 6
};
function _isoDateTime(Class2, params) {
  return new Class2({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: false,
    local: false,
    precision: null,
    ...normalizeParams(params)
  });
}
function _isoDate(Class2, params) {
  return new Class2({
    type: "string",
    format: "date",
    check: "string_format",
    ...normalizeParams(params)
  });
}
function _isoTime(Class2, params) {
  return new Class2({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...normalizeParams(params)
  });
}
function _isoDuration(Class2, params) {
  return new Class2({
    type: "string",
    format: "duration",
    check: "string_format",
    ...normalizeParams(params)
  });
}
function _number(Class2, params) {
  return new Class2({
    type: "number",
    checks: [],
    ...normalizeParams(params)
  });
}
function _coercedNumber(Class2, params) {
  return new Class2({
    type: "number",
    coerce: true,
    checks: [],
    ...normalizeParams(params)
  });
}
function _int(Class2, params) {
  return new Class2({
    type: "number",
    check: "number_format",
    abort: false,
    format: "safeint",
    ...normalizeParams(params)
  });
}
function _float32(Class2, params) {
  return new Class2({
    type: "number",
    check: "number_format",
    abort: false,
    format: "float32",
    ...normalizeParams(params)
  });
}
function _float64(Class2, params) {
  return new Class2({
    type: "number",
    check: "number_format",
    abort: false,
    format: "float64",
    ...normalizeParams(params)
  });
}
function _int32(Class2, params) {
  return new Class2({
    type: "number",
    check: "number_format",
    abort: false,
    format: "int32",
    ...normalizeParams(params)
  });
}
function _uint32(Class2, params) {
  return new Class2({
    type: "number",
    check: "number_format",
    abort: false,
    format: "uint32",
    ...normalizeParams(params)
  });
}
function _boolean(Class2, params) {
  return new Class2({
    type: "boolean",
    ...normalizeParams(params)
  });
}
function _coercedBoolean(Class2, params) {
  return new Class2({
    type: "boolean",
    coerce: true,
    ...normalizeParams(params)
  });
}
function _bigint(Class2, params) {
  return new Class2({
    type: "bigint",
    ...normalizeParams(params)
  });
}
function _coercedBigint(Class2, params) {
  return new Class2({
    type: "bigint",
    coerce: true,
    ...normalizeParams(params)
  });
}
function _int64(Class2, params) {
  return new Class2({
    type: "bigint",
    check: "bigint_format",
    abort: false,
    format: "int64",
    ...normalizeParams(params)
  });
}
function _uint64(Class2, params) {
  return new Class2({
    type: "bigint",
    check: "bigint_format",
    abort: false,
    format: "uint64",
    ...normalizeParams(params)
  });
}
function _symbol(Class2, params) {
  return new Class2({
    type: "symbol",
    ...normalizeParams(params)
  });
}
function _undefined2(Class2, params) {
  return new Class2({
    type: "undefined",
    ...normalizeParams(params)
  });
}
function _null2(Class2, params) {
  return new Class2({
    type: "null",
    ...normalizeParams(params)
  });
}
function _any(Class2) {
  return new Class2({
    type: "any"
  });
}
function _unknown(Class2) {
  return new Class2({
    type: "unknown"
  });
}
function _never(Class2, params) {
  return new Class2({
    type: "never",
    ...normalizeParams(params)
  });
}
function _void(Class2, params) {
  return new Class2({
    type: "void",
    ...normalizeParams(params)
  });
}
function _date(Class2, params) {
  return new Class2({
    type: "date",
    ...normalizeParams(params)
  });
}
function _coercedDate(Class2, params) {
  return new Class2({
    type: "date",
    coerce: true,
    ...normalizeParams(params)
  });
}
function _nan(Class2, params) {
  return new Class2({
    type: "nan",
    ...normalizeParams(params)
  });
}
function _lt(value, params) {
  return new $ZodCheckLessThan({
    check: "less_than",
    ...normalizeParams(params),
    value,
    inclusive: false
  });
}
function _lte(value, params) {
  return new $ZodCheckLessThan({
    check: "less_than",
    ...normalizeParams(params),
    value,
    inclusive: true
  });
}
function _gt(value, params) {
  return new $ZodCheckGreaterThan({
    check: "greater_than",
    ...normalizeParams(params),
    value,
    inclusive: false
  });
}
function _gte(value, params) {
  return new $ZodCheckGreaterThan({
    check: "greater_than",
    ...normalizeParams(params),
    value,
    inclusive: true
  });
}
function _positive(params) {
  return _gt(0, params);
}
function _negative(params) {
  return _lt(0, params);
}
function _nonpositive(params) {
  return _lte(0, params);
}
function _nonnegative(params) {
  return _gte(0, params);
}
function _multipleOf(value, params) {
  return new $ZodCheckMultipleOf({
    check: "multiple_of",
    ...normalizeParams(params),
    value
  });
}
function _maxSize(maximum, params) {
  return new $ZodCheckMaxSize({
    check: "max_size",
    ...normalizeParams(params),
    maximum
  });
}
function _minSize(minimum, params) {
  return new $ZodCheckMinSize({
    check: "min_size",
    ...normalizeParams(params),
    minimum
  });
}
function _size(size, params) {
  return new $ZodCheckSizeEquals({
    check: "size_equals",
    ...normalizeParams(params),
    size
  });
}
function _maxLength(maximum, params) {
  const ch = new $ZodCheckMaxLength({
    check: "max_length",
    ...normalizeParams(params),
    maximum
  });
  return ch;
}
function _minLength(minimum, params) {
  return new $ZodCheckMinLength({
    check: "min_length",
    ...normalizeParams(params),
    minimum
  });
}
function _length(length, params) {
  return new $ZodCheckLengthEquals({
    check: "length_equals",
    ...normalizeParams(params),
    length
  });
}
function _regex(pattern, params) {
  return new $ZodCheckRegex({
    check: "string_format",
    format: "regex",
    ...normalizeParams(params),
    pattern
  });
}
function _lowercase(params) {
  return new $ZodCheckLowerCase({
    check: "string_format",
    format: "lowercase",
    ...normalizeParams(params)
  });
}
function _uppercase(params) {
  return new $ZodCheckUpperCase({
    check: "string_format",
    format: "uppercase",
    ...normalizeParams(params)
  });
}
function _includes(includes, params) {
  return new $ZodCheckIncludes({
    check: "string_format",
    format: "includes",
    ...normalizeParams(params),
    includes
  });
}
function _startsWith(prefix, params) {
  return new $ZodCheckStartsWith({
    check: "string_format",
    format: "starts_with",
    ...normalizeParams(params),
    prefix
  });
}
function _endsWith(suffix, params) {
  return new $ZodCheckEndsWith({
    check: "string_format",
    format: "ends_with",
    ...normalizeParams(params),
    suffix
  });
}
function _property(property, schema, params) {
  return new $ZodCheckProperty({
    check: "property",
    property,
    schema,
    ...normalizeParams(params)
  });
}
function _mime(types, params) {
  return new $ZodCheckMimeType({
    check: "mime_type",
    mime: types,
    ...normalizeParams(params)
  });
}
function _overwrite(tx) {
  return new $ZodCheckOverwrite({
    check: "overwrite",
    tx
  });
}
function _normalize(form) {
  return _overwrite((input) => input.normalize(form));
}
function _trim() {
  return _overwrite((input) => input.trim());
}
function _toLowerCase() {
  return _overwrite((input) => input.toLowerCase());
}
function _toUpperCase() {
  return _overwrite((input) => input.toUpperCase());
}
function _array(Class2, element, params) {
  return new Class2({
    type: "array",
    element,
    // get element() {
    //   return element;
    // },
    ...normalizeParams(params)
  });
}
function _union(Class2, options, params) {
  return new Class2({
    type: "union",
    options,
    ...normalizeParams(params)
  });
}
function _discriminatedUnion(Class2, discriminator, options, params) {
  return new Class2({
    type: "union",
    options,
    discriminator,
    ...normalizeParams(params)
  });
}
function _intersection(Class2, left, right) {
  return new Class2({
    type: "intersection",
    left,
    right
  });
}
function _tuple(Class2, items, _paramsOrRest, _params) {
  const hasRest = _paramsOrRest instanceof $ZodType;
  const params = hasRest ? _params : _paramsOrRest;
  const rest = hasRest ? _paramsOrRest : null;
  return new Class2({
    type: "tuple",
    items,
    rest,
    ...normalizeParams(params)
  });
}
function _record(Class2, keyType, valueType, params) {
  return new Class2({
    type: "record",
    keyType,
    valueType,
    ...normalizeParams(params)
  });
}
function _map(Class2, keyType, valueType, params) {
  return new Class2({
    type: "map",
    keyType,
    valueType,
    ...normalizeParams(params)
  });
}
function _set(Class2, valueType, params) {
  return new Class2({
    type: "set",
    valueType,
    ...normalizeParams(params)
  });
}
function _enum(Class2, values, params) {
  const entries = Array.isArray(values) ? Object.fromEntries(values.map((v4) => [v4, v4])) : values;
  return new Class2({
    type: "enum",
    entries,
    ...normalizeParams(params)
  });
}
function _nativeEnum(Class2, entries, params) {
  return new Class2({
    type: "enum",
    entries,
    ...normalizeParams(params)
  });
}
function _literal(Class2, value, params) {
  return new Class2({
    type: "literal",
    values: Array.isArray(value) ? value : [value],
    ...normalizeParams(params)
  });
}
function _file(Class2, params) {
  return new Class2({
    type: "file",
    ...normalizeParams(params)
  });
}
function _transform(Class2, fn) {
  return new Class2({
    type: "transform",
    transform: fn
  });
}
function _optional(Class2, innerType) {
  return new Class2({
    type: "optional",
    innerType
  });
}
function _nullable(Class2, innerType) {
  return new Class2({
    type: "nullable",
    innerType
  });
}
function _default2(Class2, innerType, defaultValue) {
  return new Class2({
    type: "default",
    innerType,
    get defaultValue() {
      return typeof defaultValue === "function" ? defaultValue() : defaultValue;
    }
  });
}
function _nonoptional(Class2, innerType, params) {
  return new Class2({
    type: "nonoptional",
    innerType,
    ...normalizeParams(params)
  });
}
function _success(Class2, innerType) {
  return new Class2({
    type: "success",
    innerType
  });
}
function _catch(Class2, innerType, catchValue) {
  return new Class2({
    type: "catch",
    innerType,
    catchValue: typeof catchValue === "function" ? catchValue : () => catchValue
  });
}
function _pipe(Class2, in_, out) {
  return new Class2({
    type: "pipe",
    in: in_,
    out
  });
}
function _readonly(Class2, innerType) {
  return new Class2({
    type: "readonly",
    innerType
  });
}
function _templateLiteral(Class2, parts, params) {
  return new Class2({
    type: "template_literal",
    parts,
    ...normalizeParams(params)
  });
}
function _lazy(Class2, getter) {
  return new Class2({
    type: "lazy",
    getter
  });
}
function _promise(Class2, innerType) {
  return new Class2({
    type: "promise",
    innerType
  });
}
function _custom(Class2, fn, _params) {
  var _a17;
  const norm = normalizeParams(_params);
  (_a17 = norm.abort) != null ? _a17 : norm.abort = true;
  const schema = new Class2({
    type: "custom",
    check: "custom",
    fn,
    ...norm
  });
  return schema;
}
function _refine(Class2, fn, _params) {
  const schema = new Class2({
    type: "custom",
    check: "custom",
    fn,
    ...normalizeParams(_params)
  });
  return schema;
}
function _stringbool(Classes, _params) {
  var _a17, _b8, _c, _d, _e2, _f;
  const params = normalizeParams(_params);
  let truthyArray = (_a17 = params.truthy) != null ? _a17 : ["true", "1", "yes", "on", "y", "enabled"];
  let falsyArray = (_b8 = params.falsy) != null ? _b8 : ["false", "0", "no", "off", "n", "disabled"];
  if (params.case !== "sensitive") {
    truthyArray = truthyArray.map((v4) => typeof v4 === "string" ? v4.toLowerCase() : v4);
    falsyArray = falsyArray.map((v4) => typeof v4 === "string" ? v4.toLowerCase() : v4);
  }
  const truthySet = new Set(truthyArray);
  const falsySet = new Set(falsyArray);
  const _Pipe = (_c = Classes.Pipe) != null ? _c : $ZodPipe;
  const _Boolean = (_d = Classes.Boolean) != null ? _d : $ZodBoolean;
  const _String = (_e2 = Classes.String) != null ? _e2 : $ZodString;
  const _Transform = (_f = Classes.Transform) != null ? _f : $ZodTransform;
  const tx = new _Transform({
    type: "transform",
    transform: (input, payload) => {
      let data = input;
      if (params.case !== "sensitive")
        data = data.toLowerCase();
      if (truthySet.has(data)) {
        return true;
      } else if (falsySet.has(data)) {
        return false;
      } else {
        payload.issues.push({
          code: "invalid_value",
          expected: "stringbool",
          values: [...truthySet, ...falsySet],
          input: payload.value,
          inst: tx
        });
        return {};
      }
    },
    error: params.error
  });
  const innerPipe = new _Pipe({
    type: "pipe",
    in: new _String({ type: "string", error: params.error }),
    out: tx,
    error: params.error
  });
  const outerPipe = new _Pipe({
    type: "pipe",
    in: innerPipe,
    out: new _Boolean({
      type: "boolean",
      error: params.error
    }),
    error: params.error
  });
  return outerPipe;
}
function _stringFormat(Class2, format, fnOrRegex, _params = {}) {
  const params = normalizeParams(_params);
  const def = {
    ...normalizeParams(_params),
    check: "string_format",
    type: "string",
    format,
    fn: typeof fnOrRegex === "function" ? fnOrRegex : (val) => fnOrRegex.test(val),
    ...params
  };
  if (fnOrRegex instanceof RegExp) {
    def.pattern = fnOrRegex;
  }
  const inst = new Class2(def);
  return inst;
}

// node_modules/zod/v4/core/function.js
var $ZodFunction = class {
  constructor(def) {
    this._def = def;
    this.def = def;
  }
  implement(func) {
    if (typeof func !== "function") {
      throw new Error("implement() must be called with a function");
    }
    const impl = (...args) => {
      const parsedArgs = this._def.input ? parse(this._def.input, args, void 0, { callee: impl }) : args;
      if (!Array.isArray(parsedArgs)) {
        throw new Error("Invalid arguments schema: not an array or tuple schema.");
      }
      const output = func(...parsedArgs);
      return this._def.output ? parse(this._def.output, output, void 0, { callee: impl }) : output;
    };
    return impl;
  }
  implementAsync(func) {
    if (typeof func !== "function") {
      throw new Error("implement() must be called with a function");
    }
    const impl = async (...args) => {
      const parsedArgs = this._def.input ? await parseAsync(this._def.input, args, void 0, { callee: impl }) : args;
      if (!Array.isArray(parsedArgs)) {
        throw new Error("Invalid arguments schema: not an array or tuple schema.");
      }
      const output = await func(...parsedArgs);
      return this._def.output ? parseAsync(this._def.output, output, void 0, { callee: impl }) : output;
    };
    return impl;
  }
  input(...args) {
    const F4 = this.constructor;
    if (Array.isArray(args[0])) {
      return new F4({
        type: "function",
        input: new $ZodTuple({
          type: "tuple",
          items: args[0],
          rest: args[1]
        }),
        output: this._def.output
      });
    }
    return new F4({
      type: "function",
      input: args[0],
      output: this._def.output
    });
  }
  output(output) {
    const F4 = this.constructor;
    return new F4({
      type: "function",
      input: this._def.input,
      output
    });
  }
};
function _function(params) {
  var _a17, _b8;
  return new $ZodFunction({
    type: "function",
    input: Array.isArray(params == null ? void 0 : params.input) ? _tuple($ZodTuple, params == null ? void 0 : params.input) : (_a17 = params == null ? void 0 : params.input) != null ? _a17 : _array($ZodArray, _unknown($ZodUnknown)),
    output: (_b8 = params == null ? void 0 : params.output) != null ? _b8 : _unknown($ZodUnknown)
  });
}

// node_modules/zod/v4/core/to-json-schema.js
var JSONSchemaGenerator = class {
  constructor(params) {
    var _a17, _b8, _c, _d, _e2;
    this.counter = 0;
    this.metadataRegistry = (_a17 = params == null ? void 0 : params.metadata) != null ? _a17 : globalRegistry;
    this.target = (_b8 = params == null ? void 0 : params.target) != null ? _b8 : "draft-2020-12";
    this.unrepresentable = (_c = params == null ? void 0 : params.unrepresentable) != null ? _c : "throw";
    this.override = (_d = params == null ? void 0 : params.override) != null ? _d : () => {
    };
    this.io = (_e2 = params == null ? void 0 : params.io) != null ? _e2 : "output";
    this.seen = /* @__PURE__ */ new Map();
  }
  process(schema, _params = { path: [], schemaPath: [] }) {
    var _a18, _b8, _c, _d, _e2;
    var _a17;
    const def = schema._zod.def;
    const formatMap = {
      guid: "uuid",
      url: "uri",
      datetime: "date-time",
      json_string: "json-string",
      regex: ""
      // do not set
    };
    const seen = this.seen.get(schema);
    if (seen) {
      seen.count++;
      const isCycle = _params.schemaPath.includes(schema);
      if (isCycle) {
        seen.cycle = _params.path;
      }
      return seen.schema;
    }
    const result = { schema: {}, count: 1, cycle: void 0, path: _params.path };
    this.seen.set(schema, result);
    const overrideSchema = (_b8 = (_a18 = schema._zod).toJSONSchema) == null ? void 0 : _b8.call(_a18);
    if (overrideSchema) {
      result.schema = overrideSchema;
    } else {
      const params = {
        ..._params,
        schemaPath: [..._params.schemaPath, schema],
        path: _params.path
      };
      const parent = schema._zod.parent;
      if (parent) {
        result.ref = parent;
        this.process(parent, params);
        this.seen.get(parent).isParent = true;
      } else {
        const _json = result.schema;
        switch (def.type) {
          case "string": {
            const json2 = _json;
            json2.type = "string";
            const { minimum, maximum, format, patterns, contentEncoding } = schema._zod.bag;
            if (typeof minimum === "number")
              json2.minLength = minimum;
            if (typeof maximum === "number")
              json2.maxLength = maximum;
            if (format) {
              json2.format = (_c = formatMap[format]) != null ? _c : format;
              if (json2.format === "")
                delete json2.format;
            }
            if (contentEncoding)
              json2.contentEncoding = contentEncoding;
            if (patterns && patterns.size > 0) {
              const regexes = [...patterns];
              if (regexes.length === 1)
                json2.pattern = regexes[0].source;
              else if (regexes.length > 1) {
                result.schema.allOf = [
                  ...regexes.map((regex) => ({
                    ...this.target === "draft-7" ? { type: "string" } : {},
                    pattern: regex.source
                  }))
                ];
              }
            }
            break;
          }
          case "number": {
            const json2 = _json;
            const { minimum, maximum, format, multipleOf, exclusiveMaximum, exclusiveMinimum } = schema._zod.bag;
            if (typeof format === "string" && format.includes("int"))
              json2.type = "integer";
            else
              json2.type = "number";
            if (typeof exclusiveMinimum === "number")
              json2.exclusiveMinimum = exclusiveMinimum;
            if (typeof minimum === "number") {
              json2.minimum = minimum;
              if (typeof exclusiveMinimum === "number") {
                if (exclusiveMinimum >= minimum)
                  delete json2.minimum;
                else
                  delete json2.exclusiveMinimum;
              }
            }
            if (typeof exclusiveMaximum === "number")
              json2.exclusiveMaximum = exclusiveMaximum;
            if (typeof maximum === "number") {
              json2.maximum = maximum;
              if (typeof exclusiveMaximum === "number") {
                if (exclusiveMaximum <= maximum)
                  delete json2.maximum;
                else
                  delete json2.exclusiveMaximum;
              }
            }
            if (typeof multipleOf === "number")
              json2.multipleOf = multipleOf;
            break;
          }
          case "boolean": {
            const json2 = _json;
            json2.type = "boolean";
            break;
          }
          case "bigint": {
            if (this.unrepresentable === "throw") {
              throw new Error("BigInt cannot be represented in JSON Schema");
            }
            break;
          }
          case "symbol": {
            if (this.unrepresentable === "throw") {
              throw new Error("Symbols cannot be represented in JSON Schema");
            }
            break;
          }
          case "null": {
            _json.type = "null";
            break;
          }
          case "any": {
            break;
          }
          case "unknown": {
            break;
          }
          case "undefined": {
            if (this.unrepresentable === "throw") {
              throw new Error("Undefined cannot be represented in JSON Schema");
            }
            break;
          }
          case "void": {
            if (this.unrepresentable === "throw") {
              throw new Error("Void cannot be represented in JSON Schema");
            }
            break;
          }
          case "never": {
            _json.not = {};
            break;
          }
          case "date": {
            if (this.unrepresentable === "throw") {
              throw new Error("Date cannot be represented in JSON Schema");
            }
            break;
          }
          case "array": {
            const json2 = _json;
            const { minimum, maximum } = schema._zod.bag;
            if (typeof minimum === "number")
              json2.minItems = minimum;
            if (typeof maximum === "number")
              json2.maxItems = maximum;
            json2.type = "array";
            json2.items = this.process(def.element, { ...params, path: [...params.path, "items"] });
            break;
          }
          case "object": {
            const json2 = _json;
            json2.type = "object";
            json2.properties = {};
            const shape = def.shape;
            for (const key2 in shape) {
              json2.properties[key2] = this.process(shape[key2], {
                ...params,
                path: [...params.path, "properties", key2]
              });
            }
            const allKeys = new Set(Object.keys(shape));
            const requiredKeys = new Set([...allKeys].filter((key2) => {
              const v4 = def.shape[key2]._zod;
              if (this.io === "input") {
                return v4.optin === void 0;
              } else {
                return v4.optout === void 0;
              }
            }));
            if (requiredKeys.size > 0) {
              json2.required = Array.from(requiredKeys);
            }
            if (((_d = def.catchall) == null ? void 0 : _d._zod.def.type) === "never") {
              json2.additionalProperties = false;
            } else if (!def.catchall) {
              if (this.io === "output")
                json2.additionalProperties = false;
            } else if (def.catchall) {
              json2.additionalProperties = this.process(def.catchall, {
                ...params,
                path: [...params.path, "additionalProperties"]
              });
            }
            break;
          }
          case "union": {
            const json2 = _json;
            json2.anyOf = def.options.map((x4, i4) => this.process(x4, {
              ...params,
              path: [...params.path, "anyOf", i4]
            }));
            break;
          }
          case "intersection": {
            const json2 = _json;
            const a4 = this.process(def.left, {
              ...params,
              path: [...params.path, "allOf", 0]
            });
            const b3 = this.process(def.right, {
              ...params,
              path: [...params.path, "allOf", 1]
            });
            const isSimpleIntersection = (val) => "allOf" in val && Object.keys(val).length === 1;
            const allOf = [
              ...isSimpleIntersection(a4) ? a4.allOf : [a4],
              ...isSimpleIntersection(b3) ? b3.allOf : [b3]
            ];
            json2.allOf = allOf;
            break;
          }
          case "tuple": {
            const json2 = _json;
            json2.type = "array";
            const prefixItems = def.items.map((x4, i4) => this.process(x4, { ...params, path: [...params.path, "prefixItems", i4] }));
            if (this.target === "draft-2020-12") {
              json2.prefixItems = prefixItems;
            } else {
              json2.items = prefixItems;
            }
            if (def.rest) {
              const rest = this.process(def.rest, {
                ...params,
                path: [...params.path, "items"]
              });
              if (this.target === "draft-2020-12") {
                json2.items = rest;
              } else {
                json2.additionalItems = rest;
              }
            }
            if (def.rest) {
              json2.items = this.process(def.rest, {
                ...params,
                path: [...params.path, "items"]
              });
            }
            const { minimum, maximum } = schema._zod.bag;
            if (typeof minimum === "number")
              json2.minItems = minimum;
            if (typeof maximum === "number")
              json2.maxItems = maximum;
            break;
          }
          case "record": {
            const json2 = _json;
            json2.type = "object";
            json2.propertyNames = this.process(def.keyType, { ...params, path: [...params.path, "propertyNames"] });
            json2.additionalProperties = this.process(def.valueType, {
              ...params,
              path: [...params.path, "additionalProperties"]
            });
            break;
          }
          case "map": {
            if (this.unrepresentable === "throw") {
              throw new Error("Map cannot be represented in JSON Schema");
            }
            break;
          }
          case "set": {
            if (this.unrepresentable === "throw") {
              throw new Error("Set cannot be represented in JSON Schema");
            }
            break;
          }
          case "enum": {
            const json2 = _json;
            const values = getEnumValues(def.entries);
            if (values.every((v4) => typeof v4 === "number"))
              json2.type = "number";
            if (values.every((v4) => typeof v4 === "string"))
              json2.type = "string";
            json2.enum = values;
            break;
          }
          case "literal": {
            const json2 = _json;
            const vals = [];
            for (const val of def.values) {
              if (val === void 0) {
                if (this.unrepresentable === "throw") {
                  throw new Error("Literal `undefined` cannot be represented in JSON Schema");
                } else {
                }
              } else if (typeof val === "bigint") {
                if (this.unrepresentable === "throw") {
                  throw new Error("BigInt literals cannot be represented in JSON Schema");
                } else {
                  vals.push(Number(val));
                }
              } else {
                vals.push(val);
              }
            }
            if (vals.length === 0) {
            } else if (vals.length === 1) {
              const val = vals[0];
              json2.type = val === null ? "null" : typeof val;
              json2.const = val;
            } else {
              if (vals.every((v4) => typeof v4 === "number"))
                json2.type = "number";
              if (vals.every((v4) => typeof v4 === "string"))
                json2.type = "string";
              if (vals.every((v4) => typeof v4 === "boolean"))
                json2.type = "string";
              if (vals.every((v4) => v4 === null))
                json2.type = "null";
              json2.enum = vals;
            }
            break;
          }
          case "file": {
            const json2 = _json;
            const file2 = {
              type: "string",
              format: "binary",
              contentEncoding: "binary"
            };
            const { minimum, maximum, mime } = schema._zod.bag;
            if (minimum !== void 0)
              file2.minLength = minimum;
            if (maximum !== void 0)
              file2.maxLength = maximum;
            if (mime) {
              if (mime.length === 1) {
                file2.contentMediaType = mime[0];
                Object.assign(json2, file2);
              } else {
                json2.anyOf = mime.map((m5) => {
                  const mFile = { ...file2, contentMediaType: m5 };
                  return mFile;
                });
              }
            } else {
              Object.assign(json2, file2);
            }
            break;
          }
          case "transform": {
            if (this.unrepresentable === "throw") {
              throw new Error("Transforms cannot be represented in JSON Schema");
            }
            break;
          }
          case "nullable": {
            const inner = this.process(def.innerType, params);
            _json.anyOf = [inner, { type: "null" }];
            break;
          }
          case "nonoptional": {
            this.process(def.innerType, params);
            result.ref = def.innerType;
            break;
          }
          case "success": {
            const json2 = _json;
            json2.type = "boolean";
            break;
          }
          case "default": {
            this.process(def.innerType, params);
            result.ref = def.innerType;
            _json.default = JSON.parse(JSON.stringify(def.defaultValue));
            break;
          }
          case "prefault": {
            this.process(def.innerType, params);
            result.ref = def.innerType;
            if (this.io === "input")
              _json._prefault = JSON.parse(JSON.stringify(def.defaultValue));
            break;
          }
          case "catch": {
            this.process(def.innerType, params);
            result.ref = def.innerType;
            let catchValue;
            try {
              catchValue = def.catchValue(void 0);
            } catch (e4) {
              throw new Error("Dynamic catch values are not supported in JSON Schema");
            }
            _json.default = catchValue;
            break;
          }
          case "nan": {
            if (this.unrepresentable === "throw") {
              throw new Error("NaN cannot be represented in JSON Schema");
            }
            break;
          }
          case "template_literal": {
            const json2 = _json;
            const pattern = schema._zod.pattern;
            if (!pattern)
              throw new Error("Pattern not found in template literal");
            json2.type = "string";
            json2.pattern = pattern.source;
            break;
          }
          case "pipe": {
            const innerType = this.io === "input" ? def.in._zod.def.type === "transform" ? def.out : def.in : def.out;
            this.process(innerType, params);
            result.ref = innerType;
            break;
          }
          case "readonly": {
            this.process(def.innerType, params);
            result.ref = def.innerType;
            _json.readOnly = true;
            break;
          }
          case "promise": {
            this.process(def.innerType, params);
            result.ref = def.innerType;
            break;
          }
          case "optional": {
            this.process(def.innerType, params);
            result.ref = def.innerType;
            break;
          }
          case "lazy": {
            const innerType = schema._zod.innerType;
            this.process(innerType, params);
            result.ref = innerType;
            break;
          }
          case "custom": {
            if (this.unrepresentable === "throw") {
              throw new Error("Custom types cannot be represented in JSON Schema");
            }
            break;
          }
          default: {
            def;
          }
        }
      }
    }
    const meta = this.metadataRegistry.get(schema);
    if (meta)
      Object.assign(result.schema, meta);
    if (this.io === "input" && isTransforming(schema)) {
      delete result.schema.examples;
      delete result.schema.default;
    }
    if (this.io === "input" && result.schema._prefault)
      (_e2 = (_a17 = result.schema).default) != null ? _e2 : _a17.default = result.schema._prefault;
    delete result.schema._prefault;
    const _result = this.seen.get(schema);
    return _result.schema;
  }
  emit(schema, _params) {
    var _a17, _b8, _c, _d, _e2, _f, _g, _h, _i, _j;
    const params = {
      cycles: (_a17 = _params == null ? void 0 : _params.cycles) != null ? _a17 : "ref",
      reused: (_b8 = _params == null ? void 0 : _params.reused) != null ? _b8 : "inline",
      // unrepresentable: _params?.unrepresentable ?? "throw",
      // uri: _params?.uri ?? ((id) => `${id}`),
      external: (_c = _params == null ? void 0 : _params.external) != null ? _c : void 0
    };
    const root = this.seen.get(schema);
    if (!root)
      throw new Error("Unprocessed schema. This is a bug in Zod.");
    const makeURI = (entry) => {
      var _a18, _b9, _c2, _d2, _e3;
      const defsSegment = this.target === "draft-2020-12" ? "$defs" : "definitions";
      if (params.external) {
        const externalId = (_a18 = params.external.registry.get(entry[0])) == null ? void 0 : _a18.id;
        const uriGenerator = (_b9 = params.external.uri) != null ? _b9 : (id2) => id2;
        if (externalId) {
          return { ref: uriGenerator(externalId) };
        }
        const id = (_d2 = (_c2 = entry[1].defId) != null ? _c2 : entry[1].schema.id) != null ? _d2 : "schema".concat(this.counter++);
        entry[1].defId = id;
        return { defId: id, ref: "".concat(uriGenerator("__shared"), "#/").concat(defsSegment, "/").concat(id) };
      }
      if (entry[1] === root) {
        return { ref: "#" };
      }
      const uriPrefix = "#";
      const defUriPrefix = "".concat(uriPrefix, "/").concat(defsSegment, "/");
      const defId = (_e3 = entry[1].schema.id) != null ? _e3 : "__schema".concat(this.counter++);
      return { defId, ref: defUriPrefix + defId };
    };
    const extractToDef = (entry) => {
      if (entry[1].schema.$ref) {
        return;
      }
      const seen = entry[1];
      const { ref, defId } = makeURI(entry);
      seen.def = { ...seen.schema };
      if (defId)
        seen.defId = defId;
      const schema2 = seen.schema;
      for (const key2 in schema2) {
        delete schema2[key2];
      }
      schema2.$ref = ref;
    };
    if (params.cycles === "throw") {
      for (const entry of this.seen.entries()) {
        const seen = entry[1];
        if (seen.cycle) {
          throw new Error("Cycle detected: " + "#/".concat((_d = seen.cycle) == null ? void 0 : _d.join("/"), "/<root>") + '\n\nSet the `cycles` parameter to `"ref"` to resolve cyclical schemas with defs.');
        }
      }
    }
    for (const entry of this.seen.entries()) {
      const seen = entry[1];
      if (schema === entry[0]) {
        extractToDef(entry);
        continue;
      }
      if (params.external) {
        const ext = (_e2 = params.external.registry.get(entry[0])) == null ? void 0 : _e2.id;
        if (schema !== entry[0] && ext) {
          extractToDef(entry);
          continue;
        }
      }
      const id = (_f = this.metadataRegistry.get(entry[0])) == null ? void 0 : _f.id;
      if (id) {
        extractToDef(entry);
        continue;
      }
      if (seen.cycle) {
        extractToDef(entry);
        continue;
      }
      if (seen.count > 1) {
        if (params.reused === "ref") {
          extractToDef(entry);
          continue;
        }
      }
    }
    const flattenRef = (zodSchema2, params2) => {
      var _a18, _b9, _c2;
      const seen = this.seen.get(zodSchema2);
      const schema2 = (_a18 = seen.def) != null ? _a18 : seen.schema;
      const _cached = { ...schema2 };
      if (seen.ref === null) {
        return;
      }
      const ref = seen.ref;
      seen.ref = null;
      if (ref) {
        flattenRef(ref, params2);
        const refSchema = this.seen.get(ref).schema;
        if (refSchema.$ref && params2.target === "draft-7") {
          schema2.allOf = (_b9 = schema2.allOf) != null ? _b9 : [];
          schema2.allOf.push(refSchema);
        } else {
          Object.assign(schema2, refSchema);
          Object.assign(schema2, _cached);
        }
      }
      if (!seen.isParent)
        this.override({
          zodSchema: zodSchema2,
          jsonSchema: schema2,
          path: (_c2 = seen.path) != null ? _c2 : []
        });
    };
    for (const entry of [...this.seen.entries()].reverse()) {
      flattenRef(entry[0], { target: this.target });
    }
    const result = {};
    if (this.target === "draft-2020-12") {
      result.$schema = "https://json-schema.org/draft/2020-12/schema";
    } else if (this.target === "draft-7") {
      result.$schema = "http://json-schema.org/draft-07/schema#";
    } else {
      console.warn("Invalid target: ".concat(this.target));
    }
    if ((_g = params.external) == null ? void 0 : _g.uri) {
      const id = (_h = params.external.registry.get(schema)) == null ? void 0 : _h.id;
      if (!id)
        throw new Error("Schema is missing an `id` property");
      result.$id = params.external.uri(id);
    }
    Object.assign(result, root.def);
    const defs = (_j = (_i = params.external) == null ? void 0 : _i.defs) != null ? _j : {};
    for (const entry of this.seen.entries()) {
      const seen = entry[1];
      if (seen.def && seen.defId) {
        defs[seen.defId] = seen.def;
      }
    }
    if (params.external) {
    } else {
      if (Object.keys(defs).length > 0) {
        if (this.target === "draft-2020-12") {
          result.$defs = defs;
        } else {
          result.definitions = defs;
        }
      }
    }
    try {
      return JSON.parse(JSON.stringify(result));
    } catch (_err) {
      throw new Error("Error converting schema to JSON.");
    }
  }
};
function toJSONSchema(input, _params) {
  if (input instanceof $ZodRegistry) {
    const gen2 = new JSONSchemaGenerator(_params);
    const defs = {};
    for (const entry of input._idmap.entries()) {
      const [_4, schema] = entry;
      gen2.process(schema);
    }
    const schemas = {};
    const external = {
      registry: input,
      uri: _params == null ? void 0 : _params.uri,
      defs
    };
    for (const entry of input._idmap.entries()) {
      const [key2, schema] = entry;
      schemas[key2] = gen2.emit(schema, {
        ..._params,
        external
      });
    }
    if (Object.keys(defs).length > 0) {
      const defsSegment = gen2.target === "draft-2020-12" ? "$defs" : "definitions";
      schemas.__shared = {
        [defsSegment]: defs
      };
    }
    return { schemas };
  }
  const gen = new JSONSchemaGenerator(_params);
  gen.process(input);
  return gen.emit(input, _params);
}
function isTransforming(_schema, _ctx) {
  const ctx = _ctx != null ? _ctx : { seen: /* @__PURE__ */ new Set() };
  if (ctx.seen.has(_schema))
    return false;
  ctx.seen.add(_schema);
  const schema = _schema;
  const def = schema._zod.def;
  switch (def.type) {
    case "string":
    case "number":
    case "bigint":
    case "boolean":
    case "date":
    case "symbol":
    case "undefined":
    case "null":
    case "any":
    case "unknown":
    case "never":
    case "void":
    case "literal":
    case "enum":
    case "nan":
    case "file":
    case "template_literal":
      return false;
    case "array": {
      return isTransforming(def.element, ctx);
    }
    case "object": {
      for (const key2 in def.shape) {
        if (isTransforming(def.shape[key2], ctx))
          return true;
      }
      return false;
    }
    case "union": {
      for (const option of def.options) {
        if (isTransforming(option, ctx))
          return true;
      }
      return false;
    }
    case "intersection": {
      return isTransforming(def.left, ctx) || isTransforming(def.right, ctx);
    }
    case "tuple": {
      for (const item11 of def.items) {
        if (isTransforming(item11, ctx))
          return true;
      }
      if (def.rest && isTransforming(def.rest, ctx))
        return true;
      return false;
    }
    case "record": {
      return isTransforming(def.keyType, ctx) || isTransforming(def.valueType, ctx);
    }
    case "map": {
      return isTransforming(def.keyType, ctx) || isTransforming(def.valueType, ctx);
    }
    case "set": {
      return isTransforming(def.valueType, ctx);
    }
    case "promise":
    case "optional":
    case "nonoptional":
    case "nullable":
    case "readonly":
      return isTransforming(def.innerType, ctx);
    case "lazy":
      return isTransforming(def.getter(), ctx);
    case "default": {
      return isTransforming(def.innerType, ctx);
    }
    case "prefault": {
      return isTransforming(def.innerType, ctx);
    }
    case "custom": {
      return false;
    }
    case "transform": {
      return true;
    }
    case "pipe": {
      return isTransforming(def.in, ctx) || isTransforming(def.out, ctx);
    }
    case "success": {
      return false;
    }
    case "catch": {
      return false;
    }
    default:
      def;
  }
  throw new Error("Unknown schema type: ".concat(def.type));
}

// node_modules/zod/v4/core/json-schema.js
var json_schema_exports = {};

// node_modules/zod/v4/classic/iso.js
var iso_exports = {};
__export(iso_exports, {
  ZodISODate: () => ZodISODate,
  ZodISODateTime: () => ZodISODateTime,
  ZodISODuration: () => ZodISODuration,
  ZodISOTime: () => ZodISOTime,
  date: () => date2,
  datetime: () => datetime2,
  duration: () => duration2,
  time: () => time2
});
var ZodISODateTime = /* @__PURE__ */ $constructor("ZodISODateTime", (inst, def) => {
  $ZodISODateTime.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function datetime2(params) {
  return _isoDateTime(ZodISODateTime, params);
}
var ZodISODate = /* @__PURE__ */ $constructor("ZodISODate", (inst, def) => {
  $ZodISODate.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function date2(params) {
  return _isoDate(ZodISODate, params);
}
var ZodISOTime = /* @__PURE__ */ $constructor("ZodISOTime", (inst, def) => {
  $ZodISOTime.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function time2(params) {
  return _isoTime(ZodISOTime, params);
}
var ZodISODuration = /* @__PURE__ */ $constructor("ZodISODuration", (inst, def) => {
  $ZodISODuration.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function duration2(params) {
  return _isoDuration(ZodISODuration, params);
}

// node_modules/zod/v4/classic/errors.js
var initializer2 = (inst, issues) => {
  $ZodError.init(inst, issues);
  inst.name = "ZodError";
  Object.defineProperties(inst, {
    format: {
      value: (mapper) => formatError(inst, mapper)
      // enumerable: false,
    },
    flatten: {
      value: (mapper) => flattenError(inst, mapper)
      // enumerable: false,
    },
    addIssue: {
      value: (issue2) => inst.issues.push(issue2)
      // enumerable: false,
    },
    addIssues: {
      value: (issues2) => inst.issues.push(...issues2)
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return inst.issues.length === 0;
      }
      // enumerable: false,
    }
  });
};
var ZodError = $constructor("ZodError", initializer2);
var ZodRealError = $constructor("ZodError", initializer2, {
  Parent: Error
});

// node_modules/zod/v4/classic/parse.js
var parse2 = /* @__PURE__ */ _parse(ZodRealError);
var parseAsync2 = /* @__PURE__ */ _parseAsync(ZodRealError);
var safeParse2 = /* @__PURE__ */ _safeParse(ZodRealError);
var safeParseAsync2 = /* @__PURE__ */ _safeParseAsync(ZodRealError);

// node_modules/zod/v4/classic/schemas.js
var ZodType = /* @__PURE__ */ $constructor("ZodType", (inst, def) => {
  $ZodType.init(inst, def);
  inst.def = def;
  Object.defineProperty(inst, "_def", { value: def });
  inst.check = (...checks) => {
    var _a17;
    return inst.clone(
      {
        ...def,
        checks: [
          ...(_a17 = def.checks) != null ? _a17 : [],
          ...checks.map((ch) => typeof ch === "function" ? { _zod: { check: ch, def: { check: "custom" }, onattach: [] } } : ch)
        ]
      }
      // { parent: true }
    );
  };
  inst.clone = (def2, params) => clone(inst, def2, params);
  inst.brand = () => inst;
  inst.register = (reg, meta) => {
    reg.add(inst, meta);
    return inst;
  };
  inst.parse = (data, params) => parse2(inst, data, params, { callee: inst.parse });
  inst.safeParse = (data, params) => safeParse2(inst, data, params);
  inst.parseAsync = async (data, params) => parseAsync2(inst, data, params, { callee: inst.parseAsync });
  inst.safeParseAsync = async (data, params) => safeParseAsync2(inst, data, params);
  inst.spa = inst.safeParseAsync;
  inst.refine = (check2, params) => inst.check(refine(check2, params));
  inst.superRefine = (refinement) => inst.check(superRefine(refinement));
  inst.overwrite = (fn) => inst.check(_overwrite(fn));
  inst.optional = () => optional(inst);
  inst.nullable = () => nullable(inst);
  inst.nullish = () => optional(nullable(inst));
  inst.nonoptional = (params) => nonoptional(inst, params);
  inst.array = () => array(inst);
  inst.or = (arg) => union([inst, arg]);
  inst.and = (arg) => intersection(inst, arg);
  inst.transform = (tx) => pipe(inst, transform(tx));
  inst.default = (def2) => _default3(inst, def2);
  inst.prefault = (def2) => prefault(inst, def2);
  inst.catch = (params) => _catch2(inst, params);
  inst.pipe = (target) => pipe(inst, target);
  inst.readonly = () => readonly(inst);
  inst.describe = (description) => {
    const cl = inst.clone();
    globalRegistry.add(cl, { description });
    return cl;
  };
  Object.defineProperty(inst, "description", {
    get() {
      var _a17;
      return (_a17 = globalRegistry.get(inst)) == null ? void 0 : _a17.description;
    },
    configurable: true
  });
  inst.meta = (...args) => {
    if (args.length === 0) {
      return globalRegistry.get(inst);
    }
    const cl = inst.clone();
    globalRegistry.add(cl, args[0]);
    return cl;
  };
  inst.isOptional = () => inst.safeParse(void 0).success;
  inst.isNullable = () => inst.safeParse(null).success;
  return inst;
});
var _ZodString = /* @__PURE__ */ $constructor("_ZodString", (inst, def) => {
  var _a17, _b8, _c;
  $ZodString.init(inst, def);
  ZodType.init(inst, def);
  const bag = inst._zod.bag;
  inst.format = (_a17 = bag.format) != null ? _a17 : null;
  inst.minLength = (_b8 = bag.minimum) != null ? _b8 : null;
  inst.maxLength = (_c = bag.maximum) != null ? _c : null;
  inst.regex = (...args) => inst.check(_regex(...args));
  inst.includes = (...args) => inst.check(_includes(...args));
  inst.startsWith = (...args) => inst.check(_startsWith(...args));
  inst.endsWith = (...args) => inst.check(_endsWith(...args));
  inst.min = (...args) => inst.check(_minLength(...args));
  inst.max = (...args) => inst.check(_maxLength(...args));
  inst.length = (...args) => inst.check(_length(...args));
  inst.nonempty = (...args) => inst.check(_minLength(1, ...args));
  inst.lowercase = (params) => inst.check(_lowercase(params));
  inst.uppercase = (params) => inst.check(_uppercase(params));
  inst.trim = () => inst.check(_trim());
  inst.normalize = (...args) => inst.check(_normalize(...args));
  inst.toLowerCase = () => inst.check(_toLowerCase());
  inst.toUpperCase = () => inst.check(_toUpperCase());
});
var ZodString = /* @__PURE__ */ $constructor("ZodString", (inst, def) => {
  $ZodString.init(inst, def);
  _ZodString.init(inst, def);
  inst.email = (params) => inst.check(_email(ZodEmail, params));
  inst.url = (params) => inst.check(_url(ZodURL, params));
  inst.jwt = (params) => inst.check(_jwt(ZodJWT, params));
  inst.emoji = (params) => inst.check(_emoji2(ZodEmoji, params));
  inst.guid = (params) => inst.check(_guid(ZodGUID, params));
  inst.uuid = (params) => inst.check(_uuid(ZodUUID, params));
  inst.uuidv4 = (params) => inst.check(_uuidv4(ZodUUID, params));
  inst.uuidv6 = (params) => inst.check(_uuidv6(ZodUUID, params));
  inst.uuidv7 = (params) => inst.check(_uuidv7(ZodUUID, params));
  inst.nanoid = (params) => inst.check(_nanoid(ZodNanoID, params));
  inst.guid = (params) => inst.check(_guid(ZodGUID, params));
  inst.cuid = (params) => inst.check(_cuid(ZodCUID, params));
  inst.cuid2 = (params) => inst.check(_cuid2(ZodCUID2, params));
  inst.ulid = (params) => inst.check(_ulid(ZodULID, params));
  inst.base64 = (params) => inst.check(_base64(ZodBase64, params));
  inst.base64url = (params) => inst.check(_base64url(ZodBase64URL, params));
  inst.xid = (params) => inst.check(_xid(ZodXID, params));
  inst.ksuid = (params) => inst.check(_ksuid(ZodKSUID, params));
  inst.ipv4 = (params) => inst.check(_ipv4(ZodIPv4, params));
  inst.ipv6 = (params) => inst.check(_ipv6(ZodIPv6, params));
  inst.cidrv4 = (params) => inst.check(_cidrv4(ZodCIDRv4, params));
  inst.cidrv6 = (params) => inst.check(_cidrv6(ZodCIDRv6, params));
  inst.e164 = (params) => inst.check(_e164(ZodE164, params));
  inst.datetime = (params) => inst.check(datetime2(params));
  inst.date = (params) => inst.check(date2(params));
  inst.time = (params) => inst.check(time2(params));
  inst.duration = (params) => inst.check(duration2(params));
});
function string2(params) {
  return _string(ZodString, params);
}
var ZodStringFormat = /* @__PURE__ */ $constructor("ZodStringFormat", (inst, def) => {
  $ZodStringFormat.init(inst, def);
  _ZodString.init(inst, def);
});
var ZodEmail = /* @__PURE__ */ $constructor("ZodEmail", (inst, def) => {
  $ZodEmail.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function email2(params) {
  return _email(ZodEmail, params);
}
var ZodGUID = /* @__PURE__ */ $constructor("ZodGUID", (inst, def) => {
  $ZodGUID.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function guid2(params) {
  return _guid(ZodGUID, params);
}
var ZodUUID = /* @__PURE__ */ $constructor("ZodUUID", (inst, def) => {
  $ZodUUID.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function uuid2(params) {
  return _uuid(ZodUUID, params);
}
function uuidv4(params) {
  return _uuidv4(ZodUUID, params);
}
function uuidv6(params) {
  return _uuidv6(ZodUUID, params);
}
function uuidv7(params) {
  return _uuidv7(ZodUUID, params);
}
var ZodURL = /* @__PURE__ */ $constructor("ZodURL", (inst, def) => {
  $ZodURL.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function url(params) {
  return _url(ZodURL, params);
}
var ZodEmoji = /* @__PURE__ */ $constructor("ZodEmoji", (inst, def) => {
  $ZodEmoji.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function emoji2(params) {
  return _emoji2(ZodEmoji, params);
}
var ZodNanoID = /* @__PURE__ */ $constructor("ZodNanoID", (inst, def) => {
  $ZodNanoID.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function nanoid2(params) {
  return _nanoid(ZodNanoID, params);
}
var ZodCUID = /* @__PURE__ */ $constructor("ZodCUID", (inst, def) => {
  $ZodCUID.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function cuid3(params) {
  return _cuid(ZodCUID, params);
}
var ZodCUID2 = /* @__PURE__ */ $constructor("ZodCUID2", (inst, def) => {
  $ZodCUID2.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function cuid22(params) {
  return _cuid2(ZodCUID2, params);
}
var ZodULID = /* @__PURE__ */ $constructor("ZodULID", (inst, def) => {
  $ZodULID.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function ulid2(params) {
  return _ulid(ZodULID, params);
}
var ZodXID = /* @__PURE__ */ $constructor("ZodXID", (inst, def) => {
  $ZodXID.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function xid2(params) {
  return _xid(ZodXID, params);
}
var ZodKSUID = /* @__PURE__ */ $constructor("ZodKSUID", (inst, def) => {
  $ZodKSUID.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function ksuid2(params) {
  return _ksuid(ZodKSUID, params);
}
var ZodIPv4 = /* @__PURE__ */ $constructor("ZodIPv4", (inst, def) => {
  $ZodIPv4.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function ipv42(params) {
  return _ipv4(ZodIPv4, params);
}
var ZodIPv6 = /* @__PURE__ */ $constructor("ZodIPv6", (inst, def) => {
  $ZodIPv6.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function ipv62(params) {
  return _ipv6(ZodIPv6, params);
}
var ZodCIDRv4 = /* @__PURE__ */ $constructor("ZodCIDRv4", (inst, def) => {
  $ZodCIDRv4.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function cidrv42(params) {
  return _cidrv4(ZodCIDRv4, params);
}
var ZodCIDRv6 = /* @__PURE__ */ $constructor("ZodCIDRv6", (inst, def) => {
  $ZodCIDRv6.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function cidrv62(params) {
  return _cidrv6(ZodCIDRv6, params);
}
var ZodBase64 = /* @__PURE__ */ $constructor("ZodBase64", (inst, def) => {
  $ZodBase64.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function base642(params) {
  return _base64(ZodBase64, params);
}
var ZodBase64URL = /* @__PURE__ */ $constructor("ZodBase64URL", (inst, def) => {
  $ZodBase64URL.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function base64url2(params) {
  return _base64url(ZodBase64URL, params);
}
var ZodE164 = /* @__PURE__ */ $constructor("ZodE164", (inst, def) => {
  $ZodE164.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function e1642(params) {
  return _e164(ZodE164, params);
}
var ZodJWT = /* @__PURE__ */ $constructor("ZodJWT", (inst, def) => {
  $ZodJWT.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function jwt(params) {
  return _jwt(ZodJWT, params);
}
var ZodCustomStringFormat = /* @__PURE__ */ $constructor("ZodCustomStringFormat", (inst, def) => {
  $ZodCustomStringFormat.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function stringFormat(format, fnOrRegex, _params = {}) {
  return _stringFormat(ZodCustomStringFormat, format, fnOrRegex, _params);
}
var ZodNumber = /* @__PURE__ */ $constructor("ZodNumber", (inst, def) => {
  var _a17, _b8, _c, _d, _e2, _f, _g, _h, _i;
  $ZodNumber.init(inst, def);
  ZodType.init(inst, def);
  inst.gt = (value, params) => inst.check(_gt(value, params));
  inst.gte = (value, params) => inst.check(_gte(value, params));
  inst.min = (value, params) => inst.check(_gte(value, params));
  inst.lt = (value, params) => inst.check(_lt(value, params));
  inst.lte = (value, params) => inst.check(_lte(value, params));
  inst.max = (value, params) => inst.check(_lte(value, params));
  inst.int = (params) => inst.check(int(params));
  inst.safe = (params) => inst.check(int(params));
  inst.positive = (params) => inst.check(_gt(0, params));
  inst.nonnegative = (params) => inst.check(_gte(0, params));
  inst.negative = (params) => inst.check(_lt(0, params));
  inst.nonpositive = (params) => inst.check(_lte(0, params));
  inst.multipleOf = (value, params) => inst.check(_multipleOf(value, params));
  inst.step = (value, params) => inst.check(_multipleOf(value, params));
  inst.finite = () => inst;
  const bag = inst._zod.bag;
  inst.minValue = (_c = Math.max((_a17 = bag.minimum) != null ? _a17 : Number.NEGATIVE_INFINITY, (_b8 = bag.exclusiveMinimum) != null ? _b8 : Number.NEGATIVE_INFINITY)) != null ? _c : null;
  inst.maxValue = (_f = Math.min((_d = bag.maximum) != null ? _d : Number.POSITIVE_INFINITY, (_e2 = bag.exclusiveMaximum) != null ? _e2 : Number.POSITIVE_INFINITY)) != null ? _f : null;
  inst.isInt = ((_g = bag.format) != null ? _g : "").includes("int") || Number.isSafeInteger((_h = bag.multipleOf) != null ? _h : 0.5);
  inst.isFinite = true;
  inst.format = (_i = bag.format) != null ? _i : null;
});
function number2(params) {
  return _number(ZodNumber, params);
}
var ZodNumberFormat = /* @__PURE__ */ $constructor("ZodNumberFormat", (inst, def) => {
  $ZodNumberFormat.init(inst, def);
  ZodNumber.init(inst, def);
});
function int(params) {
  return _int(ZodNumberFormat, params);
}
function float32(params) {
  return _float32(ZodNumberFormat, params);
}
function float64(params) {
  return _float64(ZodNumberFormat, params);
}
function int32(params) {
  return _int32(ZodNumberFormat, params);
}
function uint32(params) {
  return _uint32(ZodNumberFormat, params);
}
var ZodBoolean = /* @__PURE__ */ $constructor("ZodBoolean", (inst, def) => {
  $ZodBoolean.init(inst, def);
  ZodType.init(inst, def);
});
function boolean2(params) {
  return _boolean(ZodBoolean, params);
}
var ZodBigInt = /* @__PURE__ */ $constructor("ZodBigInt", (inst, def) => {
  var _a17, _b8, _c;
  $ZodBigInt.init(inst, def);
  ZodType.init(inst, def);
  inst.gte = (value, params) => inst.check(_gte(value, params));
  inst.min = (value, params) => inst.check(_gte(value, params));
  inst.gt = (value, params) => inst.check(_gt(value, params));
  inst.gte = (value, params) => inst.check(_gte(value, params));
  inst.min = (value, params) => inst.check(_gte(value, params));
  inst.lt = (value, params) => inst.check(_lt(value, params));
  inst.lte = (value, params) => inst.check(_lte(value, params));
  inst.max = (value, params) => inst.check(_lte(value, params));
  inst.positive = (params) => inst.check(_gt(BigInt(0), params));
  inst.negative = (params) => inst.check(_lt(BigInt(0), params));
  inst.nonpositive = (params) => inst.check(_lte(BigInt(0), params));
  inst.nonnegative = (params) => inst.check(_gte(BigInt(0), params));
  inst.multipleOf = (value, params) => inst.check(_multipleOf(value, params));
  const bag = inst._zod.bag;
  inst.minValue = (_a17 = bag.minimum) != null ? _a17 : null;
  inst.maxValue = (_b8 = bag.maximum) != null ? _b8 : null;
  inst.format = (_c = bag.format) != null ? _c : null;
});
function bigint2(params) {
  return _bigint(ZodBigInt, params);
}
var ZodBigIntFormat = /* @__PURE__ */ $constructor("ZodBigIntFormat", (inst, def) => {
  $ZodBigIntFormat.init(inst, def);
  ZodBigInt.init(inst, def);
});
function int64(params) {
  return _int64(ZodBigIntFormat, params);
}
function uint64(params) {
  return _uint64(ZodBigIntFormat, params);
}
var ZodSymbol = /* @__PURE__ */ $constructor("ZodSymbol", (inst, def) => {
  $ZodSymbol.init(inst, def);
  ZodType.init(inst, def);
});
function symbol15(params) {
  return _symbol(ZodSymbol, params);
}
var ZodUndefined = /* @__PURE__ */ $constructor("ZodUndefined", (inst, def) => {
  $ZodUndefined.init(inst, def);
  ZodType.init(inst, def);
});
function _undefined3(params) {
  return _undefined2(ZodUndefined, params);
}
var ZodNull = /* @__PURE__ */ $constructor("ZodNull", (inst, def) => {
  $ZodNull.init(inst, def);
  ZodType.init(inst, def);
});
function _null3(params) {
  return _null2(ZodNull, params);
}
var ZodAny = /* @__PURE__ */ $constructor("ZodAny", (inst, def) => {
  $ZodAny.init(inst, def);
  ZodType.init(inst, def);
});
function any() {
  return _any(ZodAny);
}
var ZodUnknown = /* @__PURE__ */ $constructor("ZodUnknown", (inst, def) => {
  $ZodUnknown.init(inst, def);
  ZodType.init(inst, def);
});
function unknown() {
  return _unknown(ZodUnknown);
}
var ZodNever = /* @__PURE__ */ $constructor("ZodNever", (inst, def) => {
  $ZodNever.init(inst, def);
  ZodType.init(inst, def);
});
function never(params) {
  return _never(ZodNever, params);
}
var ZodVoid = /* @__PURE__ */ $constructor("ZodVoid", (inst, def) => {
  $ZodVoid.init(inst, def);
  ZodType.init(inst, def);
});
function _void2(params) {
  return _void(ZodVoid, params);
}
var ZodDate = /* @__PURE__ */ $constructor("ZodDate", (inst, def) => {
  $ZodDate.init(inst, def);
  ZodType.init(inst, def);
  inst.min = (value, params) => inst.check(_gte(value, params));
  inst.max = (value, params) => inst.check(_lte(value, params));
  const c4 = inst._zod.bag;
  inst.minDate = c4.minimum ? new Date(c4.minimum) : null;
  inst.maxDate = c4.maximum ? new Date(c4.maximum) : null;
});
function date3(params) {
  return _date(ZodDate, params);
}
var ZodArray = /* @__PURE__ */ $constructor("ZodArray", (inst, def) => {
  $ZodArray.init(inst, def);
  ZodType.init(inst, def);
  inst.element = def.element;
  inst.min = (minLength, params) => inst.check(_minLength(minLength, params));
  inst.nonempty = (params) => inst.check(_minLength(1, params));
  inst.max = (maxLength, params) => inst.check(_maxLength(maxLength, params));
  inst.length = (len, params) => inst.check(_length(len, params));
  inst.unwrap = () => inst.element;
});
function array(element, params) {
  return _array(ZodArray, element, params);
}
function keyof(schema) {
  const shape = schema._zod.def.shape;
  return literal(Object.keys(shape));
}
var ZodObject = /* @__PURE__ */ $constructor("ZodObject", (inst, def) => {
  $ZodObject.init(inst, def);
  ZodType.init(inst, def);
  util_exports.defineLazy(inst, "shape", () => def.shape);
  inst.keyof = () => _enum2(Object.keys(inst._zod.def.shape));
  inst.catchall = (catchall) => inst.clone({ ...inst._zod.def, catchall });
  inst.passthrough = () => inst.clone({ ...inst._zod.def, catchall: unknown() });
  inst.loose = () => inst.clone({ ...inst._zod.def, catchall: unknown() });
  inst.strict = () => inst.clone({ ...inst._zod.def, catchall: never() });
  inst.strip = () => inst.clone({ ...inst._zod.def, catchall: void 0 });
  inst.extend = (incoming) => {
    return util_exports.extend(inst, incoming);
  };
  inst.merge = (other) => util_exports.merge(inst, other);
  inst.pick = (mask) => util_exports.pick(inst, mask);
  inst.omit = (mask) => util_exports.omit(inst, mask);
  inst.partial = (...args) => util_exports.partial(ZodOptional, inst, args[0]);
  inst.required = (...args) => util_exports.required(ZodNonOptional, inst, args[0]);
});
function object(shape, params) {
  const def = {
    type: "object",
    get shape() {
      util_exports.assignProp(this, "shape", { ...shape });
      return this.shape;
    },
    ...util_exports.normalizeParams(params)
  };
  return new ZodObject(def);
}
function strictObject(shape, params) {
  return new ZodObject({
    type: "object",
    get shape() {
      util_exports.assignProp(this, "shape", { ...shape });
      return this.shape;
    },
    catchall: never(),
    ...util_exports.normalizeParams(params)
  });
}
function looseObject(shape, params) {
  return new ZodObject({
    type: "object",
    get shape() {
      util_exports.assignProp(this, "shape", { ...shape });
      return this.shape;
    },
    catchall: unknown(),
    ...util_exports.normalizeParams(params)
  });
}
var ZodUnion = /* @__PURE__ */ $constructor("ZodUnion", (inst, def) => {
  $ZodUnion.init(inst, def);
  ZodType.init(inst, def);
  inst.options = def.options;
});
function union(options, params) {
  return new ZodUnion({
    type: "union",
    options,
    ...util_exports.normalizeParams(params)
  });
}
var ZodDiscriminatedUnion = /* @__PURE__ */ $constructor("ZodDiscriminatedUnion", (inst, def) => {
  ZodUnion.init(inst, def);
  $ZodDiscriminatedUnion.init(inst, def);
});
function discriminatedUnion(discriminator, options, params) {
  return new ZodDiscriminatedUnion({
    type: "union",
    options,
    discriminator,
    ...util_exports.normalizeParams(params)
  });
}
var ZodIntersection = /* @__PURE__ */ $constructor("ZodIntersection", (inst, def) => {
  $ZodIntersection.init(inst, def);
  ZodType.init(inst, def);
});
function intersection(left, right) {
  return new ZodIntersection({
    type: "intersection",
    left,
    right
  });
}
var ZodTuple = /* @__PURE__ */ $constructor("ZodTuple", (inst, def) => {
  $ZodTuple.init(inst, def);
  ZodType.init(inst, def);
  inst.rest = (rest) => inst.clone({
    ...inst._zod.def,
    rest
  });
});
function tuple(items, _paramsOrRest, _params) {
  const hasRest = _paramsOrRest instanceof $ZodType;
  const params = hasRest ? _params : _paramsOrRest;
  const rest = hasRest ? _paramsOrRest : null;
  return new ZodTuple({
    type: "tuple",
    items,
    rest,
    ...util_exports.normalizeParams(params)
  });
}
var ZodRecord = /* @__PURE__ */ $constructor("ZodRecord", (inst, def) => {
  $ZodRecord.init(inst, def);
  ZodType.init(inst, def);
  inst.keyType = def.keyType;
  inst.valueType = def.valueType;
});
function record(keyType, valueType, params) {
  return new ZodRecord({
    type: "record",
    keyType,
    valueType,
    ...util_exports.normalizeParams(params)
  });
}
function partialRecord(keyType, valueType, params) {
  return new ZodRecord({
    type: "record",
    keyType: union([keyType, never()]),
    valueType,
    ...util_exports.normalizeParams(params)
  });
}
var ZodMap = /* @__PURE__ */ $constructor("ZodMap", (inst, def) => {
  $ZodMap.init(inst, def);
  ZodType.init(inst, def);
  inst.keyType = def.keyType;
  inst.valueType = def.valueType;
});
function map(keyType, valueType, params) {
  return new ZodMap({
    type: "map",
    keyType,
    valueType,
    ...util_exports.normalizeParams(params)
  });
}
var ZodSet = /* @__PURE__ */ $constructor("ZodSet", (inst, def) => {
  $ZodSet.init(inst, def);
  ZodType.init(inst, def);
  inst.min = (...args) => inst.check(_minSize(...args));
  inst.nonempty = (params) => inst.check(_minSize(1, params));
  inst.max = (...args) => inst.check(_maxSize(...args));
  inst.size = (...args) => inst.check(_size(...args));
});
function set(valueType, params) {
  return new ZodSet({
    type: "set",
    valueType,
    ...util_exports.normalizeParams(params)
  });
}
var ZodEnum = /* @__PURE__ */ $constructor("ZodEnum", (inst, def) => {
  $ZodEnum.init(inst, def);
  ZodType.init(inst, def);
  inst.enum = def.entries;
  inst.options = Object.values(def.entries);
  const keys = new Set(Object.keys(def.entries));
  inst.extract = (values, params) => {
    const newEntries = {};
    for (const value of values) {
      if (keys.has(value)) {
        newEntries[value] = def.entries[value];
      } else
        throw new Error("Key ".concat(value, " not found in enum"));
    }
    return new ZodEnum({
      ...def,
      checks: [],
      ...util_exports.normalizeParams(params),
      entries: newEntries
    });
  };
  inst.exclude = (values, params) => {
    const newEntries = { ...def.entries };
    for (const value of values) {
      if (keys.has(value)) {
        delete newEntries[value];
      } else
        throw new Error("Key ".concat(value, " not found in enum"));
    }
    return new ZodEnum({
      ...def,
      checks: [],
      ...util_exports.normalizeParams(params),
      entries: newEntries
    });
  };
});
function _enum2(values, params) {
  const entries = Array.isArray(values) ? Object.fromEntries(values.map((v4) => [v4, v4])) : values;
  return new ZodEnum({
    type: "enum",
    entries,
    ...util_exports.normalizeParams(params)
  });
}
function nativeEnum(entries, params) {
  return new ZodEnum({
    type: "enum",
    entries,
    ...util_exports.normalizeParams(params)
  });
}
var ZodLiteral = /* @__PURE__ */ $constructor("ZodLiteral", (inst, def) => {
  $ZodLiteral.init(inst, def);
  ZodType.init(inst, def);
  inst.values = new Set(def.values);
  Object.defineProperty(inst, "value", {
    get() {
      if (def.values.length > 1) {
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      }
      return def.values[0];
    }
  });
});
function literal(value, params) {
  return new ZodLiteral({
    type: "literal",
    values: Array.isArray(value) ? value : [value],
    ...util_exports.normalizeParams(params)
  });
}
var ZodFile = /* @__PURE__ */ $constructor("ZodFile", (inst, def) => {
  $ZodFile.init(inst, def);
  ZodType.init(inst, def);
  inst.min = (size, params) => inst.check(_minSize(size, params));
  inst.max = (size, params) => inst.check(_maxSize(size, params));
  inst.mime = (types, params) => inst.check(_mime(Array.isArray(types) ? types : [types], params));
});
function file(params) {
  return _file(ZodFile, params);
}
var ZodTransform = /* @__PURE__ */ $constructor("ZodTransform", (inst, def) => {
  $ZodTransform.init(inst, def);
  ZodType.init(inst, def);
  inst._zod.parse = (payload, _ctx) => {
    payload.addIssue = (issue2) => {
      var _a17, _b8, _c, _d;
      if (typeof issue2 === "string") {
        payload.issues.push(util_exports.issue(issue2, payload.value, def));
      } else {
        const _issue = issue2;
        if (_issue.fatal)
          _issue.continue = false;
        (_a17 = _issue.code) != null ? _a17 : _issue.code = "custom";
        (_b8 = _issue.input) != null ? _b8 : _issue.input = payload.value;
        (_c = _issue.inst) != null ? _c : _issue.inst = inst;
        (_d = _issue.continue) != null ? _d : _issue.continue = true;
        payload.issues.push(util_exports.issue(_issue));
      }
    };
    const output = def.transform(payload.value, payload);
    if (output instanceof Promise) {
      return output.then((output2) => {
        payload.value = output2;
        return payload;
      });
    }
    payload.value = output;
    return payload;
  };
});
function transform(fn) {
  return new ZodTransform({
    type: "transform",
    transform: fn
  });
}
var ZodOptional = /* @__PURE__ */ $constructor("ZodOptional", (inst, def) => {
  $ZodOptional.init(inst, def);
  ZodType.init(inst, def);
  inst.unwrap = () => inst._zod.def.innerType;
});
function optional(innerType) {
  return new ZodOptional({
    type: "optional",
    innerType
  });
}
var ZodNullable = /* @__PURE__ */ $constructor("ZodNullable", (inst, def) => {
  $ZodNullable.init(inst, def);
  ZodType.init(inst, def);
  inst.unwrap = () => inst._zod.def.innerType;
});
function nullable(innerType) {
  return new ZodNullable({
    type: "nullable",
    innerType
  });
}
function nullish2(innerType) {
  return optional(nullable(innerType));
}
var ZodDefault = /* @__PURE__ */ $constructor("ZodDefault", (inst, def) => {
  $ZodDefault.init(inst, def);
  ZodType.init(inst, def);
  inst.unwrap = () => inst._zod.def.innerType;
  inst.removeDefault = inst.unwrap;
});
function _default3(innerType, defaultValue) {
  return new ZodDefault({
    type: "default",
    innerType,
    get defaultValue() {
      return typeof defaultValue === "function" ? defaultValue() : defaultValue;
    }
  });
}
var ZodPrefault = /* @__PURE__ */ $constructor("ZodPrefault", (inst, def) => {
  $ZodPrefault.init(inst, def);
  ZodType.init(inst, def);
  inst.unwrap = () => inst._zod.def.innerType;
});
function prefault(innerType, defaultValue) {
  return new ZodPrefault({
    type: "prefault",
    innerType,
    get defaultValue() {
      return typeof defaultValue === "function" ? defaultValue() : defaultValue;
    }
  });
}
var ZodNonOptional = /* @__PURE__ */ $constructor("ZodNonOptional", (inst, def) => {
  $ZodNonOptional.init(inst, def);
  ZodType.init(inst, def);
  inst.unwrap = () => inst._zod.def.innerType;
});
function nonoptional(innerType, params) {
  return new ZodNonOptional({
    type: "nonoptional",
    innerType,
    ...util_exports.normalizeParams(params)
  });
}
var ZodSuccess = /* @__PURE__ */ $constructor("ZodSuccess", (inst, def) => {
  $ZodSuccess.init(inst, def);
  ZodType.init(inst, def);
  inst.unwrap = () => inst._zod.def.innerType;
});
function success(innerType) {
  return new ZodSuccess({
    type: "success",
    innerType
  });
}
var ZodCatch = /* @__PURE__ */ $constructor("ZodCatch", (inst, def) => {
  $ZodCatch.init(inst, def);
  ZodType.init(inst, def);
  inst.unwrap = () => inst._zod.def.innerType;
  inst.removeCatch = inst.unwrap;
});
function _catch2(innerType, catchValue) {
  return new ZodCatch({
    type: "catch",
    innerType,
    catchValue: typeof catchValue === "function" ? catchValue : () => catchValue
  });
}
var ZodNaN = /* @__PURE__ */ $constructor("ZodNaN", (inst, def) => {
  $ZodNaN.init(inst, def);
  ZodType.init(inst, def);
});
function nan(params) {
  return _nan(ZodNaN, params);
}
var ZodPipe = /* @__PURE__ */ $constructor("ZodPipe", (inst, def) => {
  $ZodPipe.init(inst, def);
  ZodType.init(inst, def);
  inst.in = def.in;
  inst.out = def.out;
});
function pipe(in_, out) {
  return new ZodPipe({
    type: "pipe",
    in: in_,
    out
    // ...util.normalizeParams(params),
  });
}
var ZodReadonly = /* @__PURE__ */ $constructor("ZodReadonly", (inst, def) => {
  $ZodReadonly.init(inst, def);
  ZodType.init(inst, def);
});
function readonly(innerType) {
  return new ZodReadonly({
    type: "readonly",
    innerType
  });
}
var ZodTemplateLiteral = /* @__PURE__ */ $constructor("ZodTemplateLiteral", (inst, def) => {
  $ZodTemplateLiteral.init(inst, def);
  ZodType.init(inst, def);
});
function templateLiteral(parts, params) {
  return new ZodTemplateLiteral({
    type: "template_literal",
    parts,
    ...util_exports.normalizeParams(params)
  });
}
var ZodLazy = /* @__PURE__ */ $constructor("ZodLazy", (inst, def) => {
  $ZodLazy.init(inst, def);
  ZodType.init(inst, def);
  inst.unwrap = () => inst._zod.def.getter();
});
function lazy(getter) {
  return new ZodLazy({
    type: "lazy",
    getter
  });
}
var ZodPromise = /* @__PURE__ */ $constructor("ZodPromise", (inst, def) => {
  $ZodPromise.init(inst, def);
  ZodType.init(inst, def);
  inst.unwrap = () => inst._zod.def.innerType;
});
function promise(innerType) {
  return new ZodPromise({
    type: "promise",
    innerType
  });
}
var ZodCustom = /* @__PURE__ */ $constructor("ZodCustom", (inst, def) => {
  $ZodCustom.init(inst, def);
  ZodType.init(inst, def);
});
function check(fn) {
  const ch = new $ZodCheck({
    check: "custom"
    // ...util.normalizeParams(params),
  });
  ch._zod.check = fn;
  return ch;
}
function custom(fn, _params) {
  return _custom(ZodCustom, fn != null ? fn : () => true, _params);
}
function refine(fn, _params = {}) {
  return _refine(ZodCustom, fn, _params);
}
function superRefine(fn) {
  const ch = check((payload) => {
    payload.addIssue = (issue2) => {
      var _a17, _b8, _c, _d;
      if (typeof issue2 === "string") {
        payload.issues.push(util_exports.issue(issue2, payload.value, ch._zod.def));
      } else {
        const _issue = issue2;
        if (_issue.fatal)
          _issue.continue = false;
        (_a17 = _issue.code) != null ? _a17 : _issue.code = "custom";
        (_b8 = _issue.input) != null ? _b8 : _issue.input = payload.value;
        (_c = _issue.inst) != null ? _c : _issue.inst = ch;
        (_d = _issue.continue) != null ? _d : _issue.continue = !ch._zod.def.abort;
        payload.issues.push(util_exports.issue(_issue));
      }
    };
    return fn(payload.value, payload);
  });
  return ch;
}
function _instanceof(cls, params = {
  error: "Input not instance of ".concat(cls.name)
}) {
  const inst = new ZodCustom({
    type: "custom",
    check: "custom",
    fn: (data) => data instanceof cls,
    abort: true,
    ...util_exports.normalizeParams(params)
  });
  inst._zod.bag.Class = cls;
  return inst;
}
var stringbool = (...args) => _stringbool({
  Pipe: ZodPipe,
  Boolean: ZodBoolean,
  String: ZodString,
  Transform: ZodTransform
}, ...args);
function json(params) {
  const jsonSchema2 = lazy(() => {
    return union([string2(params), number2(), boolean2(), _null3(), array(jsonSchema2), record(string2(), jsonSchema2)]);
  });
  return jsonSchema2;
}
function preprocess(fn, schema) {
  return pipe(transform(fn), schema);
}

// node_modules/zod/v4/classic/compat.js
var ZodIssueCode = {
  invalid_type: "invalid_type",
  too_big: "too_big",
  too_small: "too_small",
  invalid_format: "invalid_format",
  not_multiple_of: "not_multiple_of",
  unrecognized_keys: "unrecognized_keys",
  invalid_union: "invalid_union",
  invalid_key: "invalid_key",
  invalid_element: "invalid_element",
  invalid_value: "invalid_value",
  custom: "custom"
};
function setErrorMap(map2) {
  config({
    customError: map2
  });
}
function getErrorMap() {
  return config().customError;
}

// node_modules/zod/v4/classic/coerce.js
var coerce_exports = {};
__export(coerce_exports, {
  bigint: () => bigint3,
  boolean: () => boolean3,
  date: () => date4,
  number: () => number3,
  string: () => string3
});
function string3(params) {
  return _coercedString(ZodString, params);
}
function number3(params) {
  return _coercedNumber(ZodNumber, params);
}
function boolean3(params) {
  return _coercedBoolean(ZodBoolean, params);
}
function bigint3(params) {
  return _coercedBigint(ZodBigInt, params);
}
function date4(params) {
  return _coercedDate(ZodDate, params);
}

// node_modules/zod/v4/classic/external.js
config(en_default());

// node_modules/zod/v3/helpers/util.js
var util;
(function(util2) {
  util2.assertEqual = (_4) => {
  };
  function assertIs2(_arg) {
  }
  util2.assertIs = assertIs2;
  function assertNever2(_x) {
    throw new Error();
  }
  util2.assertNever = assertNever2;
  util2.arrayToEnum = (items) => {
    const obj = {};
    for (const item11 of items) {
      obj[item11] = item11;
    }
    return obj;
  };
  util2.getValidEnumValues = (obj) => {
    const validKeys = util2.objectKeys(obj).filter((k4) => typeof obj[obj[k4]] !== "number");
    const filtered = {};
    for (const k4 of validKeys) {
      filtered[k4] = obj[k4];
    }
    return util2.objectValues(filtered);
  };
  util2.objectValues = (obj) => {
    return util2.objectKeys(obj).map(function(e4) {
      return obj[e4];
    });
  };
  util2.objectKeys = typeof Object.keys === "function" ? (obj) => Object.keys(obj) : (object3) => {
    const keys = [];
    for (const key2 in object3) {
      if (Object.prototype.hasOwnProperty.call(object3, key2)) {
        keys.push(key2);
      }
    }
    return keys;
  };
  util2.find = (arr, checker) => {
    for (const item11 of arr) {
      if (checker(item11))
        return item11;
    }
    return void 0;
  };
  util2.isInteger = typeof Number.isInteger === "function" ? (val) => Number.isInteger(val) : (val) => typeof val === "number" && Number.isFinite(val) && Math.floor(val) === val;
  function joinValues2(array2, separator2 = " | ") {
    return array2.map((val) => typeof val === "string" ? "'".concat(val, "'") : val).join(separator2);
  }
  util2.joinValues = joinValues2;
  util2.jsonStringifyReplacer = (_4, value) => {
    if (typeof value === "bigint") {
      return value.toString();
    }
    return value;
  };
})(util || (util = {}));
var objectUtil;
(function(objectUtil2) {
  objectUtil2.mergeShapes = (first2, second) => {
    return {
      ...first2,
      ...second
      // second overwrites first
    };
  };
})(objectUtil || (objectUtil = {}));
var ZodParsedType = util.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]);
var getParsedType2 = (data) => {
  const t4 = typeof data;
  switch (t4) {
    case "undefined":
      return ZodParsedType.undefined;
    case "string":
      return ZodParsedType.string;
    case "number":
      return Number.isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
    case "boolean":
      return ZodParsedType.boolean;
    case "function":
      return ZodParsedType.function;
    case "bigint":
      return ZodParsedType.bigint;
    case "symbol":
      return ZodParsedType.symbol;
    case "object":
      if (Array.isArray(data)) {
        return ZodParsedType.array;
      }
      if (data === null) {
        return ZodParsedType.null;
      }
      if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") {
        return ZodParsedType.promise;
      }
      if (typeof Map !== "undefined" && data instanceof Map) {
        return ZodParsedType.map;
      }
      if (typeof Set !== "undefined" && data instanceof Set) {
        return ZodParsedType.set;
      }
      if (typeof Date !== "undefined" && data instanceof Date) {
        return ZodParsedType.date;
      }
      return ZodParsedType.object;
    default:
      return ZodParsedType.unknown;
  }
};

// node_modules/zod/v3/ZodError.js
var ZodIssueCode2 = util.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
var ZodError2 = class _ZodError extends Error {
  get errors() {
    return this.issues;
  }
  constructor(issues) {
    super();
    this.issues = [];
    this.addIssue = (sub) => {
      this.issues = [...this.issues, sub];
    };
    this.addIssues = (subs = []) => {
      this.issues = [...this.issues, ...subs];
    };
    const actualProto = new.target.prototype;
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(this, actualProto);
    } else {
      this.__proto__ = actualProto;
    }
    this.name = "ZodError";
    this.issues = issues;
  }
  format(_mapper) {
    const mapper = _mapper || function(issue2) {
      return issue2.message;
    };
    const fieldErrors = { _errors: [] };
    const processError = (error40) => {
      for (const issue2 of error40.issues) {
        if (issue2.code === "invalid_union") {
          issue2.unionErrors.map(processError);
        } else if (issue2.code === "invalid_return_type") {
          processError(issue2.returnTypeError);
        } else if (issue2.code === "invalid_arguments") {
          processError(issue2.argumentsError);
        } else if (issue2.path.length === 0) {
          fieldErrors._errors.push(mapper(issue2));
        } else {
          let curr = fieldErrors;
          let i4 = 0;
          while (i4 < issue2.path.length) {
            const el = issue2.path[i4];
            const terminal = i4 === issue2.path.length - 1;
            if (!terminal) {
              curr[el] = curr[el] || { _errors: [] };
            } else {
              curr[el] = curr[el] || { _errors: [] };
              curr[el]._errors.push(mapper(issue2));
            }
            curr = curr[el];
            i4++;
          }
        }
      }
    };
    processError(this);
    return fieldErrors;
  }
  static assert(value) {
    if (!(value instanceof _ZodError)) {
      throw new Error("Not a ZodError: ".concat(value));
    }
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(mapper = (issue2) => issue2.message) {
    const fieldErrors = {};
    const formErrors = [];
    for (const sub of this.issues) {
      if (sub.path.length > 0) {
        const firstEl = sub.path[0];
        fieldErrors[firstEl] = fieldErrors[firstEl] || [];
        fieldErrors[firstEl].push(mapper(sub));
      } else {
        formErrors.push(mapper(sub));
      }
    }
    return { formErrors, fieldErrors };
  }
  get formErrors() {
    return this.flatten();
  }
};
ZodError2.create = (issues) => {
  const error40 = new ZodError2(issues);
  return error40;
};

// node_modules/zod/v3/locales/en.js
var errorMap = (issue2, _ctx) => {
  let message;
  switch (issue2.code) {
    case ZodIssueCode2.invalid_type:
      if (issue2.received === ZodParsedType.undefined) {
        message = "Required";
      } else {
        message = "Expected ".concat(issue2.expected, ", received ").concat(issue2.received);
      }
      break;
    case ZodIssueCode2.invalid_literal:
      message = "Invalid literal value, expected ".concat(JSON.stringify(issue2.expected, util.jsonStringifyReplacer));
      break;
    case ZodIssueCode2.unrecognized_keys:
      message = "Unrecognized key(s) in object: ".concat(util.joinValues(issue2.keys, ", "));
      break;
    case ZodIssueCode2.invalid_union:
      message = "Invalid input";
      break;
    case ZodIssueCode2.invalid_union_discriminator:
      message = "Invalid discriminator value. Expected ".concat(util.joinValues(issue2.options));
      break;
    case ZodIssueCode2.invalid_enum_value:
      message = "Invalid enum value. Expected ".concat(util.joinValues(issue2.options), ", received '").concat(issue2.received, "'");
      break;
    case ZodIssueCode2.invalid_arguments:
      message = "Invalid function arguments";
      break;
    case ZodIssueCode2.invalid_return_type:
      message = "Invalid function return type";
      break;
    case ZodIssueCode2.invalid_date:
      message = "Invalid date";
      break;
    case ZodIssueCode2.invalid_string:
      if (typeof issue2.validation === "object") {
        if ("includes" in issue2.validation) {
          message = 'Invalid input: must include "'.concat(issue2.validation.includes, '"');
          if (typeof issue2.validation.position === "number") {
            message = "".concat(message, " at one or more positions greater than or equal to ").concat(issue2.validation.position);
          }
        } else if ("startsWith" in issue2.validation) {
          message = 'Invalid input: must start with "'.concat(issue2.validation.startsWith, '"');
        } else if ("endsWith" in issue2.validation) {
          message = 'Invalid input: must end with "'.concat(issue2.validation.endsWith, '"');
        } else {
          util.assertNever(issue2.validation);
        }
      } else if (issue2.validation !== "regex") {
        message = "Invalid ".concat(issue2.validation);
      } else {
        message = "Invalid";
      }
      break;
    case ZodIssueCode2.too_small:
      if (issue2.type === "array")
        message = "Array must contain ".concat(issue2.exact ? "exactly" : issue2.inclusive ? "at least" : "more than", " ").concat(issue2.minimum, " element(s)");
      else if (issue2.type === "string")
        message = "String must contain ".concat(issue2.exact ? "exactly" : issue2.inclusive ? "at least" : "over", " ").concat(issue2.minimum, " character(s)");
      else if (issue2.type === "number")
        message = "Number must be ".concat(issue2.exact ? "exactly equal to " : issue2.inclusive ? "greater than or equal to " : "greater than ").concat(issue2.minimum);
      else if (issue2.type === "bigint")
        message = "Number must be ".concat(issue2.exact ? "exactly equal to " : issue2.inclusive ? "greater than or equal to " : "greater than ").concat(issue2.minimum);
      else if (issue2.type === "date")
        message = "Date must be ".concat(issue2.exact ? "exactly equal to " : issue2.inclusive ? "greater than or equal to " : "greater than ").concat(new Date(Number(issue2.minimum)));
      else
        message = "Invalid input";
      break;
    case ZodIssueCode2.too_big:
      if (issue2.type === "array")
        message = "Array must contain ".concat(issue2.exact ? "exactly" : issue2.inclusive ? "at most" : "less than", " ").concat(issue2.maximum, " element(s)");
      else if (issue2.type === "string")
        message = "String must contain ".concat(issue2.exact ? "exactly" : issue2.inclusive ? "at most" : "under", " ").concat(issue2.maximum, " character(s)");
      else if (issue2.type === "number")
        message = "Number must be ".concat(issue2.exact ? "exactly" : issue2.inclusive ? "less than or equal to" : "less than", " ").concat(issue2.maximum);
      else if (issue2.type === "bigint")
        message = "BigInt must be ".concat(issue2.exact ? "exactly" : issue2.inclusive ? "less than or equal to" : "less than", " ").concat(issue2.maximum);
      else if (issue2.type === "date")
        message = "Date must be ".concat(issue2.exact ? "exactly" : issue2.inclusive ? "smaller than or equal to" : "smaller than", " ").concat(new Date(Number(issue2.maximum)));
      else
        message = "Invalid input";
      break;
    case ZodIssueCode2.custom:
      message = "Invalid input";
      break;
    case ZodIssueCode2.invalid_intersection_types:
      message = "Intersection results could not be merged";
      break;
    case ZodIssueCode2.not_multiple_of:
      message = "Number must be a multiple of ".concat(issue2.multipleOf);
      break;
    case ZodIssueCode2.not_finite:
      message = "Number must be finite";
      break;
    default:
      message = _ctx.defaultError;
      util.assertNever(issue2);
  }
  return { message };
};
var en_default2 = errorMap;

// node_modules/zod/v3/errors.js
var overrideErrorMap = en_default2;
function getErrorMap2() {
  return overrideErrorMap;
}

// node_modules/zod/v3/helpers/parseUtil.js
var makeIssue = (params) => {
  const { data, path, errorMaps, issueData } = params;
  const fullPath = [...path, ...issueData.path || []];
  const fullIssue = {
    ...issueData,
    path: fullPath
  };
  if (issueData.message !== void 0) {
    return {
      ...issueData,
      path: fullPath,
      message: issueData.message
    };
  }
  let errorMessage = "";
  const maps = errorMaps.filter((m5) => !!m5).slice().reverse();
  for (const map2 of maps) {
    errorMessage = map2(fullIssue, { data, defaultError: errorMessage }).message;
  }
  return {
    ...issueData,
    path: fullPath,
    message: errorMessage
  };
};
function addIssueToContext(ctx, issueData) {
  const overrideMap = getErrorMap2();
  const issue2 = makeIssue({
    issueData,
    data: ctx.data,
    path: ctx.path,
    errorMaps: [
      ctx.common.contextualErrorMap,
      // contextual error map is first priority
      ctx.schemaErrorMap,
      // then schema-bound map if available
      overrideMap,
      // then global override map
      overrideMap === en_default2 ? void 0 : en_default2
      // then global default map
    ].filter((x4) => !!x4)
  });
  ctx.common.issues.push(issue2);
}
var ParseStatus = class _ParseStatus {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    if (this.value === "valid")
      this.value = "dirty";
  }
  abort() {
    if (this.value !== "aborted")
      this.value = "aborted";
  }
  static mergeArray(status2, results) {
    const arrayValue = [];
    for (const s4 of results) {
      if (s4.status === "aborted")
        return INVALID;
      if (s4.status === "dirty")
        status2.dirty();
      arrayValue.push(s4.value);
    }
    return { status: status2.value, value: arrayValue };
  }
  static async mergeObjectAsync(status2, pairs) {
    const syncPairs = [];
    for (const pair of pairs) {
      const key2 = await pair.key;
      const value = await pair.value;
      syncPairs.push({
        key: key2,
        value
      });
    }
    return _ParseStatus.mergeObjectSync(status2, syncPairs);
  }
  static mergeObjectSync(status2, pairs) {
    const finalObject = {};
    for (const pair of pairs) {
      const { key: key2, value } = pair;
      if (key2.status === "aborted")
        return INVALID;
      if (value.status === "aborted")
        return INVALID;
      if (key2.status === "dirty")
        status2.dirty();
      if (value.status === "dirty")
        status2.dirty();
      if (key2.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) {
        finalObject[key2.value] = value.value;
      }
    }
    return { status: status2.value, value: finalObject };
  }
};
var INVALID = Object.freeze({
  status: "aborted"
});
var DIRTY = (value) => ({ status: "dirty", value });
var OK = (value) => ({ status: "valid", value });
var isAborted = (x4) => x4.status === "aborted";
var isDirty = (x4) => x4.status === "dirty";
var isValid = (x4) => x4.status === "valid";
var isAsync = (x4) => typeof Promise !== "undefined" && x4 instanceof Promise;

// node_modules/zod/v3/helpers/errorUtil.js
var errorUtil;
(function(errorUtil2) {
  errorUtil2.errToObj = (message) => typeof message === "string" ? { message } : message || {};
  errorUtil2.toString = (message) => typeof message === "string" ? message : message == null ? void 0 : message.message;
})(errorUtil || (errorUtil = {}));

// node_modules/zod/v3/types.js
var ParseInputLazyPath = class {
  constructor(parent, value, path, key2) {
    this._cachedPath = [];
    this.parent = parent;
    this.data = value;
    this._path = path;
    this._key = key2;
  }
  get path() {
    if (!this._cachedPath.length) {
      if (Array.isArray(this._key)) {
        this._cachedPath.push(...this._path, ...this._key);
      } else {
        this._cachedPath.push(...this._path, this._key);
      }
    }
    return this._cachedPath;
  }
};
var handleResult = (ctx, result) => {
  if (isValid(result)) {
    return { success: true, data: result.value };
  } else {
    if (!ctx.common.issues.length) {
      throw new Error("Validation failed but no issues detected.");
    }
    return {
      success: false,
      get error() {
        if (this._error)
          return this._error;
        const error40 = new ZodError2(ctx.common.issues);
        this._error = error40;
        return this._error;
      }
    };
  }
};
function processCreateParams(params) {
  if (!params)
    return {};
  const { errorMap: errorMap2, invalid_type_error, required_error, description } = params;
  if (errorMap2 && (invalid_type_error || required_error)) {
    throw new Error('Can\'t use "invalid_type_error" or "required_error" in conjunction with custom error map.');
  }
  if (errorMap2)
    return { errorMap: errorMap2, description };
  const customMap = (iss, ctx) => {
    var _a17, _b8;
    const { message } = params;
    if (iss.code === "invalid_enum_value") {
      return { message: message != null ? message : ctx.defaultError };
    }
    if (typeof ctx.data === "undefined") {
      return { message: (_a17 = message != null ? message : required_error) != null ? _a17 : ctx.defaultError };
    }
    if (iss.code !== "invalid_type")
      return { message: ctx.defaultError };
    return { message: (_b8 = message != null ? message : invalid_type_error) != null ? _b8 : ctx.defaultError };
  };
  return { errorMap: customMap, description };
}
var ZodType2 = class {
  get description() {
    return this._def.description;
  }
  _getType(input) {
    return getParsedType2(input.data);
  }
  _getOrReturnCtx(input, ctx) {
    return ctx || {
      common: input.parent.common,
      data: input.data,
      parsedType: getParsedType2(input.data),
      schemaErrorMap: this._def.errorMap,
      path: input.path,
      parent: input.parent
    };
  }
  _processInputParams(input) {
    return {
      status: new ParseStatus(),
      ctx: {
        common: input.parent.common,
        data: input.data,
        parsedType: getParsedType2(input.data),
        schemaErrorMap: this._def.errorMap,
        path: input.path,
        parent: input.parent
      }
    };
  }
  _parseSync(input) {
    const result = this._parse(input);
    if (isAsync(result)) {
      throw new Error("Synchronous parse encountered promise.");
    }
    return result;
  }
  _parseAsync(input) {
    const result = this._parse(input);
    return Promise.resolve(result);
  }
  parse(data, params) {
    const result = this.safeParse(data, params);
    if (result.success)
      return result.data;
    throw result.error;
  }
  safeParse(data, params) {
    var _a17;
    const ctx = {
      common: {
        issues: [],
        async: (_a17 = params == null ? void 0 : params.async) != null ? _a17 : false,
        contextualErrorMap: params == null ? void 0 : params.errorMap
      },
      path: (params == null ? void 0 : params.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType2(data)
    };
    const result = this._parseSync({ data, path: ctx.path, parent: ctx });
    return handleResult(ctx, result);
  }
  "~validate"(data) {
    var _a17, _b8;
    const ctx = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType2(data)
    };
    if (!this["~standard"].async) {
      try {
        const result = this._parseSync({ data, path: [], parent: ctx });
        return isValid(result) ? {
          value: result.value
        } : {
          issues: ctx.common.issues
        };
      } catch (err) {
        if ((_b8 = (_a17 = err == null ? void 0 : err.message) == null ? void 0 : _a17.toLowerCase()) == null ? void 0 : _b8.includes("encountered")) {
          this["~standard"].async = true;
        }
        ctx.common = {
          issues: [],
          async: true
        };
      }
    }
    return this._parseAsync({ data, path: [], parent: ctx }).then((result) => isValid(result) ? {
      value: result.value
    } : {
      issues: ctx.common.issues
    });
  }
  async parseAsync(data, params) {
    const result = await this.safeParseAsync(data, params);
    if (result.success)
      return result.data;
    throw result.error;
  }
  async safeParseAsync(data, params) {
    const ctx = {
      common: {
        issues: [],
        contextualErrorMap: params == null ? void 0 : params.errorMap,
        async: true
      },
      path: (params == null ? void 0 : params.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType2(data)
    };
    const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
    const result = await (isAsync(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
    return handleResult(ctx, result);
  }
  refine(check2, message) {
    const getIssueProperties = (val) => {
      if (typeof message === "string" || typeof message === "undefined") {
        return { message };
      } else if (typeof message === "function") {
        return message(val);
      } else {
        return message;
      }
    };
    return this._refinement((val, ctx) => {
      const result = check2(val);
      const setError = () => ctx.addIssue({
        code: ZodIssueCode2.custom,
        ...getIssueProperties(val)
      });
      if (typeof Promise !== "undefined" && result instanceof Promise) {
        return result.then((data) => {
          if (!data) {
            setError();
            return false;
          } else {
            return true;
          }
        });
      }
      if (!result) {
        setError();
        return false;
      } else {
        return true;
      }
    });
  }
  refinement(check2, refinementData) {
    return this._refinement((val, ctx) => {
      if (!check2(val)) {
        ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
        return false;
      } else {
        return true;
      }
    });
  }
  _refinement(refinement) {
    return new ZodEffects({
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "refinement", refinement }
    });
  }
  superRefine(refinement) {
    return this._refinement(refinement);
  }
  constructor(def) {
    this.spa = this.safeParseAsync;
    this._def = def;
    this.parse = this.parse.bind(this);
    this.safeParse = this.safeParse.bind(this);
    this.parseAsync = this.parseAsync.bind(this);
    this.safeParseAsync = this.safeParseAsync.bind(this);
    this.spa = this.spa.bind(this);
    this.refine = this.refine.bind(this);
    this.refinement = this.refinement.bind(this);
    this.superRefine = this.superRefine.bind(this);
    this.optional = this.optional.bind(this);
    this.nullable = this.nullable.bind(this);
    this.nullish = this.nullish.bind(this);
    this.array = this.array.bind(this);
    this.promise = this.promise.bind(this);
    this.or = this.or.bind(this);
    this.and = this.and.bind(this);
    this.transform = this.transform.bind(this);
    this.brand = this.brand.bind(this);
    this.default = this.default.bind(this);
    this.catch = this.catch.bind(this);
    this.describe = this.describe.bind(this);
    this.pipe = this.pipe.bind(this);
    this.readonly = this.readonly.bind(this);
    this.isNullable = this.isNullable.bind(this);
    this.isOptional = this.isOptional.bind(this);
    this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (data) => this["~validate"](data)
    };
  }
  optional() {
    return ZodOptional2.create(this, this._def);
  }
  nullable() {
    return ZodNullable2.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ZodArray2.create(this);
  }
  promise() {
    return ZodPromise2.create(this, this._def);
  }
  or(option) {
    return ZodUnion2.create([this, option], this._def);
  }
  and(incoming) {
    return ZodIntersection2.create(this, incoming, this._def);
  }
  transform(transform2) {
    return new ZodEffects({
      ...processCreateParams(this._def),
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "transform", transform: transform2 }
    });
  }
  default(def) {
    const defaultValueFunc = typeof def === "function" ? def : () => def;
    return new ZodDefault2({
      ...processCreateParams(this._def),
      innerType: this,
      defaultValue: defaultValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodDefault
    });
  }
  brand() {
    return new ZodBranded({
      typeName: ZodFirstPartyTypeKind.ZodBranded,
      type: this,
      ...processCreateParams(this._def)
    });
  }
  catch(def) {
    const catchValueFunc = typeof def === "function" ? def : () => def;
    return new ZodCatch2({
      ...processCreateParams(this._def),
      innerType: this,
      catchValue: catchValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodCatch
    });
  }
  describe(description) {
    const This = this.constructor;
    return new This({
      ...this._def,
      description
    });
  }
  pipe(target) {
    return ZodPipeline.create(this, target);
  }
  readonly() {
    return ZodReadonly2.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
};
var cuidRegex = /^c[^\s-]{8,}$/i;
var cuid2Regex = /^[0-9a-z]+$/;
var ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
var uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
var nanoidRegex = /^[a-z0-9_-]{21}$/i;
var jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
var durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
var emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
var _emojiRegex = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
var emojiRegex;
var ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
var ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
var ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
var ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
var base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
var base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
var dateRegexSource = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))";
var dateRegex = new RegExp("^".concat(dateRegexSource, "$"));
function timeRegexSource(args) {
  let secondsRegexSource = "[0-5]\\d";
  if (args.precision) {
    secondsRegexSource = "".concat(secondsRegexSource, "\\.\\d{").concat(args.precision, "}");
  } else if (args.precision == null) {
    secondsRegexSource = "".concat(secondsRegexSource, "(\\.\\d+)?");
  }
  const secondsQuantifier = args.precision ? "+" : "?";
  return "([01]\\d|2[0-3]):[0-5]\\d(:".concat(secondsRegexSource, ")").concat(secondsQuantifier);
}
function timeRegex(args) {
  return new RegExp("^".concat(timeRegexSource(args), "$"));
}
function datetimeRegex(args) {
  let regex = "".concat(dateRegexSource, "T").concat(timeRegexSource(args));
  const opts = [];
  opts.push(args.local ? "Z?" : "Z");
  if (args.offset)
    opts.push("([+-]\\d{2}:?\\d{2})");
  regex = "".concat(regex, "(").concat(opts.join("|"), ")");
  return new RegExp("^".concat(regex, "$"));
}
function isValidIP(ip, version2) {
  if ((version2 === "v4" || !version2) && ipv4Regex.test(ip)) {
    return true;
  }
  if ((version2 === "v6" || !version2) && ipv6Regex.test(ip)) {
    return true;
  }
  return false;
}
function isValidJWT2(jwt2, alg) {
  if (!jwtRegex.test(jwt2))
    return false;
  try {
    const [header2] = jwt2.split(".");
    if (!header2)
      return false;
    const base643 = header2.replace(/-/g, "+").replace(/_/g, "/").padEnd(header2.length + (4 - header2.length % 4) % 4, "=");
    const decoded = JSON.parse(atob(base643));
    if (typeof decoded !== "object" || decoded === null)
      return false;
    if ("typ" in decoded && (decoded == null ? void 0 : decoded.typ) !== "JWT")
      return false;
    if (!decoded.alg)
      return false;
    if (alg && decoded.alg !== alg)
      return false;
    return true;
  } catch (e4) {
    return false;
  }
}
function isValidCidr(ip, version2) {
  if ((version2 === "v4" || !version2) && ipv4CidrRegex.test(ip)) {
    return true;
  }
  if ((version2 === "v6" || !version2) && ipv6CidrRegex.test(ip)) {
    return true;
  }
  return false;
}
var ZodString2 = class _ZodString2 extends ZodType2 {
  _parse(input) {
    if (this._def.coerce) {
      input.data = String(input.data);
    }
    const parsedType4 = this._getType(input);
    if (parsedType4 !== ZodParsedType.string) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode2.invalid_type,
        expected: ZodParsedType.string,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    const status2 = new ParseStatus();
    let ctx = void 0;
    for (const check2 of this._def.checks) {
      if (check2.kind === "min") {
        if (input.data.length < check2.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode2.too_small,
            minimum: check2.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "max") {
        if (input.data.length > check2.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode2.too_big,
            maximum: check2.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "length") {
        const tooBig = input.data.length > check2.value;
        const tooSmall = input.data.length < check2.value;
        if (tooBig || tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          if (tooBig) {
            addIssueToContext(ctx, {
              code: ZodIssueCode2.too_big,
              maximum: check2.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check2.message
            });
          } else if (tooSmall) {
            addIssueToContext(ctx, {
              code: ZodIssueCode2.too_small,
              minimum: check2.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check2.message
            });
          }
          status2.dirty();
        }
      } else if (check2.kind === "email") {
        if (!emailRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "email",
            code: ZodIssueCode2.invalid_string,
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "emoji") {
        if (!emojiRegex) {
          emojiRegex = new RegExp(_emojiRegex, "u");
        }
        if (!emojiRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "emoji",
            code: ZodIssueCode2.invalid_string,
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "uuid") {
        if (!uuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "uuid",
            code: ZodIssueCode2.invalid_string,
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "nanoid") {
        if (!nanoidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "nanoid",
            code: ZodIssueCode2.invalid_string,
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "cuid") {
        if (!cuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid",
            code: ZodIssueCode2.invalid_string,
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "cuid2") {
        if (!cuid2Regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid2",
            code: ZodIssueCode2.invalid_string,
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "ulid") {
        if (!ulidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ulid",
            code: ZodIssueCode2.invalid_string,
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "url") {
        try {
          new URL(input.data);
        } catch (e4) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "url",
            code: ZodIssueCode2.invalid_string,
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "regex") {
        check2.regex.lastIndex = 0;
        const testResult = check2.regex.test(input.data);
        if (!testResult) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "regex",
            code: ZodIssueCode2.invalid_string,
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "trim") {
        input.data = input.data.trim();
      } else if (check2.kind === "includes") {
        if (!input.data.includes(check2.value, check2.position)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode2.invalid_string,
            validation: { includes: check2.value, position: check2.position },
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "toLowerCase") {
        input.data = input.data.toLowerCase();
      } else if (check2.kind === "toUpperCase") {
        input.data = input.data.toUpperCase();
      } else if (check2.kind === "startsWith") {
        if (!input.data.startsWith(check2.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode2.invalid_string,
            validation: { startsWith: check2.value },
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "endsWith") {
        if (!input.data.endsWith(check2.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode2.invalid_string,
            validation: { endsWith: check2.value },
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "datetime") {
        const regex = datetimeRegex(check2);
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode2.invalid_string,
            validation: "datetime",
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "date") {
        const regex = dateRegex;
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode2.invalid_string,
            validation: "date",
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "time") {
        const regex = timeRegex(check2);
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode2.invalid_string,
            validation: "time",
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "duration") {
        if (!durationRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "duration",
            code: ZodIssueCode2.invalid_string,
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "ip") {
        if (!isValidIP(input.data, check2.version)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ip",
            code: ZodIssueCode2.invalid_string,
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "jwt") {
        if (!isValidJWT2(input.data, check2.alg)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "jwt",
            code: ZodIssueCode2.invalid_string,
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "cidr") {
        if (!isValidCidr(input.data, check2.version)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cidr",
            code: ZodIssueCode2.invalid_string,
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "base64") {
        if (!base64Regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "base64",
            code: ZodIssueCode2.invalid_string,
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "base64url") {
        if (!base64urlRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "base64url",
            code: ZodIssueCode2.invalid_string,
            message: check2.message
          });
          status2.dirty();
        }
      } else {
        util.assertNever(check2);
      }
    }
    return { status: status2.value, value: input.data };
  }
  _regex(regex, validation, message) {
    return this.refinement((data) => regex.test(data), {
      validation,
      code: ZodIssueCode2.invalid_string,
      ...errorUtil.errToObj(message)
    });
  }
  _addCheck(check2) {
    return new _ZodString2({
      ...this._def,
      checks: [...this._def.checks, check2]
    });
  }
  email(message) {
    return this._addCheck({ kind: "email", ...errorUtil.errToObj(message) });
  }
  url(message) {
    return this._addCheck({ kind: "url", ...errorUtil.errToObj(message) });
  }
  emoji(message) {
    return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(message) });
  }
  uuid(message) {
    return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(message) });
  }
  nanoid(message) {
    return this._addCheck({ kind: "nanoid", ...errorUtil.errToObj(message) });
  }
  cuid(message) {
    return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(message) });
  }
  cuid2(message) {
    return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(message) });
  }
  ulid(message) {
    return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(message) });
  }
  base64(message) {
    return this._addCheck({ kind: "base64", ...errorUtil.errToObj(message) });
  }
  base64url(message) {
    return this._addCheck({
      kind: "base64url",
      ...errorUtil.errToObj(message)
    });
  }
  jwt(options) {
    return this._addCheck({ kind: "jwt", ...errorUtil.errToObj(options) });
  }
  ip(options) {
    return this._addCheck({ kind: "ip", ...errorUtil.errToObj(options) });
  }
  cidr(options) {
    return this._addCheck({ kind: "cidr", ...errorUtil.errToObj(options) });
  }
  datetime(options) {
    var _a17, _b8;
    if (typeof options === "string") {
      return this._addCheck({
        kind: "datetime",
        precision: null,
        offset: false,
        local: false,
        message: options
      });
    }
    return this._addCheck({
      kind: "datetime",
      precision: typeof (options == null ? void 0 : options.precision) === "undefined" ? null : options == null ? void 0 : options.precision,
      offset: (_a17 = options == null ? void 0 : options.offset) != null ? _a17 : false,
      local: (_b8 = options == null ? void 0 : options.local) != null ? _b8 : false,
      ...errorUtil.errToObj(options == null ? void 0 : options.message)
    });
  }
  date(message) {
    return this._addCheck({ kind: "date", message });
  }
  time(options) {
    if (typeof options === "string") {
      return this._addCheck({
        kind: "time",
        precision: null,
        message: options
      });
    }
    return this._addCheck({
      kind: "time",
      precision: typeof (options == null ? void 0 : options.precision) === "undefined" ? null : options == null ? void 0 : options.precision,
      ...errorUtil.errToObj(options == null ? void 0 : options.message)
    });
  }
  duration(message) {
    return this._addCheck({ kind: "duration", ...errorUtil.errToObj(message) });
  }
  regex(regex, message) {
    return this._addCheck({
      kind: "regex",
      regex,
      ...errorUtil.errToObj(message)
    });
  }
  includes(value, options) {
    return this._addCheck({
      kind: "includes",
      value,
      position: options == null ? void 0 : options.position,
      ...errorUtil.errToObj(options == null ? void 0 : options.message)
    });
  }
  startsWith(value, message) {
    return this._addCheck({
      kind: "startsWith",
      value,
      ...errorUtil.errToObj(message)
    });
  }
  endsWith(value, message) {
    return this._addCheck({
      kind: "endsWith",
      value,
      ...errorUtil.errToObj(message)
    });
  }
  min(minLength, message) {
    return this._addCheck({
      kind: "min",
      value: minLength,
      ...errorUtil.errToObj(message)
    });
  }
  max(maxLength, message) {
    return this._addCheck({
      kind: "max",
      value: maxLength,
      ...errorUtil.errToObj(message)
    });
  }
  length(len, message) {
    return this._addCheck({
      kind: "length",
      value: len,
      ...errorUtil.errToObj(message)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(message) {
    return this.min(1, errorUtil.errToObj(message));
  }
  trim() {
    return new _ZodString2({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new _ZodString2({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new _ZodString2({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((ch) => ch.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((ch) => ch.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((ch) => ch.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((ch) => ch.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((ch) => ch.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((ch) => ch.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((ch) => ch.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((ch) => ch.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((ch) => ch.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((ch) => ch.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((ch) => ch.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((ch) => ch.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((ch) => ch.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((ch) => ch.kind === "base64url");
  }
  get minLength() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxLength() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
};
ZodString2.create = (params) => {
  var _a17;
  return new ZodString2({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodString,
    coerce: (_a17 = params == null ? void 0 : params.coerce) != null ? _a17 : false,
    ...processCreateParams(params)
  });
};
function floatSafeRemainder2(val, step) {
  const valDecCount = (val.toString().split(".")[1] || "").length;
  const stepDecCount = (step.toString().split(".")[1] || "").length;
  const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
  const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
  const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
  return valInt % stepInt / 10 ** decCount;
}
var ZodNumber2 = class _ZodNumber extends ZodType2 {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
    this.step = this.multipleOf;
  }
  _parse(input) {
    if (this._def.coerce) {
      input.data = Number(input.data);
    }
    const parsedType4 = this._getType(input);
    if (parsedType4 !== ZodParsedType.number) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode2.invalid_type,
        expected: ZodParsedType.number,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    let ctx = void 0;
    const status2 = new ParseStatus();
    for (const check2 of this._def.checks) {
      if (check2.kind === "int") {
        if (!util.isInteger(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode2.invalid_type,
            expected: "integer",
            received: "float",
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "min") {
        const tooSmall = check2.inclusive ? input.data < check2.value : input.data <= check2.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode2.too_small,
            minimum: check2.value,
            type: "number",
            inclusive: check2.inclusive,
            exact: false,
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "max") {
        const tooBig = check2.inclusive ? input.data > check2.value : input.data >= check2.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode2.too_big,
            maximum: check2.value,
            type: "number",
            inclusive: check2.inclusive,
            exact: false,
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "multipleOf") {
        if (floatSafeRemainder2(input.data, check2.value) !== 0) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode2.not_multiple_of,
            multipleOf: check2.value,
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "finite") {
        if (!Number.isFinite(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode2.not_finite,
            message: check2.message
          });
          status2.dirty();
        }
      } else {
        util.assertNever(check2);
      }
    }
    return { status: status2.value, value: input.data };
  }
  gte(value, message) {
    return this.setLimit("min", value, true, errorUtil.toString(message));
  }
  gt(value, message) {
    return this.setLimit("min", value, false, errorUtil.toString(message));
  }
  lte(value, message) {
    return this.setLimit("max", value, true, errorUtil.toString(message));
  }
  lt(value, message) {
    return this.setLimit("max", value, false, errorUtil.toString(message));
  }
  setLimit(kind, value, inclusive, message) {
    return new _ZodNumber({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message)
        }
      ]
    });
  }
  _addCheck(check2) {
    return new _ZodNumber({
      ...this._def,
      checks: [...this._def.checks, check2]
    });
  }
  int(message) {
    return this._addCheck({
      kind: "int",
      message: errorUtil.toString(message)
    });
  }
  positive(message) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  negative(message) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  nonpositive(message) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  nonnegative(message) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  multipleOf(value, message) {
    return this._addCheck({
      kind: "multipleOf",
      value,
      message: errorUtil.toString(message)
    });
  }
  finite(message) {
    return this._addCheck({
      kind: "finite",
      message: errorUtil.toString(message)
    });
  }
  safe(message) {
    return this._addCheck({
      kind: "min",
      inclusive: true,
      value: Number.MIN_SAFE_INTEGER,
      message: errorUtil.toString(message)
    })._addCheck({
      kind: "max",
      inclusive: true,
      value: Number.MAX_SAFE_INTEGER,
      message: errorUtil.toString(message)
    });
  }
  get minValue() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxValue() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
  get isInt() {
    return !!this._def.checks.find((ch) => ch.kind === "int" || ch.kind === "multipleOf" && util.isInteger(ch.value));
  }
  get isFinite() {
    let max = null;
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") {
        return true;
      } else if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      } else if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return Number.isFinite(min) && Number.isFinite(max);
  }
};
ZodNumber2.create = (params) => {
  return new ZodNumber2({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodNumber,
    coerce: (params == null ? void 0 : params.coerce) || false,
    ...processCreateParams(params)
  });
};
var ZodBigInt2 = class _ZodBigInt extends ZodType2 {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
  }
  _parse(input) {
    if (this._def.coerce) {
      try {
        input.data = BigInt(input.data);
      } catch (e4) {
        return this._getInvalidInput(input);
      }
    }
    const parsedType4 = this._getType(input);
    if (parsedType4 !== ZodParsedType.bigint) {
      return this._getInvalidInput(input);
    }
    let ctx = void 0;
    const status2 = new ParseStatus();
    for (const check2 of this._def.checks) {
      if (check2.kind === "min") {
        const tooSmall = check2.inclusive ? input.data < check2.value : input.data <= check2.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode2.too_small,
            type: "bigint",
            minimum: check2.value,
            inclusive: check2.inclusive,
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "max") {
        const tooBig = check2.inclusive ? input.data > check2.value : input.data >= check2.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode2.too_big,
            type: "bigint",
            maximum: check2.value,
            inclusive: check2.inclusive,
            message: check2.message
          });
          status2.dirty();
        }
      } else if (check2.kind === "multipleOf") {
        if (input.data % check2.value !== BigInt(0)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode2.not_multiple_of,
            multipleOf: check2.value,
            message: check2.message
          });
          status2.dirty();
        }
      } else {
        util.assertNever(check2);
      }
    }
    return { status: status2.value, value: input.data };
  }
  _getInvalidInput(input) {
    const ctx = this._getOrReturnCtx(input);
    addIssueToContext(ctx, {
      code: ZodIssueCode2.invalid_type,
      expected: ZodParsedType.bigint,
      received: ctx.parsedType
    });
    return INVALID;
  }
  gte(value, message) {
    return this.setLimit("min", value, true, errorUtil.toString(message));
  }
  gt(value, message) {
    return this.setLimit("min", value, false, errorUtil.toString(message));
  }
  lte(value, message) {
    return this.setLimit("max", value, true, errorUtil.toString(message));
  }
  lt(value, message) {
    return this.setLimit("max", value, false, errorUtil.toString(message));
  }
  setLimit(kind, value, inclusive, message) {
    return new _ZodBigInt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message)
        }
      ]
    });
  }
  _addCheck(check2) {
    return new _ZodBigInt({
      ...this._def,
      checks: [...this._def.checks, check2]
    });
  }
  positive(message) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  negative(message) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  nonpositive(message) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  nonnegative(message) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  multipleOf(value, message) {
    return this._addCheck({
      kind: "multipleOf",
      value,
      message: errorUtil.toString(message)
    });
  }
  get minValue() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxValue() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
};
ZodBigInt2.create = (params) => {
  var _a17;
  return new ZodBigInt2({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodBigInt,
    coerce: (_a17 = params == null ? void 0 : params.coerce) != null ? _a17 : false,
    ...processCreateParams(params)
  });
};
var ZodBoolean2 = class extends ZodType2 {
  _parse(input) {
    if (this._def.coerce) {
      input.data = Boolean(input.data);
    }
    const parsedType4 = this._getType(input);
    if (parsedType4 !== ZodParsedType.boolean) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode2.invalid_type,
        expected: ZodParsedType.boolean,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodBoolean2.create = (params) => {
  return new ZodBoolean2({
    typeName: ZodFirstPartyTypeKind.ZodBoolean,
    coerce: (params == null ? void 0 : params.coerce) || false,
    ...processCreateParams(params)
  });
};
var ZodDate2 = class _ZodDate extends ZodType2 {
  _parse(input) {
    if (this._def.coerce) {
      input.data = new Date(input.data);
    }
    const parsedType4 = this._getType(input);
    if (parsedType4 !== ZodParsedType.date) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode2.invalid_type,
        expected: ZodParsedType.date,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    if (Number.isNaN(input.data.getTime())) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode2.invalid_date
      });
      return INVALID;
    }
    const status2 = new ParseStatus();
    let ctx = void 0;
    for (const check2 of this._def.checks) {
      if (check2.kind === "min") {
        if (input.data.getTime() < check2.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode2.too_small,
            message: check2.message,
            inclusive: true,
            exact: false,
            minimum: check2.value,
            type: "date"
          });
          status2.dirty();
        }
      } else if (check2.kind === "max") {
        if (input.data.getTime() > check2.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode2.too_big,
            message: check2.message,
            inclusive: true,
            exact: false,
            maximum: check2.value,
            type: "date"
          });
          status2.dirty();
        }
      } else {
        util.assertNever(check2);
      }
    }
    return {
      status: status2.value,
      value: new Date(input.data.getTime())
    };
  }
  _addCheck(check2) {
    return new _ZodDate({
      ...this._def,
      checks: [...this._def.checks, check2]
    });
  }
  min(minDate, message) {
    return this._addCheck({
      kind: "min",
      value: minDate.getTime(),
      message: errorUtil.toString(message)
    });
  }
  max(maxDate, message) {
    return this._addCheck({
      kind: "max",
      value: maxDate.getTime(),
      message: errorUtil.toString(message)
    });
  }
  get minDate() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min != null ? new Date(min) : null;
  }
  get maxDate() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max != null ? new Date(max) : null;
  }
};
ZodDate2.create = (params) => {
  return new ZodDate2({
    checks: [],
    coerce: (params == null ? void 0 : params.coerce) || false,
    typeName: ZodFirstPartyTypeKind.ZodDate,
    ...processCreateParams(params)
  });
};
var ZodSymbol2 = class extends ZodType2 {
  _parse(input) {
    const parsedType4 = this._getType(input);
    if (parsedType4 !== ZodParsedType.symbol) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode2.invalid_type,
        expected: ZodParsedType.symbol,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodSymbol2.create = (params) => {
  return new ZodSymbol2({
    typeName: ZodFirstPartyTypeKind.ZodSymbol,
    ...processCreateParams(params)
  });
};
var ZodUndefined2 = class extends ZodType2 {
  _parse(input) {
    const parsedType4 = this._getType(input);
    if (parsedType4 !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode2.invalid_type,
        expected: ZodParsedType.undefined,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodUndefined2.create = (params) => {
  return new ZodUndefined2({
    typeName: ZodFirstPartyTypeKind.ZodUndefined,
    ...processCreateParams(params)
  });
};
var ZodNull2 = class extends ZodType2 {
  _parse(input) {
    const parsedType4 = this._getType(input);
    if (parsedType4 !== ZodParsedType.null) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode2.invalid_type,
        expected: ZodParsedType.null,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodNull2.create = (params) => {
  return new ZodNull2({
    typeName: ZodFirstPartyTypeKind.ZodNull,
    ...processCreateParams(params)
  });
};
var ZodAny2 = class extends ZodType2 {
  constructor() {
    super(...arguments);
    this._any = true;
  }
  _parse(input) {
    return OK(input.data);
  }
};
ZodAny2.create = (params) => {
  return new ZodAny2({
    typeName: ZodFirstPartyTypeKind.ZodAny,
    ...processCreateParams(params)
  });
};
var ZodUnknown2 = class extends ZodType2 {
  constructor() {
    super(...arguments);
    this._unknown = true;
  }
  _parse(input) {
    return OK(input.data);
  }
};
ZodUnknown2.create = (params) => {
  return new ZodUnknown2({
    typeName: ZodFirstPartyTypeKind.ZodUnknown,
    ...processCreateParams(params)
  });
};
var ZodNever2 = class extends ZodType2 {
  _parse(input) {
    const ctx = this._getOrReturnCtx(input);
    addIssueToContext(ctx, {
      code: ZodIssueCode2.invalid_type,
      expected: ZodParsedType.never,
      received: ctx.parsedType
    });
    return INVALID;
  }
};
ZodNever2.create = (params) => {
  return new ZodNever2({
    typeName: ZodFirstPartyTypeKind.ZodNever,
    ...processCreateParams(params)
  });
};
var ZodVoid2 = class extends ZodType2 {
  _parse(input) {
    const parsedType4 = this._getType(input);
    if (parsedType4 !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode2.invalid_type,
        expected: ZodParsedType.void,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodVoid2.create = (params) => {
  return new ZodVoid2({
    typeName: ZodFirstPartyTypeKind.ZodVoid,
    ...processCreateParams(params)
  });
};
var ZodArray2 = class _ZodArray extends ZodType2 {
  _parse(input) {
    const { ctx, status: status2 } = this._processInputParams(input);
    const def = this._def;
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode2.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (def.exactLength !== null) {
      const tooBig = ctx.data.length > def.exactLength.value;
      const tooSmall = ctx.data.length < def.exactLength.value;
      if (tooBig || tooSmall) {
        addIssueToContext(ctx, {
          code: tooBig ? ZodIssueCode2.too_big : ZodIssueCode2.too_small,
          minimum: tooSmall ? def.exactLength.value : void 0,
          maximum: tooBig ? def.exactLength.value : void 0,
          type: "array",
          inclusive: true,
          exact: true,
          message: def.exactLength.message
        });
        status2.dirty();
      }
    }
    if (def.minLength !== null) {
      if (ctx.data.length < def.minLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode2.too_small,
          minimum: def.minLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def.minLength.message
        });
        status2.dirty();
      }
    }
    if (def.maxLength !== null) {
      if (ctx.data.length > def.maxLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode2.too_big,
          maximum: def.maxLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def.maxLength.message
        });
        status2.dirty();
      }
    }
    if (ctx.common.async) {
      return Promise.all([...ctx.data].map((item11, i4) => {
        return def.type._parseAsync(new ParseInputLazyPath(ctx, item11, ctx.path, i4));
      })).then((result2) => {
        return ParseStatus.mergeArray(status2, result2);
      });
    }
    const result = [...ctx.data].map((item11, i4) => {
      return def.type._parseSync(new ParseInputLazyPath(ctx, item11, ctx.path, i4));
    });
    return ParseStatus.mergeArray(status2, result);
  }
  get element() {
    return this._def.type;
  }
  min(minLength, message) {
    return new _ZodArray({
      ...this._def,
      minLength: { value: minLength, message: errorUtil.toString(message) }
    });
  }
  max(maxLength, message) {
    return new _ZodArray({
      ...this._def,
      maxLength: { value: maxLength, message: errorUtil.toString(message) }
    });
  }
  length(len, message) {
    return new _ZodArray({
      ...this._def,
      exactLength: { value: len, message: errorUtil.toString(message) }
    });
  }
  nonempty(message) {
    return this.min(1, message);
  }
};
ZodArray2.create = (schema, params) => {
  return new ZodArray2({
    type: schema,
    minLength: null,
    maxLength: null,
    exactLength: null,
    typeName: ZodFirstPartyTypeKind.ZodArray,
    ...processCreateParams(params)
  });
};
function deepPartialify(schema) {
  if (schema instanceof ZodObject2) {
    const newShape = {};
    for (const key2 in schema.shape) {
      const fieldSchema = schema.shape[key2];
      newShape[key2] = ZodOptional2.create(deepPartialify(fieldSchema));
    }
    return new ZodObject2({
      ...schema._def,
      shape: () => newShape
    });
  } else if (schema instanceof ZodArray2) {
    return new ZodArray2({
      ...schema._def,
      type: deepPartialify(schema.element)
    });
  } else if (schema instanceof ZodOptional2) {
    return ZodOptional2.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodNullable2) {
    return ZodNullable2.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodTuple2) {
    return ZodTuple2.create(schema.items.map((item11) => deepPartialify(item11)));
  } else {
    return schema;
  }
}
var ZodObject2 = class _ZodObject extends ZodType2 {
  constructor() {
    super(...arguments);
    this._cached = null;
    this.nonstrict = this.passthrough;
    this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const shape = this._def.shape();
    const keys = util.objectKeys(shape);
    this._cached = { shape, keys };
    return this._cached;
  }
  _parse(input) {
    const parsedType4 = this._getType(input);
    if (parsedType4 !== ZodParsedType.object) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode2.invalid_type,
        expected: ZodParsedType.object,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    const { status: status2, ctx } = this._processInputParams(input);
    const { shape, keys: shapeKeys } = this._getCached();
    const extraKeys = [];
    if (!(this._def.catchall instanceof ZodNever2 && this._def.unknownKeys === "strip")) {
      for (const key2 in ctx.data) {
        if (!shapeKeys.includes(key2)) {
          extraKeys.push(key2);
        }
      }
    }
    const pairs = [];
    for (const key2 of shapeKeys) {
      const keyValidator = shape[key2];
      const value = ctx.data[key2];
      pairs.push({
        key: { status: "valid", value: key2 },
        value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key2)),
        alwaysSet: key2 in ctx.data
      });
    }
    if (this._def.catchall instanceof ZodNever2) {
      const unknownKeys = this._def.unknownKeys;
      if (unknownKeys === "passthrough") {
        for (const key2 of extraKeys) {
          pairs.push({
            key: { status: "valid", value: key2 },
            value: { status: "valid", value: ctx.data[key2] }
          });
        }
      } else if (unknownKeys === "strict") {
        if (extraKeys.length > 0) {
          addIssueToContext(ctx, {
            code: ZodIssueCode2.unrecognized_keys,
            keys: extraKeys
          });
          status2.dirty();
        }
      } else if (unknownKeys === "strip") {
      } else {
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
      }
    } else {
      const catchall = this._def.catchall;
      for (const key2 of extraKeys) {
        const value = ctx.data[key2];
        pairs.push({
          key: { status: "valid", value: key2 },
          value: catchall._parse(
            new ParseInputLazyPath(ctx, value, ctx.path, key2)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: key2 in ctx.data
        });
      }
    }
    if (ctx.common.async) {
      return Promise.resolve().then(async () => {
        const syncPairs = [];
        for (const pair of pairs) {
          const key2 = await pair.key;
          const value = await pair.value;
          syncPairs.push({
            key: key2,
            value,
            alwaysSet: pair.alwaysSet
          });
        }
        return syncPairs;
      }).then((syncPairs) => {
        return ParseStatus.mergeObjectSync(status2, syncPairs);
      });
    } else {
      return ParseStatus.mergeObjectSync(status2, pairs);
    }
  }
  get shape() {
    return this._def.shape();
  }
  strict(message) {
    errorUtil.errToObj;
    return new _ZodObject({
      ...this._def,
      unknownKeys: "strict",
      ...message !== void 0 ? {
        errorMap: (issue2, ctx) => {
          var _a17, _b8, _c, _d;
          const defaultError = (_c = (_b8 = (_a17 = this._def).errorMap) == null ? void 0 : _b8.call(_a17, issue2, ctx).message) != null ? _c : ctx.defaultError;
          if (issue2.code === "unrecognized_keys")
            return {
              message: (_d = errorUtil.errToObj(message).message) != null ? _d : defaultError
            };
          return {
            message: defaultError
          };
        }
      } : {}
    });
  }
  strip() {
    return new _ZodObject({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new _ZodObject({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(augmentation) {
    return new _ZodObject({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...augmentation
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(merging) {
    const merged = new _ZodObject({
      unknownKeys: merging._def.unknownKeys,
      catchall: merging._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...merging._def.shape()
      }),
      typeName: ZodFirstPartyTypeKind.ZodObject
    });
    return merged;
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(key2, schema) {
    return this.augment({ [key2]: schema });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(index) {
    return new _ZodObject({
      ...this._def,
      catchall: index
    });
  }
  pick(mask) {
    const shape = {};
    for (const key2 of util.objectKeys(mask)) {
      if (mask[key2] && this.shape[key2]) {
        shape[key2] = this.shape[key2];
      }
    }
    return new _ZodObject({
      ...this._def,
      shape: () => shape
    });
  }
  omit(mask) {
    const shape = {};
    for (const key2 of util.objectKeys(this.shape)) {
      if (!mask[key2]) {
        shape[key2] = this.shape[key2];
      }
    }
    return new _ZodObject({
      ...this._def,
      shape: () => shape
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return deepPartialify(this);
  }
  partial(mask) {
    const newShape = {};
    for (const key2 of util.objectKeys(this.shape)) {
      const fieldSchema = this.shape[key2];
      if (mask && !mask[key2]) {
        newShape[key2] = fieldSchema;
      } else {
        newShape[key2] = fieldSchema.optional();
      }
    }
    return new _ZodObject({
      ...this._def,
      shape: () => newShape
    });
  }
  required(mask) {
    const newShape = {};
    for (const key2 of util.objectKeys(this.shape)) {
      if (mask && !mask[key2]) {
        newShape[key2] = this.shape[key2];
      } else {
        const fieldSchema = this.shape[key2];
        let newField = fieldSchema;
        while (newField instanceof ZodOptional2) {
          newField = newField._def.innerType;
        }
        newShape[key2] = newField;
      }
    }
    return new _ZodObject({
      ...this._def,
      shape: () => newShape
    });
  }
  keyof() {
    return createZodEnum(util.objectKeys(this.shape));
  }
};
ZodObject2.create = (shape, params) => {
  return new ZodObject2({
    shape: () => shape,
    unknownKeys: "strip",
    catchall: ZodNever2.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
ZodObject2.strictCreate = (shape, params) => {
  return new ZodObject2({
    shape: () => shape,
    unknownKeys: "strict",
    catchall: ZodNever2.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
ZodObject2.lazycreate = (shape, params) => {
  return new ZodObject2({
    shape,
    unknownKeys: "strip",
    catchall: ZodNever2.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
var ZodUnion2 = class extends ZodType2 {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const options = this._def.options;
    function handleResults(results) {
      for (const result of results) {
        if (result.result.status === "valid") {
          return result.result;
        }
      }
      for (const result of results) {
        if (result.result.status === "dirty") {
          ctx.common.issues.push(...result.ctx.common.issues);
          return result.result;
        }
      }
      const unionErrors = results.map((result) => new ZodError2(result.ctx.common.issues));
      addIssueToContext(ctx, {
        code: ZodIssueCode2.invalid_union,
        unionErrors
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return Promise.all(options.map(async (option) => {
        const childCtx = {
          ...ctx,
          common: {
            ...ctx.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: childCtx
          }),
          ctx: childCtx
        };
      })).then(handleResults);
    } else {
      let dirty = void 0;
      const issues = [];
      for (const option of options) {
        const childCtx = {
          ...ctx,
          common: {
            ...ctx.common,
            issues: []
          },
          parent: null
        };
        const result = option._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: childCtx
        });
        if (result.status === "valid") {
          return result;
        } else if (result.status === "dirty" && !dirty) {
          dirty = { result, ctx: childCtx };
        }
        if (childCtx.common.issues.length) {
          issues.push(childCtx.common.issues);
        }
      }
      if (dirty) {
        ctx.common.issues.push(...dirty.ctx.common.issues);
        return dirty.result;
      }
      const unionErrors = issues.map((issues2) => new ZodError2(issues2));
      addIssueToContext(ctx, {
        code: ZodIssueCode2.invalid_union,
        unionErrors
      });
      return INVALID;
    }
  }
  get options() {
    return this._def.options;
  }
};
ZodUnion2.create = (types, params) => {
  return new ZodUnion2({
    options: types,
    typeName: ZodFirstPartyTypeKind.ZodUnion,
    ...processCreateParams(params)
  });
};
var getDiscriminator = (type) => {
  if (type instanceof ZodLazy2) {
    return getDiscriminator(type.schema);
  } else if (type instanceof ZodEffects) {
    return getDiscriminator(type.innerType());
  } else if (type instanceof ZodLiteral2) {
    return [type.value];
  } else if (type instanceof ZodEnum2) {
    return type.options;
  } else if (type instanceof ZodNativeEnum) {
    return util.objectValues(type.enum);
  } else if (type instanceof ZodDefault2) {
    return getDiscriminator(type._def.innerType);
  } else if (type instanceof ZodUndefined2) {
    return [void 0];
  } else if (type instanceof ZodNull2) {
    return [null];
  } else if (type instanceof ZodOptional2) {
    return [void 0, ...getDiscriminator(type.unwrap())];
  } else if (type instanceof ZodNullable2) {
    return [null, ...getDiscriminator(type.unwrap())];
  } else if (type instanceof ZodBranded) {
    return getDiscriminator(type.unwrap());
  } else if (type instanceof ZodReadonly2) {
    return getDiscriminator(type.unwrap());
  } else if (type instanceof ZodCatch2) {
    return getDiscriminator(type._def.innerType);
  } else {
    return [];
  }
};
var ZodDiscriminatedUnion2 = class _ZodDiscriminatedUnion extends ZodType2 {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode2.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const discriminator = this.discriminator;
    const discriminatorValue = ctx.data[discriminator];
    const option = this.optionsMap.get(discriminatorValue);
    if (!option) {
      addIssueToContext(ctx, {
        code: ZodIssueCode2.invalid_union_discriminator,
        options: Array.from(this.optionsMap.keys()),
        path: [discriminator]
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return option._parseAsync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    } else {
      return option._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    }
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(discriminator, options, params) {
    const optionsMap = /* @__PURE__ */ new Map();
    for (const type of options) {
      const discriminatorValues = getDiscriminator(type.shape[discriminator]);
      if (!discriminatorValues.length) {
        throw new Error("A discriminator value for key `".concat(discriminator, "` could not be extracted from all schema options"));
      }
      for (const value of discriminatorValues) {
        if (optionsMap.has(value)) {
          throw new Error("Discriminator property ".concat(String(discriminator), " has duplicate value ").concat(String(value)));
        }
        optionsMap.set(value, type);
      }
    }
    return new _ZodDiscriminatedUnion({
      typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
      discriminator,
      options,
      optionsMap,
      ...processCreateParams(params)
    });
  }
};
function mergeValues2(a4, b3) {
  const aType = getParsedType2(a4);
  const bType = getParsedType2(b3);
  if (a4 === b3) {
    return { valid: true, data: a4 };
  } else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
    const bKeys = util.objectKeys(b3);
    const sharedKeys = util.objectKeys(a4).filter((key2) => bKeys.indexOf(key2) !== -1);
    const newObj = { ...a4, ...b3 };
    for (const key2 of sharedKeys) {
      const sharedValue = mergeValues2(a4[key2], b3[key2]);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newObj[key2] = sharedValue.data;
    }
    return { valid: true, data: newObj };
  } else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
    if (a4.length !== b3.length) {
      return { valid: false };
    }
    const newArray = [];
    for (let index = 0; index < a4.length; index++) {
      const itemA = a4[index];
      const itemB = b3[index];
      const sharedValue = mergeValues2(itemA, itemB);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newArray.push(sharedValue.data);
    }
    return { valid: true, data: newArray };
  } else if (aType === ZodParsedType.date && bType === ZodParsedType.date && +a4 === +b3) {
    return { valid: true, data: a4 };
  } else {
    return { valid: false };
  }
}
var ZodIntersection2 = class extends ZodType2 {
  _parse(input) {
    const { status: status2, ctx } = this._processInputParams(input);
    const handleParsed = (parsedLeft, parsedRight) => {
      if (isAborted(parsedLeft) || isAborted(parsedRight)) {
        return INVALID;
      }
      const merged = mergeValues2(parsedLeft.value, parsedRight.value);
      if (!merged.valid) {
        addIssueToContext(ctx, {
          code: ZodIssueCode2.invalid_intersection_types
        });
        return INVALID;
      }
      if (isDirty(parsedLeft) || isDirty(parsedRight)) {
        status2.dirty();
      }
      return { status: status2.value, value: merged.data };
    };
    if (ctx.common.async) {
      return Promise.all([
        this._def.left._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }),
        this._def.right._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        })
      ]).then(([left, right]) => handleParsed(left, right));
    } else {
      return handleParsed(this._def.left._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }), this._def.right._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }));
    }
  }
};
ZodIntersection2.create = (left, right, params) => {
  return new ZodIntersection2({
    left,
    right,
    typeName: ZodFirstPartyTypeKind.ZodIntersection,
    ...processCreateParams(params)
  });
};
var ZodTuple2 = class _ZodTuple extends ZodType2 {
  _parse(input) {
    const { status: status2, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode2.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (ctx.data.length < this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode2.too_small,
        minimum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      return INVALID;
    }
    const rest = this._def.rest;
    if (!rest && ctx.data.length > this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode2.too_big,
        maximum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      status2.dirty();
    }
    const items = [...ctx.data].map((item11, itemIndex) => {
      const schema = this._def.items[itemIndex] || this._def.rest;
      if (!schema)
        return null;
      return schema._parse(new ParseInputLazyPath(ctx, item11, ctx.path, itemIndex));
    }).filter((x4) => !!x4);
    if (ctx.common.async) {
      return Promise.all(items).then((results) => {
        return ParseStatus.mergeArray(status2, results);
      });
    } else {
      return ParseStatus.mergeArray(status2, items);
    }
  }
  get items() {
    return this._def.items;
  }
  rest(rest) {
    return new _ZodTuple({
      ...this._def,
      rest
    });
  }
};
ZodTuple2.create = (schemas, params) => {
  if (!Array.isArray(schemas)) {
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  }
  return new ZodTuple2({
    items: schemas,
    typeName: ZodFirstPartyTypeKind.ZodTuple,
    rest: null,
    ...processCreateParams(params)
  });
};
var ZodRecord2 = class _ZodRecord extends ZodType2 {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status: status2, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode2.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const pairs = [];
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    for (const key2 in ctx.data) {
      pairs.push({
        key: keyType._parse(new ParseInputLazyPath(ctx, key2, ctx.path, key2)),
        value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key2], ctx.path, key2)),
        alwaysSet: key2 in ctx.data
      });
    }
    if (ctx.common.async) {
      return ParseStatus.mergeObjectAsync(status2, pairs);
    } else {
      return ParseStatus.mergeObjectSync(status2, pairs);
    }
  }
  get element() {
    return this._def.valueType;
  }
  static create(first2, second, third) {
    if (second instanceof ZodType2) {
      return new _ZodRecord({
        keyType: first2,
        valueType: second,
        typeName: ZodFirstPartyTypeKind.ZodRecord,
        ...processCreateParams(third)
      });
    }
    return new _ZodRecord({
      keyType: ZodString2.create(),
      valueType: first2,
      typeName: ZodFirstPartyTypeKind.ZodRecord,
      ...processCreateParams(second)
    });
  }
};
var ZodMap2 = class extends ZodType2 {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status: status2, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.map) {
      addIssueToContext(ctx, {
        code: ZodIssueCode2.invalid_type,
        expected: ZodParsedType.map,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    const pairs = [...ctx.data.entries()].map(([key2, value], index) => {
      return {
        key: keyType._parse(new ParseInputLazyPath(ctx, key2, ctx.path, [index, "key"])),
        value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"]))
      };
    });
    if (ctx.common.async) {
      const finalMap = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const pair of pairs) {
          const key2 = await pair.key;
          const value = await pair.value;
          if (key2.status === "aborted" || value.status === "aborted") {
            return INVALID;
          }
          if (key2.status === "dirty" || value.status === "dirty") {
            status2.dirty();
          }
          finalMap.set(key2.value, value.value);
        }
        return { status: status2.value, value: finalMap };
      });
    } else {
      const finalMap = /* @__PURE__ */ new Map();
      for (const pair of pairs) {
        const key2 = pair.key;
        const value = pair.value;
        if (key2.status === "aborted" || value.status === "aborted") {
          return INVALID;
        }
        if (key2.status === "dirty" || value.status === "dirty") {
          status2.dirty();
        }
        finalMap.set(key2.value, value.value);
      }
      return { status: status2.value, value: finalMap };
    }
  }
};
ZodMap2.create = (keyType, valueType, params) => {
  return new ZodMap2({
    valueType,
    keyType,
    typeName: ZodFirstPartyTypeKind.ZodMap,
    ...processCreateParams(params)
  });
};
var ZodSet2 = class _ZodSet extends ZodType2 {
  _parse(input) {
    const { status: status2, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.set) {
      addIssueToContext(ctx, {
        code: ZodIssueCode2.invalid_type,
        expected: ZodParsedType.set,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const def = this._def;
    if (def.minSize !== null) {
      if (ctx.data.size < def.minSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode2.too_small,
          minimum: def.minSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def.minSize.message
        });
        status2.dirty();
      }
    }
    if (def.maxSize !== null) {
      if (ctx.data.size > def.maxSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode2.too_big,
          maximum: def.maxSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def.maxSize.message
        });
        status2.dirty();
      }
    }
    const valueType = this._def.valueType;
    function finalizeSet(elements2) {
      const parsedSet = /* @__PURE__ */ new Set();
      for (const element of elements2) {
        if (element.status === "aborted")
          return INVALID;
        if (element.status === "dirty")
          status2.dirty();
        parsedSet.add(element.value);
      }
      return { status: status2.value, value: parsedSet };
    }
    const elements = [...ctx.data.values()].map((item11, i4) => valueType._parse(new ParseInputLazyPath(ctx, item11, ctx.path, i4)));
    if (ctx.common.async) {
      return Promise.all(elements).then((elements2) => finalizeSet(elements2));
    } else {
      return finalizeSet(elements);
    }
  }
  min(minSize, message) {
    return new _ZodSet({
      ...this._def,
      minSize: { value: minSize, message: errorUtil.toString(message) }
    });
  }
  max(maxSize, message) {
    return new _ZodSet({
      ...this._def,
      maxSize: { value: maxSize, message: errorUtil.toString(message) }
    });
  }
  size(size, message) {
    return this.min(size, message).max(size, message);
  }
  nonempty(message) {
    return this.min(1, message);
  }
};
ZodSet2.create = (valueType, params) => {
  return new ZodSet2({
    valueType,
    minSize: null,
    maxSize: null,
    typeName: ZodFirstPartyTypeKind.ZodSet,
    ...processCreateParams(params)
  });
};
var ZodFunction = class _ZodFunction extends ZodType2 {
  constructor() {
    super(...arguments);
    this.validate = this.implement;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.function) {
      addIssueToContext(ctx, {
        code: ZodIssueCode2.invalid_type,
        expected: ZodParsedType.function,
        received: ctx.parsedType
      });
      return INVALID;
    }
    function makeArgsIssue(args, error40) {
      return makeIssue({
        data: args,
        path: ctx.path,
        errorMaps: [ctx.common.contextualErrorMap, ctx.schemaErrorMap, getErrorMap2(), en_default2].filter((x4) => !!x4),
        issueData: {
          code: ZodIssueCode2.invalid_arguments,
          argumentsError: error40
        }
      });
    }
    function makeReturnsIssue(returns, error40) {
      return makeIssue({
        data: returns,
        path: ctx.path,
        errorMaps: [ctx.common.contextualErrorMap, ctx.schemaErrorMap, getErrorMap2(), en_default2].filter((x4) => !!x4),
        issueData: {
          code: ZodIssueCode2.invalid_return_type,
          returnTypeError: error40
        }
      });
    }
    const params = { errorMap: ctx.common.contextualErrorMap };
    const fn = ctx.data;
    if (this._def.returns instanceof ZodPromise2) {
      const me2 = this;
      return OK(async function(...args) {
        const error40 = new ZodError2([]);
        const parsedArgs = await me2._def.args.parseAsync(args, params).catch((e4) => {
          error40.addIssue(makeArgsIssue(args, e4));
          throw error40;
        });
        const result = await Reflect.apply(fn, this, parsedArgs);
        const parsedReturns = await me2._def.returns._def.type.parseAsync(result, params).catch((e4) => {
          error40.addIssue(makeReturnsIssue(result, e4));
          throw error40;
        });
        return parsedReturns;
      });
    } else {
      const me2 = this;
      return OK(function(...args) {
        const parsedArgs = me2._def.args.safeParse(args, params);
        if (!parsedArgs.success) {
          throw new ZodError2([makeArgsIssue(args, parsedArgs.error)]);
        }
        const result = Reflect.apply(fn, this, parsedArgs.data);
        const parsedReturns = me2._def.returns.safeParse(result, params);
        if (!parsedReturns.success) {
          throw new ZodError2([makeReturnsIssue(result, parsedReturns.error)]);
        }
        return parsedReturns.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...items) {
    return new _ZodFunction({
      ...this._def,
      args: ZodTuple2.create(items).rest(ZodUnknown2.create())
    });
  }
  returns(returnType) {
    return new _ZodFunction({
      ...this._def,
      returns: returnType
    });
  }
  implement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  strictImplement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  static create(args, returns, params) {
    return new _ZodFunction({
      args: args ? args : ZodTuple2.create([]).rest(ZodUnknown2.create()),
      returns: returns || ZodUnknown2.create(),
      typeName: ZodFirstPartyTypeKind.ZodFunction,
      ...processCreateParams(params)
    });
  }
};
var ZodLazy2 = class extends ZodType2 {
  get schema() {
    return this._def.getter();
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const lazySchema = this._def.getter();
    return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
  }
};
ZodLazy2.create = (getter, params) => {
  return new ZodLazy2({
    getter,
    typeName: ZodFirstPartyTypeKind.ZodLazy,
    ...processCreateParams(params)
  });
};
var ZodLiteral2 = class extends ZodType2 {
  _parse(input) {
    if (input.data !== this._def.value) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode2.invalid_literal,
        expected: this._def.value
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
  get value() {
    return this._def.value;
  }
};
ZodLiteral2.create = (value, params) => {
  return new ZodLiteral2({
    value,
    typeName: ZodFirstPartyTypeKind.ZodLiteral,
    ...processCreateParams(params)
  });
};
function createZodEnum(values, params) {
  return new ZodEnum2({
    values,
    typeName: ZodFirstPartyTypeKind.ZodEnum,
    ...processCreateParams(params)
  });
}
var ZodEnum2 = class _ZodEnum extends ZodType2 {
  _parse(input) {
    if (typeof input.data !== "string") {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        expected: util.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode2.invalid_type
      });
      return INVALID;
    }
    if (!this._cache) {
      this._cache = new Set(this._def.values);
    }
    if (!this._cache.has(input.data)) {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode2.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Values() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  extract(values, newDef = this._def) {
    return _ZodEnum.create(values, {
      ...this._def,
      ...newDef
    });
  }
  exclude(values, newDef = this._def) {
    return _ZodEnum.create(this.options.filter((opt) => !values.includes(opt)), {
      ...this._def,
      ...newDef
    });
  }
};
ZodEnum2.create = createZodEnum;
var ZodNativeEnum = class extends ZodType2 {
  _parse(input) {
    const nativeEnumValues = util.getValidEnumValues(this._def.values);
    const ctx = this._getOrReturnCtx(input);
    if (ctx.parsedType !== ZodParsedType.string && ctx.parsedType !== ZodParsedType.number) {
      const expectedValues = util.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        expected: util.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode2.invalid_type
      });
      return INVALID;
    }
    if (!this._cache) {
      this._cache = new Set(util.getValidEnumValues(this._def.values));
    }
    if (!this._cache.has(input.data)) {
      const expectedValues = util.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode2.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get enum() {
    return this._def.values;
  }
};
ZodNativeEnum.create = (values, params) => {
  return new ZodNativeEnum({
    values,
    typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
    ...processCreateParams(params)
  });
};
var ZodPromise2 = class extends ZodType2 {
  unwrap() {
    return this._def.type;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.promise && ctx.common.async === false) {
      addIssueToContext(ctx, {
        code: ZodIssueCode2.invalid_type,
        expected: ZodParsedType.promise,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const promisified = ctx.parsedType === ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
    return OK(promisified.then((data) => {
      return this._def.type.parseAsync(data, {
        path: ctx.path,
        errorMap: ctx.common.contextualErrorMap
      });
    }));
  }
};
ZodPromise2.create = (schema, params) => {
  return new ZodPromise2({
    type: schema,
    typeName: ZodFirstPartyTypeKind.ZodPromise,
    ...processCreateParams(params)
  });
};
var ZodEffects = class extends ZodType2 {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(input) {
    const { status: status2, ctx } = this._processInputParams(input);
    const effect = this._def.effect || null;
    const checkCtx = {
      addIssue: (arg) => {
        addIssueToContext(ctx, arg);
        if (arg.fatal) {
          status2.abort();
        } else {
          status2.dirty();
        }
      },
      get path() {
        return ctx.path;
      }
    };
    checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
    if (effect.type === "preprocess") {
      const processed = effect.transform(ctx.data, checkCtx);
      if (ctx.common.async) {
        return Promise.resolve(processed).then(async (processed2) => {
          if (status2.value === "aborted")
            return INVALID;
          const result = await this._def.schema._parseAsync({
            data: processed2,
            path: ctx.path,
            parent: ctx
          });
          if (result.status === "aborted")
            return INVALID;
          if (result.status === "dirty")
            return DIRTY(result.value);
          if (status2.value === "dirty")
            return DIRTY(result.value);
          return result;
        });
      } else {
        if (status2.value === "aborted")
          return INVALID;
        const result = this._def.schema._parseSync({
          data: processed,
          path: ctx.path,
          parent: ctx
        });
        if (result.status === "aborted")
          return INVALID;
        if (result.status === "dirty")
          return DIRTY(result.value);
        if (status2.value === "dirty")
          return DIRTY(result.value);
        return result;
      }
    }
    if (effect.type === "refinement") {
      const executeRefinement = (acc) => {
        const result = effect.refinement(acc, checkCtx);
        if (ctx.common.async) {
          return Promise.resolve(result);
        }
        if (result instanceof Promise) {
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        }
        return acc;
      };
      if (ctx.common.async === false) {
        const inner = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inner.status === "aborted")
          return INVALID;
        if (inner.status === "dirty")
          status2.dirty();
        executeRefinement(inner.value);
        return { status: status2.value, value: inner.value };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((inner) => {
          if (inner.status === "aborted")
            return INVALID;
          if (inner.status === "dirty")
            status2.dirty();
          return executeRefinement(inner.value).then(() => {
            return { status: status2.value, value: inner.value };
          });
        });
      }
    }
    if (effect.type === "transform") {
      if (ctx.common.async === false) {
        const base = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (!isValid(base))
          return INVALID;
        const result = effect.transform(base.value, checkCtx);
        if (result instanceof Promise) {
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        }
        return { status: status2.value, value: result };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((base) => {
          if (!isValid(base))
            return INVALID;
          return Promise.resolve(effect.transform(base.value, checkCtx)).then((result) => ({
            status: status2.value,
            value: result
          }));
        });
      }
    }
    util.assertNever(effect);
  }
};
ZodEffects.create = (schema, effect, params) => {
  return new ZodEffects({
    schema,
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    effect,
    ...processCreateParams(params)
  });
};
ZodEffects.createWithPreprocess = (preprocess2, schema, params) => {
  return new ZodEffects({
    schema,
    effect: { type: "preprocess", transform: preprocess2 },
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    ...processCreateParams(params)
  });
};
var ZodOptional2 = class extends ZodType2 {
  _parse(input) {
    const parsedType4 = this._getType(input);
    if (parsedType4 === ZodParsedType.undefined) {
      return OK(void 0);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ZodOptional2.create = (type, params) => {
  return new ZodOptional2({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodOptional,
    ...processCreateParams(params)
  });
};
var ZodNullable2 = class extends ZodType2 {
  _parse(input) {
    const parsedType4 = this._getType(input);
    if (parsedType4 === ZodParsedType.null) {
      return OK(null);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ZodNullable2.create = (type, params) => {
  return new ZodNullable2({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodNullable,
    ...processCreateParams(params)
  });
};
var ZodDefault2 = class extends ZodType2 {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    let data = ctx.data;
    if (ctx.parsedType === ZodParsedType.undefined) {
      data = this._def.defaultValue();
    }
    return this._def.innerType._parse({
      data,
      path: ctx.path,
      parent: ctx
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
ZodDefault2.create = (type, params) => {
  return new ZodDefault2({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodDefault,
    defaultValue: typeof params.default === "function" ? params.default : () => params.default,
    ...processCreateParams(params)
  });
};
var ZodCatch2 = class extends ZodType2 {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const newCtx = {
      ...ctx,
      common: {
        ...ctx.common,
        issues: []
      }
    };
    const result = this._def.innerType._parse({
      data: newCtx.data,
      path: newCtx.path,
      parent: {
        ...newCtx
      }
    });
    if (isAsync(result)) {
      return result.then((result2) => {
        return {
          status: "valid",
          value: result2.status === "valid" ? result2.value : this._def.catchValue({
            get error() {
              return new ZodError2(newCtx.common.issues);
            },
            input: newCtx.data
          })
        };
      });
    } else {
      return {
        status: "valid",
        value: result.status === "valid" ? result.value : this._def.catchValue({
          get error() {
            return new ZodError2(newCtx.common.issues);
          },
          input: newCtx.data
        })
      };
    }
  }
  removeCatch() {
    return this._def.innerType;
  }
};
ZodCatch2.create = (type, params) => {
  return new ZodCatch2({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodCatch,
    catchValue: typeof params.catch === "function" ? params.catch : () => params.catch,
    ...processCreateParams(params)
  });
};
var ZodNaN2 = class extends ZodType2 {
  _parse(input) {
    const parsedType4 = this._getType(input);
    if (parsedType4 !== ZodParsedType.nan) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode2.invalid_type,
        expected: ZodParsedType.nan,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
};
ZodNaN2.create = (params) => {
  return new ZodNaN2({
    typeName: ZodFirstPartyTypeKind.ZodNaN,
    ...processCreateParams(params)
  });
};
var BRAND = Symbol("zod_brand");
var ZodBranded = class extends ZodType2 {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const data = ctx.data;
    return this._def.type._parse({
      data,
      path: ctx.path,
      parent: ctx
    });
  }
  unwrap() {
    return this._def.type;
  }
};
var ZodPipeline = class _ZodPipeline extends ZodType2 {
  _parse(input) {
    const { status: status2, ctx } = this._processInputParams(input);
    if (ctx.common.async) {
      const handleAsync = async () => {
        const inResult = await this._def.in._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inResult.status === "aborted")
          return INVALID;
        if (inResult.status === "dirty") {
          status2.dirty();
          return DIRTY(inResult.value);
        } else {
          return this._def.out._parseAsync({
            data: inResult.value,
            path: ctx.path,
            parent: ctx
          });
        }
      };
      return handleAsync();
    } else {
      const inResult = this._def.in._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
      if (inResult.status === "aborted")
        return INVALID;
      if (inResult.status === "dirty") {
        status2.dirty();
        return {
          status: "dirty",
          value: inResult.value
        };
      } else {
        return this._def.out._parseSync({
          data: inResult.value,
          path: ctx.path,
          parent: ctx
        });
      }
    }
  }
  static create(a4, b3) {
    return new _ZodPipeline({
      in: a4,
      out: b3,
      typeName: ZodFirstPartyTypeKind.ZodPipeline
    });
  }
};
var ZodReadonly2 = class extends ZodType2 {
  _parse(input) {
    const result = this._def.innerType._parse(input);
    const freeze = (data) => {
      if (isValid(data)) {
        data.value = Object.freeze(data.value);
      }
      return data;
    };
    return isAsync(result) ? result.then((data) => freeze(data)) : freeze(result);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ZodReadonly2.create = (type, params) => {
  return new ZodReadonly2({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodReadonly,
    ...processCreateParams(params)
  });
};
var late = {
  object: ZodObject2.lazycreate
};
var ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind2) {
  ZodFirstPartyTypeKind2["ZodString"] = "ZodString";
  ZodFirstPartyTypeKind2["ZodNumber"] = "ZodNumber";
  ZodFirstPartyTypeKind2["ZodNaN"] = "ZodNaN";
  ZodFirstPartyTypeKind2["ZodBigInt"] = "ZodBigInt";
  ZodFirstPartyTypeKind2["ZodBoolean"] = "ZodBoolean";
  ZodFirstPartyTypeKind2["ZodDate"] = "ZodDate";
  ZodFirstPartyTypeKind2["ZodSymbol"] = "ZodSymbol";
  ZodFirstPartyTypeKind2["ZodUndefined"] = "ZodUndefined";
  ZodFirstPartyTypeKind2["ZodNull"] = "ZodNull";
  ZodFirstPartyTypeKind2["ZodAny"] = "ZodAny";
  ZodFirstPartyTypeKind2["ZodUnknown"] = "ZodUnknown";
  ZodFirstPartyTypeKind2["ZodNever"] = "ZodNever";
  ZodFirstPartyTypeKind2["ZodVoid"] = "ZodVoid";
  ZodFirstPartyTypeKind2["ZodArray"] = "ZodArray";
  ZodFirstPartyTypeKind2["ZodObject"] = "ZodObject";
  ZodFirstPartyTypeKind2["ZodUnion"] = "ZodUnion";
  ZodFirstPartyTypeKind2["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
  ZodFirstPartyTypeKind2["ZodIntersection"] = "ZodIntersection";
  ZodFirstPartyTypeKind2["ZodTuple"] = "ZodTuple";
  ZodFirstPartyTypeKind2["ZodRecord"] = "ZodRecord";
  ZodFirstPartyTypeKind2["ZodMap"] = "ZodMap";
  ZodFirstPartyTypeKind2["ZodSet"] = "ZodSet";
  ZodFirstPartyTypeKind2["ZodFunction"] = "ZodFunction";
  ZodFirstPartyTypeKind2["ZodLazy"] = "ZodLazy";
  ZodFirstPartyTypeKind2["ZodLiteral"] = "ZodLiteral";
  ZodFirstPartyTypeKind2["ZodEnum"] = "ZodEnum";
  ZodFirstPartyTypeKind2["ZodEffects"] = "ZodEffects";
  ZodFirstPartyTypeKind2["ZodNativeEnum"] = "ZodNativeEnum";
  ZodFirstPartyTypeKind2["ZodOptional"] = "ZodOptional";
  ZodFirstPartyTypeKind2["ZodNullable"] = "ZodNullable";
  ZodFirstPartyTypeKind2["ZodDefault"] = "ZodDefault";
  ZodFirstPartyTypeKind2["ZodCatch"] = "ZodCatch";
  ZodFirstPartyTypeKind2["ZodPromise"] = "ZodPromise";
  ZodFirstPartyTypeKind2["ZodBranded"] = "ZodBranded";
  ZodFirstPartyTypeKind2["ZodPipeline"] = "ZodPipeline";
  ZodFirstPartyTypeKind2["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
var stringType = ZodString2.create;
var numberType = ZodNumber2.create;
var nanType = ZodNaN2.create;
var bigIntType = ZodBigInt2.create;
var booleanType = ZodBoolean2.create;
var dateType = ZodDate2.create;
var symbolType = ZodSymbol2.create;
var undefinedType = ZodUndefined2.create;
var nullType = ZodNull2.create;
var anyType = ZodAny2.create;
var unknownType = ZodUnknown2.create;
var neverType = ZodNever2.create;
var voidType = ZodVoid2.create;
var arrayType = ZodArray2.create;
var objectType = ZodObject2.create;
var strictObjectType = ZodObject2.strictCreate;
var unionType = ZodUnion2.create;
var discriminatedUnionType = ZodDiscriminatedUnion2.create;
var intersectionType = ZodIntersection2.create;
var tupleType = ZodTuple2.create;
var recordType = ZodRecord2.create;
var mapType = ZodMap2.create;
var setType = ZodSet2.create;
var functionType = ZodFunction.create;
var lazyType = ZodLazy2.create;
var literalType = ZodLiteral2.create;
var enumType = ZodEnum2.create;
var nativeEnumType = ZodNativeEnum.create;
var promiseType = ZodPromise2.create;
var effectsType = ZodEffects.create;
var optionalType = ZodOptional2.create;
var nullableType = ZodNullable2.create;
var preprocessType = ZodEffects.createWithPreprocess;
var pipelineType = ZodPipeline.create;

// node_modules/@ai-sdk/provider-utils/dist/index.mjs
function combineHeaders(...headers) {
  return headers.reduce(
    (combinedHeaders, currentHeaders) => ({
      ...combinedHeaders,
      ...currentHeaders != null ? currentHeaders : {}
    }),
    {}
  );
}
function extractResponseHeaders(response) {
  return Object.fromEntries([...response.headers]);
}
var createIdGenerator = ({
  prefix,
  size = 16,
  alphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
  separator: separator2 = "-"
} = {}) => {
  const generator = () => {
    const alphabetLength = alphabet.length;
    const chars = new Array(size);
    for (let i4 = 0; i4 < size; i4++) {
      chars[i4] = alphabet[Math.random() * alphabetLength | 0];
    }
    return chars.join("");
  };
  if (prefix == null) {
    return generator;
  }
  if (alphabet.includes(separator2)) {
    throw new InvalidArgumentError({
      argument: "separator",
      message: 'The separator "'.concat(separator2, '" must not be part of the alphabet "').concat(alphabet, '".')
    });
  }
  return () => "".concat(prefix).concat(separator2).concat(generator());
};
var generateId = createIdGenerator();
function isAbortError(error40) {
  return (error40 instanceof Error || error40 instanceof DOMException) && (error40.name === "AbortError" || error40.name === "ResponseAborted" || // Next.js
  error40.name === "TimeoutError");
}
var FETCH_FAILED_ERROR_MESSAGES = ["fetch failed", "failed to fetch"];
function handleFetchError({
  error: error40,
  url: url2,
  requestBodyValues
}) {
  if (isAbortError(error40)) {
    return error40;
  }
  if (error40 instanceof TypeError && FETCH_FAILED_ERROR_MESSAGES.includes(error40.message.toLowerCase())) {
    const cause = error40.cause;
    if (cause != null) {
      return new APICallError({
        message: "Cannot connect to API: ".concat(cause.message),
        cause,
        url: url2,
        requestBodyValues,
        isRetryable: true
        // retry when network error
      });
    }
  }
  return error40;
}
function getRuntimeEnvironmentUserAgent(globalThisAny = globalThis) {
  var _a17, _b8, _c;
  if (globalThisAny.window) {
    return "runtime/browser";
  }
  if ((_a17 = globalThisAny.navigator) == null ? void 0 : _a17.userAgent) {
    return "runtime/".concat(globalThisAny.navigator.userAgent.toLowerCase());
  }
  if ((_c = (_b8 = globalThisAny.process) == null ? void 0 : _b8.versions) == null ? void 0 : _c.node) {
    return "runtime/node.js/".concat(globalThisAny.process.version.substring(0));
  }
  if (globalThisAny.EdgeRuntime) {
    return "runtime/vercel-edge";
  }
  return "runtime/unknown";
}
function normalizeHeaders(headers) {
  if (headers == null) {
    return {};
  }
  const normalized = {};
  if (headers instanceof Headers) {
    headers.forEach((value, key2) => {
      normalized[key2.toLowerCase()] = value;
    });
  } else {
    if (!Array.isArray(headers)) {
      headers = Object.entries(headers);
    }
    for (const [key2, value] of headers) {
      if (value != null) {
        normalized[key2.toLowerCase()] = value;
      }
    }
  }
  return normalized;
}
function withUserAgentSuffix(headers, ...userAgentSuffixParts) {
  const normalizedHeaders = new Headers(normalizeHeaders(headers));
  const currentUserAgentHeader = normalizedHeaders.get("user-agent") || "";
  normalizedHeaders.set(
    "user-agent",
    [currentUserAgentHeader, ...userAgentSuffixParts].filter(Boolean).join(" ")
  );
  return Object.fromEntries(normalizedHeaders.entries());
}
var VERSION = true ? "3.0.14" : "0.0.0-test";
var getOriginalFetch = () => globalThis.fetch;
var getFromApi = async ({
  url: url2,
  headers = {},
  successfulResponseHandler,
  failedResponseHandler,
  abortSignal,
  fetch: fetch2 = getOriginalFetch()
}) => {
  try {
    const response = await fetch2(url2, {
      method: "GET",
      headers: withUserAgentSuffix(
        headers,
        "ai-sdk/provider-utils/".concat(VERSION),
        getRuntimeEnvironmentUserAgent()
      ),
      signal: abortSignal
    });
    const responseHeaders = extractResponseHeaders(response);
    if (!response.ok) {
      let errorInformation;
      try {
        errorInformation = await failedResponseHandler({
          response,
          url: url2,
          requestBodyValues: {}
        });
      } catch (error40) {
        if (isAbortError(error40) || APICallError.isInstance(error40)) {
          throw error40;
        }
        throw new APICallError({
          message: "Failed to process error response",
          cause: error40,
          statusCode: response.status,
          url: url2,
          responseHeaders,
          requestBodyValues: {}
        });
      }
      throw errorInformation.value;
    }
    try {
      return await successfulResponseHandler({
        response,
        url: url2,
        requestBodyValues: {}
      });
    } catch (error40) {
      if (error40 instanceof Error) {
        if (isAbortError(error40) || APICallError.isInstance(error40)) {
          throw error40;
        }
      }
      throw new APICallError({
        message: "Failed to process successful response",
        cause: error40,
        statusCode: response.status,
        url: url2,
        responseHeaders,
        requestBodyValues: {}
      });
    }
  } catch (error40) {
    throw handleFetchError({ error: error40, url: url2, requestBodyValues: {} });
  }
};
function loadOptionalSetting({
  settingValue,
  environmentVariableName
}) {
  if (typeof settingValue === "string") {
    return settingValue;
  }
  if (settingValue != null || typeof process === "undefined") {
    return void 0;
  }
  settingValue = process.env[environmentVariableName];
  if (settingValue == null || typeof settingValue !== "string") {
    return void 0;
  }
  return settingValue;
}
var suspectProtoRx = /"__proto__"\s*:/;
var suspectConstructorRx = /"constructor"\s*:/;
function _parse2(text4) {
  const obj = JSON.parse(text4);
  if (obj === null || typeof obj !== "object") {
    return obj;
  }
  if (suspectProtoRx.test(text4) === false && suspectConstructorRx.test(text4) === false) {
    return obj;
  }
  return filter(obj);
}
function filter(obj) {
  let next2 = [obj];
  while (next2.length) {
    const nodes = next2;
    next2 = [];
    for (const node of nodes) {
      if (Object.prototype.hasOwnProperty.call(node, "__proto__")) {
        throw new SyntaxError("Object contains forbidden prototype property");
      }
      if (Object.prototype.hasOwnProperty.call(node, "constructor") && Object.prototype.hasOwnProperty.call(node.constructor, "prototype")) {
        throw new SyntaxError("Object contains forbidden prototype property");
      }
      for (const key2 in node) {
        const value = node[key2];
        if (value && typeof value === "object") {
          next2.push(value);
        }
      }
    }
  }
  return obj;
}
function secureJsonParse(text4) {
  const { stackTraceLimit } = Error;
  Error.stackTraceLimit = 0;
  try {
    return _parse2(text4);
  } finally {
    Error.stackTraceLimit = stackTraceLimit;
  }
}
var validatorSymbol = Symbol.for("vercel.ai.validator");
function validator(validate) {
  return { [validatorSymbol]: true, validate };
}
function isValidator(value) {
  return typeof value === "object" && value !== null && validatorSymbol in value && value[validatorSymbol] === true && "validate" in value;
}
function lazyValidator(createValidator) {
  let validator2;
  return () => {
    if (validator2 == null) {
      validator2 = createValidator();
    }
    return validator2;
  };
}
function asValidator(value) {
  return isValidator(value) ? value : typeof value === "function" ? value() : standardSchemaValidator(value);
}
function standardSchemaValidator(standardSchema) {
  return validator(async (value) => {
    const result = await standardSchema["~standard"].validate(value);
    return result.issues == null ? { success: true, value: result.value } : {
      success: false,
      error: new TypeValidationError({
        value,
        cause: result.issues
      })
    };
  });
}
async function validateTypes({
  value,
  schema
}) {
  const result = await safeValidateTypes({ value, schema });
  if (!result.success) {
    throw TypeValidationError.wrap({ value, cause: result.error });
  }
  return result.value;
}
async function safeValidateTypes({
  value,
  schema
}) {
  const validator2 = asValidator(schema);
  try {
    if (validator2.validate == null) {
      return { success: true, value, rawValue: value };
    }
    const result = await validator2.validate(value);
    if (result.success) {
      return { success: true, value: result.value, rawValue: value };
    }
    return {
      success: false,
      error: TypeValidationError.wrap({ value, cause: result.error }),
      rawValue: value
    };
  } catch (error40) {
    return {
      success: false,
      error: TypeValidationError.wrap({ value, cause: error40 }),
      rawValue: value
    };
  }
}
async function parseJSON({
  text: text4,
  schema
}) {
  try {
    const value = secureJsonParse(text4);
    if (schema == null) {
      return value;
    }
    return validateTypes({ value, schema });
  } catch (error40) {
    if (JSONParseError.isInstance(error40) || TypeValidationError.isInstance(error40)) {
      throw error40;
    }
    throw new JSONParseError({ text: text4, cause: error40 });
  }
}
async function safeParseJSON({
  text: text4,
  schema
}) {
  try {
    const value = secureJsonParse(text4);
    if (schema == null) {
      return { success: true, value, rawValue: value };
    }
    return await safeValidateTypes({ value, schema });
  } catch (error40) {
    return {
      success: false,
      error: JSONParseError.isInstance(error40) ? error40 : new JSONParseError({ text: text4, cause: error40 }),
      rawValue: void 0
    };
  }
}
function parseJsonEventStream({
  stream,
  schema
}) {
  return stream.pipeThrough(new TextDecoderStream()).pipeThrough(new EventSourceParserStream()).pipeThrough(
    new TransformStream({
      async transform({ data }, controller) {
        if (data === "[DONE]") {
          return;
        }
        controller.enqueue(await safeParseJSON({ text: data, schema }));
      }
    })
  );
}
var getOriginalFetch2 = () => globalThis.fetch;
var postJsonToApi = async ({
  url: url2,
  headers,
  body,
  failedResponseHandler,
  successfulResponseHandler,
  abortSignal,
  fetch: fetch2
}) => postToApi({
  url: url2,
  headers: {
    "Content-Type": "application/json",
    ...headers
  },
  body: {
    content: JSON.stringify(body),
    values: body
  },
  failedResponseHandler,
  successfulResponseHandler,
  abortSignal,
  fetch: fetch2
});
var postToApi = async ({
  url: url2,
  headers = {},
  body,
  successfulResponseHandler,
  failedResponseHandler,
  abortSignal,
  fetch: fetch2 = getOriginalFetch2()
}) => {
  try {
    const response = await fetch2(url2, {
      method: "POST",
      headers: withUserAgentSuffix(
        headers,
        "ai-sdk/provider-utils/".concat(VERSION),
        getRuntimeEnvironmentUserAgent()
      ),
      body: body.content,
      signal: abortSignal
    });
    const responseHeaders = extractResponseHeaders(response);
    if (!response.ok) {
      let errorInformation;
      try {
        errorInformation = await failedResponseHandler({
          response,
          url: url2,
          requestBodyValues: body.values
        });
      } catch (error40) {
        if (isAbortError(error40) || APICallError.isInstance(error40)) {
          throw error40;
        }
        throw new APICallError({
          message: "Failed to process error response",
          cause: error40,
          statusCode: response.status,
          url: url2,
          responseHeaders,
          requestBodyValues: body.values
        });
      }
      throw errorInformation.value;
    }
    try {
      return await successfulResponseHandler({
        response,
        url: url2,
        requestBodyValues: body.values
      });
    } catch (error40) {
      if (error40 instanceof Error) {
        if (isAbortError(error40) || APICallError.isInstance(error40)) {
          throw error40;
        }
      }
      throw new APICallError({
        message: "Failed to process successful response",
        cause: error40,
        statusCode: response.status,
        url: url2,
        responseHeaders,
        requestBodyValues: body.values
      });
    }
  } catch (error40) {
    throw handleFetchError({ error: error40, url: url2, requestBodyValues: body.values });
  }
};
async function resolve(value) {
  if (typeof value === "function") {
    value = value();
  }
  return Promise.resolve(value);
}
var createJsonErrorResponseHandler = ({
  errorSchema,
  errorToMessage,
  isRetryable
}) => async ({ response, url: url2, requestBodyValues }) => {
  const responseBody = await response.text();
  const responseHeaders = extractResponseHeaders(response);
  if (responseBody.trim() === "") {
    return {
      responseHeaders,
      value: new APICallError({
        message: response.statusText,
        url: url2,
        requestBodyValues,
        statusCode: response.status,
        responseHeaders,
        responseBody,
        isRetryable: isRetryable == null ? void 0 : isRetryable(response)
      })
    };
  }
  try {
    const parsedError = await parseJSON({
      text: responseBody,
      schema: errorSchema
    });
    return {
      responseHeaders,
      value: new APICallError({
        message: errorToMessage(parsedError),
        url: url2,
        requestBodyValues,
        statusCode: response.status,
        responseHeaders,
        responseBody,
        data: parsedError,
        isRetryable: isRetryable == null ? void 0 : isRetryable(response, parsedError)
      })
    };
  } catch (parseError) {
    return {
      responseHeaders,
      value: new APICallError({
        message: response.statusText,
        url: url2,
        requestBodyValues,
        statusCode: response.status,
        responseHeaders,
        responseBody,
        isRetryable: isRetryable == null ? void 0 : isRetryable(response)
      })
    };
  }
};
var createEventSourceResponseHandler = (chunkSchema) => async ({ response }) => {
  const responseHeaders = extractResponseHeaders(response);
  if (response.body == null) {
    throw new EmptyResponseBodyError({});
  }
  return {
    responseHeaders,
    value: parseJsonEventStream({
      stream: response.body,
      schema: chunkSchema
    })
  };
};
var createJsonResponseHandler = (responseSchema) => async ({ response, url: url2, requestBodyValues }) => {
  const responseBody = await response.text();
  const parsedResult = await safeParseJSON({
    text: responseBody,
    schema: responseSchema
  });
  const responseHeaders = extractResponseHeaders(response);
  if (!parsedResult.success) {
    throw new APICallError({
      message: "Invalid JSON response",
      cause: parsedResult.error,
      statusCode: response.status,
      responseHeaders,
      responseBody,
      url: url2,
      requestBodyValues
    });
  }
  return {
    responseHeaders,
    value: parsedResult.value,
    rawValue: parsedResult.rawValue
  };
};
var getRelativePath = (pathA, pathB) => {
  let i4 = 0;
  for (; i4 < pathA.length && i4 < pathB.length; i4++) {
    if (pathA[i4] !== pathB[i4])
      break;
  }
  return [(pathA.length - i4).toString(), ...pathB.slice(i4)].join("/");
};
var ignoreOverride = Symbol(
  "Let zodToJsonSchema decide on which parser to use"
);
var defaultOptions = {
  name: void 0,
  $refStrategy: "root",
  basePath: ["#"],
  effectStrategy: "input",
  pipeStrategy: "all",
  dateStrategy: "format:date-time",
  mapStrategy: "entries",
  removeAdditionalStrategy: "passthrough",
  allowedAdditionalProperties: true,
  rejectedAdditionalProperties: false,
  definitionPath: "definitions",
  strictUnions: false,
  definitions: {},
  errorMessages: false,
  patternStrategy: "escape",
  applyRegexFlags: false,
  emailStrategy: "format:email",
  base64Strategy: "contentEncoding:base64",
  nameStrategy: "ref"
};
var getDefaultOptions = (options) => typeof options === "string" ? {
  ...defaultOptions,
  name: options
} : {
  ...defaultOptions,
  ...options
};
function parseAnyDef() {
  return {};
}
function parseArrayDef(def, refs) {
  var _a17, _b8, _c;
  const res = {
    type: "array"
  };
  if (((_a17 = def.type) == null ? void 0 : _a17._def) && ((_c = (_b8 = def.type) == null ? void 0 : _b8._def) == null ? void 0 : _c.typeName) !== ZodFirstPartyTypeKind.ZodAny) {
    res.items = parseDef(def.type._def, {
      ...refs,
      currentPath: [...refs.currentPath, "items"]
    });
  }
  if (def.minLength) {
    res.minItems = def.minLength.value;
  }
  if (def.maxLength) {
    res.maxItems = def.maxLength.value;
  }
  if (def.exactLength) {
    res.minItems = def.exactLength.value;
    res.maxItems = def.exactLength.value;
  }
  return res;
}
function parseBigintDef(def) {
  const res = {
    type: "integer",
    format: "int64"
  };
  if (!def.checks)
    return res;
  for (const check2 of def.checks) {
    switch (check2.kind) {
      case "min":
        if (check2.inclusive) {
          res.minimum = check2.value;
        } else {
          res.exclusiveMinimum = check2.value;
        }
        break;
      case "max":
        if (check2.inclusive) {
          res.maximum = check2.value;
        } else {
          res.exclusiveMaximum = check2.value;
        }
        break;
      case "multipleOf":
        res.multipleOf = check2.value;
        break;
    }
  }
  return res;
}
function parseBooleanDef() {
  return { type: "boolean" };
}
function parseBrandedDef(_def, refs) {
  return parseDef(_def.type._def, refs);
}
var parseCatchDef = (def, refs) => {
  return parseDef(def.innerType._def, refs);
};
function parseDateDef(def, refs, overrideDateStrategy) {
  const strategy = overrideDateStrategy != null ? overrideDateStrategy : refs.dateStrategy;
  if (Array.isArray(strategy)) {
    return {
      anyOf: strategy.map((item11, i4) => parseDateDef(def, refs, item11))
    };
  }
  switch (strategy) {
    case "string":
    case "format:date-time":
      return {
        type: "string",
        format: "date-time"
      };
    case "format:date":
      return {
        type: "string",
        format: "date"
      };
    case "integer":
      return integerDateParser(def);
  }
}
var integerDateParser = (def) => {
  const res = {
    type: "integer",
    format: "unix-time"
  };
  for (const check2 of def.checks) {
    switch (check2.kind) {
      case "min":
        res.minimum = check2.value;
        break;
      case "max":
        res.maximum = check2.value;
        break;
    }
  }
  return res;
};
function parseDefaultDef(_def, refs) {
  return {
    ...parseDef(_def.innerType._def, refs),
    default: _def.defaultValue()
  };
}
function parseEffectsDef(_def, refs) {
  return refs.effectStrategy === "input" ? parseDef(_def.schema._def, refs) : parseAnyDef();
}
function parseEnumDef(def) {
  return {
    type: "string",
    enum: Array.from(def.values)
  };
}
var isJsonSchema7AllOfType = (type) => {
  if ("type" in type && type.type === "string")
    return false;
  return "allOf" in type;
};
function parseIntersectionDef(def, refs) {
  const allOf = [
    parseDef(def.left._def, {
      ...refs,
      currentPath: [...refs.currentPath, "allOf", "0"]
    }),
    parseDef(def.right._def, {
      ...refs,
      currentPath: [...refs.currentPath, "allOf", "1"]
    })
  ].filter((x4) => !!x4);
  const mergedAllOf = [];
  allOf.forEach((schema) => {
    if (isJsonSchema7AllOfType(schema)) {
      mergedAllOf.push(...schema.allOf);
    } else {
      let nestedSchema = schema;
      if ("additionalProperties" in schema && schema.additionalProperties === false) {
        const { additionalProperties, ...rest } = schema;
        nestedSchema = rest;
      }
      mergedAllOf.push(nestedSchema);
    }
  });
  return mergedAllOf.length ? { allOf: mergedAllOf } : void 0;
}
function parseLiteralDef(def) {
  const parsedType4 = typeof def.value;
  if (parsedType4 !== "bigint" && parsedType4 !== "number" && parsedType4 !== "boolean" && parsedType4 !== "string") {
    return {
      type: Array.isArray(def.value) ? "array" : "object"
    };
  }
  return {
    type: parsedType4 === "bigint" ? "integer" : parsedType4,
    const: def.value
  };
}
var emojiRegex2 = void 0;
var zodPatterns = {
  /**
   * `c` was changed to `[cC]` to replicate /i flag
   */
  cuid: /^[cC][^\s-]{8,}$/,
  cuid2: /^[0-9a-z]+$/,
  ulid: /^[0-9A-HJKMNP-TV-Z]{26}$/,
  /**
   * `a-z` was added to replicate /i flag
   */
  email: /^(?!\.)(?!.*\.\.)([a-zA-Z0-9_'+\-\.]*)[a-zA-Z0-9_+-]@([a-zA-Z0-9][a-zA-Z0-9\-]*\.)+[a-zA-Z]{2,}$/,
  /**
   * Constructed a valid Unicode RegExp
   *
   * Lazily instantiate since this type of regex isn't supported
   * in all envs (e.g. React Native).
   *
   * See:
   * https://github.com/colinhacks/zod/issues/2433
   * Fix in Zod:
   * https://github.com/colinhacks/zod/commit/9340fd51e48576a75adc919bff65dbc4a5d4c99b
   */
  emoji: () => {
    if (emojiRegex2 === void 0) {
      emojiRegex2 = RegExp(
        "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$",
        "u"
      );
    }
    return emojiRegex2;
  },
  /**
   * Unused
   */
  uuid: /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/,
  /**
   * Unused
   */
  ipv4: /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/,
  ipv4Cidr: /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/,
  /**
   * Unused
   */
  ipv6: /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/,
  ipv6Cidr: /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/,
  base64: /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/,
  base64url: /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/,
  nanoid: /^[a-zA-Z0-9_-]{21}$/,
  jwt: /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/
};
function parseStringDef(def, refs) {
  const res = {
    type: "string"
  };
  if (def.checks) {
    for (const check2 of def.checks) {
      switch (check2.kind) {
        case "min":
          res.minLength = typeof res.minLength === "number" ? Math.max(res.minLength, check2.value) : check2.value;
          break;
        case "max":
          res.maxLength = typeof res.maxLength === "number" ? Math.min(res.maxLength, check2.value) : check2.value;
          break;
        case "email":
          switch (refs.emailStrategy) {
            case "format:email":
              addFormat(res, "email", check2.message, refs);
              break;
            case "format:idn-email":
              addFormat(res, "idn-email", check2.message, refs);
              break;
            case "pattern:zod":
              addPattern(res, zodPatterns.email, check2.message, refs);
              break;
          }
          break;
        case "url":
          addFormat(res, "uri", check2.message, refs);
          break;
        case "uuid":
          addFormat(res, "uuid", check2.message, refs);
          break;
        case "regex":
          addPattern(res, check2.regex, check2.message, refs);
          break;
        case "cuid":
          addPattern(res, zodPatterns.cuid, check2.message, refs);
          break;
        case "cuid2":
          addPattern(res, zodPatterns.cuid2, check2.message, refs);
          break;
        case "startsWith":
          addPattern(
            res,
            RegExp("^".concat(escapeLiteralCheckValue(check2.value, refs))),
            check2.message,
            refs
          );
          break;
        case "endsWith":
          addPattern(
            res,
            RegExp("".concat(escapeLiteralCheckValue(check2.value, refs), "$")),
            check2.message,
            refs
          );
          break;
        case "datetime":
          addFormat(res, "date-time", check2.message, refs);
          break;
        case "date":
          addFormat(res, "date", check2.message, refs);
          break;
        case "time":
          addFormat(res, "time", check2.message, refs);
          break;
        case "duration":
          addFormat(res, "duration", check2.message, refs);
          break;
        case "length":
          res.minLength = typeof res.minLength === "number" ? Math.max(res.minLength, check2.value) : check2.value;
          res.maxLength = typeof res.maxLength === "number" ? Math.min(res.maxLength, check2.value) : check2.value;
          break;
        case "includes": {
          addPattern(
            res,
            RegExp(escapeLiteralCheckValue(check2.value, refs)),
            check2.message,
            refs
          );
          break;
        }
        case "ip": {
          if (check2.version !== "v6") {
            addFormat(res, "ipv4", check2.message, refs);
          }
          if (check2.version !== "v4") {
            addFormat(res, "ipv6", check2.message, refs);
          }
          break;
        }
        case "base64url":
          addPattern(res, zodPatterns.base64url, check2.message, refs);
          break;
        case "jwt":
          addPattern(res, zodPatterns.jwt, check2.message, refs);
          break;
        case "cidr": {
          if (check2.version !== "v6") {
            addPattern(res, zodPatterns.ipv4Cidr, check2.message, refs);
          }
          if (check2.version !== "v4") {
            addPattern(res, zodPatterns.ipv6Cidr, check2.message, refs);
          }
          break;
        }
        case "emoji":
          addPattern(res, zodPatterns.emoji(), check2.message, refs);
          break;
        case "ulid": {
          addPattern(res, zodPatterns.ulid, check2.message, refs);
          break;
        }
        case "base64": {
          switch (refs.base64Strategy) {
            case "format:binary": {
              addFormat(res, "binary", check2.message, refs);
              break;
            }
            case "contentEncoding:base64": {
              res.contentEncoding = "base64";
              break;
            }
            case "pattern:zod": {
              addPattern(res, zodPatterns.base64, check2.message, refs);
              break;
            }
          }
          break;
        }
        case "nanoid": {
          addPattern(res, zodPatterns.nanoid, check2.message, refs);
        }
        case "toLowerCase":
        case "toUpperCase":
        case "trim":
          break;
        default:
          /* @__PURE__ */ ((_4) => {
          })(check2);
      }
    }
  }
  return res;
}
function escapeLiteralCheckValue(literal2, refs) {
  return refs.patternStrategy === "escape" ? escapeNonAlphaNumeric(literal2) : literal2;
}
var ALPHA_NUMERIC = new Set(
  "ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvxyz0123456789"
);
function escapeNonAlphaNumeric(source) {
  let result = "";
  for (let i4 = 0; i4 < source.length; i4++) {
    if (!ALPHA_NUMERIC.has(source[i4])) {
      result += "\\";
    }
    result += source[i4];
  }
  return result;
}
function addFormat(schema, value, message, refs) {
  var _a17;
  if (schema.format || ((_a17 = schema.anyOf) == null ? void 0 : _a17.some((x4) => x4.format))) {
    if (!schema.anyOf) {
      schema.anyOf = [];
    }
    if (schema.format) {
      schema.anyOf.push({
        format: schema.format
      });
      delete schema.format;
    }
    schema.anyOf.push({
      format: value,
      ...message && refs.errorMessages && { errorMessage: { format: message } }
    });
  } else {
    schema.format = value;
  }
}
function addPattern(schema, regex, message, refs) {
  var _a17;
  if (schema.pattern || ((_a17 = schema.allOf) == null ? void 0 : _a17.some((x4) => x4.pattern))) {
    if (!schema.allOf) {
      schema.allOf = [];
    }
    if (schema.pattern) {
      schema.allOf.push({
        pattern: schema.pattern
      });
      delete schema.pattern;
    }
    schema.allOf.push({
      pattern: stringifyRegExpWithFlags(regex, refs),
      ...message && refs.errorMessages && { errorMessage: { pattern: message } }
    });
  } else {
    schema.pattern = stringifyRegExpWithFlags(regex, refs);
  }
}
function stringifyRegExpWithFlags(regex, refs) {
  var _a17;
  if (!refs.applyRegexFlags || !regex.flags) {
    return regex.source;
  }
  const flags = {
    i: regex.flags.includes("i"),
    // Case-insensitive
    m: regex.flags.includes("m"),
    // `^` and `$` matches adjacent to newline characters
    s: regex.flags.includes("s")
    // `.` matches newlines
  };
  const source = flags.i ? regex.source.toLowerCase() : regex.source;
  let pattern = "";
  let isEscaped = false;
  let inCharGroup = false;
  let inCharRange = false;
  for (let i4 = 0; i4 < source.length; i4++) {
    if (isEscaped) {
      pattern += source[i4];
      isEscaped = false;
      continue;
    }
    if (flags.i) {
      if (inCharGroup) {
        if (source[i4].match(/[a-z]/)) {
          if (inCharRange) {
            pattern += source[i4];
            pattern += "".concat(source[i4 - 2], "-").concat(source[i4]).toUpperCase();
            inCharRange = false;
          } else if (source[i4 + 1] === "-" && ((_a17 = source[i4 + 2]) == null ? void 0 : _a17.match(/[a-z]/))) {
            pattern += source[i4];
            inCharRange = true;
          } else {
            pattern += "".concat(source[i4]).concat(source[i4].toUpperCase());
          }
          continue;
        }
      } else if (source[i4].match(/[a-z]/)) {
        pattern += "[".concat(source[i4]).concat(source[i4].toUpperCase(), "]");
        continue;
      }
    }
    if (flags.m) {
      if (source[i4] === "^") {
        pattern += "(^|(?<=[\r\n]))";
        continue;
      } else if (source[i4] === "$") {
        pattern += "($|(?=[\r\n]))";
        continue;
      }
    }
    if (flags.s && source[i4] === ".") {
      pattern += inCharGroup ? "".concat(source[i4], "\r\n") : "[".concat(source[i4], "\r\n]");
      continue;
    }
    pattern += source[i4];
    if (source[i4] === "\\") {
      isEscaped = true;
    } else if (inCharGroup && source[i4] === "]") {
      inCharGroup = false;
    } else if (!inCharGroup && source[i4] === "[") {
      inCharGroup = true;
    }
  }
  try {
    new RegExp(pattern);
  } catch (e4) {
    console.warn(
      "Could not convert regex pattern at ".concat(refs.currentPath.join(
        "/"
      ), " to a flag-independent form! Falling back to the flag-ignorant source")
    );
    return regex.source;
  }
  return pattern;
}
function parseRecordDef(def, refs) {
  var _a17, _b8, _c, _d, _e2, _f;
  const schema = {
    type: "object",
    additionalProperties: (_a17 = parseDef(def.valueType._def, {
      ...refs,
      currentPath: [...refs.currentPath, "additionalProperties"]
    })) != null ? _a17 : refs.allowedAdditionalProperties
  };
  if (((_b8 = def.keyType) == null ? void 0 : _b8._def.typeName) === ZodFirstPartyTypeKind.ZodString && ((_c = def.keyType._def.checks) == null ? void 0 : _c.length)) {
    const { type, ...keyType } = parseStringDef(def.keyType._def, refs);
    return {
      ...schema,
      propertyNames: keyType
    };
  } else if (((_d = def.keyType) == null ? void 0 : _d._def.typeName) === ZodFirstPartyTypeKind.ZodEnum) {
    return {
      ...schema,
      propertyNames: {
        enum: def.keyType._def.values
      }
    };
  } else if (((_e2 = def.keyType) == null ? void 0 : _e2._def.typeName) === ZodFirstPartyTypeKind.ZodBranded && def.keyType._def.type._def.typeName === ZodFirstPartyTypeKind.ZodString && ((_f = def.keyType._def.type._def.checks) == null ? void 0 : _f.length)) {
    const { type, ...keyType } = parseBrandedDef(
      def.keyType._def,
      refs
    );
    return {
      ...schema,
      propertyNames: keyType
    };
  }
  return schema;
}
function parseMapDef(def, refs) {
  if (refs.mapStrategy === "record") {
    return parseRecordDef(def, refs);
  }
  const keys = parseDef(def.keyType._def, {
    ...refs,
    currentPath: [...refs.currentPath, "items", "items", "0"]
  }) || parseAnyDef();
  const values = parseDef(def.valueType._def, {
    ...refs,
    currentPath: [...refs.currentPath, "items", "items", "1"]
  }) || parseAnyDef();
  return {
    type: "array",
    maxItems: 125,
    items: {
      type: "array",
      items: [keys, values],
      minItems: 2,
      maxItems: 2
    }
  };
}
function parseNativeEnumDef(def) {
  const object3 = def.values;
  const actualKeys = Object.keys(def.values).filter((key2) => {
    return typeof object3[object3[key2]] !== "number";
  });
  const actualValues = actualKeys.map((key2) => object3[key2]);
  const parsedTypes = Array.from(
    new Set(actualValues.map((values) => typeof values))
  );
  return {
    type: parsedTypes.length === 1 ? parsedTypes[0] === "string" ? "string" : "number" : ["string", "number"],
    enum: actualValues
  };
}
function parseNeverDef() {
  return { not: parseAnyDef() };
}
function parseNullDef() {
  return {
    type: "null"
  };
}
var primitiveMappings = {
  ZodString: "string",
  ZodNumber: "number",
  ZodBigInt: "integer",
  ZodBoolean: "boolean",
  ZodNull: "null"
};
function parseUnionDef(def, refs) {
  const options = def.options instanceof Map ? Array.from(def.options.values()) : def.options;
  if (options.every(
    (x4) => x4._def.typeName in primitiveMappings && (!x4._def.checks || !x4._def.checks.length)
  )) {
    const types = options.reduce((types2, x4) => {
      const type = primitiveMappings[x4._def.typeName];
      return type && !types2.includes(type) ? [...types2, type] : types2;
    }, []);
    return {
      type: types.length > 1 ? types : types[0]
    };
  } else if (options.every((x4) => x4._def.typeName === "ZodLiteral" && !x4.description)) {
    const types = options.reduce(
      (acc, x4) => {
        const type = typeof x4._def.value;
        switch (type) {
          case "string":
          case "number":
          case "boolean":
            return [...acc, type];
          case "bigint":
            return [...acc, "integer"];
          case "object":
            if (x4._def.value === null)
              return [...acc, "null"];
          case "symbol":
          case "undefined":
          case "function":
          default:
            return acc;
        }
      },
      []
    );
    if (types.length === options.length) {
      const uniqueTypes = types.filter((x4, i4, a4) => a4.indexOf(x4) === i4);
      return {
        type: uniqueTypes.length > 1 ? uniqueTypes : uniqueTypes[0],
        enum: options.reduce(
          (acc, x4) => {
            return acc.includes(x4._def.value) ? acc : [...acc, x4._def.value];
          },
          []
        )
      };
    }
  } else if (options.every((x4) => x4._def.typeName === "ZodEnum")) {
    return {
      type: "string",
      enum: options.reduce(
        (acc, x4) => [
          ...acc,
          ...x4._def.values.filter((x22) => !acc.includes(x22))
        ],
        []
      )
    };
  }
  return asAnyOf(def, refs);
}
var asAnyOf = (def, refs) => {
  const anyOf = (def.options instanceof Map ? Array.from(def.options.values()) : def.options).map(
    (x4, i4) => parseDef(x4._def, {
      ...refs,
      currentPath: [...refs.currentPath, "anyOf", "".concat(i4)]
    })
  ).filter(
    (x4) => !!x4 && (!refs.strictUnions || typeof x4 === "object" && Object.keys(x4).length > 0)
  );
  return anyOf.length ? { anyOf } : void 0;
};
function parseNullableDef(def, refs) {
  if (["ZodString", "ZodNumber", "ZodBigInt", "ZodBoolean", "ZodNull"].includes(
    def.innerType._def.typeName
  ) && (!def.innerType._def.checks || !def.innerType._def.checks.length)) {
    return {
      type: [
        primitiveMappings[def.innerType._def.typeName],
        "null"
      ]
    };
  }
  const base = parseDef(def.innerType._def, {
    ...refs,
    currentPath: [...refs.currentPath, "anyOf", "0"]
  });
  return base && { anyOf: [base, { type: "null" }] };
}
function parseNumberDef(def) {
  const res = {
    type: "number"
  };
  if (!def.checks)
    return res;
  for (const check2 of def.checks) {
    switch (check2.kind) {
      case "int":
        res.type = "integer";
        break;
      case "min":
        if (check2.inclusive) {
          res.minimum = check2.value;
        } else {
          res.exclusiveMinimum = check2.value;
        }
        break;
      case "max":
        if (check2.inclusive) {
          res.maximum = check2.value;
        } else {
          res.exclusiveMaximum = check2.value;
        }
        break;
      case "multipleOf":
        res.multipleOf = check2.value;
        break;
    }
  }
  return res;
}
function parseObjectDef(def, refs) {
  const result = {
    type: "object",
    properties: {}
  };
  const required2 = [];
  const shape = def.shape();
  for (const propName in shape) {
    let propDef = shape[propName];
    if (propDef === void 0 || propDef._def === void 0) {
      continue;
    }
    const propOptional = safeIsOptional(propDef);
    const parsedDef = parseDef(propDef._def, {
      ...refs,
      currentPath: [...refs.currentPath, "properties", propName],
      propertyPath: [...refs.currentPath, "properties", propName]
    });
    if (parsedDef === void 0) {
      continue;
    }
    result.properties[propName] = parsedDef;
    if (!propOptional) {
      required2.push(propName);
    }
  }
  if (required2.length) {
    result.required = required2;
  }
  const additionalProperties = decideAdditionalProperties(def, refs);
  if (additionalProperties !== void 0) {
    result.additionalProperties = additionalProperties;
  }
  return result;
}
function decideAdditionalProperties(def, refs) {
  if (def.catchall._def.typeName !== "ZodNever") {
    return parseDef(def.catchall._def, {
      ...refs,
      currentPath: [...refs.currentPath, "additionalProperties"]
    });
  }
  switch (def.unknownKeys) {
    case "passthrough":
      return refs.allowedAdditionalProperties;
    case "strict":
      return refs.rejectedAdditionalProperties;
    case "strip":
      return refs.removeAdditionalStrategy === "strict" ? refs.allowedAdditionalProperties : refs.rejectedAdditionalProperties;
  }
}
function safeIsOptional(schema) {
  try {
    return schema.isOptional();
  } catch (e4) {
    return true;
  }
}
var parseOptionalDef = (def, refs) => {
  var _a17;
  if (refs.currentPath.toString() === ((_a17 = refs.propertyPath) == null ? void 0 : _a17.toString())) {
    return parseDef(def.innerType._def, refs);
  }
  const innerSchema = parseDef(def.innerType._def, {
    ...refs,
    currentPath: [...refs.currentPath, "anyOf", "1"]
  });
  return innerSchema ? { anyOf: [{ not: parseAnyDef() }, innerSchema] } : parseAnyDef();
};
var parsePipelineDef = (def, refs) => {
  if (refs.pipeStrategy === "input") {
    return parseDef(def.in._def, refs);
  } else if (refs.pipeStrategy === "output") {
    return parseDef(def.out._def, refs);
  }
  const a4 = parseDef(def.in._def, {
    ...refs,
    currentPath: [...refs.currentPath, "allOf", "0"]
  });
  const b3 = parseDef(def.out._def, {
    ...refs,
    currentPath: [...refs.currentPath, "allOf", a4 ? "1" : "0"]
  });
  return {
    allOf: [a4, b3].filter((x4) => x4 !== void 0)
  };
};
function parsePromiseDef(def, refs) {
  return parseDef(def.type._def, refs);
}
function parseSetDef(def, refs) {
  const items = parseDef(def.valueType._def, {
    ...refs,
    currentPath: [...refs.currentPath, "items"]
  });
  const schema = {
    type: "array",
    uniqueItems: true,
    items
  };
  if (def.minSize) {
    schema.minItems = def.minSize.value;
  }
  if (def.maxSize) {
    schema.maxItems = def.maxSize.value;
  }
  return schema;
}
function parseTupleDef(def, refs) {
  if (def.rest) {
    return {
      type: "array",
      minItems: def.items.length,
      items: def.items.map(
        (x4, i4) => parseDef(x4._def, {
          ...refs,
          currentPath: [...refs.currentPath, "items", "".concat(i4)]
        })
      ).reduce(
        (acc, x4) => x4 === void 0 ? acc : [...acc, x4],
        []
      ),
      additionalItems: parseDef(def.rest._def, {
        ...refs,
        currentPath: [...refs.currentPath, "additionalItems"]
      })
    };
  } else {
    return {
      type: "array",
      minItems: def.items.length,
      maxItems: def.items.length,
      items: def.items.map(
        (x4, i4) => parseDef(x4._def, {
          ...refs,
          currentPath: [...refs.currentPath, "items", "".concat(i4)]
        })
      ).reduce(
        (acc, x4) => x4 === void 0 ? acc : [...acc, x4],
        []
      )
    };
  }
}
function parseUndefinedDef() {
  return {
    not: parseAnyDef()
  };
}
function parseUnknownDef() {
  return parseAnyDef();
}
var parseReadonlyDef = (def, refs) => {
  return parseDef(def.innerType._def, refs);
};
var selectParser = (def, typeName, refs) => {
  switch (typeName) {
    case ZodFirstPartyTypeKind.ZodString:
      return parseStringDef(def, refs);
    case ZodFirstPartyTypeKind.ZodNumber:
      return parseNumberDef(def);
    case ZodFirstPartyTypeKind.ZodObject:
      return parseObjectDef(def, refs);
    case ZodFirstPartyTypeKind.ZodBigInt:
      return parseBigintDef(def);
    case ZodFirstPartyTypeKind.ZodBoolean:
      return parseBooleanDef();
    case ZodFirstPartyTypeKind.ZodDate:
      return parseDateDef(def, refs);
    case ZodFirstPartyTypeKind.ZodUndefined:
      return parseUndefinedDef();
    case ZodFirstPartyTypeKind.ZodNull:
      return parseNullDef();
    case ZodFirstPartyTypeKind.ZodArray:
      return parseArrayDef(def, refs);
    case ZodFirstPartyTypeKind.ZodUnion:
    case ZodFirstPartyTypeKind.ZodDiscriminatedUnion:
      return parseUnionDef(def, refs);
    case ZodFirstPartyTypeKind.ZodIntersection:
      return parseIntersectionDef(def, refs);
    case ZodFirstPartyTypeKind.ZodTuple:
      return parseTupleDef(def, refs);
    case ZodFirstPartyTypeKind.ZodRecord:
      return parseRecordDef(def, refs);
    case ZodFirstPartyTypeKind.ZodLiteral:
      return parseLiteralDef(def);
    case ZodFirstPartyTypeKind.ZodEnum:
      return parseEnumDef(def);
    case ZodFirstPartyTypeKind.ZodNativeEnum:
      return parseNativeEnumDef(def);
    case ZodFirstPartyTypeKind.ZodNullable:
      return parseNullableDef(def, refs);
    case ZodFirstPartyTypeKind.ZodOptional:
      return parseOptionalDef(def, refs);
    case ZodFirstPartyTypeKind.ZodMap:
      return parseMapDef(def, refs);
    case ZodFirstPartyTypeKind.ZodSet:
      return parseSetDef(def, refs);
    case ZodFirstPartyTypeKind.ZodLazy:
      return () => def.getter()._def;
    case ZodFirstPartyTypeKind.ZodPromise:
      return parsePromiseDef(def, refs);
    case ZodFirstPartyTypeKind.ZodNaN:
    case ZodFirstPartyTypeKind.ZodNever:
      return parseNeverDef();
    case ZodFirstPartyTypeKind.ZodEffects:
      return parseEffectsDef(def, refs);
    case ZodFirstPartyTypeKind.ZodAny:
      return parseAnyDef();
    case ZodFirstPartyTypeKind.ZodUnknown:
      return parseUnknownDef();
    case ZodFirstPartyTypeKind.ZodDefault:
      return parseDefaultDef(def, refs);
    case ZodFirstPartyTypeKind.ZodBranded:
      return parseBrandedDef(def, refs);
    case ZodFirstPartyTypeKind.ZodReadonly:
      return parseReadonlyDef(def, refs);
    case ZodFirstPartyTypeKind.ZodCatch:
      return parseCatchDef(def, refs);
    case ZodFirstPartyTypeKind.ZodPipeline:
      return parsePipelineDef(def, refs);
    case ZodFirstPartyTypeKind.ZodFunction:
    case ZodFirstPartyTypeKind.ZodVoid:
    case ZodFirstPartyTypeKind.ZodSymbol:
      return void 0;
    default:
      return /* @__PURE__ */ ((_4) => void 0)(typeName);
  }
};
function parseDef(def, refs, forceResolution = false) {
  var _a17;
  const seenItem = refs.seen.get(def);
  if (refs.override) {
    const overrideResult = (_a17 = refs.override) == null ? void 0 : _a17.call(
      refs,
      def,
      refs,
      seenItem,
      forceResolution
    );
    if (overrideResult !== ignoreOverride) {
      return overrideResult;
    }
  }
  if (seenItem && !forceResolution) {
    const seenSchema = get$ref(seenItem, refs);
    if (seenSchema !== void 0) {
      return seenSchema;
    }
  }
  const newItem = { def, path: refs.currentPath, jsonSchema: void 0 };
  refs.seen.set(def, newItem);
  const jsonSchemaOrGetter = selectParser(def, def.typeName, refs);
  const jsonSchema2 = typeof jsonSchemaOrGetter === "function" ? parseDef(jsonSchemaOrGetter(), refs) : jsonSchemaOrGetter;
  if (jsonSchema2) {
    addMeta(def, refs, jsonSchema2);
  }
  if (refs.postProcess) {
    const postProcessResult = refs.postProcess(jsonSchema2, def, refs);
    newItem.jsonSchema = jsonSchema2;
    return postProcessResult;
  }
  newItem.jsonSchema = jsonSchema2;
  return jsonSchema2;
}
var get$ref = (item11, refs) => {
  switch (refs.$refStrategy) {
    case "root":
      return { $ref: item11.path.join("/") };
    case "relative":
      return { $ref: getRelativePath(refs.currentPath, item11.path) };
    case "none":
    case "seen": {
      if (item11.path.length < refs.currentPath.length && item11.path.every((value, index) => refs.currentPath[index] === value)) {
        console.warn(
          "Recursive reference detected at ".concat(refs.currentPath.join(
            "/"
          ), "! Defaulting to any")
        );
        return parseAnyDef();
      }
      return refs.$refStrategy === "seen" ? parseAnyDef() : void 0;
    }
  }
};
var addMeta = (def, refs, jsonSchema2) => {
  if (def.description) {
    jsonSchema2.description = def.description;
  }
  return jsonSchema2;
};
var getRefs = (options) => {
  const _options = getDefaultOptions(options);
  const currentPath = _options.name !== void 0 ? [..._options.basePath, _options.definitionPath, _options.name] : _options.basePath;
  return {
    ..._options,
    currentPath,
    propertyPath: void 0,
    seen: new Map(
      Object.entries(_options.definitions).map(([name16, def]) => [
        def._def,
        {
          def: def._def,
          path: [..._options.basePath, _options.definitionPath, name16],
          // Resolution of references will be forced even though seen, so it's ok that the schema is undefined here for now.
          jsonSchema: void 0
        }
      ])
    )
  };
};
var zodToJsonSchema = (schema, options) => {
  var _a17;
  const refs = getRefs(options);
  let definitions = typeof options === "object" && options.definitions ? Object.entries(options.definitions).reduce(
    (acc, [name24, schema2]) => {
      var _a24;
      return {
        ...acc,
        [name24]: (_a24 = parseDef(
          schema2._def,
          {
            ...refs,
            currentPath: [...refs.basePath, refs.definitionPath, name24]
          },
          true
        )) != null ? _a24 : parseAnyDef()
      };
    },
    {}
  ) : void 0;
  const name16 = typeof options === "string" ? options : (options == null ? void 0 : options.nameStrategy) === "title" ? void 0 : options == null ? void 0 : options.name;
  const main = (_a17 = parseDef(
    schema._def,
    name16 === void 0 ? refs : {
      ...refs,
      currentPath: [...refs.basePath, refs.definitionPath, name16]
    },
    false
  )) != null ? _a17 : parseAnyDef();
  const title = typeof options === "object" && options.name !== void 0 && options.nameStrategy === "title" ? options.name : void 0;
  if (title !== void 0) {
    main.title = title;
  }
  const combined = name16 === void 0 ? definitions ? {
    ...main,
    [refs.definitionPath]: definitions
  } : main : {
    $ref: [
      ...refs.$refStrategy === "relative" ? [] : refs.basePath,
      refs.definitionPath,
      name16
    ].join("/"),
    [refs.definitionPath]: {
      ...definitions,
      [name16]: main
    }
  };
  combined.$schema = "http://json-schema.org/draft-07/schema#";
  return combined;
};
var zod_to_json_schema_default = zodToJsonSchema;
function zod3Schema(zodSchema2, options) {
  var _a17;
  const useReferences = (_a17 = options == null ? void 0 : options.useReferences) != null ? _a17 : false;
  return jsonSchema(
    // defer json schema creation to avoid unnecessary computation when only validation is needed
    () => zod_to_json_schema_default(zodSchema2, {
      $refStrategy: useReferences ? "root" : "none"
    }),
    {
      validate: async (value) => {
        const result = await zodSchema2.safeParseAsync(value);
        return result.success ? { success: true, value: result.data } : { success: false, error: result.error };
      }
    }
  );
}
function zod4Schema(zodSchema2, options) {
  var _a17;
  const useReferences = (_a17 = options == null ? void 0 : options.useReferences) != null ? _a17 : false;
  return jsonSchema(
    // defer json schema creation to avoid unnecessary computation when only validation is needed
    () => toJSONSchema(zodSchema2, {
      target: "draft-7",
      io: "output",
      reused: useReferences ? "ref" : "inline"
    }),
    {
      validate: async (value) => {
        const result = await safeParseAsync2(zodSchema2, value);
        return result.success ? { success: true, value: result.data } : { success: false, error: result.error };
      }
    }
  );
}
function isZod4Schema(zodSchema2) {
  return "_zod" in zodSchema2;
}
function zodSchema(zodSchema2, options) {
  if (isZod4Schema(zodSchema2)) {
    return zod4Schema(zodSchema2, options);
  } else {
    return zod3Schema(zodSchema2, options);
  }
}
var schemaSymbol = Symbol.for("vercel.ai.schema");
function jsonSchema(jsonSchema2, {
  validate
} = {}) {
  return {
    [schemaSymbol]: true,
    _type: void 0,
    // should never be used directly
    [validatorSymbol]: true,
    get jsonSchema() {
      if (typeof jsonSchema2 === "function") {
        jsonSchema2 = jsonSchema2();
      }
      return jsonSchema2;
    },
    validate
  };
}
function isSchema(value) {
  return typeof value === "object" && value !== null && schemaSymbol in value && value[schemaSymbol] === true && "jsonSchema" in value && "validate" in value;
}
function asSchema(schema) {
  return schema == null ? jsonSchema({
    properties: {},
    additionalProperties: false
  }) : isSchema(schema) ? schema : typeof schema === "function" ? schema() : zodSchema(schema);
}
var { btoa, atob: atob2 } = globalThis;
function withoutTrailingSlash(url2) {
  return url2 == null ? void 0 : url2.replace(/\/$/, "");
}

// node_modules/@ai-sdk/gateway/dist/index.mjs
var import_oidc = __toESM(require_index_browser(), 1);
var import_oidc2 = __toESM(require_index_browser(), 1);
var marker15 = "vercel.ai.gateway.error";
var symbol16 = Symbol.for(marker15);
var _a15;
var _b;
var GatewayError = class _GatewayError extends (_b = Error, _a15 = symbol16, _b) {
  constructor({
    message,
    statusCode = 500,
    cause
  }) {
    super(message);
    this[_a15] = true;
    this.statusCode = statusCode;
    this.cause = cause;
  }
  /**
   * Checks if the given error is a Gateway Error.
   * @param {unknown} error - The error to check.
   * @returns {boolean} True if the error is a Gateway Error, false otherwise.
   */
  static isInstance(error40) {
    return _GatewayError.hasMarker(error40);
  }
  static hasMarker(error40) {
    return typeof error40 === "object" && error40 !== null && symbol16 in error40 && error40[symbol16] === true;
  }
};
var name14 = "GatewayAuthenticationError";
var marker22 = "vercel.ai.gateway.error.".concat(name14);
var symbol22 = Symbol.for(marker22);
var _a22;
var _b2;
var GatewayAuthenticationError = class _GatewayAuthenticationError extends (_b2 = GatewayError, _a22 = symbol22, _b2) {
  constructor({
    message = "Authentication failed",
    statusCode = 401,
    cause
  } = {}) {
    super({ message, statusCode, cause });
    this[_a22] = true;
    this.name = name14;
    this.type = "authentication_error";
  }
  static isInstance(error40) {
    return GatewayError.hasMarker(error40) && symbol22 in error40;
  }
  /**
   * Creates a contextual error message when authentication fails
   */
  static createContextualError({
    apiKeyProvided,
    oidcTokenProvided,
    message = "Authentication failed",
    statusCode = 401,
    cause
  }) {
    let contextualMessage;
    if (apiKeyProvided) {
      contextualMessage = "AI Gateway authentication failed: Invalid API key.\n\nCreate a new API key: https://vercel.com/d?to=%2F%5Bteam%5D%2F%7E%2Fai%2Fapi-keys\n\nProvide via 'apiKey' option or 'AI_GATEWAY_API_KEY' environment variable.";
    } else if (oidcTokenProvided) {
      contextualMessage = "AI Gateway authentication failed: Invalid OIDC token.\n\nRun 'npx vercel link' to link your project, then 'vc env pull' to fetch the token.\n\nAlternatively, use an API key: https://vercel.com/d?to=%2F%5Bteam%5D%2F%7E%2Fai%2Fapi-keys";
    } else {
      contextualMessage = "AI Gateway authentication failed: No authentication provided.\n\nOption 1 - API key:\nCreate an API key: https://vercel.com/d?to=%2F%5Bteam%5D%2F%7E%2Fai%2Fapi-keys\nProvide via 'apiKey' option or 'AI_GATEWAY_API_KEY' environment variable.\n\nOption 2 - OIDC token:\nRun 'npx vercel link' to link your project, then 'vc env pull' to fetch the token.";
    }
    return new _GatewayAuthenticationError({
      message: contextualMessage,
      statusCode,
      cause
    });
  }
};
var name22 = "GatewayInvalidRequestError";
var marker32 = "vercel.ai.gateway.error.".concat(name22);
var symbol32 = Symbol.for(marker32);
var _a32;
var _b3;
var GatewayInvalidRequestError = class extends (_b3 = GatewayError, _a32 = symbol32, _b3) {
  constructor({
    message = "Invalid request",
    statusCode = 400,
    cause
  } = {}) {
    super({ message, statusCode, cause });
    this[_a32] = true;
    this.name = name22;
    this.type = "invalid_request_error";
  }
  static isInstance(error40) {
    return GatewayError.hasMarker(error40) && symbol32 in error40;
  }
};
var name32 = "GatewayRateLimitError";
var marker42 = "vercel.ai.gateway.error.".concat(name32);
var symbol42 = Symbol.for(marker42);
var _a42;
var _b4;
var GatewayRateLimitError = class extends (_b4 = GatewayError, _a42 = symbol42, _b4) {
  constructor({
    message = "Rate limit exceeded",
    statusCode = 429,
    cause
  } = {}) {
    super({ message, statusCode, cause });
    this[_a42] = true;
    this.name = name32;
    this.type = "rate_limit_exceeded";
  }
  static isInstance(error40) {
    return GatewayError.hasMarker(error40) && symbol42 in error40;
  }
};
var name42 = "GatewayModelNotFoundError";
var marker52 = "vercel.ai.gateway.error.".concat(name42);
var symbol52 = Symbol.for(marker52);
var modelNotFoundParamSchema = lazyValidator(
  () => zodSchema(
    external_exports.object({
      modelId: external_exports.string()
    })
  )
);
var _a52;
var _b5;
var GatewayModelNotFoundError = class extends (_b5 = GatewayError, _a52 = symbol52, _b5) {
  constructor({
    message = "Model not found",
    statusCode = 404,
    modelId,
    cause
  } = {}) {
    super({ message, statusCode, cause });
    this[_a52] = true;
    this.name = name42;
    this.type = "model_not_found";
    this.modelId = modelId;
  }
  static isInstance(error40) {
    return GatewayError.hasMarker(error40) && symbol52 in error40;
  }
};
var name52 = "GatewayInternalServerError";
var marker62 = "vercel.ai.gateway.error.".concat(name52);
var symbol62 = Symbol.for(marker62);
var _a62;
var _b6;
var GatewayInternalServerError = class extends (_b6 = GatewayError, _a62 = symbol62, _b6) {
  constructor({
    message = "Internal server error",
    statusCode = 500,
    cause
  } = {}) {
    super({ message, statusCode, cause });
    this[_a62] = true;
    this.name = name52;
    this.type = "internal_server_error";
  }
  static isInstance(error40) {
    return GatewayError.hasMarker(error40) && symbol62 in error40;
  }
};
var name62 = "GatewayResponseError";
var marker72 = "vercel.ai.gateway.error.".concat(name62);
var symbol72 = Symbol.for(marker72);
var _a72;
var _b7;
var GatewayResponseError = class extends (_b7 = GatewayError, _a72 = symbol72, _b7) {
  constructor({
    message = "Invalid response from Gateway",
    statusCode = 502,
    response,
    validationError,
    cause
  } = {}) {
    super({ message, statusCode, cause });
    this[_a72] = true;
    this.name = name62;
    this.type = "response_error";
    this.response = response;
    this.validationError = validationError;
  }
  static isInstance(error40) {
    return GatewayError.hasMarker(error40) && symbol72 in error40;
  }
};
async function createGatewayErrorFromResponse({
  response,
  statusCode,
  defaultMessage = "Gateway request failed",
  cause,
  authMethod
}) {
  const parseResult = await safeValidateTypes({
    value: response,
    schema: gatewayErrorResponseSchema
  });
  if (!parseResult.success) {
    return new GatewayResponseError({
      message: "Invalid error response format: ".concat(defaultMessage),
      statusCode,
      response,
      validationError: parseResult.error,
      cause
    });
  }
  const validatedResponse = parseResult.value;
  const errorType = validatedResponse.error.type;
  const message = validatedResponse.error.message;
  switch (errorType) {
    case "authentication_error":
      return GatewayAuthenticationError.createContextualError({
        apiKeyProvided: authMethod === "api-key",
        oidcTokenProvided: authMethod === "oidc",
        statusCode,
        cause
      });
    case "invalid_request_error":
      return new GatewayInvalidRequestError({ message, statusCode, cause });
    case "rate_limit_exceeded":
      return new GatewayRateLimitError({ message, statusCode, cause });
    case "model_not_found": {
      const modelResult = await safeValidateTypes({
        value: validatedResponse.error.param,
        schema: modelNotFoundParamSchema
      });
      return new GatewayModelNotFoundError({
        message,
        statusCode,
        modelId: modelResult.success ? modelResult.value.modelId : void 0,
        cause
      });
    }
    case "internal_server_error":
      return new GatewayInternalServerError({ message, statusCode, cause });
    default:
      return new GatewayInternalServerError({ message, statusCode, cause });
  }
}
var gatewayErrorResponseSchema = lazyValidator(
  () => zodSchema(
    external_exports.object({
      error: external_exports.object({
        message: external_exports.string(),
        type: external_exports.string().nullish(),
        param: external_exports.unknown().nullish(),
        code: external_exports.union([external_exports.string(), external_exports.number()]).nullish()
      })
    })
  )
);
function asGatewayError(error40, authMethod) {
  var _a83;
  if (GatewayError.isInstance(error40)) {
    return error40;
  }
  if (APICallError.isInstance(error40)) {
    return createGatewayErrorFromResponse({
      response: extractApiCallResponse(error40),
      statusCode: (_a83 = error40.statusCode) != null ? _a83 : 500,
      defaultMessage: "Gateway request failed",
      cause: error40,
      authMethod
    });
  }
  return createGatewayErrorFromResponse({
    response: {},
    statusCode: 500,
    defaultMessage: error40 instanceof Error ? "Gateway request failed: ".concat(error40.message) : "Unknown Gateway error",
    cause: error40,
    authMethod
  });
}
function extractApiCallResponse(error40) {
  if (error40.data !== void 0) {
    return error40.data;
  }
  if (error40.responseBody != null) {
    try {
      return JSON.parse(error40.responseBody);
    } catch (e4) {
      return error40.responseBody;
    }
  }
  return {};
}
var GATEWAY_AUTH_METHOD_HEADER = "ai-gateway-auth-method";
async function parseAuthMethod(headers) {
  const result = await safeValidateTypes({
    value: headers[GATEWAY_AUTH_METHOD_HEADER],
    schema: gatewayAuthMethodSchema
  });
  return result.success ? result.value : void 0;
}
var gatewayAuthMethodSchema = lazyValidator(
  () => zodSchema(external_exports.union([external_exports.literal("api-key"), external_exports.literal("oidc")]))
);
var GatewayFetchMetadata = class {
  constructor(config2) {
    this.config = config2;
  }
  async getAvailableModels() {
    try {
      const { value } = await getFromApi({
        url: "".concat(this.config.baseURL, "/config"),
        headers: await resolve(this.config.headers()),
        successfulResponseHandler: createJsonResponseHandler(
          gatewayAvailableModelsResponseSchema
        ),
        failedResponseHandler: createJsonErrorResponseHandler({
          errorSchema: external_exports.any(),
          errorToMessage: (data) => data
        }),
        fetch: this.config.fetch
      });
      return value;
    } catch (error40) {
      throw await asGatewayError(error40);
    }
  }
  async getCredits() {
    try {
      const baseUrl = new URL(this.config.baseURL);
      const { value } = await getFromApi({
        url: "".concat(baseUrl.origin, "/v1/credits"),
        headers: await resolve(this.config.headers()),
        successfulResponseHandler: createJsonResponseHandler(
          gatewayCreditsResponseSchema
        ),
        failedResponseHandler: createJsonErrorResponseHandler({
          errorSchema: external_exports.any(),
          errorToMessage: (data) => data
        }),
        fetch: this.config.fetch
      });
      return value;
    } catch (error40) {
      throw await asGatewayError(error40);
    }
  }
};
var gatewayAvailableModelsResponseSchema = lazyValidator(
  () => zodSchema(
    external_exports.object({
      models: external_exports.array(
        external_exports.object({
          id: external_exports.string(),
          name: external_exports.string(),
          description: external_exports.string().nullish(),
          pricing: external_exports.object({
            input: external_exports.string(),
            output: external_exports.string(),
            input_cache_read: external_exports.string().nullish(),
            input_cache_write: external_exports.string().nullish()
          }).transform(
            ({ input, output, input_cache_read, input_cache_write }) => ({
              input,
              output,
              ...input_cache_read ? { cachedInputTokens: input_cache_read } : {},
              ...input_cache_write ? { cacheCreationInputTokens: input_cache_write } : {}
            })
          ).nullish(),
          specification: external_exports.object({
            specificationVersion: external_exports.literal("v2"),
            provider: external_exports.string(),
            modelId: external_exports.string()
          }),
          modelType: external_exports.enum(["language", "embedding", "image"]).nullish()
        })
      )
    })
  )
);
var gatewayCreditsResponseSchema = lazyValidator(
  () => zodSchema(
    external_exports.object({
      balance: external_exports.string(),
      total_used: external_exports.string()
    }).transform(({ balance, total_used }) => ({
      balance,
      totalUsed: total_used
    }))
  )
);
var GatewayLanguageModel = class {
  constructor(modelId, config2) {
    this.modelId = modelId;
    this.config = config2;
    this.specificationVersion = "v2";
    this.supportedUrls = { "*/*": [/.*/] };
  }
  get provider() {
    return this.config.provider;
  }
  async getArgs(options) {
    const { abortSignal: _abortSignal, ...optionsWithoutSignal } = options;
    return {
      args: this.maybeEncodeFileParts(optionsWithoutSignal),
      warnings: []
    };
  }
  async doGenerate(options) {
    const { args, warnings } = await this.getArgs(options);
    const { abortSignal } = options;
    const resolvedHeaders = await resolve(this.config.headers());
    try {
      const {
        responseHeaders,
        value: responseBody,
        rawValue: rawResponse
      } = await postJsonToApi({
        url: this.getUrl(),
        headers: combineHeaders(
          resolvedHeaders,
          options.headers,
          this.getModelConfigHeaders(this.modelId, false),
          await resolve(this.config.o11yHeaders)
        ),
        body: args,
        successfulResponseHandler: createJsonResponseHandler(external_exports.any()),
        failedResponseHandler: createJsonErrorResponseHandler({
          errorSchema: external_exports.any(),
          errorToMessage: (data) => data
        }),
        ...abortSignal && { abortSignal },
        fetch: this.config.fetch
      });
      return {
        ...responseBody,
        request: { body: args },
        response: { headers: responseHeaders, body: rawResponse },
        warnings
      };
    } catch (error40) {
      throw await asGatewayError(error40, await parseAuthMethod(resolvedHeaders));
    }
  }
  async doStream(options) {
    const { args, warnings } = await this.getArgs(options);
    const { abortSignal } = options;
    const resolvedHeaders = await resolve(this.config.headers());
    try {
      const { value: response, responseHeaders } = await postJsonToApi({
        url: this.getUrl(),
        headers: combineHeaders(
          resolvedHeaders,
          options.headers,
          this.getModelConfigHeaders(this.modelId, true),
          await resolve(this.config.o11yHeaders)
        ),
        body: args,
        successfulResponseHandler: createEventSourceResponseHandler(external_exports.any()),
        failedResponseHandler: createJsonErrorResponseHandler({
          errorSchema: external_exports.any(),
          errorToMessage: (data) => data
        }),
        ...abortSignal && { abortSignal },
        fetch: this.config.fetch
      });
      return {
        stream: response.pipeThrough(
          new TransformStream({
            start(controller) {
              if (warnings.length > 0) {
                controller.enqueue({ type: "stream-start", warnings });
              }
            },
            transform(chunk2, controller) {
              if (chunk2.success) {
                const streamPart = chunk2.value;
                if (streamPart.type === "raw" && !options.includeRawChunks) {
                  return;
                }
                if (streamPart.type === "response-metadata" && streamPart.timestamp && typeof streamPart.timestamp === "string") {
                  streamPart.timestamp = new Date(streamPart.timestamp);
                }
                controller.enqueue(streamPart);
              } else {
                controller.error(
                  chunk2.error
                );
              }
            }
          })
        ),
        request: { body: args },
        response: { headers: responseHeaders }
      };
    } catch (error40) {
      throw await asGatewayError(error40, await parseAuthMethod(resolvedHeaders));
    }
  }
  isFilePart(part) {
    return part && typeof part === "object" && "type" in part && part.type === "file";
  }
  /**
   * Encodes file parts in the prompt to base64. Mutates the passed options
   * instance directly to avoid copying the file data.
   * @param options - The options to encode.
   * @returns The options with the file parts encoded.
   */
  maybeEncodeFileParts(options) {
    for (const message of options.prompt) {
      for (const part of message.content) {
        if (this.isFilePart(part)) {
          const filePart = part;
          if (filePart.data instanceof Uint8Array) {
            const buffer = Uint8Array.from(filePart.data);
            const base64Data = Buffer.from(buffer).toString("base64");
            filePart.data = new URL(
              "data:".concat(filePart.mediaType || "application/octet-stream", ";base64,").concat(base64Data)
            );
          }
        }
      }
    }
    return options;
  }
  getUrl() {
    return "".concat(this.config.baseURL, "/language-model");
  }
  getModelConfigHeaders(modelId, streaming) {
    return {
      "ai-language-model-specification-version": "2",
      "ai-language-model-id": modelId,
      "ai-language-model-streaming": String(streaming)
    };
  }
};
var GatewayEmbeddingModel = class {
  constructor(modelId, config2) {
    this.modelId = modelId;
    this.config = config2;
    this.specificationVersion = "v2";
    this.maxEmbeddingsPerCall = 2048;
    this.supportsParallelCalls = true;
  }
  get provider() {
    return this.config.provider;
  }
  async doEmbed({
    values,
    headers,
    abortSignal,
    providerOptions
  }) {
    var _a83;
    const resolvedHeaders = await resolve(this.config.headers());
    try {
      const {
        responseHeaders,
        value: responseBody,
        rawValue
      } = await postJsonToApi({
        url: this.getUrl(),
        headers: combineHeaders(
          resolvedHeaders,
          headers != null ? headers : {},
          this.getModelConfigHeaders(),
          await resolve(this.config.o11yHeaders)
        ),
        body: {
          input: values.length === 1 ? values[0] : values,
          ...providerOptions ? { providerOptions } : {}
        },
        successfulResponseHandler: createJsonResponseHandler(
          gatewayEmbeddingResponseSchema
        ),
        failedResponseHandler: createJsonErrorResponseHandler({
          errorSchema: external_exports.any(),
          errorToMessage: (data) => data
        }),
        ...abortSignal && { abortSignal },
        fetch: this.config.fetch
      });
      return {
        embeddings: responseBody.embeddings,
        usage: (_a83 = responseBody.usage) != null ? _a83 : void 0,
        providerMetadata: responseBody.providerMetadata,
        response: { headers: responseHeaders, body: rawValue }
      };
    } catch (error40) {
      throw await asGatewayError(error40, await parseAuthMethod(resolvedHeaders));
    }
  }
  getUrl() {
    return "".concat(this.config.baseURL, "/embedding-model");
  }
  getModelConfigHeaders() {
    return {
      "ai-embedding-model-specification-version": "2",
      "ai-model-id": this.modelId
    };
  }
};
var gatewayEmbeddingResponseSchema = lazyValidator(
  () => zodSchema(
    external_exports.object({
      embeddings: external_exports.array(external_exports.array(external_exports.number())),
      usage: external_exports.object({ tokens: external_exports.number() }).nullish(),
      providerMetadata: external_exports.record(external_exports.string(), external_exports.record(external_exports.string(), external_exports.unknown())).optional()
    })
  )
);
async function getVercelRequestId() {
  var _a83;
  return (_a83 = (0, import_oidc.getContext)().headers) == null ? void 0 : _a83["x-vercel-id"];
}
var VERSION2 = true ? "2.0.4" : "0.0.0-test";
var AI_GATEWAY_PROTOCOL_VERSION = "0.0.1";
function createGatewayProvider(options = {}) {
  var _a83, _b8;
  let pendingMetadata = null;
  let metadataCache = null;
  const cacheRefreshMillis = (_a83 = options.metadataCacheRefreshMillis) != null ? _a83 : 1e3 * 60 * 5;
  let lastFetchTime = 0;
  const baseURL = (_b8 = withoutTrailingSlash(options.baseURL)) != null ? _b8 : "https://ai-gateway.vercel.sh/v1/ai";
  const getHeaders = async () => {
    const auth = await getGatewayAuthToken(options);
    if (auth) {
      return withUserAgentSuffix(
        {
          Authorization: "Bearer ".concat(auth.token),
          "ai-gateway-protocol-version": AI_GATEWAY_PROTOCOL_VERSION,
          [GATEWAY_AUTH_METHOD_HEADER]: auth.authMethod,
          ...options.headers
        },
        "ai-sdk/gateway/".concat(VERSION2)
      );
    }
    throw GatewayAuthenticationError.createContextualError({
      apiKeyProvided: false,
      oidcTokenProvided: false,
      statusCode: 401
    });
  };
  const createO11yHeaders = () => {
    const deploymentId = loadOptionalSetting({
      settingValue: void 0,
      environmentVariableName: "VERCEL_DEPLOYMENT_ID"
    });
    const environment = loadOptionalSetting({
      settingValue: void 0,
      environmentVariableName: "VERCEL_ENV"
    });
    const region = loadOptionalSetting({
      settingValue: void 0,
      environmentVariableName: "VERCEL_REGION"
    });
    return async () => {
      const requestId = await getVercelRequestId();
      return {
        ...deploymentId && { "ai-o11y-deployment-id": deploymentId },
        ...environment && { "ai-o11y-environment": environment },
        ...region && { "ai-o11y-region": region },
        ...requestId && { "ai-o11y-request-id": requestId }
      };
    };
  };
  const createLanguageModel = (modelId) => {
    return new GatewayLanguageModel(modelId, {
      provider: "gateway",
      baseURL,
      headers: getHeaders,
      fetch: options.fetch,
      o11yHeaders: createO11yHeaders()
    });
  };
  const getAvailableModels = async () => {
    var _a93, _b9, _c;
    const now = (_c = (_b9 = (_a93 = options._internal) == null ? void 0 : _a93.currentDate) == null ? void 0 : _b9.call(_a93).getTime()) != null ? _c : Date.now();
    if (!pendingMetadata || now - lastFetchTime > cacheRefreshMillis) {
      lastFetchTime = now;
      pendingMetadata = new GatewayFetchMetadata({
        baseURL,
        headers: getHeaders,
        fetch: options.fetch
      }).getAvailableModels().then((metadata) => {
        metadataCache = metadata;
        return metadata;
      }).catch(async (error40) => {
        throw await asGatewayError(
          error40,
          await parseAuthMethod(await getHeaders())
        );
      });
    }
    return metadataCache ? Promise.resolve(metadataCache) : pendingMetadata;
  };
  const getCredits = async () => {
    return new GatewayFetchMetadata({
      baseURL,
      headers: getHeaders,
      fetch: options.fetch
    }).getCredits().catch(async (error40) => {
      throw await asGatewayError(
        error40,
        await parseAuthMethod(await getHeaders())
      );
    });
  };
  const provider = function(modelId) {
    if (new.target) {
      throw new Error(
        "The Gateway Provider model function cannot be called with the new keyword."
      );
    }
    return createLanguageModel(modelId);
  };
  provider.getAvailableModels = getAvailableModels;
  provider.getCredits = getCredits;
  provider.imageModel = (modelId) => {
    throw new NoSuchModelError({ modelId, modelType: "imageModel" });
  };
  provider.languageModel = createLanguageModel;
  provider.textEmbeddingModel = (modelId) => {
    return new GatewayEmbeddingModel(modelId, {
      provider: "gateway",
      baseURL,
      headers: getHeaders,
      fetch: options.fetch,
      o11yHeaders: createO11yHeaders()
    });
  };
  return provider;
}
var gateway = createGatewayProvider();
async function getGatewayAuthToken(options) {
  const apiKey = loadOptionalSetting({
    settingValue: options.apiKey,
    environmentVariableName: "AI_GATEWAY_API_KEY"
  });
  if (apiKey) {
    return {
      token: apiKey,
      authMethod: "api-key"
    };
  }
  try {
    const oidcToken = await (0, import_oidc2.getVercelOidcToken)();
    return {
      token: oidcToken,
      authMethod: "oidc"
    };
  } catch (e4) {
    return null;
  }
}

// node_modules/ai/dist/index.mjs
var __defProp = Object.defineProperty;
var __export2 = (target, all) => {
  for (var name16 in all)
    __defProp(target, name16, { get: all[name16], enumerable: true });
};
var name15 = "AI_NoOutputSpecifiedError";
var marker16 = "vercel.ai.error.".concat(name15);
var symbol17 = Symbol.for(marker16);
var _a16;
_a16 = symbol17;
var name23 = "AI_InvalidArgumentError";
var marker23 = "vercel.ai.error.".concat(name23);
var symbol23 = Symbol.for(marker23);
var _a23;
_a23 = symbol23;
var name33 = "AI_InvalidStreamPartError";
var marker33 = "vercel.ai.error.".concat(name33);
var symbol33 = Symbol.for(marker33);
var _a33;
_a33 = symbol33;
var name43 = "AI_InvalidToolInputError";
var marker43 = "vercel.ai.error.".concat(name43);
var symbol43 = Symbol.for(marker43);
var _a43;
_a43 = symbol43;
var name53 = "AI_NoImageGeneratedError";
var marker53 = "vercel.ai.error.".concat(name53);
var symbol53 = Symbol.for(marker53);
var _a53;
_a53 = symbol53;
var name63 = "AI_NoObjectGeneratedError";
var marker63 = "vercel.ai.error.".concat(name63);
var symbol63 = Symbol.for(marker63);
var _a63;
var NoObjectGeneratedError = class extends AISDKError {
  constructor({
    message = "No object generated.",
    cause,
    text: text22,
    response,
    usage,
    finishReason
  }) {
    super({ name: name63, message, cause });
    this[_a63] = true;
    this.text = text22;
    this.response = response;
    this.usage = usage;
    this.finishReason = finishReason;
  }
  static isInstance(error40) {
    return AISDKError.hasMarker(error40, marker63);
  }
};
_a63 = symbol63;
var name72 = "AI_NoOutputGeneratedError";
var marker73 = "vercel.ai.error.".concat(name72);
var symbol73 = Symbol.for(marker73);
var _a73;
_a73 = symbol73;
var name82 = "AI_NoSuchToolError";
var marker82 = "vercel.ai.error.".concat(name82);
var symbol82 = Symbol.for(marker82);
var _a82;
_a82 = symbol82;
var name92 = "AI_ToolCallRepairError";
var marker92 = "vercel.ai.error.".concat(name92);
var symbol92 = Symbol.for(marker92);
var _a92;
_a92 = symbol92;
var name102 = "AI_InvalidDataContentError";
var marker102 = "vercel.ai.error.".concat(name102);
var symbol102 = Symbol.for(marker102);
var _a102;
_a102 = symbol102;
var name112 = "AI_InvalidMessageRoleError";
var marker112 = "vercel.ai.error.".concat(name112);
var symbol112 = Symbol.for(marker112);
var _a112;
_a112 = symbol112;
var name122 = "AI_MessageConversionError";
var marker122 = "vercel.ai.error.".concat(name122);
var symbol122 = Symbol.for(marker122);
var _a122;
_a122 = symbol122;
var name132 = "AI_DownloadError";
var marker132 = "vercel.ai.error.".concat(name132);
var symbol132 = Symbol.for(marker132);
var _a132;
_a132 = symbol132;
var name142 = "AI_RetryError";
var marker142 = "vercel.ai.error.".concat(name142);
var symbol142 = Symbol.for(marker142);
var _a142;
_a142 = symbol142;
var VERSION3 = true ? "5.0.84" : "0.0.0-test";
var dataContentSchema = external_exports.union([
  external_exports.string(),
  external_exports.instanceof(Uint8Array),
  external_exports.instanceof(ArrayBuffer),
  external_exports.custom(
    // Buffer might not be available in some environments such as CloudFlare:
    (value) => {
      var _a162, _b8;
      return (_b8 = (_a162 = globalThis.Buffer) == null ? void 0 : _a162.isBuffer(value)) != null ? _b8 : false;
    },
    { message: "Must be a Buffer" }
  )
]);
var jsonValueSchema = external_exports.lazy(
  () => external_exports.union([
    external_exports.null(),
    external_exports.string(),
    external_exports.number(),
    external_exports.boolean(),
    external_exports.record(external_exports.string(), jsonValueSchema),
    external_exports.array(jsonValueSchema)
  ])
);
var providerMetadataSchema = external_exports.record(
  external_exports.string(),
  external_exports.record(external_exports.string(), jsonValueSchema)
);
var textPartSchema = external_exports.object({
  type: external_exports.literal("text"),
  text: external_exports.string(),
  providerOptions: providerMetadataSchema.optional()
});
var imagePartSchema = external_exports.object({
  type: external_exports.literal("image"),
  image: external_exports.union([dataContentSchema, external_exports.instanceof(URL)]),
  mediaType: external_exports.string().optional(),
  providerOptions: providerMetadataSchema.optional()
});
var filePartSchema = external_exports.object({
  type: external_exports.literal("file"),
  data: external_exports.union([dataContentSchema, external_exports.instanceof(URL)]),
  filename: external_exports.string().optional(),
  mediaType: external_exports.string(),
  providerOptions: providerMetadataSchema.optional()
});
var reasoningPartSchema = external_exports.object({
  type: external_exports.literal("reasoning"),
  text: external_exports.string(),
  providerOptions: providerMetadataSchema.optional()
});
var toolCallPartSchema = external_exports.object({
  type: external_exports.literal("tool-call"),
  toolCallId: external_exports.string(),
  toolName: external_exports.string(),
  input: external_exports.unknown(),
  providerOptions: providerMetadataSchema.optional(),
  providerExecuted: external_exports.boolean().optional()
});
var outputSchema = external_exports.discriminatedUnion("type", [
  external_exports.object({
    type: external_exports.literal("text"),
    value: external_exports.string()
  }),
  external_exports.object({
    type: external_exports.literal("json"),
    value: jsonValueSchema
  }),
  external_exports.object({
    type: external_exports.literal("error-text"),
    value: external_exports.string()
  }),
  external_exports.object({
    type: external_exports.literal("error-json"),
    value: jsonValueSchema
  }),
  external_exports.object({
    type: external_exports.literal("content"),
    value: external_exports.array(
      external_exports.union([
        external_exports.object({
          type: external_exports.literal("text"),
          text: external_exports.string()
        }),
        external_exports.object({
          type: external_exports.literal("media"),
          data: external_exports.string(),
          mediaType: external_exports.string()
        })
      ])
    )
  })
]);
var toolResultPartSchema = external_exports.object({
  type: external_exports.literal("tool-result"),
  toolCallId: external_exports.string(),
  toolName: external_exports.string(),
  output: outputSchema,
  providerOptions: providerMetadataSchema.optional()
});
var systemModelMessageSchema = external_exports.object(
  {
    role: external_exports.literal("system"),
    content: external_exports.string(),
    providerOptions: providerMetadataSchema.optional()
  }
);
var userModelMessageSchema = external_exports.object({
  role: external_exports.literal("user"),
  content: external_exports.union([
    external_exports.string(),
    external_exports.array(external_exports.union([textPartSchema, imagePartSchema, filePartSchema]))
  ]),
  providerOptions: providerMetadataSchema.optional()
});
var assistantModelMessageSchema = external_exports.object({
  role: external_exports.literal("assistant"),
  content: external_exports.union([
    external_exports.string(),
    external_exports.array(
      external_exports.union([
        textPartSchema,
        filePartSchema,
        reasoningPartSchema,
        toolCallPartSchema,
        toolResultPartSchema
      ])
    )
  ]),
  providerOptions: providerMetadataSchema.optional()
});
var toolModelMessageSchema = external_exports.object({
  role: external_exports.literal("tool"),
  content: external_exports.array(toolResultPartSchema),
  providerOptions: providerMetadataSchema.optional()
});
var modelMessageSchema = external_exports.union([
  systemModelMessageSchema,
  userModelMessageSchema,
  assistantModelMessageSchema,
  toolModelMessageSchema
]);
var originalGenerateId = createIdGenerator({
  prefix: "aitxt",
  size: 24
});
var JsonToSseTransformStream = class extends TransformStream {
  constructor() {
    super({
      transform(part, controller) {
        controller.enqueue("data: ".concat(JSON.stringify(part), "\n\n"));
      },
      flush(controller) {
        controller.enqueue("data: [DONE]\n\n");
      }
    });
  }
};
var uiMessageChunkSchema = lazyValidator(
  () => zodSchema(
    external_exports.union([
      external_exports.strictObject({
        type: external_exports.literal("text-start"),
        id: external_exports.string(),
        providerMetadata: providerMetadataSchema.optional()
      }),
      external_exports.strictObject({
        type: external_exports.literal("text-delta"),
        id: external_exports.string(),
        delta: external_exports.string(),
        providerMetadata: providerMetadataSchema.optional()
      }),
      external_exports.strictObject({
        type: external_exports.literal("text-end"),
        id: external_exports.string(),
        providerMetadata: providerMetadataSchema.optional()
      }),
      external_exports.strictObject({
        type: external_exports.literal("error"),
        errorText: external_exports.string()
      }),
      external_exports.strictObject({
        type: external_exports.literal("tool-input-start"),
        toolCallId: external_exports.string(),
        toolName: external_exports.string(),
        providerExecuted: external_exports.boolean().optional(),
        dynamic: external_exports.boolean().optional()
      }),
      external_exports.strictObject({
        type: external_exports.literal("tool-input-delta"),
        toolCallId: external_exports.string(),
        inputTextDelta: external_exports.string()
      }),
      external_exports.strictObject({
        type: external_exports.literal("tool-input-available"),
        toolCallId: external_exports.string(),
        toolName: external_exports.string(),
        input: external_exports.unknown(),
        providerExecuted: external_exports.boolean().optional(),
        providerMetadata: providerMetadataSchema.optional(),
        dynamic: external_exports.boolean().optional()
      }),
      external_exports.strictObject({
        type: external_exports.literal("tool-input-error"),
        toolCallId: external_exports.string(),
        toolName: external_exports.string(),
        input: external_exports.unknown(),
        providerExecuted: external_exports.boolean().optional(),
        providerMetadata: providerMetadataSchema.optional(),
        dynamic: external_exports.boolean().optional(),
        errorText: external_exports.string()
      }),
      external_exports.strictObject({
        type: external_exports.literal("tool-output-available"),
        toolCallId: external_exports.string(),
        output: external_exports.unknown(),
        providerExecuted: external_exports.boolean().optional(),
        dynamic: external_exports.boolean().optional(),
        preliminary: external_exports.boolean().optional()
      }),
      external_exports.strictObject({
        type: external_exports.literal("tool-output-error"),
        toolCallId: external_exports.string(),
        errorText: external_exports.string(),
        providerExecuted: external_exports.boolean().optional(),
        dynamic: external_exports.boolean().optional()
      }),
      external_exports.strictObject({
        type: external_exports.literal("reasoning-start"),
        id: external_exports.string(),
        providerMetadata: providerMetadataSchema.optional()
      }),
      external_exports.strictObject({
        type: external_exports.literal("reasoning-delta"),
        id: external_exports.string(),
        delta: external_exports.string(),
        providerMetadata: providerMetadataSchema.optional()
      }),
      external_exports.strictObject({
        type: external_exports.literal("reasoning-end"),
        id: external_exports.string(),
        providerMetadata: providerMetadataSchema.optional()
      }),
      external_exports.strictObject({
        type: external_exports.literal("source-url"),
        sourceId: external_exports.string(),
        url: external_exports.string(),
        title: external_exports.string().optional(),
        providerMetadata: providerMetadataSchema.optional()
      }),
      external_exports.strictObject({
        type: external_exports.literal("source-document"),
        sourceId: external_exports.string(),
        mediaType: external_exports.string(),
        title: external_exports.string(),
        filename: external_exports.string().optional(),
        providerMetadata: providerMetadataSchema.optional()
      }),
      external_exports.strictObject({
        type: external_exports.literal("file"),
        url: external_exports.string(),
        mediaType: external_exports.string(),
        providerMetadata: providerMetadataSchema.optional()
      }),
      external_exports.strictObject({
        type: external_exports.custom(
          (value) => typeof value === "string" && value.startsWith("data-"),
          { message: 'Type must start with "data-"' }
        ),
        id: external_exports.string().optional(),
        data: external_exports.unknown(),
        transient: external_exports.boolean().optional()
      }),
      external_exports.strictObject({
        type: external_exports.literal("start-step")
      }),
      external_exports.strictObject({
        type: external_exports.literal("finish-step")
      }),
      external_exports.strictObject({
        type: external_exports.literal("start"),
        messageId: external_exports.string().optional(),
        messageMetadata: external_exports.unknown().optional()
      }),
      external_exports.strictObject({
        type: external_exports.literal("finish"),
        messageMetadata: external_exports.unknown().optional()
      }),
      external_exports.strictObject({
        type: external_exports.literal("abort")
      }),
      external_exports.strictObject({
        type: external_exports.literal("message-metadata"),
        messageMetadata: external_exports.unknown()
      })
    ])
  )
);
function isDataUIMessageChunk(chunk2) {
  return chunk2.type.startsWith("data-");
}
function mergeObjects(base, overrides) {
  if (base === void 0 && overrides === void 0) {
    return void 0;
  }
  if (base === void 0) {
    return overrides;
  }
  if (overrides === void 0) {
    return base;
  }
  const result = { ...base };
  for (const key2 in overrides) {
    if (Object.prototype.hasOwnProperty.call(overrides, key2)) {
      const overridesValue = overrides[key2];
      if (overridesValue === void 0)
        continue;
      const baseValue = key2 in base ? base[key2] : void 0;
      const isSourceObject = overridesValue !== null && typeof overridesValue === "object" && !Array.isArray(overridesValue) && !(overridesValue instanceof Date) && !(overridesValue instanceof RegExp);
      const isTargetObject = baseValue !== null && baseValue !== void 0 && typeof baseValue === "object" && !Array.isArray(baseValue) && !(baseValue instanceof Date) && !(baseValue instanceof RegExp);
      if (isSourceObject && isTargetObject) {
        result[key2] = mergeObjects(
          baseValue,
          overridesValue
        );
      } else {
        result[key2] = overridesValue;
      }
    }
  }
  return result;
}
function fixJson(input) {
  const stack = ["ROOT"];
  let lastValidIndex = -1;
  let literalStart = null;
  function processValueStart(char, i4, swapState) {
    {
      switch (char) {
        case '"': {
          lastValidIndex = i4;
          stack.pop();
          stack.push(swapState);
          stack.push("INSIDE_STRING");
          break;
        }
        case "f":
        case "t":
        case "n": {
          lastValidIndex = i4;
          literalStart = i4;
          stack.pop();
          stack.push(swapState);
          stack.push("INSIDE_LITERAL");
          break;
        }
        case "-": {
          stack.pop();
          stack.push(swapState);
          stack.push("INSIDE_NUMBER");
          break;
        }
        case "0":
        case "1":
        case "2":
        case "3":
        case "4":
        case "5":
        case "6":
        case "7":
        case "8":
        case "9": {
          lastValidIndex = i4;
          stack.pop();
          stack.push(swapState);
          stack.push("INSIDE_NUMBER");
          break;
        }
        case "{": {
          lastValidIndex = i4;
          stack.pop();
          stack.push(swapState);
          stack.push("INSIDE_OBJECT_START");
          break;
        }
        case "[": {
          lastValidIndex = i4;
          stack.pop();
          stack.push(swapState);
          stack.push("INSIDE_ARRAY_START");
          break;
        }
      }
    }
  }
  function processAfterObjectValue(char, i4) {
    switch (char) {
      case ",": {
        stack.pop();
        stack.push("INSIDE_OBJECT_AFTER_COMMA");
        break;
      }
      case "}": {
        lastValidIndex = i4;
        stack.pop();
        break;
      }
    }
  }
  function processAfterArrayValue(char, i4) {
    switch (char) {
      case ",": {
        stack.pop();
        stack.push("INSIDE_ARRAY_AFTER_COMMA");
        break;
      }
      case "]": {
        lastValidIndex = i4;
        stack.pop();
        break;
      }
    }
  }
  for (let i4 = 0; i4 < input.length; i4++) {
    const char = input[i4];
    const currentState = stack[stack.length - 1];
    switch (currentState) {
      case "ROOT":
        processValueStart(char, i4, "FINISH");
        break;
      case "INSIDE_OBJECT_START": {
        switch (char) {
          case '"': {
            stack.pop();
            stack.push("INSIDE_OBJECT_KEY");
            break;
          }
          case "}": {
            lastValidIndex = i4;
            stack.pop();
            break;
          }
        }
        break;
      }
      case "INSIDE_OBJECT_AFTER_COMMA": {
        switch (char) {
          case '"': {
            stack.pop();
            stack.push("INSIDE_OBJECT_KEY");
            break;
          }
        }
        break;
      }
      case "INSIDE_OBJECT_KEY": {
        switch (char) {
          case '"': {
            stack.pop();
            stack.push("INSIDE_OBJECT_AFTER_KEY");
            break;
          }
        }
        break;
      }
      case "INSIDE_OBJECT_AFTER_KEY": {
        switch (char) {
          case ":": {
            stack.pop();
            stack.push("INSIDE_OBJECT_BEFORE_VALUE");
            break;
          }
        }
        break;
      }
      case "INSIDE_OBJECT_BEFORE_VALUE": {
        processValueStart(char, i4, "INSIDE_OBJECT_AFTER_VALUE");
        break;
      }
      case "INSIDE_OBJECT_AFTER_VALUE": {
        processAfterObjectValue(char, i4);
        break;
      }
      case "INSIDE_STRING": {
        switch (char) {
          case '"': {
            stack.pop();
            lastValidIndex = i4;
            break;
          }
          case "\\": {
            stack.push("INSIDE_STRING_ESCAPE");
            break;
          }
          default: {
            lastValidIndex = i4;
          }
        }
        break;
      }
      case "INSIDE_ARRAY_START": {
        switch (char) {
          case "]": {
            lastValidIndex = i4;
            stack.pop();
            break;
          }
          default: {
            lastValidIndex = i4;
            processValueStart(char, i4, "INSIDE_ARRAY_AFTER_VALUE");
            break;
          }
        }
        break;
      }
      case "INSIDE_ARRAY_AFTER_VALUE": {
        switch (char) {
          case ",": {
            stack.pop();
            stack.push("INSIDE_ARRAY_AFTER_COMMA");
            break;
          }
          case "]": {
            lastValidIndex = i4;
            stack.pop();
            break;
          }
          default: {
            lastValidIndex = i4;
            break;
          }
        }
        break;
      }
      case "INSIDE_ARRAY_AFTER_COMMA": {
        processValueStart(char, i4, "INSIDE_ARRAY_AFTER_VALUE");
        break;
      }
      case "INSIDE_STRING_ESCAPE": {
        stack.pop();
        lastValidIndex = i4;
        break;
      }
      case "INSIDE_NUMBER": {
        switch (char) {
          case "0":
          case "1":
          case "2":
          case "3":
          case "4":
          case "5":
          case "6":
          case "7":
          case "8":
          case "9": {
            lastValidIndex = i4;
            break;
          }
          case "e":
          case "E":
          case "-":
          case ".": {
            break;
          }
          case ",": {
            stack.pop();
            if (stack[stack.length - 1] === "INSIDE_ARRAY_AFTER_VALUE") {
              processAfterArrayValue(char, i4);
            }
            if (stack[stack.length - 1] === "INSIDE_OBJECT_AFTER_VALUE") {
              processAfterObjectValue(char, i4);
            }
            break;
          }
          case "}": {
            stack.pop();
            if (stack[stack.length - 1] === "INSIDE_OBJECT_AFTER_VALUE") {
              processAfterObjectValue(char, i4);
            }
            break;
          }
          case "]": {
            stack.pop();
            if (stack[stack.length - 1] === "INSIDE_ARRAY_AFTER_VALUE") {
              processAfterArrayValue(char, i4);
            }
            break;
          }
          default: {
            stack.pop();
            break;
          }
        }
        break;
      }
      case "INSIDE_LITERAL": {
        const partialLiteral = input.substring(literalStart, i4 + 1);
        if (!"false".startsWith(partialLiteral) && !"true".startsWith(partialLiteral) && !"null".startsWith(partialLiteral)) {
          stack.pop();
          if (stack[stack.length - 1] === "INSIDE_OBJECT_AFTER_VALUE") {
            processAfterObjectValue(char, i4);
          } else if (stack[stack.length - 1] === "INSIDE_ARRAY_AFTER_VALUE") {
            processAfterArrayValue(char, i4);
          }
        } else {
          lastValidIndex = i4;
        }
        break;
      }
    }
  }
  let result = input.slice(0, lastValidIndex + 1);
  for (let i4 = stack.length - 1; i4 >= 0; i4--) {
    const state = stack[i4];
    switch (state) {
      case "INSIDE_STRING": {
        result += '"';
        break;
      }
      case "INSIDE_OBJECT_KEY":
      case "INSIDE_OBJECT_AFTER_KEY":
      case "INSIDE_OBJECT_AFTER_COMMA":
      case "INSIDE_OBJECT_START":
      case "INSIDE_OBJECT_BEFORE_VALUE":
      case "INSIDE_OBJECT_AFTER_VALUE": {
        result += "}";
        break;
      }
      case "INSIDE_ARRAY_START":
      case "INSIDE_ARRAY_AFTER_COMMA":
      case "INSIDE_ARRAY_AFTER_VALUE": {
        result += "]";
        break;
      }
      case "INSIDE_LITERAL": {
        const partialLiteral = input.substring(literalStart, input.length);
        if ("true".startsWith(partialLiteral)) {
          result += "true".slice(partialLiteral.length);
        } else if ("false".startsWith(partialLiteral)) {
          result += "false".slice(partialLiteral.length);
        } else if ("null".startsWith(partialLiteral)) {
          result += "null".slice(partialLiteral.length);
        }
      }
    }
  }
  return result;
}
async function parsePartialJson(jsonText) {
  if (jsonText === void 0) {
    return { value: void 0, state: "undefined-input" };
  }
  let result = await safeParseJSON({ text: jsonText });
  if (result.success) {
    return { value: result.value, state: "successful-parse" };
  }
  result = await safeParseJSON({ text: fixJson(jsonText) });
  if (result.success) {
    return { value: result.value, state: "repaired-parse" };
  }
  return { value: void 0, state: "failed-parse" };
}
function isToolUIPart(part) {
  return part.type.startsWith("tool-");
}
function isDynamicToolUIPart(part) {
  return part.type === "dynamic-tool";
}
function isToolOrDynamicToolUIPart(part) {
  return isToolUIPart(part) || isDynamicToolUIPart(part);
}
function getToolName(part) {
  return part.type.split("-").slice(1).join("-");
}
function createStreamingUIMessageState({
  lastMessage,
  messageId
}) {
  return {
    message: (lastMessage == null ? void 0 : lastMessage.role) === "assistant" ? lastMessage : {
      id: messageId,
      metadata: void 0,
      role: "assistant",
      parts: []
    },
    activeTextParts: {},
    activeReasoningParts: {},
    partialToolCalls: {}
  };
}
function processUIMessageStream({
  stream,
  messageMetadataSchema,
  dataPartSchemas,
  runUpdateMessageJob,
  onError,
  onToolCall,
  onData
}) {
  return stream.pipeThrough(
    new TransformStream({
      async transform(chunk2, controller) {
        await runUpdateMessageJob(async ({ state, write }) => {
          var _a162, _b8, _c, _d;
          function getToolInvocation(toolCallId) {
            const toolInvocations = state.message.parts.filter(isToolUIPart);
            const toolInvocation = toolInvocations.find(
              (invocation) => invocation.toolCallId === toolCallId
            );
            if (toolInvocation == null) {
              throw new Error(
                "tool-output-error must be preceded by a tool-input-available"
              );
            }
            return toolInvocation;
          }
          function getDynamicToolInvocation(toolCallId) {
            const toolInvocations = state.message.parts.filter(
              (part) => part.type === "dynamic-tool"
            );
            const toolInvocation = toolInvocations.find(
              (invocation) => invocation.toolCallId === toolCallId
            );
            if (toolInvocation == null) {
              throw new Error(
                "tool-output-error must be preceded by a tool-input-available"
              );
            }
            return toolInvocation;
          }
          function updateToolPart(options) {
            var _a17;
            const part = state.message.parts.find(
              (part2) => isToolUIPart(part2) && part2.toolCallId === options.toolCallId
            );
            const anyOptions = options;
            const anyPart = part;
            if (part != null) {
              part.state = options.state;
              anyPart.input = anyOptions.input;
              anyPart.output = anyOptions.output;
              anyPart.errorText = anyOptions.errorText;
              anyPart.rawInput = anyOptions.rawInput;
              anyPart.preliminary = anyOptions.preliminary;
              anyPart.providerExecuted = (_a17 = anyOptions.providerExecuted) != null ? _a17 : part.providerExecuted;
              if (anyOptions.providerMetadata != null && part.state === "input-available") {
                part.callProviderMetadata = anyOptions.providerMetadata;
              }
            } else {
              state.message.parts.push({
                type: "tool-".concat(options.toolName),
                toolCallId: options.toolCallId,
                state: options.state,
                input: anyOptions.input,
                output: anyOptions.output,
                rawInput: anyOptions.rawInput,
                errorText: anyOptions.errorText,
                providerExecuted: anyOptions.providerExecuted,
                preliminary: anyOptions.preliminary,
                ...anyOptions.providerMetadata != null ? { callProviderMetadata: anyOptions.providerMetadata } : {}
              });
            }
          }
          function updateDynamicToolPart(options) {
            var _a17;
            const part = state.message.parts.find(
              (part2) => part2.type === "dynamic-tool" && part2.toolCallId === options.toolCallId
            );
            const anyOptions = options;
            const anyPart = part;
            if (part != null) {
              part.state = options.state;
              anyPart.toolName = options.toolName;
              anyPart.input = anyOptions.input;
              anyPart.output = anyOptions.output;
              anyPart.errorText = anyOptions.errorText;
              anyPart.rawInput = (_a17 = anyOptions.rawInput) != null ? _a17 : anyPart.rawInput;
              anyPart.preliminary = anyOptions.preliminary;
              if (anyOptions.providerMetadata != null && part.state === "input-available") {
                part.callProviderMetadata = anyOptions.providerMetadata;
              }
            } else {
              state.message.parts.push({
                type: "dynamic-tool",
                toolName: options.toolName,
                toolCallId: options.toolCallId,
                state: options.state,
                input: anyOptions.input,
                output: anyOptions.output,
                errorText: anyOptions.errorText,
                preliminary: anyOptions.preliminary,
                ...anyOptions.providerMetadata != null ? { callProviderMetadata: anyOptions.providerMetadata } : {}
              });
            }
          }
          async function updateMessageMetadata(metadata) {
            if (metadata != null) {
              const mergedMetadata = state.message.metadata != null ? mergeObjects(state.message.metadata, metadata) : metadata;
              if (messageMetadataSchema != null) {
                await validateTypes({
                  value: mergedMetadata,
                  schema: messageMetadataSchema
                });
              }
              state.message.metadata = mergedMetadata;
            }
          }
          switch (chunk2.type) {
            case "text-start": {
              const textPart = {
                type: "text",
                text: "",
                providerMetadata: chunk2.providerMetadata,
                state: "streaming"
              };
              state.activeTextParts[chunk2.id] = textPart;
              state.message.parts.push(textPart);
              write();
              break;
            }
            case "text-delta": {
              const textPart = state.activeTextParts[chunk2.id];
              textPart.text += chunk2.delta;
              textPart.providerMetadata = (_a162 = chunk2.providerMetadata) != null ? _a162 : textPart.providerMetadata;
              write();
              break;
            }
            case "text-end": {
              const textPart = state.activeTextParts[chunk2.id];
              textPart.state = "done";
              textPart.providerMetadata = (_b8 = chunk2.providerMetadata) != null ? _b8 : textPart.providerMetadata;
              delete state.activeTextParts[chunk2.id];
              write();
              break;
            }
            case "reasoning-start": {
              const reasoningPart = {
                type: "reasoning",
                text: "",
                providerMetadata: chunk2.providerMetadata,
                state: "streaming"
              };
              state.activeReasoningParts[chunk2.id] = reasoningPart;
              state.message.parts.push(reasoningPart);
              write();
              break;
            }
            case "reasoning-delta": {
              const reasoningPart = state.activeReasoningParts[chunk2.id];
              reasoningPart.text += chunk2.delta;
              reasoningPart.providerMetadata = (_c = chunk2.providerMetadata) != null ? _c : reasoningPart.providerMetadata;
              write();
              break;
            }
            case "reasoning-end": {
              const reasoningPart = state.activeReasoningParts[chunk2.id];
              reasoningPart.providerMetadata = (_d = chunk2.providerMetadata) != null ? _d : reasoningPart.providerMetadata;
              reasoningPart.state = "done";
              delete state.activeReasoningParts[chunk2.id];
              write();
              break;
            }
            case "file": {
              state.message.parts.push({
                type: "file",
                mediaType: chunk2.mediaType,
                url: chunk2.url
              });
              write();
              break;
            }
            case "source-url": {
              state.message.parts.push({
                type: "source-url",
                sourceId: chunk2.sourceId,
                url: chunk2.url,
                title: chunk2.title,
                providerMetadata: chunk2.providerMetadata
              });
              write();
              break;
            }
            case "source-document": {
              state.message.parts.push({
                type: "source-document",
                sourceId: chunk2.sourceId,
                mediaType: chunk2.mediaType,
                title: chunk2.title,
                filename: chunk2.filename,
                providerMetadata: chunk2.providerMetadata
              });
              write();
              break;
            }
            case "tool-input-start": {
              const toolInvocations = state.message.parts.filter(isToolUIPart);
              state.partialToolCalls[chunk2.toolCallId] = {
                text: "",
                toolName: chunk2.toolName,
                index: toolInvocations.length,
                dynamic: chunk2.dynamic
              };
              if (chunk2.dynamic) {
                updateDynamicToolPart({
                  toolCallId: chunk2.toolCallId,
                  toolName: chunk2.toolName,
                  state: "input-streaming",
                  input: void 0
                });
              } else {
                updateToolPart({
                  toolCallId: chunk2.toolCallId,
                  toolName: chunk2.toolName,
                  state: "input-streaming",
                  input: void 0,
                  providerExecuted: chunk2.providerExecuted
                });
              }
              write();
              break;
            }
            case "tool-input-delta": {
              const partialToolCall = state.partialToolCalls[chunk2.toolCallId];
              partialToolCall.text += chunk2.inputTextDelta;
              const { value: partialArgs } = await parsePartialJson(
                partialToolCall.text
              );
              if (partialToolCall.dynamic) {
                updateDynamicToolPart({
                  toolCallId: chunk2.toolCallId,
                  toolName: partialToolCall.toolName,
                  state: "input-streaming",
                  input: partialArgs
                });
              } else {
                updateToolPart({
                  toolCallId: chunk2.toolCallId,
                  toolName: partialToolCall.toolName,
                  state: "input-streaming",
                  input: partialArgs
                });
              }
              write();
              break;
            }
            case "tool-input-available": {
              if (chunk2.dynamic) {
                updateDynamicToolPart({
                  toolCallId: chunk2.toolCallId,
                  toolName: chunk2.toolName,
                  state: "input-available",
                  input: chunk2.input,
                  providerMetadata: chunk2.providerMetadata
                });
              } else {
                updateToolPart({
                  toolCallId: chunk2.toolCallId,
                  toolName: chunk2.toolName,
                  state: "input-available",
                  input: chunk2.input,
                  providerExecuted: chunk2.providerExecuted,
                  providerMetadata: chunk2.providerMetadata
                });
              }
              write();
              if (onToolCall && !chunk2.providerExecuted) {
                await onToolCall({
                  toolCall: chunk2
                });
              }
              break;
            }
            case "tool-input-error": {
              if (chunk2.dynamic) {
                updateDynamicToolPart({
                  toolCallId: chunk2.toolCallId,
                  toolName: chunk2.toolName,
                  state: "output-error",
                  input: chunk2.input,
                  errorText: chunk2.errorText,
                  providerMetadata: chunk2.providerMetadata
                });
              } else {
                updateToolPart({
                  toolCallId: chunk2.toolCallId,
                  toolName: chunk2.toolName,
                  state: "output-error",
                  input: void 0,
                  rawInput: chunk2.input,
                  errorText: chunk2.errorText,
                  providerExecuted: chunk2.providerExecuted,
                  providerMetadata: chunk2.providerMetadata
                });
              }
              write();
              break;
            }
            case "tool-output-available": {
              if (chunk2.dynamic) {
                const toolInvocation = getDynamicToolInvocation(
                  chunk2.toolCallId
                );
                updateDynamicToolPart({
                  toolCallId: chunk2.toolCallId,
                  toolName: toolInvocation.toolName,
                  state: "output-available",
                  input: toolInvocation.input,
                  output: chunk2.output,
                  preliminary: chunk2.preliminary
                });
              } else {
                const toolInvocation = getToolInvocation(chunk2.toolCallId);
                updateToolPart({
                  toolCallId: chunk2.toolCallId,
                  toolName: getToolName(toolInvocation),
                  state: "output-available",
                  input: toolInvocation.input,
                  output: chunk2.output,
                  providerExecuted: chunk2.providerExecuted,
                  preliminary: chunk2.preliminary
                });
              }
              write();
              break;
            }
            case "tool-output-error": {
              if (chunk2.dynamic) {
                const toolInvocation = getDynamicToolInvocation(
                  chunk2.toolCallId
                );
                updateDynamicToolPart({
                  toolCallId: chunk2.toolCallId,
                  toolName: toolInvocation.toolName,
                  state: "output-error",
                  input: toolInvocation.input,
                  errorText: chunk2.errorText
                });
              } else {
                const toolInvocation = getToolInvocation(chunk2.toolCallId);
                updateToolPart({
                  toolCallId: chunk2.toolCallId,
                  toolName: getToolName(toolInvocation),
                  state: "output-error",
                  input: toolInvocation.input,
                  rawInput: toolInvocation.rawInput,
                  errorText: chunk2.errorText
                });
              }
              write();
              break;
            }
            case "start-step": {
              state.message.parts.push({ type: "step-start" });
              break;
            }
            case "finish-step": {
              state.activeTextParts = {};
              state.activeReasoningParts = {};
              break;
            }
            case "start": {
              if (chunk2.messageId != null) {
                state.message.id = chunk2.messageId;
              }
              await updateMessageMetadata(chunk2.messageMetadata);
              if (chunk2.messageId != null || chunk2.messageMetadata != null) {
                write();
              }
              break;
            }
            case "finish": {
              await updateMessageMetadata(chunk2.messageMetadata);
              if (chunk2.messageMetadata != null) {
                write();
              }
              break;
            }
            case "message-metadata": {
              await updateMessageMetadata(chunk2.messageMetadata);
              if (chunk2.messageMetadata != null) {
                write();
              }
              break;
            }
            case "error": {
              onError == null ? void 0 : onError(new Error(chunk2.errorText));
              break;
            }
            default: {
              if (isDataUIMessageChunk(chunk2)) {
                if ((dataPartSchemas == null ? void 0 : dataPartSchemas[chunk2.type]) != null) {
                  await validateTypes({
                    value: chunk2.data,
                    schema: dataPartSchemas[chunk2.type]
                  });
                }
                const dataChunk = chunk2;
                if (dataChunk.transient) {
                  onData == null ? void 0 : onData(dataChunk);
                  break;
                }
                const existingUIPart = dataChunk.id != null ? state.message.parts.find(
                  (chunkArg) => dataChunk.type === chunkArg.type && dataChunk.id === chunkArg.id
                ) : void 0;
                if (existingUIPart != null) {
                  existingUIPart.data = dataChunk.data;
                } else {
                  state.message.parts.push(dataChunk);
                }
                onData == null ? void 0 : onData(dataChunk);
                write();
              }
            }
          }
          controller.enqueue(chunk2);
        });
      }
    })
  );
}
async function consumeStream({
  stream,
  onError
}) {
  const reader = stream.getReader();
  try {
    while (true) {
      const { done } = await reader.read();
      if (done)
        break;
    }
  } catch (error40) {
    onError == null ? void 0 : onError(error40);
  } finally {
    reader.releaseLock();
  }
}
var originalGenerateId2 = createIdGenerator({
  prefix: "aitxt",
  size: 24
});
var originalGenerateId3 = createIdGenerator({ prefix: "aiobj", size: 24 });
var SerialJobExecutor = class {
  constructor() {
    this.queue = [];
    this.isProcessing = false;
  }
  async processQueue() {
    if (this.isProcessing) {
      return;
    }
    this.isProcessing = true;
    while (this.queue.length > 0) {
      await this.queue[0]();
      this.queue.shift();
    }
    this.isProcessing = false;
  }
  async run(job) {
    return new Promise((resolve2, reject) => {
      this.queue.push(async () => {
        try {
          await job();
          resolve2();
        } catch (error40) {
          reject(error40);
        }
      });
      void this.processQueue();
    });
  }
};
var originalGenerateId4 = createIdGenerator({ prefix: "aiobj", size: 24 });
var output_exports = {};
__export2(output_exports, {
  object: () => object2,
  text: () => text3
});
var text3 = () => ({
  type: "text",
  responseFormat: { type: "text" },
  async parsePartial({ text: text22 }) {
    return { partial: text22 };
  },
  async parseOutput({ text: text22 }) {
    return text22;
  }
});
var object2 = ({
  schema: inputSchema
}) => {
  const schema = asSchema(inputSchema);
  return {
    type: "object",
    responseFormat: {
      type: "json",
      schema: schema.jsonSchema
    },
    async parsePartial({ text: text22 }) {
      const result = await parsePartialJson(text22);
      switch (result.state) {
        case "failed-parse":
        case "undefined-input":
          return void 0;
        case "repaired-parse":
        case "successful-parse":
          return {
            // Note: currently no validation of partial results:
            partial: result.value
          };
        default: {
          const _exhaustiveCheck = result.state;
          throw new Error("Unsupported parse state: ".concat(_exhaustiveCheck));
        }
      }
    },
    async parseOutput({ text: text22 }, context) {
      const parseResult = await safeParseJSON({ text: text22 });
      if (!parseResult.success) {
        throw new NoObjectGeneratedError({
          message: "No object generated: could not parse the response.",
          cause: parseResult.error,
          text: text22,
          response: context.response,
          usage: context.usage,
          finishReason: context.finishReason
        });
      }
      const validationResult = await safeValidateTypes({
        value: parseResult.value,
        schema
      });
      if (!validationResult.success) {
        throw new NoObjectGeneratedError({
          message: "No object generated: response did not match schema.",
          cause: validationResult.error,
          text: text22,
          response: context.response,
          usage: context.usage,
          finishReason: context.finishReason
        });
      }
      return validationResult.value;
    }
  };
};
var name152 = "AI_NoSuchProviderError";
var marker152 = "vercel.ai.error.".concat(name152);
var symbol152 = Symbol.for(marker152);
var _a152;
_a152 = symbol152;
async function convertFileListToFileUIParts(files) {
  if (files == null) {
    return [];
  }
  if (!globalThis.FileList || !(files instanceof globalThis.FileList)) {
    throw new Error("FileList is not supported in the current environment");
  }
  return Promise.all(
    Array.from(files).map(async (file2) => {
      const { name: name16, type } = file2;
      const dataUrl = await new Promise((resolve2, reject) => {
        const reader = new FileReader();
        reader.onload = (readerEvent) => {
          var _a162;
          resolve2((_a162 = readerEvent.target) == null ? void 0 : _a162.result);
        };
        reader.onerror = (error40) => reject(error40);
        reader.readAsDataURL(file2);
      });
      return {
        type: "file",
        mediaType: type,
        filename: name16,
        url: dataUrl
      };
    })
  );
}
var HttpChatTransport = class {
  constructor({
    api = "/api/chat",
    credentials,
    headers,
    body,
    fetch: fetch2,
    prepareSendMessagesRequest,
    prepareReconnectToStreamRequest
  }) {
    this.api = api;
    this.credentials = credentials;
    this.headers = headers;
    this.body = body;
    this.fetch = fetch2;
    this.prepareSendMessagesRequest = prepareSendMessagesRequest;
    this.prepareReconnectToStreamRequest = prepareReconnectToStreamRequest;
  }
  async sendMessages({
    abortSignal,
    ...options
  }) {
    var _a162, _b8, _c, _d, _e2;
    const resolvedBody = await resolve(this.body);
    const resolvedHeaders = await resolve(this.headers);
    const resolvedCredentials = await resolve(this.credentials);
    const baseHeaders = {
      ...normalizeHeaders(resolvedHeaders),
      ...normalizeHeaders(options.headers)
    };
    const preparedRequest = await ((_a162 = this.prepareSendMessagesRequest) == null ? void 0 : _a162.call(this, {
      api: this.api,
      id: options.chatId,
      messages: options.messages,
      body: { ...resolvedBody, ...options.body },
      headers: baseHeaders,
      credentials: resolvedCredentials,
      requestMetadata: options.metadata,
      trigger: options.trigger,
      messageId: options.messageId
    }));
    const api = (_b8 = preparedRequest == null ? void 0 : preparedRequest.api) != null ? _b8 : this.api;
    const headers = (preparedRequest == null ? void 0 : preparedRequest.headers) !== void 0 ? normalizeHeaders(preparedRequest.headers) : baseHeaders;
    const body = (preparedRequest == null ? void 0 : preparedRequest.body) !== void 0 ? preparedRequest.body : {
      ...resolvedBody,
      ...options.body,
      id: options.chatId,
      messages: options.messages,
      trigger: options.trigger,
      messageId: options.messageId
    };
    const credentials = (_c = preparedRequest == null ? void 0 : preparedRequest.credentials) != null ? _c : resolvedCredentials;
    const fetch2 = (_d = this.fetch) != null ? _d : globalThis.fetch;
    const response = await fetch2(api, {
      method: "POST",
      headers: withUserAgentSuffix(
        {
          "Content-Type": "application/json",
          ...headers
        },
        "ai-sdk/".concat(VERSION3),
        getRuntimeEnvironmentUserAgent()
      ),
      body: JSON.stringify(body),
      credentials,
      signal: abortSignal
    });
    if (!response.ok) {
      throw new Error(
        (_e2 = await response.text()) != null ? _e2 : "Failed to fetch the chat response."
      );
    }
    if (!response.body) {
      throw new Error("The response body is empty.");
    }
    return this.processResponseStream(response.body);
  }
  async reconnectToStream(options) {
    var _a162, _b8, _c, _d, _e2;
    const resolvedBody = await resolve(this.body);
    const resolvedHeaders = await resolve(this.headers);
    const resolvedCredentials = await resolve(this.credentials);
    const baseHeaders = {
      ...normalizeHeaders(resolvedHeaders),
      ...normalizeHeaders(options.headers)
    };
    const preparedRequest = await ((_a162 = this.prepareReconnectToStreamRequest) == null ? void 0 : _a162.call(this, {
      api: this.api,
      id: options.chatId,
      body: { ...resolvedBody, ...options.body },
      headers: baseHeaders,
      credentials: resolvedCredentials,
      requestMetadata: options.metadata
    }));
    const api = (_b8 = preparedRequest == null ? void 0 : preparedRequest.api) != null ? _b8 : "".concat(this.api, "/").concat(options.chatId, "/stream");
    const headers = (preparedRequest == null ? void 0 : preparedRequest.headers) !== void 0 ? normalizeHeaders(preparedRequest.headers) : baseHeaders;
    const credentials = (_c = preparedRequest == null ? void 0 : preparedRequest.credentials) != null ? _c : resolvedCredentials;
    const fetch2 = (_d = this.fetch) != null ? _d : globalThis.fetch;
    const response = await fetch2(api, {
      method: "GET",
      headers: withUserAgentSuffix(
        headers,
        "ai-sdk/".concat(VERSION3),
        getRuntimeEnvironmentUserAgent()
      ),
      credentials
    });
    if (response.status === 204) {
      return null;
    }
    if (!response.ok) {
      throw new Error(
        (_e2 = await response.text()) != null ? _e2 : "Failed to fetch the chat response."
      );
    }
    if (!response.body) {
      throw new Error("The response body is empty.");
    }
    return this.processResponseStream(response.body);
  }
};
var DefaultChatTransport = class extends HttpChatTransport {
  constructor(options = {}) {
    super(options);
  }
  processResponseStream(stream) {
    return parseJsonEventStream({
      stream,
      schema: uiMessageChunkSchema
    }).pipeThrough(
      new TransformStream({
        async transform(chunk2, controller) {
          if (!chunk2.success) {
            throw chunk2.error;
          }
          controller.enqueue(chunk2.value);
        }
      })
    );
  }
};
var AbstractChat = class {
  constructor({
    generateId: generateId3 = generateId,
    id = generateId3(),
    transport = new DefaultChatTransport(),
    messageMetadataSchema,
    dataPartSchemas,
    state,
    onError,
    onToolCall,
    onFinish,
    onData,
    sendAutomaticallyWhen
  }) {
    this.activeResponse = void 0;
    this.jobExecutor = new SerialJobExecutor();
    this.sendMessage = async (message, options) => {
      var _a162, _b8, _c, _d;
      if (message == null) {
        await this.makeRequest({
          trigger: "submit-message",
          messageId: (_a162 = this.lastMessage) == null ? void 0 : _a162.id,
          ...options
        });
        return;
      }
      let uiMessage;
      if ("text" in message || "files" in message) {
        const fileParts = Array.isArray(message.files) ? message.files : await convertFileListToFileUIParts(message.files);
        uiMessage = {
          parts: [
            ...fileParts,
            ..."text" in message && message.text != null ? [{ type: "text", text: message.text }] : []
          ]
        };
      } else {
        uiMessage = message;
      }
      if (message.messageId != null) {
        const messageIndex = this.state.messages.findIndex(
          (m5) => m5.id === message.messageId
        );
        if (messageIndex === -1) {
          throw new Error("message with id ".concat(message.messageId, " not found"));
        }
        if (this.state.messages[messageIndex].role !== "user") {
          throw new Error(
            "message with id ".concat(message.messageId, " is not a user message")
          );
        }
        this.state.messages = this.state.messages.slice(0, messageIndex + 1);
        this.state.replaceMessage(messageIndex, {
          ...uiMessage,
          id: message.messageId,
          role: (_b8 = uiMessage.role) != null ? _b8 : "user",
          metadata: message.metadata
        });
      } else {
        this.state.pushMessage({
          ...uiMessage,
          id: (_c = uiMessage.id) != null ? _c : this.generateId(),
          role: (_d = uiMessage.role) != null ? _d : "user",
          metadata: message.metadata
        });
      }
      await this.makeRequest({
        trigger: "submit-message",
        messageId: message.messageId,
        ...options
      });
    };
    this.regenerate = async ({
      messageId,
      ...options
    } = {}) => {
      const messageIndex = messageId == null ? this.state.messages.length - 1 : this.state.messages.findIndex((message) => message.id === messageId);
      if (messageIndex === -1) {
        throw new Error("message ".concat(messageId, " not found"));
      }
      this.state.messages = this.state.messages.slice(
        0,
        // if the message is a user message, we need to include it in the request:
        this.messages[messageIndex].role === "assistant" ? messageIndex : messageIndex + 1
      );
      await this.makeRequest({
        trigger: "regenerate-message",
        messageId,
        ...options
      });
    };
    this.resumeStream = async (options = {}) => {
      await this.makeRequest({ trigger: "resume-stream", ...options });
    };
    this.clearError = () => {
      if (this.status === "error") {
        this.state.error = void 0;
        this.setStatus({ status: "ready" });
      }
    };
    this.addToolResult = async ({
      state: state2 = "output-available",
      tool: tool2,
      toolCallId,
      output,
      errorText
    }) => this.jobExecutor.run(async () => {
      var _a162, _b8;
      const messages = this.state.messages;
      const lastMessage = messages[messages.length - 1];
      this.state.replaceMessage(messages.length - 1, {
        ...lastMessage,
        parts: lastMessage.parts.map(
          (part) => isToolOrDynamicToolUIPart(part) && part.toolCallId === toolCallId ? { ...part, state: state2, output, errorText } : part
        )
      });
      if (this.activeResponse) {
        this.activeResponse.state.message.parts = this.activeResponse.state.message.parts.map(
          (part) => isToolOrDynamicToolUIPart(part) && part.toolCallId === toolCallId ? {
            ...part,
            state: state2,
            output,
            errorText
          } : part
        );
      }
      if (this.status !== "streaming" && this.status !== "submitted" && ((_a162 = this.sendAutomaticallyWhen) == null ? void 0 : _a162.call(this, { messages: this.state.messages }))) {
        this.makeRequest({
          trigger: "submit-message",
          messageId: (_b8 = this.lastMessage) == null ? void 0 : _b8.id
        });
      }
    });
    this.stop = async () => {
      var _a162;
      if (this.status !== "streaming" && this.status !== "submitted")
        return;
      if ((_a162 = this.activeResponse) == null ? void 0 : _a162.abortController) {
        this.activeResponse.abortController.abort();
      }
    };
    this.id = id;
    this.transport = transport;
    this.generateId = generateId3;
    this.messageMetadataSchema = messageMetadataSchema;
    this.dataPartSchemas = dataPartSchemas;
    this.state = state;
    this.onError = onError;
    this.onToolCall = onToolCall;
    this.onFinish = onFinish;
    this.onData = onData;
    this.sendAutomaticallyWhen = sendAutomaticallyWhen;
  }
  /**
   * Hook status:
   *
   * - `submitted`: The message has been sent to the API and we're awaiting the start of the response stream.
   * - `streaming`: The response is actively streaming in from the API, receiving chunks of data.
   * - `ready`: The full response has been received and processed; a new user message can be submitted.
   * - `error`: An error occurred during the API request, preventing successful completion.
   */
  get status() {
    return this.state.status;
  }
  setStatus({
    status: status2,
    error: error40
  }) {
    if (this.status === status2)
      return;
    this.state.status = status2;
    this.state.error = error40;
  }
  get error() {
    return this.state.error;
  }
  get messages() {
    return this.state.messages;
  }
  get lastMessage() {
    return this.state.messages[this.state.messages.length - 1];
  }
  set messages(messages) {
    this.state.messages = messages;
  }
  async makeRequest({
    trigger,
    metadata,
    headers,
    body,
    messageId
  }) {
    var _a162, _b8, _c;
    this.setStatus({ status: "submitted", error: void 0 });
    const lastMessage = this.lastMessage;
    let isAbort = false;
    let isDisconnect = false;
    let isError = false;
    try {
      const activeResponse = {
        state: createStreamingUIMessageState({
          lastMessage: this.state.snapshot(lastMessage),
          messageId: this.generateId()
        }),
        abortController: new AbortController()
      };
      activeResponse.abortController.signal.addEventListener("abort", () => {
        isAbort = true;
      });
      this.activeResponse = activeResponse;
      let stream;
      if (trigger === "resume-stream") {
        const reconnect = await this.transport.reconnectToStream({
          chatId: this.id,
          metadata,
          headers,
          body
        });
        if (reconnect == null) {
          this.setStatus({ status: "ready" });
          return;
        }
        stream = reconnect;
      } else {
        stream = await this.transport.sendMessages({
          chatId: this.id,
          messages: this.state.messages,
          abortSignal: activeResponse.abortController.signal,
          metadata,
          headers,
          body,
          trigger,
          messageId
        });
      }
      const runUpdateMessageJob = (job) => (
        // serialize the job execution to avoid race conditions:
        this.jobExecutor.run(
          () => job({
            state: activeResponse.state,
            write: () => {
              var _a17;
              this.setStatus({ status: "streaming" });
              const replaceLastMessage = activeResponse.state.message.id === ((_a17 = this.lastMessage) == null ? void 0 : _a17.id);
              if (replaceLastMessage) {
                this.state.replaceMessage(
                  this.state.messages.length - 1,
                  activeResponse.state.message
                );
              } else {
                this.state.pushMessage(activeResponse.state.message);
              }
            }
          })
        )
      );
      await consumeStream({
        stream: processUIMessageStream({
          stream,
          onToolCall: this.onToolCall,
          onData: this.onData,
          messageMetadataSchema: this.messageMetadataSchema,
          dataPartSchemas: this.dataPartSchemas,
          runUpdateMessageJob,
          onError: (error40) => {
            throw error40;
          }
        }),
        onError: (error40) => {
          throw error40;
        }
      });
      this.setStatus({ status: "ready" });
    } catch (err) {
      if (isAbort || err.name === "AbortError") {
        isAbort = true;
        this.setStatus({ status: "ready" });
        return null;
      }
      isError = true;
      if (err instanceof TypeError && (err.message.toLowerCase().includes("fetch") || err.message.toLowerCase().includes("network"))) {
        isDisconnect = true;
      }
      if (this.onError && err instanceof Error) {
        this.onError(err);
      }
      this.setStatus({ status: "error", error: err });
    } finally {
      try {
        (_a162 = this.onFinish) == null ? void 0 : _a162.call(this, {
          message: this.activeResponse.state.message,
          messages: this.state.messages,
          isAbort,
          isDisconnect,
          isError
        });
      } catch (err) {
        console.error(err);
      }
      this.activeResponse = void 0;
    }
    if (((_b8 = this.sendAutomaticallyWhen) == null ? void 0 : _b8.call(this, { messages: this.state.messages })) && !isError) {
      await this.makeRequest({
        trigger: "submit-message",
        messageId: (_c = this.lastMessage) == null ? void 0 : _c.id,
        metadata,
        headers,
        body
      });
    }
  }
};
function lastAssistantMessageIsCompleteWithToolCalls({
  messages
}) {
  const message = messages[messages.length - 1];
  if (!message) {
    return false;
  }
  if (message.role !== "assistant") {
    return false;
  }
  const lastStepStartIndex = message.parts.reduce((lastIndex, part, index) => {
    return part.type === "step-start" ? index : lastIndex;
  }, -1);
  const lastStepToolInvocations = message.parts.slice(lastStepStartIndex + 1).filter(isToolOrDynamicToolUIPart);
  return lastStepToolInvocations.length > 0 && lastStepToolInvocations.every(
    (part) => part.state === "output-available" || part.state === "output-error"
  );
}
var uiMessagesSchema = lazyValidator(
  () => zodSchema(
    external_exports.array(
      external_exports.object({
        id: external_exports.string(),
        role: external_exports.enum(["system", "user", "assistant"]),
        metadata: external_exports.unknown().optional(),
        parts: external_exports.array(
          external_exports.union([
            external_exports.object({
              type: external_exports.literal("text"),
              text: external_exports.string(),
              state: external_exports.enum(["streaming", "done"]).optional(),
              providerMetadata: providerMetadataSchema.optional()
            }),
            external_exports.object({
              type: external_exports.literal("reasoning"),
              text: external_exports.string(),
              state: external_exports.enum(["streaming", "done"]).optional(),
              providerMetadata: providerMetadataSchema.optional()
            }),
            external_exports.object({
              type: external_exports.literal("source-url"),
              sourceId: external_exports.string(),
              url: external_exports.string(),
              title: external_exports.string().optional(),
              providerMetadata: providerMetadataSchema.optional()
            }),
            external_exports.object({
              type: external_exports.literal("source-document"),
              sourceId: external_exports.string(),
              mediaType: external_exports.string(),
              title: external_exports.string(),
              filename: external_exports.string().optional(),
              providerMetadata: providerMetadataSchema.optional()
            }),
            external_exports.object({
              type: external_exports.literal("file"),
              mediaType: external_exports.string(),
              filename: external_exports.string().optional(),
              url: external_exports.string(),
              providerMetadata: providerMetadataSchema.optional()
            }),
            external_exports.object({
              type: external_exports.literal("step-start")
            }),
            external_exports.object({
              type: external_exports.string().startsWith("data-"),
              id: external_exports.string().optional(),
              data: external_exports.unknown()
            }),
            external_exports.object({
              type: external_exports.literal("dynamic-tool"),
              toolName: external_exports.string(),
              toolCallId: external_exports.string(),
              state: external_exports.literal("input-streaming"),
              input: external_exports.unknown().optional(),
              output: external_exports.never().optional(),
              errorText: external_exports.never().optional()
            }),
            external_exports.object({
              type: external_exports.literal("dynamic-tool"),
              toolName: external_exports.string(),
              toolCallId: external_exports.string(),
              state: external_exports.literal("input-available"),
              input: external_exports.unknown(),
              output: external_exports.never().optional(),
              errorText: external_exports.never().optional(),
              callProviderMetadata: providerMetadataSchema.optional()
            }),
            external_exports.object({
              type: external_exports.literal("dynamic-tool"),
              toolName: external_exports.string(),
              toolCallId: external_exports.string(),
              state: external_exports.literal("output-available"),
              input: external_exports.unknown(),
              output: external_exports.unknown(),
              errorText: external_exports.never().optional(),
              callProviderMetadata: providerMetadataSchema.optional(),
              preliminary: external_exports.boolean().optional()
            }),
            external_exports.object({
              type: external_exports.literal("dynamic-tool"),
              toolName: external_exports.string(),
              toolCallId: external_exports.string(),
              state: external_exports.literal("output-error"),
              input: external_exports.unknown(),
              output: external_exports.never().optional(),
              errorText: external_exports.string(),
              callProviderMetadata: providerMetadataSchema.optional()
            }),
            external_exports.object({
              type: external_exports.string().startsWith("tool-"),
              toolCallId: external_exports.string(),
              state: external_exports.literal("input-streaming"),
              providerExecuted: external_exports.boolean().optional(),
              input: external_exports.unknown().optional(),
              output: external_exports.never().optional(),
              errorText: external_exports.never().optional(),
              approval: external_exports.never().optional()
            }),
            external_exports.object({
              type: external_exports.string().startsWith("tool-"),
              toolCallId: external_exports.string(),
              state: external_exports.literal("input-available"),
              providerExecuted: external_exports.boolean().optional(),
              input: external_exports.unknown(),
              output: external_exports.never().optional(),
              errorText: external_exports.never().optional(),
              callProviderMetadata: providerMetadataSchema.optional(),
              approval: external_exports.never().optional()
            }),
            external_exports.object({
              type: external_exports.string().startsWith("tool-"),
              toolCallId: external_exports.string(),
              state: external_exports.literal("approval-requested"),
              input: external_exports.unknown(),
              providerExecuted: external_exports.boolean().optional(),
              output: external_exports.never().optional(),
              errorText: external_exports.never().optional(),
              callProviderMetadata: providerMetadataSchema.optional(),
              approval: external_exports.object({
                id: external_exports.string(),
                approved: external_exports.never().optional(),
                reason: external_exports.never().optional()
              })
            }),
            external_exports.object({
              type: external_exports.string().startsWith("tool-"),
              toolCallId: external_exports.string(),
              state: external_exports.literal("approval-responded"),
              input: external_exports.unknown(),
              providerExecuted: external_exports.boolean().optional(),
              output: external_exports.never().optional(),
              errorText: external_exports.never().optional(),
              callProviderMetadata: providerMetadataSchema.optional(),
              approval: external_exports.object({
                id: external_exports.string(),
                approved: external_exports.boolean(),
                reason: external_exports.string().optional()
              })
            }),
            external_exports.object({
              type: external_exports.string().startsWith("tool-"),
              toolCallId: external_exports.string(),
              state: external_exports.literal("output-available"),
              providerExecuted: external_exports.boolean().optional(),
              input: external_exports.unknown(),
              output: external_exports.unknown(),
              errorText: external_exports.never().optional(),
              callProviderMetadata: providerMetadataSchema.optional(),
              preliminary: external_exports.boolean().optional(),
              approval: external_exports.object({
                id: external_exports.string(),
                approved: external_exports.literal(true),
                reason: external_exports.string().optional()
              }).optional()
            }),
            external_exports.object({
              type: external_exports.string().startsWith("tool-"),
              toolCallId: external_exports.string(),
              state: external_exports.literal("output-error"),
              providerExecuted: external_exports.boolean().optional(),
              input: external_exports.unknown(),
              output: external_exports.never().optional(),
              errorText: external_exports.string(),
              callProviderMetadata: providerMetadataSchema.optional(),
              approval: external_exports.object({
                id: external_exports.string(),
                approved: external_exports.literal(true),
                reason: external_exports.string().optional()
              }).optional()
            }),
            external_exports.object({
              type: external_exports.string().startsWith("tool-"),
              toolCallId: external_exports.string(),
              state: external_exports.literal("output-denied"),
              providerExecuted: external_exports.boolean().optional(),
              input: external_exports.unknown(),
              output: external_exports.never().optional(),
              errorText: external_exports.never().optional(),
              callProviderMetadata: providerMetadataSchema.optional(),
              approval: external_exports.object({
                id: external_exports.string(),
                approved: external_exports.literal(false),
                reason: external_exports.string().optional()
              })
            })
          ])
        )
      })
    )
  )
);

// node_modules/instantsearch.js/es/lib/chat/chat.js
var _excluded43 = ["messages", "agentId"];
function _typeof91(o4) {
  "@babel/helpers - typeof";
  return _typeof91 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof91(o4);
}
function ownKeys96(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread96(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys96(Object(t4), true).forEach(function(r4) {
      _defineProperty91(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys96(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _objectWithoutProperties24(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose24(source, excluded);
  var key2, i4;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i4 = 0; i4 < sourceSymbolKeys.length; i4++) {
      key2 = sourceSymbolKeys[i4];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose24(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i4;
  for (i4 = 0; i4 < sourceKeys.length; i4++) {
    key2 = sourceKeys[i4];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function _inherits8(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf8(subClass, superClass);
}
function _setPrototypeOf8(o4, p4) {
  _setPrototypeOf8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf9(o5, p5) {
    o5.__proto__ = p5;
    return o5;
  };
  return _setPrototypeOf8(o4, p4);
}
function _createSuper8(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct8();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf8(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf8(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn8(this, result);
  };
}
function _possibleConstructorReturn8(self, call) {
  if (call && (_typeof91(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized8(self);
}
function _assertThisInitialized8(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct8() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e4) {
    return false;
  }
}
function _getPrototypeOf8(o4) {
  _getPrototypeOf8 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf9(o5) {
    return o5.__proto__ || Object.getPrototypeOf(o5);
  };
  return _getPrototypeOf8(o4);
}
function _toConsumableArray13(arr) {
  return _arrayWithoutHoles13(arr) || _iterableToArray13(arr) || _unsupportedIterableToArray26(arr) || _nonIterableSpread13();
}
function _nonIterableSpread13() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray26(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray26(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray26(o4, minLen);
}
function _iterableToArray13(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles13(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray26(arr);
}
function _arrayLikeToArray26(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
function _classCallCheck9(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties9(target, props) {
  for (var i4 = 0; i4 < props.length; i4++) {
    var descriptor = props[i4];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey90(descriptor.key), descriptor);
  }
}
function _createClass9(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties9(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties9(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _defineProperty91(obj, key2, value) {
  key2 = _toPropertyKey90(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey90(t4) {
  var i4 = _toPrimitive90(t4, "string");
  return "symbol" == _typeof91(i4) ? i4 : String(i4);
}
function _toPrimitive90(t4, r3) {
  if ("object" != _typeof91(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof91(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
var CACHE_KEY = "instantsearch-chat-initial-messages-";
function getDefaultInitialMessages(id) {
  var initialMessages = sessionStorage.getItem(CACHE_KEY + id);
  return initialMessages ? JSON.parse(initialMessages) : [];
}
var ChatState = /* @__PURE__ */ function() {
  function ChatState2() {
    var _this = this;
    var id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0;
    var initialMessages = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getDefaultInitialMessages(id);
    _classCallCheck9(this, ChatState2);
    _defineProperty91(this, "_messages", void 0);
    _defineProperty91(this, "_status", "ready");
    _defineProperty91(this, "_error", void 0);
    _defineProperty91(this, "_messagesCallbacks", /* @__PURE__ */ new Set());
    _defineProperty91(this, "_statusCallbacks", /* @__PURE__ */ new Set());
    _defineProperty91(this, "_errorCallbacks", /* @__PURE__ */ new Set());
    _defineProperty91(this, "pushMessage", function(message) {
      _this._messages = _this._messages.concat(message);
      _this._callMessagesCallbacks();
    });
    _defineProperty91(this, "popMessage", function() {
      _this._messages = _this._messages.slice(0, -1);
      _this._callMessagesCallbacks();
    });
    _defineProperty91(this, "replaceMessage", function(index, message) {
      _this._messages = [].concat(_toConsumableArray13(_this._messages.slice(0, index)), [
        // We deep clone the message here to ensure the new React Compiler (currently in RC) detects deeply nested parts/metadata changes:
        _this.snapshot(message)
      ], _toConsumableArray13(_this._messages.slice(index + 1)));
      _this._callMessagesCallbacks();
    });
    _defineProperty91(this, "snapshot", function(thing) {
      return JSON.parse(JSON.stringify(thing));
    });
    _defineProperty91(this, "~registerMessagesCallback", function(onChange) {
      var callback = onChange;
      _this._messagesCallbacks.add(callback);
      return function() {
        _this._messagesCallbacks.delete(callback);
      };
    });
    _defineProperty91(this, "~registerStatusCallback", function(onChange) {
      _this._statusCallbacks.add(onChange);
      return function() {
        _this._statusCallbacks.delete(onChange);
      };
    });
    _defineProperty91(this, "~registerErrorCallback", function(onChange) {
      _this._errorCallbacks.add(onChange);
      return function() {
        _this._errorCallbacks.delete(onChange);
      };
    });
    _defineProperty91(this, "_callMessagesCallbacks", function() {
      _this._messagesCallbacks.forEach(function(callback) {
        return callback();
      });
    });
    _defineProperty91(this, "_callStatusCallbacks", function() {
      _this._statusCallbacks.forEach(function(callback) {
        return callback();
      });
    });
    _defineProperty91(this, "_callErrorCallbacks", function() {
      _this._errorCallbacks.forEach(function(callback) {
        return callback();
      });
    });
    this._messages = initialMessages;
    var saveMessagesInLocalStorage = function saveMessagesInLocalStorage2() {
      if (_this.status === "ready") {
        try {
          sessionStorage.setItem(CACHE_KEY + id, JSON.stringify(_this.messages));
        } catch (e4) {
        }
      }
    };
    this["~registerMessagesCallback"](saveMessagesInLocalStorage);
    this["~registerStatusCallback"](saveMessagesInLocalStorage);
  }
  _createClass9(ChatState2, [{
    key: "status",
    get: function get() {
      return this._status;
    },
    set: function set2(newStatus) {
      this._status = newStatus;
      this._callStatusCallbacks();
    }
  }, {
    key: "error",
    get: function get() {
      return this._error;
    },
    set: function set2(newError) {
      this._error = newError;
      this._callErrorCallbacks();
    }
  }, {
    key: "messages",
    get: function get() {
      return this._messages;
    },
    set: function set2(newMessages) {
      this._messages = _toConsumableArray13(newMessages);
      this._callMessagesCallbacks();
    }
  }]);
  return ChatState2;
}();
var Chat = /* @__PURE__ */ function(_AbstractChat) {
  _inherits8(Chat3, _AbstractChat);
  var _super = _createSuper8(Chat3);
  function Chat3(_ref9) {
    var _this2;
    var messages = _ref9.messages, agentId = _ref9.agentId, init = _objectWithoutProperties24(_ref9, _excluded43);
    _classCallCheck9(this, Chat3);
    var state = new ChatState(agentId, messages);
    _this2 = _super.call(this, _objectSpread96(_objectSpread96({}, init), {}, {
      state
    }));
    _defineProperty91(_assertThisInitialized8(_this2), "_state", void 0);
    _defineProperty91(_assertThisInitialized8(_this2), "~registerMessagesCallback", function(onChange) {
      return _this2._state["~registerMessagesCallback"](onChange);
    });
    _defineProperty91(_assertThisInitialized8(_this2), "~registerStatusCallback", function(onChange) {
      return _this2._state["~registerStatusCallback"](onChange);
    });
    _defineProperty91(_assertThisInitialized8(_this2), "~registerErrorCallback", function(onChange) {
      return _this2._state["~registerErrorCallback"](onChange);
    });
    _this2._state = state;
    return _this2;
  }
  return _createClass9(Chat3);
}(AbstractChat);

// node_modules/instantsearch.js/es/lib/chat/index.js
var SearchIndexToolType = "algolia_search_index";
var RecommendToolType = "algolia_recommend";

// node_modules/instantsearch.js/es/connectors/chat/connectChat.js
function _typeof92(o4) {
  "@babel/helpers - typeof";
  return _typeof92 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof92(o4);
}
var _excluded44 = ["resume", "tools"];
function ownKeys97(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread97(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys97(Object(t4), true).forEach(function(r4) {
      _defineProperty92(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys97(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty92(obj, key2, value) {
  key2 = _toPropertyKey91(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey91(t4) {
  var i4 = _toPrimitive91(t4, "string");
  return "symbol" == _typeof92(i4) ? i4 : String(i4);
}
function _toPrimitive91(t4, r3) {
  if ("object" != _typeof92(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof92(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _slicedToArray16(arr, i4) {
  return _arrayWithHoles16(arr) || _iterableToArrayLimit16(arr, i4) || _unsupportedIterableToArray27(arr, i4) || _nonIterableRest16();
}
function _nonIterableRest16() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray27(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray27(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray27(o4, minLen);
}
function _arrayLikeToArray27(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
function _iterableToArrayLimit16(r3, l4) {
  var t4 = null == r3 ? null : "undefined" != typeof Symbol && r3[Symbol.iterator] || r3["@@iterator"];
  if (null != t4) {
    var e4, n4, i4, u4, a4 = [], f4 = true, o4 = false;
    try {
      if (i4 = (t4 = t4.call(r3)).next, 0 === l4) {
        if (Object(t4) !== t4)
          return;
        f4 = false;
      } else
        for (; !(f4 = (e4 = i4.call(t4)).done) && (a4.push(e4.value), a4.length !== l4); f4 = true)
          ;
    } catch (r4) {
      o4 = true, n4 = r4;
    } finally {
      try {
        if (!f4 && null != t4.return && (u4 = t4.return(), Object(u4) !== u4))
          return;
      } finally {
        if (o4)
          throw n4;
      }
    }
    return a4;
  }
}
function _arrayWithHoles16(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _objectWithoutProperties25(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose25(source, excluded);
  var key2, i4;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i4 = 0; i4 < sourceSymbolKeys.length; i4++) {
      key2 = sourceSymbolKeys[i4];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose25(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i4;
  for (i4 = 0; i4 < sourceKeys.length; i4++) {
    key2 = sourceKeys[i4];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
var withUsage63 = createDocumentationMessageGenerator({
  name: "chat",
  connector: true
});
var connectChat_default = function connectChat(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
  checkRendering(renderFn, withUsage63());
  return function(widgetParams) {
    false ? _warning(false, "Chat is not yet stable and will change in the future.") : void 0;
    var _ref9 = widgetParams || {}, _ref$resume = _ref9.resume, resume = _ref$resume === void 0 ? false : _ref$resume, _ref$tools = _ref9.tools, tools = _ref$tools === void 0 ? {} : _ref$tools, options = _objectWithoutProperties25(_ref9, _excluded44);
    var _chatInstance;
    var input = "";
    var open = false;
    var sendEvent;
    var setInput;
    var setOpen;
    var setMessages = function setMessages2(messagesParam) {
      if (typeof messagesParam === "function") {
        messagesParam = messagesParam(_chatInstance.messages);
      }
      _chatInstance.messages = messagesParam;
    };
    var makeChatInstance = function makeChatInstance2(instantSearchInstance) {
      var transport;
      var _getAppIdAndApiKey = getAppIdAndApiKey(instantSearchInstance.client), _getAppIdAndApiKey2 = _slicedToArray16(_getAppIdAndApiKey, 2), appId = _getAppIdAndApiKey2[0], apiKey = _getAppIdAndApiKey2[1];
      if ("transport" in options && options.transport) {
        transport = new DefaultChatTransport(options.transport);
      }
      if ("agentId" in options && options.agentId) {
        var agentId = options.agentId;
        if (!appId || !apiKey) {
          throw new Error(withUsage63("Could not extract Algolia credentials from the search client."));
        }
        transport = new DefaultChatTransport({
          api: "https://".concat(appId, ".algolia.net/agent-studio/1/agents/").concat(agentId, "/completions?compatibilityMode=ai-sdk-5"),
          headers: {
            "x-algolia-application-id": appId,
            "x-algolia-api-Key": apiKey
          }
        });
      }
      if (!transport) {
        throw new Error(withUsage63("You need to provide either an `agentId` or a `transport`."));
      }
      if ("chat" in options) {
        return options.chat;
      }
      return new Chat(_objectSpread97(_objectSpread97({}, options), {}, {
        transport,
        sendAutomaticallyWhen: lastAssistantMessageIsCompleteWithToolCalls,
        onToolCall: function onToolCall(_ref23) {
          var toolCall = _ref23.toolCall;
          var tool2 = tools[toolCall.toolName];
          if (!tool2) {
            if (false) {
              throw new Error('No tool implementation found for "'.concat(toolCall.toolName, '". Please provide a tool implementation in the `tools` prop.'));
            }
            return _chatInstance.addToolResult({
              output: 'No tool implemented for "'.concat(toolCall.toolName, '".'),
              tool: toolCall.toolName,
              toolCallId: toolCall.toolCallId
            });
          }
          if (tool2.onToolCall) {
            var addToolResult = function addToolResult2(_ref33) {
              var output = _ref33.output;
              return _chatInstance.addToolResult({
                output,
                tool: toolCall.toolName,
                toolCallId: toolCall.toolCallId
              });
            };
            return tool2.onToolCall(_objectSpread97(_objectSpread97({}, toolCall), {}, {
              addToolResult
            }));
          }
          return Promise.resolve();
        }
      }));
    };
    return {
      $$type: "ais.chat",
      init: function init(initOptions) {
        var _this = this;
        var instantSearchInstance = initOptions.instantSearchInstance;
        _chatInstance = makeChatInstance(instantSearchInstance);
        var render = function render2() {
          renderFn(_objectSpread97(_objectSpread97({}, _this.getWidgetRenderState(initOptions)), {}, {
            instantSearchInstance: initOptions.instantSearchInstance
          }), false);
        };
        setOpen = function setOpen2(o4) {
          open = o4;
          render();
        };
        setInput = function setInput2(i4) {
          input = i4;
          render();
        };
        _chatInstance["~registerErrorCallback"](render);
        _chatInstance["~registerMessagesCallback"](render);
        _chatInstance["~registerStatusCallback"](render);
        if (resume) {
          _chatInstance.resumeStream();
        }
        renderFn(_objectSpread97(_objectSpread97({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        renderFn(_objectSpread97(_objectSpread97({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: renderOptions.instantSearchInstance
        }), false);
      },
      getRenderState: function getRenderState(renderState) {
        return renderState;
      },
      getWidgetRenderState: function getWidgetRenderState(renderState) {
        var instantSearchInstance = renderState.instantSearchInstance, parent = renderState.parent;
        if (!_chatInstance) {
          this.init(_objectSpread97(_objectSpread97({}, renderState), {}, {
            uiState: {},
            results: void 0
          }));
        }
        if (!sendEvent) {
          sendEvent = createSendEventForHits({
            instantSearchInstance: renderState.instantSearchInstance,
            helper: renderState.helper,
            widgetType: this.$$type
          });
        }
        return {
          indexUiState: instantSearchInstance.getUiState()[parent.getIndexId()],
          input,
          open,
          sendEvent,
          setIndexUiState: parent.setIndexUiState.bind(parent),
          setInput,
          setOpen,
          setMessages,
          widgetParams,
          // Chat instance render state
          addToolResult: _chatInstance.addToolResult,
          clearError: _chatInstance.clearError,
          error: _chatInstance.error,
          id: _chatInstance.id,
          messages: _chatInstance.messages,
          regenerate: _chatInstance.regenerate,
          resumeStream: _chatInstance.resumeStream,
          sendMessage: _chatInstance.sendMessage,
          status: _chatInstance.status,
          stop: _chatInstance.stop
        };
      },
      dispose: function dispose() {
        unmountFn();
      },
      shouldRender: function shouldRender() {
        return true;
      },
      get chatInstance() {
        return _chatInstance;
      }
    };
  };
};

// node_modules/instantsearch.js/es/lib/useStickToBottom.js
var useStickToBottom = createStickToBottom({
  useCallback: x3,
  useEffect: _3,
  useMemo: q2,
  useRef: F3,
  useState: p3
});

// node_modules/instantsearch.js/es/templates/carousel/carousel.js
function _typeof93(o4) {
  "@babel/helpers - typeof";
  return _typeof93 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof93(o4);
}
function ownKeys98(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread98(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys98(Object(t4), true).forEach(function(r4) {
      _defineProperty93(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys98(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty93(obj, key2, value) {
  key2 = _toPropertyKey92(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey92(t4) {
  var i4 = _toPrimitive92(t4, "string");
  return "symbol" == _typeof93(i4) ? i4 : String(i4);
}
function _toPrimitive92(t4, r3) {
  if ("object" != _typeof93(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof93(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _extends29() {
  _extends29 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends29.apply(this, arguments);
}
function _slicedToArray17(arr, i4) {
  return _arrayWithHoles17(arr) || _iterableToArrayLimit17(arr, i4) || _unsupportedIterableToArray28(arr, i4) || _nonIterableRest17();
}
function _nonIterableRest17() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray28(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray28(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray28(o4, minLen);
}
function _arrayLikeToArray28(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
function _iterableToArrayLimit17(r3, l4) {
  var t4 = null == r3 ? null : "undefined" != typeof Symbol && r3[Symbol.iterator] || r3["@@iterator"];
  if (null != t4) {
    var e4, n4, i4, u4, a4 = [], f4 = true, o4 = false;
    try {
      if (i4 = (t4 = t4.call(r3)).next, 0 === l4) {
        if (Object(t4) !== t4)
          return;
        f4 = false;
      } else
        for (; !(f4 = (e4 = i4.call(t4)).done) && (a4.push(e4.value), a4.length !== l4); f4 = true)
          ;
    } catch (r4) {
      o4 = true, n4 = r4;
    } finally {
      try {
        if (!f4 && null != t4.return && (u4 = t4.return(), Object(u4) !== u4))
          return;
      } finally {
        if (o4)
          throw n4;
      }
    }
    return a4;
  }
}
function _arrayWithHoles17(arr) {
  if (Array.isArray(arr))
    return arr;
}
var Carousel = createCarouselComponent({
  createElement: y2,
  Fragment: g2
});
function CarouselWithRefs(props) {
  var _useState = p3(false), _useState2 = _slicedToArray17(_useState, 2), canScrollLeft = _useState2[0], setCanScrollLeft = _useState2[1];
  var _useState3 = p3(true), _useState4 = _slicedToArray17(_useState3, 2), canScrollRight = _useState4[0], setCanScrollRight = _useState4[1];
  var carouselRefs = {
    listRef: F3(null),
    nextButtonRef: F3(null),
    previousButtonRef: F3(null),
    carouselIdRef: F3(generateCarouselId()),
    canScrollLeft,
    canScrollRight,
    setCanScrollLeft,
    setCanScrollRight
  };
  return y2(Carousel, _extends29({}, carouselRefs, props));
}
function carousel() {
  var _ref9 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, cssClasses = _ref9.cssClasses, _ref$templates = _ref9.templates, templates = _ref$templates === void 0 ? {} : _ref$templates, _ref$showNavigation = _ref9.showNavigation, showNavigation = _ref$showNavigation === void 0 ? true : _ref$showNavigation;
  return function CarouselTemplate(_ref23) {
    var items = _ref23.items, widgetTemplates = _ref23.templates, _ref2$cssClasses = _ref23.cssClasses, widgetCssClasses = _ref2$cssClasses === void 0 ? {} : _ref2$cssClasses, _ref2$sendEvent = _ref23.sendEvent, sendEvent = _ref2$sendEvent === void 0 ? function() {
    } : _ref2$sendEvent;
    var previous2 = templates.previous, next2 = templates.next, header2 = templates.header;
    return y2(CarouselWithRefs, {
      items,
      sendEvent,
      itemComponent: widgetTemplates.item,
      headerComponent: header2 ? function(props) {
        return header2(_objectSpread98({
          html: m3
        }, props));
      } : void 0,
      previousIconComponent: previous2 ? function() {
        return previous2({
          html: m3
        });
      } : void 0,
      nextIconComponent: next2 ? function() {
        return next2({
          html: m3
        });
      } : void 0,
      classNames: _objectSpread98(_objectSpread98({}, cssClasses), {
        list: cx(cssClasses === null || cssClasses === void 0 ? void 0 : cssClasses.list, widgetCssClasses === null || widgetCssClasses === void 0 ? void 0 : widgetCssClasses.list),
        item: cx(cssClasses === null || cssClasses === void 0 ? void 0 : cssClasses.item, widgetCssClasses === null || widgetCssClasses === void 0 ? void 0 : widgetCssClasses.item)
      }),
      showNavigation
    });
  };
}

// node_modules/instantsearch.js/es/widgets/chat/chat.js
function _typeof94(o4) {
  "@babel/helpers - typeof";
  return _typeof94 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof94(o4);
}
var _excluded45 = ["container", "templates", "cssClasses", "resume", "tools", "getSearchPageURL"];
function _objectWithoutProperties26(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose26(source, excluded);
  var key2, i4;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i4 = 0; i4 < sourceSymbolKeys.length; i4++) {
      key2 = sourceSymbolKeys[i4];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose26(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i4;
  for (i4 = 0; i4 < sourceKeys.length; i4++) {
    key2 = sourceKeys[i4];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function ownKeys99(e4, r3) {
  var t4 = Object.keys(e4);
  if (Object.getOwnPropertySymbols) {
    var o4 = Object.getOwnPropertySymbols(e4);
    r3 && (o4 = o4.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e4, r4).enumerable;
    })), t4.push.apply(t4, o4);
  }
  return t4;
}
function _objectSpread99(e4) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t4 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys99(Object(t4), true).forEach(function(r4) {
      _defineProperty94(e4, r4, t4[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : ownKeys99(Object(t4)).forEach(function(r4) {
      Object.defineProperty(e4, r4, Object.getOwnPropertyDescriptor(t4, r4));
    });
  }
  return e4;
}
function _defineProperty94(obj, key2, value) {
  key2 = _toPropertyKey93(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey93(t4) {
  var i4 = _toPrimitive93(t4, "string");
  return "symbol" == _typeof94(i4) ? i4 : String(i4);
}
function _toPrimitive93(t4, r3) {
  if ("object" != _typeof94(t4) || !t4)
    return t4;
  var e4 = t4[Symbol.toPrimitive];
  if (void 0 !== e4) {
    var i4 = e4.call(t4, r3 || "default");
    if ("object" != _typeof94(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t4);
}
function _extends30() {
  _extends30 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends30.apply(this, arguments);
}
function _slicedToArray18(arr, i4) {
  return _arrayWithHoles18(arr) || _iterableToArrayLimit18(arr, i4) || _unsupportedIterableToArray29(arr, i4) || _nonIterableRest18();
}
function _nonIterableRest18() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray29(o4, minLen) {
  if (!o4)
    return;
  if (typeof o4 === "string")
    return _arrayLikeToArray29(o4, minLen);
  var n4 = Object.prototype.toString.call(o4).slice(8, -1);
  if (n4 === "Object" && o4.constructor)
    n4 = o4.constructor.name;
  if (n4 === "Map" || n4 === "Set")
    return Array.from(o4);
  if (n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4))
    return _arrayLikeToArray29(o4, minLen);
}
function _arrayLikeToArray29(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i4 = 0, arr2 = new Array(len); i4 < len; i4++)
    arr2[i4] = arr[i4];
  return arr2;
}
function _iterableToArrayLimit18(r3, l4) {
  var t4 = null == r3 ? null : "undefined" != typeof Symbol && r3[Symbol.iterator] || r3["@@iterator"];
  if (null != t4) {
    var e4, n4, i4, u4, a4 = [], f4 = true, o4 = false;
    try {
      if (i4 = (t4 = t4.call(r3)).next, 0 === l4) {
        if (Object(t4) !== t4)
          return;
        f4 = false;
      } else
        for (; !(f4 = (e4 = i4.call(t4)).done) && (a4.push(e4.value), a4.length !== l4); f4 = true)
          ;
    } catch (r4) {
      o4 = true, n4 = r4;
    } finally {
      try {
        if (!f4 && null != t4.return && (u4 = t4.return(), Object(u4) !== u4))
          return;
      } finally {
        if (o4)
          throw n4;
      }
    }
    return a4;
  }
}
function _arrayWithHoles18(arr) {
  if (Array.isArray(arr))
    return arr;
}
var withUsage64 = createDocumentationMessageGenerator({
  name: "chat"
});
var Chat2 = createChatComponent({
  createElement: y2,
  Fragment: g2
});
function getDefinedProperties(obj) {
  return Object.fromEntries(Object.entries(obj).filter(function(_ref9) {
    var _ref23 = _slicedToArray18(_ref9, 2), value = _ref23[1];
    return value !== void 0;
  }));
}
var _ref63 = y2(ArrowRightIconComponent, {
  createElement: y2
});
var _ref7 = y2(ChevronLeftIconComponent, {
  createElement: y2
});
var _ref8 = y2(ChevronRightIconComponent, {
  createElement: y2
});
function createCarouselTool(showViewAll, templates, getSearchPageURL) {
  var Button2 = createButtonComponent({
    createElement: y2
  });
  function SearchLayoutComponent(_ref33) {
    var message = _ref33.message, indexUiState = _ref33.indexUiState, setIndexUiState = _ref33.setIndexUiState, onClose = _ref33.onClose;
    var input = message === null || message === void 0 ? void 0 : message.input;
    var output = message === null || message === void 0 ? void 0 : message.output;
    var items = (output === null || output === void 0 ? void 0 : output.hits) || [];
    var MemoedHeaderComponent = q2(function() {
      return function(props) {
        return y2(HeaderComponent, _extends30({
          nbHits: output === null || output === void 0 ? void 0 : output.nbHits,
          query: input === null || input === void 0 ? void 0 : input.query,
          hitsPerPage: items.length,
          setIndexUiState,
          indexUiState,
          getSearchPageURL,
          onClose
        }, props));
      };
    }, [items.length, input === null || input === void 0 ? void 0 : input.query, output === null || output === void 0 ? void 0 : output.nbHits, setIndexUiState, indexUiState, onClose]);
    return carousel({
      showNavigation: false,
      templates: {
        header: MemoedHeaderComponent
      }
    })({
      items,
      templates: {
        item: function item11(_ref44) {
          var _item = _ref44.item;
          return y2(Template_default, {
            templates,
            templateKey: "item",
            data: _item,
            rootTagName: "fragment"
          });
        }
      },
      sendEvent: function sendEvent() {
      }
    });
  }
  function HeaderComponent(_ref52) {
    var canScrollLeft = _ref52.canScrollLeft, canScrollRight = _ref52.canScrollRight, scrollLeft = _ref52.scrollLeft, scrollRight = _ref52.scrollRight, nbHits = _ref52.nbHits, query = _ref52.query, hitsPerPage3 = _ref52.hitsPerPage, setIndexUiState = _ref52.setIndexUiState, indexUiState = _ref52.indexUiState, onClose = _ref52.onClose, getSearchPageURL2 = _ref52.getSearchPageURL;
    if ((hitsPerPage3 !== null && hitsPerPage3 !== void 0 ? hitsPerPage3 : 0) < 1) {
      return null;
    }
    return y2("div", {
      className: "ais-ChatToolSearchIndexCarouselHeader"
    }, y2("div", {
      className: "ais-ChatToolSearchIndexCarouselHeaderResults"
    }, nbHits && y2("div", {
      className: "ais-ChatToolSearchIndexCarouselHeaderCount"
    }, hitsPerPage3 !== null && hitsPerPage3 !== void 0 ? hitsPerPage3 : 0, " of ", nbHits.toLocaleString(), " result", nbHits > 1 ? "s" : ""), showViewAll && y2(Button2, {
      variant: "ghost",
      size: "sm",
      onClick: function onClick() {
        if (!query)
          return;
        var nextUiState = _objectSpread99(_objectSpread99({}, indexUiState), {}, {
          query
        });
        if (!getSearchPageURL2 || getSearchPageURL2 && new URL(getSearchPageURL2(nextUiState)).pathname === window.location.pathname) {
          setIndexUiState(nextUiState);
          onClose();
          return;
        }
        window.location.href = getSearchPageURL2(nextUiState);
      },
      className: "ais-ChatToolSearchIndexCarouselHeaderViewAll"
    }, "View all", _ref63)), (hitsPerPage3 !== null && hitsPerPage3 !== void 0 ? hitsPerPage3 : 0) > 2 && y2("div", {
      className: "ais-ChatToolSearchIndexCarouselHeaderScrollButtons"
    }, y2(Button2, {
      variant: "outline",
      size: "sm",
      iconOnly: true,
      onClick: scrollLeft,
      disabled: !canScrollLeft,
      className: "ais-ChatToolSearchIndexCarouselHeaderScrollButton"
    }, _ref7), y2(Button2, {
      variant: "outline",
      size: "sm",
      iconOnly: true,
      onClick: scrollRight,
      disabled: !canScrollRight,
      className: "ais-ChatToolSearchIndexCarouselHeaderScrollButton"
    }, _ref8)));
  }
  return {
    templates: {
      layout: SearchLayoutComponent
    }
  };
}
function createDefaultTools(templates, getSearchPageURL) {
  var _ref9;
  return _ref9 = {}, _defineProperty94(_ref9, SearchIndexToolType, createCarouselTool(true, templates, getSearchPageURL)), _defineProperty94(_ref9, RecommendToolType, createCarouselTool(false, templates, getSearchPageURL)), _ref9;
}
function ChatWrapper(_ref10) {
  var cssClasses = _ref10.cssClasses, chatOpen = _ref10.chatOpen, setChatOpen = _ref10.setChatOpen, chatMessages = _ref10.chatMessages, setChatMessages = _ref10.setChatMessages, indexUiState = _ref10.indexUiState, setIndexUiState = _ref10.setIndexUiState, chatStatus = _ref10.chatStatus, chatInput = _ref10.chatInput, setChatInput = _ref10.setChatInput, sendMessage = _ref10.sendMessage, regenerate = _ref10.regenerate, stop = _ref10.stop, toolsForUi = _ref10.toolsForUi, toggleButtonProps = _ref10.toggleButtonProps, headerProps = _ref10.headerProps, messagesProps = _ref10.messagesProps, promptProps = _ref10.promptProps, state = _ref10.state;
  var _useStickToBottom = useStickToBottom({
    initial: "smooth",
    resize: "smooth"
  }), scrollRef = _useStickToBottom.scrollRef, contentRef = _useStickToBottom.contentRef, scrollToBottom = _useStickToBottom.scrollToBottom, isAtBottom = _useStickToBottom.isAtBottom;
  state.init();
  var _state$use = state.use(false), _state$use2 = _slicedToArray18(_state$use, 2), isClearing = _state$use2[0], setIsClearing = _state$use2[1];
  var _state$use3 = state.use(false), _state$use4 = _slicedToArray18(_state$use3, 2), maximized = _state$use4[0], setMaximized = _state$use4[1];
  var onClear = function onClear2() {
    return setIsClearing(true);
  };
  var onClearTransitionEnd = function onClearTransitionEnd2() {
    setChatMessages([]);
    setIsClearing(false);
  };
  return y2(Chat2, {
    classNames: cssClasses,
    open: chatOpen,
    maximized,
    toggleButtonComponent: toggleButtonProps.layoutComponent,
    toggleButtonProps: {
      open: chatOpen,
      onClick: function onClick() {
        return setChatOpen(!chatOpen);
      },
      toggleIconComponent: toggleButtonProps.iconComponent
    },
    headerComponent: headerProps.layoutComponent,
    promptComponent: promptProps.layoutComponent,
    headerProps: {
      onClose: function onClose() {
        return setChatOpen(false);
      },
      maximized,
      onToggleMaximize: function onToggleMaximize() {
        return setMaximized(!maximized);
      },
      onClear,
      canClear: Boolean(chatMessages === null || chatMessages === void 0 ? void 0 : chatMessages.length) && !isClearing,
      closeIconComponent: headerProps.closeIconComponent,
      minimizeIconComponent: headerProps.minimizeIconComponent,
      maximizeIconComponent: headerProps.maximizeIconComponent,
      titleIconComponent: headerProps.titleIconComponent,
      translations: headerProps.translations
    },
    messagesProps: {
      status: chatStatus,
      onReload: function onReload(messageId) {
        return regenerate({
          messageId
        });
      },
      onClose: function onClose() {
        return setChatOpen(false);
      },
      messages: chatMessages,
      indexUiState,
      isClearing,
      onClearTransitionEnd,
      isScrollAtBottom: isAtBottom,
      scrollRef,
      contentRef,
      onScrollToBottom: scrollToBottom,
      setIndexUiState,
      tools: toolsForUi,
      loaderComponent: messagesProps.loaderComponent,
      errorComponent: messagesProps.errorComponent,
      actionsComponent: messagesProps.actionsComponent,
      translations: messagesProps.translations
    },
    promptProps: {
      promptRef: promptProps.promptRef,
      status: chatStatus,
      value: chatInput,
      onInput: function onInput(event) {
        setChatInput(event.currentTarget.value);
      },
      onSubmit: function onSubmit() {
        sendMessage({
          text: chatInput
        });
        setChatInput("");
      },
      onStop: function onStop() {
        stop();
      },
      headerComponent: promptProps.headerComponent,
      footerComponent: promptProps.footerComponent,
      translations: promptProps.translations
    }
  });
}
var createRenderer4 = function createRenderer5(_ref11) {
  var renderState = _ref11.renderState, cssClasses = _ref11.cssClasses, containerNode = _ref11.containerNode, templates = _ref11.templates, tools = _ref11.tools;
  var state = createLocalState();
  var promptRef = {
    current: null
  };
  return function(props, isFirstRendering) {
    var _templates$header, _templates$header2, _templates$header3, _templates$header4, _templates$header5, _templates$header6, _templates$header7, _templates$header8, _templates$header9, _templates$header10, _templates$messages, _templates$messages2, _templates$messages3, _templates$messages4, _templates$messages5, _templates$messages6, _templates$prompt, _templates$prompt2, _templates$prompt3, _templates$prompt4, _templates$prompt5, _templates$prompt6, _templates$prompt7, _templates$prompt8, _templates$prompt9, _templates$toggleButt, _templates$toggleButt2;
    var indexUiState = props.indexUiState, input = props.input, instantSearchInstance = props.instantSearchInstance, messages = props.messages, open = props.open, sendMessage = props.sendMessage, setIndexUiState = props.setIndexUiState, setInput = props.setInput, setMessages = props.setMessages, setOpen = props.setOpen, status2 = props.status, error40 = props.error, addToolResult = props.addToolResult, regenerate = props.regenerate, stop = props.stop;
    if (false) {
      throw error40;
    }
    if (isFirstRendering) {
      renderState.templateProps = prepareTemplateProps({
        defaultTemplates: {},
        templatesConfig: instantSearchInstance.templatesConfig,
        templates
      });
      return;
    }
    var toolsForUi = {};
    Object.entries(tools).forEach(function(_ref12) {
      var _ref13 = _slicedToArray18(_ref12, 2), key2 = _ref13[0], tool2 = _ref13[1];
      toolsForUi[key2] = _objectSpread99(_objectSpread99({}, tool2), {}, {
        addToolResult,
        layoutComponent: function layoutComponent(layoutComponentProps) {
          return y2(Template_default, {
            templates: tool2.templates,
            rootTagName: "fragment",
            templateKey: "layout",
            data: layoutComponentProps
          });
        }
      });
    });
    var headerTemplateProps = prepareTemplateProps({
      defaultTemplates: {},
      templatesConfig: instantSearchInstance.templatesConfig,
      templates: templates.header
    });
    var headerLayoutComponent = (_templates$header = templates.header) !== null && _templates$header !== void 0 && _templates$header.layout ? function(headerProps) {
      return y2(Template_default, _extends30({}, headerTemplateProps, {
        templateKey: "layout",
        rootTagName: "div",
        data: headerProps
      }));
    } : void 0;
    var headerCloseIconComponent = (_templates$header2 = templates.header) !== null && _templates$header2 !== void 0 && _templates$header2.closeIcon ? function() {
      return y2(Template_default, _extends30({}, headerTemplateProps, {
        templateKey: "closeIcon",
        rootTagName: "span"
      }));
    } : void 0;
    var headerMinimizeIconComponent = (_templates$header3 = templates.header) !== null && _templates$header3 !== void 0 && _templates$header3.minimizeIcon ? function() {
      return y2(Template_default, _extends30({}, headerTemplateProps, {
        templateKey: "minimizeIcon",
        rootTagName: "span"
      }));
    } : void 0;
    var headerMaximizeIconComponent = (_templates$header4 = templates.header) !== null && _templates$header4 !== void 0 && _templates$header4.maximizeIcon ? function(_ref14) {
      var maximized = _ref14.maximized;
      return y2(Template_default, _extends30({}, headerTemplateProps, {
        templateKey: "maximizeIcon",
        rootTagName: "span",
        data: {
          maximized
        }
      }));
    } : void 0;
    var headerTitleIconComponent = (_templates$header5 = templates.header) !== null && _templates$header5 !== void 0 && _templates$header5.titleIcon ? function() {
      return y2(Template_default, _extends30({}, headerTemplateProps, {
        templateKey: "titleIcon",
        rootTagName: "span"
      }));
    } : void 0;
    var headerTranslations = getDefinedProperties({
      title: (_templates$header6 = templates.header) === null || _templates$header6 === void 0 ? void 0 : _templates$header6.titleText,
      minimizeLabel: (_templates$header7 = templates.header) === null || _templates$header7 === void 0 ? void 0 : _templates$header7.minimizeLabelText,
      maximizeLabel: (_templates$header8 = templates.header) === null || _templates$header8 === void 0 ? void 0 : _templates$header8.maximizeLabelText,
      closeLabel: (_templates$header9 = templates.header) === null || _templates$header9 === void 0 ? void 0 : _templates$header9.closeLabelText,
      clearLabel: (_templates$header10 = templates.header) === null || _templates$header10 === void 0 ? void 0 : _templates$header10.clearLabelText
    });
    var messagesTemplateProps = prepareTemplateProps({
      defaultTemplates: {},
      templatesConfig: instantSearchInstance.templatesConfig,
      templates: templates.messages
    });
    var messagesLoaderComponent = (_templates$messages = templates.messages) !== null && _templates$messages !== void 0 && _templates$messages.loader ? function(loaderProps) {
      return y2(Template_default, _extends30({}, messagesTemplateProps, {
        templateKey: "loader",
        rootTagName: "div",
        data: loaderProps
      }));
    } : void 0;
    var messagesErrorComponent = (_templates$messages2 = templates.messages) !== null && _templates$messages2 !== void 0 && _templates$messages2.error ? function(errorProps) {
      return y2(Template_default, _extends30({}, messagesTemplateProps, {
        templateKey: "error",
        rootTagName: "div",
        data: errorProps
      }));
    } : void 0;
    var messagesTranslations = getDefinedProperties({
      scrollToBottomLabel: (_templates$messages3 = templates.messages) === null || _templates$messages3 === void 0 ? void 0 : _templates$messages3.scrollToBottomLabelText,
      loaderText: (_templates$messages4 = templates.messages) === null || _templates$messages4 === void 0 ? void 0 : _templates$messages4.loaderText,
      copyToClipboardLabel: (_templates$messages5 = templates.messages) === null || _templates$messages5 === void 0 ? void 0 : _templates$messages5.copyToClipboardLabelText,
      regenerateLabel: (_templates$messages6 = templates.messages) === null || _templates$messages6 === void 0 ? void 0 : _templates$messages6.regenerateLabelText
    });
    var promptTemplateProps = prepareTemplateProps({
      defaultTemplates: {},
      templatesConfig: instantSearchInstance.templatesConfig,
      templates: templates.prompt
    });
    var promptLayoutComponent = (_templates$prompt = templates.prompt) !== null && _templates$prompt !== void 0 && _templates$prompt.layout ? function(promptProps) {
      return y2(Template_default, _extends30({}, promptTemplateProps, {
        templateKey: "layout",
        rootTagName: "div",
        data: promptProps
      }));
    } : void 0;
    var promptHeaderComponent = (_templates$prompt2 = templates.prompt) !== null && _templates$prompt2 !== void 0 && _templates$prompt2.header ? function() {
      return y2(Template_default, _extends30({}, promptTemplateProps, {
        templateKey: "header",
        rootTagName: "fragment"
      }));
    } : void 0;
    var promptFooterComponent = (_templates$prompt3 = templates.prompt) !== null && _templates$prompt3 !== void 0 && _templates$prompt3.footer ? function() {
      return y2(Template_default, _extends30({}, promptTemplateProps, {
        templateKey: "footer",
        rootTagName: "fragment"
      }));
    } : void 0;
    var promptTranslations = getDefinedProperties({
      textareaLabel: (_templates$prompt4 = templates.prompt) === null || _templates$prompt4 === void 0 ? void 0 : _templates$prompt4.textareaLabelText,
      textareaPlaceholder: (_templates$prompt5 = templates.prompt) === null || _templates$prompt5 === void 0 ? void 0 : _templates$prompt5.textareaPlaceholderText,
      emptyMessageTooltip: (_templates$prompt6 = templates.prompt) === null || _templates$prompt6 === void 0 ? void 0 : _templates$prompt6.emptyMessageTooltipText,
      stopResponseTooltip: (_templates$prompt7 = templates.prompt) === null || _templates$prompt7 === void 0 ? void 0 : _templates$prompt7.stopResponseTooltipText,
      sendMessageTooltip: (_templates$prompt8 = templates.prompt) === null || _templates$prompt8 === void 0 ? void 0 : _templates$prompt8.sendMessageTooltipText,
      disclaimer: (_templates$prompt9 = templates.prompt) === null || _templates$prompt9 === void 0 ? void 0 : _templates$prompt9.disclaimerText
    });
    var actionsComponent = templates.actions ? function(actionsProps) {
      return y2(Template_default, _extends30({}, renderState.templateProps, {
        templateKey: "actions",
        rootTagName: "div",
        data: actionsProps
      }));
    } : void 0;
    var toggleButtonTemplateProps = prepareTemplateProps({
      defaultTemplates: {},
      templatesConfig: instantSearchInstance.templatesConfig,
      templates: templates.toggleButton
    });
    var toggleButtonLayoutComponent = (_templates$toggleButt = templates.toggleButton) !== null && _templates$toggleButt !== void 0 && _templates$toggleButt.layout ? function(toggleButtonProps) {
      return y2(Template_default, _extends30({}, toggleButtonTemplateProps, {
        templateKey: "layout",
        rootTagName: "button",
        data: toggleButtonProps
      }));
    } : void 0;
    var toggleButtonIconComponent = (_templates$toggleButt2 = templates.toggleButton) !== null && _templates$toggleButt2 !== void 0 && _templates$toggleButt2.icon ? function(_ref15) {
      var isOpen = _ref15.isOpen;
      return y2(Template_default, _extends30({}, toggleButtonTemplateProps, {
        templateKey: "icon",
        rootTagName: "span",
        data: {
          isOpen
        }
      }));
    } : void 0;
    state.subscribe(rerender);
    function rerender() {
      N2(y2(ChatWrapper, {
        cssClasses,
        chatOpen: open,
        setChatOpen: setOpen,
        chatMessages: messages,
        setChatMessages: setMessages,
        indexUiState,
        setIndexUiState,
        chatStatus: status2,
        chatInput: input,
        setChatInput: setInput,
        sendMessage,
        regenerate,
        stop,
        toolsForUi,
        toggleButtonProps: {
          layoutComponent: toggleButtonLayoutComponent,
          iconComponent: toggleButtonIconComponent
        },
        headerProps: {
          layoutComponent: headerLayoutComponent,
          closeIconComponent: headerCloseIconComponent,
          minimizeIconComponent: headerMinimizeIconComponent,
          maximizeIconComponent: headerMaximizeIconComponent,
          titleIconComponent: headerTitleIconComponent,
          translations: headerTranslations
        },
        messagesProps: {
          loaderComponent: messagesLoaderComponent,
          errorComponent: messagesErrorComponent,
          actionsComponent,
          translations: messagesTranslations
        },
        promptProps: {
          layoutComponent: promptLayoutComponent,
          headerComponent: promptHeaderComponent,
          footerComponent: promptFooterComponent,
          translations: promptTranslations,
          promptRef
        },
        state
      }), containerNode);
    }
    rerender();
  };
};
var defaultTemplates20 = {
  item: function item10(_item2) {
    return JSON.stringify(_item2, null, 2);
  }
};
var chat_default = function chat(widgetParams) {
  var _ref16 = widgetParams || {}, container = _ref16.container, _ref16$templates = _ref16.templates, userTemplates = _ref16$templates === void 0 ? {} : _ref16$templates, _ref16$cssClasses = _ref16.cssClasses, cssClasses = _ref16$cssClasses === void 0 ? {} : _ref16$cssClasses, _ref16$resume = _ref16.resume, resume = _ref16$resume === void 0 ? false : _ref16$resume, userTools = _ref16.tools, getSearchPageURL = _ref16.getSearchPageURL, options = _objectWithoutProperties26(_ref16, _excluded45);
  if (!container) {
    throw new Error(withUsage64("The `container` option is required."));
  }
  var containerNode = getContainerNode(container);
  var templates = _objectSpread99(_objectSpread99({}, defaultTemplates20), userTemplates);
  var defaultTools = createDefaultTools(templates, getSearchPageURL);
  var tools = _objectSpread99(_objectSpread99({}, defaultTools), userTools);
  var specializedRenderer = createRenderer4({
    containerNode,
    cssClasses,
    renderState: {},
    templates,
    tools
  });
  var makeWidget = connectChat_default(specializedRenderer, function() {
    return N2(null, containerNode);
  });
  return _objectSpread99(_objectSpread99({}, makeWidget(_objectSpread99({
    resume,
    tools
  }, options))), {}, {
    $$widgetType: "ais.chat"
  });
};
function createLocalState() {
  var state = [];
  var subscriptions = /* @__PURE__ */ new Set();
  var cursor = 0;
  function use(initialValue) {
    var index = cursor++;
    if (state[index] === void 0) {
      state[index] = initialValue;
    }
    return [state[index], function(value) {
      var prev = state[index];
      if (prev === value) {
        return prev;
      }
      state[index] = value;
      subscriptions.forEach(function(fn) {
        return fn();
      });
      return value;
    }];
  }
  return {
    init: function init() {
      cursor = 0;
    },
    subscribe: function subscribe(fn) {
      subscriptions.add(fn);
      return function() {
        return subscriptions.delete(fn);
      };
    },
    use
  };
}

// node_modules/instantsearch.js/es/widgets/index.js
var EXPERIMENTAL_answers = deprecate(answers_default, "answers is no longer supported");
var EXPERIMENTAL_configureRelatedItems = deprecate(configure_related_items_default, "EXPERIMENTAL_configureRelatedItems is deprecated and will be removed in a next minor version of InstantSearch. Please use relatedItems instead.");
var EXPERIMENTAL_dynamicWidgets = deprecate(dynamic_widgets_default, "use dynamicWidgets");
export {
  EXPERIMENTAL_answers,
  EXPERIMENTAL_configureRelatedItems,
  EXPERIMENTAL_dynamicWidgets,
  analytics_default as analytics,
  breadcrumb_default as breadcrumb,
  chat_default as chat,
  clear_refinements_default as clearRefinements,
  configure_default as configure,
  current_refinements_default as currentRefinements,
  dynamic_widgets_default as dynamicWidgets,
  frequently_bought_together_default as frequentlyBoughtTogether,
  geo_search_default as geoSearch,
  hierarchical_menu_default as hierarchicalMenu,
  hits_default as hits,
  hits_per_page_default as hitsPerPage,
  index_default as index,
  infinite_hits_default as infiniteHits,
  looking_similar_default as lookingSimilar,
  menu_default as menu,
  menu_select_default as menuSelect,
  numeric_menu_default as numericMenu,
  pagination_default as pagination,
  panel_default as panel,
  places_default as places,
  powered_by_default as poweredBy,
  query_rule_context_default as queryRuleContext,
  query_rule_custom_data_default as queryRuleCustomData,
  range_input_default as rangeInput,
  range_slider_default as rangeSlider,
  rating_menu_default as ratingMenu,
  refinement_list_default as refinementList,
  related_products_default as relatedProducts,
  relevant_sort_default as relevantSort,
  search_box_default as searchBox,
  sort_by_default as sortBy,
  stats_default as stats,
  toggle_refinement_default as toggleRefinement,
  trending_items_default as trendingItems,
  voice_search_default as voiceSearch
};
/*! Bundled license information:

react/cjs/react.production.js:
  (**
   * @license React
   * react.production.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)
*/
//# sourceMappingURL=instantsearch__js_es_widgets.js.map
